/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 288);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(111);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exenv = __webpack_require__(4);

var serverLog = false;
var clientLog = false;

if (false) {
  // eslint-disable-next-line global-require
  serverLog = require('../server/services/logger_service');
} else {
  // eslint-disable-next-line global-require
  clientLog = __webpack_require__(131);
}

var log = _exenv.canUseDOM ? clientLog : serverLog;

module.exports = log;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(292);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(303)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2017 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.1
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");
var util = _dereq_("./util");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29,"./util":36}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context) {
var getDomain = Promise._getDomain;
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    var self = this;
    setTimeout(function() {
        self._notifyUnhandledRejection();
    }, 1);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Context.activateLongStackTraces();
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};

var fireDomEvent = (function() {
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new CustomEvent(name.toLowerCase(), {
                    detail: event,
                    cancelable: true
                });
                return !util.global.dispatchEvent(domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new Event(name.toLowerCase(), {
                    cancelable: true
                });
                domEvent.detail = event;
                return !util.global.dispatchEvent(domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name.toLowerCase(), false, true,
                    event);
                return !util.global.dispatchEvent(domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
         getDomain) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) {
                            holder.fn = util.domainBind(domain, holder.fn);
                        }
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : util.domainBind(domain, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;
var debug = _dereq_("./debuggability")(Promise, Context);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var domain = getDomain();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: domain === null ? handler
                : (typeof handler === "function" &&
                    util.domainBind(domain, handler)),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);

    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
Promise.Promise = Promise;
Promise.version = "3.5.1";
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./call_get.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./filter.js')(Promise, INTERNAL);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var domain = getDomain();
    this._fn = domain === null ? fn : util.domainBind(domain, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined && 
        this._eachValues !== null && 
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova))) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while (l--) new FakeConstructor();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj instanceof Error ||
        (obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string");
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    "object" !== "undefined";

function env(key) {
    return hasEnvVariables ? Object({"NODE_ENV":"production","RUNTIME_ENV":"browser"})[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if ({}.toString.call(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

function domainBind(self, cb) {
    return self.bind(cb);
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    domainBind: domainBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68), __webpack_require__(36), __webpack_require__(289).setImmediate))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (status, action) {
  var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    type: action,
    status: status,
    store: store
  };
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(343);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exenv = __webpack_require__(4);

var serverCache = false;
var clientCache = false;

if (false) {
  // eslint-disable-next-line global-require
  serverCache = require('../server/services/redis_service');
} else {
  // eslint-disable-next-line global-require
  clientCache = __webpack_require__(229);
}

var cache = _exenv.canUseDOM ? clientCache : serverCache;

module.exports = cache;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _exenv = __webpack_require__(4);

var serverRequest = false;
var clientRequest = false;

if (false) {
  // eslint-disable-next-line global-require
  serverRequest = require('../server/utils/request_util');
} else {
  // eslint-disable-next-line global-require
  clientRequest = __webpack_require__(506);
}

var request = _exenv.canUseDOM ? clientRequest : serverRequest;

module.exports = request;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO: dry up models
var BaseModel = function () {
  function BaseModel() {
    _classCallCheck(this, BaseModel);
  }

  _createClass(BaseModel, null, [{
    key: 'cleanParam',
    value: function cleanParam() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!name) {
        return '';
      }
      return name.split('?')[0];
    }
  }]);

  return BaseModel;
}();

exports.default = BaseModel;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(3);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/PropTypes.js


var subscriptionShape = prop_types_default.a.shape({
  trySubscribe: prop_types_default.a.func.isRequired,
  tryUnsubscribe: prop_types_default.a.func.isRequired,
  notifyNestedSubs: prop_types_default.a.func.isRequired,
  isSubscribed: prop_types_default.a.func.isRequired
});

var storeShape = prop_types_default.a.shape({
  subscribe: prop_types_default.a.func.isRequired,
  dispatch: prop_types_default.a.func.isRequired,
  getState: prop_types_default.a.func.isRequired
});
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  warning('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return react["Children"].only(this.props.children);
    };

    return Provider;
  }(react["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: storeShape.isRequired,
    children: prop_types_default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = storeShape.isRequired, _Provider$childContex[subscriptionKey] = subscriptionShape, _Provider$childContex);

  return Provider;
}

/* harmony default export */ var components_Provider = (createProvider());
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/hoist-non-react-statics/index.js
var hoist_non_react_statics = __webpack_require__(337);
var hoist_non_react_statics_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(25);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
function Subscription__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    Subscription__classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function connectAdvanced__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function connectAdvanced__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function connectAdvanced__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = storeShape, _contextTypes[subscriptionKey] = subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = subscriptionShape, _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    browser_default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      connectAdvanced__inherits(Connect, _Component);

      function Connect(props, context) {
        connectAdvanced__classCallCheck(this, Connect);

        var _this = connectAdvanced__possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        browser_default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        browser_default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new Subscription(this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(react["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(react["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return hoist_non_react_statics_default()(Connect, WrappedComponent);
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(92);

// EXTERNAL MODULE: ./node_modules/lodash-es/isPlainObject.js + 8 modules
var isPlainObject = __webpack_require__(118);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/verifyPlainObject.js



function verifyPlainObject_verifyPlainObject(value, displayName, methodName) {
  if (!Object(isPlainObject["a" /* default */])(value)) {
    warning(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return Object(es["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ var connect_mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ var connect_mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js
var mergeProps__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return mergeProps__extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ var connect_mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/verifySubselectors.js


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      warning('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors_verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js
function selectorFactory__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = selectorFactory__objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js
var connect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function connect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? connect_mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? connect_mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? connect_mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? shallowEqual : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? shallowEqual : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? shallowEqual : _ref2$areMergedPropsE,
        extraOptions = connect__objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, connect__extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ var connect_connect = (createConnect());
// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Provider", function() { return components_Provider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createProvider", function() { return createProvider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return connectAdvanced; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "connect", function() { return connect_connect; });






/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.figureOutPriorityTag = figureOutPriorityTag;
;(figureOutAdzone);
exports.buildPostAdModel = buildPostAdModel;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _cloneDeep = __webpack_require__(74);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _isString = __webpack_require__(98);

var _isString2 = _interopRequireDefault(_isString);

var _string_util = __webpack_require__(129);

var _string_util2 = _interopRequireDefault(_string_util);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function figureOutPriorityTag(originalTags) {
  var tags = (0, _cloneDeep2.default)(originalTags);
  var tagMatch = {
    slug: '',
    name: ''
  };

  if (tags && tags.length) {
    // We only care about first tag that is elibigle
    tags.reverse();
    tags.forEach(function (tag) {
      var tagSlug = tag.slug;
      var tagName = tag.name;
      // TODO: clean this up
      var matchedPriorityTag = (0, _get2.default)((0, _get2.default)(_ads2.default, 'priorityTags')[tagSlug], 'slug');
      if (tagMatch.slug === '' && matchedPriorityTag) {
        tagMatch.slug = matchedPriorityTag;
        tagMatch.name = matchedPriorityTag.replace(/-/gi, ' ');
      }

      if (tagName.indexOf('*') !== -1) {
        tagMatch.slug = tagName;
        tagMatch.name = tagName;
      }
    });
  }
  return tagMatch;
}

// construct adzone from a list of tags by looking up adtag mapping
function figureOutAdzone() {
  var originalTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'news';
  var adsConfig = arguments[2];
  var pageType = arguments[3];

  var typeMap = {
    homepage: function homepage() {
      return 'homepage/homepage';
    },
    categoryPage: function categoryPage() {
      return category + '/' + category;
    },
    postPage: function postPage() {
      var adzone = 'misc/misc';
      var tagList = (0, _cloneDeep2.default)(originalTags);

      if (tagList.length) {
        // We only care about first tag that is elibigle
        tagList.reverse();

        // Matches tags against our existing list, if matched, set that tag as priority
        var tagMatch = null;

        // If there's a star tag, that tag will override the category in ad call and analytics
        var starTagMatch = null;

        tagList.forEach(function (tag) {
          var tagSlug = tag.slug;
          var tagName = tag.name;
          var matchedPriorityTag = (0, _get2.default)((0, _get2.default)(_ads2.default, 'priorityTags')[tagSlug], 'slug');
          if (tagMatch === null && matchedPriorityTag) {
            tagMatch = matchedPriorityTag;
          }

          if (tagName.indexOf('*') !== -1) {
            starTagMatch = tagName.replace(/\s+/g, '_');
          }
        });

        // adzone logic:
        // if the tag is found in the tag mapping, then use that mapping as tag
        // topic is category of the post
        // otherwise, defaults to misc

        if (starTagMatch) {
          return 'advertorial/' + starTagMatch;
        } else if (tagMatch) {
          var tagMatchDeslugged = (0, _string_util2.default)(tagMatch);
          adzone = (0, _isString2.default)(category) ? category + '/' + tagMatchDeslugged : 'misc/' + tagMatchDeslugged;
          if (starTagMatch) {
            adzone = starTagMatch + '/' + tagMatchDeslugged;
          }
        } else {
          adzone = (0, _isString2.default)(category) ? category + '/misc' : 'misc/misc';
        }
      } else {
        adzone = (0, _isString2.default)(category) ? category + '/misc' : 'misc/misc';
      }
      return adzone;
    },
    tagPage: function tagPage() {
      if (category.name) {
        if (category.name.indexOf('*') !== -1) {
          return 'advertorial/' + category.name.replace(/\s+/g, '_');
        }
        var matchedTopicCategory = (0, _get2.default)((0, _get2.default)(_ads2.default, 'priorityTags')[category.slug], 'category') || 'misc';
        return matchedTopicCategory + '/' + (0, _string_util2.default)(category.slug);
      }
      return '';
    },
    searchPage: function searchPage() {
      return 'search/search';
    },
    authorPage: function authorPage() {
      return 'author/author';
    },
    wpPage: function wpPage() {
      return 'page/page';
    },
    videoPage: function videoPage() {
      var video = (0, _get2.default)(category, 'data.playlist[0]', {});
      var series = video.series || 'video';
      return 'video/' + series;
    },
    videoIndexPage: function videoIndexPage() {
      return 'video/video';
    },
    productPage: function productPage() {
      return 'product/product';
    }
  };

  if (typeMap[pageType]) {
    return typeMap[pageType]();
  }

  // Default adzone
  return 'misc/misc';
}

/*
  Builds the following model params for ad key val generation
  name: topic (should only show on hp, topic, tag pages)
  type: homepage, post, postList, user
  kind: homepage, article, slideshow, video, collection profile
  url: url of the page (full url with http/https)
  topic: topic of the post
  supertag: primary tag
  tags: rest of the tag
  author: author name
*/
function buildPostAdModel(adsConfig, site, pageData, pageType) {
  var tagList = (0, _get2.default)(pageData, 'tags') || [];

  var category = (0, _get2.default)(pageData, 'categories[0].slug');

  // On topic pages category string is being passed in as the pageData param
  if (!category) {
    category = pageData;
  }

  var pageTypeMap = {
    post: 'article',
    gallery: 'slideshow',
    video: 'video'
  };

  var contentType = pageTypeMap[(0, _get2.default)(pageData, 'format')] || 'article';

  var typeMap = {
    homepage: function homepage() {
      return {
        name: 'homepage',
        type: 'homepage',
        kind: 'homepage',
        url: 'https://www.' + site + '.com'
      };
    },
    categoryPage: function categoryPage() {
      if (!category) {
        category = 'news';
      }

      return {
        type: 'category',
        kind: 'category',
        name: category,
        url: 'https://www.' + site + '.com/' + category
      };
    },
    tagPage: function tagPage() {
      var name = '';
      var tags = [];
      var slug = (0, _get2.default)(pageData, 'slug');
      var pageName = (0, _get2.default)(pageData, 'name');
      var categoryMatch = (0, _get2.default)((0, _get2.default)(_ads2.default, 'priorityTags')[slug], 'category');

      if (pageName) {
        if (pageName.indexOf('*') !== -1) {
          name = 'advertorial';
          tags.push(name);
          tags.push('custom');
          tags.push(slug);
        } else {
          if (categoryMatch) {
            name = categoryMatch;
            tags.push(categoryMatch);
            tags.push('custom');
          }
          tags.push(slug);
        }
      } else {
        tags.push(slug);
      }

      return {
        type: 'tag',
        kind: 'tag',
        name: name,
        tags: tags,
        url: 'https://www.' + site + '.com/section/' + slug
      };
    },
    searchPage: function searchPage() {
      return {
        kind: 'search',
        type: 'search',
        name: 'search'
      };
    },
    authorPage: function authorPage() {
      var author = (0, _get2.default)(pageData, 'slug');
      return {
        kind: 'author',
        type: 'author',
        name: 'author',
        author: author
      };
    },
    postPage: function postPage() {
      var tags = [];
      tagList.forEach(function (topicItem) {
        tags.push(topicItem.slug);
      });

      return {
        type: 'post',
        kind: contentType,
        url: 'https://www.fastcompany.com/' + (0, _get2.default)(pageData, 'id') + '/' + (0, _get2.default)(pageData, 'slug'),
        topic: category,
        supertag: '',
        tags: tags,
        author: (0, _get2.default)(pageData, 'author.slug')
      };
    },
    wpPage: function wpPage() {
      return {
        kind: 'page',
        type: 'page',
        name: 'page'
      };
    },
    videoPage: function videoPage() {
      return {
        kind: 'video',
        type: 'video',
        name: 'video'
      };
    },
    videoIndexPage: function videoIndexPage() {
      return {
        kind: 'video',
        type: 'video',
        name: 'video'
      };
    },
    productPage: function productPage() {
      return {
        kind: 'product',
        type: 'product',
        name: 'product'
      };
    }
  };

  var fn = typeMap[pageType] || function noop() {};

  var model = (0, _extend2.default)({}, {
    site: site,
    adzone: figureOutAdzone(tagList, category, adsConfig, pageType)
  }, fn());

  return {
    config: adsConfig,
    model: model
  };
}

;(buildPostAdModel);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  baseConfig: {
    companyID: '4160',
    siteZones: {
      fastcompany: 'mv.fc',
      fastcodesign: 'mv.fcdesign'
    }
  },
  priorityTags: {
    _custom: { slug: '_custom', category: 'advertorial' },
    _syndicated: { slug: '_syndicated', category: 'advertorial' },
    _brandview: { slug: '_brandview', category: 'advertorial' },
    '30-second-mba': { slug: '30-second-mba', category: 'studio' },
    'a-leap-forward': { slug: 'a-leap-forward', category: 'advertorial' },
    accelerator: { slug: 'accelerator', category: 'technology' },
    'ad-of-the-day': { slug: 'ad-of-the-day', category: 'misc' },
    adops: { slug: 'adops', category: 'misc' },
    afghanistan: { slug: 'afghanistan', category: 'misc' },
    agendas: { slug: 'agendas', category: 'misc' },
    'all-stars': { slug: 'all-stars', category: 'misc' },
    'almost-genius': { slug: 'almost-genius', category: 'misc' },
    analyzed: { slug: 'analyzed', category: 'misc' },
    'app-economy': { slug: 'app-economy', category: 'misc' },
    'apple-event': { slug: 'apple-event', category: 'misc' },
    asides: { slug: 'asides', category: 'misc' },
    'ask-the-experts': { slug: 'ask-the-experts', category: 'misc' },
    'awful-or-awesome': { slug: 'awful-or-awesome', category: 'misc' },
    badvocacy: { slug: 'badvocacy', category: 'misc' },
    bananas: { slug: 'bananas', category: 'misc' },
    'behind-the-brand': { slug: 'behind-the-brand', category: 'leadership' },
    'beside-great-leaders': {
      slug: 'beside-great-leaders',
      category: 'advertorial'
    },
    'big-bang-design': { slug: 'big-bang-design', category: 'misc' },
    biomimicry: { slug: 'biomimicry', category: 'innovation' },
    'biz-of-youtube': { slug: 'biz-of-youtube', category: 'misc' },
    'body-os': { slug: 'body-os', category: 'technology' },
    'body-week': { slug: 'body-week', category: 'misc' },
    'bottom-line': { slug: 'bottom-line', category: 'leadership' },
    'brand-evolution': { slug: 'brand-evolution', category: 'studio' },
    'breaking-the-status-quo': {
      slug: 'breaking-the-status-quo',
      category: 'misc'
    },
    'breakthrough-capitalism': {
      slug: 'breakthrough-capitalism',
      category: 'misc'
    },
    'brilliant-minds': { slug: 'brilliant-minds', category: 'advertorial' },
    'bugaboo-boxer': { slug: 'bugaboo-boxer', category: 'advertorial' },
    'build-a-business': { slug: 'build-a-business', category: 'leadership' },
    'builders-and-innovators': {
      slug: 'builders-and-innovators',
      category: 'advertorial'
    },
    'business-of-tech': { slug: 'business-of-tech', category: 'technology' },
    'business-simplified': {
      slug: 'business-simplified',
      category: 'advertorial'
    },
    'butterfly-effect': { slug: 'butterfly-effect', category: 'technology' },
    buyology: { slug: 'buyology', category: 'innovation' },
    cannes: { slug: 'cannes', category: 'misc' },
    'career-evolution': { slug: 'career-evolution', category: 'misc' },
    'ceelo-most-creative-videos': {
      slug: 'ceelo-most-creative-videos',
      category: 'studio'
    },
    'change-agents': { slug: 'change-agents', category: 'advertorial' },
    'change-generation': { slug: 'change-generation', category: 'innovation' },
    'chris-test': { slug: 'chris-test', category: 'misc' },
    'closer-to-next': { slug: 'closer-to-next', category: 'advertorial' },
    'co-creators': { slug: 'co-creators', category: 'misc' },
    'co-location': { slug: 'co-location', category: 'misc' },
    'coexists-2015-in-review': {
      slug: 'coexists-2015-in-review',
      category: 'misc'
    },
    'coexists-2016-in-review': {
      slug: 'coexists-2016-in-review',
      category: 'misc'
    },
    'coffee-week': { slug: 'coffee-week', category: 'misc' },
    'colabs-classes': { slug: 'colabs-classes', category: 'misc' },
    'conquering-the-cloud': {
      slug: 'conquering-the-cloud',
      category: 'advertorial'
    },
    'conquering-the-cloud-test': {
      slug: 'conquering-the-cloud-test',
      category: 'misc'
    },
    'content-and-pervasive-creativity': {
      slug: 'content-and-pervasive-creativity',
      category: 'advertorial'
    },
    'creating-happiness': { slug: 'creating-happiness', category: 'misc' },
    'creation-stories': { slug: 'creation-stories', category: 'misc' },
    'creative-braintrust': { slug: 'creative-braintrust', category: 'misc' },
    'creative-braintrust-test': {
      slug: 'creative-braintrust-test',
      category: 'misc'
    },
    'creative-calendar': { slug: 'creative-calendar', category: 'misc' },
    'creative-conversations': {
      slug: 'creative-conversations',
      category: 'misc'
    },
    'creative-counselor': { slug: 'creative-counselor', category: 'misc' },
    'creative-cultures': { slug: 'creative-cultures', category: 'misc' },
    'creative-defiance': { slug: 'creative-defiance', category: 'misc' },
    'creative-destination': { slug: 'creative-destination', category: 'misc' },
    'creativity-by-the-numbers': {
      slug: 'creativity-by-the-numbers',
      category: 'misc'
    },
    'creators-profile': { slug: 'creators-profile', category: 'misc' },
    'defining-moments-visualized': {
      slug: 'defining-moments-visualized',
      category: 'advertorial'
    },
    'design-50': { slug: 'design-50', category: 'misc' },
    'design-award': { slug: 'design-award', category: 'advertorial' },
    'design-crime': { slug: 'design-crime', category: 'misc' },
    'design-for-living': { slug: 'design-for-living', category: 'misc' },
    'design-moves': { slug: 'design-moves', category: 'misc' },
    'designed-for-success': {
      slug: 'designed-for-success',
      category: 'advertorial'
    },
    'designing-women': { slug: 'designing-women', category: 'misc' },
    'destination-design': {
      slug: 'destination-design',
      category: 'advertorial'
    },
    'destination-entrepreneurs': {
      slug: 'destination-entrepreneurs',
      category: 'misc'
    },
    'destinations-uncovered': {
      slug: 'destinations-uncovered',
      category: 'advertorial'
    },
    dialed: { slug: 'dialed', category: 'leadership' },
    'difficult-conversations': {
      slug: 'difficult-conversations',
      category: 'misc'
    },
    'digital-hollywood': { slug: 'digital-hollywood', category: 'misc' },
    'digital-trailblazers': {
      slug: 'digital-trailblazers',
      category: 'advertorial'
    },
    'dispatch-from': { slug: 'dispatch-from', category: 'advertorial' },
    'do-more': { slug: 'do-more', category: 'advertorial' },
    'drive-your-business-forward': {
      slug: 'drive-your-business-forward',
      category: 'advertorial'
    },
    'driving-innovation': {
      slug: 'driving-innovation',
      category: 'innovation'
    },
    'drone-vs': { slug: 'drone-vs', category: 'misc' },
    'dynamic-dialogues': { slug: 'dynamic-dialogues', category: 'advertorial' },
    elasticity: { slug: 'elasticity', category: 'misc' },
    'election-2016': { slug: 'election-2016', category: 'misc' },
    'electric-avenue': { slug: 'electric-avenue', category: 'misc' },
    'elevator-pitch': { slug: 'elevator-pitch', category: 'advertorial' },
    'engineering-creativity': {
      slug: 'engineering-creativity',
      category: 'advertorial'
    },
    'ethonomic-indicator': { slug: 'ethonomic-indicator', category: 'misc' },
    events: { slug: 'events', category: 'misc' },
    evidence: { slug: 'evidence', category: 'misc' },
    exclusive: { slug: 'exclusive', category: 'misc' },
    'exclusive-video': { slug: 'exclusive-video', category: 'misc' },
    experiments: { slug: 'experiments', category: 'misc' },
    exposure: { slug: 'exposure', category: 'misc' },
    'faces-of-founders': { slug: 'faces-of-founders', category: 'advertorial' },
    'fashion-forward': { slug: 'fashion-forward', category: 'misc' },
    'fast-cities': { slug: 'fast-cities', category: 'innovation' },
    'fast-company-live': { slug: 'fast-company-live', category: 'misc' },
    'fast-feed': { slug: 'fast-feed', category: 'misc' },
    'fast-forward': { slug: 'fast-forward', category: 'misc' },
    'fast-forward-workday': {
      slug: 'fast-forward-workday',
      category: 'advertorial'
    },
    'fast-take': { slug: 'fast-take', category: 'misc' },
    'fast-talk': { slug: 'fast-talk', category: 'misc' },
    fastcoworks: { slug: 'fastcoworks', category: 'misc' },
    'feeding-the-future': { slug: 'feeding-the-future', category: 'misc' },
    'find-your-values': { slug: 'find-your-values', category: 'leadership' },
    'first-look': { slug: 'first-look', category: 'misc' },
    'food-week': { slug: 'food-week', category: 'misc' },
    'fund-this': { slug: 'fund-this', category: 'innovation' },
    'future-forward': { slug: 'future-forward', category: 'misc' },
    'future-of-philanthropy': {
      slug: 'future-of-philanthropy',
      category: 'misc'
    },
    'future-of-retail': { slug: 'future-of-retail', category: 'technology' },
    'future-proof': { slug: 'future-proof', category: 'misc' },
    'futurist-forum': { slug: 'futurist-forum', category: 'innovation' },
    'generation-flux': { slug: 'generation-flux', category: 'technology' },
    'generosity-series': { slug: 'generosity-series', category: 'misc' },
    'genius-marketing': { slug: 'genius-marketing', category: 'misc' },
    'getting-funded': { slug: 'getting-funded', category: 'misc' },
    'gif-of-the-day': { slug: 'gif-of-the-day', category: 'misc' },
    'gift-guide': { slug: 'gift-guide', category: 'misc' },
    gigged: { slug: 'gigged', category: 'misc' },
    'good-design-is-good-business': {
      slug: 'good-design-is-good-business',
      category: 'innovation'
    },
    'greatest-geek-moment-in-history': {
      slug: 'greatest-geek-moment-in-history',
      category: 'misc'
    },
    'growth-hacking': { slug: 'growth-hacking', category: 'advertorial' },
    'growth-notes': { slug: 'growth-notes', category: 'advertorial' },
    'hackers-we-love': { slug: 'hackers-we-love', category: 'misc' },
    healthware: { slug: 'healthware', category: 'technology' },
    help: { slug: 'help', category: 'misc' },
    'heres-an-idea': { slug: 'heres-an-idea', category: 'innovation' },
    'hit-the-ground-running': {
      slug: 'hit-the-ground-running',
      category: 'misc'
    },
    'homebrew-news': { slug: 'homebrew-news', category: 'misc' },
    'hotel-revolution': { slug: 'hotel-revolution', category: 'advertorial' },
    'how-i-get-it-done': { slug: 'how-i-get-it-done', category: 'leadership' },
    'how-to-be-a-success-at-everything': {
      slug: 'how-to-be-a-success-at-everything',
      category: 'leadership'
    },
    'how-to-build-the-perfect-city': {
      slug: 'how-to-build-the-perfect-city',
      category: 'misc'
    },
    'hows-that-working-out-for-you': {
      slug: 'hows-that-working-out-for-you',
      category: 'misc'
    },
    hr: { slug: 'hr', category: 'misc' },
    ifive: { slug: 'ifive', category: 'misc' },
    'ignite-positive-change': {
      slug: 'ignite-positive-change',
      category: 'leadership'
    },
    'image-of-the-day': { slug: 'image-of-the-day', category: 'misc' },
    'industrial-internet': {
      slug: 'industrial-internet',
      category: 'advertorial'
    },
    'industries-to-watch': {
      slug: 'industries-to-watch',
      category: 'innovation'
    },
    'industry-pov': { slug: 'industry-pov', category: 'innovation' },
    'influence-project': { slug: 'influence-project', category: 'misc' },
    'influencer-collective': {
      slug: 'influencer-collective',
      category: 'misc'
    },
    'infographic-of-the-day': {
      slug: 'infographic-of-the-day',
      category: 'misc'
    },
    'innovation-agents': { slug: 'innovation-agents', category: 'misc' },
    'innovation-by-design': { slug: 'innovation-by-design', category: 'misc' },
    'innovation-by-design-2014': {
      slug: 'innovation-by-design-2014',
      category: 'misc'
    },
    'innovation-by-design-awards': {
      slug: 'innovation-by-design-awards',
      category: 'misc'
    },
    'innovation-by-design-awards-2014': {
      slug: 'innovation-by-design-awards-2014',
      category: 'misc'
    },
    'innovation-by-design-awards-2015': {
      slug: 'innovation-by-design-awards-2015',
      category: 'misc'
    },
    'innovation-by-design-awards-entries-2014': {
      slug: 'innovation-by-design-awards-entries-2014',
      category: 'misc'
    },
    'innovation-by-design-awards-entries-2015': {
      slug: 'innovation-by-design-awards-entries-2015',
      category: 'misc'
    },
    'innovation-by-design-conference': {
      slug: 'innovation-by-design-conference',
      category: 'misc'
    },
    'innovation-enabled': { slug: 'innovation-enabled', category: 'misc' },
    'innovation-engine': { slug: 'innovation-engine', category: 'misc' },
    'innovation-nation': { slug: 'innovation-nation', category: 'misc' },
    'innovation-pipeline': { slug: 'innovation-pipeline', category: 'misc' },
    'innovation-uncensored-sf-2014': {
      slug: 'innovation-uncensored-sf-2014',
      category: 'misc'
    },
    'insider-insight': { slug: 'insider-insight', category: 'misc' },
    'inspiration-and-impact': {
      slug: 'inspiration-and-impact',
      category: 'advertorial'
    },
    'inspired-ethonomics': { slug: 'inspired-ethonomics', category: 'misc' },
    'internet-of-things': { slug: 'internet-of-things', category: 'misc' },
    'isle-of-innovation': {
      slug: 'isle-of-innovation',
      category: 'advertorial'
    },
    'its-good-not-to-be-home': {
      slug: 'its-good-not-to-be-home',
      category: 'advertorial'
    },
    'know-it-all': { slug: 'know-it-all', category: 'misc' },
    'leadership-now': { slug: 'leadership-now', category: 'misc' },
    'league-of-extraordinary-women-2012': {
      slug: 'league-of-extraordinary-women-2012',
      category: 'leadership'
    },
    'lessons-learned': { slug: 'lessons-learned', category: 'innovation' },
    'let-it-fly': { slug: 'let-it-fly', category: 'advertorial' },
    'life-in-beta': { slug: 'life-in-beta', category: 'innovation' },
    'living-smarter': { slug: 'living-smarter', category: 'leadership' },
    'location-location-location': {
      slug: 'location-location-location',
      category: 'misc'
    },
    'lorem-ipsum': { slug: 'lorem-ipsum', category: 'misc' },
    'made-to-stick': { slug: 'made-to-stick', category: 'misc' },
    'make-a-name': { slug: 'make-a-name', category: 'misc' },
    'make-your-move': { slug: 'make-your-move', category: 'misc' },
    'making-it': { slug: 'making-it', category: 'innovation' },
    'making-your-workplace-work': {
      slug: 'making-your-workplace-work',
      category: 'misc'
    },
    maps: { slug: 'maps', category: 'misc' },
    'mark-bittman': { slug: 'mark-bittman', category: 'misc' },
    'master-class': { slug: 'master-class', category: 'misc' },
    'masters-of-design': { slug: 'masters-of-design', category: 'misc' },
    'masters-of-design-2005': {
      slug: 'masters-of-design-2005',
      category: 'misc'
    },
    'masters-of-design-2006': {
      slug: 'masters-of-design-2006',
      category: 'misc'
    },
    'masters-of-design-2007': {
      slug: 'masters-of-design-2007',
      category: 'misc'
    },
    'masters-of-design-2008': {
      slug: 'masters-of-design-2008',
      category: 'misc'
    },
    'masters-of-design-2009': {
      slug: 'masters-of-design-2009',
      category: 'misc'
    },
    'masters-of-design-2010': {
      slug: 'masters-of-design-2010',
      category: 'misc'
    },
    'masters-of-design-2011': {
      slug: 'masters-of-design-2011',
      category: 'misc'
    },
    'masters-of-marketing': { slug: 'masters-of-marketing', category: 'misc' },
    meme: { slug: 'meme', category: 'misc' },
    'mind-and-machine': { slug: 'mind-and-machine', category: 'misc' },
    mobilizing: { slug: 'mobilizing', category: 'misc' },
    'most-creative-people': {
      slug: 'most-creative-people',
      category: 'leadership'
    },
    'most-creative-people-2009': {
      slug: 'most-creative-people-2009',
      category: 'leadership'
    },
    'most-creative-people-2010': {
      slug: 'most-creative-people-2010',
      category: 'leadership'
    },
    'most-creative-people-2011': {
      slug: 'most-creative-people-2011',
      category: 'leadership'
    },
    'most-creative-people-2012': {
      slug: 'most-creative-people-2012',
      category: 'leadership'
    },
    'most-creative-people-2013': {
      slug: 'most-creative-people-2013',
      category: 'leadership'
    },
    'most-creative-people-2014': {
      slug: 'most-creative-people-2014',
      category: 'leadership'
    },
    'most-creative-people-2015': {
      slug: 'most-creative-people-2015',
      category: 'leadership'
    },
    'most-innovative-companies': {
      slug: 'most-innovative-companies',
      category: 'misc'
    },
    'most-innovative-moments': {
      slug: 'most-innovative-moments',
      category: 'innovation'
    },
    'moving-the-needle': { slug: 'moving-the-needle', category: 'innovation' },
    'my-creative-life': { slug: 'my-creative-life', category: 'misc' },
    'my-way': { slug: 'my-way', category: 'misc' },
    'new-heights': { slug: 'new-heights', category: 'misc' },
    'new-money': { slug: 'new-money', category: 'misc' },
    'next-design': { slug: 'next-design', category: 'innovation' },
    'next-gen-design': { slug: 'next-gen-design', category: 'advertorial' },
    'objet-dinternet': { slug: 'objet-dinternet', category: 'misc' },
    'olympics-2012': { slug: 'olympics-2012', category: 'misc' },
    'one-more-thing': { slug: 'one-more-thing', category: 'misc' },
    'open-company': { slug: 'open-company', category: 'misc' },
    'out-of-office-with': {
      slug: 'out-of-office-with',
      category: 'leadership'
    },
    'passion-to-profit': { slug: 'passion-to-profit', category: 'misc' },
    'pet-week': { slug: 'pet-week', category: 'misc' },
    'platform-wars': { slug: 'platform-wars', category: 'misc' },
    politechs: { slug: 'politechs', category: 'misc' },
    pov: { slug: 'pov', category: 'leadership' },
    'power-couples': { slug: 'power-couples', category: 'misc' },
    'power-of-ai': { slug: 'power-of-ai', category: 'advertorial' },
    'powering-the-future': {
      slug: 'powering-the-future',
      category: 'innovation'
    },
    'productivity-in-motion': {
      slug: 'productivity-in-motion',
      category: 'advertorial'
    },
    'progress-is-possible': {
      slug: 'progress-is-possible',
      category: 'advertorial'
    },
    'project-fusion': { slug: 'project-fusion', category: 'advertorial' },
    qa: { slug: 'qa', category: 'misc' },
    'quick-hit': { slug: 'quick-hit', category: 'misc' },
    'reading-list': { slug: 'reading-list', category: 'misc' },
    'rebranding-pot': { slug: 'rebranding-pot', category: 'misc' },
    'reinventing-music': { slug: 'reinventing-music', category: 'misc' },
    retrology: { slug: 'retrology', category: 'misc' },
    'reverse-engineered': { slug: 'reverse-engineered', category: 'misc' },
    'revision-history': { slug: 'revision-history', category: 'misc' },
    'revolutionizing-work': {
      slug: 'revolutionizing-work',
      category: 'advertorial'
    },
    'rhone-technology': { slug: 'rhone-technology', category: 'advertorial' },
    'risks-visualized': { slug: 'risks-visualized', category: 'advertorial' },
    'robot-revolution': { slug: 'robot-revolution', category: 'misc' },
    'running-lean': { slug: 'running-lean', category: 'misc' },
    'second-shift': { slug: 'second-shift', category: 'misc' },
    'secrets-of-the-most-productive-people': {
      slug: 'secrets-of-the-most-productive-people',
      category: 'misc'
    },
    'sector-forecasting': {
      slug: 'sector-forecasting',
      category: 'innovation'
    },
    'seth-bodnar-ge': { slug: 'seth-bodnar-ge', category: 'misc' },
    'show-up-differently': {
      slug: 'show-up-differently',
      category: 'advertorial'
    },
    'side-project': { slug: 'side-project', category: 'misc' },
    'signs-and-symbols': { slug: 'signs-and-symbols', category: 'leadership' },
    'silicon-valley-social-entrepreneurs': {
      slug: 'silicon-valley-social-entrepreneurs',
      category: 'misc'
    },
    'simple-genius': { slug: 'simple-genius', category: 'misc' },
    'sleep-week': { slug: 'sleep-week', category: 'misc' },
    'slicker-city': { slug: 'slicker-city', category: 'misc' },
    'solving-inequality': { slug: 'solving-inequality', category: 'misc' },
    'startup-report': { slug: 'startup-report', category: 'misc' },
    storytellers: { slug: 'storytellers', category: 'misc' },
    'strong-female-lead': { slug: 'strong-female-lead', category: 'misc' },
    'style-revolution': { slug: 'style-revolution', category: 'advertorial' },
    'super-bowl-50': { slug: 'super-bowl-50', category: 'misc' },
    'super-bowl-li': { slug: 'super-bowl-li', category: 'misc' },
    'super-bowl-xlix': { slug: 'super-bowl-xlix', category: 'misc' },
    'super-bowl-xlvi': { slug: 'super-bowl-xlvi', category: 'misc' },
    'super-bowl-xlvii': { slug: 'super-bowl-xlvii', category: 'misc' },
    'super-bowl-xlviii': { slug: 'super-bowl-xlviii', category: 'misc' },
    'superlatives-week': { slug: 'superlatives-week', category: 'misc' },
    'supertag-test-multiple-sites': {
      slug: 'supertag-test-multiple-sites',
      category: 'misc'
    },
    sxsw: { slug: 'sxsw', category: 'misc' },
    'sxsw-2016': { slug: 'sxsw-2016', category: 'misc' },
    'tech-edge': { slug: 'tech-edge', category: 'misc' },
    'tech-forecast': { slug: 'tech-forecast', category: 'misc' },
    technovore: { slug: 'technovore', category: 'misc' },
    techsocial: { slug: 'techsocial', category: 'misc' },
    'terminal-velocity': { slug: 'terminal-velocity', category: 'misc' },
    'the-29th-floor': { slug: 'the-29th-floor', category: 'misc' },
    'the-big-idea': { slug: 'the-big-idea', category: 'misc' },
    'the-big-story': { slug: 'the-big-story', category: 'misc' },
    'the-code-war': { slug: 'the-code-war', category: 'technology' },
    'the-creator-economy': { slug: 'the-creator-economy', category: 'misc' },
    'the-fast-company-innovation-festival': {
      slug: 'the-fast-company-innovation-festival',
      category: 'misc'
    },
    'the-future-of-collaboration': {
      slug: 'the-future-of-collaboration',
      category: 'misc'
    },
    'the-future-of-everything': {
      slug: 'the-future-of-everything',
      category: 'misc'
    },
    'the-future-of-policing': {
      slug: 'the-future-of-policing',
      category: 'misc'
    },
    'the-future-of-service-in-america': {
      slug: 'the-future-of-service-in-america',
      category: 'misc'
    },
    'the-future-of-work': { slug: 'the-future-of-work', category: 'misc' },
    'the-legacy-of-1995': { slug: 'the-legacy-of-1995', category: 'misc' },
    'the-misfit-economy': { slug: 'the-misfit-economy', category: 'misc' },
    'the-new-magic': { slug: 'the-new-magic', category: 'misc' },
    'the-new-rules-of-work': {
      slug: 'the-new-rules-of-work',
      category: 'misc'
    },
    'the-other-side': { slug: 'the-other-side', category: 'misc' },
    'the-pivot': { slug: 'the-pivot', category: 'misc' },
    'the-purposeful-ceo': { slug: 'the-purposeful-ceo', category: 'misc' },
    'the-recommender': { slug: 'the-recommender', category: 'misc' },
    'the-rules-of-social-media': {
      slug: 'the-rules-of-social-media',
      category: 'misc'
    },
    'the-science-of-work': { slug: 'the-science-of-work', category: 'misc' },
    'the-sensor-revolution': {
      slug: 'the-sensor-revolution',
      category: 'misc'
    },
    'the-thread': { slug: 'the-thread', category: 'misc' },
    'the-ultimate-urban-utility-bike': {
      slug: 'the-ultimate-urban-utility-bike',
      category: 'misc'
    },
    'the-valley': { slug: 'the-valley', category: 'misc' },
    'the-vow': { slug: 'the-vow', category: 'advertorial' },
    'the-walk-through': { slug: 'the-walk-through', category: 'misc' },
    'the-y-combinator-chronicles': {
      slug: 'the-y-combinator-chronicles',
      category: 'misc'
    },
    'the-year-in-post-truth': {
      slug: 'the-year-in-post-truth',
      category: 'misc'
    },
    'then-and-now': { slug: 'then-and-now', category: 'misc' },
    'tim-cooks-apple': { slug: 'tim-cooks-apple', category: 'misc' },
    'today-in-tabs': { slug: 'today-in-tabs', category: 'misc' },
    'top-5-ads': { slug: 'top-5-ads', category: 'misc' },
    'top-jobs': { slug: 'top-jobs', category: 'misc' },
    tracking: { slug: 'tracking', category: 'misc' },
    'travel-smarter': { slug: 'travel-smarter', category: 'misc' },
    'tribeca-film-festival': {
      slug: 'tribeca-film-festival',
      category: 'misc'
    },
    'united-states-of-innovation': {
      slug: 'united-states-of-innovation',
      category: 'technology'
    },
    unplug: { slug: 'unplug', category: 'misc' },
    unreasonables: { slug: 'unreasonables', category: 'misc' },
    upswing: { slug: 'upswing', category: 'misc' },
    'us-innovation': { slug: 'us-innovation', category: 'innovation' },
    visualized: { slug: 'visualized', category: 'misc' },
    visualizing: { slug: 'visualizing', category: 'misc' },
    'visualizing-success': { slug: 'visualizing-success', category: 'misc' },
    wanderlust: { slug: 'wanderlust', category: 'misc' },
    wanted: { slug: 'wanted', category: 'misc' },
    'wearable-computing': { slug: 'wearable-computing', category: 'misc' },
    'wearables-week': { slug: 'wearables-week', category: 'misc' },
    wears: { slug: 'wears', category: 'misc' },
    'weekly-top-5': { slug: 'weekly-top-5', category: 'misc' },
    'well-to-do': { slug: 'well-to-do', category: 'technology' },
    'where-are-they-now': { slug: 'where-are-they-now', category: 'misc' },
    'whos-next': { slug: 'whos-next', category: 'innovation' },
    'why-here': { slug: 'why-here', category: 'misc' },
    'why-youre-fat': { slug: 'why-youre-fat', category: 'misc' },
    'women-heroes': { slug: 'women-heroes', category: 'leadership' },
    'women-in-tech-2009': {
      slug: 'women-in-tech-2009',
      category: 'leadership'
    },
    'women-in-tech-2010': {
      slug: 'women-in-tech-2010',
      category: 'leadership'
    },
    'women-in-tech-2011': {
      slug: 'women-in-tech-2011',
      category: 'leadership'
    },
    'women-to-watch': { slug: 'women-to-watch', category: 'advertorial' },
    'work-mode': { slug: 'work-mode', category: 'leadership' },
    'work-smart': { slug: 'work-smart', category: 'leadership' },
    'working-while-female': {
      slug: 'working-while-female',
      category: 'leadership'
    },
    'workplace-evolution': {
      slug: 'workplace-evolution',
      category: 'leadership'
    },
    'world-changing-ideas': { slug: 'world-changing-ideas', category: 'misc' },
    'world-changing-ideas-2015': {
      slug: 'world-changing-ideas-2015',
      category: 'misc'
    },
    'worth-the-risk': { slug: 'worth-the-risk', category: 'advertorial' },
    wwdc: { slug: 'wwdc', category: 'misc' },
    'your-most-productive-self': {
      slug: 'your-most-productive-self',
      category: 'misc'
    }
  },
  definitions: {
    welcome: {
      size: [600, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[600, 400], [640, 480], [600, 600]] }, { viewport: [640, 0], slot: [[600, 400], [640, 480], [600, 600]] }, { viewport: [0, 0], slot: [[300, 250], [320, 250]] }]
    },
    flexiblebillboard: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_1: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_2: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_3: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_4: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblebillboard_5: {
      size: [728, 90],
      sizeMapping: [{ viewport: [1024, 0], slot: [[728, 90], [970, 250], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [3, 1]] }]
    },
    flexiblepushdown: {
      size: [728, 90],
      sizeMapping: [{
        viewport: [1024, 0],
        slot: [[728, 90], [970, 90], [970, 250], [970, 415], [970, 600], [3, 1]]
      }, { viewport: [640, 0], slot: [[728, 90], [2, 2], [3, 1]] }]
    },
    flexiblehalfpage: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_1: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_2: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_3: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_4: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_5: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_6: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_7: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_8: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_9: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_10: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_11: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    flexiblehalfpage_12: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    slideshowhalfpage: {
      size: [300, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600]] }]
    },
    fixedrectangle: {
      size: [300, 250],
      sizeMapping: [{ viewport: [1024, 0], slot: [300, 250] }, { viewport: [640, 0], slot: [300, 250] }]
    },
    fixedrectangle_2: {
      size: [300, 250],
      sizeMapping: [{ viewport: [1024, 0], slot: [300, 250] }, { viewport: [640, 0], slot: [300, 250] }]
    },
    fixedrectangle_3: {
      size: [300, 250],
      sizeMapping: [{ viewport: [1024, 0], slot: [300, 250] }, { viewport: [640, 0], slot: [300, 250] }]
    },
    slideshowrectangle: {
      size: [300, 250],
      sizeMapping: [{ viewport: [1024, 0], slot: [300, 250] }, { viewport: [640, 0], slot: [300, 250] }, { viewport: [0, 0], slot: [300, 250] }]
    },
    mobileparallax_1: {
      size: [300, 250],
      sizeMapping: [{
        viewport: [0, 0],
        slot: [[300, 250], [320, 250], [640, 1138], [3, 1]]
      }]
    },
    mobileparallax_2: {
      size: [300, 250],
      sizeMapping: [{
        viewport: [0, 0],
        slot: [[300, 250], [320, 250], [640, 1138], [3, 1]]
      }]
    },
    mobilerectangle: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_1: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_2: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_3: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_4: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_5: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_6: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_7: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_8: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_9: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_10: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_11: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobilerectangle_12: {
      size: [300, 250],
      sizeMapping: [{ viewport: [0, 0], slot: [[300, 250], [320, 250], [2, 2], [3, 1]] }]
    },
    mobileleaderboard: {
      size: [320, 50],
      sizeMapping: [{
        viewport: [0, 0],
        slot: [[320, 50], [320, 100], [300, 250], [2, 2], [3, 1]]
      }]
    },
    flexibleleaderboard: {
      size: [728, 90],
      sizeMapping: [{ viewport: [0, 0], slot: [[728, 90], [2, 2], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [2, 2], [3, 1]] }]
    },
    slideshowleaderboard: {
      size: [728, 90],
      sizeMapping: [{ viewport: [640, 0], slot: [[728, 90], [2, 2], [3, 1]] }]
    },
    flexibleinterrupter: {
      size: [970, 600],
      sizeMapping: [{ viewport: [1024, 0], slot: [[970, 415], [970, 600], [2, 2], [3, 1]] }, { viewport: [640, 0], slot: [[728, 90], [2, 2], [3, 1]] }]
    },
    flexiblelogo: {
      size: [120, 90],
      sizeMapping: [{ viewport: [0, 0], slot: [[88, 31], [120, 60], [120, 90]] }]
    },
    flexibleportrait: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_1: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_2: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_3: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_4: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_5: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_6: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_7: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_8: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_9: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_10: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_11: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    flexibleportrait_12: {
      size: [300, 1050],
      sizeMapping: [{ viewport: [1024, 0], slot: [[300, 250], [300, 600], [300, 1050]] }]
    },
    oop: {
      size: [1, 1],
      sizeMapping: [{ viewport: [0, 0], slot: [1, 1] }]
    },
    nativetile_1: {
      size: [3, 3],
      sizeMapping: [{ viewport: [3, 3], slot: [3, 3] }]
    },
    nativetile_2: {
      size: [3, 3],
      sizeMapping: [{ viewport: [3, 3], slot: [3, 3] }]
    },
    nativetile_3: {
      size: [3, 3],
      sizeMapping: [{ viewport: [3, 3], slot: [3, 3] }]
    },
    nativetile_4: {
      size: [3, 3],
      sizeMapping: [{ viewport: [3, 3], slot: [3, 3] }]
    },
    welcomemat: {
      size: [970, 415],
      sizeMapping: [{ viewport: [0, 0], slot: [970, 415] }]
    },
    welcome_ad_video_pixel: {
      size: [1, 1],
      sizeMapping: [{ viewport: [0, 0], slot: [1, 1] }]
    }
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Bling = __webpack_require__(384);

var _Bling2 = _interopRequireDefault(_Bling);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _union = __webpack_require__(393);

var _union2 = _interopRequireDefault(_union);

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _url_util = __webpack_require__(197);

var _url_util2 = _interopRequireDefault(_url_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hasSetSafeFrameRefresh = false;
var adRefreshQueue = [];

if (_exenv2.default) {
  // Enable sync correlator value
  _Bling2.default.syncCorrelator();
}

/**
 *
 * @param {Array} keysArray a list of keys to clear from targetting
 */
function removeSlideshowAdKeyTargeting(keysArray) {
  var slots = window.parent.googletag.pubads().getSlots();
  // eslint-disable-next-line no-plusplus
  for (var i = slots.length; i--;) {
    // eslint-disable-next-line no-plusplus
    for (var j = keysArray.length; j--;) {
      slots[i].clearTargeting(keysArray[j]);
    }
  }
}

/**
 * Clears a list of key vals from targetting and refresh the
 * ad based on matching matching key val "slotid" and limit to flexibleportrait unit
 *
 * @param {Array} keysArray
 * @param {String} slotId
 */
function refreshSafeFrameSlot(keysArray, slotId) {
  var _window = window,
      googletag = _window.googletag;

  if (!googletag) {
    return;
  }

  if (slotId.indexOf('flexibleportrait') === -1 && slotId.indexOf('flexiblehalfpage') === -1) {
    return;
  }

  var slots = googletag.pubads().getSlots();
  // eslint-disable-next-line no-plusplus
  for (var i = slots.length; i--;) {
    var targetSlotID = (0, _get2.default)(slots[i].getTargeting('slotid'), '[0]');
    if (targetSlotID && targetSlotID === slotId) {
      // eslint-disable-next-line no-plusplus
      for (var j = keysArray.length; j--;) {
        slots[i].clearTargeting(keysArray[j]);
      }
      googletag.pubads().refresh([slots[i]], { changeCorrelator: false });
    }
  }
}

/**
 * Refreshes the queue of ads stored up from when the user is not active on the page
 */
function refreshAdQueue() {
  if (adRefreshQueue.length) {
    adRefreshQueue.forEach(function (slotId) {
      refreshSafeFrameSlot(['prebid_trigger', 'hb_bidder', 'hb_adid', 'hb_pb', 'hb_size', 'hb_deal'], slotId);
    });
    adRefreshQueue = [];
  }
}

/**
 * An Ad Component using Google Publisher Tags wrapped on top of react-gpt from NFL
 * https://github.com/nfl/react-gpt
 * https://developers.google.com/doubleclick-gpt/
 *
 * DEBUG MODE: Append ?debug to url to enable console logging of ad events
 * EXAMPLE USAGE:
 * const combinedAdModel = { ...AdConfig, ...AdContext };
 *     <Ad
 *      {...combinedAdModel}
 *       name="flexibleleaderboard"
 *     />
 * where combinedAdModel is an object merged from ad_context.json and config.json.
 * note: ad_context.json is a stub, in the real world,
 * that data would come from the page context model
 *
 */

var Ad = function (_Component) {
  _inherits(Ad, _Component);

  function Ad() {
    _classCallCheck(this, Ad);

    var _this = _possibleConstructorReturn(this, (Ad.__proto__ || Object.getPrototypeOf(Ad)).call(this));

    _this.addSlideShowAdRefreshListener = _this.addSlideShowAdRefreshListener.bind(_this);
    return _this;
  }

  _createClass(Ad, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.canRefresh) {
        window.removeEventListener('FC_REFRESH_EVENT', this.addSlideShowAdRefreshListener);
      }
    }
  }, {
    key: 'constructData',
    value: function constructData() {
      var _props = this.props,
          baseConfig = _props.baseConfig,
          definitions = _props.definitions,
          model = _props.model,
          name = _props.name,
          region = _props.region,
          slug = _props.slug,
          oop = _props.oop,
          pos = _props.pos,
          pageNum = _props.pageNum,
          noLazyLoad = _props.noLazyLoad;
      var adzoneOverride = this.props.adzoneOverride;

      var siteZones = (0, _get2.default)(baseConfig, 'siteZones', null);

      var defaultSizeMapping = [{
        slot: [],
        viewport: []
      }];

      if (!siteZones) {
        _logger_service2.default.error('No siteZones config object set');
        // Set a default for GPT lib, they need this value or else it will crash the app
        this.sizeMapping = defaultSizeMapping;
        return;
      }

      this.name = name;
      this.region = region;
      this.oop = oop;
      this.pos = pos === 'atf' ? 'atf' : 'btf'; // position defaults to below the fold

      // lazy load = atf, non-lazy load = btf
      this.pos = noLazyLoad ? 'btf' : 'atf';

      // Figure out adzone
      var companyID = (0, _get2.default)(baseConfig, 'companyID');
      var site = (0, _get2.default)(model, 'site') || 'fastcompany';
      var zone = (0, _get2.default)(model, 'adzone');

      // If querystring override is enabled then override the adzone
      var queryAdzoneOverride = (0, _url_util2.default)('adzone');

      if (queryAdzoneOverride) {
        adzoneOverride = queryAdzoneOverride;
      }

      this.constructAdZone(companyID, siteZones, zone, adzoneOverride, site, name);

      // Figure out size mapping
      this.sizeMapping = (0, _get2.default)(definitions[name], 'sizeMapping', defaultSizeMapping);

      // Figure out key val mapping, returns a key val pair object
      this.constructKeyVals(model, pageNum, name);

      // Optionally display "advertisement" label
      this.adLabel = slug === false ? '' : _react2.default.createElement(
        'div',
        { className: 'ad-wrapper__ad-slug' },
        'advertisement'
      );

      if (noLazyLoad) {
        this.noLazyLoad = true;
      }
    }
  }, {
    key: 'addSlideShowAdRefreshListener',
    value: function addSlideShowAdRefreshListener(event) {
      if (_exenv2.default) {
        window.addEventListener('FC_REFRESH_EVENT', function eventListener(e) {
          try {
            if (event.slot.getAdUnitPath().indexOf(e.detail) !== -1) {
              window.removeEventListener('FC_REFRESH_EVENT', eventListener);
              removeSlideshowAdKeyTargeting(['prebid_trigger', 'hb_bidder', 'hb_adid', 'hb_pb', 'hb_size', 'hb_deal']);
              _Bling2.default.refresh([event.slot]);
            }
          } catch (err) {
            _logger_service2.default.error(err, 'unable to refresh ad in from 3 slides.');
          }
        });
      }
    }

    /**
     * Use anti-fraud detection to add a window listener from
     * ad unit's post message safe frame.
     * AntiFraud Detection: If the user hasn't moved for x amount of seconds,
     * ad unit will not refresh even if it passed the time needed to refresh.
     * Refresh Logic: Listens to an event from ad's safeframe,
     * if the event is heard, and user is not inactive, then refresh the ad unit.
     */

  }, {
    key: 'attachSafeFrameRefreshEvent',
    value: function attachSafeFrameRefreshEvent() {
      if (hasSetSafeFrameRefresh === false) {
        var d = document || window.document;
        d.onload = refreshAdQueue;
        d.onmousemove = refreshAdQueue;
        d.onmousedown = refreshAdQueue;
        d.ontouchstart = refreshAdQueue;
        d.onclick = refreshAdQueue;
        d.onscroll = refreshAdQueue;
        d.onkeypress = refreshAdQueue;

        window.addEventListener('message', function (event) {
          var dataSource = (0, _get2.default)(event, 'data.source');
          var slotId = (0, _get2.default)(event, 'data.slotId');
          if (dataSource === 'fc_ad_refresh') {
            adRefreshQueue.push(slotId);
          }
        }, false);
        hasSetSafeFrameRefresh = true;
      }
    }
    /**
     *
     * Converts a url into a unique hash value, ported over from admanager
     */

  }, {
    key: 'constructCMSHash',
    value: function constructCMSHash(url) {
      var cmsQueryValue = (0, _url_util2.default)('cms');
      if (cmsQueryValue) {
        return cmsQueryValue;
      }

      var key = url;
      var hash = 0;
      var i = void 0;
      var chr = void 0;

      if (!key || key.length === 0) {
        return hash;
      }
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < key.length; i++) {
        chr = key.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + chr;
        // eslint-disable-next-line
        hash &= hash;
      }
      hash = Math.abs(hash);
      hash = hash.toString(36);
      return hash;
    }

    /**
     *
     * Constructs an adzone string from metadata to be passed to the ad component
     */

  }, {
    key: 'constructAdZone',
    value: function constructAdZone(companyID, siteZones, zone, adzoneOverride) {
      var site = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'fastcompany';
      var name = arguments[5];

      var finalizedAdZone = zone;
      // Override the adzone param if it's passed
      if (adzoneOverride && adzoneOverride !== '') {
        finalizedAdZone = adzoneOverride + '/' + adzoneOverride;
      }

      this.adZone = '/' + companyID + '/' + siteZones[site] + '/' + finalizedAdZone + '/' + name;
    }

    /**
     *
     * Constructs key value pair for ad targetting, returns an key value paired object
     * c_type = content type (slideshow, article, video, homepage, category, tag, etc)
       cms = unique hash of current page url, query string unaffected
       vport = viewport
       cat = category
       tag = tags
       aut = author
       scroll = page number
       adslot = name of the ad unit
       vport = user vport size (large, medium small)
       pos = atf (above the fold) / btf (below the fold)
       video = boolean, is the post a video post (NOT IMPLEMENTED)
       login = is the VISITOR logged in (NOT IMPLEMENTED)
     */

  }, {
    key: 'constructKeyVals',
    value: function constructKeyVals(model) {
      var pageNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var zone = arguments[2];

      var pageLevelKeyvals = {};
      var name = model.name,
          author = model.author,
          kind = model.kind,
          tags = model.tags,
          topic = model.topic,
          type = model.type,
          url = model.url;


      pageLevelKeyvals.c_type = kind || type;
      pageLevelKeyvals.cms = this.constructCMSHash(url);
      pageLevelKeyvals.cat = topic || name || '';

      if (tags && tags.length) {
        pageLevelKeyvals.tags = (0, _union2.default)(tags);
      } else {
        pageLevelKeyvals.tags = [name];
      }

      pageLevelKeyvals.aut = author ? author.toLowerCase().replace(/-/g, '') : '';
      pageLevelKeyvals.pos = this.pos;
      pageLevelKeyvals.adslot = this.name;
      pageLevelKeyvals.scroll = String(pageNum); // this needs to be converted to a string

      // CID value for bot activity tracking as per Adops request
      pageLevelKeyvals.CID = (0, _url_util2.default)('cid') || '0';

      pageLevelKeyvals.chn = [];
      if (topic) {
        pageLevelKeyvals.chn.push(topic);
      }

      if (window && window.innerWidth) {
        var userWidth = window.innerWidth;
        var vPort = void 0;
        if (userWidth >= 1024) {
          vPort = 'l';
        } else if (userWidth < 1024 && userWidth >= 640) {
          vPort = 'm';
        } else if (userWidth < 640) {
          this.userViewport = 'mobile';
          vPort = 's';
        }
        pageLevelKeyvals.vport = vPort;
      }

      pageLevelKeyvals.slotid = '' + zone + pageNum;

      this.slotLevelKeyvals = pageLevelKeyvals;

      // Set keyval to a global obj to help Browsi
      window.fc_ads = {};
      window.fc_ads.keyVals = pageLevelKeyvals;
    }

    /**
     *
     * Constructs a class string BEM style with region be the modifier
     */

  }, {
    key: 'constructAdClass',
    value: function constructAdClass(adName, region) {
      var classNameFull = 'ad-wrapper ad-wrapper--' + adName;

      if (region && region !== '') {
        classNameFull += ' ad-wrapper--' + region;
      }
      return classNameFull;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.initialPageLoad) {
        // If there's a ?adfree=1 then don't render any ad
        var queryAdFree = (0, _url_util2.default)('adfree');
        if (queryAdFree) {
          return null;
        }

        // This here will determine whether to make the actual call or not on mobile
        var userViewportWidth = window.innerWidth;
        var adUnitName = (0, _get2.default)(this.props, 'name');
        if (adUnitName.indexOf('oop') === -1) {
          // do not show an ads when:
          // mobile ad unit name is not found and viewport > 1024
          if (adUnitName.indexOf('mobile') !== -1 && userViewportWidth >= 1024 || adUnitName.indexOf('mobile') === -1 && userViewportWidth < 1024) {
            return null;
          }
        }

        this.constructData();
        this.attachSafeFrameRefreshEvent();
        var viewableThreshold = 0;
        var renderWhenViewable = this.noLazyLoad === undefined;
        var collapseEmptyDiv = false;
        var viewableThresholdValues = {
          userViewport: this.userViewport ? this.userViewport : 'desktop',
          mobileValue: 350,
          desktopValue: 500
        };

        return _react2.default.createElement(
          'div',
          { className: this.constructAdClass(this.name, this.region) },
          _react2.default.createElement(
            'div',
            { className: 'ad-wrapper--ad-unit-wrap' },
            this.adLabel,
            _react2.default.createElement(
              'div',
              { className: 'ad-unit ad-unit__border' },
              _react2.default.createElement(_Bling2.default, {
                adUnitPath: this.adZone,
                sizeMapping: this.sizeMapping,
                targeting: this.slotLevelKeyvals,
                viewableThreshold: viewableThreshold,
                renderWhenViewable: renderWhenViewable,
                collapseEmptyDiv: collapseEmptyDiv,
                outOfPage: this.oop,
                onSlotRenderEnded: this.props.canRefresh ? this.addSlideShowAdRefreshListener : null,
                viewableThresholdValues: viewableThresholdValues
              })
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        {
          className: this.constructAdClass(this.props.name, this.props.region)
        },
        _react2.default.createElement(
          'div',
          { className: 'ad-wrapper--ad-unit-wrap' },
          this.props.slug === 'false' || this.props.name === 'oop' ? '' : _react2.default.createElement(
            'div',
            { className: 'ad-wrapper__ad-slug' },
            'advertisement'
          ),
          _react2.default.createElement('div', { className: 'ad-unit ad-unit__border' })
        )
      );
    }
  }]);

  return Ad;
}(_react.Component);

Ad.propTypes = {
  initialPageLoad: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  baseConfig: _propTypes2.default.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  definitions: _propTypes2.default.object.isRequired,
  adzoneOverride: _propTypes2.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  model: _propTypes2.default.object.isRequired,
  name: _propTypes2.default.string.isRequired,
  region: _propTypes2.default.string,
  slug: _propTypes2.default.bool,
  oop: _propTypes2.default.bool,
  pos: _propTypes2.default.string,
  pageNum: _propTypes2.default.number,
  noLazyLoad: _propTypes2.default.bool,
  canRefresh: _propTypes2.default.bool
};

Ad.defaultProps = {
  adzoneOverride: '',
  region: '',
  slug: true,
  oop: false,
  pos: 'btf',
  pageNum: 1,
  noLazyLoad: false,
  canRefresh: false
};

function mapStateToProps(state) {
  var initialPageLoad = state.config.initialPageLoad;

  return {
    initialPageLoad: initialPageLoad
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Ad);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (state) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';

  return {
    method: method,
    auth: {
      username: (0, _get2.default)(state, 'config.authUsername'),
      password: (0, _get2.default)(state, 'config.authPassword')
    }
  };
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound(_ref) {
  var message = _ref.message,
      statusCode = _ref.statusCode;

  return _react2.default.createElement(
    'div',
    { className: 'not-found' },
    _react2.default.createElement(
      'h2',
      { className: 'not-found__title' },
      statusCode,
      ': ',
      message
    ),
    _react2.default.createElement(
      'h3',
      { className: 'not-found__subtitle' },
      'Please enjoy these suggestions:'
    )
  );
}

NotFound.defaultProps = {
  message: 'the page you are looking for cannot be found',
  statusCode: 404
};

NotFound.propTypes = {
  message: _propTypes2.default.string,
  statusCode: _propTypes2.default.number
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchRecircModule;
exports.hideRecircAction = hideRecircAction;

var _recirc_feed_action_creators = __webpack_require__(507);

var recircFeedActions = _interopRequireWildcard(_recirc_feed_action_creators);

var _recirc_module = __webpack_require__(508);

var _recirc_module2 = _interopRequireDefault(_recirc_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchRecircModule(params, store) {
  return function firstDispatchRecirc(dispatch) {
    dispatch(recircFeedActions.recircFeedLoading({}, store));
    return _recirc_module2.default.fetch(params, store).then(function handleRecircModuleData(resp) {
      dispatch(recircFeedActions.recircFeedLoaded(resp.data, store));
    }).catch(function handleRecircError(err) {
      dispatch(recircFeedActions.recircFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in recirc feed actions, message: ' + err.message);
    });
  };
}

function hideRecircAction(dispatch) {
  return function hide() {
    dispatch(recircFeedActions.hideRecircFeed());
  };
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingSpinner = function (_Component) {
  _inherits(LoadingSpinner, _Component);

  function LoadingSpinner() {
    _classCallCheck(this, LoadingSpinner);

    return _possibleConstructorReturn(this, (LoadingSpinner.__proto__ || Object.getPrototypeOf(LoadingSpinner)).apply(this, arguments));
  }

  _createClass(LoadingSpinner, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var modifier = this.props.modifier;


      return _react2.default.createElement(
        'div',
        { className: 'loader-wrap' },
        _react2.default.createElement('div', { className: 'loader ' + (modifier ? 'loader--' + modifier : '') })
      );
    }
  }]);

  return LoadingSpinner;
}(_react.Component);

exports.default = LoadingSpinner;


LoadingSpinner.defaultProps = {
  modifier: ''
};

LoadingSpinner.propTypes = {
  modifier: _propTypes2.default.string
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var fastcompany = {
  'fb:pages': '5942134076',
  'og:site_name': 'Fast Company',
  'fb:app_id': '178479832213933',
  'fb:admins': '100000062710915',
  'article:publisher': 'https://www.facebook.com/FastCompany',
  'twitter:site': '@FastCompany',
  'twitter:domain': 'fastcompany.com',
  imageUrl: 'https://a.fastcompany.net/image/upload/v1485296620/fcweb/fastcompany-seo.png'
};

var fastcodesign = {
  'fb:pages': '107619279310824',
  'og:site_name': 'Co.Design',
  'fb:app_id': '123388861116012',
  'fb:admins': '100000062710915',
  'article:publisher': 'https://www.facebook.com/FastCoDesign',
  'twitter:site': '@FastCoDesign',
  'twitter:domain': 'fastcodesign.com',
  imageUrl: 'https://a.fastcompany.net/image/upload/v1485296802/fcweb/codesign-seo.png'
};

exports.default = {
  fastcompany: fastcompany,
  fastcodesign: fastcodesign
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var site = data.site,
      siteConf = data.siteConf,
      type = data.type,
      rss = data.rss,
      _data$publisher = data.publisher,
      publisher = _data$publisher === undefined ? true : _data$publisher,
      _data$extend = data.extend,
      extend = _data$extend === undefined ? [] : _data$extend;

  var amp = (0, _get2.default)(data, 'config.amp');
  var fbia = (0, _get2.default)(data, 'config.fbia');
  var useSloganTitle = data.useSloganTitle,
      titleTruncated = data.titleTruncated,
      noPipe = data.noPipe;
  var title = data.title;

  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]', '');
  var analytics = _identity2.default[site] || _identity2.default.fastcompany;
  var description = data.description || analytics.description || '';
  var url = data.url || analytics.url || '';
  var siteSlug = analytics.slug || '';
  var fbConfig = analytics.facebook || {};
  var image = data.image || analytics.logo;
  var imageWidth = data.image_width;
  var imageHeight = data.image_height;

  // title = original title from each seo util, titleSEO modified title base on page type, to be displayed in metatags
  // If titleTruncated exists, only apply it to <title> but keep social title untruncated

  // Default title | sitename
  var titleSEO = title + ' | ' + (0, _get2.default)(_identity2.default[site], 'siteName', '');

  // If this is set, usually on homepages, display slogan instead
  if (useSloganTitle === true) {
    titleSEO = title + ' | ' + (0, _get2.default)(_identity2.default[site], 'slogan', '');
  }

  // Pass this option to render no pipe on specific page type utils
  if (noPipe === true) {
    titleSEO = title;
  }

  var config = {
    title: titleTruncated || titleSEO,
    meta: [{
      'http-equiv': 'X-UA-Compatible',
      content: 'IE=edge,chrome=1'
    }, {
      property: 'fb:pages',
      content: '' + (0, _get2.default)(_identity2.default, 'fastcompany.facebook.fanpageId')
    }, {
      property: 'fb:pages',
      content: '' + (0, _get2.default)(_identity2.default, 'fastcodesign.facebook.fanpageId')
    }, {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    }, {
      name: 'description',
      content: description
    }, {
      property: 'og:type',
      content: type || 'article'
    }, {
      property: 'og:title',
      content: titleSEO
    }, {
      property: 'og:url',
      content: url
    }, {
      property: 'og:locale',
      content: 'en_US'
    }, {
      property: 'og:description',
      content: description
    }, {
      property: 'og:image',
      content: image
    }, {
      property: 'og:site_name',
      content: siteHumanReadable
    }, {
      property: 'fb:app_id',
      content: '' + (0, _get2.default)(fbConfig, 'appId')
    }, {
      property: 'fb:admins',
      content: '' + (0, _get2.default)(fbConfig, 'appAdminId')
    }, {
      name: 'twitter:card',
      content: data.twitterCard || 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: titleSEO
    }, {
      name: 'twitter:description',
      content: description
    }, {
      name: 'twitter:url',
      content: url
    }, {
      name: 'twitter:site',
      content: '@' + siteSlug
    }, {
      name: 'twitter:image',
      content: data.twitterImage || image
    }, {
      name: 'twitter:domain',
      content: siteSlug + '.com'
    }, {
      itemProp: 'name',
      content: titleSEO
    }, {
      itemProp: 'description',
      content: description
    }, {
      name: 'theme-color',
      content: '#ffffff'
    }],
    link: [{
      rel: 'canonical',
      href: url
    }, {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/apple-touch-icon.png?v=2'
    }, {
      rel: 'icon',
      type: 'image/png',
      href: '/favicon-32x32.png',
      sizes: '32x32'
    }, {
      rel: 'icon',
      type: 'image/png',
      href: '/favicon-16x16.png',
      sizes: '16x16'
    }, {
      rel: 'manifest',
      href: '/manifest.json'
    }, {
      rel: 'mask-icon',
      href: '/safari-pinned-tab.svg',
      color: '#000000'
    }, {
      rel: 'shortcut icon',
      href: '/favicon.ico?v=4'
    }, {
      rel: 'alternate',
      href: url,
      hrefLang: 'en'
    }, {
      rel: 'prefetch',
      href: 'https://tpc.googlesyndication.com/safeframe/1-0-5/html/container.html'
    }],
    noscript: [],
    style: []
  };

  if (site === 'fastcompany') {
    config.meta.push({
      name: 'google-site-verification',
      content: 'rU5yl8EMHvPkTmEeqiqqeEVmNz4eTxaV_Zw8-tr26VA'
    });
  } else if (site === 'fastcodesign') {
    config.meta.push({
      name: 'google-site-verification',
      content: 'hEoYh9bBZQ_K6nUgOetsOet3PbXC8DxQaxc2muRShTA'
    });
  }

  if (publisher) {
    config.meta.push({
      property: 'article:publisher',
      content: siteConf['article:publisher'] || ''
    });
  }

  if (data.articleSection) {
    config.meta.push({
      property: 'article:section',
      content: data.articleSection
    });
  }

  if (rss) {
    config.link.push({
      rel: 'alternate',
      type: 'application/rss+xml',
      title: 'RSS',
      href: rss
    });
  }

  if (image && imageWidth && imageHeight) {
    config.meta.push({
      property: 'og:image:width',
      content: imageWidth
    });

    config.meta.push({
      property: 'og:image:height',
      content: imageHeight
    });
  }

  if (amp) {
    config = {
      title: titleSEO,
      meta: [],
      link: [],
      extend: []
    };
  }

  if (fbia) {
    config = {
      title: titleSEO,
      meta: [],
      link: [],
      extend: []
    };
  }

  // Extend is used to add objects to the arrays in the config object.
  // For example if you would like to add another meta tag you can:
  // const data = baseSeoUtil({
  //   ...
  //   extend: [{
  //     meta: [{
  //       property: 'META_PROPERTY',
  //       content: 'META_CONTENT'
  //     }]
  //   }]
  // });

  extend.forEach(function (extras) {
    var key = Object.keys(extras).join('');
    var arr = extras[key];

    config[key] = config[key].concat(arr);
  });

  return config;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Slug = function (_Component) {
  _inherits(Slug, _Component);

  function Slug() {
    _classCallCheck(this, Slug);

    var _this = _possibleConstructorReturn(this, (Slug.__proto__ || Object.getPrototypeOf(Slug)).call(this));

    _this.renderTitle = _this.renderTitle.bind(_this);
    return _this;
  }

  _createClass(Slug, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle(title) {
      var classes = ['slug'];
      var _props = this.props,
          advertorial = _props.advertorial,
          className = _props.className;


      if (advertorial) {
        classes.push('slug--advertorial');
      }

      if (className) {
        classes.push(' ' + className + '__slug');
      }

      classes = classes.join(' ');

      if (className === 'tag-page' || className === 'tag-page-section') {
        return _react2.default.createElement(
          'h2',
          { className: classes },
          title
        );
      }

      if (className === 'category-page') {
        return _react2.default.createElement(
          'h1',
          { className: classes },
          title
        );
      }

      return _react2.default.createElement(
        'h2',
        { className: classes },
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props) {
        return null;
      }

      var _props2 = this.props,
          slugName = _props2.slugName,
          className = _props2.className,
          linkTo = _props2.linkTo,
          archives = _props2.archives;

      var hasLink = linkTo ? linkTo.length : false;
      var slugClasses = 'slug-component' + (className ? ' ' + className + '__slug-component' : '');
      var title = slugName.replace(/\*/g, '').replace(/_/g, ' ');

      if (hasLink) {
        title = _react2.default.createElement(
          'a',
          { href: linkTo, className: 'slug__title-link' },
          title
        );
      }

      return _react2.default.createElement(
        'div',
        { className: slugClasses },
        this.renderTitle(title),
        archives.name && archives.url ? _react2.default.createElement(
          'a',
          { href: archives.url, className: 'slug__archives' },
          _react2.default.createElement(
            'span',
            null,
            archives.name
          )
        ) : null
      );
    }
  }]);

  return Slug;
}(_react.Component);

exports.default = Slug;


Slug.defaultProps = {
  slugName: '',
  className: '',
  linkTo: '',
  advertorial: false,
  archives: {
    name: '',
    url: ''
  }
};

Slug.propTypes = {
  slugName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  linkTo: _propTypes2.default.string,
  advertorial: _propTypes2.default.bool,
  archives: _propTypes2.default.shape({})
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(32);

var _urlParse = __webpack_require__(45);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FCLink = function (_Component) {
  _inherits(FCLink, _Component);

  function FCLink() {
    _classCallCheck(this, FCLink);

    return _possibleConstructorReturn(this, (FCLink.__proto__ || Object.getPrototypeOf(FCLink)).apply(this, arguments));
  }

  _createClass(FCLink, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          to = _props.to,
          title = _props.title,
          children = _props.children,
          externalLink = _props.externalLink;
      var site = config.site,
          env = config.env,
          amp = config.amp;

      var development = env === 'development';
      var sameDomain = !amp && to.indexOf(site) !== -1;
      var external = externalLink || to.indexOf('/videos/list/') !== -1;
      var relativePath = void 0;
      var href = void 0;

      // Use local TLD with port if dev.
      if (development && !external) {
        href = to.replace(/http(s)?:\/\/(www.)?/, 'http://').replace('.com', '.local:8880');
      }

      // If we are on the current site use the link component to avoid page refresh.
      if (sameDomain && !external) {
        relativePath = (0, _urlParse2.default)(to, true).pathname;
        // Redirect MCP tag to MCP category.
        if (relativePath === '/section/most-creative-people') {
          relativePath = '/most-creative-people';
        }
      }

      if (relativePath) {
        return _react2.default.createElement(
          _reactRouterDom.Link,
          { to: relativePath, title: title },
          children
        );
      }

      return _react2.default.createElement(
        'a',
        { href: href || to, title: title },
        children
      );
    }
  }]);

  return FCLink;
}(_react.Component);

exports.default = FCLink;


FCLink.defaultProps = {
  to: '',
  externalLink: false,
  title: ''
};

FCLink.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  to: _propTypes2.default.string,
  title: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  externalLink: _propTypes2.default.bool
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  fastcompany: {
    siteName: 'Fast Company',
    slug: 'fastcompany',
    url: 'https://www.fastcompany.com',
    slogan: 'The future of business',
    description: "Fast Company is the world's leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.",
    favicon: '/favicon.ico',
    logo: 'https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png',
    keywords: ['business', 'magazine', 'news', 'leadership', 'most innovative companies', 'most creative people', 'videos', 'innovation'],
    facebook: {
      fanpageId: '5942134076',
      appId: '178479832213933',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53aqF_f'
    },
    reCaptcha: {
      public: '6Lf59DoUAAAAAMImCMrNJRUIrtlnwN5sH_NOQ9D2'
    },
    omniture: {
      server: 'fastcompany',
      trackingPixel: '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode: '//images.fastcompany.net/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcompany.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-2',
      rollupPropertyId: 'UA-4300461-33'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcompany.com'
    },
    pingdom: {
      id: '518c1737abe53dc44c000000'
    },
    magazineSubUrls: ['https://magazine.fastcompany.com/loc/FST/holiday2017']
  },
  fastcodesign: {
    siteName: 'Co.Design',
    slug: 'fastcodesign',
    url: 'https://www.fastcodesign.com',
    slogan: 'Where business and design collide',
    description: 'Inspiring stories about innovation and business, seen through the lens of design.',
    favicon: '/favicon.ico',
    logo: 'https://images.fastcompany.net/image/upload/v1481312788/fcweb/codesign-share-graphic.png',
    keywords: ['innovation', 'ethonomics', 'graphics', 'innovation by design', 'interactive', 'product', 'spaces', 'world changing ideas'],
    facebook: {
      fanpageId: '107619279310824',
      appId: '123388861116012',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53bAWi-'
    },
    omniture: {
      server: 'fastcodesign',
      trackingPixel: '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode: '//images.fastcompany.net/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcodesign.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-6',
      rollupPropertyId: 'UA-4300461-33'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcodesign.com'
    },
    pingdom: {
      id: '51955434abe53d9a09000000'
    },
    magazineSubUrls: ['https://magazine.fastcompany.com/loc/FST/holiday2017']
  }
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(178),
    getTag = __webpack_require__(127),
    isArguments = __webpack_require__(95),
    isArray = __webpack_require__(29),
    isArrayLike = __webpack_require__(41),
    isBuffer = __webpack_require__(96),
    isPrototype = __webpack_require__(73),
    isTypedArray = __webpack_require__(121);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getAdvertorialEyebrow = getAdvertorialEyebrow;
exports.isAdvertorial = isAdvertorial;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function generateTagData() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var data = {};

  tags.forEach(function (tag) {
    var name = tag.name;

    var slicedName = name.slice(0, 1);

    // there are cases of no star, hence this does not always work
    if (!data.advertiser && slicedName === '*') {
      data.advertiser = name.slice(1).replace(/_/g, ' ').replace(/\s?advertorial/g, '').toUpperCase();
    } else if (!data.type && slicedName === '_') {
      data.type = name;
    }
  });

  return data;
}

function getAdvertorialEyebrow(tags) {
  var tagData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var data = tagData || generateTagData(tags);
  var copy = 'Created For and Commissioned By: ';

  if (!data.advertiser) {
    return 'Sponsored Content';
  }

  if (data.type === '_syndicated') {
    copy = 'Paid For And Posted By: ';
  }

  copy += data.advertiser;

  return copy;
}

function isAdvertorial() {
  var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return !!tags.filter(function (tag) {
    return tag.slug === 'advertorial';
  }).length;
}

var Advertorial = function (_Component) {
  _inherits(Advertorial, _Component);

  function Advertorial() {
    _classCallCheck(this, Advertorial);

    return _possibleConstructorReturn(this, (Advertorial.__proto__ || Object.getPrototypeOf(Advertorial)).apply(this, arguments));
  }

  _createClass(Advertorial, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'getBranding',
    value: function getBranding(slot) {
      var type = void 0;

      switch (slot) {
        case '_custom':
          type = ['fast-co-works'];
          break;
        case '_brandview':
          type = ['fast-co-works', 'inc-brand-view'];
          break;
        case '_syndicated':
          type = _react2.default.createElement(_ad2.default, _extends({}, this.props.adModel, {
            noLazyLoad: true,
            slug: false,
            pos: 'atf',
            name: 'flexiblelogo'
          }));
          break;
        default:
          type = null;
          break;
      }

      if (Array.isArray(type)) {
        return _react2.default.createElement(
          'ul',
          { className: 'advertorial__list' },
          type.map(function (item) {
            return _react2.default.createElement('li', {
              key: item,
              className: 'advertorial__item advertorial__item--' + item
            });
          })
        );
      }

      return type;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          modifier = _props.modifier,
          tags = _props.tags,
          section = _props.section;

      var data = generateTagData(tags);
      var eyebrow = getAdvertorialEyebrow(tags, data);

      if (section) {
        return _react2.default.createElement(
          'h3',
          { className: 'advertorial__module-deck' },
          eyebrow
        );
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'advertorial ' + (modifier ? 'advertorial--' + modifier : '')
        },
        data.type || data.advertiser ? _react2.default.createElement(
          'div',
          {
            className: 'advertorial__container ' + (modifier ? 'advertorial__container--' + modifier : '')
          },
          data.type && this.getBranding(data.type),
          data.advertiser ? _react2.default.createElement(
            'span',
            { className: 'advertorial__copy' },
            eyebrow
          ) : ''
        ) : null
      );
    }
  }]);

  return Advertorial;
}(_react.Component);

exports.default = Advertorial;


Advertorial.defaultProps = {
  modifier: '',
  section: '',
  adModel: {}
};

Advertorial.propTypes = {
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  modifier: _propTypes2.default.string,
  section: _propTypes2.default.string,
  adModel: _propTypes2.default.shape({})
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageSizesLookup = undefined;
;(buildAssetUrlWithSizes);
;(buildAssetUrlWithAuto);
exports.buildSrcSet = buildSrcSet;
exports.makeHttps = makeHttps;
exports.buildAssetUrlWithPresets = buildAssetUrlWithPresets;
exports.changeAssetDomain = changeAssetDomain;
exports.convertGIFToVideoAssets = convertGIFToVideoAssets;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isUndefined = __webpack_require__(429);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isString = __webpack_require__(98);

var _isString2 = _interopRequireDefault(_isString);

var _urlParse = __webpack_require__(45);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fcAssetsDomain = 'images.fastcompany.net';
var legacyAssetsDomain = 'assets.fastcompnay.com';
var cloudinaryDomain = 'fast-company-res.cloudinary.com';
var s3Domain = 'wp-cms-fastcompany-com.s3.amazonaws.com';

function buildAssetUrlWithSizes(assetUrl, size) {
  if (typeof assetUrl === 'string' && typeof size === 'string') {
    var matchData = size.match(/w_(\d*)/);
    var width = (0, _get2.default)(matchData, '1');

    return width ? assetUrl.replace('/upload/', '/upload/' + size + '/').replace('/fetch/', '/fetch/' + size + '/') + ' ' + width + 'w' : '';
  }

  return '';
}

function buildAssetUrlWithAuto(src) {
  return src && typeof src === 'string' ? src.replace('upload/', 'upload/w_auto,c_limit/') : '';
}

function buildSrcSet(assetSizes, propsToSrcSetForSize, src) {
  var srcSetItems = (0, _get2.default)(assetSizes, propsToSrcSetForSize) || [];
  return srcSetItems.map(function (item) {
    return buildAssetUrlWithSizes(src, item);
  }).join(', ');
}

function makeHttps(url) {
  if (!(0, _isString2.default)(url)) {
    return null;
  }
  var parsed = new _urlParse2.default(url);
  if (parsed.protocol !== 'https:') {
    parsed.set('protocol', 'https:');
    return parsed.toString();
  }

  return url;
}

function buildAssetUrlWithPresets(src, size, isDesktop) {
  var smallSizes = (0, _get2.default)(size, 'small.srcset');
  var smallSizesLength = (0, _get2.default)(smallSizes, 'length');
  var largestSmallPreset = (0, _get2.default)(smallSizes, '[' + (smallSizesLength - 1) + ']');

  var largeSizes = (0, _get2.default)(size, 'large.srcset');
  var largeSizesLength = (0, _get2.default)(largeSizes, 'length');
  var largestLargePreset = (0, _get2.default)(largeSizes, '[' + (largeSizesLength - 1) + ']');

  // this is to provide an asset size for gifs converted to videos
  // since they can't take an entire srcset string
  var presetSize = isDesktop ? largestLargePreset : largestSmallPreset;

  if (!(0, _isString2.default)(src)) {
    return null;
  }

  var parsed = new _urlParse2.default(src);

  if (parsed.host === cloudinaryDomain || parsed.host === legacyAssetsDomain || parsed.host === fcAssetsDomain) {
    parsed.set('pathname', parsed.pathname.replace('/upload/', '/upload/' + presetSize + '/').replace('/fetch/', '/fetch/' + presetSize + '/'));
    return parsed.toString();
  }

  return src;
}

function changeAssetDomain(url) {
  if (!(0, _isString2.default)(url)) {
    return null;
  }

  var parsed = new _urlParse2.default(url);

  // cloudinary fetch api must use cloudinary domain, otherwise, asset will 404
  var doesNotUseCloudinaryFetch = parsed.pathname.indexOf('/fetch/') === -1;
  if (parsed.host === cloudinaryDomain && doesNotUseCloudinaryFetch) {
    parsed.set('host', fcAssetsDomain);
    return parsed.toString();
  }

  if (parsed.host === s3Domain) {
    parsed.set('host', fcAssetsDomain);
    var pathname = parsed.pathname;

    parsed.set('pathname', '/image/upload/wp-cms' + pathname);
    return parsed.toString();
  }

  return url;
}

function convertGIFToVideoAssets(assetUrl) {
  if (!(0, _isString2.default)(assetUrl) || (0, _isUndefined2.default)(assetUrl)) {
    return null;
  }

  var parsed = new _urlParse2.default(assetUrl);
  var formats = ['jpg', 'webm', 'mp4'];
  var assets = {};
  if (parsed.host === fcAssetsDomain || parsed.host === cloudinaryDomain || parsed.host === legacyAssetsDomain) {
    formats.forEach(function createAssetUrlForEachFormat(format) {
      assets[format] = assetUrl.replace('f_auto', 'f_' + format);
      if (format === 'mp4' || format === 'webm') {
        assets[format] = assets[format].replace(',q_auto', ',q_70').replace(',q_auto', ',q_70');
      }
    });
    return assets;
  }

  return assetUrl;
}

// following breakpoints generated with http://www.responsivebreakpoints.com/ (size step 45kb on desktop, 25kb on mobile, max 5 image)
var imageSizesLookup = exports.imageSizesLookup = {
  column: {
    large: {
      sizes: 'calc(0.1666 * (100vw - 40px))',
      srcset: ['w_112,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_306,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_141,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_236,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  4: {
    large: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_216,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_560,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_141,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_472,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  3: {
    large: {
      sizes: '33vw',
      srcset: ['w_301,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_772,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_141,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_472,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  2: {
    large: {
      sizes: '50vw',
      srcset: ['w_491,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_900,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1162,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1200,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_141,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_472,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  1: {
    large: {
      sizes: 'calc(0.666 * (100vw - 40px))',
      srcset: ['w_650,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1045,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1348,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1557,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1626,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(100vw - 20px)',
      srcset: ['w_300,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_638,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_800,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  poster: {
    large: {
      sizes: 'calc(0.58333 * (100vw - 40px))',
      srcset: ['w_562,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_937,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1379,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_1400,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(100vw - 20px)',
      srcset: ['w_300,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_638,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_800,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  meta: {
    large: {
      sizes: '100vw',
      srcset: ['w_1280,f_auto,q_auto,fl_lossy']
    }
  },
  slider: {
    large: {
      sizes: 'calc(0.58333 * (100vw - 40px))',
      srcset: ['w_562,c_limit,f_auto,q_auto,fl_lossy', 'w_937,c_limit,f_auto,q_auto,fl_lossy', 'w_1153,c_limit,f_auto,q_auto,fl_lossy', 'w_1379,c_limit,f_auto,q_auto,fl_lossy', 'w_1400,c_limit,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(100vw - 20px)',
      srcset: ['w_300,c_limit,f_auto,q_auto,fl_lossy', 'w_638,c_limit,f_auto,q_auto,fl_lossy', 'w_800,c_limit,f_auto,q_auto,fl_lossy']
    }
  },
  bigFirstMobile: {
    large: {
      sizes: 'calc(0.25 * (100vw - 40px))',
      srcset: ['w_772,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_302,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(100vw - 20px)',
      srcset: ['w_300,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_638,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy', 'w_800,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy']
    }
  },
  magazine: {
    large: {
      sizes: 'calc(0.25 * (100vw - 40px))',
      srcset: ['w_130,f_auto,q_auto,fl_lossy', 'w_750,f_auto,q_auto,fl_lossy']
    },
    small: {
      sizes: 'calc(0.5 * (100vw - 20px))',
      srcset: ['w_180,f_auto,q_auto,fl_lossy', 'w_589,f_auto,q_auto,fl_lossy', 'w_600,f_auto,q_auto,fl_lossy']
    }
  }
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(93),
    copyObject = __webpack_require__(49),
    createAssigner = __webpack_require__(171),
    isArrayLike = __webpack_require__(41),
    isPrototype = __webpack_require__(73),
    keys = __webpack_require__(50);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/warning/browser.js
var browser = __webpack_require__(23);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(3);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/history/createBrowserHistory.js
var createBrowserHistory = __webpack_require__(154);
var createBrowserHistory_default = /*#__PURE__*/__webpack_require__.n(createBrowserHistory);

// EXTERNAL MODULE: ./node_modules/react-router/es/Router.js
var Router = __webpack_require__(90);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Router.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Router = (Router["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/BrowserRouter.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter_BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = createBrowserHistory_default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    browser_default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return react_default.a.createElement(es_Router, { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(react_default.a.Component);

BrowserRouter_BrowserRouter.propTypes = {
  basename: prop_types_default.a.string,
  forceRefresh: prop_types_default.a.bool,
  getUserConfirmation: prop_types_default.a.func,
  keyLength: prop_types_default.a.number,
  children: prop_types_default.a.node
};


/* harmony default export */ var es_BrowserRouter = (BrowserRouter_BrowserRouter);
// EXTERNAL MODULE: ./node_modules/history/createHashHistory.js
var createHashHistory = __webpack_require__(433);
var createHashHistory_default = /*#__PURE__*/__webpack_require__.n(createHashHistory);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/HashRouter.js
function HashRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HashRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HashRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter_HashRouter = function (_React$Component) {
  HashRouter__inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    HashRouter__classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HashRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = createHashHistory_default()(_this.props), _temp), HashRouter__possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    browser_default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return react_default.a.createElement(es_Router, { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(react_default.a.Component);

HashRouter_HashRouter.propTypes = {
  basename: prop_types_default.a.string,
  getUserConfirmation: prop_types_default.a.func,
  hashType: prop_types_default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: prop_types_default.a.node
};


/* harmony default export */ var es_HashRouter = (HashRouter_HashRouter);
// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var invariant_browser = __webpack_require__(25);
var invariant_browser_default = /*#__PURE__*/__webpack_require__.n(invariant_browser);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Link.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Link__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Link__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Link__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link_Link = function (_React$Component) {
  Link__inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    Link__classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Link__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), Link__possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    invariant_browser_default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return react_default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(react_default.a.Component);

Link_Link.propTypes = {
  onClick: prop_types_default.a.func,
  target: prop_types_default.a.string,
  replace: prop_types_default.a.bool,
  to: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]).isRequired,
  innerRef: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.func])
};
Link_Link.defaultProps = {
  replace: false
};
Link_Link.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired,
      createHref: prop_types_default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ var es_Link = (Link_Link);
// EXTERNAL MODULE: ./node_modules/react-router/es/MemoryRouter.js
var MemoryRouter = __webpack_require__(162);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/MemoryRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_MemoryRouter = (MemoryRouter["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/react-router/es/Route.js
var Route = __webpack_require__(117);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Route.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Route = (Route["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/NavLink.js
var NavLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function NavLink__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink_NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = NavLink__objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return react_default.a.createElement(es_Route, {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return react_default.a.createElement(es_Link, NavLink__extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? NavLink__extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink_NavLink.propTypes = {
  to: es_Link.propTypes.to,
  exact: prop_types_default.a.bool,
  strict: prop_types_default.a.bool,
  location: prop_types_default.a.object,
  activeClassName: prop_types_default.a.string,
  className: prop_types_default.a.string,
  activeStyle: prop_types_default.a.object,
  style: prop_types_default.a.object,
  isActive: prop_types_default.a.func,
  ariaCurrent: prop_types_default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink_NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ var es_NavLink = (NavLink_NavLink);
// EXTERNAL MODULE: ./node_modules/react-router/es/Prompt.js
var Prompt = __webpack_require__(163);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Prompt.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Prompt = (Prompt["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/react-router/es/Redirect.js + 8 modules
var Redirect = __webpack_require__(164);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Redirect.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Redirect = (Redirect["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/react-router/es/StaticRouter.js
var StaticRouter = __webpack_require__(165);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/StaticRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_StaticRouter = (StaticRouter["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/react-router/es/Switch.js
var Switch = __webpack_require__(166);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Switch.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_Switch = (Switch["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/react-router/es/matchPath.js
var matchPath = __webpack_require__(91);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/matchPath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_matchPath = (matchPath["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/react-router/es/withRouter.js
var withRouter = __webpack_require__(167);

// CONCATENATED MODULE: ./node_modules/react-router-dom/es/withRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var es_withRouter = (withRouter["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return es_BrowserRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HashRouter", function() { return es_HashRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Link", function() { return es_Link; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return es_MemoryRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NavLink", function() { return es_NavLink; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Prompt", function() { return es_Prompt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Redirect", function() { return es_Redirect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Route", function() { return es_Route; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Router", function() { return es_Router; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return es_StaticRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Switch", function() { return es_Switch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "matchPath", function() { return es_matchPath; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withRouter", function() { return es_withRouter; });



























/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Card;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _default_card = __webpack_require__(438);

var _default_card2 = _interopRequireDefault(_default_card);

var _featured_card = __webpack_require__(439);

var _featured_card2 = _interopRequireDefault(_featured_card);

var _all_feed_card = __webpack_require__(440);

var _all_feed_card2 = _interopRequireDefault(_all_feed_card);

var _video_card = __webpack_require__(441);

var _video_card2 = _interopRequireDefault(_video_card);

var _recirc_card = __webpack_require__(442);

var _recirc_card2 = _interopRequireDefault(_recirc_card);

var _small_card = __webpack_require__(443);

var _small_card2 = _interopRequireDefault(_small_card);

var _magazine_card = __webpack_require__(444);

var _magazine_card2 = _interopRequireDefault(_magazine_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Card(props) {
  var type = props.type,
      metadata = props.metadata;


  if ((0, _isEmpty2.default)(metadata)) {
    return null;
  }

  switch (type) {
    case 'featured':
      return _react2.default.createElement(_featured_card2.default, props);
    case 'video':
      return _react2.default.createElement(_video_card2.default, props);
    case 'all-feed':
      return _react2.default.createElement(_all_feed_card2.default, props);
    case 'recirc':
      return _react2.default.createElement(_recirc_card2.default, props);
    case 'small':
      return _react2.default.createElement(_small_card2.default, props);
    case 'magazine':
      return _react2.default.createElement(_magazine_card2.default, props);
    default:
      return _react2.default.createElement(_default_card2.default, props);
  }
}

Card.defaultProps = {
  type: ''
};

Card.propTypes = {
  type: _propTypes2.default.string,
  metadata: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(214);
var isBuffer = __webpack_require__(468);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  "isFunction": ((isFunction),null),
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStickynode = __webpack_require__(77);

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _chunk = __webpack_require__(103);

var _chunk2 = _interopRequireDefault(_chunk);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _debounce = __webpack_require__(211);

var _debounce2 = _interopRequireDefault(_debounce);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _get_site_from_uri_util = __webpack_require__(487);

var _get_site_from_uri_util2 = _interopRequireDefault(_get_site_from_uri_util);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _cloudinary_asset_util = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function noop() {}

var AllFeed = function (_Component) {
  _inherits(AllFeed, _Component);

  function AllFeed(props) {
    _classCallCheck(this, AllFeed);

    var _this = _possibleConstructorReturn(this, (AllFeed.__proto__ || Object.getPrototypeOf(AllFeed)).call(this, props));

    _this.renderMoreButton = _this.renderMoreButton.bind(_this);
    _this.enableInfiniteScroll = _this.enableInfiniteScroll.bind(_this);
    _this.handleScroll = (0, _debounce2.default)(_this.handleScroll.bind(_this), 100);
    return _this;
  }

  _createClass(AllFeed, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isDesktop = (0, _client_util2.default)();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getAllStories',
    value: function getAllStories() {
      var formattedStories = this.props.stories.map(function (post, i) {
        return (0, _assign2.default)(post, {
          site: (0, _get_site_from_uri_util2.default)((0, _get2.default)(post, 'link')),
          assetSizes: i === 0 ? _cloudinary_asset_util.imageSizesLookup.bigFirstMobile : _cloudinary_asset_util.imageSizesLookup[3],
          allowNoImage: true,
          excerpt: (0, _striptags2.default)(post.excerpt || '')
        });
      });

      if (this.props.allRendered || this.props.paginationEnabled || this.props.infiniteScrollEnabled) {
        return formattedStories;
      }

      return this.props.stories.length >= 10 ? formattedStories.slice(0, 10) : formattedStories;
    }
  }, {
    key: 'getSections',
    value: function getSections() {
      var sections = (0, _chunk2.default)(this.getAllStories(), 10);

      return sections.map(function (section, index) {
        return {
          id: 'section-' + (index + 1),
          stories: section
        };
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableInfiniteScroll',
    value: function enableInfiniteScroll(e) {
      var _this2 = this;

      e.preventDefault();
      this.infiniteScrollInitialized = true;
      this.props.hideRecircFeed();
      this.props.infiniteScrollAllFeedFetch({
        page: this.props.page + 1,
        slug: this.props.section
      }, this.props.config).then(function () {
        window.addEventListener('scroll', _this2.handleScroll);
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (!this.props.infiniteScrollLoading) {
        if (this.props.totalPages < this.props.page) {
          return this.removeEvents();
        }
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 3000) {
          return this.props.infiniteScrollAllFeedFetch({
            page: this.props.page + 1,
            slug: this.props.section
          }, this.props.config);
        }
      }
      return false;
    }
  }, {
    key: 'renderMoreButton',
    value: function renderMoreButton(index, allFeedLength, isLastSection, isLastPage, config) {
      if (this.props.infiniteScrollEnabled) {
        if (this.infiniteScrollInitialized) {
          return null;
        }

        if (this.props.totalPages === 1 || this.props.infiniteScrollLoading && !isLastSection) {
          return null;
        }

        if (isLastSection) {
          var page = this.props.page + 1;
          var href = this.props.type === 'homepage' ? '/all/' + page : '/' + this.props.type + '/' + this.props.section + '/' + page;

          if (this.props.hrefOverride) {
            href = '' + this.props.hrefOverride + page;
          }
          return _react2.default.createElement(
            'a',
            {
              title: 'See More ' + this.props.section + ' on page ' + this.props.page,
              href: href
            },
            _react2.default.createElement(
              'button',
              { onClick: this.enableInfiniteScroll },
              'See More Stories'
            )
          );
        }
      }

      if (this.props.paginationEnabled) {
        if (isLastPage) {
          return null;
        }
        if (isLastSection) {
          var _page = this.props.page;

          var _href = this.props.type === 'homepage' ? '/all/' + _page : '/' + this.props.type + '/' + this.props.section + '/' + _page;

          if (this.props.hrefOverride) {
            _href = '' + this.props.hrefOverride + _page;
          }
          return _react2.default.createElement(
            'div',
            {
              className: 'all-feed__button all-feed__button--' + (0, _get2.default)(config, 'site', '') + ' ' + (this.props.mobileSeeMoreHidden ? 'all-feed__button--mobile-hidden' : '')
            },
            _react2.default.createElement(
              _fc_link2.default,
              {
                title: 'See More ' + this.props.section + ' on page ' + (this.props.page + 1),
                to: _href,
                config: config
              },
              _react2.default.createElement(
                'button',
                null,
                'See More Stories'
              )
            )
          );
        }
        return null;
      }

      if (index !== 1 || this.props.allRendered || this.props.disableMore) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'all-feed__button all-feed__button--' + (0, _get2.default)(config, 'site', '') + ' ' + (this.props.mobileSeeMoreHidden ? 'all-feed__button--mobile-hidden' : '')
        },
        _react2.default.createElement(
          'button',
          { onClick: this.props.setAllLoadedState },
          'See More Stories'
        )
      );
    }
  }, {
    key: 'renderMobileAd',
    value: function renderMobileAd(index) {
      if (index === 1) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'all-feed__mobile-ad-container' },
        _react2.default.createElement(_ad2.default, _extends({}, this.props.adModel, { name: 'mobilerectangle_3' }))
      );
    }
  }, {
    key: 'renderSlugOrName',
    value: function renderSlugOrName(props) {
      if (!props || !props.hasSlug) {
        return null;
      }

      if (props.authorPage) {
        if ((0, _isEmpty2.default)(props.author)) return '';

        return _react2.default.createElement(
          'h2',
          { className: 'author-page__all-feed-title' },
          'Stories by ' + (0, _get2.default)(props.author, 'name'),
          _react2.default.createElement(
            'span',
            { className: 'author-page__all-feed-title-rss' },
            _react2.default.createElement(
              'a',
              { href: '/user/' + (0, _get2.default)(props.author, 'slug') + '/rss' },
              'RSS'
            )
          )
        );
      }

      if (!(0, _isEmpty2.default)(props.advertorialSlugs)) {
        return _react2.default.createElement(_slug2.default, {
          slugName: (0, _get2.default)(props.advertorialSlugs, 'name'),
          className: 'tag-page',
          advertorial: true
        });
      }

      var archives = {};
      if (props.titleOverride.indexOf('Magazine') > -1) {
        archives = {
          name: 'See Archives',
          url: '/magazine/archive'
        };
      }

      return _react2.default.createElement(_slug2.default, {
        linkTo: '//www.fastcompany.com',
        slugName: (0, _get2.default)(props, 'titleOverride') || 'All Stories',
        archives: archives
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          config = _props.config,
          advertorialSlugs = _props.advertorialSlugs,
          authorPage = _props.authorPage,
          author = _props.author,
          hasSlug = _props.hasSlug,
          titleOverride = _props.titleOverride,
          isLastPage = _props.isLastPage;
      var modifier = this.props.modifier;


      if (!modifier && !hasSlug) {
        modifier = 'no-slug';
      }

      var fullPageAdvertorial = modifier === 'advertorial';

      var allFeedLength = (0, _get2.default)(this.props, 'stories', []).length;

      return _react2.default.createElement(
        'section',
        { className: 'all-feed' },
        this.renderSlugOrName({
          advertorialSlugs: advertorialSlugs,
          authorPage: authorPage,
          author: author,
          hasSlug: hasSlug,
          titleOverride: titleOverride
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'all-feed__wrapper ' + (modifier ? 'all-feed__wrapper--' + modifier : '')
          },
          this.getSections().map(function (section, sectionIndex) {
            var isLastSection = _this3.getSections().length === sectionIndex + 1;
            var adCounter = sectionIndex + 1 > 10 ? 10 : sectionIndex + 1;

            return _react2.default.createElement(
              'div',
              { key: section.id, className: 'all-feed__section' },
              _react2.default.createElement(
                'div',
                { className: 'all-feed__posts' },
                section.stories.map(function (story, cardIndex) {
                  return _react2.default.createElement(_card2.default, {
                    type: 'all-feed',
                    key: story.id || story.mediaid,
                    metadata: story,
                    config: config,
                    hasExcerpt: story.layout === 'long',
                    fullPageAdvertorial: fullPageAdvertorial,
                    top: sectionIndex === 0 && cardIndex === 0
                  });
                }),
                _this3.renderMobileAd(sectionIndex),
                _this3.renderMoreButton(sectionIndex, allFeedLength, isLastSection, isLastPage, config)
              ),
              _react2.default.createElement(
                'div',
                { className: 'all-feed__sidebar' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'all-feed__promotion',
                    id: 'sidebar-ad-' + sectionIndex
                  },
                  _react2.default.createElement(
                    _reactStickynode2.default,
                    {
                      top: 100,
                      bottomBoundary: '#sidebar-ad-' + sectionIndex,
                      enabled: _this3.isDesktop
                    },
                    _react2.default.createElement(_ad2.default, _extends({}, _this3.props.adModel, {
                      name: 'flexiblehalfpage_' + adCounter
                    }))
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return AllFeed;
}(_react.Component);

AllFeed.defaultProps = {
  stories: [],
  allRendered: false,
  modifier: '',
  mobileSeeMoreHidden: false,
  advertorialSlugs: {},
  authorPage: false,
  author: {},
  hasSlug: true,
  disableMore: false,
  titleOverride: '',
  paginationEnabled: false,
  totalPages: 0,
  page: 0,
  section: '',
  type: '',
  isLastPage: false,
  infiniteScrollEnabled: false,
  infiniteScrollAllFeedFetch: noop,
  hideRecircFeed: noop,
  setAllLoadedState: noop,
  infiniteScrollLoading: false,
  hrefOverride: ''
};

AllFeed.propTypes = {
  stories: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  adModel: _propTypes2.default.shape({}).isRequired,
  allRendered: _propTypes2.default.bool,
  setAllLoadedState: _propTypes2.default.func,
  modifier: _propTypes2.default.string,
  mobileSeeMoreHidden: _propTypes2.default.bool,
  advertorialSlugs: _propTypes2.default.shape({}),
  authorPage: _propTypes2.default.bool,
  author: _propTypes2.default.shape({}),
  hasSlug: _propTypes2.default.bool,
  disableMore: _propTypes2.default.bool,
  titleOverride: _propTypes2.default.string,
  paginationEnabled: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  section: _propTypes2.default.string,
  page: _propTypes2.default.number,
  totalPages: _propTypes2.default.number,
  isLastPage: _propTypes2.default.bool,
  infiniteScrollLoading: _propTypes2.default.bool,
  infiniteScrollEnabled: _propTypes2.default.bool,
  infiniteScrollAllFeedFetch: _propTypes2.default.func,
  hideRecircFeed: _propTypes2.default.func,
  config: _propTypes2.default.shape({}).isRequired,
  hrefOverride: _propTypes2.default.string
};

exports.default = AllFeed;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(159);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matchMediaDesktop;
function matchMediaDesktop() {
  var minWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '40em';

  return window.matchMedia('(min-width: ' + minWidth + ')').matches;
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(160),
    isLength = __webpack_require__(119);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.striptags = factory();
  }
}(this, function () {

    var STATE_OUTPUT       = 0,
        STATE_HTML         = 1,
        STATE_PRE_COMMENT  = 2,
        STATE_COMMENT      = 3,
        WHITESPACE         = /\s/,
        ALLOWED_TAGS_REGEX = /<(\w*)>/g;

    function striptags(html, allowableTags, tagReplacement) {
        var html = html || '',
            state = STATE_OUTPUT,
            depth = 0,
            output = '',
            tagBuffer = '',
            inQuote = false,
            i, length, c;

        if (typeof allowableTags === 'string') {
            // Parse the string into an array of tags
            allowableTags = parseAllowableTags(allowableTags);
        } else if (!Array.isArray(allowableTags)) {
            // If it is not an array, explicitly set to null
            allowableTags = null;
        }

        for (i = 0, length = html.length; i < length; i++) {
            c = html[i];

            switch (c) {
                case '<': {
                    // ignore '<' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // '<' followed by a space is not a valid tag, continue
                    if (html[i + 1] == ' ') {
                        consumeCharacter(c);
                        break;
                    }

                    // change to STATE_HTML
                    if (state == STATE_OUTPUT) {
                        state = STATE_HTML;

                        consumeCharacter(c);
                        break;
                    }

                    // ignore additional '<' characters when inside a tag
                    if (state == STATE_HTML) {
                        depth++;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '>': {
                    // something like this is happening: '<<>>'
                    if (depth) {
                        depth--;
                        break;
                    }

                    // ignore '>' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // an HTML tag was closed
                    if (state == STATE_HTML) {
                        inQuote = state = 0;

                        if (allowableTags) {
                            tagBuffer += '>';
                            flushTagBuffer();
                        }

                        break;
                    }

                    // '<!' met its ending '>'
                    if (state == STATE_PRE_COMMENT) {
                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    // if last two characters were '--', then end comment
                    if (state == STATE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '-') {

                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                // catch both single and double quotes
                case '"':
                case '\'': {
                    if (state == STATE_HTML) {
                        if (inQuote == c) {
                            // end quote found
                            inQuote = false;
                        } else if (!inQuote) {
                            // start quote only if not already in one
                            inQuote = c;
                        }
                    }

                    consumeCharacter(c);
                    break;
                }

                case '!': {
                    if (state == STATE_HTML &&
                        html[i - 1] == '<') {

                        // looks like we might be starting a comment
                        state = STATE_PRE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '-': {
                    // if the previous two characters were '!-', this is a comment
                    if (state == STATE_PRE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '!') {

                        state = STATE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case 'E':
                case 'e': {
                    // check for DOCTYPE, because it looks like a comment and isn't
                    if (state == STATE_PRE_COMMENT &&
                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {

                        state = STATE_HTML;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                default: {
                    consumeCharacter(c);
                }
            }
        }

        function consumeCharacter(c) {
            if (state == STATE_OUTPUT) {
                output += c;
            } else if (allowableTags && state == STATE_HTML) {
                tagBuffer += c;
            }
        }

        function flushTagBuffer() {
            var normalized = '',
                nonWhitespaceSeen = false,
                i, length, c;

            normalizeTagBuffer:
            for (i = 0, length = tagBuffer.length; i < length; i++) {
                c = tagBuffer[i].toLowerCase();

                switch (c) {
                    case '<': {
                        break;
                    }

                    case '>': {
                        break normalizeTagBuffer;
                    }

                    case '/': {
                        nonWhitespaceSeen = true;
                        break;
                    }

                    default: {
                        if (!c.match(WHITESPACE)) {
                            nonWhitespaceSeen = true;
                            normalized += c;
                        } else if (nonWhitespaceSeen) {
                            break normalizeTagBuffer;
                        }
                    }
                }
            }

            if (allowableTags.indexOf(normalized) !== -1) {
                output += tagBuffer;
            } else if (tagReplacement) {
                output += tagReplacement;
            }

            tagBuffer = '';
        }

        return output;
    }

    /**
     * Return an array containing tags that are allowed to pass through the
     * algorithm.
     *
     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
     * @return array|null An array of allowed tags or null if none.
     */
    function parseAllowableTags(allowableTags) {
        var tagsArray = [],
            match;

        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
            tagsArray.push(match[1]);
        }

        return tagsArray.length !== 0 ? tagsArray : null;
    }

    return striptags;
}));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(509);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__(405)
  , qs = __webpack_require__(406)
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @api public
 */
function lolcation(loc) {
  loc = loc || global.location || {};

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new URL(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new URL(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @api private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @api private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} location Location defaults for relative paths.
 * @param {Boolean|Function} parser Parser for the query string.
 * @api public
 */
function URL(address, location, parser) {
  if (!(this instanceof URL)) {
    return new URL(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[2] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL}
 * @api public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String}
 * @api public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

URL.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
URL.extractProtocol = extractProtocol;
URL.location = lolcation;
URL.qs = qs;

module.exports = URL;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagAllFeedLoading = tagAllFeedLoading;
exports.tagAllFeedLoaded = tagAllFeedLoaded;
exports.tagAllFeedLoadError = tagAllFeedLoadError;
exports.tagAllFeedAllStoriesRendered = tagAllFeedAllStoriesRendered;
// import { canUseDOM } from 'exenv';

function tagAllFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_ALL_FEED_LOADING',
    tagAllFeed: resp,
    store: store
  };
}

function tagAllFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_ALL_FEED_LOADED',
    tagAllFeed: resp,
    store: store
  };
}

function tagAllFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_ALL_FEED_ERROR',
    tagAllFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function tagAllFeedAllStoriesRendered() {
  return {
    type: 'TAG_ALL_FEED_ALL_STORIES_RENDERED',
    allRendered: true
  };
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    getRawTag = __webpack_require__(307),
    objectToString = __webpack_require__(308);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(315),
    getValue = __webpack_require__(318);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(93),
    baseAssignValue = __webpack_require__(169);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(176),
    baseKeys = __webpack_require__(178),
    isArrayLike = __webpack_require__(41);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadGATracker;
exports.trackGAEvent = trackGAEvent;

var _forEach = __webpack_require__(99);

var _forEach2 = _interopRequireDefault(_forEach);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _exenv = __webpack_require__(4);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

var _ad_util = __webpack_require__(12);

var _feature_flags = __webpack_require__(75);

var _feature_flags2 = _interopRequireDefault(_feature_flags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadGATracker(currentState) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
  if (window.ga) {
    var _window = window,
        ga = _window.ga;

    var siteConfig = _identity2.default[(0, _get2.default)(currentState, 'context.site', 'fastcompany')];
    var siteSlug = (0, _get2.default)(siteConfig, 'slug');
    var context = (0, _get2.default)(currentState, 'context');

    var postData = context.postData,
        tagPageData = context.tagPageData,
        categoryPageData = context.categoryPageData,
        type = context.type;


    var _category = '';
    var _tag = '';

    if (_feature_flags2.default.gaCustomVarEnabled) {
      // config here: https://analytics.google.com/analytics/web/#management/Settings/a45063514w75598220p78098335/%3Fm.page%3DPropertySettings/
      var legacyDomain = siteSlug;
      var customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'homepage' }];
      var typeLookup = {
        post: function post() {
          _category = (0, _get2.default)(postData, 'categories[0].slug', 'technology');
          var tags = (0, _get2.default)(postData, 'tags');
          var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);

          var bylineAttribution = null;

          (0, _forEach2.default)(tags, function (tagObj) {
            if (tagObj.name.indexOf('byline_') !== -1 || tagObj.slug.indexOf('byline-') !== -1) {
              bylineAttribution = tagObj.name.replace('byline_', '');
            }
          });

          // For mapping of language, anaytics need to be consistent, language wise
          var typeMap = {
            standard: 'article',
            gallery: 'slideshow',
            video: 'video'
          };
          var pageType = typeMap[(0, _get2.default)(postData, 'format')] || 'article';

          if (_category === 'ideas') {
            legacyDomain = 'Fastcoexist.com';
          } else if (_category === 'entertainment') {
            legacyDomain = 'FastcoCreate.com';
          }

          customDimensions = [{ 'Legacy Domain': legacyDomain }, { Category: _category }, { 'Publication Date': (0, _get2.default)(postData, 'omnitureDate') }, { 'Content Type': pageType }, { 'Minutes Length': (0, _get2.default)(postData, 'readTime') }, { 'Scroll Page Number': pageNumber }];

          if (bylineAttribution) {
            customDimensions.push({ Contributor: bylineAttribution });
            customDimensions.push({ Editor: 'Fast Company' });
          } else {
            customDimensions.push({ Contributor: 'Fast Company' });
            customDimensions.push({ Editor: (0, _get2.default)(postData, 'author.name') });
          }

          var eyeBrowTag = (0, _get2.default)(eyeBrowText, 'name');
          if (eyeBrowTag !== '') {
            customDimensions.push({ Tag: eyeBrowTag });
          } else {
            customDimensions.push({ Tag: 'Fast Company' });
          }
        },
        category: function category() {
          _category = (0, _get2.default)(categoryPageData, 'slug');
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { Category: _category }, { 'Content Type': type }];
        },
        tag: function tag() {
          _tag = (0, _get2.default)(tagPageData, 'name');
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { Tag: _tag }, { 'Content Type': 'section page' }];
        },
        author: function author() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': type }];
        },
        search: function search() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': type }];
        },
        page: function page() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': type }];
        },
        personPage: function personPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'person' }];
        },
        personIndexSectionPage: function personIndexSectionPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'person index' }];
        },
        mostCreativePeoplePage: function mostCreativePeoplePage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'most creative people' }];
        },
        mostCreativePeopleCommunityPage: function mostCreativePeopleCommunityPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'most creative people community' }];
        },
        micSectorPage: function micSectorPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'most innovative companies sector' }];
        },
        companyIndexSectionPage: function companyIndexSectionPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'company sector index' }];
        },
        ibdPage: function ibdPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'innovation by design' }];
        },
        companyPage: function companyPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'company' }];
        },
        productPage: function productPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'product' }];
        },
        micYearPage: function micYearPage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'most innovative companies year' }];
        },
        magazineArchivePage: function magazineArchivePage() {
          customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'magazine archives' }];
        }
      };

      if (typeLookup[type]) {
        typeLookup[type]();
      }

      // eslint-disable-next-line
      console.log(JSON.stringify(customDimensions));
      (0, _forEach2.default)(customDimensions, function (dimension) {
        if (!dimension) {
          return;
        }
        var key = Object.keys(dimension)[0];
        var dimensionKey = dimension[key];
        ga('set', '' + key, '' + dimensionKey);
      }).join('');
    }

    ga('send', 'pageview');
    ga('rollup.send', 'pageview');
  }
}

function trackGAEvent(eventParams) {
  if (_exenv.canUseDOM) {
    if (window && window.ga) {
      var eventCategory = eventParams.eventCategory,
          eventAction = eventParams.eventAction,
          _eventParams$eventLab = eventParams.eventLabel,
          eventLabel = _eventParams$eventLab === undefined ? null : _eventParams$eventLab;

      if (eventCategory && eventAction) {
        window.ga('send', 'event', eventCategory, eventAction, eventLabel);
        window.ga('rollup.send', 'event', eventCategory, eventAction, eventLabel);
      }
    }
  }
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Social;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStickynode = __webpack_require__(77);

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _social_models = __webpack_require__(466);

var _social_models2 = _interopRequireDefault(_social_models);

var _share_util = __webpack_require__(213);

var _parsely = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleClick(event, url, popup, socialShare) {
  if (socialShare.action !== 'email') {
    event.preventDefault();
  }

  if (popup) {
    (0, _share_util.popupCenter)(event, url, 560, 725);
  }

  if (socialShare) {
    (0, _share_util.trackSocial)(socialShare.platform, socialShare.action);
    (0, _parsely.trainParselyProfile)();
  }
}

function renderSocialList(empty, properties) {
  return _react2.default.createElement(
    'ul',
    { className: 'social__list ' + (empty ? 'social__list--post-empty' : '') },
    properties.map(function (sharer) {
      var property = sharer.property,
          url = sharer.url,
          _sharer$icon = sharer.icon,
          icon = _sharer$icon === undefined ? '' : _sharer$icon,
          popup = sharer.popup,
          socialShare = sharer.socialShare;


      return _react2.default.createElement(
        'li',
        {
          key: property,
          className: 'social__item ' + (empty ? 'social__item--empty' : '')
        },
        _react2.default.createElement(
          'a',
          {
            className: 'social__link social__link--' + property,
            href: url,
            onClick: function onClick(e) {
              return handleClick(e, url, popup, socialShare);
            },
            rel: 'noopener noreferrer'
          },
          _react2.default.createElement('i', { className: 'icon-' + (icon || property) })
        )
      );
    })
  );
}

function Social(props) {
  if (!props) {
    return null;
  }

  var encodedPostUrl = props.uri;
  var encodedTitle = props.text || props.socialText;
  var properties = (0, _social_models2.default)(encodedPostUrl, encodedTitle);
  var classes = ['social', 'social--' + props.modifier];

  return _react2.default.createElement(
    'div',
    { className: classes.join(' '), id: props.encapsulateId },
    _react2.default.createElement(
      _reactStickynode2.default,
      {
        top: props.topValue,
        bottomBoundary: props.bottomBoundary,
        enabled: props.enableSticky
      },
      renderSocialList(props.empty, properties)
    )
  );
}

Social.defaultProps = {
  uri: 'https://www.fastcompany.com',
  text: 'Fast Company is the world&#x27;s leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.',
  modifier: 'default',
  topValue: 56,
  bottomBoundary: 0,
  encapsulateId: '',
  empty: false,
  enableSticky: false
};

Social.propTypes = {
  empty: _propTypes2.default.bool,
  enableSticky: _propTypes2.default.bool,
  modifier: _propTypes2.default.string,
  uri: _propTypes2.default.string,
  text: _propTypes2.default.string,
  // eslint-disable-next-line react/require-default-props
  socialText: _propTypes2.default.shape({
    twitter: _propTypes2.default.string,
    linkedin: _propTypes2.default.string,
    email: _propTypes2.default.string
  }),
  bottomBoundary: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  encapsulateId: _propTypes2.default.string,
  topValue: _propTypes2.default.number
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(467);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactStickynode = __webpack_require__(77);

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 import { canUseDOM } from 'exenv';
 if(canUseDOM) {
 debugger;
 }
 */

var WP = function (_Component) {
  _inherits(WP, _Component);

  function WP() {
    _classCallCheck(this, WP);

    return _possibleConstructorReturn(this, (WP.__proto__ || Object.getPrototypeOf(WP)).apply(this, arguments));
  }

  _createClass(WP, [{
    key: 'componentDidMount',

    // eslint-disable-line react/prefer-stateless-function

    value: function componentDidMount() {
      this.isDesktop = (0, _client_util2.default)();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          wpPage = _props.wpPage,
          customPage = _props.customPage;


      if (wpPage.error && customPage.error) {
        return _react2.default.createElement(
          'section',
          { className: 'wp-page' },
          _react2.default.createElement(
            'article',
            { className: 'wp-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (wpPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(wpPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });
      var content = (0, _get2.default)(customPage, 'content.rendered');
      var singleColLayout = ['about', 'most-innovative-companies', 'world-changing-ideas'];

      // This conditional is for non-standard custom WP Page layouts like franchise awards pages
      var slug = (0, _get2.default)(customPage, 'slug');
      var lookup = {
        about: {
          modifier: 'ibd',
          img: 'https://images.fastcompany.net/image/upload/w_700,h_400,c_crop,q_auto:best,f_auto,fl_lossy/v1500314681/fcweb/3056495-poster-ibd-logo-poster-thin_qmvllz.jpg',
          link: ''
        },
        'most-innovative-companies': {
          modifier: 'mic',
          img: 'https://images.fastcompany.net/image/upload/w_700,h_400,c_crop,q_auto:best,f_auto,fl_lossy/v1497392323/fcweb/mic-logo-poster.jpg',
          link: 'https://fastcompany.swoogo.com/mic',
          alt: '2018 Most Innovative Companies'
        },
        'world-changing-ideas': {
          modifier: 'wci',
          img: 'https://images.fastcompany.net/image/upload/v1506454149/fcweb/wci-logo-poster_ygncww_rrcgpd.jpg',
          link: null,
          alt: 'World Changing Ideas'
        }
      };

      var header = lookup[slug] || null;

      if (singleColLayout.indexOf((0, _get2.default)(customPage, 'slug')) > -1) {
        return _react2.default.createElement(
          'section',
          { className: 'awards-page' },
          header ? _react2.default.createElement(
            'header',
            {
              className: 'awards-page__header awards-page__header--' + header.modifier
            },
            _react2.default.createElement(
              'a',
              { href: header.link, title: header.alt },
              _react2.default.createElement('img', { src: header.img, alt: header.alt })
            )
          ) : '',
          _react2.default.createElement(
            'section',
            { className: 'awards-page__content' },
            _react2.default.createElement(
              'div',
              { className: 'awards-page__main' },
              _react2.default.createElement('article', { dangerouslySetInnerHTML: { __html: content } })
            )
          )
        );
      }

      return _react2.default.createElement(
        'section',
        { className: 'custom-page' },
        _react2.default.createElement(
          'div',
          { className: 'post_wrapper' },
          _react2.default.createElement(
            'section',
            { className: 'custom-content' },
            _react2.default.createElement(
              'div',
              { className: 'post' },
              _react2.default.createElement(
                'div',
                { className: 'post__main' },
                _react2.default.createElement(
                  'h1',
                  { className: 'post__title' },
                  (0, _get2.default)(customPage, 'title.rendered')
                ),
                _react2.default.createElement('article', {
                  className: 'post__article',
                  dangerouslySetInnerHTML: { __html: content }
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'post__sidebar', id: 'custom-page-ad' },
                content && content.length ? _react2.default.createElement(
                  _reactStickynode2.default,
                  {
                    top: 100,
                    bottomBoundary: '#custom-page-ad',
                    enabled: this.isDesktop
                  },
                  _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
                    noLazyLoad: true,
                    pos: 'atf',
                    name: 'flexiblehalfpage'
                  }))
                ) : ''
              )
            )
          )
        ),
        _react2.default.createElement(
          'section',
          { className: 'recirc-feed' },
          !(0, _isEmpty2.default)(customPage) ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_1' }))
          ) : ''
        )
      );
    }
  }]);

  return WP;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    wpPage: state.wpPage || {
      ads: {
        baseConfig: {}
      }
    },
    customPage: (0, _get2.default)(state, 'customPage.data.page[0]') || { error: true }
  };
}

WP.propTypes = {
  wpPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  customPage: _propTypes2.default.shape({
    error: _propTypes2.default.bool
  }).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WP);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wpData;

var _exenv = __webpack_require__(4);

var _async_wp_page_actions = __webpack_require__(647);

var _async_wp_page_actions2 = _interopRequireDefault(_async_wp_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wpData(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_wp_page_actions2.default)(nextState, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_wp_page_actions2.default)(nextState, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleServerSideRenderError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(293);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      return !fn(el)
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(84);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(3);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-router/es/index.js
var es = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/react-router-redux/es/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}
// CONCATENATED MODULE: ./node_modules/react-router-redux/es/ConnectedRouter.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter_ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: LOCATION_CHANGE,
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history;

    this.store = propsStore || this.context.store;

    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
    this.handleLocationChange(history.location);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return react_default.a.createElement(es["Router"], this.props);
  };

  return ConnectedRouter;
}(react["Component"]);

ConnectedRouter_ConnectedRouter.propTypes = {
  store: prop_types_default.a.object,
  history: prop_types_default.a.object,
  children: prop_types_default.a.node
};
ConnectedRouter_ConnectedRouter.contextTypes = {
  store: prop_types_default.a.object
};


/* harmony default export */ var es_ConnectedRouter = (ConnectedRouter_ConnectedRouter);
// CONCATENATED MODULE: ./node_modules/react-router-redux/es/actions.js

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };
// CONCATENATED MODULE: ./node_modules/react-router-redux/es/middleware.js


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}
// CONCATENATED MODULE: ./node_modules/react-router-redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ConnectedRouter", function() { return es_ConnectedRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LOCATION_CHANGE", function() { return LOCATION_CHANGE; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "routerReducer", function() { return routerReducer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CALL_HISTORY_METHOD", function() { return CALL_HISTORY_METHOD; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "push", function() { return push; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "replace", function() { return replace; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "go", function() { return go; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "goBack", function() { return goBack; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "goForward", function() { return goForward; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "routerActions", function() { return routerActions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "routerMiddleware", function() { return routerMiddleware; });








/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Poster;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _image = __webpack_require__(76);

var _image2 = _interopRequireDefault(_image);

var _gif_converter = __webpack_require__(204);

var _gif_converter2 = _interopRequireDefault(_gif_converter);

var _create_class_list_util = __webpack_require__(133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Poster(props) {
  var metadata = props.metadata,
      className = props.className,
      generateClasses = props.generateClasses;

  var image = (0, _get2.default)(metadata, 'featured_image.source');

  if (metadata.allowNoImage && !image || metadata.layout === 'short' && metadata.hasVideoPoster === false) {
    return null;
  }

  var assignedImage = image || 'https://images.fastcompany.net/image/upload/v1485990651/fcweb/fastcompanyimagedefault.jpg';
  var posterClasses = className;
  if (generateClasses) {
    posterClasses = (0, _create_class_list_util.createPosterClasses)(metadata.tags, metadata.events, className, metadata.hasVideoPoster, metadata.isPlayerVideo);
  }
  var isGif = /.gif$/.test(assignedImage);
  var markup = _react2.default.createElement(_image2.default, {
    alt: metadata.title,
    src: assignedImage,
    noLazy: metadata.noLazy,
    assetSizes: metadata.assetSizes
  });

  if (isGif) {
    markup = _react2.default.createElement(_gif_converter2.default, {
      alt: metadata.title,
      src: assignedImage,
      noLazy: metadata.noLazy,
      assetSizes: metadata.assetSizes
    });
  }

  return _react2.default.createElement(
    'figure',
    { className: posterClasses },
    markup
  );
}

// NOTE: generateClasses will be removed once we kill createPosterClasses
Poster.defaultProps = {
  className: '',
  generateClasses: true
};

Poster.propTypes = {
  metadata: _propTypes2.default.shape({}).isRequired,
  className: _propTypes2.default.string,
  generateClasses: _propTypes2.default.bool
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Eyebrow;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(32);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _advertorial = __webpack_require__(28);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function showLive(live) {
  if (live) {
    return _react2.default.createElement(
      'li',
      { className: 'eyebrow__item eyebrow__item--live' },
      _react2.default.createElement(
        'span',
        { className: 'eyebrow__live' },
        'Live'
      )
    );
  }

  return null;
}

function renderTag(tags) {
  var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);
  var slug = eyeBrowText.slug;
  var name = eyeBrowText.name;


  if (!slug || !name) {
    return null;
  }

  name = name.replace(/\*/g, '').replace(/_/g, ' ').replace(/\s?advertorial/g, '');

  var to = '/section/' + slug;

  if (to === '/section/most-creative-people') {
    to = '/most-creative-people';
  }

  return _react2.default.createElement(
    'li',
    { className: 'eyebrow__item' },
    (0, _advertorial.isAdvertorial)(tags) ? name : _react2.default.createElement(
      _reactRouterDom.Link,
      { to: to },
      name
    )
  );
}

function shouldShowTime(post) {
  var showTime = (0, _get2.default)(post, 'showTime');
  if (!showTime) return null;
  return _react2.default.createElement(
    'li',
    { className: 'eyebrow__item' },
    (0, _get2.default)(post, 'timePublished'),
    ' '
  );
}

function Eyebrow(props) {
  if (!props) {
    return null;
  }

  var metadata = props.metadata,
      post = props.post,
      tags = props.tags,
      modifier = props.modifier,
      live = props.live;


  if (!(0, _isEmpty2.default)(metadata)) {
    var cardTags = metadata.tags || [];
    var category = (0, _get2.default)(metadata, 'categories[0].name');
    var eyebrow = metadata.site || category || null;

    if (!eyebrow && metadata.dateFormatted && metadata.timePublished) {
      eyebrow = metadata.dateFormatted + ' | ' + metadata.timePublished;
    }

    if ((0, _advertorial.isAdvertorial)(cardTags)) {
      eyebrow = 'Sponsored Content';
    }

    // When it's a News story, it has category Uncategorized
    // we don't want to show that to the user, use date instead
    if (eyebrow === 'Uncategorized') {
      eyebrow = metadata.timePublished;
    }

    if (metadata.customEyebrowText) {
      eyebrow = metadata.customEyebrowText;
    }

    return eyebrow && _react2.default.createElement(
      'span',
      { className: 'eyebrow eyebrow--' + modifier },
      eyebrow
    );
  }

  if (!(0, _isEmpty2.default)(post)) {
    return _react2.default.createElement(
      'ul',
      { className: 'eyebrow' },
      showLive(live),
      _react2.default.createElement(
        'li',
        { className: 'eyebrow__item' },
        _react2.default.createElement(
          'time',
          { dateTime: (0, _get2.default)(post, 'structuredData.published') },
          (0, _get2.default)(post, 'dateFormatted')
        )
      ),
      shouldShowTime(post),
      renderTag(tags)
    );
  }

  return null;
}

Eyebrow.defaultProps = {
  post: {},
  metadata: {},
  modifier: '',
  live: false
};

Eyebrow.propTypes = {
  post: _propTypes2.default.shape({}),
  // eslint-disable-next-line react/require-default-props
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  metadata: _propTypes2.default.shape({}),
  modifier: _propTypes2.default.string,
  live: _propTypes2.default.bool
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(211),
    isObject = __webpack_require__(38);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _reactSlick = __webpack_require__(104);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _video_module_ads = __webpack_require__(140);

var _video_module_ads2 = _interopRequireDefault(_video_module_ads);

var _video_module_autoplay = __webpack_require__(504);

var _video_module_autoplay2 = _interopRequireDefault(_video_module_autoplay);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;
if (_exenv.canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = __webpack_require__(58);
}

var Video = function (_Component) {
  _inherits(Video, _Component);

  function Video() {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this));

    _this.state = {
      playingIndex: 0,
      activeTitle: ''
    };

    // lookup for PERCENT INVIEW THRESHOLD for AUTOPLAY
    _this.siteToPercentView = {
      fastcompany: 10,
      fastcodesign: 10
    };

    _this.autoplay = null;
    _this.videoCardClick = _this.videoCardClick.bind(_this);
    _this.updateTitle = _this.updateTitle.bind(_this);
    _this.setCaptions = _this.setCaptions.bind(_this);
    _this.setNextVideo = _this.setNextVideo.bind(_this);
    _this.setMoatTracking = _this.setMoatTracking.bind(_this);
    return _this;
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        settings: {
          arrows: false,
          infinite: false,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 2,
              slide: '.video-slide'
            }
          }, {
            breakpoint: 100000,
            settings: 'unslick'
          }]
        }
      });

      if (scriptjs) {
        var data = this.props.data;
        var playerid = this.props.playerid;

        // When we're testing, use a dev specific video player so we can override adzone

        if (window && window.location.href.indexOf('adzone=qa') !== -1) {
          playerid = 'wip8TrhU';
        }

        scriptjs(['//content.jwplatform.com/libraries/' + playerid + '.js', 'https://z.moatads.com/jwplayerplugin0938452/moatplugin.js'], function () {
          _this2.player = window.jwplayer('video-module__player');
          _this2.adTagGenerator = new _video_module_ads2.default((0, _get2.default)(data, 'title'), _this2.props.type);
          _this2.initPlayer();
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var updateSettings = !this.state.settings;
      var updatePlayingIndex = this.state.playingIndex !== nextState.playingIndex;
      var updateActiveTitle = this.state.activeTitle !== nextState.activeTitle;

      return updateSettings || updatePlayingIndex || updateActiveTitle;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if ((0, _get2.default)(this, 'player.remove')) this.player.remove();
      if (this.autoplay !== null) this.autoplay.off();

      if (_exenv.canUseDOM) {
        if (window.moatjw) {
          window.moatjw.removeAll();
        }
      }
    }
  }, {
    key: 'getVideoImage',
    value: function getVideoImage(image) {
      if (!image) return '';
      var fastlyCloudinaryFetchEnabled = (0, _get2.default)(this.props, 'config.featureFlags.fastlyCloudinaryFetchEnabled');

      if (fastlyCloudinaryFetchEnabled) {
        return 'https://images.fastcompany.net/image/fetch/w_280,ar_16:9,c_fill,g_auto,q_auto,f_auto,fl_lossy/' + image;
      }

      return '//fast-company-res.cloudinary.com/image/fetch/w_280,ar_16:9,c_fill,g_auto,q_auto,f_auto,fl_lossy/' + image;
    }
  }, {
    key: 'getVideoList',
    value: function getVideoList() {
      var _this3 = this;

      var stories = this.props.stories;


      return stories.map(function (video, index) {
        return {
          id: video.mediaid,
          title: video.title,
          link: video.link,
          featured_image: {
            source: _this3.getVideoImage((0, _get2.default)(video, 'image'))
          },
          isPlayerVideo: true,
          isVideoActive: _this3.state.playingIndex === index,
          index: index
        };
      });
    }
  }, {
    key: 'setCaptions',
    value: function setCaptions() {
      var caption = this.player.getMute() ? 1 : 0;
      return this.player.setCurrentCaptions(caption);
    }
  }, {
    key: 'setNextVideo',
    value: function setNextVideo() {
      var playingIndex = this.state.playingIndex + 1;
      this.setState({ playingIndex: playingIndex });
    }
  }, {
    key: 'setMoatTracking',
    value: function setMoatTracking(event) {
      if (window.moatjw) {
        window.moatjw.add({
          partnerCode: 'mansuetojwint127635890115',
          player: this.player,
          adImpressionEvent: event
        });
      }
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle() {
      var video = this.player.getPlaylistItem();
      this.setState({ activeTitle: video.title });
    }
  }, {
    key: 'initPlayer',
    value: function initPlayer() {
      var _this4 = this;

      // we will want to pass in playerid to ad tag
      var _props = this.props,
          data = _props.data,
          config = _props.config;


      var options = {
        playlist: '//content.jwplatform.com/feeds/' + data.feedid + '.json',
        autostart: 'viewable',
        sharing: {
          link: 'https://www.' + config.site + '.com/video/share/MEDIAID'
        }
      };

      // example where homepage is setup https://dashboard.jwplayer.com/#/players/basic_setup?property=c08f27a0-75f3-11e6-8d4f-0a55b80e2f57&player_key=76APbejE
      options.advertising = {
        client: 'googima',
        tag: this.adTagGenerator.adTag,
        vpaidcontrols: true
      };

      this.player.setup(options);

      this.player.on('ready', function () {
        _this4.player.setMute(true);
        _this4.autoplay = new _video_module_autoplay2.default({
          player: _this4.player,
          percentInView: _this4.props.isPost ? _this4.siteToPercentView[(0, _get2.default)(config, 'site', '')] : 10
        });
        _this4.autoplay.on();
        _this4.player.on('playlistItem', _this4.updateTitle);
        _this4.player.on('play', _this4.setCaptions);
        _this4.player.on('mute', _this4.setCaptions);
        _this4.player.on('complete', _this4.setNextVideo);
        _this4.player.on('adImpression', _this4.setMoatTracking);
      });
    }
  }, {
    key: 'videoCardClick',
    value: function videoCardClick(event, index) {
      this.setState({ playingIndex: index });
      this.player.playlistItem(index);
    }
  }, {
    key: 'renderSlides',
    value: function renderSlides() {
      var _this5 = this;

      var settings = this.state.settings;
      var config = this.props.config;

      if (settings) {
        var stories = this.getVideoList();
        return _react2.default.createElement(
          'div',
          { className: 'video-module-playlist' },
          _react2.default.createElement(
            _reactSlick2.default,
            settings,
            stories.map(function (item) {
              return _react2.default.createElement(
                'div',
                { className: 'video-slide video-slide--vertical', key: item.id },
                _react2.default.createElement(_card2.default, {
                  type: 'video',
                  config: config,
                  metadata: item,
                  cardEvent: _this5.videoCardClick,
                  hasLink: false
                })
              );
            })
          )
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          slugName = _props2.slugName,
          isPost = _props2.isPost;


      return _react2.default.createElement(
        'section',
        { className: 'video-row ' + (isPost ? 'video-row--post' : '') },
        _react2.default.createElement(_slug2.default, { linkTo: '//fastcompany.com/videos', slugName: slugName }),
        _react2.default.createElement(
          'div',
          { className: 'video-module' },
          _react2.default.createElement(
            'div',
            { className: 'video-module__player-container' },
            _react2.default.createElement('div', { id: 'video-module__player' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'video-module__title' },
            this.state.activeTitle
          )
        ),
        this.renderSlides()
      );
    }
  }]);

  return Video;
}(_react.Component);

exports.default = Video;


Video.defaultProps = {
  stories: [],
  data: {},
  slugName: 'Video',
  isPost: false
};

Video.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  stories: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  data: _propTypes2.default.shape({}),
  playerid: _propTypes2.default.string.isRequired,
  slugName: _propTypes2.default.string,
  isPost: _propTypes2.default.bool,
  type: _propTypes2.default.string.isRequired
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _async_category_page_actions = __webpack_require__(543);

var _async_category_page_actions2 = _interopRequireDefault(_async_category_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store, override, isTag) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;


    if (override) {
      (0, _set2.default)(nextState, 'params.category', override);
    }

    // run async
    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_category_page_actions2.default)(nextState.params, store, isTag)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_category_page_actions2.default)(nextState.params, store, isTag)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(29),
    isKey = __webpack_require__(112),
    stringToPath = __webpack_require__(309),
    toString = __webpack_require__(115);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(122);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  // Ad ops uses this to measure users w/o js
  adOpsIframe: false,
  // Currently only enabled on author pages
  infiniteScrollAllFeed: true,
  // Video Permalinks Pages /video/slug/id
  videoPagesEnabled: true,
  // Ad on top of nav, marketing team test
  topNavAdEnabled: false,
  // Omniture replacement, adops test
  gaCustomVarEnabled: false,
  // newletter preferences page
  newsletterPreferencesPageEnabled: true,
  // Revcontent raw js widget
  revContentJSWidgetEnabled: true,
  // amp
  ampEnabled: false,
  // fbia
  fbiaEnabled: false,
  // personalized recommendations widget on post pages
  postPersonalizedRecommendationsEnabled: true,
  // Lift igniter
  liftIgniterEnabled: false,
  fastlyCloudinaryFetchEnabled: true,
  ampIngestionEnabled: true
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _cloudinary_asset_util = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          alt = _props.alt,
          src = _props.src,
          assetSizes = _props.assetSizes,
          noLazy = _props.noLazy,
          baseClass = _props.baseClass,
          modifier = _props.modifier;

      var secureSrc = (0, _cloudinary_asset_util.makeHttps)(src);
      var fcDomainAsset = (0, _cloudinary_asset_util.changeAssetDomain)(secureSrc);
      var sourceAttribs = {
        media: '(max-width: 40em)',
        'data-sizes': (0, _get2.default)(assetSizes, 'small.sizes'),
        'data-srcset': (0, _cloudinary_asset_util.buildSrcSet)(assetSizes, 'small.srcset', fcDomainAsset)
      };
      var imgAttribs = {
        'data-sizes': (0, _get2.default)(assetSizes, 'large.sizes'),
        'data-srcset': (0, _cloudinary_asset_util.buildSrcSet)(assetSizes, 'large.srcset', fcDomainAsset),
        className: (noLazy ? '' : 'lazyload') + ' ' + baseClass + ' ' + baseClass + '--' + modifier
      };

      function removeData(str) {
        return str.replace('data-', '');
      }

      function removeDataAttrs(obj) {
        var correctedParams = (0, _assign2.default)({}, obj);
        // eslint-disable-next-line no-restricted-syntax
        for (var attr in correctedParams) {
          if (/^data-/.test(attr)) {
            correctedParams[removeData(attr)] = correctedParams[attr];
            delete correctedParams[attr];
          }
        }

        return correctedParams;
      }

      if (noLazy) {
        imgAttribs = removeDataAttrs(imgAttribs);
        sourceAttribs = removeDataAttrs(sourceAttribs);
      }

      if (src && !(0, _isEmpty2.default)(assetSizes)) {
        return _react2.default.createElement(
          'picture',
          null,
          _react2.default.createElement('source', {
            media: sourceAttribs.media,
            sizes: sourceAttribs.sizes,
            srcSet: sourceAttribs.srcset
          }),
          noLazy ? _react2.default.createElement('img', {
            media: imgAttribs.media,
            sizes: imgAttribs.sizes,
            srcSet: imgAttribs.srcset,
            alt: alt
          }) : _react2.default.createElement('img', _extends({}, imgAttribs, { alt: alt }))
        );
      }

      return _react2.default.createElement(
        'picture',
        null,
        _react2.default.createElement('img', {
          alt: alt,
          'data-src': src,
          className: '' + (noLazy ? '' : 'lazyload')
        })
      );
    }
  }]);

  return Image;
}(_react.Component);

exports.default = Image;


Image.defaultProps = {
  noLazy: false,
  assetSizes: {},
  baseClass: '',
  modifier: ''
};

Image.propTypes = {
  alt: _propTypes2.default.string.isRequired,
  baseClass: _propTypes2.default.string,
  modifier: _propTypes2.default.string,
  src: _propTypes2.default.string.isRequired,
  noLazy: _propTypes2.default.bool,
  assetSizes: _propTypes2.default.shape({
    large: _propTypes2.default.shape({
      sizes: _propTypes2.default.string,
      srcset: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    small: _propTypes2.default.shape({
      sizes: _propTypes2.default.string,
      srcset: _propTypes2.default.arrayOf(_propTypes2.default.string)
    })
  })
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(455);


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(566),
    baseMatchesProperty = __webpack_require__(573),
    identity = __webpack_require__(94),
    isArray = __webpack_require__(29),
    property = __webpack_require__(577);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollToEl;

var _exenv = __webpack_require__(4);

function scrollLoop(element, duration, navHeight) {
  if (duration <= 0) return;

  var difference = element.offsetTop - document.body.scrollTop - navHeight;
  var perTick = difference / duration * 10;

  setTimeout(function () {
    // eslint-disable-next-line no-param-reassign
    document.body.scrollTop += perTick;
    return scrollLoop(element, duration - 10, navHeight);
  }, 10);
}

function scrollToEl(querySelector, duration) {
  if (_exenv.canUseDOM && querySelector && duration && duration > 0) {
    var el = document.querySelector(querySelector + ':not(.scrolled)');
    var navHeight = window.innerWidth > 640 ? 90 : 0;
    if (el) {
      scrollLoop(el, duration, navHeight);
      el.classList.add('scrolled');
    }
  }
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _async_tag_page_actions = __webpack_require__(667);

var _async_tag_page_actions2 = _interopRequireDefault(_async_tag_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store, override) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;


    if (override) {
      if (override !== 'magazine') {
        (0, _set2.default)(nextState, 'params.tag', override); // eslint-disable-next-line no-param-reassign
      } else {
        (0, _set2.default)(nextState, 'params.magazine', true);
      }
    }
    // run async
    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_tag_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_tag_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchTag;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _tag_all_feed_action_creators = __webpack_require__(46);

var tagAllFeedActions = _interopRequireWildcard(_tag_all_feed_action_creators);

var _tag_all_feed = __webpack_require__(672);

var _tag_all_feed2 = _interopRequireDefault(_tag_all_feed);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchTag(params, store, shouldNot404) {
  return function firstDispatch(dispatch) {
    dispatch(tagAllFeedActions.tagAllFeedLoading({}, store));
    return _tag_all_feed2.default.fetch(params, store).then(function handleTagDetailData(TagData) {
      if (params.page && !(0, _get2.default)(TagData, 'data.posts.length')) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }
      dispatch(tagAllFeedActions.tagAllFeedLoaded(TagData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (!shouldNot404) {
        if (status === 404) {
          dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
        }
      }
      dispatch(tagAllFeedActions.tagAllFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in tag all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _throttle = __webpack_require__(64);

var _throttle2 = _interopRequireDefault(_throttle);

var _jsCookie = __webpack_require__(809);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _container = __webpack_require__(146);

var _container2 = _interopRequireDefault(_container);

var _moreStoriesComponent = __webpack_require__(226);

var _moreStoriesComponent2 = _interopRequireDefault(_moreStoriesComponent);

var _video_module = __webpack_require__(66);

var _video_module2 = _interopRequireDefault(_video_module);

var _revcontent = __webpack_require__(251);

var _revcontent2 = _interopRequireDefault(_revcontent);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _trackThirdPartyJS = __webpack_require__(147);

var _trackThirdPartyJS2 = _interopRequireDefault(_trackThirdPartyJS);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _postpage_action_creators = __webpack_require__(272);

var _async_post_finite_actions = __webpack_require__(810);

var _async_post_finite_actions2 = _interopRequireDefault(_async_post_finite_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;

if (_exenv.canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = __webpack_require__(58);
}

var PostPage = function (_Component) {
  _inherits(PostPage, _Component);

  function PostPage(props) {
    _classCallCheck(this, PostPage);

    var _this = _possibleConstructorReturn(this, (PostPage.__proto__ || Object.getPrototypeOf(PostPage)).call(this, props));

    var live = props.post.live;


    _this.finiteScrollDepth = null;
    _this.setScrollEvents = (0, _throttle2.default)(function () {
      var _this$window = _this.window,
          scrollY = _this$window.scrollY,
          innerHeight = _this$window.innerHeight;

      _this.setFiniteScrollDepth(scrollY, innerHeight);
      _this.setInviewPostUrl(scrollY, innerHeight);
    }, 100);
    _this.generateAdData = _this.generateAdData.bind(_this);
    _this.state = {
      finitePosts: []
    };
    _this.playerScriptIds = ['QV73eWiB', '4h5SWQPt', 'Pafg29um', '27mBLzWL', 'i70nsZ8K', 'Lrp0YsKC', 'wGNMZweZ', 'kMmGs8qw', 'WXJihrBk', 'iqio3VCM', 'OolwHeKf', 'FsIzKJce', 'r04h3Jdn', 'RvGXj7in', 'flarUGPa', 'HzdTLaau', 'gAy6i1bi', 'RqEFED7X', 'vp2iCnvh', 'b2BPV4nc'];
    _this.live = (0, _get2.default)(live, 'enabled', false) && !!(0, _get2.default)(live, 'posts.length', 0);
    return _this;
  }

  _createClass(PostPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          statusCode = _props.statusCode,
          config = _props.config,
          post = _props.post;


      this.window = window;
      this.body = document.body;
      this.activePost = (0, _get2.default)(post, 'id') || (0, _get2.default)(this.props, 'match.params.id');
      this.lazyThresholdFromBottom = 400;
      this.stickySidebar = (0, _client_util2.default)();
      this.trackedPosts = [];

      this.setActiveSocial();
      this.refreshSocialEmbeds();

      if (!this.live) {
        this.window.addEventListener('scroll', this.setScrollEvents);
      }

      if (statusCode !== 404 && statusCode !== 403 && statusCode !== 500) {
        var postId = (0, _get2.default)(this.props, 'match.params.id');
        this.props.dispatchPostFinite(postId, config);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var live = (0, _get2.default)(this.props, 'post.live');
      this.live = (0, _get2.default)(live, 'enabled', false) && !!(0, _get2.default)(live, 'posts.length', 0);
      this.refreshSocialEmbeds();

      this.posts = this.getPostElements();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.live) {
        this.window.removeEventListener('scroll', this.setScrollEvents);
      }
    }
  }, {
    key: 'getPostElements',
    value: function getPostElements() {
      return document.querySelectorAll('.post__body');
    }
  }, {
    key: 'setActiveSocial',
    value: function setActiveSocial(post) {
      var activeClass = 'social--active';
      var activeSocial = document.querySelector('.' + activeClass);

      if (activeSocial) {
        activeSocial.classList.remove(activeClass);
      }

      var activePost = post || document.querySelector('.post__wrapper');
      if (activePost) {
        activePost.querySelector('.social').classList.add(activeClass);
      }
    }
  }, {
    key: 'setFiniteScrollDepth',
    value: function setFiniteScrollDepth(windowPosition, screenHeight) {
      var postFinite = this.props.postFinite;

      var RECIRC_OFFSET = 300;
      var bottomOfScreen = windowPosition + screenHeight;
      var recircPosition = document.querySelector('.recirc').offsetTop;
      var triggerPoint = recircPosition - RECIRC_OFFSET;

      if (triggerPoint < bottomOfScreen && postFinite.length) {
        this.setState({
          finitePosts: [].concat(_toConsumableArray(this.state.finitePosts), [postFinite.shift()])
        });
      }
    }
  }, {
    key: 'setInviewPostUrl',
    value: function setInviewPostUrl(windowPosition, screenHeight) {
      if (!this.posts || !this.posts.length) {
        return false;
      }
      var triggerPoint = windowPosition + screenHeight / 2;
      for (var i = 1; i <= this.posts.length; i += 1) {
        var post = this.posts[i - 1];
        var sectionTopPosition = post.offsetTop;
        var sectionBottomPosition = sectionTopPosition + post.clientHeight;
        var postId = parseFloat(post.dataset.id);

        if (this.activePost !== postId && sectionTopPosition <= triggerPoint && sectionBottomPosition > triggerPoint) {
          this.activePost = postId;
          // const postData = post.dataset;
          var postData = i === 1 ? this.props.post : this.state.finitePosts[i - 2];

          // React router redux does not support replace state without page refresh.
          this.props.dispatchInfiniteScrollUrlChange();

          var replacedURL = '/' + postData.id + '/' + postData.slug;

          if ((0, _get2.default)(postData, 'isVideoPermalink')) {
            replacedURL = '/video/' + postData.slug + '/' + (0, _get2.default)(postData, 'posterVideo.feedId');
          }

          window.history.replaceState({}, '', replacedURL);

          // Only track this again on first post onwards
          if (i > 1 && this.trackedPosts.indexOf(this.activePost) === -1) {
            this.trackedPosts.push(this.activePost);
            this.refreshThirdPartyTrackers(postData, i);
          }

          this.setActiveSocial(post);
        }
      }
      return false;
    }
  }, {
    key: 'refreshSocialEmbeds',
    value: function refreshSocialEmbeds() {
      if (_exenv.canUseDOM) {
        if (!window.instgrm) {
          scriptjs('//platform.instagram.com/en_US/embeds.js', function () {
            window.instgrm.Embeds.process();
          });
        } else {
          window.instgrm.Embeds.process();
        }

        if (!window.twttr) {
          scriptjs('//platform.twitter.com/widgets.js', function () {
            window.twttr.widgets.load();
          });
        } else {
          window.twttr.widgets.load();
        }
      }
    }
  }, {
    key: 'refreshThirdPartyTrackers',
    value: function refreshThirdPartyTrackers(postData, pageNumber) {
      var config = this.props.config;

      var currentActivePostState = {
        context: {
          site: (0, _get2.default)(config, 'site'),
          type: 'post',
          postData: postData
        },
        config: config
      };
      (0, _trackThirdPartyJS2.default)(currentActivePostState, pageNumber);
    }
  }, {
    key: 'generateAdData',
    value: function generateAdData(postData) {
      var config = this.props.config;

      var site = (0, _get2.default)(config, 'site') || 'fastcompany';
      var adData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, postData, 'postPage');

      return (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') || {} }, { definitions: (0, _get2.default)(adData, 'config.definitions') || {} }, { model: adData.model || {} });
    }
  }, {
    key: 'renderRevContentOrMoreStories',
    value: function renderRevContentOrMoreStories() {
      var _props2 = this.props,
          config = _props2.config,
          postAfterbodyRecircModuleType = _props2.postAfterbodyRecircModuleType;

      var initialPageLoad = (0, _get2.default)(config, 'initialPageLoad');
      var moduleType = (0, _get2.default)(postAfterbodyRecircModuleType, 'type');

      if (config.featureFlags.revContentJSWidgetEnabled) {
        if (!initialPageLoad && _exenv.canUseDOM) {
          if (_jsCookie2.default.get('fc_rev_content')) {
            return _react2.default.createElement(_revcontent2.default, {
              initialPageLoad: initialPageLoad,
              site: (0, _get2.default)(config, 'site')
            });
          }
        }
      }

      // Hard return more stories for test
      if (moduleType === 'More Stories') {
        return this.renderMoreStories();
      }

      return _react2.default.createElement(_revcontent2.default, {
        initialPageLoad: (0, _get2.default)(config, 'initialPageLoad'),
        site: (0, _get2.default)(config, 'site')
      });
    }
  }, {
    key: 'renderVideo',
    value: function renderVideo() {
      var _props3 = this.props,
          postVideo = _props3.postVideo,
          config = _props3.config,
          post = _props3.post;

      var feedID = (0, _get2.default)(post, 'posterVideo.feedId');

      // Do not display video module when on a video post
      if (config.featureFlags.videoPagesEnabled && feedID) {
        return '';
      }

      if (!(0, _isEmpty2.default)(postVideo)) {
        var currentSite = (0, _get2.default)(this.props, 'config.site');
        (0, _get2.default)(config, 'site');
        return _react2.default.createElement(_video_module2.default, {
          config: config,
          data: postVideo,
          playerid: 'MyQ2uJQ0',
          stories: this.props.postVideo.playlist,
          currentSite: currentSite,
          isPost: true
        });
      }

      return null;
    }
  }, {
    key: 'renderMoreStories',
    value: function renderMoreStories() {
      var postMoreStories = (0, _get2.default)(this.props, 'postMoreStories.posts');

      if (postMoreStories && postMoreStories.length && this.props.postFinite.length && _exenv.canUseDOM) {
        return _react2.default.createElement(_moreStoriesComponent2.default, {
          metadata: postMoreStories,
          isPost: true,
          config: this.props.config
        });
      }

      return null;
    }
  }, {
    key: 'renderPostFinite',
    value: function renderPostFinite(postFinite, related, sticky, config, playerIds) {
      var _this2 = this;

      if (!postFinite.length) {
        return null;
      }

      return postFinite.map(function (postData, index) {
        if (postData.isVideoPermalink || (0, _get2.default)(postData, 'posterVideo.feedId')) {
          if (!playerIds[index + 1]) {
            (0, _set2.default)(postData, 'playerScriptId', 'G2hQKLvX');
          } else {
            (0, _set2.default)(postData, 'playerScriptId', playerIds[index + 1]);
          }
        }

        return _react2.default.createElement(_container2.default, {
          key: (0, _get2.default)(postData, 'id'),
          posts: [postData],
          related: related,
          isDesktop: sticky,
          pageNum: index + 1,
          combinedAdModel: _this2.generateAdData(postData),
          config: config,
          videoAdData: (0, _get2.default)(_this2.props.postpage, 'ads.model', {}),
          updateCorrelator: true
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          config = _props4.config,
          statusCode = _props4.statusCode,
          post = _props4.post,
          related = _props4.related,
          postpage = _props4.postpage;


      if (postpage.isLoading && statusCode === 200) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      if (postpage.error || (0, _isEmpty2.default)(post)) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, {
              statusCode: statusCode,
              message: statusCode === 403 ? 'Post is not available.' : ''
            })
          )
        );
      }

      var sticky = this.stickySidebar;

      var combinedAdModel = this.generateAdData(post);
      if (post.isVideoPermalink || (0, _get2.default)(post, 'posterVideo.feedId')) {
        (0, _set2.default)(post, 'playerScriptId', this.playerScriptIds[0]);
      }

      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(_container2.default, {
          config: this.props.config,
          posts: [post],
          combinedAdModel: combinedAdModel,
          pageNum: 0,
          related: related,
          isDesktop: sticky,
          isFirstPost: true,
          videoAdData: (0, _get2.default)(postpage, 'ads.model', {}),
          live: this.live
        }),
        this.live ? _react2.default.createElement(
          'div',
          { className: 'post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'flexiblebillboard',
            region: 'articlebottom',
            pageNum: 1
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'mobileleaderboard',
            region: 'articlebottom',
            pageNum: 1
          }))
        ) : _react2.default.createElement(
          'div',
          null,
          this.renderRevContentOrMoreStories(),
          this.renderVideo(),
          this.renderPostFinite(this.state.finitePosts, related, sticky, config, this.playerScriptIds)
        )
      );
    }
  }]);

  return PostPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    statusCode: (0, _get2.default)(state, 'status.code'),
    config: state.config,
    postpage: state.postpage,
    post: (0, _get2.default)(state, 'post.data.post') || {},
    related: (0, _get2.default)(state, 'post.data.related') || [],
    postVideo: (0, _get2.default)(state, 'postVideo.data') || {
      feedid: '',
      playlist: [],
      title: ''
    },
    postAfterbodyRecircModuleType: (0, _get2.default)(state, 'postAfterbodyRecircModuleType.data'),
    postMoreStories: (0, _get2.default)(state, 'postMoreStories.data'),
    postFinite: (0, _get2.default)(state, 'postFinite.data.posts') || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchInfiniteScrollUrlChange: function dispatchInfiniteScrollUrlChange() {
      dispatch((0, _postpage_action_creators.infiniteScrollUrlChange)());
    },
    dispatchPostFinite: function dispatchPostFinite(id, config) {
      return (0, _async_post_finite_actions2.default)(dispatch, id, config);
    }
  };
}

PostPage.defaultProps = {
  postAfterbodyRecircModuleType: {
    type: 'More Stories'
  }
};

PostPage.propTypes = {
  statusCode: _propTypes2.default.number.isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  dispatchInfiniteScrollUrlChange: _propTypes2.default.func.isRequired,
  dispatchPostFinite: _propTypes2.default.func.isRequired,
  post: _propTypes2.default.shape({}).isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  postpage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string,
    postScrollDepth: _propTypes2.default.number
  }).isRequired,
  postVideo: _propTypes2.default.shape({
    feedid: _propTypes2.default.string,
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    title: _propTypes2.default.string
  }).isRequired,
  postFinite: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  postAfterbodyRecircModuleType: _propTypes2.default.shape({
    type: _propTypes2.default.string
  })
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostPage);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_postpage_actions = __webpack_require__(815);

var _async_postpage_actions2 = _interopRequireDefault(_async_postpage_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_postpage_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_postpage_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        if (callback) {
          return callback();
        }
        return false;
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(323),
    listCacheDelete = __webpack_require__(324),
    listCacheGet = __webpack_require__(325),
    listCacheHas = __webpack_require__(326),
    listCacheSet = __webpack_require__(327);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(88);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(329);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash-es/isPlainObject.js + 8 modules
var isPlainObject = __webpack_require__(118);

// EXTERNAL MODULE: ./node_modules/symbol-observable/index.js
var symbol_observable = __webpack_require__(339);
var symbol_observable_default = /*#__PURE__*/__webpack_require__.n(symbol_observable);

// CONCATENATED MODULE: ./node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(isPlainObject["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[symbol_observable_default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[symbol_observable_default.a] = observable, _ref2;
}
// CONCATENATED MODULE: ./node_modules/redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning_warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ./node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(isPlainObject["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ./node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
// CONCATENATED MODULE: ./node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(169),
    eq = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(349),
    isObjectLike = __webpack_require__(44);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(37),
    stubFalse = __webpack_require__(350);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)(module)))

/***/ }),
/* 97 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isArray = __webpack_require__(29),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(177),
    baseEach = __webpack_require__(199),
    castFunction = __webpack_require__(415),
    isArray = __webpack_require__(29);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38),
    isSymbol = __webpack_require__(84);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FeatureFeed;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _cloudinary_asset_util = __webpack_require__(30);

var _format_post_object = __webpack_require__(135);

var _format_post_object2 = _interopRequireDefault(_format_post_object);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _scroll = __webpack_require__(453);

var _scroll2 = _interopRequireDefault(_scroll);

var _social = __webpack_require__(52);

var _social2 = _interopRequireDefault(_social);

var _newsletterSignup = __webpack_require__(219);

var _newsletterSignup2 = _interopRequireDefault(_newsletterSignup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildActiveSponsoredCardDataObject(props) {
  var featuredSponsoredCard = (0, _get2.default)(props, 'featuredSponsoredCard');
  var cardMetadata = (0, _get2.default)(props, 'featuredSponsoredCard.meta');
  var featuredSponsoredCardType = (0, _get2.default)(featuredSponsoredCard, 'type');
  if (!featuredSponsoredCard || !cardMetadata) {
    return [{
      newsletter: true,
      poster: 'https://images.fastcompany.net/image/upload/v1488227009/fcweb/fj7ll7zhfiwfdlhgpe5g.png',
      noLazy: true
    }];
  }

  var parsedCardMetadata = JSON.parse(cardMetadata);
  var featuredSponsoredCardData = {
    Event: function Event() {
      return [{
        id: '12345',
        topic: 'Events',
        title: (0, _get2.default)(parsedCardMetadata, 'title'),
        link: (0, _get2.default)(parsedCardMetadata, 'link'),
        featured_image: {
          source: (0, _get2.default)(parsedCardMetadata, 'image')
        },
        external: true,
        currentSite: (0, _get2.default)(props, 'config.site'),
        events: true,
        customEyebrowText: (0, _get2.default)(parsedCardMetadata, 'eyebrow'),
        buttonText: (0, _get2.default)(parsedCardMetadata, 'buttonText'),
        assetSizes: _cloudinary_asset_util.imageSizesLookup.bigFirstMobile,
        noLazy: true
      }];
    },

    'Sponsored Story': function sponsoredStory() {
      return [{
        id: '12345',
        categories: [{
          name: 'Sponsored Content'
        }],
        title: (0, _get2.default)(parsedCardMetadata, 'title'),
        link: (0, _get2.default)(parsedCardMetadata, 'link'),
        featured_image: {
          source: (0, _get2.default)(parsedCardMetadata, 'image')
        },
        currentSite: (0, _get2.default)(props, 'config.site'),
        tags: [{ name: 'advertorial', slug: 'advertorial' }],
        events: false,
        assetSizes: _cloudinary_asset_util.imageSizesLookup.bigFirstMobile,
        noLazy: true,
        sponsored: true,
        external: true
      }];
    },
    'Email Signup': function emailSignup() {
      return [{
        newsletter: true,
        title: (0, _get2.default)(parsedCardMetadata, 'title'),
        deck: (0, _get2.default)(parsedCardMetadata, 'deck'),
        poster: (0, _get2.default)(parsedCardMetadata, 'image'),
        noLazy: true
      }];
    },
    'Franchise Promo': function franchisePromo() {
      return [{
        title: (0, _get2.default)(parsedCardMetadata, 'title'),
        deck: (0, _get2.default)(parsedCardMetadata, 'deck'),
        poster: (0, _get2.default)(parsedCardMetadata, 'image'),
        noLazy: true
      }];
    }
  };
  // figure out which card type it is, and send relevant metadata
  return featuredSponsoredCardData[featuredSponsoredCardType]();
}

function getFeaturedStory(props, post) {
  return (0, _format_post_object2.default)({
    props: props,
    post: post,
    imgSize: _cloudinary_asset_util.imageSizesLookup[1],
    allowTextOnly: true
  });
}

function getScrollingModule(props, scrollingModule) {
  var scrollingModuleTag = (0, _get2.default)(scrollingModule, 'tag', null);
  var newsStories = (0, _get2.default)(scrollingModule, 'posts', []).map(function (post) {
    return (0, _format_post_object2.default)({
      props: props,
      post: post,
      imgSize: _cloudinary_asset_util.imageSizesLookup.column,
      allowNoImage: true,
      deck: false
    });
  });
  var newsFeed = newsStories.length ? { stories: newsStories, tag: scrollingModuleTag } : null;

  return newsFeed;
}

function renderSponsoredCard(props) {
  var item = buildActiveSponsoredCardDataObject(props)[0];

  if (!item.newsletter) {
    return _react2.default.createElement(_card2.default, { metadata: item, config: (0, _get2.default)(props, 'config') });
  }

  return _react2.default.createElement(
    'div',
    { className: 'card card--default' },
    _react2.default.createElement(_newsletterSignup2.default, {
      hideCheckBox: true,
      modifier: 'homepage',
      title: item.title || '',
      deck: item.deck || '',
      poster: item.poster || 'https://fast-company-res.cloudinary.com/image/upload/v1488227009/fcweb/fj7ll7zhfiwfdlhgpe5g.png',
      newsletters: [{ list: 'fastcompany', default: true }]
    })
  );
}

function FeatureFeed(props) {
  var featuredFeed = props.featuredFeed,
      scrollingModule = props.scrollingModule,
      social = props.social,
      config = props.config;

  var featured = (0, _get2.default)(featuredFeed, 'featured[0]', {});
  var topStories = (0, _get2.default)(featuredFeed, 'top', []);
  var totalTopStories = topStories.length;
  var hasSocial = !(0, _isEmpty2.default)(social) && 'row--social';

  return _react2.default.createElement(
    'section',
    { className: 'featured-feed featured-feed--' + props.page },
    _react2.default.createElement(
      'div',
      { className: 'row ' + hasSocial },
      hasSocial ? _react2.default.createElement(_social2.default, social) : '',
      _react2.default.createElement(_card2.default, {
        type: 'featured',
        metadata: getFeaturedStory(props, featured),
        config: config
      }),
      _react2.default.createElement(_scroll2.default, {
        config: config,
        metadata: getScrollingModule(props, scrollingModule),
        promoBanner: props.promoBanner,
        className: 'news-column'
      })
    ),
    (0, _get2.default)(props, 'featuredFeed.featured').length ? _react2.default.createElement(
      'div',
      { className: props.page + '-page__ff-ad-container' },
      _react2.default.createElement(_ad2.default, _extends({}, props.combinedAdModel, {
        noLazyLoad: true,
        pos: 'atf',
        name: 'flexiblebillboard_1'
      })),
      _react2.default.createElement(_ad2.default, _extends({}, props.combinedAdModel, {
        noLazyLoad: true,
        pos: 'atf',
        name: 'mobileparallax_1'
      }))
    ) : '',
    totalTopStories >= 2 ? _react2.default.createElement(
      'div',
      { className: 'row' },
      topStories.slice(0, 2).map(function (post, i, arr) {
        return _react2.default.createElement(_card2.default, {
          key: post.id,
          metadata: (0, _format_post_object2.default)({
            props: props,
            post: post,
            imgSize: _cloudinary_asset_util.imageSizesLookup[arr.length + 1],
            allowTextOnly: true
          }),
          config: config,
          totalCards: arr.length + 1
        });
      }),
      renderSponsoredCard(props)
    ) : null,
    totalTopStories >= 4 ? _react2.default.createElement(
      'div',
      { className: 'row' },
      topStories.slice(2, 4).map(function (post, i, arr) {
        return _react2.default.createElement(_card2.default, {
          key: post.id,
          metadata: (0, _format_post_object2.default)({
            props: props,
            post: post,
            imgSize: _cloudinary_asset_util.imageSizesLookup[arr.length],
            allowTextOnly: true
          }),
          config: config,
          totalCards: arr.length
        });
      })
    ) : null
  );
}

FeatureFeed.defaultProps = {
  isPromoting: false,
  social: {},
  promoBanner: {}
};

FeatureFeed.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  featuredFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired,
  scrollingModule: _propTypes2.default.shape({}).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  page: _propTypes2.default.string.isRequired,
  promoBanner: _propTypes2.default.shape({}),
  social: _propTypes2.default.shape({})
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var EventEmitter = __webpack_require__(191);

module.exports = {
    connections: {},
    EE: new EventEmitter(),
    enableResizeInfo: false,
    enableScrollInfo: false,
    listeners: {},
    removers: []
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(132),
    isIterateeCall = __webpack_require__(175),
    toInteger = __webpack_require__(222);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(488);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(155);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(156);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react-router/matchPath.js
var matchPath = __webpack_require__(109);
var matchPath_default = /*#__PURE__*/__webpack_require__.n(matchPath);

// EXTERNAL MODULE: ./node_modules/react-router/Router.js
var Router = __webpack_require__(302);
var Router_default = /*#__PURE__*/__webpack_require__.n(Router);

// CONCATENATED MODULE: ./node_modules/react-router-config/es/matchRoutes.js



// ensure we're using the exact code for default root match
var computeMatch = Router_default.a.prototype.computeMatch;


var matchRoutes_matchRoutes = function matchRoutes(routes, pathname) {
  var branch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  routes.some(function (route) {
    var match = route.path ? matchPath_default()(pathname, route) : branch.length ? branch[branch.length - 1].match // use parent match
    : computeMatch(pathname); // use default "root" match

    if (match) {
      branch.push({ route: route, match: match });

      if (route.routes) {
        matchRoutes(route.routes, pathname, branch);
      }
    }

    return match;
  });

  return branch;
};

/* harmony default export */ var es_matchRoutes = (matchRoutes_matchRoutes);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router/Switch.js
var Switch = __webpack_require__(305);
var Switch_default = /*#__PURE__*/__webpack_require__.n(Switch);

// EXTERNAL MODULE: ./node_modules/react-router/Route.js
var Route = __webpack_require__(306);
var Route_default = /*#__PURE__*/__webpack_require__.n(Route);

// CONCATENATED MODULE: ./node_modules/react-router-config/es/renderRoutes.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var renderRoutes_renderRoutes = function renderRoutes(routes) {
  var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return routes ? react_default.a.createElement(
    Switch_default.a,
    null,
    routes.map(function (route, i) {
      return react_default.a.createElement(Route_default.a, {
        key: route.key || i,
        path: route.path,
        exact: route.exact,
        strict: route.strict,
        render: function render(props) {
          return react_default.a.createElement(route.component, _extends({}, props, extraProps, { route: route }));
        }
      });
    })
  ) : null;
};

/* harmony default export */ var es_renderRoutes = (renderRoutes_renderRoutes);
// CONCATENATED MODULE: ./node_modules/react-router-config/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "matchRoutes", function() { return es_matchRoutes; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "renderRoutes", function() { return es_renderRoutes; });





/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pathToRegexp = __webpack_require__(158);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

exports.default = matchPath;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(70),
    toKey = __webpack_require__(60);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(29),
    isSymbol = __webpack_require__(84);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(312),
    mapCacheDelete = __webpack_require__(328),
    mapCacheGet = __webpack_require__(330),
    mapCacheHas = __webpack_require__(331),
    mapCacheSet = __webpack_require__(332);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(333);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(91);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/_freeGlobal.js
var _freeGlobal = __webpack_require__(338);

// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (Symbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(176),
    baseKeysIn = __webpack_require__(354),
    isArrayLike = __webpack_require__(41);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(351),
    baseUnary = __webpack_require__(352),
    nodeUtil = __webpack_require__(353);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(123),
    arrayEach = __webpack_require__(177),
    assignValue = __webpack_require__(93),
    baseAssign = __webpack_require__(361),
    baseAssignIn = __webpack_require__(363),
    cloneBuffer = __webpack_require__(364),
    copyArray = __webpack_require__(365),
    copySymbols = __webpack_require__(366),
    copySymbolsIn = __webpack_require__(368),
    getAllKeys = __webpack_require__(182),
    getAllKeysIn = __webpack_require__(184),
    getTag = __webpack_require__(127),
    initCloneArray = __webpack_require__(372),
    initCloneByTag = __webpack_require__(373),
    initCloneObject = __webpack_require__(382),
    isArray = __webpack_require__(29),
    isBuffer = __webpack_require__(96),
    isObject = __webpack_require__(38),
    keys = __webpack_require__(50);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86),
    stackClear = __webpack_require__(356),
    stackDelete = __webpack_require__(357),
    stackGet = __webpack_require__(358),
    stackHas = __webpack_require__(359),
    stackSet = __webpack_require__(360);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(367),
    stubArray = __webpack_require__(180);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(179);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(369),
    Map = __webpack_require__(114),
    Promise = __webpack_require__(370),
    Set = __webpack_require__(185),
    WeakMap = __webpack_require__(371),
    baseGetTag = __webpack_require__(47),
    toSource = __webpack_require__(161);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(186);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addQuotes = addQuotes;
exports.default = deSlugify;
exports.capitalize = capitalize;
function addQuotes(text) {
  return '"' + text + '"';
}

function deSlugify(text) {
  if (text) {
    return text.replace(/-/g, '');
  }
  return '';
}

function capitalize(string) {
  return typeof string === 'string' ? '' + string.charAt(0).toUpperCase() + string.slice(1) : '';
}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(194),
    arrayIncludes = __webpack_require__(397),
    arrayIncludesWith = __webpack_require__(401),
    cacheHas = __webpack_require__(196),
    createSet = __webpack_require__(402),
    setToArray = __webpack_require__(97);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _scriptjs = __webpack_require__(58);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logglyLoaded = false;

// import $ from 'jquery';
// import circularJSON from 'circular-json';
/**
 * Send log request to site.
 * @param {string} level The log level.
 * @param {Object} data The log data.
 * @param {string} message The log message.
 * @private
 * @returns {Promise}
 */
function log(level) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = arguments[2];

  var jsonData = {};

  // if (data.message && data.stack) {
  //   return $.getScript('https://cdnjs.cloudflare.com/ajax/libs/stacktrace.js/1.3.1/stacktrace.min.js',
  //     () => {
  //       window.StackTrace.fromError(data)
  //         .then((dataWithStackTraces) => {
  //           jsonData.message = data.message;
  //           jsonData.stack = dataWithStackTraces;
  //           return axios({
  //             url: '/api/v1/log', // TODO: talk with team to make api absorb these logs?
  //             method: 'POST',
  //             dataType: 'json',
  //             data: {
  //               level,
  //               data: circularJSON.stringify(jsonData),
  //               message
  //             }
  //           });
  //         })
  //         .catch(function handleErrorGracefully(lerr) {
  //           // TODO: track in ga here
  // eslint-disable-next-line no-console
  //           console.error(lerr);
  //         });
  //     });
  // }

  (0, _extend2.default)(jsonData, data);
  if (!logglyLoaded) {
    return (0, _scriptjs2.default)('//cloudfront.loggly.com/js/loggly.tracker-2.1.min.js', function () {
      logglyLoaded = true;
    });
  }
  // eslint-disable-next-line no-underscore-dangle
  return window._LTracker.push({
    level: level,
    data: {
      message: jsonData.message,
      stack: jsonData.stack
    },
    message: message
  });
}

/**
 * Send log request to server side.
 * @typedef {function} logMethod
 * @param {Object|string} data The log data or message.
 * @param {string=} message The log message if the log data was specified.
 * @returns {Promise}
 */

/**
 * Methods: trace, debug, info, warn, error, fatal.
 *
 * See methods API: https://github.com/trentm/node-bunyan#log-method-api
 *
 * @example
 *   var log = require('./services/logger');
 *   log.error({ stack: err.stack }, 'Descriptive Error message' );
 *
 * @module services/logger
 */

var Logger = function () {
  function Logger() {
    _classCallCheck(this, Logger);

    (0, _extend2.default)(this, {
      /**
       * @name module:services/logger.trace
       * @type {logMethod}
       */
      trace: this.createLogFn('trace'),

      /**
       * @name module:services/logger.debug
       * @type {logMethod}
       */
      debug: this.createLogFn('debug'),

      /**
       * @name module:services/logger.info
       * @type {logMethod}
       */
      info: this.createLogFn('info'),

      /**
       * @name module:services/logger.warn
       * @type {logMethod}
       */
      warn: this.createLogFn('warn'),

      /**
       * @name module:services/logger.error
       * @type {logMethod}
       */
      error: this.createLogFn('error'),

      /**
       * @name module:services/logger.fatal
       * @type {logMethod}
       */
      fatal: this.createLogFn('fatal')
    });
  }

  /**
   * Factory to create log methods.
   * @param {string} level The log level method name.
   * @private
   * @returns {function}
   */


  _createClass(Logger, [{
    key: 'createLogFn',
    value: function createLogFn(level) {
      return function logFn(data, message) {
        if (!data && !message) {
          // console error if in development
          return false;
        }

        // TODO: clean up here
        var prodLog = level === 'trace' || level === 'debug' || level === 'info' || level === 'warn';

        if (this.env === 'production' && prodLog) {
          return false;
        }

        var currentInfo = {
          current_location: window.location.href
        };

        if (typeof data === 'string') {
          return log(level, (0, _extend2.default)({}, this.data, currentInfo), data);
        }

        if (this.env === 'development') {
          if (data.stack && data.message) {
            // eslint-disable-next-line no-console
            console.error(data);
          }
        }

        return log(level, (0, _extend2.default)(data, this.data, currentInfo), message);
      };
    }
  }, {
    key: 'initialize',
    value: function initialize(conf) {
      this.env = (0, _get2.default)(conf, 'config.env');
      this.data = (0, _extend2.default)({}, {
        site: (0, _get2.default)(conf, 'config.site'),
        userAgent: window.navigator.userAgent
      });
    }
  }]);

  return Logger;
}();

exports.default = new Logger();

/***/ }),
/* 132 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setModifierClass = setModifierClass;
exports.setElementClass = setElementClass;
exports.createPosterClasses = createPosterClasses;

var _advertorial = __webpack_require__(28);

function setModifierClass(condition, baseClass, modifier) {
  if (!condition || !baseClass || !modifier) return '';
  return baseClass + '--' + modifier;
}

function setElementClass(elementName, baseClass) {
  if (!elementName || !baseClass) return '';
  return elementName + '__' + baseClass;
}

function createPosterClasses(tags, events, className, hasVideoPoster) {
  var posterClass = 'poster';
  var advertorial = setModifierClass((0, _advertorial.isAdvertorial)(tags), posterClass, 'advertorial');
  var isEventCard = setModifierClass(events, posterClass, 'event-card');
  var hasClassName = setElementClass(className, posterClass);
  var requiresVideoOverlay = setModifierClass(hasVideoPoster, posterClass, 'video');
  var allClasses = [posterClass, advertorial, isEventCard, hasClassName, requiresVideoOverlay];

  return allClasses.filter(function (element) {
    return element;
  }).join(' ');
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _feature_feed = __webpack_require__(101);

var _feature_feed2 = _interopRequireDefault(_feature_feed);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _video_module = __webpack_require__(66);

var _video_module2 = _interopRequireDefault(_video_module);

var _magazine_archive = __webpack_require__(141);

var _magazine_archive2 = _interopRequireDefault(_magazine_archive);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _moreStoriesComponent = __webpack_require__(226);

var _moreStoriesComponent2 = _interopRequireDefault(_moreStoriesComponent);

var _async_is_all_feed_actions = __webpack_require__(505);

var _async_is_all_feed_actions2 = _interopRequireDefault(_async_is_all_feed_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Homepage = function (_Component) {
  _inherits(Homepage, _Component);

  function Homepage() {
    _classCallCheck(this, Homepage);

    return _possibleConstructorReturn(this, (Homepage.__proto__ || Object.getPrototypeOf(Homepage)).apply(this, arguments));
  }

  _createClass(Homepage, [{
    key: 'mergeArchiveData',
    value: function mergeArchiveData() {
      var magazineLatestIssuePosts = this.props.magazineLatestIssuePosts;

      var currentIssue = (0, _get2.default)(magazineLatestIssuePosts, 'data.issue', {});
      var pastIssues = (0, _get2.default)(magazineLatestIssuePosts, 'data.magazineArchive', []);

      return [currentIssue].concat(_toConsumableArray(pastIssues.slice(0, 3)));
    }
  }, {
    key: 'render',
    value: function render() {
      var page = (0, _get2.default)(this.props, 'allFeed.page');
      var pageParam = (0, _get2.default)(this.props, 'match.params.page', false);
      var totalPages = (0, _get2.default)(this.props, 'allFeed.totalPages');
      var isLastPage = Number(page) >= totalPages;

      var _props = this.props,
          config = _props.config,
          homepageTag = _props.homepageTag;

      var tags = (0, _get2.default)(homepageTag, 'posts[0].tags') || [];

      if (this.props.homepage.error) {
        return _react2.default.createElement(
          'section',
          { className: 'homepage-page' },
          _react2.default.createElement(
            'article',
            { className: 'homepage-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.homepage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'homepage-page' },
          _react2.default.createElement(
            'article',
            { className: 'homepage-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(this.props, 'homepage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      if (!pageParam && (0, _get2.default)(this.props, 'location.pathname') === '/') {
        return _react2.default.createElement(
          'section',
          { className: 'homepage-page' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
          _react2.default.createElement(_feature_feed2.default, {
            featuredFeed: this.props.featuredFeed,
            promoBanner: this.props.promoBanner,
            scrollingModule: this.props.scrollingModule,
            combinedAdModel: combinedAdModel,
            page: 'homepage',
            featuredSponsoredCard: this.props.featuredSponsoredCard,
            config: config
          }),
          (0, _get2.default)(this.props, 'featuredFeed.top').length >= 2 ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__ff-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
          ) : '',
          _react2.default.createElement(
            'section',
            { className: 'homepage-tag' },
            _react2.default.createElement(_moreStoriesComponent2.default, {
              metadata: (0, _get2.default)(this.props, 'homepageTag.posts'),
              slugData: (0, _get2.default)(this.props, 'homepageTag.tags[0]'),
              tags: tags,
              config: config
            })
          ),
          (0, _get2.default)(this.props, 'homepageTag.posts').length ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__tag-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_4' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
          ) : '',
          _react2.default.createElement(_magazine_archive2.default, {
            magazines: this.mergeArchiveData(),
            eventCategory: 'Home Page',
            config: config
          }),
          _react2.default.createElement(_video_module2.default, {
            config: config,
            data: this.props.homepageVideo,
            playerid: '76APbejE',
            stories: this.props.homepageVideo.playlist
          }),
          (0, _get2.default)(this.props, 'homepageVideo.playlist').length ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__video-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_3' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
          ) : '',
          _react2.default.createElement(_all_feed2.default, {
            hasSlug: true,
            adModel: combinedAdModel,
            stories: (0, _get2.default)(this.props, 'allFeed.posts'),
            allRendered: (0, _get2.default)(this.props, 'allFeed.allRendered'),
            paginationEnabled: true,
            totalPages: totalPages,
            page: page,
            section: 'all',
            type: 'homepage',
            isLastPage: isLastPage,
            infiniteScrollEnabled: config.featureFlags.infiniteScrollAllFeed,
            infiniteScrollAllFeedFetch: this.props.allISFeedActions,
            infiniteScrollLoading: (0, _get2.default)(this.props, 'allFeed.isLoading'),
            config: config,
            hideRecircFeed: this.props.hideRecircFeed
          }),
          (0, _get2.default)(this.props, 'allFeed.isLoading') && _react2.default.createElement(_loading_spinner2.default, null),
          this.props.allFeed.posts.length ? _react2.default.createElement(
            'div',
            { className: 'homepage-page__all-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_4' }))
          ) : ''
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'homepage-page' },
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, { slugName: 'All Stories', className: 'category-page' })
        ),
        _react2.default.createElement(_all_feed2.default, {
          config: config,
          hasSlug: false,
          adModel: combinedAdModel,
          stories: (0, _get2.default)(this.props, 'allFeed.posts'),
          allRendered: (0, _get2.default)(this.props, 'allFeed.allRendered'),
          paginationEnabled: true,
          page: page + 1,
          section: 'all',
          type: 'homepage',
          isLastPage: isLastPage
        }),
        this.props.allFeed.posts.length ? _react2.default.createElement(
          'div',
          { className: 'homepage-page__all-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_4' }))
        ) : ''
      );
    }
  }]);

  return Homepage;
}(_react.Component);

function mapDispatchToProps(dispatch) {
  return {
    allISFeedActions: (0, _async_is_all_feed_actions2.default)(dispatch),
    hideRecircFeed: (0, _async_recirc_feed_actions.hideRecircAction)(dispatch)
  };
}

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config,
    scrollingModule: (0, _get2.default)(state, 'scrollingModule.data') || {},
    promoBanner: (0, _get2.default)(state, 'promoBanner.data') || {},
    featuredSponsoredCard: (0, _get2.default)(state, 'featuredSponsoredCard.data') || {},
    allFeed: {
      isLoading: (0, _get2.default)(state, 'allFeed.isLoading', false),
      allRendered: (0, _get2.default)(state, 'allFeed.allRendered', false),
      posts: (0, _get2.default)(state, 'allFeed.data.posts', []),
      page: (0, _get2.default)(state, 'allFeed.data.page'),
      totalPages: (0, _get2.default)(state, 'allFeed.data.totalPages')
    },
    homepageVideo: {
      playlist: (0, _get2.default)(state, 'homepageVideo.data.playlist', []),
      title: (0, _get2.default)(state, 'homepageVideo.data.title', ''),
      feedid: (0, _get2.default)(state, 'homepageVideo.data.feedid', '')
    },
    featuredFeed: {
      source: (0, _get2.default)(state, 'featuredFeed.data.source', ''),
      top: (0, _get2.default)(state, 'featuredFeed.data.top', []),
      featured: (0, _get2.default)(state, 'featuredFeed.data.featured', [])
    },
    homepageTag: {
      tags: (0, _get2.default)(state, 'homepageTag.data.tags', []),
      posts: (0, _get2.default)(state, 'homepageTag.data.posts', [])
    },
    homepage: state.homepage || {},
    magazineLatestIssuePosts: (0, _get2.default)(state, 'magazineLatestIssuePosts') || {}
  };
}

Homepage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  homepage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    error: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  homepageVideo: _propTypes2.default.shape({
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    feedid: _propTypes2.default.string,
    title: _propTypes2.default.string
  }).isRequired,
  homepageTag: _propTypes2.default.shape({
    tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired,
  scrollingModule: _propTypes2.default.shape({}).isRequired,
  promoBanner: _propTypes2.default.shape({}).isRequired,
  featuredSponsoredCard: _propTypes2.default.shape({}).isRequired,
  allFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool
  }).isRequired,
  featuredFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired,
  allISFeedActions: _propTypes2.default.func.isRequired,
  hideRecircFeed: _propTypes2.default.func.isRequired,
  magazineLatestIssuePosts: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Homepage);

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatPostObject;

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatPostObject(config) {
  var post = config.post,
      imgSize = config.imgSize,
      _config$allowNoImage = config.allowNoImage,
      allowNoImage = _config$allowNoImage === undefined ? true : _config$allowNoImage,
      _config$allowTextOnly = config.allowTextOnly,
      allowTextOnly = _config$allowTextOnly === undefined ? false : _config$allowTextOnly;

  var formattedPost = {
    assetSizes: imgSize,
    allowNoImage: allowNoImage,
    noLazy: true,
    allowTextOnly: allowTextOnly
  };

  formattedPost = (0, _assign2.default)(formattedPost, post, {
    excerpt: ''
  });

  return formattedPost;
}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(71)(module)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadParselyTracker;
exports.trainParselyProfile = trainParselyProfile;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _axios = __webpack_require__(53);

var _axios2 = _interopRequireDefault(_axios);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadParselyTracker(currentState) {
  if (window.PARSELY && window.PARSELY.beacon) {
    var url = window.location.href;
    var navHistory = (0, _get2.default)(currentState, 'config.navHistory') || [];
    window.PARSELY.beacon.trackPageView({
      url: url,
      urlref: navHistory[navHistory.length - 1],
      js: 1
    });
  }
}

// Builds a profile of the user's recommendation list, doc https://www.parse.ly/help/api/recommendations/#get-related
function trainParselyProfile(url) {
  if (window.PARSELY && window.PARSELY.config) {
    var profileURL = url || window.location.href;
    var uuid = (0, _get2.default)(window, 'PARSELY.config.uuid');

    // Train user base on UUID and post
    _axios2.default.get('https://api.parsely.com/v2/profile?apikey=fastcompany.com&url=' + profileURL + '&uuid=' + uuid).catch(function (error) {
      _logger_service2.default.error('Parsely profile trainer error', error);
    });
  }
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(34);
var normalizeHeaderName = __webpack_require__(470);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(215);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(215);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _trackHelper = __webpack_require__(223);

var _objectAssign = __webpack_require__(39);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helpers = {
  initialize: function initialize(props) {
    var slickList = _reactDom2.default.findDOMNode(this.list);

    var slideCount = _react2.default.Children.count(props.children);
    var listWidth = this.getWidth(slickList);
    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
    var slideWidth;

    if (!props.vertical) {
      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
    } else {
      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
    }

    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * props.slidesToShow;

    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      currentSlide: currentSlide,
      slideHeight: slideHeight,
      listHeight: listHeight
    }, function () {

      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, props, this.state));
      // getCSS function needs previously set state
      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

      this.setState({ trackStyle: trackStyle });

      this.autoPlay(); // once we're set up, trigger the initial autoplay.
    });
  },
  update: function update(props) {
    var slickList = _reactDom2.default.findDOMNode(this.list);
    // This method has mostly same code as initialize method.
    // Refactor it
    var slideCount = _react2.default.Children.count(props.children);
    var listWidth = this.getWidth(slickList);
    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
    var slideWidth;

    if (!props.vertical) {
      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
    } else {
      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
    }

    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * props.slidesToShow;

    // pause slider if autoplay is set to false
    if (!props.autoplay) {
      this.pause();
    } else {
      this.autoPlay();
    }

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      slideHeight: slideHeight,
      listHeight: listHeight
    }, function () {

      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, props, this.state));
      // getCSS function needs previously set state
      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

      this.setState({ trackStyle: trackStyle });
    });
  },
  getWidth: function getWidth(elem) {
    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
  },
  getHeight: function getHeight(elem) {
    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
  },

  adaptHeight: function adaptHeight() {
    if (this.props.adaptiveHeight) {
      var selector = '[data-index="' + this.state.currentSlide + '"]';
      if (this.list) {
        var slickList = _reactDom2.default.findDOMNode(this.list);
        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
      }
    }
  },
  canGoNext: function canGoNext(opts) {
    var canGo = true;
    if (!opts.infinite) {
      if (opts.centerMode) {
        // check if current slide is last slide
        if (opts.currentSlide >= opts.slideCount - 1) {
          canGo = false;
        }
      } else {
        // check if all slides are shown in slider
        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
          canGo = false;
        }
      }
    }
    return canGo;
  },
  slideHandler: function slideHandler(index) {
    var _this = this;

    // Functionality of animateSlide and postSlide is merged into this function
    // console.log('slideHandler', index);
    var targetSlide, currentSlide;
    var targetLeft, currentLeft;
    var callback;

    if (this.props.waitForAnimate && this.state.animating) {
      return;
    }

    if (this.props.fade) {
      currentSlide = this.state.currentSlide;

      // Don't change slide if it's not infite and current slide is the first or last slide.
      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
        return;
      }

      //  Shifting targetSlide back into the range
      if (index < 0) {
        targetSlide = index + this.state.slideCount;
      } else if (index >= this.state.slideCount) {
        targetSlide = index - this.state.slideCount;
      } else {
        targetSlide = index;
      }

      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
        });
      }

      callback = function callback() {
        _this.setState({
          animating: false
        });
        if (_this.props.afterChange) {
          _this.props.afterChange(targetSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: targetSlide
      }, function () {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });

      if (this.props.beforeChange) {
        this.props.beforeChange(this.state.currentSlide, targetSlide);
      }

      this.autoPlay();
      return;
    }

    targetSlide = index;
    if (targetSlide < 0) {
      if (this.props.infinite === false) {
        currentSlide = 0;
      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
      } else {
        currentSlide = this.state.slideCount + targetSlide;
      }
    } else if (targetSlide >= this.state.slideCount) {
      if (this.props.infinite === false) {
        currentSlide = this.state.slideCount - this.props.slidesToShow;
      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
        currentSlide = 0;
      } else {
        currentSlide = targetSlide - this.state.slideCount;
      }
    } else {
      currentSlide = targetSlide;
    }

    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: targetSlide,
      trackRef: this.track
    }, this.props, this.state));

    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: currentSlide,
      trackRef: this.track
    }, this.props, this.state));

    if (this.props.infinite === false) {
      targetLeft = currentLeft;
    }

    if (this.props.beforeChange) {
      this.props.beforeChange(this.state.currentSlide, currentSlide);
    }

    if (this.props.lazyLoad) {
      var loaded = true;
      var slidesToLoad = [];
      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
        if (!loaded) {
          slidesToLoad.push(i);
        }
      }
      if (!loaded) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
        });
      }
    }

    // Slide Transition happens here.
    // animated transition happens to target Slide and
    // non - animated transition happens to current Slide
    // If CSS transitions are false, directly go the current slide.

    if (this.props.useCSS === false) {

      this.setState({
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
      }, function () {
        if (this.props.afterChange) {
          this.props.afterChange(currentSlide);
        }
      });
    } else {

      var nextStateChanges = {
        animating: false,
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
        swipeLeft: null
      };

      callback = function callback() {
        _this.setState(nextStateChanges);
        if (_this.props.afterChange) {
          _this.props.afterChange(currentSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
      }, function () {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });
    }

    this.autoPlay();
  },
  swipeDirection: function swipeDirection(touchObject) {
    var xDist, yDist, r, swipeAngle;

    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
      return this.props.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return this.props.rtl === false ? 'right' : 'left';
    }
    if (this.props.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }

    return 'vertical';
  },
  play: function play() {
    var nextIndex;

    if (!this.state.mounted) {
      return false;
    }

    if (this.props.rtl) {
      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
    } else {
      if (this.canGoNext(_extends({}, this.props, this.state))) {
        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
      } else {
        return false;
      }
    }

    this.slideHandler(nextIndex);
  },
  autoPlay: function autoPlay() {
    if (this.state.autoPlayTimer) {
      clearTimeout(this.state.autoPlayTimer);
    }
    if (this.props.autoplay) {
      this.setState({
        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
      });
    }
  },
  pause: function pause() {
    if (this.state.autoPlayTimer) {
      clearTimeout(this.state.autoPlayTimer);
      this.setState({
        autoPlayTimer: null
      });
    }
  }
};

exports.default = helpers;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(playerTitle, type) {
    _classCallCheck(this, _class);

    this.title = this.sanitizeTitle(playerTitle, type);
    this.adZoneSite = this.getSite();
    this.adZone = this.buildAdZone();
    this.adTag = this.buildAdURL();
  }

  _createClass(_class, [{
    key: 'getParameterByName',
    value: function getParameterByName(name) {
      var paramName = name;
      var url = window.location.href;
      paramName = paramName.replace(/[[\]]/g, '\\$&');

      var regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);

      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }, {
    key: 'buildAdURL',
    value: function buildAdURL() {
      var adZoneParam = this.getParameterByName('adzone');
      var cmsValueParam = this.getParameterByName('cms');
      var CIDValueParam = this.getParameterByName('cid') || '0';
      var customParams = 'video_tags%3D__item-tags__%26vport%3D' + this.getViewport() + '%26video_id%3D__item-mediaid__';

      if (_exenv2.default) {
        // adzone override, add ?adzone=test to url to activate
        if (adZoneParam) {
          this.adZone = '/4160/mv.fc/' + adZoneParam;
        }

        // custom param override, add ?cms=test to url to activate
        if (cmsValueParam) {
          customParams = customParams + '&cms=' + cmsValueParam;
        }

        if (CIDValueParam) {
          customParams = customParams + '&CID=' + CIDValueParam;
        }
      }

      // prettier-ignore
      var tag = '' + ('//pubads.g.doubleclick.net/gampad/ads?' + 'sz=640x360' + '&impl=s' + '&gdfp_req=1' + '&env=vp' + '&output=vast' + '&unviewed_position_start=1' + '&vad_type=linear' + '&vpos=preroll' + '&correlator=') + Date.now() + '&iu=' + this.adZone
      // Custom Params:
      // TESTING:
      // }&cust_params=cms%3Ddfp_video_test` +
      // PRODUCTION:
      + '&cust_params=' + customParams;

      return tag;
    }
  }, {
    key: 'sanitizeTitle',
    value: function sanitizeTitle(title, type) {
      if (type) {
        return type;
      }
      switch (true) {
        case title.match(/Homepage/) !== null:
          return 'homepage';
        case title.match(/Infinite/) !== null:
          return 'infinitescroll';
        default:
          return 'homepage';
      }
    }
  }, {
    key: 'buildAdZone',
    value: function buildAdZone() {
      var adZoneArray = ['', '4160', this.adZoneSite, '__item-category__', '__item-series__', 'preroll_' + this.title];
      return adZoneArray.join('/');
    }
  }, {
    key: 'getSite',
    value: function getSite() {
      if (_exenv2.default) {
        var loc = window.location.href;
        switch (true) {
          case loc.match(/fastcompany/) !== null:
            return 'mv.fc';
          case loc.match(/fastcodesign/) !== null:
            return 'mv.fcdesign';
          default:
            return 'mv.fc';
        }
      }
      return 'mv.fc';
    }
  }, {
    key: 'getViewport',
    value: function getViewport() {
      if (_exenv2.default) {
        var w = window.innerWidth;

        if (w > 1023) {
          return 'l';
        }

        if (w < 640) {
          return 's';
        }

        return 'm';
      }
      return 'undefined';
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _ga = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MagazineArchive = function (_Component) {
  _inherits(MagazineArchive, _Component);

  function MagazineArchive(props) {
    _classCallCheck(this, MagazineArchive);

    var _this = _possibleConstructorReturn(this, (MagazineArchive.__proto__ || Object.getPrototypeOf(MagazineArchive)).call(this, props));

    _this.totalMagazines = (0, _get2.default)(props, 'magazines.length', 0);
    _this.state = {
      limit: props.limit
    };

    _this.showAllMagazines = _this.showAllMagazines.bind(_this);
    return _this;
  }

  _createClass(MagazineArchive, [{
    key: 'showAllMagazines',
    value: function showAllMagazines() {
      this.setState({
        limit: this.totalMagazines
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          title = _props.title,
          description = _props.description,
          eventCategory = _props.eventCategory;

      var magazines = (0, _get2.default)(this.props, 'magazines', []);

      return _react2.default.createElement(
        'div',
        { className: 'magazine-archive' },
        _react2.default.createElement(_slug2.default, { slugName: title, linkTo: 'https://www.fastcompany.com/magazine' }),
        _react2.default.createElement(
          'h3',
          { className: 'page-description' },
          description
        ),
        _react2.default.createElement(
          'div',
          { className: 'row row--magazine' },
          magazines.slice(0, this.state.limit).map(function (issue) {
            if (!issue) {
              return null;
            }

            return _react2.default.createElement(_card2.default, {
              config: config,
              key: issue.issue,
              type: 'magazine',
              metadata: issue,
              cardEvent: function cardEvent() {
                if (eventCategory) {
                  (0, _ga.trackGAEvent)({
                    eventCategory: eventCategory,
                    eventAction: 'Magazine',
                    eventLabel: 'Issue ' + issue.issue
                  });
                }
              }
            });
          })
        ),
        this.state.limit !== this.totalMagazines ? _react2.default.createElement(
          'div',
          { className: 'magazine-archive__see-more' },
          _react2.default.createElement(
            'button',
            {
              className: 'magazine-archive__button',
              onClick: this.showAllMagazines
            },
            'See More Magazine Issues'
          )
        ) : null
      );
    }
  }]);

  return MagazineArchive;
}(_react.Component);

exports.default = MagazineArchive;


MagazineArchive.defaultProps = {
  title: 'Fast Company Magazine',
  description: 'Browse Our Most Current Issues',
  eventCategory: '',
  limit: 4
};

MagazineArchive.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  eventCategory: _propTypes2.default.string,
  // eslint-disable-next-line react/no-unused-prop-types
  magazines: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  limit: _propTypes2.default.number
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _exenv = __webpack_require__(4);

var _async_homepage_actions = __webpack_require__(510);

var _async_homepage_actions2 = _interopRequireDefault(_async_homepage_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store, isAllIndex) {
  return function fetchData(nextState, replace, callback) {
    if (isAllIndex) {
      (0, _set2.default)(nextState.params, 'page', 1);
    }

    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_homepage_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_homepage_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback();
      }
      return false;
    });
  };
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _featured_sponsored_card_action_creators = __webpack_require__(529);

var featuredSponsoredCardActions = _interopRequireWildcard(_featured_sponsored_card_action_creators);

var _featured_sponsored_card_module = __webpack_require__(530);

var _featured_sponsored_card_module2 = _interopRequireDefault(_featured_sponsored_card_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(featuredSponsoredCardActions.featuredSponsoredCardLoading({}, store));
    return _featured_sponsored_card_module2.default.fetch(params, store, isTag).then(function handlePostDetailData(resp) {
      dispatch(featuredSponsoredCardActions.featuredSponsoredCardLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(featuredSponsoredCardActions.featuredSponsoredCardLoadError(err, store));
      _logger_service2.default.error(err, 'Error in featured sponsored card actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authorAllFeedLoading = authorAllFeedLoading;
exports.authorAllFeedLoaded = authorAllFeedLoaded;
exports.authorAllFeedLoadError = authorAllFeedLoadError;
exports.authorAllFeedAllStoriesRendered = authorAllFeedAllStoriesRendered;
exports.authorAllFeedISLoading = authorAllFeedISLoading;
exports.authorAllFeedISLoaded = authorAllFeedISLoaded;
exports.authorAllFeedISError = authorAllFeedISError;
// import { canUseDOM } from 'exenv';

function authorAllFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'AUTHOR_ALL_FEED_LOADING',
    authorAllFeed: resp,
    store: store
  };
}

function authorAllFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'AUTHOR_ALL_FEED_LOADED',
    authorAllFeed: resp,
    store: store
  };
}

function authorAllFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'AUTHOR_ALL_FEED_ERROR',
    authorAllFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function authorAllFeedAllStoriesRendered() {
  return {
    type: 'AUTHOR_ALL_FEED_ALL_STORIES_RENDERED',
    allRendered: true
  };
}

function authorAllFeedISLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'AUTHOR_ALL_FEED_IS_LOADING',
    authorAllFeed: resp,
    config: config
  };
}

function authorAllFeedISLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'AUTHOR_ALL_FEED_IS_LOADED',
    authorAllFeed: resp,
    config: config
  };
}

function authorAllFeedISError() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'AUTHOR_ALL_FEED_IS_ERROR',
    authorAllFeed: resp,
    config: config
  };
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(22);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _feature_feed = __webpack_require__(101);

var _feature_feed2 = _interopRequireDefault(_feature_feed);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _video_module = __webpack_require__(66);

var _video_module2 = _interopRequireDefault(_video_module);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _category_all_feed_action_creators = __webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Category = function (_Component) {
  _inherits(Category, _Component);

  function Category() {
    _classCallCheck(this, Category);

    return _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).apply(this, arguments));
  }

  _createClass(Category, [{
    key: 'render',
    value: function render() {
      if (this.props.categoryPage.error || this.props.categoryFeaturedFeed.error || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.categoryPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(this.props, 'categoryPage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var config = (0, _get2.default)(this.props, 'config');
      var tag = (0, _get2.default)(this.props, 'categoryAllFeed.tag.name');
      var category = (0, _get2.default)(this.props, 'categoryFeaturedFeed.category.name');
      var description = tag ? (0, _get2.default)(this.props, 'categoryAllFeed.tag.description') : (0, _get2.default)(this.props, 'categoryFeaturedFeed.category.description');
      var page = (0, _get2.default)(this.props, 'match.params.page', false);
      var totalPages = (0, _get2.default)(this.props, 'categoryAllFeed.totalPages');
      var hrefOverride = tag ? '/' + (0, _get2.default)(this.props, 'categoryFeaturedFeed.category.slug') + '/' + (0, _get2.default)(this.props, 'categoryAllFeed.tag.slug') + '/' : '';
      var type = tag ? 'category_tag' : 'category';
      var isLastPage = Number(page) === totalPages;

      if (!page) {
        if (totalPages === 1) {
          isLastPage = true;
        }
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
          _react2.default.createElement(
            'section',
            { className: 'page-title' },
            _react2.default.createElement(_slug2.default, {
              slugName: tag ? category + ' : ' + tag : category,
              className: 'category-page'
            }),
            description ? _react2.default.createElement('h3', {
              className: 'page-description',
              dangerouslySetInnerHTML: { __html: description }
            }) : ''
          ),
          _react2.default.createElement(_feature_feed2.default, {
            config: config,
            featuredFeed: this.props.categoryFeaturedFeed,
            promoBanner: this.props.categoryPromoBanner,
            scrollingModule: this.props.categoryScrollingModule,
            combinedAdModel: combinedAdModel,
            page: 'category',
            featuredSponsoredCard: this.props.featuredSponsoredCard
          }),
          (0, _get2.default)(this.props, 'categoryFeaturedFeed.top').length >= 2 ? _react2.default.createElement(
            'div',
            { className: 'category-page__ff-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
          ) : '',
          _react2.default.createElement(_video_module2.default, {
            config: config,
            type: 'category',
            data: this.props.categoryVideo,
            playerid: 'HliaKwd3',
            stories: this.props.categoryVideo.playlist
          }),
          (0, _get2.default)(this.props, 'categoryVideo.playlist').length ? _react2.default.createElement(
            'div',
            { className: 'category-page__video-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_3' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
          ) : '',
          _react2.default.createElement(_all_feed2.default, {
            config: config,
            adModel: combinedAdModel,
            stories: (0, _get2.default)(this.props, 'categoryAllFeed.posts'),
            allRendered: (0, _get2.default)(this.props, 'categoryAllFeed.allRendered'),
            updateAction: _category_all_feed_action_creators.categoryAllFeedAllStoriesRendered,
            paginationEnabled: true,
            page: Number((0, _get2.default)(this.props, 'match.params.page', '1')) + 1,
            section: category ? category.toLowerCase() : '',
            type: type,
            hrefOverride: hrefOverride,
            isLastPage: isLastPage,
            titleOverride: 'All ' + (tag ? category + ' : ' + tag : category) + ' Stories'
          }),
          this.props.categoryAllFeed.posts.length ? _react2.default.createElement(
            'div',
            { className: 'category-page__all-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
          ) : ''
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'category-page' },
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, {
            slugName: '' + (tag ? category + ' : ' + tag : category),
            className: 'category-page'
          }),
          description ? _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            description
          ) : ''
        ),
        _react2.default.createElement(_all_feed2.default, {
          config: config,
          hasSlug: false,
          adModel: combinedAdModel,
          stories: (0, _get2.default)(this.props, 'categoryAllFeed.posts'),
          allRendered: (0, _get2.default)(this.props, 'categoryAllFeed.allRendered'),
          updateAction: _category_all_feed_action_creators.categoryAllFeedAllStoriesRendered,
          paginationEnabled: true,
          page: Number((0, _get2.default)(this.props, 'match.params.page', '1')) + 1,
          section: category.toLowerCase(),
          type: type,
          isLastPage: isLastPage,
          paginationPath: '' + category,
          hrefOverride: hrefOverride
        }),
        this.props.categoryAllFeed.posts.length ? _react2.default.createElement(
          'div',
          { className: 'category-page__all-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
        ) : ''
      );
    }
  }]);

  return Category;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: (0, _get2.default)(state, 'categoryFeaturedFeed.source', ''),
      featured: (0, _get2.default)(state, 'categoryFeaturedFeed.featured', []),
      top: (0, _get2.default)(state, 'categoryFeaturedFeed.top', []),
      category: (0, _get2.default)(state, 'categoryFeaturedFeed.category', {}),
      error: (0, _get2.default)(state, 'categoryFeaturedFeed.error', false)
    },
    categoryVideo: {
      playlist: (0, _get2.default)(state, 'categoryVideo.data.playlist', []),
      title: (0, _get2.default)(state, 'categoryVideo.data.title', ''),
      feedid: (0, _get2.default)(state, 'categoryVideo.data.feedid', '')
    },
    categoryPage: (0, _get2.default)(state, 'categoryPage', {}),
    categoryScrollingModule: (0, _get2.default)(state, 'categoryScrollingModule.data', {}),
    categoryPromoBanner: (0, _get2.default)(state, 'categoryPromoBanner.data', {}),
    featuredSponsoredCard: (0, _get2.default)(state, 'featuredSponsoredCard.data', {}),
    categoryAllFeed: {
      allRendered: (0, _get2.default)(state, 'categoryAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'categoryAllFeed.data.posts', []),
      totalPages: (0, _get2.default)(state, 'categoryAllFeed.data.totalPages', 0),
      totalPosts: (0, _get2.default)(state, 'categoryAllFeed.data.totalPosts', 0),
      tag: (0, _get2.default)(state, 'categoryAllFeed.data.tag')
    }
  };
}

Category.propTypes = {
  status: _propTypes2.default.number.isRequired,
  categoryPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  categoryFeaturedFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    category: _propTypes2.default.object,
    error: _propTypes2.default.bool
  }).isRequired,
  categoryVideo: _propTypes2.default.shape({
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    feedid: _propTypes2.default.string,
    title: _propTypes2.default.string
  }).isRequired,
  categoryScrollingModule: _propTypes2.default.shape({}).isRequired,
  categoryPromoBanner: _propTypes2.default.shape({}).isRequired,
  featuredSponsoredCard: _propTypes2.default.shape({}).isRequired,
  categoryAllFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool,
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number,
    tag: _propTypes2.default.shape({})
  }).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Category));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _exenv = __webpack_require__(4);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _body = __webpack_require__(580);

var _body2 = _interopRequireDefault(_body);

var _sidebar = __webpack_require__(250);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _advertorial = __webpack_require__(28);

var _embed_autoplay = __webpack_require__(614);

var _embed_autoplay2 = _interopRequireDefault(_embed_autoplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostsContainer = function (_Component) {
  _inherits(PostsContainer, _Component);

  function PostsContainer() {
    _classCallCheck(this, PostsContainer);

    var _this = _possibleConstructorReturn(this, (PostsContainer.__proto__ || Object.getPrototypeOf(PostsContainer)).call(this));

    _this.videosOnPage = [];
    _this.cachedVideosOnPage = [];
    _this.activatedVideosOnPage = [];
    return _this;
  }

  _createClass(PostsContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.updateCorrelator && _exenv.canUseDOM && window.googletag) {
        window.googletag.pubads().updateCorrelator();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.rendered = true;
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      var props = this.props,
          rendered = this.rendered;
      // initialPageLoad is needed for the first post to enable sticky ads.

      var isInitLoad = props.config.initialPageLoad;

      return !rendered || isInitLoad;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (_exenv.canUseDOM) {
        this.videosOnPage = document.querySelectorAll('.inline-video iframe[src*="fastco"]');
        if (this.cachedVideosOnPage.length !== this.videosOnPage.length) {
          this.cachedVideosOnPage = this.videosOnPage;
          for (var i = 0; i < this.activatedVideosOnPage.length; i += 1) {
            this.activatedVideosOnPage[i].off();
          }
          for (var _i = 0; _i < this.videosOnPage.length; _i += 1) {
            var activeVid = new _embed_autoplay2.default(this.videosOnPage[_i]);
            activeVid.on();
            this.activatedVideosOnPage.push(activeVid);
          }
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      for (var i = 0; i < this.activatedVideosOnPage.length; i += 1) {
        this.activatedVideosOnPage[i].off();
      }
    }
  }, {
    key: 'setWrapperClasses',
    value: function setWrapperClasses(advertorial) {
      var classNames = ['post__wrapper'];

      if (advertorial) {
        classNames.push('post__wrapper--advertorial');
      }

      return classNames.join(' ');
    }
  }, {
    key: 'renderPostBody',
    value: function renderPostBody(post, index, advertorial, related) {
      var _props = this.props,
          posts = _props.posts,
          config = _props.config,
          isDesktop = _props.isDesktop,
          isFirstPost = _props.isFirstPost,
          videoAdData = _props.videoAdData,
          combinedAdModel = _props.combinedAdModel,
          pageNum = _props.pageNum,
          live = _props.live;

      var totalPosts = posts.length;
      var hasNewsletter = true;
      var isLongPost = post.layout === 'long';
      var isVideoPost = false;

      if (totalPosts > 1) {
        hasNewsletter = isFirstPost && index === totalPosts - 1;
      }

      if (config.featureFlags.videoPagesEnabled) {
        isVideoPost = post.layout === 'video';
        if (isVideoPost) {
          hasNewsletter = false;
        }
      }

      return _react2.default.createElement(_body2.default, {
        key: post.id,
        post: post,
        advertorial: advertorial,
        combinedAdModel: combinedAdModel,
        isFirstPost: isFirstPost,
        config: config,
        isDesktop: isDesktop,
        videoAdData: videoAdData,
        pageNum: pageNum,
        isLongPost: isLongPost,
        isVideoPost: isVideoPost,
        hasNewsletter: hasNewsletter,
        related: related,
        live: live
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          config = _props2.config,
          posts = _props2.posts,
          related = _props2.related,
          isDesktop = _props2.isDesktop,
          isFirstPost = _props2.isFirstPost,
          combinedAdModel = _props2.combinedAdModel,
          pageNum = _props2.pageNum;

      var firstPost = (0, _get2.default)(posts, '[0]');
      var tags = (0, _get2.default)(firstPost, 'tags');
      var advertorial = (0, _advertorial.isAdvertorial)(tags);

      var adName = isFirstPost ? 'flexiblepushdown' : 'flexiblebillboard';
      var isLongPost = firstPost.layout === 'long';

      var isVideoPost = false;
      if (!firstPost) return null;

      if (config.featureFlags.videoPagesEnabled) {
        isVideoPost = (0, _get2.default)(firstPost, 'layout', false) === 'video';
      }

      return _react2.default.createElement(
        'div',
        { className: this.setWrapperClasses(advertorial) },
        _react2.default.createElement(
          'div',
          { className: 'post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: adName,
            region: 'articletop',
            pageNum: pageNum
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'mobileleaderboard',
            region: 'articletop',
            pageNum: pageNum
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'oop',
            slug: false,
            oop: true,
            pageNum: pageNum
          }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'post ' + (isVideoPost ? 'post--video' : '') },
          _react2.default.createElement(
            'div',
            { className: 'post__main' },
            posts.map(function (post, index) {
              return _this2.renderPostBody(post, index, advertorial, related);
            })
          ),
          _react2.default.createElement(_sidebar2.default, {
            config: config,
            post: firstPost,
            related: related,
            isFirstPost: isFirstPost,
            combinedAdModel: combinedAdModel,
            isDesktop: isDesktop,
            pageNum: pageNum,
            fullPageAdvertorial: advertorial,
            isLongPost: isLongPost,
            isVideoPost: isVideoPost
          })
        )
      );
    }
  }]);

  return PostsContainer;
}(_react.Component);

exports.default = PostsContainer;


PostsContainer.defaultProps = {
  isDesktop: false,
  isFirstPost: false,
  related: [],
  updateCorrelator: false,
  live: false
};

PostsContainer.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  isDesktop: _propTypes2.default.bool,
  isFirstPost: _propTypes2.default.bool,
  videoAdData: _propTypes2.default.shape({}).isRequired,
  pageNum: _propTypes2.default.number.isRequired,
  updateCorrelator: _propTypes2.default.bool,
  live: _propTypes2.default.bool
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trackThirdPartyJS;

var _exenv = __webpack_require__(4);

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _ga = __webpack_require__(51);

var _ga2 = _interopRequireDefault(_ga);

var _facebook = __webpack_require__(619);

var _facebook2 = _interopRequireDefault(_facebook);

var _omniture = __webpack_require__(246);

var _omniture2 = _interopRequireDefault(_omniture);

var _comscore = __webpack_require__(247);

var _comscore2 = _interopRequireDefault(_comscore);

var _nielsen = __webpack_require__(620);

var _nielsen2 = _interopRequireDefault(_nielsen);

var _krux = __webpack_require__(621);

var _krux2 = _interopRequireDefault(_krux);

var _parsely = __webpack_require__(137);

var _parsely2 = _interopRequireDefault(_parsely);

var _liftIgniter = __webpack_require__(622);

var _liftIgniter2 = _interopRequireDefault(_liftIgniter);

var _feature_flags = __webpack_require__(75);

var _feature_flags2 = _interopRequireDefault(_feature_flags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The following trackers are executed on CLIENT SIDE ONLY
// Usually during single page app's "pageview" action
function trackThirdPartyJS(currentState, pageNumber) {
  if (_exenv.canUseDOM) {
    var trackers = [(0, _ga2.default)(currentState, pageNumber), (0, _facebook2.default)(currentState), (0, _omniture2.default)(currentState, pageNumber), (0, _comscore2.default)(currentState), (0, _nielsen2.default)(), (0, _krux2.default)(currentState), (0, _parsely2.default)(currentState)];

    if (_feature_flags2.default.liftIgniterEnabled) {
      trackers.push((0, _liftIgniter2.default)(currentState));
    }

    return _bluebird2.default.all(trackers);
  }
  return _bluebird2.default.resolve([]);
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactPaginate = __webpack_require__(237);

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _reactRouterRedux = __webpack_require__(61);

var _search = __webpack_require__(203);

var _search2 = _interopRequireDefault(_search);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var SearchPage = function (_Component) {
  _inherits(SearchPage, _Component);

  function SearchPage(props) {
    _classCallCheck(this, SearchPage);

    var _this = _possibleConstructorReturn(this, (SearchPage.__proto__ || Object.getPrototypeOf(SearchPage)).call(this, props));

    _this.renderSearch = _this.renderSearch.bind(_this);
    _this.renderAllFeed = _this.renderAllFeed.bind(_this);
    _this.onPaginateClick = _this.onPaginateClick.bind(_this);
    return _this;
  }

  _createClass(SearchPage, [{
    key: 'onPaginateClick',
    value: function onPaginateClick(data) {
      var search = this.props.search;

      var query = (0, _get2.default)(search, 'data.query.queryString');
      var page = data.selected;
      var url = '/search/' + query + '/' + (page + 1);
      this.props.nextPage(url);
    }
  }, {
    key: 'renderResultBlock',
    value: function renderResultBlock(searchResults, searchTerm) {
      return _react2.default.createElement(
        'div',
        { className: 'search__content' },
        searchTerm ? _react2.default.createElement(_search2.default, { modifier: 'search-page', skin: 'dark', searchTerm: searchTerm }) : null,
        _react2.default.createElement(
          'div',
          { className: 'search-results__meta' },
          _react2.default.createElement(
            'h2',
            {
              className: 'search-results__count search-results__count--' + (searchTerm ? 'top' : 'bottom')
            },
            searchResults,
            ' results'
          ),
          searchResults >= 10 ? this.renderPagination(searchTerm) : null
        )
      );
    }
  }, {
    key: 'renderPagination',
    value: function renderPagination(searchTerm) {
      var search = this.props.search;


      return _react2.default.createElement(_reactPaginate2.default, {
        forcePage: (0, _get2.default)(search, 'data.paging.currPage') - 1,
        onPageChange: this.onPaginateClick,
        pageCount: (0, _get2.default)(search, 'data.paging.totalPages'),
        pageRangeDisplayed: 2,
        marginPagesDisplayed: 1,
        previousLabel: 'Prev',
        nextLabel: 'Next',
        breakLabel: '...',
        containerClassName: 'pagination pagination--' + (searchTerm ? 'top' : 'bottom'),
        pageClassName: 'pagination__page',
        activeClassName: 'pagination__page pagination__page--active',
        previousClassName: 'pagination__page pagination__page--prev',
        nextClassName: 'pagination__page pagination__page--next',
        breakClassName: 'pagination__page pagination__page--break',
        pageLinkClassName: 'pagination__link',
        previousLinkClassName: 'pagination__link',
        nextLinkClassName: 'pagination__link',
        disabledClassName: 'pagination__link--disabled'
      });
    }
  }, {
    key: 'renderSearch',
    value: function renderSearch(searchTerm, searchResults, entry, config, combinedAdModel) {
      return _react2.default.createElement(
        'section',
        { className: 'search__wrapper' },
        this.renderResultBlock(searchResults, searchTerm),
        _react2.default.createElement(_all_feed2.default, {
          adModel: combinedAdModel,
          stories: entry,
          currentSite: 'fastcompany',
          config: config,
          hasSlug: false,
          search: true,
          disableMore: true
        }),
        this.renderResultBlock(searchResults)
      );
    }
  }, {
    key: 'renderAllFeed',
    value: function renderAllFeed(searchTerm, allFeed, config, combinedAdModel) {
      return _react2.default.createElement(
        'section',
        { className: 'search__wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'search__content' },
          _react2.default.createElement(_search2.default, { modifier: 'search-page', skin: 'dark', searchTerm: searchTerm }),
          _react2.default.createElement(
            'div',
            { className: 'search-results__meta' },
            _react2.default.createElement(
              'h2',
              { className: 'search-results__count search-results__count--none' },
              'No results were found, but please enjoy these suggestions:'
            )
          )
        ),
        _react2.default.createElement(_all_feed2.default, {
          adModel: combinedAdModel,
          stories: allFeed,
          currentSite: 'fastcompany',
          config: config,
          hasSlug: false,
          disableMore: true
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          searchPage = _props.searchPage,
          search = _props.search,
          allFeed = _props.allFeed;


      if ((0, _get2.default)(searchPage, 'error') === true) {
        return _react2.default.createElement(
          'section',
          { className: 'search' },
          _react2.default.createElement(_not_found_component2.default, null)
        );
      }

      if ((0, _get2.default)(searchPage, 'isLoading') === true) {
        return _react2.default.createElement(
          'section',
          { className: 'search' },
          _react2.default.createElement(_loading_spinner2.default, null)
        );
      }

      var entry = (0, _get2.default)(search, 'data.entry') || [];
      var adData = (0, _get2.default)(searchPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });
      var searchResults = (0, _get2.default)(search, 'data.paging.totalItems');
      var searchTerm = (0, _get2.default)(search, 'data.query.queryString');

      return _react2.default.createElement(
        'section',
        { className: 'search' },
        entry.length ? this.renderSearch(searchTerm, searchResults, entry, config, combinedAdModel) : this.renderAllFeed(searchTerm, allFeed, config, combinedAdModel),
        _react2.default.createElement(
          'div',
          { className: 'search-results__bottom-ad' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'flexiblebillboard_2',
            region: 'searchbottom'
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'mobilerectangle_2',
            region: 'searchbottom'
          }))
        )
      );
    }
  }]);

  return SearchPage;
}(_react.Component);

function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage(url) {
      dispatch((0, _reactRouterRedux.push)(url));
    }
  };
}

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    search: state.search || {},
    allFeed: (0, _get2.default)(state, 'allFeed.data.posts') || [],
    searchPage: state.searchPage || {
      ads: {
        baseConfig: {}
      }
    }
  };
}

SearchPage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  searchPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string,
    searchTerm: _propTypes2.default.string
  }).isRequired,
  allFeed: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  search: _propTypes2.default.shape({}).isRequired,
  nextPage: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchPage);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchSearchData;

var _exenv = __webpack_require__(4);

var _async_search_page_actions = __webpack_require__(659);

var _async_search_page_actions2 = _interopRequireDefault(_async_search_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSearchData(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_search_page_actions2.default)(nextState, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_search_page_actions2.default)(nextState, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleServerSideRenderError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _feature_feed = __webpack_require__(101);

var _feature_feed2 = _interopRequireDefault(_feature_feed);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _video_module = __webpack_require__(66);

var _video_module2 = _interopRequireDefault(_video_module);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _advertorial = __webpack_require__(28);

var _advertorial2 = _interopRequireDefault(_advertorial);

var _tag_all_feed_action_creators = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Tag = function (_Component) {
  _inherits(Tag, _Component);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
  }

  _createClass(Tag, [{
    key: 'render',
    value: function render() {
      if (this.props.tagPage.error || this.props.tagFeaturedFeed.error) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.tagPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          tagPage = _props.tagPage,
          config = _props.config,
          tagFeaturedFeed = _props.tagFeaturedFeed,
          tagAllFeed = _props.tagAllFeed;

      var adData = (0, _get2.default)(tagPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgName = (0, _get2.default)(tagFeaturedFeed, 'tag.name');
      var pgDesc = (0, _get2.default)(tagFeaturedFeed, 'tag.description');
      var tags = (0, _get2.default)(tagAllFeed, 'posts[0].tags');
      var advertorial = (0, _advertorial.isAdvertorial)(tags);
      var page = (0, _get2.default)(this.props, 'match.params.page', false);
      var totalPages = (0, _get2.default)(this.props, 'tagAllFeed.totalPages');
      var isLastPage = Number(page) === totalPages;

      if (!page) {
        if (totalPages === 1) {
          isLastPage = true;
        }
        return _react2.default.createElement(
          'section',
          {
            className: 'tag-page ' + (advertorial ? 'tag-page--advertorial' : '')
          },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
          advertorial ? _react2.default.createElement(_advertorial2.default, {
            modifier: 'tag-page',
            tags: tags,
            adModel: combinedAdModel
          }) : '',
          advertorial ? _react2.default.createElement(_all_feed2.default, {
            adModel: combinedAdModel,
            stories: (0, _get2.default)(this.props, 'tagAllFeed.posts'),
            allRendered: (0, _get2.default)(this.props, 'tagAllFeed.allRendered'),
            updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
            config: config,
            tags: (0, _get2.default)(this.props, 'tagAllFeed.posts[0].tags'),
            advertorialSlugs: (0, _get2.default)(this.props, 'tagFeaturedFeed.tag'),
            modifier: 'advertorial'
          }) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'section',
              { className: 'page-title' },
              _react2.default.createElement(_slug2.default, { slugName: pgName, className: 'tag-page' }),
              pgDesc ? _react2.default.createElement('h3', {
                className: 'page-description',
                dangerouslySetInnerHTML: { __html: pgDesc }
              }) : ''
            ),
            _react2.default.createElement(_feature_feed2.default, {
              featuredFeed: this.props.tagFeaturedFeed,
              promoBanner: this.props.tagPromoBanner,
              scrollingModule: this.props.tagScrollingModule,
              combinedAdModel: combinedAdModel,
              config: config,
              page: 'tag',
              featuredSponsoredCard: this.props.featuredSponsoredCard
            }),
            (0, _get2.default)(this.props, 'tagFeaturedFeed.top').length >= 2 ? _react2.default.createElement(
              'div',
              { className: 'tag-page__ff-ad-container' },
              _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
              _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
            ) : '',
            _react2.default.createElement(_video_module2.default, {
              config: config,
              type: 'tag',
              data: this.props.tagVideo,
              playerid: 'HliaKwd3',
              stories: this.props.tagVideo.playlist
            }),
            (0, _get2.default)(this.props, 'tagFeaturedFeed.top').length ? _react2.default.createElement(
              'div',
              { className: 'tag-page__ff-ad-container' },
              _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
              _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
            ) : '',
            _react2.default.createElement(_all_feed2.default, {
              adModel: combinedAdModel,
              stories: (0, _get2.default)(this.props, 'tagAllFeed.posts'),
              allRendered: (0, _get2.default)(this.props, 'tagAllFeed.allRendered'),
              updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
              config: config,
              paginationEnabled: true,
              page: Number((0, _get2.default)(this.props, 'match.params.page', '1')) + 1,
              section: (0, _get2.default)(this.props, 'match.params.tag'),
              type: 'section',
              isLastPage: isLastPage,
              titleOverride: 'All ' + pgName + ' Stories'
            })
          ),
          (0, _get2.default)(this.props, 'tagVideo.playlist').length ? _react2.default.createElement(
            'div',
            { className: 'tag-page__video-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_3' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
          ) : ''
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'tag-page' },
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, { slugName: pgName, className: 'tag-page' }),
          pgDesc ? _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          ) : ''
        ),
        _react2.default.createElement(_all_feed2.default, {
          hasSlug: false,
          adModel: combinedAdModel,
          stories: (0, _get2.default)(this.props, 'tagAllFeed.posts'),
          allRendered: (0, _get2.default)(this.props, 'tagAllFeed.allRendered'),
          updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
          config: config,
          paginationEnabled: true,
          page: Number((0, _get2.default)(this.props, 'match.params.page', '1')) + 1,
          section: (0, _get2.default)(this.props, 'match.params.tag'),
          type: 'section',
          isLastPage: isLastPage
        }),
        this.props.tagAllFeed.posts.length ? _react2.default.createElement(
          'div',
          { className: 'tag-page__all-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
        ) : ''
      );
    }
  }]);

  return Tag;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    featuredSponsoredCard: (0, _get2.default)(state, 'featuredSponsoredCard.data') || {},
    tagFeaturedFeed: {
      featured: (0, _get2.default)(state, 'tagFeaturedFeed.featured') || [],
      top: (0, _get2.default)(state, 'tagFeaturedFeed.top') || [],
      tag: (0, _get2.default)(state, 'tagFeaturedFeed.tag') || {},
      source: (0, _get2.default)(state, 'tagFeaturedFeed.source') || '',
      error: (0, _get2.default)(state, 'tagFeaturedFeed.error') || false
    },
    tagVideo: (0, _get2.default)(state, 'tagVideo.data') || {
      playlist: [],
      title: '',
      feedid: ''
    },
    tagPage: (0, _get2.default)(state, 'tagPage') || { error: true },
    tagScrollingModule: (0, _get2.default)(state, 'tagScrollingModule.data') || {},
    tagPromoBanner: (0, _get2.default)(state, 'tagPromoBanner.data') || {},
    tagAllFeed: {
      totalPosts: (0, _get2.default)(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: (0, _get2.default)(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: (0, _get2.default)(state, 'tagAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'tagAllFeed.data.posts', [])
      // scrollingModule: get(state, 'scrollingModule.data.posts') || []
    } };
}

Tag.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  tagPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  tagFeaturedFeed: _propTypes2.default.shape({
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    tag: _propTypes2.default.object,
    source: _propTypes2.default.string,
    error: _propTypes2.default.bool
  }).isRequired,
  tagVideo: _propTypes2.default.shape({
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    feedid: _propTypes2.default.string,
    title: _propTypes2.default.string
  }).isRequired,
  tagScrollingModule: _propTypes2.default.shape({}).isRequired,
  tagPromoBanner: _propTypes2.default.shape({}).isRequired,
  featuredSponsoredCard: _propTypes2.default.shape({}).isRequired,
  tagAllFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool,
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number
  }).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Tag));

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(32);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _scroll_to_el_util = __webpack_require__(79);

var _scroll_to_el_util2 = _interopRequireDefault(_scroll_to_el_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FranchiseIndexSection = function (_Component) {
  _inherits(FranchiseIndexSection, _Component);

  function FranchiseIndexSection(props) {
    _classCallCheck(this, FranchiseIndexSection);

    var _this = _possibleConstructorReturn(this, (FranchiseIndexSection.__proto__ || Object.getPrototypeOf(FranchiseIndexSection)).call(this, props));

    _this.screenLarge = true;
    return _this;
  }

  _createClass(FranchiseIndexSection, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _scroll_to_el_util2.default)('.franchise-accordion-section--' + this.props.activeSection, 100);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          combinedAdModel = _props.combinedAdModel,
          index = _props.index,
          data = _props.data,
          nextPage = _props.nextPage,
          prevPage = _props.prevPage,
          activeSection = _props.activeSection,
          propertyToDisplay = _props.propertyToDisplay,
          pathForSection = _props.pathForSection,
          pathForData = _props.pathForData;


      var nextStyle = {
        minHeight: 473
      };

      var dataList = (0, _get2.default)(data, 'rows') ? data.rows : null;
      var dataListSections = [];

      if (dataList && dataList.length) {
        var i = 0;
        var chunk = 10;
        for (i; i < dataList.length; i += chunk) {
          dataListSections.push(dataList.slice(i, i + chunk));
        }
      }
      return _react2.default.createElement(
        'section',
        {
          className: 'franchise-accordion-section franchise-accordion-section--' + index,
          style: activeSection === index && this.screenLarge ? nextStyle : {}
        },
        _react2.default.createElement(
          _reactRouterDom.Link,
          {
            to: activeSection === index ? '/' + pathForSection : '/' + pathForSection + '/' + index + '/1',
            className: 'franchise-accordion-section__title-row franchise-accordion-section__title-row--' + index,
            title: index
          },
          _react2.default.createElement(
            'h2',
            { className: 'franchise-accordion-section__title' },
            index
          ),
          _react2.default.createElement('img', {
            className: 'franchise-accordion-section__title-icon\n              ' + (activeSection === index ? ' franchise-accordion-section__title-icon--active' : ''),
            src: '//images.fastcompany.net/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg',
            alt: 'arrow icon',
            title: 'arrow icon'
          })
        ),
        dataListSections.length && activeSection === index ? _react2.default.createElement(
          'div',
          { className: 'franchise-accordion-section__list-container' },
          prevPage && this.screenLarge ? _react2.default.createElement(
            'div',
            { className: 'franchise-accordion-section__prev-paddle' },
            _react2.default.createElement(
              _reactRouterDom.Link,
              {
                to: '/' + pathForSection + '/' + index + '/' + prevPage,
                title: 'Previous'
              },
              _react2.default.createElement('div', { className: 'franchise-accordion-section__prev-icon' })
            )
          ) : '',
          _react2.default.createElement(
            'div',
            { className: 'franchise-accordion-section__list' },
            dataListSections.map(function (section) {
              return _react2.default.createElement(
                'div',
                {
                  key: '' + section[0][propertyToDisplay],
                  className: 'franchise-accordion-section__list-column'
                },
                section.map(function (datum) {
                  return _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                      to: '/' + pathForData + '/' + datum.url,
                      key: datum[propertyToDisplay],
                      title: datum[propertyToDisplay]
                    },
                    datum[propertyToDisplay]
                  );
                })
              );
            }),
            !this.screenLarge && (prevPage || nextPage) ? _react2.default.createElement(
              'ul',
              { className: 'pagination franchise-accordion-section__pagination' },
              _react2.default.createElement(
                'li',
                {
                  className: 'pagination__page pagination__page--prev' + (!prevPage ? ' franchise-accordion-section__pagination-page--inactive' : '')
                },
                prevPage ? _react2.default.createElement(
                  _reactRouterDom.Link,
                  {
                    to: '/' + pathForSection + '/' + index + '/' + prevPage,
                    title: 'Previous'
                  },
                  'Prev'
                ) : _react2.default.createElement(
                  'span',
                  { className: 'pagination__link' },
                  'Prev'
                )
              ),
              _react2.default.createElement(
                'li',
                {
                  className: 'pagination__page pagination__page--next' + (!nextPage ? ' franchise-accordion-section__pagination-page--inactive' : '')
                },
                nextPage ? _react2.default.createElement(
                  _reactRouterDom.Link,
                  {
                    to: '/' + pathForSection + '/' + index + '/' + nextPage,
                    title: 'Next'
                  },
                  'Next'
                ) : _react2.default.createElement(
                  'span',
                  { className: 'pagination__link' },
                  'Next'
                )
              )
            ) : ''
          ),
          nextPage && this.screenLarge ? _react2.default.createElement(
            'div',
            { className: 'franchise-accordion-section__next-paddle' },
            _react2.default.createElement(
              _reactRouterDom.Link,
              {
                to: '/' + pathForSection + '/' + index + '/' + nextPage,
                title: 'Next'
              },
              _react2.default.createElement('div', { className: 'franchise-accordion-section__next-icon' })
            )
          ) : ''
        ) : '',
        index === 'j' || index === 'z' ? _react2.default.createElement(
          'div',
          { className: 'franchise-accordion-section__ff-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: 'mobileparallax_1' }))
        ) : ''
      );
    }
  }]);

  return FranchiseIndexSection;
}(_react.Component);

exports.default = FranchiseIndexSection;


FranchiseIndexSection.defaultProps = {
  nextPage: '',
  prevPage: '',
  activeSection: '',
  propertyToDisplay: '',
  pathForSection: '',
  pathForData: ''
};

FranchiseIndexSection.propTypes = {
  data: _propTypes2.default.shape({}).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  index: _propTypes2.default.string.isRequired,
  nextPage: _propTypes2.default.string,
  prevPage: _propTypes2.default.string,
  activeSection: _propTypes2.default.string,
  propertyToDisplay: _propTypes2.default.string,
  pathForSection: _propTypes2.default.string,
  pathForData: _propTypes2.default.string
};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _social = __webpack_require__(52);

var _social2 = _interopRequireDefault(_social);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FranchiseIntro = function (_Component) {
  _inherits(FranchiseIntro, _Component);

  function FranchiseIntro(props) {
    _classCallCheck(this, FranchiseIntro);

    var _this = _possibleConstructorReturn(this, (FranchiseIntro.__proto__ || Object.getPrototypeOf(FranchiseIntro)).call(this, props));

    _this.state = { introText: _this.props.desc };
    return _this;
  }

  _createClass(FranchiseIntro, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // PATCH: React 16 is not rehydrating correctly the dangerouslySetInnerHTML html. It seems like there is
      // a difference between the client and server value and the text is removed in the client side.
      // Probably related to this: https://github.com/facebook/react/issues/10993
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ introText: this.props.desc + '<noscript></noscript>' });
    }
  }, {
    key: 'render',
    value: function render() {
      var isGiftGuide = this.props.giftGuide;
      var imageCol = isGiftGuide ? 6 : 4;
      var descCol = isGiftGuide ? 4 : 6;
      return _react2.default.createElement(
        'div',
        { className: 'franchise-intro' },
        _react2.default.createElement(_social2.default, this.props.social),
        _react2.default.createElement(
          'div',
          { className: 'franchise-intro__col--' + imageCol },
          _react2.default.createElement('img', { src: this.props.poster, alt: this.props.title })
        ),
        _react2.default.createElement(
          'div',
          { className: 'franchise-intro__col--' + descCol },
          _react2.default.createElement(
            'h1',
            { className: 'franchise-intro__title' },
            this.props.title
          ),
          _react2.default.createElement('p', {
            className: 'franchise-intro__desc',
            dangerouslySetInnerHTML: { __html: this.state.introText }
          })
        )
      );
    }
  }]);

  return FranchiseIntro;
}(_react.Component);

FranchiseIntro.defaultProps = {
  poster: '',
  title: '',
  desc: '',
  social: {},
  giftGuide: false
};

FranchiseIntro.propTypes = {
  poster: _propTypes2.default.string,
  title: _propTypes2.default.string,
  desc: _propTypes2.default.string,
  social: _propTypes2.default.shape({}),
  giftGuide: _propTypes2.default.bool
};

exports.default = FranchiseIntro;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(106);

var _PathUtils = __webpack_require__(69);

var _createTransitionManager = __webpack_require__(107);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(301)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObject = __webpack_require__(38);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(90);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(3);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/warning/browser.js
var browser = __webpack_require__(23);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var invariant_browser = __webpack_require__(25);
var invariant_browser_default = /*#__PURE__*/__webpack_require__.n(invariant_browser);

// EXTERNAL MODULE: ./node_modules/resolve-pathname/index.js
var resolve_pathname = __webpack_require__(155);

// EXTERNAL MODULE: ./node_modules/value-equal/index.js
var value_equal = __webpack_require__(156);

// CONCATENATED MODULE: ./node_modules/history/es/PathUtils.js
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};
// CONCATENATED MODULE: ./node_modules/history/es/LocationUtils.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var LocationUtils_createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(resolve_pathname["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var LocationUtils_locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(value_equal["default"])(a.state, b.state);
};
// CONCATENATED MODULE: ./node_modules/history/es/createTransitionManager.js


var createTransitionManager_createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    browser_default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          browser_default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ var es_createTransitionManager = (createTransitionManager_createTransitionManager);
// CONCATENATED MODULE: ./node_modules/history/es/DOMUtils.js
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};
// CONCATENATED MODULE: ./node_modules/history/es/createBrowserHistory.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var createBrowserHistory__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory_createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  invariant_browser_default()(canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    browser_default()(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = stripBasename(path, basename);

    return LocationUtils_createLocation(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = es_createTransitionManager();

  var setState = function setState(nextState) {
    createBrowserHistory__extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + createPath(location);
  };

  var push = function push(path, state) {
    browser_default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = LocationUtils_createLocation(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        browser_default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    browser_default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = LocationUtils_createLocation(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        browser_default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      addEventListener(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) addEventListener(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      removeEventListener(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) removeEventListener(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ var es_createBrowserHistory = (createBrowserHistory_createBrowserHistory);
// CONCATENATED MODULE: ./node_modules/history/es/createHashHistory.js
var createHashHistory__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var createHashHistory_HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory_createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  invariant_browser_default()(canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    browser_default()(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = stripBasename(path, basename);

    return LocationUtils_createLocation(path);
  };

  var transitionManager = es_createTransitionManager();

  var setState = function setState(nextState) {
    createHashHistory__extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && LocationUtils_locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  };

  var push = function push(path, state) {
    browser_default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = LocationUtils_createLocation(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        browser_default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    browser_default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = LocationUtils_createLocation(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    browser_default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      addEventListener(window, createHashHistory_HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      removeEventListener(window, createHashHistory_HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ var es_createHashHistory = (createHashHistory_createHashHistory);
// CONCATENATED MODULE: ./node_modules/history/es/createMemoryHistory.js
var createMemoryHistory__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var createMemoryHistory__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory_createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = es_createTransitionManager();

  var setState = function setState(nextState) {
    createMemoryHistory__extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? LocationUtils_createLocation(entry, undefined, createKey()) : LocationUtils_createLocation(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = createPath;

  var push = function push(path, state) {
    browser_default()(!((typeof path === 'undefined' ? 'undefined' : createMemoryHistory__typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = LocationUtils_createLocation(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    browser_default()(!((typeof path === 'undefined' ? 'undefined' : createMemoryHistory__typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = LocationUtils_createLocation(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ var es_createMemoryHistory = (createMemoryHistory_createMemoryHistory);
// CONCATENATED MODULE: ./node_modules/history/es/index.js









// CONCATENATED MODULE: ./node_modules/react-router/es/Redirect.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect_Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    invariant_browser_default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = LocationUtils_createLocation(prevProps.to);
    var nextTo = LocationUtils_createLocation(this.props.to);

    if (LocationUtils_locationsAreEqual(prevTo, nextTo)) {
      browser_default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(react_default.a.Component);

Redirect_Redirect.propTypes = {
  push: prop_types_default.a.bool,
  from: prop_types_default.a.string,
  to: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]).isRequired
};
Redirect_Redirect.defaultProps = {
  push: false
};
Redirect_Redirect.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired
    }).isRequired,
    staticContext: prop_types_default.a.object
  }).isRequired
};


/* harmony default export */ var es_Redirect = __webpack_exports__["a"] = (Redirect_Redirect);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(90);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(91);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(117);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRoutesWithStore;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _web_layout = __webpack_require__(342);

var _web_layout2 = _interopRequireDefault(_web_layout);

var _homepage_route = __webpack_require__(452);

var _homepage_route2 = _interopRequireDefault(_homepage_route);

var _homepage_all_route = __webpack_require__(531);

var _homepage_all_route2 = _interopRequireDefault(_homepage_all_route);

var _homepage_all_index_route = __webpack_require__(532);

var _homepage_all_index_route2 = _interopRequireDefault(_homepage_all_index_route);

var _author_route = __webpack_require__(533);

var _author_route2 = _interopRequireDefault(_author_route);

var _author_paginated_route = __webpack_require__(541);

var _author_paginated_route2 = _interopRequireDefault(_author_paginated_route);

var _category_route = __webpack_require__(542);

var _category_route2 = _interopRequireDefault(_category_route);

var _category_paginated_route = __webpack_require__(559);

var _category_paginated_route2 = _interopRequireDefault(_category_paginated_route);

var _news_category_route = __webpack_require__(560);

var _news_category_route2 = _interopRequireDefault(_news_category_route);

var _news_category_paginated_route = __webpack_require__(623);

var _news_category_paginated_route2 = _interopRequireDefault(_news_category_paginated_route);

var _magazine_category_route = __webpack_require__(624);

var _magazine_category_route2 = _interopRequireDefault(_magazine_category_route);

var _community_route = __webpack_require__(626);

var _community_route2 = _interopRequireDefault(_community_route);

var _html_sitemap_index_route = __webpack_require__(628);

var _html_sitemap_index_route2 = _interopRequireDefault(_html_sitemap_index_route);

var _html_sitemap_year_route = __webpack_require__(634);

var _html_sitemap_year_route2 = _interopRequireDefault(_html_sitemap_year_route);

var _html_sitemap_post_route = __webpack_require__(635);

var _html_sitemap_post_route2 = _interopRequireDefault(_html_sitemap_post_route);

var _about_us_route = __webpack_require__(646);

var _about_us_route2 = _interopRequireDefault(_about_us_route);

var _innovation_by_design_awards_wp_page_route = __webpack_require__(652);

var _innovation_by_design_awards_wp_page_route2 = _interopRequireDefault(_innovation_by_design_awards_wp_page_route);

var _apply_route = __webpack_require__(653);

var _apply_route2 = _interopRequireDefault(_apply_route);

var _contact_us_route = __webpack_require__(654);

var _contact_us_route2 = _interopRequireDefault(_contact_us_route);

var _privacy_policy_route = __webpack_require__(655);

var _privacy_policy_route2 = _interopRequireDefault(_privacy_policy_route);

var _staff_masthead_route = __webpack_require__(656);

var _staff_masthead_route2 = _interopRequireDefault(_staff_masthead_route);

var _terms_route = __webpack_require__(657);

var _terms_route2 = _interopRequireDefault(_terms_route);

var _search_route = __webpack_require__(658);

var _search_route2 = _interopRequireDefault(_search_route);

var _search_query_route = __webpack_require__(664);

var _search_query_route2 = _interopRequireDefault(_search_query_route);

var _search_paginated_route = __webpack_require__(665);

var _search_paginated_route2 = _interopRequireDefault(_search_paginated_route);

var _tag_page_route = __webpack_require__(666);

var _tag_page_route2 = _interopRequireDefault(_tag_page_route);

var _tag_page_paginated_route = __webpack_require__(685);

var _tag_page_paginated_route2 = _interopRequireDefault(_tag_page_paginated_route);

var _living_smarter_tag_page_route = __webpack_require__(686);

var _living_smarter_tag_page_route2 = _interopRequireDefault(_living_smarter_tag_page_route);

var _urban_x_tag_page_route = __webpack_require__(688);

var _urban_x_tag_page_route2 = _interopRequireDefault(_urban_x_tag_page_route);

var _magazine_tag_page_route = __webpack_require__(690);

var _magazine_tag_page_route2 = _interopRequireDefault(_magazine_tag_page_route);

var _product_route = __webpack_require__(692);

var _product_route2 = _interopRequireDefault(_product_route);

var _product_index_section_route = __webpack_require__(700);

var _product_index_section_route2 = _interopRequireDefault(_product_index_section_route);

var _product_index_route = __webpack_require__(710);

var _product_index_route2 = _interopRequireDefault(_product_index_route);

var _person_index_route = __webpack_require__(714);

var _person_index_route2 = _interopRequireDefault(_person_index_route);

var _person_index_paginated_route = __webpack_require__(723);

var _person_index_paginated_route2 = _interopRequireDefault(_person_index_paginated_route);

var _ibd_route = __webpack_require__(724);

var _ibd_route2 = _interopRequireDefault(_ibd_route);

var _ibd_category_route = __webpack_require__(734);

var _ibd_category_route2 = _interopRequireDefault(_ibd_category_route);

var _mcp_community_route = __webpack_require__(735);

var _mcp_community_route2 = _interopRequireDefault(_mcp_community_route);

var _mcp_community_paginated_route = __webpack_require__(745);

var _mcp_community_paginated_route2 = _interopRequireDefault(_mcp_community_paginated_route);

var _most_creative_people_route = __webpack_require__(746);

var _most_creative_people_route2 = _interopRequireDefault(_most_creative_people_route);

var _company_route = __webpack_require__(761);

var _company_route2 = _interopRequireDefault(_company_route);

var _company_index_route = __webpack_require__(775);

var _company_index_route2 = _interopRequireDefault(_company_index_route);

var _mic_year_route = __webpack_require__(784);

var _mic_year_route2 = _interopRequireDefault(_mic_year_route);

var _mic_year_sector_route = __webpack_require__(795);

var _mic_year_sector_route2 = _interopRequireDefault(_mic_year_sector_route);

var _person_route = __webpack_require__(799);

var _person_route2 = _interopRequireDefault(_person_route);

var _company_index_paginated_route = __webpack_require__(807);

var _company_index_paginated_route2 = _interopRequireDefault(_company_index_paginated_route);

var _post_route = __webpack_require__(808);

var _post_route2 = _interopRequireDefault(_post_route);

var _post_section_route = __webpack_require__(828);

var _post_section_route2 = _interopRequireDefault(_post_section_route);

var _post_paginated_slideshow_route = __webpack_require__(829);

var _post_paginated_slideshow_route2 = _interopRequireDefault(_post_paginated_slideshow_route);

var _post_preview_route = __webpack_require__(830);

var _post_preview_route2 = _interopRequireDefault(_post_preview_route);

var _post_preview_section_route = __webpack_require__(831);

var _post_preview_section_route2 = _interopRequireDefault(_post_preview_section_route);

var _not_found_route = __webpack_require__(832);

var _not_found_route2 = _interopRequireDefault(_not_found_route);

var _video_route = __webpack_require__(837);

var _video_route2 = _interopRequireDefault(_video_route);

var _video_playlist_index_route = __webpack_require__(850);

var _video_playlist_index_route2 = _interopRequireDefault(_video_playlist_index_route);

var _video_index_route = __webpack_require__(857);

var _video_index_route2 = _interopRequireDefault(_video_index_route);

var _video_playlist_page_route = __webpack_require__(862);

var _video_playlist_page_route2 = _interopRequireDefault(_video_playlist_page_route);

var _newsletters_route = __webpack_require__(869);

var _newsletters_route2 = _interopRequireDefault(_newsletters_route);

var _newsletters_preferences_page_route = __webpack_require__(890);

var _newsletters_preferences_page_route2 = _interopRequireDefault(_newsletters_preferences_page_route);

var _category_tag_route = __webpack_require__(895);

var _category_tag_route2 = _interopRequireDefault(_category_tag_route);

var _gift_guide_route = __webpack_require__(896);

var _gift_guide_route2 = _interopRequireDefault(_gift_guide_route);

var _gift_guide_category_route = __webpack_require__(905);

var _gift_guide_category_route2 = _interopRequireDefault(_gift_guide_category_route);

var _gift_route = __webpack_require__(906);

var _gift_route2 = _interopRequireDefault(_gift_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getRoutesWithStore(store) {
  var state = store.getState();
  var routeConfig = [{
    component: _web_layout2.default,
    routes: [].concat(_toConsumableArray((0, _category_tag_route2.default)(store)), [(0, _video_route2.default)(store), (0, _video_index_route2.default)(store), (0, _video_playlist_index_route2.default)(store), (0, _video_playlist_page_route2.default)(store), (0, _homepage_all_index_route2.default)(store), (0, _homepage_all_route2.default)(store), (0, _community_route2.default)(store), (0, _about_us_route2.default)(store), (0, _apply_route2.default)(store), (0, _newsletters_route2.default)(store), (0, _contact_us_route2.default)(store), (0, _staff_masthead_route2.default)(store), (0, _privacy_policy_route2.default)(store), (0, _terms_route2.default)(store), (0, _search_paginated_route2.default)(store), (0, _search_query_route2.default)(store), (0, _search_route2.default)(store), (0, _html_sitemap_index_route2.default)(store), (0, _html_sitemap_year_route2.default)(store), (0, _html_sitemap_post_route2.default)(store), (0, _living_smarter_tag_page_route2.default)(store), (0, _urban_x_tag_page_route2.default)(store), (0, _tag_page_route2.default)(store), (0, _tag_page_paginated_route2.default)(store)], _toConsumableArray((0, _magazine_tag_page_route2.default)(store)), [(0, _product_index_route2.default)(store), (0, _product_index_section_route2.default)(store), (0, _product_route2.default)(store), (0, _ibd_category_route2.default)(store), (0, _ibd_route2.default)(store), (0, _gift_guide_route2.default)(store), (0, _gift_guide_category_route2.default)(store), (0, _gift_route2.default)(store), (0, _person_index_route2.default)(store), (0, _person_index_paginated_route2.default)(store), (0, _mcp_community_route2.default)(store), (0, _mcp_community_paginated_route2.default)(store), (0, _innovation_by_design_awards_wp_page_route2.default)(store), (0, _person_route2.default)(store), (0, _most_creative_people_route2.default)(store), (0, _company_route2.default)(store), (0, _company_index_route2.default)(store), (0, _company_index_paginated_route2.default)(store), (0, _mic_year_sector_route2.default)(store), (0, _mic_year_route2.default)(store), (0, _author_route2.default)(store), (0, _author_paginated_route2.default)(store), (0, _post_preview_route2.default)(store), (0, _post_preview_section_route2.default)(store), (0, _news_category_paginated_route2.default)(store), (0, _magazine_category_route2.default)(store), (0, _news_category_route2.default)(store), (0, _category_paginated_route2.default)(store), (0, _category_route2.default)(store), (0, _post_route2.default)(store), (0, _post_section_route2.default)(store), (0, _post_paginated_slideshow_route2.default)(store), (0, _homepage_route2.default)(store), (0, _not_found_route2.default)(store)])
  }];

  if ((0, _get2.default)(state, 'config.featureFlags.newsletterPreferencesPageEnabled')) {
    routeConfig[0].routes.unshift((0, _newsletters_preferences_page_route2.default)(store));
  }

  return routeConfig;
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(170);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(172),
    isIterateeCall = __webpack_require__(175);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(94),
    overRest = __webpack_require__(173),
    setToString = __webpack_require__(174);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(344);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(345),
    shortOut = __webpack_require__(347);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(88),
    isArrayLike = __webpack_require__(41),
    isIndex = __webpack_require__(72),
    isObject = __webpack_require__(38);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(348),
    isArguments = __webpack_require__(95),
    isArray = __webpack_require__(29),
    isBuffer = __webpack_require__(96),
    isIndex = __webpack_require__(72),
    isTypedArray = __webpack_require__(121);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(73),
    nativeKeys = __webpack_require__(362);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(125),
    getPrototype = __webpack_require__(126),
    getSymbols = __webpack_require__(124),
    stubArray = __webpack_require__(180);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(183),
    getSymbols = __webpack_require__(124),
    keys = __webpack_require__(50);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(125),
    isArray = __webpack_require__(29);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(183),
    getSymbolsIn = __webpack_require__(181),
    keysIn = __webpack_require__(120);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(385);
var isArguments = __webpack_require__(386);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 190 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Events = {
    READY: "ready",
    RENDER: "render",
    SLOT_RENDER_ENDED: "slotRenderEnded",
    IMPRESSION_VIEWABLE: "impressionViewable",
    SLOT_VISIBILITY_CHANGED: "slotVisibilityChanged"
};

exports.default = Events;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   noTrailing     Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   debounceMode   If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
module.exports = function ( delay, noTrailing, callback, debounceMode ) {

	// After wrapper has stopped being called, this timeout ensures that
	// `callback` is executed at the proper times in `throttle` and `end`
	// debounce modes.
	var timeoutID;

	// Keep track of the last time `callback` was executed.
	var lastExec = 0;

	// `noTrailing` defaults to falsy.
	if ( typeof noTrailing !== 'boolean' ) {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	// The `wrapper` function encapsulates all of the throttling / debouncing
	// functionality and when executed will limit the rate at which `callback`
	// is executed.
	function wrapper () {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		// Execute `callback` and update the `lastExec` timestamp.
		function exec () {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		// If `debounceMode` is true (at begin) this is used to clear the flag
		// to allow future `callback` executions.
		function clear () {
			timeoutID = undefined;
		}

		if ( debounceMode && !timeoutID ) {
			// Since `wrapper` is being called for the first time and
			// `debounceMode` is true (at begin), execute `callback`.
			exec();
		}

		// Clear any existing timeout.
		if ( timeoutID ) {
			clearTimeout(timeoutID);
		}

		if ( debounceMode === undefined && elapsed > delay ) {
			// In throttle mode, if `delay` time has been exceeded, execute
			// `callback`.
			exec();

		} else if ( noTrailing !== true ) {
			// In trailing throttle mode, since `delay` time has not been
			// exceeded, schedule `callback` to execute `delay` ms after most
			// recent execution.
			//
			// If `debounceMode` is true (at begin), schedule `clear` to execute
			// after `delay` ms.
			//
			// If `debounceMode` is false (at end), schedule `callback` to
			// execute after `delay` ms.
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}

	}

	// Return the wrapper function.
	return wrapper;

};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(125),
    isFlattenable = __webpack_require__(394);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(113),
    setCacheAdd = __webpack_require__(395),
    setCacheHas = __webpack_require__(396);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryParameterByName;
exports.correctSubDomain = correctSubDomain;
exports.resolveHost = resolveHost;

var _exenv = __webpack_require__(4);

var _urlParse = __webpack_require__(45);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getQueryParameterByName(queryName) {
  if (_exenv.canUseDOM) {
    var name = queryName;
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(window.location.href);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  return null;
}

function correctSubDomain(url) {
  if (url && url.indexOf('https://www.') === -1 && typeof url === 'string') {
    return url.replace('https://', 'https://www.');
  }

  return url;
}

function resolveHost(url) {
  if (!url) {
    // todo: log error
    return '';
  }

  if (/\/wp.fastcompany.com\/fastcodesign/.test(url)) {
    return 'fastcodesign.com';
  }

  if (/\/wp.fastcompany.com\/fastcocreate/.test(url)) {
    return 'fastcocreate.com';
  }

  if (/\/wp.fastcompany.com\/fastcoexist/.test(url)) {
    return 'fastcoexist.com';
  }

  var _parse = (0, _urlParse2.default)(url, true),
      host = _parse.host;

  if (host === 'wp.fastcompany.com') {
    return 'fastcompany.com';
  }

  return host;
}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(411),
    createBaseEach = __webpack_require__(414);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(115),
    upperFirst = __webpack_require__(420);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Merge content body together, it is used for post content field
function mergeContent(content) {
  var html = '';

  content.forEach(function (markup) {
    html += markup.join('');
  });

  return html;
}

exports.default = mergeContent;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouterRedux = __webpack_require__(61);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function (_Component) {
  _inherits(Search, _Component);

  function Search() {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this));

    _this.handleSearchSubmit = _this.handleSearchSubmit.bind(_this);
    _this.clearSearch = _this.clearSearch.bind(_this);
    return _this;
  }

  _createClass(Search, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.active !== nextProps.active;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.active) {
        this.q.focus();
      }
    }
  }, {
    key: 'setFormClasses',
    value: function setFormClasses() {
      var _props = this.props,
          active = _props.active,
          modifier = _props.modifier,
          skin = _props.skin,
          modal = _props.modal;

      var baseClass = 'search-form';
      var classNames = baseClass + ' ' + baseClass + '--' + skin;

      if (modal) {
        classNames += ' ' + baseClass + '--modal';
      }

      if (modifier) {
        classNames += ' ' + baseClass + '--' + modifier;
      }

      if (active) {
        classNames += ' ' + baseClass + '--active';
      }

      return classNames;
    }
  }, {
    key: 'handleSearchSubmit',
    value: function handleSearchSubmit(event) {
      event.preventDefault();

      var _props2 = this.props,
          modal = _props2.modal,
          closeModal = _props2.closeModal;


      if (modal && closeModal) {
        closeModal(false);
      }

      this.props.search('/search/' + this.q.value);
      this.clearSearch(event);
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch(event) {
      var input = this.q;

      var action = event && event.type === 'click' ? 'focus' : 'blur';
      var delay = event && event.type === 'submit' ? 200 : 0;

      setTimeout(function () {
        input.value = '';
      }, delay);

      input[action]();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var modal = this.props.modal;


      return _react2.default.createElement(
        'form',
        {
          className: this.setFormClasses(),
          onSubmit: this.handleSearchSubmit
        },
        _react2.default.createElement(
          'div',
          {
            className: 'search-form__wrapper ' + (modal ? 'search-form__wrapper--modal' : '')
          },
          _react2.default.createElement('input', {
            name: 'q',
            className: 'search-form__input  ' + (modal ? 'search-form__input--modal' : 'search-form__input--in-page'),
            defaultValue: (0, _get2.default)(this.props, 'searchTerm'),
            placeholder: 'Search',
            type: 'text',
            ref: function ref(input) {
              _this2.q = input;
            }
          }),
          _react2.default.createElement('button', {
            type: 'button',
            className: 'search-form__clear-input icon-close',
            onClick: this.clearSearch
          })
        )
      );
    }
  }]);

  return Search;
}(_react.Component);

Search.defaultProps = {
  modifier: '',
  active: false,
  modal: false,
  closeModal: function closeModal() {}
};

Search.propTypes = {
  skin: _propTypes2.default.string.isRequired,
  modifier: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  modal: _propTypes2.default.bool,
  closeModal: _propTypes2.default.func,
  search: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return {
    search: function search(location) {
      dispatch((0, _reactRouterRedux.push)(location));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isString = __webpack_require__(98);

var _isString2 = _interopRequireDefault(_isString);

var _cloudinary_asset_util = __webpack_require__(30);

var _image = __webpack_require__(76);

var _image2 = _interopRequireDefault(_image);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GifConverter = function (_Component) {
  _inherits(GifConverter, _Component);

  function GifConverter() {
    _classCallCheck(this, GifConverter);

    var _this = _possibleConstructorReturn(this, (GifConverter.__proto__ || Object.getPrototypeOf(GifConverter)).call(this));

    _this.state = {
      renderVideo: false
    };
    return _this;
  }

  _createClass(GifConverter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          assetSizes = _props.assetSizes,
          src = _props.src;

      var isDesktop = (0, _client_util2.default)();
      var secureSrc = (0, _cloudinary_asset_util.makeHttps)(src);
      var fcDomainAsset = (0, _cloudinary_asset_util.changeAssetDomain)(secureSrc);
      var assetsWithPresets = (0, _cloudinary_asset_util.buildAssetUrlWithPresets)(fcDomainAsset, assetSizes, isDesktop);
      this.formats = (0, _cloudinary_asset_util.convertGIFToVideoAssets)(assetsWithPresets);

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ renderVideo: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          alt = _props2.alt,
          src = _props2.src,
          assetSizes = _props2.assetSizes;

      var videoFormats = this.formats;
      var tag = _react2.default.createElement(_image2.default, {
        alt: alt,
        src: (0, _isString2.default)(src) ? src.replace(/.gif$/, '.jpg') : null,
        assetSizes: assetSizes
      });

      if (this.state.renderVideo) {
        /* eslint-disable jsx-a11y/media-has-caption */
        tag = _react2.default.createElement(
          'video',
          {
            className: 'video',
            poster: (0, _get2.default)(videoFormats, 'jpg'),
            playsInline: true,
            loop: true,
            preload: true,
            autoPlay: true,
            muted: true
          },
          _react2.default.createElement('source', { type: 'video/webm', src: (0, _get2.default)(videoFormats, 'webm') }),
          _react2.default.createElement('source', { type: 'video/mp4', src: (0, _get2.default)(videoFormats, 'mp4') })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        tag
      );
    }
  }]);

  return GifConverter;
}(_react.Component);

GifConverter.defaultProps = {
  // noLazy: false,
  assetSizes: {}
};

GifConverter.propTypes = {
  alt: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string.isRequired,
  // noLazy: PropTypes.bool,
  assetSizes: _propTypes2.default.shape({
    large: _propTypes2.default.shape({
      sizes: _propTypes2.default.string,
      srcset: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    small: _propTypes2.default.shape({
      sizes: _propTypes2.default.string,
      srcset: _propTypes2.default.arrayOf(_propTypes2.default.string)
    })
  })
};

exports.default = GifConverter;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(116),
    baseClone = __webpack_require__(122),
    baseUnset = __webpack_require__(206),
    castPath = __webpack_require__(70),
    copyObject = __webpack_require__(49),
    customOmitClone = __webpack_require__(448),
    flatRest = __webpack_require__(450),
    getAllKeysIn = __webpack_require__(184);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(70),
    last = __webpack_require__(198),
    parent = __webpack_require__(447),
    toKey = __webpack_require__(60);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(122);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Script;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Script(_ref) {
  var innerHtml = _ref.innerHtml,
      type = _ref.type,
      src = _ref.src;

  if (innerHtml) {
    return _react2.default.createElement('script', { type: type, dangerouslySetInnerHTML: { __html: innerHtml } });
  }
  return _react2.default.createElement('script', { type: type, src: src });
}

Script.defaultProps = {
  innerHtml: '',
  src: ''
};

Script.propTypes = {
  innerHtml: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler) {
    var add = 'addEventListener';
    var _remove = 'removeEventListener';

    if (!target.addEventListener && target.attachEvent) {
        add = 'attachEvent';
        _remove = 'detachEvent';
        eventType = 'on' + eventType;
    }
    target[add](eventType, handler, false);

    return {
        remove: function remove() {
            target[_remove](eventType, handler);
        }
    };
}

module.exports = listen;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */


var leIE8 = false; // less then or equal to IE8

if (typeof navigator !== 'undefined') {
    var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
    if (matches) {
        leIE8 = parseFloat(matches[1], 10) < 9;
    }
}

module.exports = leIE8;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38),
    now = __webpack_require__(459),
    toNumber = __webpack_require__(100);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = {
  EVENT_END_DELAY: 100,
  DEFAULT_THROTTLE_RATE: 50
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupCenter = popupCenter;
exports.trackSocial = trackSocial;

var _exenv = __webpack_require__(4);

function popupCenter(event, url, w, h) {
  if (_exenv.canUseDOM) {
    event.preventDefault();

    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;
    var width = window.innerWidth;
    var height = window.innerHeight;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    // https://developer.mozilla.org/en-US/docs/Web/API/Window/open
    var newWindow = window.open(url, 'FC Share', 'scrollbars=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }
}

/**
 * Sends a social event to GA to track user share activity
 * @param {String} socialPlatform (Facebook, Twitter, etc)
 * @param {String} action (Share, Tweet, etc)
 */
function trackSocial(socialPlatform, action) {
  if (_exenv.canUseDOM && window.ga) {
    window.ga('send', 'social', socialPlatform, action, window.location.href);
    window.ga('rollup.send', 'social', socialPlatform, action, window.location.href);
  }
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);
var settle = __webpack_require__(471);
var buildURL = __webpack_require__(473);
var parseHeaders = __webpack_require__(474);
var isURLSameOrigin = __webpack_require__(475);
var createError = __webpack_require__(216);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(476);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(477);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(472);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _poster = __webpack_require__(62);

var _poster2 = _interopRequireDefault(_poster);

var _cloudinary_asset_util = __webpack_require__(30);

var _create_class_list_util = __webpack_require__(133);

var _newsletter_subscriber = __webpack_require__(220);

var _newsletter_subscriber2 = _interopRequireDefault(_newsletter_subscriber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsletterSignup = function (_NewsletterSubscriber) {
  _inherits(NewsletterSignup, _NewsletterSubscriber);

  function NewsletterSignup() {
    _classCallCheck(this, NewsletterSignup);

    return _possibleConstructorReturn(this, (NewsletterSignup.__proto__ || Object.getPrototypeOf(NewsletterSignup)).apply(this, arguments));
  }

  _createClass(NewsletterSignup, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var state = this.state;

      var hasError = nextState.error;
      var hasStatusChange = nextState.message !== state.message;
      var isLoading = nextState.disabled !== state.disabled;
      var hasEmailInputChange = nextState.email !== state.email;
      return hasError || hasStatusChange || isLoading || hasEmailInputChange;
    }
  }, {
    key: 'render',
    value: function render() {
      var assignedNewsletters = this.props.assignedNewsletters;

      var currentSite = this.props.config.site;
      var isPost = this.props.modifier === 'post';

      var newsletterTitle = (0, _get2.default)(this.props, 'title') || (0, _get2.default)(assignedNewsletters, '[0].listName') + ' Newsletter';
      var newsletterDeck = (0, _get2.default)(this.props, 'deck') ? ' ' + (0, _get2.default)(this.props, 'deck') : ' ' + (0, _get2.default)(assignedNewsletters, '[0].message');

      var metadata = {
        title: 'Newsletter Signup',
        featured_image: { source: this.props.poster },
        noLazy: true,
        assetSizes: _cloudinary_asset_util.imageSizesLookup[3]
      };

      return _react2.default.createElement(
        'form',
        {
          onSubmit: this.handleSubmit,
          className: 'newsletter-signup newsletter-signup--' + this.props.modifier
        },
        _react2.default.createElement(
          'div',
          { className: 'newsletter-signup__container' },
          this.props.poster ? _react2.default.createElement(_poster2.default, { metadata: metadata }) : '',
          _react2.default.createElement(
            'p',
            { className: 'newsletter-signup__copy' },
            _react2.default.createElement(
              'strong',
              {
                className: isPost ? (0, _create_class_list_util.setElementClass)('newsletter-signup', 'copy-title--post') : (0, _create_class_list_util.setElementClass)('newsletter-signup', 'copy-title--homepage')
              },
              newsletterTitle
            ),
            isPost ? '' : newsletterDeck
          ),
          _react2.default.createElement('input', {
            className: 'newsletter-signup__input\n              ' + (this.state.error ? 'newsletter-signup__input--error' : '') + '\n              ' + (this.state.status ? 'newsletter-signup__input--success' : '') + '\n              ' + (this.state.disabled ? 'newsletter-signup__input--loading' : '') + '\n              ',
            name: 'email',
            type: 'email',
            onChange: this.handleEmailUpdate,
            value: this.state.email,
            disabled: this.state.disabled,
            placeholder: (0, _get2.default)(this.statusMessages, [this.state.status]) || 'YOUR EMAIL ADDRESS'
          }),
          _react2.default.createElement(
            'button',
            {
              className: 'newsletter-signup__button ' + (isPost ? 'newsletter-signup__button--post' : '') + ' newsletter-signup__button--' + currentSite + '\n              ' + (this.state.disabled ? 'newsletter-signup__button--loading' : '') + '\n              ',
              disabled: this.state.disabled
            },
            'Sign Up'
          ),
          this.props.hideCheckBox || assignedNewsletters.length < 2 ? '' : _react2.default.createElement(
            'div',
            { className: 'newsletter-signup__checkbox-option' },
            _react2.default.createElement(
              'div',
              { className: 'newsletter-signup__checkbox-container' },
              _react2.default.createElement(
                'div',
                { className: 'newsletter-signup__checkbox-wrapper' },
                _react2.default.createElement('input', {
                  className: 'newsletter-signup__checkbox',
                  type: 'checkbox',
                  id: 'special-offers',
                  name: (0, _get2.default)(assignedNewsletters, '[1].listId'),
                  onChange: this.handleUpdate,
                  defaultChecked: true
                })
              ),
              _react2.default.createElement(
                'label',
                {
                  className: 'newsletter-signup__label',
                  htmlFor: 'special-offers'
                },
                (0, _get2.default)(assignedNewsletters, '[1].message')
              )
            ),
            _react2.default.createElement(
              'a',
              {
                href: '//www.fastcompany.com/newsletters',
                className: 'newsletter-signup__newsletter-page-link'
              },
              'See All Newsletters'
            )
          )
        )
      );
    }
  }]);

  return NewsletterSignup;
}(_newsletter_subscriber2.default);

NewsletterSignup.defaultProps = {
  modifier: '',
  poster: '',
  hideCheckBox: false
};

NewsletterSignup.propTypes = {
  modifier: _propTypes2.default.string,
  currentSite: _propTypes2.default.string.isRequired,
  assignedNewsletters: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  poster: _propTypes2.default.string,
  hideCheckBox: _propTypes2.default.bool
};

function mapStateToProps(state, ownProps) {
  var newslettersConfig = (0, _get2.default)(state, 'config.newsletters');
  var newslettersBySlug = (0, _get2.default)(newslettersConfig, 'listsBySlug');
  var newsletterDictionary = (0, _get2.default)(newslettersConfig, 'listsById');

  var assignedNewsletters = ownProps.newsletters;
  return {
    config: state.config,
    currentSite: state.config.site,
    assignedNewsletters: assignedNewsletters.map(function processAssignedNewsletters(newsletter) {
      var newsletterNameProp = newsletter.list;
      var listId = (0, _get2.default)(newslettersBySlug, newsletterNameProp);
      var found = newsletterDictionary[listId];
      return {
        listName: (0, _get2.default)(found, 'listName'),
        listId: listId,
        message: (0, _get2.default)(found, 'short')
      };
    })
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NewsletterSignup);

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _assign2 = __webpack_require__(31);

var _assign3 = _interopRequireDefault(_assign2);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _newsletter_module = __webpack_require__(221);

var _newsletter_module2 = _interopRequireDefault(_newsletter_module);

var _newsletter_ga_util = __webpack_require__(485);

var _newsletter_ga_util2 = _interopRequireDefault(_newsletter_ga_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsletterSubscriber = function (_Component) {
  _inherits(NewsletterSubscriber, _Component);

  function NewsletterSubscriber(props) {
    _classCallCheck(this, NewsletterSubscriber);

    var _this = _possibleConstructorReturn(this, (NewsletterSubscriber.__proto__ || Object.getPrototypeOf(NewsletterSubscriber)).call(this));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleUpdate = _this.handleUpdate.bind(_this);
    _this.handleEmailUpdate = _this.handleEmailUpdate.bind(_this);
    _this.handleVerify = _this.handleVerify.bind(_this);

    _this.statusMessages = {
      normal: "You're subscribed",
      error: 'There was an error.',
      loading: 'Loading'
    };

    var config = (0, _get2.default)(props, 'config');
    var allNewsletterData = (0, _get2.default)(config, 'newsletters.listsBySlug');
    var newslettersState = {};
    var newsletterIds = props.newsletterIds || [];
    props.newsletters.forEach(function mapPropsToState(newsletterObj) {
      var listPropName = (0, _get2.default)(newsletterObj, 'list');
      var listId = (0, _get2.default)(allNewsletterData, listPropName);

      newslettersState[listId] = !!newsletterObj.default;
    });

    // hack until i refactor this
    newsletterIds.forEach(function mapPropsToState(id) {
      newslettersState[id] = false;
    });
    _this.state = {
      email: '',
      newsletters: newslettersState
    };
    return _this;
  }

  _createClass(NewsletterSubscriber, [{
    key: 'handleUpdate',
    value: function handleUpdate(e) {
      var target = e.target;
      var value = target.value,
          name = target.name;

      var newNewsletterState = (0, _assign3.default)({}, this.state.newsletters, _defineProperty({}, name, value));

      this.setState({
        newsletters: newNewsletterState
      });
    }
  }, {
    key: 'handleEmailUpdate',
    value: function handleEmailUpdate(e) {
      var target = e.target;
      var value = target.value;

      this.setState({
        email: value
      });
    }
  }, {
    key: 'handleVerify',
    value: function handleVerify(value) {
      this.setState({ recaptcha: value });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var savedEmail = this.state.email;
      this.setState({ disabled: true, status: 'loading', email: '' }, // eslint-disable-line react/no-unused-state
      function disbaledSetStateCallback() {
        var newsletters = Object.keys(this.state.newsletters) || [];
        var selectedNewsletters = newsletters.filter(function filterNewsletterList(listId) {
          return this.state.newsletters[listId];
        }.bind(this));
        var currUrl = (0, _get2.default)(this.props.config, 'navHistory[0]');
        var data = {
          email: savedEmail,
          lists: selectedNewsletters,
          sourceDescription: currUrl,
          recaptcha: this.state.recaptcha
        };
        new _newsletter_module2.default().post(data, this.props.config).then(function receiveResponse(response) {
          (0, _newsletter_ga_util2.default)(data.lists, this.props.config.newsletters);
          this.setState({
            disabled: false, // eslint-disable-line react/no-unused-state
            status: (0, _get2.default)(response, 'data.[0].status', '').toLowerCase() // eslint-disable-line react/no-unused-state
          });
        }.bind(this)).catch(function handleUserError() {
          // change this to err.status after 400 issue is fixed
          this.setState({ disabled: false, status: 'error', error: true }); // eslint-disable-line react/no-unused-state
        }.bind(this));
      }.bind(this));
    }
  }]);

  return NewsletterSubscriber;
}(_react.Component);

NewsletterSubscriber.defaultProps = {
  newsletters: [],
  newsletterIds: []
};

NewsletterSubscriber.propTypes = {
  newsletters: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  newsletterIds: _propTypes2.default.arrayOf(_propTypes2.default.number),
  config: _propTypes2.default.shape({
    newsletters: _propTypes2.default.shape({}).isRequired
  }).isRequired
};

exports.default = NewsletterSubscriber;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(53);

var _axios2 = _interopRequireDefault(_axios);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Newsletter = function () {
  function Newsletter() {
    _classCallCheck(this, Newsletter);
  }

  _createClass(Newsletter, [{
    key: 'post',
    value: function post(args, config) {
      var _buildRequestObj = this.buildRequestObj(args, config, 'post'),
          url = _buildRequestObj.url,
          options = _buildRequestObj.options;

      return _axios2.default.post(url, options);
    }
  }, {
    key: 'put',
    value: function put(args, config) {
      var _buildRequestObj2 = this.buildRequestObj(args, config, 'put'),
          url = _buildRequestObj2.url,
          options = _buildRequestObj2.options;

      return _axios2.default.post(url, options);
    }
  }, {
    key: 'buildRequestObj',
    value: function buildRequestObj(args, config, method) {
      var host = (0, _get2.default)(config, 'apiEndpoint');
      var protocol = (0, _get2.default)(config, 'protocol');
      var options = (0, _extend2.default)({}, args);
      var base = '' + protocol + host + '/api/v2/newsletter';

      var urls = {
        post: base,
        put: base + '-email'
      };

      // api has auth in beta
      if ((0, _get2.default)(config, 'authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(config, 'post'));
      }
      var url = urls[method];
      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + url + ' from model.');
      }

      return { url: url, options: options };
    }
  }]);

  return Newsletter;
}();

exports.default = Newsletter;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(486);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _objectAssign = __webpack_require__(39);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error('Keys Missing', spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);

  var trackWidth, trackHeight;

  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    if (spec.variableWidth) {
      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
    } else if (spec.centerMode) {
      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
    } else {
      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
    }
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
    transition: '',
    WebkitTransition: '',
    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
  };

  if (trackWidth) {
    (0, _objectAssign2.default)(style, { width: trackWidth });
  }

  if (trackHeight) {
    (0, _objectAssign2.default)(style, { height: trackHeight });
  }

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + 'px';
    } else {
      style.marginTop = spec.left + 'px';
    }
  }

  return style;
};

var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);

  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  return style;
};

var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {

  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);

  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (spec.fade) {
    return 0;
  }

  if (spec.infinite) {
    if (spec.slideCount >= spec.slidesToShow) {
      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
    }
    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        if (spec.slideIndex > spec.slideCount) {
          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
        } else {
          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
        }
      }
    }
  } else {

    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
        slideOffset = slidesToOffset * spec.slideWidth;
      }
    }
  }

  if (spec.centerMode) {
    if (spec.infinite) {
      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
    } else {
      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
    }
  }

  if (!spec.vertical) {
    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
  } else {
    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
  }

  if (spec.variableWidth === true) {
    var targetSlideIndex;
    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
    } else {
      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
    }
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (spec.centerMode === true) {
      if (spec.infinite === false) {
        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
      } else {
        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
      }

      if (targetSlide) {
        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
      }
    }
  }

  return targetLeft;
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
    className: '',
    accessibility: true,
    adaptiveHeight: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: false,
    centerPadding: '50px',
    cssEase: 'ease',
    customPaging: function customPaging(i) {
        return _react2.default.createElement(
            'button',
            null,
            i + 1
        );
    },
    dots: false,
    dotsClass: 'slick-dots',
    draggable: true,
    easing: 'linear',
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: false,
    pauseOnHover: true,
    responsive: null,
    rtl: false,
    slide: 'div',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    swipe: true,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    afterChange: null,
    beforeChange: null,
    edgeEvent: null,
    init: null,
    swipeEvent: null,
    // nextArrow, prevArrow are react componets
    nextArrow: null,
    prevArrow: null
};

module.exports = defaultProps;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MoreStories;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _cloudinary_asset_util = __webpack_require__(30);

var _create_class_list_util = __webpack_require__(133);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _advertorial = __webpack_require__(28);

var _advertorial2 = _interopRequireDefault(_advertorial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildSlugWrapperClass(advertorial) {
  var className = 'homepage-tag__advertorial-title-container';
  // TODO: change class modifier on setModifierClass
  var slugTitle = (0, _create_class_list_util.setModifierClass)(advertorial, className, 'advertorial') || className;
  return slugTitle;
}

function renderSlug(data, tags, advertorial) {
  var pageLink = (0, _get2.default)(data, 'slug') ? '/section/' + (0, _get2.default)(data, 'slug') : '';
  var slugName = (0, _get2.default)(data, 'name') || 'more stories';

  return _react2.default.createElement(
    'div',
    { className: buildSlugWrapperClass(advertorial) },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_slug2.default, { slugName: slugName, linkTo: pageLink }),
      advertorial ? _react2.default.createElement(_advertorial2.default, {
        modifier: 'homepage-deck',
        tags: tags,
        section: 'homepage'
      }) : ''
    )
  );
}

function MoreStories(props) {
  if (!props) {
    return null;
  }

  var config = props.config,
      metadata = props.metadata,
      slugData = props.slugData,
      tags = props.tags,
      isPost = props.isPost;

  var advertorial = (0, _advertorial.isAdvertorial)(tags);

  return _react2.default.createElement(
    'section',
    { className: isPost ? 'post-more-stories' : 'more-stories-module' },
    renderSlug(slugData, tags, advertorial),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      metadata.map(function (post, i, arr) {
        return _react2.default.createElement(_card2.default, {
          key: post.id,
          metadata: (0, _assign2.default)(post, {
            assetSizes: i === 0 ? _cloudinary_asset_util.imageSizesLookup.bigFirstMobile : _cloudinary_asset_util.imageSizesLookup[arr.length]
          }),
          config: config,
          totalCards: arr.length
        });
      })
    )
  );
}

MoreStories.defaultProps = {
  tags: [],
  isPost: false,
  slugData: {}
};

MoreStories.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  slugData: _propTypes2.default.shape({}),
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  isPost: _propTypes2.default.bool
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allFeedLoading = allFeedLoading;
exports.allFeedLoaded = allFeedLoaded;
exports.allFeedLoadError = allFeedLoadError;
exports.allFeedAllStoriesRendered = allFeedAllStoriesRendered;
exports.allFeedISLoading = allFeedISLoading;
exports.allFeedISLoaded = allFeedISLoaded;
exports.allFeedISError = allFeedISError;

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function allFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'ALL_FEED_LOADING',
    allFeed: resp,
    store: store
  };
}

function allFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'ALL_FEED_LOADED',
    allFeed: resp,
    store: store
  };
}

function allFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'ALL_FEED_ERROR',
    allFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function allFeedAllStoriesRendered() {
  return {
    type: 'ALL_FEED_ALL_STORIES_RENDERED',
    allRendered: true
  };
}

function allFeedISLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'ALL_FEED_IS_LOADING',
    allFeed: (0, _extend2.default)({ isLoading: true }, resp),
    config: config
  };
}

function allFeedISLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'ALL_FEED_IS_LOADED',
    allFeed: resp,
    config: config
  };
}

function allFeedISError() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments[1];

  return {
    type: 'ALL_FEED_IS_ERROR',
    allFeed: resp,
    config: config
  };
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _exenv = __webpack_require__(4);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllFeed = function (_Base) {
  _inherits(AllFeed, _Base);

  function AllFeed() {
    _classCallCheck(this, AllFeed);

    return _possibleConstructorReturn(this, (AllFeed.__proto__ || Object.getPrototypeOf(AllFeed)).apply(this, arguments));
  }

  _createClass(AllFeed, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var page = _ref.page;

      var state = store.getState();
      var pageParams = page ? '&page=' + page : '';
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled') || false;
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }
      var cacheKeyUrl = '' + protocol + host + '/api/v3/all-feed?total=10' + pageParams;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }, {
    key: 'fetchAllFeedIS',
    value: function fetchAllFeedIS(_ref2, config) {
      var page = _ref2.page;

      var state = config;
      var pageParams = page ? '&page=' + page : '';
      var total = 20;
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled') || false;
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }
      var cacheKeyUrl = '' + protocol + host + '/api/v3/all-feed?total=' + total + pageParams;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return AllFeed;
}(_base_model2.default);

exports.default = AllFeed;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CachingService = function () {
  function CachingService() {
    _classCallCheck(this, CachingService);

    this.cache = {};
  }

  _createClass(CachingService, [{
    key: 'initialize',
    value: function initialize(_ref) {
      var _ref$enabled = _ref.enabled,
          enabled = _ref$enabled === undefined ? false : _ref$enabled,
          _ref$cacheClearInterv = _ref.cacheClearInterval,
          cacheClearInterval = _ref$cacheClearInterv === undefined ? 20000 : _ref$cacheClearInterv;

      if (_exenv2.default) {
        if (enabled) {
          this.cacheClearInterval = setInterval(function clearCache() {
            this.cache = {};
          }.bind(this), cacheClearInterval);
        }
      }
    }
  }, {
    key: 'getAsync',
    value: function getAsync(key) {
      return _bluebird2.default.resolve(this.cache[key]);
    }
  }, {
    key: 'setex',
    value: function setex(key, expire, val) {
      this.cache[key] = val;
    }
  }]);

  return CachingService;
}();

exports.default = new CachingService();

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = allFeedAction;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _all_feed_action_creators = __webpack_require__(227);

var allFeedActions = _interopRequireWildcard(_all_feed_action_creators);

var _all_feed_module = __webpack_require__(228);

var _all_feed_module2 = _interopRequireDefault(_all_feed_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function allFeedAction(params, store) {
  return function allFeedDispatch(dispatch) {
    dispatch(allFeedActions.allFeedLoading(store));
    return _all_feed_module2.default.fetch(params, store).then(function handleAllFeedData(resp) {
      if (params.page && !(0, _get2.default)(resp, 'data.posts.length')) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }
      dispatch(allFeedActions.allFeedLoaded(resp.data, store));
    }).catch(function handleAllFeedError(err) {
      dispatch(allFeedActions.allFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMagazineLatestIssuePosts;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _magazine_latest_issue_posts_action_creators = __webpack_require__(527);

var magazineLatestIssuePostsActions = _interopRequireWildcard(_magazine_latest_issue_posts_action_creators);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _magazine_latest_issue_posts_model = __webpack_require__(528);

var _magazine_latest_issue_posts_model2 = _interopRequireDefault(_magazine_latest_issue_posts_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMagazineLatestIssuePosts(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(magazineLatestIssuePostsActions.magazineLatestIssuePostsLoading({}, store));
    return _magazine_latest_issue_posts_model2.default.fetch(params, store).then(function handleMagazineLatestIssuePostsData(magazineLatestIssuePostsData) {
      dispatch(magazineLatestIssuePostsActions.magazineLatestIssuePostsLoaded(magazineLatestIssuePostsData.data, store));
    }).catch(function handleMagazineLatestIssuePostsError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(magazineLatestIssuePostsActions.magazineLatestIssuePostsError(err.data, store));
      _logger_service2.default.error(err, 'Error in fetchMagazineLatestIssuePosts actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(22);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _author_all_feed_action_creators = __webpack_require__(144);

var _async_author_is_all_feed_actions = __webpack_require__(534);

var _async_author_is_all_feed_actions2 = _interopRequireDefault(_async_author_is_all_feed_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Author = function (_Component) {
  _inherits(Author, _Component);

  function Author() {
    _classCallCheck(this, Author);

    return _possibleConstructorReturn(this, (Author.__proto__ || Object.getPrototypeOf(Author)).apply(this, arguments));
  }

  _createClass(Author, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          authorPage = _props.authorPage,
          author = _props.author,
          config = _props.config;

      var isLoading = (0, _get2.default)(authorPage, 'isLoading');

      if ((0, _get2.default)(author, 'error') && !isLoading || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'author-page' },
          _react2.default.createElement(
            'article',
            { className: 'author-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'author-page' },
          _react2.default.createElement(
            'article',
            { className: 'author-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(authorPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var authorName = (0, _get2.default)(author, 'name');
      var authorSlug = (0, _get2.default)(author, 'slug');
      var feedURL = '//' + (0, _get2.default)(config, 'site', '') + '.com/user/' + authorSlug + '/rss';

      var page = (0, _get2.default)(this.props, 'authorAllFeed.page');
      var pageParam = (0, _get2.default)(this.props, 'match.params.page', false);
      var totalPages = (0, _get2.default)(this.props, 'authorAllFeed.totalPages');
      var isLastPage = Number(page) >= totalPages;

      if (!pageParam) {
        if (totalPages === 1) {
          isLastPage = true;
        }
        return _react2.default.createElement(
          'section',
          { className: 'author-page' },
          _react2.default.createElement(
            'section',
            { className: 'author-bio' },
            (0, _isEmpty2.default)(author) ? '' : _react2.default.createElement(
              'div',
              { className: 'author-bio__row' },
              _react2.default.createElement(
                'div',
                { className: 'author-bio__stories-col' },
                _react2.default.createElement(
                  'div',
                  { className: 'author-bio__text-wrapper' },
                  _react2.default.createElement(
                    'h1',
                    { className: 'author-bio__author-name' },
                    authorName
                  ),
                  _react2.default.createElement('article', {
                    className: 'author-bio__author-desc',
                    dangerouslySetInnerHTML: {
                      __html: (0, _get2.default)(author, 'description')
                    }
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'author-bio__rss-feed' },
                  _react2.default.createElement(
                    'a',
                    { className: 'author-bio__rss-feed-url', href: feedURL },
                    'RSS'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'author-bio__ad-col' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
                    noLazyLoad: true,
                    pos: 'atf',
                    name: 'fixedrectangle'
                  })),
                  _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
                    noLazyLoad: true,
                    pos: 'atf',
                    name: 'mobileparallax_1'
                  }))
                )
              )
            )
          ),
          _react2.default.createElement(_all_feed2.default, {
            hasSlug: false,
            adModel: combinedAdModel,
            stories: (0, _get2.default)(this.props, 'authorAllFeed.posts'),
            allRendered: (0, _get2.default)(this.props, 'authorAllFeed.allRendered'),
            updateAction: _author_all_feed_action_creators.authorAllFeedAllStoriesRendered,
            config: config,
            paginationEnabled: true,
            totalPages: totalPages,
            page: page,
            section: (0, _get2.default)(this.props, 'match.params.slug'),
            type: 'user',
            isLastPage: isLastPage,
            infiniteScrollEnabled: config.featureFlags.infiniteScrollAllFeed,
            infiniteScrollAllFeedFetch: this.props.authorISAllFeedActions,
            infiniteScrollLoading: (0, _get2.default)(this.props, 'authorAllFeed.isLoading'),
            site: (0, _get2.default)(this.props, 'config.site'),
            hideRecircFeed: this.props.hideRecircFeed
          }),
          (0, _get2.default)(this.props, 'authorAllFeed.isLoading') && _react2.default.createElement(_loading_spinner2.default, null),
          !(0, _get2.default)(this.props, 'authorAllFeed.isEnabled') && _react2.default.createElement(
            'div',
            { className: 'author-page__all-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: 'flexiblebillboard_1' }))
          )
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'author-page' },
        _react2.default.createElement(
          'section',
          { className: 'author-bio' },
          (0, _isEmpty2.default)(author) ? '' : _react2.default.createElement(
            'div',
            { className: 'author-bio__row' },
            _react2.default.createElement(
              'div',
              { className: 'author-bio__stories-col' },
              _react2.default.createElement(
                'div',
                { className: 'author-bio__text-wrapper' },
                _react2.default.createElement(
                  'h1',
                  { className: 'author-bio__author-name' },
                  authorName
                ),
                _react2.default.createElement('article', {
                  className: 'author-bio__author-desc',
                  dangerouslySetInnerHTML: {
                    __html: (0, _get2.default)(author, 'description')
                  }
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'author-bio__ad-col' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
                  noLazyLoad: true,
                  pos: 'atf',
                  name: 'fixedrectangle'
                })),
                _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
                  noLazyLoad: true,
                  pos: 'atf',
                  name: 'mobileparallax_1'
                }))
              )
            )
          )
        ),
        _react2.default.createElement(_all_feed2.default, {
          site: (0, _get2.default)(this.props, 'config.site'),
          hasSlug: false,
          adModel: combinedAdModel,
          stories: (0, _get2.default)(this.props, 'authorAllFeed.posts'),
          allRendered: (0, _get2.default)(this.props, 'authorAllFeed.allRendered'),
          updateAction: _author_all_feed_action_creators.authorAllFeedAllStoriesRendered,
          config: config,
          paginationEnabled: true,
          page: page + 1,
          section: (0, _get2.default)(this.props, 'match.params.slug'),
          type: 'user',
          isLastPage: isLastPage
        }),
        this.props.authorAllFeed.posts.length ? _react2.default.createElement(
          'div',
          { className: 'author-page__all-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
        ) : ''
      );
    }
  }]);

  return Author;
}(_react.Component);

function mapDispatchToProps(dispatch) {
  return {
    authorISAllFeedActions: (0, _async_author_is_all_feed_actions2.default)(dispatch),
    hideRecircFeed: (0, _async_recirc_feed_actions.hideRecircAction)(dispatch)
  };
}

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    status: state.status.code,
    config: state.config || {},
    authorAllFeed: {
      page: (0, _get2.default)(state, 'authorAllFeed.data.page', 0),
      isEnabled: (0, _get2.default)(state, 'authorAllFeed.isEnabled'),
      isLoading: (0, _get2.default)(state, 'authorAllFeed.isLoading'),
      totalPages: (0, _get2.default)(state, 'authorAllFeed.data.totalPages', 0),
      posts: (0, _get2.default)(state, 'authorAllFeed.data.posts', []),
      allRendered: (0, _get2.default)(state, 'authorAllFeed.allRendered', false)
    },
    authorPage: state.authorPage || {
      ads: {
        baseConfig: {}
      }
    },
    author: (0, _get2.default)(state, 'author.data') || { error: true }
  };
}

Author.propTypes = {
  status: _propTypes2.default.number.isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  authorPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  author: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    description: _propTypes2.default.string,
    link: _propTypes2.default.string
  }).isRequired,
  authorAllFeed: _propTypes2.default.shape({
    page: _propTypes2.default.number,
    isEnabled: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    totalPages: _propTypes2.default.number,
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool
  }).isRequired,
  authorISAllFeedActions: _propTypes2.default.func.isRequired,
  hideRecircFeed: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Author));

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuthorAllFeed = function (_Base) {
  _inherits(AuthorAllFeed, _Base);

  function AuthorAllFeed() {
    _classCallCheck(this, AuthorAllFeed);

    return _possibleConstructorReturn(this, (AuthorAllFeed.__proto__ || Object.getPrototypeOf(AuthorAllFeed)).apply(this, arguments));
  }

  _createClass(AuthorAllFeed, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var slug = _ref.slug,
          page = _ref.page;

      var pageParams = page ? '&page=' + page : '';
      var total = 20;
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/posts-author-slug/' + site + '/' + this.cleanParam(slug) + '?total=' + total + pageParams;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }, {
    key: 'fetchAllFeedIS',
    value: function fetchAllFeedIS(_ref2, config) {
      var slug = _ref2.slug,
          page = _ref2.page;

      var state = { config: config };
      var pageParams = page ? '&page=' + page : '';
      var total = 30;
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/posts-author-slug/' + site + '/' + this.cleanParam(slug) + '?total=' + total + pageParams;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return AuthorAllFeed;
}(_base_model2.default);

exports.default = AuthorAllFeed;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_author_page_actions = __webpack_require__(535);

var _async_author_page_actions2 = _interopRequireDefault(_async_author_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_author_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_author_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback();
      }
      return false;
    });
  };
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryAllFeedLoading = categoryAllFeedLoading;
exports.categoryAllFeedLoaded = categoryAllFeedLoaded;
exports.categoryAllFeedLoadError = categoryAllFeedLoadError;
exports.categoryAllFeedAllStoriesRendered = categoryAllFeedAllStoriesRendered;
// import { canUseDOM } from 'exenv';

function categoryAllFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_ALL_FEED_LOADING',
    categoryAllFeed: resp,
    store: store
  };
}

function categoryAllFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_ALL_FEED_LOADED',
    categoryAllFeed: resp,
    store: store
  };
}

function categoryAllFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_ALL_FEED_ERROR',
    categoryAllFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function categoryAllFeedAllStoriesRendered() {
  return {
    type: 'CATEGORY_ALL_FEED_ALL_STORIES_RENDERED',
    allRendered: true
  };
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exenv = __webpack_require__(4);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(22);

var _reactRouterRedux = __webpack_require__(61);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactPaginate = __webpack_require__(237);

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _throttle = __webpack_require__(64);

var _throttle2 = _interopRequireDefault(_throttle);

var _cloneDeep = __webpack_require__(74);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _findIndex = __webpack_require__(238);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _container = __webpack_require__(146);

var _container2 = _interopRequireDefault(_container);

var _revcontent = __webpack_require__(251);

var _revcontent2 = _interopRequireDefault(_revcontent);

var _video_module = __webpack_require__(66);

var _video_module2 = _interopRequireDefault(_video_module);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _trackThirdPartyJS = __webpack_require__(147);

var _trackThirdPartyJS2 = _interopRequireDefault(_trackThirdPartyJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;

if (_exenv.canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = __webpack_require__(58);
}

var News = function (_Component) {
  _inherits(News, _Component);

  function News() {
    _classCallCheck(this, News);

    var _this = _possibleConstructorReturn(this, (News.__proto__ || Object.getPrototypeOf(News)).call(this));

    _this.isDesktop = false;
    _this.setScrollEvents = (0, _throttle2.default)(function () {
      var _this$window = _this.window,
          scrollY = _this$window.scrollY,
          innerHeight = _this$window.innerHeight;

      _this.setInviewPost(scrollY, innerHeight);
    }, 100);
    _this.onPaginateClick = _this.onPaginateClick.bind(_this);
    _this.playerScriptIds = ['QV73eWiB', '4h5SWQPt', 'Pafg29um', '27mBLzWL', 'i70nsZ8K', 'Lrp0YsKC', 'wGNMZweZ', 'kMmGs8qw', 'WXJihrBk', 'iqio3VCM', 'OolwHeKf', 'FsIzKJce', 'r04h3Jdn', 'RvGXj7in', 'flarUGPa', 'HzdTLaau', 'gAy6i1bi', 'RqEFED7X', 'vp2iCnvh', 'b2BPV4nc'];
    return _this;
  }

  _createClass(News, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.window = window;
      this.activePost = null;
      this.isDesktop = (0, _client_util2.default)();
      this.trackedPosts = [];
      window.addEventListener('scroll', this.setScrollEvents);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.posts = this.getPostElements();

      if (_exenv.canUseDOM && this.posts.length) {
        if (!window.instgrm) {
          scriptjs('//platform.instagram.com/en_US/embeds.js', function () {
            window.instgrm.Embeds.process();
          });
        } else {
          window.instgrm.Embeds.process();
        }

        if (!window.twttr) {
          scriptjs('//platform.twitter.com/widgets.js', function () {
            window.twttr.widgets.load();
          });
        } else {
          window.twttr.widgets.load();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.window.removeEventListener('scroll', this.setScrollEvents);
    }
  }, {
    key: 'onPaginateClick',
    value: function onPaginateClick(data) {
      var url = '/news/' + (data.selected + 1);
      this.props.nextPage(url);
    }
  }, {
    key: 'setInviewPost',
    value: function setInviewPost(windowPosition, screenHeight) {
      if (!this.posts || !this.posts.length) {
        return false;
      }

      // Set url to /news if at top of screen.
      if (windowPosition === 0) {
        var page = (0, _get2.default)(this.props.match, 'params.page');
        var newsUrl = page ? '/news/' + page : '/news';
        window.history.replaceState({}, '', newsUrl);
        this.activePost = null;
        return false;
      }

      var triggerPoint = windowPosition + screenHeight / 2;
      for (var i = 1; i <= this.posts.length; i += 1) {
        var post = this.posts[i - 1];
        var sectionTopPosition = post.offsetTop;
        var sectionBottomPosition = sectionTopPosition + post.clientHeight;
        var _post$dataset = post.dataset,
            id = _post$dataset.id,
            slug = _post$dataset.slug;

        var postId = parseFloat(id);

        if (this.activePost !== postId && sectionTopPosition <= triggerPoint && sectionBottomPosition > triggerPoint) {
          var postData = (0, _get2.default)(this.props.categoryAllFeed, 'posts[' + (i - 1) + ']', {});
          this.activePost = postId;
          this.setActiveSocial(post);

          window.history.replaceState({}, '', '/' + postId + '/' + slug);

          if (this.trackedPosts.indexOf(this.activePost) === -1) {
            this.trackedPosts.push(this.activePost);
            this.refreshThirdPartyTrackers(postData, i);
          }
        }
      }
      return false;
    }
  }, {
    key: 'getPostElements',
    value: function getPostElements() {
      return document.querySelectorAll('.post__body');
    }
  }, {
    key: 'setActiveSocial',
    value: function setActiveSocial(post) {
      var activeClass = 'social--active';
      var activeSocial = document.querySelector('.' + activeClass);

      if (activeSocial) {
        activeSocial.classList.remove(activeClass);
      }

      var activePost = post || document.querySelector('.post__wrapper');
      if (activePost) {
        activePost.querySelector('.social').classList.add(activeClass);
      }
    }
  }, {
    key: 'refreshThirdPartyTrackers',
    value: function refreshThirdPartyTrackers(postData, pageNumber) {
      var config = this.props.config;

      var currentActivePostState = {
        context: {
          site: (0, _get2.default)(config, 'site'),
          type: 'post',
          postData: postData
        },
        config: config
      };
      (0, _trackThirdPartyJS2.default)(currentActivePostState, pageNumber);
    }
  }, {
    key: 'renderNewsSection',
    value: function renderNewsSection(numPosts) {
      var firstSection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var playerIds = arguments[2];

      var origPosts = (0, _get2.default)(this.props, 'categoryAllFeed.posts', []);
      var posts = this.posts;

      var slice = numPosts;
      var totalPosts = posts.length;

      if (!totalPosts) return null;

      if (totalPosts <= numPosts) {
        slice = totalPosts;
      }

      posts = this.posts.splice(0, slice);
      posts = posts.map(function (postData) {
        if (postData.isVideoPermalink || (0, _get2.default)(postData, 'posterVideo.feedId')) {
          var postIndex = (0, _findIndex2.default)(origPosts, { id: postData.id });
          if (!playerIds[postIndex]) {
            (0, _set2.default)(postData, 'playerScriptId', 'G2hQKLvX');
          } else {
            (0, _set2.default)(postData, 'playerScriptId', playerIds[postIndex]);
          }
        }
        return postData;
      });

      return _react2.default.createElement(_container2.default, _extends({}, this.props, {
        posts: posts,
        combinedAdModel: this.combinedAdModel,
        isDesktop: this.isDesktop,
        isFirstPost: firstSection,
        pageNum: 1,
        videoAdData: (0, _get2.default)(this.props.categoryPage, 'ads.model', {})
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var categoryAllFeed = this.props.categoryAllFeed;

      this.posts = (0, _cloneDeep2.default)((0, _get2.default)(categoryAllFeed, 'posts', []));

      if (this.props.categoryPage.error || this.props.categoryFeaturedFeed.error) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.categoryPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          config = _props.config,
          match = _props.match;
      var totalPosts = categoryAllFeed.totalPosts,
          totalPages = categoryAllFeed.totalPages;
      var page = match.params.page;

      var adData = (0, _get2.default)(this.props, 'categoryPage.ads');
      this.combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var currentSite = (0, _get2.default)(config, 'site');

      return _react2.default.createElement(
        'section',
        { className: 'category-page category-page--news' },
        this.renderNewsSection(3, true, this.playerScriptIds),
        _react2.default.createElement(_revcontent2.default, {
          initialPageLoad: (0, _get2.default)(this.props, 'config.initialPageLoad'),
          site: currentSite
        }),
        this.renderNewsSection(5, false, this.playerScriptIds),
        _react2.default.createElement(_video_module2.default, {
          config: config,
          type: 'category',
          data: this.props.categoryVideo,
          playerid: 'HliaKwd3',
          stories: this.props.categoryVideo.playlist,
          currentSite: currentSite,
          isPost: true
        }),
        this.renderNewsSection(3, false, this.playerScriptIds),
        this.renderNewsSection(5, false, this.playerScriptIds),
        this.renderNewsSection(4, false, this.playerScriptIds),
        _react2.default.createElement(
          'div',
          { className: 'pagination__meta' },
          _react2.default.createElement(
            'div',
            { className: 'pagination__container' },
            _react2.default.createElement(
              'h2',
              { className: 'pagination__count pagination__count--bottom' },
              totalPosts,
              ' Stories'
            ),
            _react2.default.createElement(_reactPaginate2.default, {
              forcePage: page ? parseInt(page, 10) - 1 : 0,
              onPageChange: this.onPaginateClick,
              pageCount: totalPages,
              pageRangeDisplayed: 2,
              marginPagesDisplayed: 1,
              previousLabel: 'Prev',
              nextLabel: 'Next',
              breakLabel: '...',
              containerClassName: 'pagination',
              pageClassName: 'pagination__page',
              activeClassName: 'pagination__page pagination__page--active',
              previousClassName: 'pagination__page pagination__page--prev',
              nextClassName: 'pagination__page pagination__page--next',
              breakClassName: 'pagination__page pagination__page--break',
              pageLinkClassName: 'pagination__link',
              previousLinkClassName: 'pagination__link',
              nextLinkClassName: 'pagination__link',
              disabledClassName: 'pagination__link--disabled'
            })
          )
        )
      );
    }
  }]);

  return News;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: (0, _get2.default)(state, 'categoryFeaturedFeed.source') || '',
      featured: (0, _get2.default)(state, 'categoryFeaturedFeed.featured') || [],
      top: (0, _get2.default)(state, 'categoryFeaturedFeed.top') || [],
      category: (0, _get2.default)(state, 'categoryFeaturedFeed.category') || {},
      error: (0, _get2.default)(state, 'categoryFeaturedFeed.error') || false
    },
    categoryVideo: {
      playlist: (0, _get2.default)(state, 'categoryVideo.data.playlist') || [],
      title: (0, _get2.default)(state, 'categoryVideo.data.title') || '',
      feedid: (0, _get2.default)(state, 'categoryVideo.data.feedid') || ''
    },
    categoryPage: (0, _get2.default)(state, 'categoryPage') || {},
    categoryAllFeed: {
      posts: (0, _get2.default)(state, 'categoryAllFeed.data.posts') || [],
      totalPages: (0, _get2.default)(state, 'categoryAllFeed.data.totalPages'),
      totalPosts: (0, _get2.default)(state, 'categoryAllFeed.data.totalPosts')
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    nextPage: function nextPage(url) {
      dispatch((0, _reactRouterRedux.push)(url));
    }
  };
}

News.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  match: _propTypes2.default.shape({}).isRequired,
  categoryPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  categoryFeaturedFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    category: _propTypes2.default.object,
    error: _propTypes2.default.bool
  }).isRequired,
  categoryVideo: _propTypes2.default.shape({
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    feedid: _propTypes2.default.string,
    title: _propTypes2.default.string
  }).isRequired,
  categoryAllFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number
  }).isRequired,
  nextPage: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(News));

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _PaginationBoxView = __webpack_require__(561);

var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _PaginationBoxView2.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(195),
    baseIteratee = __webpack_require__(78),
    toInteger = __webpack_require__(222);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(568),
    isObjectLike = __webpack_require__(44);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(194),
    arraySome = __webpack_require__(569),
    cacheHas = __webpack_require__(196);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _createEventHandlers = __webpack_require__(583);

var _createEventHandlers2 = _interopRequireDefault(_createEventHandlers);

var _getCurriedOnLoad = __webpack_require__(591);

var _getCurriedOnLoad2 = _interopRequireDefault(_getCurriedOnLoad);

var _getPlayerOpts = __webpack_require__(592);

var _getPlayerOpts2 = _interopRequireDefault(_getPlayerOpts);

var _initialize2 = __webpack_require__(593);

var _initialize3 = _interopRequireDefault(_initialize2);

var _installPlayerScript = __webpack_require__(594);

var _installPlayerScript2 = _interopRequireDefault(_installPlayerScript);

var _playInView = __webpack_require__(595);

var _playInView2 = _interopRequireDefault(_playInView);

var _defaultProps = __webpack_require__(597);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _propTypes = __webpack_require__(598);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = 'ReactJWPlayer';

var ReactJWPlayer = function (_Component) {
  _inherits(ReactJWPlayer, _Component);

  function ReactJWPlayer(props) {
    _classCallCheck(this, ReactJWPlayer);

    var _this = _possibleConstructorReturn(this, (ReactJWPlayer.__proto__ || Object.getPrototypeOf(ReactJWPlayer)).call(this, props));

    _this.state = {
      adHasPlayed: false,
      hasPlayed: false,
      hasFired: {}
    };
    _this.eventHandlers = (0, _createEventHandlers2.default)(_this);
    _this.uniqueScriptId = 'jw-player-script';
    _this._initialize = _this._initialize.bind(_this);
    return _this;
  }

  _createClass(ReactJWPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isJWPlayerScriptLoaded = !!window.jwplayer;
      if (isJWPlayerScriptLoaded) {
        this._initialize();
        return;
      }

      var existingScript = document.getElementById(this.uniqueScriptId);

      if (!existingScript) {
        (0, _installPlayerScript2.default)({
          context: document,
          onLoadCallback: this._initialize,
          scriptSrc: this.props.playerScript,
          uniqueScriptId: this.uniqueScriptId
        });
      } else {
        existingScript.onload = (0, _getCurriedOnLoad2.default)(existingScript, this._initialize);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.player && this.player.remove) {
        this.player.remove();
      }
      if (this.viewController) {
        this.viewController.off();
      }
    }
  }, {
    key: '_initialize',
    value: function _initialize() {
      var component = this;
      var player = window.jwplayer(this.props.playerId);
      this.player = player;
      var playerOpts = (0, _getPlayerOpts2.default)(this.props);

      (0, _initialize3.default)({ component: component, player: player, playerOpts: playerOpts });

      if (this.props.playInView) {
        this.viewController = new _playInView2.default(this.player, this.props.playInViewPercentage);
        this.viewController.on();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: this.props.className,
        dangerouslySetInnerHTML: {
          __html: '<div id="' + this.props.playerId + '"></div>'
        }
      });
    }
  }]);

  return ReactJWPlayer;
}(_react.Component);

ReactJWPlayer.defaultProps = _defaultProps2.default;
ReactJWPlayer.displayName = displayName;
ReactJWPlayer.propTypes = _propTypes2.default;
exports.default = ReactJWPlayer;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSlick = __webpack_require__(104);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isString = __webpack_require__(98);

var _isString2 = _interopRequireDefault(_isString);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

var _exenv = __webpack_require__(4);

var _cloudinary_asset_util = __webpack_require__(30);

var _image = __webpack_require__(76);

var _image2 = _interopRequireDefault(_image);

var _gif_converter = __webpack_require__(204);

var _gif_converter2 = _interopRequireDefault(_gif_converter);

var _arrow = __webpack_require__(245);

var _arrow2 = _interopRequireDefault(_arrow);

var _custom_event_util = __webpack_require__(599);

var _custom_event_util2 = _interopRequireDefault(_custom_event_util);

var _omniture = __webpack_require__(246);

var _comscore = __webpack_require__(247);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var prevArrow = _react2.default.createElement(
  'svg',
  { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 41 40' },
  _react2.default.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    _react2.default.createElement('path', {
      fill: '#CCC',
      d: 'M.47 20c0 11.045 8.952 20 20 20 11.045 0 20-8.955 20-20s-8.955-20-20-20C9.42 0 .47 8.955.47 20z'
    }),
    _react2.default.createElement('path', { fill: '#000', d: 'M12.527 19.998l7.5 3.75v-7.5' }),
    _react2.default.createElement('path', { stroke: '#000', d: 'M19.5 20h8.438' })
  )
);

var nextArrow = _react2.default.createElement(
  'svg',
  { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 41 40' },
  _react2.default.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    _react2.default.createElement('path', {
      fill: '#CCC',
      d: 'M.47 20c0 11.045 8.952 20 20 20 11.045 0 20-8.955 20-20s-8.955-20-20-20C9.42 0 .47 8.955.47 20z'
    }),
    _react2.default.createElement('path', { fill: '#000', d: 'M27.027 19.998l-7.5-3.75v7.5' }),
    _react2.default.createElement('path', { stroke: '#000', d: 'M12.5 20h8.438' })
  )
);

var settings = {
  prevArrow: _react2.default.createElement(_arrow2.default, { markup: prevArrow }),
  nextArrow: _react2.default.createElement(_arrow2.default, { markup: nextArrow }),
  accessibility: true,
  fade: true,
  swipe: false,
  lazyLoad: true,
  responsive: [{
    breakpoint: 640,
    settings: {
      fade: false,
      swipe: true
    }
  }]
};

var FCSlider = function (_Component) {
  _inherits(FCSlider, _Component);

  function FCSlider(props) {
    _classCallCheck(this, FCSlider);

    var _this = _possibleConstructorReturn(this, (FCSlider.__proto__ || Object.getPrototypeOf(FCSlider)).call(this));

    _this.counter = 0;
    _this.onBeforeChange = _this.onBeforeChange.bind(_this);
    _this.captions = props.slideShowData.map(function (slideData, index, arr) {
      return '<span class="header-slideshow__slide-curr">' + (index + 1) + '</span><span class="header-slideshow__slide-total">/' + arr.length + '</span> ' + (slideData.caption ? slideData.caption : '');
    });
    _this.mediaItems = props.slideShowData;
    _this.state = {
      readyToMount: false
    };
    return _this;
  }

  _createClass(FCSlider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.applyImagesOrientations();
      this.changeCaption(0);
    }
  }, {
    key: 'onBeforeChange',
    value: function onBeforeChange(currentSlideIndex, nextSlideIndex) {
      if (this.props.location === 'header') {
        this.triggerSlideshowRefresh();
        this.trackSlideshowEventOmn(currentSlideIndex, nextSlideIndex);
      }

      this.changeCaption(nextSlideIndex);
    }
  }, {
    key: 'applyImagesOrientations',
    value: function applyImagesOrientations() {
      var _this2 = this;

      var parentBounds = this.wrapperDimensions.getBoundingClientRect();
      var parentWidth = parentBounds.width;
      var parentHeight = parentBounds.height;
      var parentAspect = parentWidth / parentHeight;

      return this.mediaItems.forEach(function (item, i, arr) {
        if (item.imgUrl && (0, _isString2.default)(item.imgUrl)) {
          var image = new Image();
          var src = item.imgUrl.replace('wp-cms-fastcompany-com.s3.amazonaws.com', 'images.fastcompany.net/image/upload/wp-cms').replace('upload/', 'upload/w_100,q_auto:low,f_auto,fl_lossy/').replace('fast-company-res.cloudinary.com', 'images.fastcompany.net').replace('http://', 'https://');

          if (/.gif$/.test(src)) {
            src = src.replace('f_auto', 'f_jpg');
          }

          image.src = src;

          image.onload = function assignImageOrientation() {
            var width = image.width,
                height = image.height;


            var myAspect = width / height;

            if (height >= width || myAspect < parentAspect) {
              // eslint-disable-next-line no-param-reassign
              item.modifier = 'portrait';
            } else if (height < width) {
              // eslint-disable-next-line no-param-reassign
              item.modifier = 'landscape';
            }

            if (i === arr.length - 1) {
              this.setState({ readyToMount: true });
            }
          }.bind(_this2);
        } else if (i === arr.length - 1) {
          _this2.setState({ readyToMount: true });
        }
      });
    }
  }, {
    key: 'trackSlideshowEventOmn',
    value: function trackSlideshowEventOmn(currentSlideIndex, nextSlideIndex) {
      if (_exenv.canUseDOM) {
        var trackCurrent = currentSlideIndex + 1;
        if (currentSlideIndex !== undefined && nextSlideIndex !== undefined) {
          if (currentSlideIndex === 0 && currentSlideIndex - nextSlideIndex < -1) {
            (0, _omniture.trackOmniture)('event30', trackCurrent);
            (0, _comscore.sendComscoreCandidatePing)();
          } else {
            if (currentSlideIndex - nextSlideIndex > 1) {
              (0, _omniture.trackOmniture)('event29', trackCurrent);
              (0, _comscore.sendComscoreCandidatePing)();
            }
            if (nextSlideIndex - currentSlideIndex < 0 && Math.abs(nextSlideIndex - currentSlideIndex) === 1) {
              (0, _omniture.trackOmniture)('event30', trackCurrent);
              (0, _comscore.sendComscoreCandidatePing)();
            }
            if (nextSlideIndex - currentSlideIndex > 0 && Math.abs(nextSlideIndex - currentSlideIndex) === 1) {
              (0, _omniture.trackOmniture)('event29', trackCurrent);
              (0, _comscore.sendComscoreCandidatePing)();
            }
          }
        }
      }
    }
  }, {
    key: 'triggerSlideshowRefresh',
    value: function triggerSlideshowRefresh() {
      if (_exenv.canUseDOM) {
        this.counter += 1;
        if (this.counter === 3) {
          this.counter = 0;
          (0, _custom_event_util2.default)('FC_REFRESH_EVENT', { detail: 'slideshowhalfpage' }, window);
        }
      }
    }
  }, {
    key: 'changeCaption',
    value: function changeCaption(index) {
      var hasCaption = !!this.captions[index];

      this.setState({
        currentCaption: '' + (hasCaption ? this.captions[index] : '')
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var slideShowData = this.mediaItems || [];
      var location = this.props.location;


      settings.className = location + '-slideshow';

      return this.state.readyToMount ? _react2.default.createElement(
        'div',
        null,
        ' ',
        _react2.default.createElement(
          _reactSlick2.default,
          _extends({}, settings, { beforeChange: this.onBeforeChange }),
          slideShowData.map(function (slideData) {
            return _react2.default.createElement(
              'figure',
              {
                className: location + '-slideshow__slide',
                key: JSON.stringify(slideData)
              },
              ' ',
              /.gif$/.test(slideData.imgUrl) ? _react2.default.createElement(_gif_converter2.default, {
                src: (0, _get2.default)(slideData, 'imgUrl'),
                assetSizes: _cloudinary_asset_util.imageSizesLookup.slider,
                alt: (0, _get2.default)(slideData, 'caption') ? (0, _striptags2.default)((0, _get2.default)(slideData, 'caption') || '') : _this3.props.title
              }) : _react2.default.createElement(_image2.default, {
                baseClass: location + '-slideshow__image',
                modifier: (0, _get2.default)(slideData, 'modifier'),
                src: (0, _get2.default)(slideData, 'imgUrl'),
                assetSizes: _cloudinary_asset_util.imageSizesLookup.slider,
                alt: (0, _get2.default)(slideData, 'caption') ? (0, _striptags2.default)((0, _get2.default)(slideData, 'caption') || '') : _this3.props.title
              })
            );
          })
        ),
        _react2.default.createElement('div', {
          className: location + '-slideshow__caption',
          dangerouslySetInnerHTML: { __html: this.state.currentCaption }
        })
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', {
          className: 'big-card__poster',
          ref: function ref(node) {
            _this3.wrapperDimensions = node;
          }
        }),
        _react2.default.createElement('div', { className: location + '-slideshow__caption' })
      );
    }
  }]);

  return FCSlider;
}(_react.Component);

FCSlider.defaultProps = {
  slideShowData: [],
  title: '',
  location: 'header'
};

FCSlider.propTypes = {
  slideShowData: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    imgUrl: _propTypes2.default.string,
    caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
  })),
  title: _propTypes2.default.string,
  location: _propTypes2.default.string
};

exports.default = FCSlider;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Arrow;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = __webpack_require__(205);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Arrow(props) {
  return _react2.default.createElement(
    'button',
    _extends({
      type: 'button'
    }, (0, _omit2.default)(props, ['currentSlide', 'slideCount', 'markup'])),
    props.markup
  );
}

Arrow.propTypes = {
  markup: _propTypes2.default.element.isRequired
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadOmnitureTracker;
exports.trackOmniture = trackOmniture;

var _exenv = __webpack_require__(4);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _capitalize = __webpack_require__(200);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _map = __webpack_require__(600);

var _map2 = _interopRequireDefault(_map);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadOmnitureTracker(currentState) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (window.fastco_s) {
    var siteConfig = _identity2.default[(0, _get2.default)(currentState, 'context.site')];
    var siteSlug = (0, _get2.default)(siteConfig, 'slug');
    var context = (0, _get2.default)(currentState, 'context');

    var postData = context.postData,
        tagPageData = context.tagPageData,
        categoryPageData = context.categoryPageData,
        authorPageData = context.authorPageData,
        searchPageData = context.searchPageData,
        staticPageData = context.staticPageData,
        mostCreativePeoplePageData = context.mostCreativePeoplePageData,
        personPageData = context.personPageData,
        ibdPageData = context.ibdPageData,
        companyPageData = context.companyPageData,
        micPageData = context.micPageData,
        micSectorPageData = context.micSectorPageData,
        videoPageData = context.videoPageData,
        productPageData = context.productPageData,
        type = context.type;


    var _category = '';
    var _tag = '';
    // Omniture data structure, defaults to homepage value
    // it will be further extended depend on page type
    var omniture = {
      server: siteSlug,
      channel: 'homepage',
      pageName: siteSlug + ':homepage:front',
      pageURL: (0, _get2.default)(siteConfig, 'url'),
      events: 'event9',
      prop1: '',
      prop2: '',
      prop3: '',
      prop4: (0, _get2.default)(siteConfig, 'url'),
      prop5: '',
      prop6: '',
      prop7: '',
      prop8: '',
      prop9: '',
      prop10: '',
      prop11: '',
      prop13: 1,
      prop21: 'anonymous',
      prop22: 'anonymous:' + siteSlug + ':homepage:front',
      prop23: 'anonymous',
      prop28: '',
      prop31: '',
      prop32: '',
      prop33: '',
      prop34: '',
      eVar49: 1
    };

    var typeLookup = {
      post: function post() {
        _category = (0, _get2.default)(postData, 'categories[0].slug');
        var tags = (0, _get2.default)(postData, 'tags');
        var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);
        var postID = (0, _get2.default)(postData, 'id');
        var postSlug = (0, _get2.default)(postData, 'slug');

        // For mapping of language, anaytics need to be consistent, language wise
        var typeMap = {
          standard: 'article',
          gallery: 'slideshow',
          video: 'video'
        };

        var pageType = typeMap[(0, _get2.default)(postData, 'format')] || 'article';

        // Extend original omniture variable
        omniture = (0, _extend2.default)({}, omniture, {
          pageName: siteSlug + ':' + postID + ':' + postSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/' + postID + '/' + postSlug,
          channel: '',
          prop1: _category,
          prop2: _category,
          prop3: (0, _get2.default)(postData, 'title'),
          prop4: (0, _get2.default)(postData, 'link'),
          prop5: (0, _get2.default)(eyeBrowText, 'slug'),
          prop6: (0, _get2.default)(eyeBrowText, 'slug'),
          prop7: '',
          prop8: (0, _get2.default)(postData, 'author.name'),
          prop9: (0, _get2.default)(postData, 'omnitureDate'),
          prop10: postID,
          prop11: (0, _get2.default)(postData, 'author.name'),
          prop22: 'anonymous:' + siteSlug + ':' + postID + ':' + postSlug,
          prop28: pageType,
          prop31: '',
          prop32: '',
          prop33: (0, _capitalize2.default)(_category),
          prop34: (0, _get2.default)(postData, 'readTime')
        });
      },
      category: function category() {
        _category = (0, _get2.default)(categoryPageData, 'slug', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: _category,
          pageName: siteSlug + ':' + _category + ':front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/' + _category,
          url: (0, _get2.default)(siteConfig, 'url') + '/' + _category,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/' + _category,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':' + _category + ':front',
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      tag: function tag() {
        _tag = (0, _get2.default)(tagPageData, 'slug', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: _tag,
          pageName: siteSlug + ':taxonomy:' + _tag,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/section/' + _tag,
          url: (0, _get2.default)(siteConfig, 'url') + '/section/' + _tag,
          prop1: '',
          prop2: '',
          prop3: (0, _get2.default)(tagPageData, 'name'),
          prop4: (0, _get2.default)(siteConfig, 'url') + '/section/' + _tag,
          prop5: _tag,
          prop6: _tag,
          prop7: '',
          prop8: 'Fast Company Contributor',
          prop9: '',
          prop10: '',
          prop11: 'Fast Company Contributor',
          prop22: 'anonymous:' + siteSlug + ':taxonomy:' + _tag,
          prop28: 'tag',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      author: function author() {
        var authorSlug = (0, _get2.default)(authorPageData, 'slug', 'fastcompany-staff');
        var authorName = (0, _get2.default)(authorPageData, 'name', 'Fastcompany Staff');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: '',
          pageName: siteSlug + ':user:' + authorSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/user/' + authorSlug,
          url: (0, _get2.default)(siteConfig, 'url') + '/user/' + authorSlug,
          prop1: '',
          prop2: '',
          prop3: authorName,
          prop4: (0, _get2.default)(siteConfig, 'url') + '/user/' + authorSlug,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: authorName,
          prop9: '',
          prop10: '',
          prop11: authorName,
          prop22: 'anonymous:' + siteSlug + ':user:' + authorSlug,
          prop28: 'user',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      search: function search() {
        var searchQuery = (0, _get2.default)(searchPageData, 'query.queryString', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: '',
          pageName: siteSlug + ':search:' + searchQuery,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/search/' + searchQuery,
          prop1: '',
          prop2: '',
          prop3: searchQuery,
          prop4: (0, _get2.default)(siteConfig, 'url') + '/search/' + searchQuery,
          prop5: searchQuery,
          prop6: searchQuery,
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':search:' + searchQuery,
          prop28: 'search',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      page: function page() {
        var pageSlug = (0, _get2.default)(staticPageData, 'slug', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: '',
          pageName: siteSlug + ':page:' + pageSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/' + pageSlug,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/' + pageSlug,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':page:' + pageSlug,
          prop28: 'page',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      personPage: function personPage() {
        var personSlug = (0, _get2.default)(personPageData, 'data.rows[0].url');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'mcp',
          pageName: siteSlug + ':person:' + personSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/person/' + personSlug,
          url: (0, _get2.default)(siteConfig, 'url') + '/person/' + personSlug,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/person/' + personSlug,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':person:' + personSlug,
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      personIndexSectionPage: function personIndexSectionPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'person',
          pageName: siteSlug + ':person-index',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/person',
          url: (0, _get2.default)(siteConfig, 'url') + '/person',
          prop1: '',
          prop2: '',
          prop3: 'Person Index',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/person',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':person-index',
          prop28: 'person',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      mostCreativePeoplePage: function mostCreativePeoplePage() {
        var year = (0, _get2.default)(mostCreativePeoplePageData, 'year', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'mcp',
          pageName: year ? siteSlug + ':mcp:' + year : siteSlug + ':mcp:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people/' + year,
          url: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people/' + year,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people/' + year,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':page:mcp',
          prop28: 'mcp',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      mostCreativePeopleCommunityPage: function mostCreativePeopleCommunityPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'MCP',
          pageName: siteSlug + ':most-creative-people-community',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people-community',
          url: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people-community',
          prop1: '',
          prop2: '',
          prop3: 'Most Creative People Community Page',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people-community',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':mcp:community',
          prop28: 'mcp',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      ibdPage: function ibdPage() {
        var year = (0, _get2.default)(ibdPageData, 'year', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'ibd',
          pageName: year ? siteSlug + ':ibd:' + year : siteSlug + ':ibd:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design/' + year,
          url: (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design/' + year,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design/' + year,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':page:ibd',
          prop28: 'ibd',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      productIndexSectionPage: function productIndexSectionPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'product',
          pageName: 'product:homepage:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          url: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:ibd:homepage:front',
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      productIndexPage: function productIndexPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'product',
          pageName: 'product:homepage:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          url: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/stuff',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:ibd:homepage:front',
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      productPage: function productPage() {
        var productName = (0, _get2.default)(productPageData, 'data.rows[0].name');
        var productSlug = (0, _get2.default)(productPageData, 'data.rows[0].url');

        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'product',
          pageName: 'product:' + productSlug,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/product/' + productSlug,
          url: (0, _get2.default)(siteConfig, 'url') + '/product/' + productSlug,
          prop1: '',
          prop2: '',
          prop3: 'Product: ' + productName,
          prop4: (0, _get2.default)(siteConfig, 'url') + '/product/' + productSlug,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:product:' + productSlug,
          prop28: 'product',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      companyPage: function companyPage() {
        var companyURL = (0, _get2.default)(companyPageData, 'data.rows[0].url', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'company',
          pageName: 'anonymous:company:profile:' + companyURL,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/company/' + companyURL,
          url: (0, _get2.default)(siteConfig, 'url') + '/company/' + companyURL,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/company/' + companyURL,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:company:profile:' + companyURL,
          prop28: 'company',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      companyIndexSectionPage: function companyIndexSectionPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'company',
          pageName: 'company:index',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/company',
          url: (0, _get2.default)(siteConfig, 'url') + '/company',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/company',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:company:index',
          prop28: 'company',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      micYearPage: function micYearPage() {
        var year = (0, _get2.default)(micPageData, 'year', '');
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'mic',
          pageName: year ? siteSlug + ':mic:' + year : siteSlug + ':mic:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year,
          url: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':mic',
          prop28: 'mic',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      micSectorPage: function micSectorPage() {
        var year = (0, _get2.default)(micSectorPageData, 'year', '');
        var sector = (0, _get2.default)(micSectorPageData, 'sector', '');

        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'mic',
          pageName: siteSlug + ':mic:' + year + ':' + sector,
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year + '/' + sector,
          url: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year + '/' + sector,
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year + '/' + sector,
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:' + siteSlug + ':mic:' + year + ':' + sector,
          prop28: 'mic',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      videoPage: function videoPage() {
        var currentVideoData = (0, _get2.default)(videoPageData, 'data.playlist[0]', null);
        if (!currentVideoData) {
          return;
        }

        var videoPageTag = (0, _get2.default)(currentVideoData, 'category');
        var postID = (0, _get2.default)(currentVideoData, 'id');

        // Extend original omniture variable
        omniture = (0, _extend2.default)({}, omniture, {
          pageName: siteSlug + ':' + postID + ':' + (0, _get2.default)(currentVideoData, 'slug'),
          channel: 'video',
          prop1: 'video',
          prop2: 'video',
          prop3: (0, _get2.default)(currentVideoData, 'title'),
          prop4: (0, _get2.default)(currentVideoData, 'link'),
          prop5: videoPageTag,
          prop6: videoPageTag,
          prop7: '',
          prop8: 'FastCo Studios',
          prop9: (0, _get2.default)(currentVideoData, 'omnitureDate'),
          prop10: postID,
          prop11: 'FastCo Studios',
          prop22: 'anonymous:' + siteSlug + ':' + postID + ':' + (0, _get2.default)(currentVideoData, 'slug'),
          prop28: 'video',
          prop31: '',
          prop32: '',
          prop33: (0, _capitalize2.default)('video'),
          prop34: ''
        });
      },
      videoIndexPage: function videoIndexPage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'video',
          pageName: 'fastcompany:video:front',
          pageURL: 'https://www.fastcompany.com/videos',
          url: 'https://www.fastcompany.com/videos',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: 'https://www.fastcompany.com/videos',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:fastcompany:video:front',
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      },
      magazineArchivePage: function magazineArchivePage() {
        omniture = (0, _extend2.default)({}, omniture, {
          channel: 'magazine',
          pageName: 'magazine:magazine-archives:front',
          pageURL: (0, _get2.default)(siteConfig, 'url') + '/magazine/archives',
          url: (0, _get2.default)(siteConfig, 'url') + '/magazine/archives',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: (0, _get2.default)(siteConfig, 'url') + '/magazine/archives',
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop22: 'anonymous:magazine:archives:front',
          prop28: 'magazine',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: ''
        });
      }
    };

    if (typeLookup[type]) {
      typeLookup[type]();
    }

    (0, _map2.default)(omniture, function (value, key) {
      window.fastco_s[key] = value;
    });

    // Track page number
    if (pageNumber) {
      // sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
      window.fastco_s.linkTrackVars = 'events';
      window.fastco_s.linkTrackEvents = 'event31';
      window.fastco_s.events = 'event31';
      window.fastco_s.tl(this, 'o', pageNumber);
    }

    window.fastco_s.t();
  }
}

function trackOmniture(sEvent, sValue) {
  if (_exenv.canUseDOM) {
    if (!window.fastco_s) {
      // console.error('Omniture not initialized, please include omniture s_code.js');
      return;
    }

    if (!sEvent || !sValue) {
      // console.error('Tracking parameters not provided');
      return;
    }

    // sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
    window.fastco_s.linkTrackVars = 'events';
    window.fastco_s.linkTrackEvents = sEvent;
    window.fastco_s.events = sEvent;
    window.fastco_s.tl(this, 'o', sValue);
  }
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadComscoreTracker;
exports.sendComscoreCandidatePing = sendComscoreCandidatePing;

var _axios = __webpack_require__(53);

var _axios2 = _interopRequireDefault(_axios);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadComscoreTracker(currentState) {
  var site = (0, _get2.default)(currentState, 'context.site', 'fastcompany');
  var comscoreConfig = (0, _get2.default)(_identity2.default[site], 'comscore');
  var c1 = comscoreConfig.c1,
      c2 = comscoreConfig.c2;

  if (site) {
    site = site.toUpperCase();
  } else {
    site = window.location.hostname;
  }
  // reset COMSCORE
  if (window.COMSCORE && window.COMSCORE.beacon) {
    window.COMSCORE.beacon({
      c1: c1,
      c2: c2,
      options: {
        url_append: 'comscorekw=' + site
      }
    });
    _axios2.default.get('/comscore_ping').catch(function (error) {
      _logger_service2.default.error(error, 'Comscore page view candidate failed');
    });
  }
}

function sendComscoreCandidatePing() {
  // figure out domain site name and deal with subdomains etc
  var hostNameSplit = window.location.hostname.split('.');
  var site = hostNameSplit.length === 2 ? hostNameSplit[0] : hostNameSplit[1];
  var comscoreConfig = (0, _get2.default)(_identity2.default[site], 'comscore', {});
  var c1 = comscoreConfig.c1,
      c2 = comscoreConfig.c2;


  if (site) {
    site = site.toUpperCase();
  }
  // reset COMSCORE
  if (window.COMSCORE && window.COMSCORE.beacon) {
    window.COMSCORE.beacon({
      c1: c1,
      c2: c2,
      options: {
        url_append: 'comscorekw=' + site
      }
    });
    _axios2.default.get('/comscore_ping').catch(function (error) {
      _logger_service2.default.error(error, 'Comscore page view candidate failed');
    });
  }
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSlick = __webpack_require__(104);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _arrow = __webpack_require__(245);

var _arrow2 = _interopRequireDefault(_arrow);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _cloudinary_asset_util = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var prevArrow = _react2.default.createElement(
  'div',
  null,
  _react2.default.createElement(
    'svg',
    {
      width: '23',
      height: '52',
      viewBox: '0 0 23 52',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement('path', {
      d: 'M22 51L2 26 22 1',
      strokeWidth: '2',
      stroke: '#CCC',
      fill: 'none',
      fillRule: 'evenodd'
    })
  )
);

var nextArrow = _react2.default.createElement(
  'div',
  null,
  _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '23',
      height: '52',
      viewBox: '0 0 23 52'
    },
    _react2.default.createElement('path', {
      d: 'M1 1l20 25L1 51',
      strokeWidth: '2',
      stroke: '#CCC',
      fill: 'none',
      fillRule: 'evenodd'
    })
  )
);

var RelatedSlider = function (_Component) {
  _inherits(RelatedSlider, _Component);

  function RelatedSlider(props) {
    _classCallCheck(this, RelatedSlider);

    var _this = _possibleConstructorReturn(this, (RelatedSlider.__proto__ || Object.getPrototypeOf(RelatedSlider)).call(this));

    _this.renderRelatedCard = _this.renderRelatedCard.bind(_this);
    _this.generateClassNames = _this.generateClassNames.bind(_this);
    _this.handleSlideChange = _this.handleSlideChange.bind(_this);
    _this.slidesToScroll = (0, _get2.default)(props, 'responsive[1].settings.slidesToScroll') || 3;

    _this.settings = {
      prevArrow: _react2.default.createElement(_arrow2.default, { markup: prevArrow }),
      nextArrow: _react2.default.createElement(_arrow2.default, { markup: nextArrow }),
      accessibility: true,
      slide: '.video-slide--no-border',
      infinite: false,
      responsive: props.responsive ? props.responsive : [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 100000,
        settings: {
          slidesToShow: 3.3,
          slidesToScroll: _this.slidesToScroll
        }
      }]
    };

    var slideCount = props.related.length;
    _this.maxNext = Math.floor(slideCount / _this.slidesToScroll);
    return _this;
  }

  _createClass(RelatedSlider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state, react/no-unused-state
      this.setState({ settings: this.settings, paddlesToShow: [0, 1] });
    }
  }, {
    key: 'generateClassNames',
    value: function generateClassNames() {
      var classnames = ['related-slider'];
      if (this.props.classNames) {
        classnames = classnames.concat(this.props.classNames);
      }

      if (!(0, _get2.default)(this.state, 'paddlesToShow[0]')) {
        classnames.push('related-slider--initial');
      }

      if (!(0, _get2.default)(this.state, 'paddlesToShow[1]')) {
        classnames.push('related-slider--end');
      }

      return classnames.join(' ');
    }
  }, {
    key: 'handleSlideChange',
    value: function handleSlideChange(index) {
      if (index === 0) {
        return this.setState({
          paddlesToShow: [0, 1]
        });
      }

      if (index / this.slidesToScroll >= this.maxNext) {
        return this.setState({
          paddlesToShow: [1, 0]
        });
      }

      if (!this.state.paddlesToShow.reduce(function (accum, currVal) {
        return accum && currVal;
      })) {
        return this.setState({
          paddlesToShow: [1, 1]
        });
      }

      return true;
    }
  }, {
    key: 'renderRelatedCard',
    value: function renderRelatedCard(relatedVid) {
      var _this2 = this;

      var config = this.props.config;

      var post = (0, _assign2.default)({}, relatedVid, {
        assetSizes: _cloudinary_asset_util.imageSizesLookup.column
      });

      var generateClassNames = function generateClassNames() {
        var classes = ['video-slide'];

        if (_this2.props.slideClassNames) {
          classes = [].concat(_toConsumableArray(classes), _toConsumableArray(_this2.props.slideClassNames));
        }

        return classes.join(' ');
      };

      return _react2.default.createElement(
        'div',
        { className: generateClassNames(), key: post.id },
        _react2.default.createElement(_card2.default, { type: 'video', metadata: post, config: config })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.generateClassNames() },
        _react2.default.createElement(_slug2.default, { slugName: this.props.title, className: 'related-slider' }),
        _react2.default.createElement(
          'div',
          null,
          this.state ? _react2.default.createElement(
            _reactSlick2.default,
            _extends({}, (0, _get2.default)(this.state, 'settings', {}), {
              afterChange: this.handleSlideChange
            }),
            this.props.related.map(this.renderRelatedCard)
          ) : ''
        )
      );
    }
  }]);

  return RelatedSlider;
}(_react.Component);

exports.default = RelatedSlider;


RelatedSlider.defaultProps = {
  title: 'Related',
  classNames: [],
  responsive: null,
  slideClassNames: ''
};

RelatedSlider.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  title: _propTypes2.default.string,
  classNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
  responsive: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  slideClassNames: _propTypes2.default.string
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(78),
    baseUniq = __webpack_require__(130);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStickynode = __webpack_require__(77);

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _recommender = __webpack_require__(612);

var _recommender2 = _interopRequireDefault(_recommender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar() {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this));

    _this.buildClassName = _this.buildClassName.bind(_this);
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'calculateAds',
    value: function calculateAds(article) {
      if (!article) {
        return 1;
      }
      var AVERAGE_P_TAG_HEIGHT = 175;
      var AVERAGE_FIGURE_TAG_HEIGHT = 485;
      var AVERAGE_DISTANCE_INBETWEEN_ADS = 1400;
      var MIN_ADS = 1;
      var MAX_ADS = 12;

      var ps = (article.match(/<p/g) || []).length;
      var figures = (article.match(/<figure/g) || []).length;
      var height = ps * AVERAGE_P_TAG_HEIGHT + figures * AVERAGE_FIGURE_TAG_HEIGHT;
      var totalAds = Math.round(height / AVERAGE_DISTANCE_INBETWEEN_ADS);

      if (!totalAds) {
        totalAds = MIN_ADS;
      } else if (totalAds > MAX_ADS) {
        totalAds = MAX_ADS;
      }

      return totalAds;
    }
  }, {
    key: 'buildClassName',
    value: function buildClassName() {
      var _props = this.props,
          fullPageAdvertorial = _props.fullPageAdvertorial,
          isVideoPost = _props.isVideoPost;

      var className = ['post__promotion'];

      if (isVideoPost) {
        className.push('post__promotion--video');
      }

      if (fullPageAdvertorial) {
        className.push('post__promotion--advertorial');
      }

      return className.join(' ');
    }
  }, {
    key: 'renderSidebar',
    value: function renderSidebar() {
      var _props2 = this.props,
          config = _props2.config,
          post = _props2.post,
          isFirstPost = _props2.isFirstPost,
          combinedAdModel = _props2.combinedAdModel,
          isDesktop = _props2.isDesktop,
          totalAdCount = _props2.totalAdCount,
          isLongPost = _props2.isLongPost,
          isVideoPost = _props2.isVideoPost;


      var totalAds = isLongPost && !isVideoPost ? totalAdCount : 1;
      var ads = [];

      for (var i = 0; i < totalAds; i += 1) {
        ads.push(_react2.default.createElement(
          'div',
          {
            key: i,
            className: this.buildClassName(),
            id: 'post-ad-' + post.id + '-' + i
          },
          _react2.default.createElement(
            _reactStickynode2.default,
            {
              top: 100,
              bottomBoundary: '#post-ad-' + post.id + '-' + i,
              enabled: isDesktop || false
            },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
              noLazyLoad: i === 0 && isFirstPost,
              pos: i === 0 ? 'atf' : 'btf',
              name: i === 0 && (0, _get2.default)(this.props, 'post.posterSlideshow') ? 'slideshowhalfpage' : i === 0 ? 'flexibleportrait' : 'flexiblehalfpage_' + i,
              canRefresh: !!(0, _get2.default)(this.props, 'post.posterSlideshow'),
              pageNum: (0, _get2.default)(this.props, 'pageNum')
            })),
            i === 0 && isLongPost && !isVideoPost ? _react2.default.createElement(
              'div',
              { className: 'post__relative' },
              _react2.default.createElement(_recommender2.default, { initialPageLoad: config.initialPageLoad })
            ) : null
          )
        ));
      }

      return ads;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'post__sidebar ' + (this.props.isVideoPost ? 'post__sidebar--video' : '')
        },
        this.renderSidebar()
      );
    }
  }]);

  return Sidebar;
}(_react.Component);

exports.default = Sidebar;


Sidebar.defaultProps = {
  related: [],
  isDesktop: false,
  fullPageAdvertorial: false,
  totalAdCount: 2
};

Sidebar.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  post: _propTypes2.default.shape({}).isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  isDesktop: _propTypes2.default.bool,
  fullPageAdvertorial: _propTypes2.default.bool,
  totalAdCount: _propTypes2.default.number,
  isLongPost: _propTypes2.default.bool.isRequired,
  isVideoPost: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jsonp = __webpack_require__(615);

var _jsonp2 = _interopRequireDefault(_jsonp);

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

var _feature_flags = __webpack_require__(75);

var _feature_flags2 = _interopRequireDefault(_feature_flags);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RevContent = function (_PureComponent) {
  _inherits(RevContent, _PureComponent);

  function RevContent(props) {
    _classCallCheck(this, RevContent);

    var _this = _possibleConstructorReturn(this, (RevContent.__proto__ || Object.getPrototypeOf(RevContent)).call(this, props));

    _this.state = {
      revcontentStories: null
    };
    _this.storiesRequested = false;
    _this.revDiv = null;
    return _this;
  }

  _createClass(RevContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.state.revcontentStories && !this.storiesRequested && !_feature_flags2.default.revContentJSWidgetEnabled) {
        this.getRCData();
        this.storiesRequested = true;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (_feature_flags2.default.revContentJSWidgetEnabled) {
        if (!this.props.initialPageLoad && _exenv2.default && this.storiesRequested === false) {
          var widgetID = this.props.site === 'fastcompany' ? '77613' : '85314';

          /* eslint-disable */
          var referer = '';
          try {
            if (referer = document.referrer, typeof referer === 'undefined') throw 'undefined';
          } catch (exception) {
            referer = document.location.href, (referer == '' || typeof referer === 'undefined') && (referer = document.URL);
          }
          referer = referer.substr(0, 700);
          var rcel = document.createElement('script');
          rcel.id = 'rc_' + Math.floor(Math.random() * 1000);
          rcel.type = 'text/javascript';
          rcel.src = 'https://trends.revcontent.com/serve.js.php?w=' + widgetID + '&t=' + rcel.id + '&c=' + new Date().getTime() + '&width=' + (window.outerWidth || document.documentElement.clientWidth) + '&referer=' + referer;
          rcel.async = true;
          this.revDiv.innerHTML = '';
          this.revDiv.appendChild(rcel);
          /* eslint-enable */

          this.storiesRequested = true;
        }
      }
    }
  }, {
    key: 'getRCData',
    value: function getRCData() {
      var _this2 = this;

      if (!this.state.revcontentStories && !this.storiesRequested) {
        var site = this.props.site;

        var widgetID = site === 'fastcompany' ? '65657' : '65662';
        var domainID = site + '.com';

        var rcURL = '//trends.revcontent.com/api/v1/?' + 'api_key=573921e5aacb705a54512738b54b0f0bceb4cf94' + '&pub_id=6590' + ('&widget_id=' + widgetID) + ('&domain=' + encodeURI(domainID)) + ('&referer=' + encodeURI(window.location.href)) + '&format=json' + '&sponsored_count=4' + '&sponsored_offset=0' + '&internal_count=0' + '&internal_offset=0';

        (0, _jsonp2.default)(rcURL, null, function (err, data) {
          if (err) {
            _logger_service2.default.error(err.message, 'Unable to fetch revcontent stories');
          } else {
            _this2.setState({
              revcontentStories: data
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (_feature_flags2.default.revContentJSWidgetEnabled) {
        if (!this.props.initialPageLoad && _exenv2.default) {
          return _react2.default.createElement(
            'section',
            { className: 'post-more-stories post-more-stories--revcontent' },
            _react2.default.createElement('div', {
              id: 'rcjsload_a3c485',
              ref: function ref(revDiv) {
                _this3.revDiv = revDiv;
              }
            })
          );
        }
        return null;
      }

      if (!this.state.revcontentStories) {
        return null;
      }

      return _react2.default.createElement(
        'section',
        { className: 'post-more-stories post-more-stories--revcontent' },
        _react2.default.createElement(
          'div',
          { className: 'homepage-tag__advertorial-title-container' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'slug-component' },
              _react2.default.createElement(
                'h2',
                { className: 'slug category-page__slug' },
                'From Around The Web'
              )
            ),
            _react2.default.createElement(
              'h3',
              { className: 'page-description' },
              'Powered by RevContent'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row row--revcontent' },
          this.state.revcontentStories.map(function (story) {
            return _react2.default.createElement(
              'div',
              { key: story.url, className: 'card-wrapper card-wrapper--4' },
              _react2.default.createElement(
                'article',
                { className: 'card' },
                _react2.default.createElement(
                  'a',
                  { href: story.url, title: story.headline },
                  _react2.default.createElement(
                    'figure',
                    { className: 'poster' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('img', { src: story.image, alt: story.headline })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'text-wrapper' },
                    _react2.default.createElement(
                      'span',
                      { className: 'eyebrow' },
                      story.brand
                    ),
                    _react2.default.createElement(
                      'h2',
                      { className: 'title' },
                      story.headline
                    )
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return RevContent;
}(_react.PureComponent);

exports.default = RevContent;


RevContent.defaultProps = {
  site: 'fastcompany'
};

RevContent.propTypes = {
  site: _propTypes2.default.string,
  initialPageLoad: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouterDom = __webpack_require__(32);

var _reactRouter = __webpack_require__(22);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _urlParse = __webpack_require__(45);

var _urlParse2 = _interopRequireDefault(_urlParse);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var SitemapIndex = function (_Component) {
  _inherits(SitemapIndex, _Component);

  function SitemapIndex() {
    _classCallCheck(this, SitemapIndex);

    return _possibleConstructorReturn(this, (SitemapIndex.__proto__ || Object.getPrototypeOf(SitemapIndex)).apply(this, arguments));
  }

  _createClass(SitemapIndex, [{
    key: 'render',
    value: function render() {
      if (this.props.htmlSitemapIndexPage.error && this.props.htmlSitemapIndex.error) {
        return _react2.default.createElement(
          'section',
          { className: 'wp-page' },
          _react2.default.createElement(
            'article',
            { className: 'wp-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.htmlSitemapIndexPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var pathname = (0, _get2.default)(this.props, 'route.path');
      var htmlSitemapIndexReversed = (0, _get2.default)(this.props, 'htmlSitemapIndex.urls', []).reverse();

      if (pathname === '/sitemap') {
        return _react2.default.createElement(
          'section',
          { className: 'html-sitemap-index-page' },
          _react2.default.createElement(
            'div',
            { className: 'html-sitemap-index-page__main' },
            _react2.default.createElement(
              'h1',
              { className: 'html-sitemap-index-page__heading' },
              'Site Map'
            ),
            _react2.default.createElement(
              'div',
              { className: 'html-sitemap-index-page__body' },
              htmlSitemapIndexReversed.map(function sitemapLink(url) {
                var urlString = url.link.toString();
                var year = urlString.slice(-4);
                return _react2.default.createElement(
                  _reactRouterDom.Link,
                  {
                    to: url.link.replace((0, _urlParse2.default)(url.link).origin, ''),
                    className: 'url--year',
                    key: url.link
                  },
                  year
                );
              })
            )
          )
        );
      }

      var year = (0, _get2.default)(this.props, 'match.params.year');

      return _react2.default.createElement(
        'section',
        { className: 'html-sitemap-index-page' },
        _react2.default.createElement(
          'div',
          { className: 'html-sitemap-index-page__main' },
          _react2.default.createElement(
            'h1',
            { className: 'html-sitemap-index-page__heading' },
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: '/sitemap' },
              'Site Map'
            ),
            ' > ',
            year
          ),
          _react2.default.createElement(
            'div',
            { className: 'html-sitemap-index-page__body' },
            (0, _get2.default)(this.props, 'htmlSitemapIndex.urls', []).map(function sitemapLink(url) {
              var parsedUrl = (0, _urlParse2.default)(url.link, true);
              return _react2.default.createElement(
                _reactRouterDom.Link,
                {
                  to: url.link.replace(parsedUrl.origin, ''),
                  className: 'url--week',
                  key: url.link
                },
                url.timeframe
              );
            })
          )
        )
      );
    }
  }]);

  return SitemapIndex;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    htmlSitemapIndexPage: state.htmlSitemapIndexPage || [],
    htmlSitemapIndex: (0, _get2.default)(state, 'htmlSitemapIndex.data') || { error: true }
  };
}

SitemapIndex.propTypes = {
  htmlSitemapIndexPage: _propTypes2.default.shape({
    // eslint-disable-next-line
    error: _propTypes2.default.shape({}),
    isLoading: _propTypes2.default.bool
  }).isRequired,
  htmlSitemapIndex: _propTypes2.default.shape({
    // eslint-disable-next-line
    urls: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    error: _propTypes2.default.bool
  }).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(SitemapIndex));

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchHtmlSitemapIndexData;

var _exenv = __webpack_require__(4);

var _async_html_sitemap_index_page_actions = __webpack_require__(629);

var _async_html_sitemap_index_page_actions2 = _interopRequireDefault(_async_html_sitemap_index_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchHtmlSitemapIndexData(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_html_sitemap_index_page_actions2.default)(nextState, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_html_sitemap_index_page_actions2.default)(nextState, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleServerSideRenderError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

exports.arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

exports.isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductPage;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

var _social = __webpack_require__(52);

var _social2 = _interopRequireDefault(_social);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _sidebar = __webpack_require__(250);

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function processAssetServerImage(imgSrc) {
  if (typeof imgSrc !== 'string') {
    return '';
  }

  return 'https://a.fastcompany.net/image/fetch/w_599,q_auto,f_auto,fl_lossy/https:' + imgSrc;
}

function renderSocialMedia(product) {
  var socialMedia = (0, _get2.default)(product, 'social_media') || [];
  var name = (0, _get2.default)(product, 'name');

  if (!socialMedia.length) return null;

  return _react2.default.createElement(
    'div',
    { className: 'person-company-component__social-media' },
    _react2.default.createElement(
      'span',
      { className: 'person-company-component__social-media-title' },
      name,
      ' On The Web'
    ),
    socialMedia.map(function (item) {
      return _react2.default.createElement(
        'div',
        {
          key: item.name,
          className: 'person-company-component__social-media-item'
        },
        item.name === 'Website' ? _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: item.value },
            item.name
          )
        ) : _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            { href: 'https://' + item.name + '.com/' + item.value },
            item.name
          )
        )
      );
    })
  );
}

function creatorListGenerator(people, companies) {
  if (!people && !companies) return null;
  var i = void 0;
  var list = [];
  if (people) {
    for (i = 0; i < people.length; i += 1) {
      list.push(people[i].first_name + ' ' + people[i].last_name);
    }
  }

  if (companies) {
    for (i = 0; i < companies.length; i += 1) {
      list.push(companies[i].name);
    }
  }

  return list.join(', ');
}

function ProductPage(props) {
  var product = props.product,
      config = props.config,
      combinedAdModel = props.combinedAdModel,
      gift = props.gift;

  var name = (0, _get2.default)(product, 'name');
  var description = (0, _get2.default)(product, 'description');
  var url = 'https://www.fastcodesign.com/product/' + (0, _get2.default)(product, 'url');
  var poster = processAssetServerImage((0, _get2.default)(product, 'images[0].url'));
  var posterCaption = (0, _striptags2.default)((0, _get2.default)(product, 'images[0].caption')).length ? (0, _striptags2.default)((0, _get2.default)(product, 'images[0].caption')) : null;
  var posterCredit = (0, _striptags2.default)((0, _get2.default)(product, 'images[0].credit')).length ? (0, _striptags2.default)((0, _get2.default)(product, 'images[0].credit')) : null;
  // const socialMedia = get(product, 'social_media');
  var firms = (0, _get2.default)(product, 'firms');
  var creatorPeople = (0, _get2.default)(product, 'creator_people');
  var creatorCompany = (0, _get2.default)(product, 'creator_company');
  var creatorList = creatorListGenerator(creatorPeople, creatorCompany);

  var encodedUrl = encodeURIComponent(url);
  var shareCopy = encodeURIComponent('Read more about ' + name + ' on @FastCoDesign');

  return _react2.default.createElement(
    'section',
    { className: 'post post--product' },
    _react2.default.createElement(
      'div',
      { className: 'post__main' },
      _react2.default.createElement(
        'header',
        { className: 'post__header' },
        _react2.default.createElement(
          'ul',
          { className: 'eyebrow' },
          gift ? _react2.default.createElement(
            'li',
            { className: 'eyebrow__item' },
            _react2.default.createElement(
              'a',
              { href: '/gift-guide/holiday-2017' },
              'Holiday Gift Guide 2017'
            )
          ) : [_react2.default.createElement(
            'li',
            { className: 'eyebrow__item' },
            _react2.default.createElement(
              'a',
              { href: '/stuff' },
              'Product'
            )
          ), _react2.default.createElement(
            'li',
            { className: 'eyebrow__item' },
            'Profile'
          )]
        ),
        _react2.default.createElement(
          'div',
          { className: 'post__title-group' },
          _react2.default.createElement(
            _fc_link2.default,
            { config: config, to: url, title: name },
            _react2.default.createElement(
              'h1',
              { className: 'post__title' },
              name
            )
          ),
          gift ? _react2.default.createElement(
            'div',
            { className: 'post__price' },
            _react2.default.createElement(
              'span',
              null,
              '$',
              product.price
            ),
            _react2.default.createElement(
              'a',
              { href: product.affiliate_link, target: '_blank' },
              'Buy Now'
            )
          ) : null
        ),
        _react2.default.createElement(
          'h2',
          { className: 'post__deck post__deck--creators' },
          firms.length ? firms.map(function (firm) {
            return _react2.default.createElement(
              'a',
              {
                key: firm.url,
                href: '//www.fastcompany.com/company/' + firm.url
              },
              firm.name
            );
          }) : ''
        ),
        _react2.default.createElement(
          'div',
          null,
          poster ? _react2.default.createElement(
            'figure',
            { className: 'poster post-featured__poster' },
            _react2.default.createElement('img', { src: poster, alt: name, title: name })
          ) : '',
          posterCaption || posterCredit ? _react2.default.createElement(
            'div',
            { className: 'post__featured-caption' },
            '' + (posterCaption || '') + (posterCredit || '')
          ) : ''
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'post__container' },
        _react2.default.createElement(_social2.default, {
          enableSticky: false,
          text: shareCopy,
          uri: encodedUrl,
          modifier: 'product-page'
        }),
        _react2.default.createElement(
          'div',
          { className: 'post__content' },
          _react2.default.createElement('article', {
            className: 'post__article',
            dangerouslySetInnerHTML: { __html: description }
          }),
          creatorList ? _react2.default.createElement(
            'div',
            { className: 'product-creators' },
            _react2.default.createElement(
              'span',
              { className: 'product-creators__title' },
              'Creators: '
            ),
            _react2.default.createElement(
              'span',
              { className: 'product-creators__list' },
              creatorList
            )
          ) : '',
          renderSocialMedia(product),
          gift ? _react2.default.createElement(
            'a',
            {
              className: 'post__back-to-gift-guide',
              href: '/gift-guide/holiday-2017'
            },
            '< Back to Holiday Gift Guide 2017'
          ) : null
        )
      )
    ),
    _react2.default.createElement(_sidebar2.default, {
      post: product,
      isFirstPost: false,
      combinedAdModel: combinedAdModel,
      config: config,
      relatedHeight: 0,
      fullPageAdvertorial: false,
      totalAdCount: 1,
      isLongPost: false,
      isVideoPost: false
    })
  );
}

ProductPage.defaultProps = {
  gift: false
};

ProductPage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  product: _propTypes2.default.shape({}).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  gift: _propTypes2.default.bool
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _franchise_accordion_section = __webpack_require__(151);

var _franchise_accordion_section2 = _interopRequireDefault(_franchise_accordion_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var ProductIndexSectionPage = function (_Component) {
  _inherits(ProductIndexSectionPage, _Component);

  function ProductIndexSectionPage(props) {
    _classCallCheck(this, ProductIndexSectionPage);

    var _this = _possibleConstructorReturn(this, (ProductIndexSectionPage.__proto__ || Object.getPrototypeOf(ProductIndexSectionPage)).call(this, props));

    _this.alphabet = ['0-9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    return _this;
  }

  _createClass(ProductIndexSectionPage, [{
    key: 'render',
    value: function render() {
      if (this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.productIndexSectionPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'product-page' },
          _react2.default.createElement(
            'article',
            { className: 'product-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          productIndexSectionData = _props.productIndexSectionData,
          productIndexSectionNextData = _props.productIndexSectionNextData;

      var adData = (0, _get2.default)(this.props, 'productIndexSectionPage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgTitle = 'product index';
      var pgDesc = 'A list of products Co.Design has featured including finalists and winners of Innovation by Design Awards';
      var section = (0, _get2.default)(this.props, 'match.params.section');
      var page = Number((0, _get2.default)(this.props, 'match.params.page'));
      var nextPage = page && !(0, _isEmpty2.default)(productIndexSectionNextData) ? String(page + 1) : null;
      var prevPage = page > 1 ? String(page - 1) : null;

      return _react2.default.createElement(
        'section',
        { className: 'product-index-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'section',
          { className: 'page-title product-index-page__page-title' },
          _react2.default.createElement(_slug2.default, { slugName: pgTitle, className: 'category-page' }),
          _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          )
        ),
        this.alphabet.map(function (letter) {
          return _react2.default.createElement(_franchise_accordion_section2.default, {
            combinedAdModel: combinedAdModel,
            index: letter,
            key: letter,
            data: productIndexSectionData,
            propertyToDisplay: 'name',
            prevPage: prevPage,
            nextPage: nextPage,
            activeSection: section,
            pathForSection: 'stuff',
            pathForData: 'product'
          });
        })
      );
    }
  }]);

  return ProductIndexSectionPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    productIndexSectionData: (0, _get2.default)(state, 'productIndexSection.data') || {},
    productIndexSectionNextData: (0, _get2.default)(state, 'productIndexSectionNext.data') || {},
    productIndexSectionPage: Object.keys((0, _get2.default)(state, 'productIndexPage')).length ? (0, _get2.default)(state, 'productIndexPage') : (0, _get2.default)(state, 'productIndexSectionPage') || {}
  };
}

ProductIndexSectionPage.defaultProps = {
  status: 200,
  productIndexSectionData: {},
  productIndexSectionNextData: {},
  productIndexSectionPage: {}
};

ProductIndexSectionPage.propTypes = {
  status: _propTypes2.default.number,
  productIndexSectionData: _propTypes2.default.shape({}),
  productIndexSectionNextData: _propTypes2.default.shape({}),
  productIndexSectionPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  })
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(ProductIndexSectionPage));

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _franchise_accordion_section = __webpack_require__(151);

var _franchise_accordion_section2 = _interopRequireDefault(_franchise_accordion_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line
var PersonIndexSectionPage = function (_Component) {
  _inherits(PersonIndexSectionPage, _Component);

  function PersonIndexSectionPage(props) {
    _classCallCheck(this, PersonIndexSectionPage);

    var _this = _possibleConstructorReturn(this, (PersonIndexSectionPage.__proto__ || Object.getPrototypeOf(PersonIndexSectionPage)).call(this, props));

    _this.alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'y', 'z'];
    return _this;
  }

  _createClass(PersonIndexSectionPage, [{
    key: 'render',
    value: function render() {
      if (this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.personIndexSectionPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'person-page' },
          _react2.default.createElement(
            'article',
            { className: 'person-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          personIndexSectionData = _props.personIndexSectionData,
          personIndexSectionNextData = _props.personIndexSectionNextData;


      var adData = (0, _get2.default)(this.props, 'personIndexSectionPage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgTitle = 'person index';
      var section = (0, _get2.default)(this.props, 'match.params.section');
      var page = Number((0, _get2.default)(this.props, 'match.params.page'));
      var nextPage = page && !(0, _isEmpty2.default)(personIndexSectionNextData) ? String(page + 1) : null;
      var prevPage = page > 1 ? String(page - 1) : null;

      return _react2.default.createElement(
        'section',
        { className: 'person-index-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'section',
          { className: 'page-title person-index-page__page-title' },
          _react2.default.createElement(_slug2.default, { slugName: pgTitle, className: 'category-page' }),
          _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            'A list of people in the Fast Company database. For the Most Creative People in Business Community, please',
            ' ',
            _react2.default.createElement(
              'a',
              { href: 'https://www.fastcompany.com/most-creative-people-community' },
              'click here'
            )
          )
        ),
        this.alphabet.map(function (letter) {
          return _react2.default.createElement(_franchise_accordion_section2.default, {
            combinedAdModel: combinedAdModel,
            index: letter,
            key: letter,
            data: personIndexSectionData,
            propertyToDisplay: 'full_name',
            prevPage: prevPage,
            nextPage: nextPage,
            activeSection: section,
            pathForSection: 'person',
            pathForData: 'person'
          });
        })
      );
    }
  }]);

  return PersonIndexSectionPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    status: state.status.code,
    personIndexSectionData: (0, _get2.default)(state, 'personIndexSection.data') || {},
    personIndexSectionNextData: (0, _get2.default)(state, 'personIndexSectionNext.data') || {},
    personIndexSectionPage: Object.keys((0, _get2.default)(state, 'personIndexPage')).length ? (0, _get2.default)(state, 'personIndexPage') : (0, _get2.default)(state, 'personIndexSectionPage') || {}
  };
}

PersonIndexSectionPage.propTypes = {
  status: _propTypes2.default.number.isRequired,
  personIndexSectionData: _propTypes2.default.shape({}).isRequired,
  personIndexSectionNextData: _propTypes2.default.shape({}).isRequired,
  personIndexSectionPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(PersonIndexSectionPage));

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_person_index_section_page_actions = __webpack_require__(715);

var _async_person_index_section_page_actions2 = _interopRequireDefault(_async_person_index_section_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_person_index_section_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_person_index_section_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _advertorial = __webpack_require__(28);

var _ibd_category = __webpack_require__(261);

var _ibd_category2 = _interopRequireDefault(_ibd_category);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _franchise_intro = __webpack_require__(152);

var _franchise_intro2 = _interopRequireDefault(_franchise_intro);

var _scroll_to_el_util = __webpack_require__(79);

var _scroll_to_el_util2 = _interopRequireDefault(_scroll_to_el_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnovationByDesign = function (_Component) {
  _inherits(InnovationByDesign, _Component);

  function InnovationByDesign() {
    _classCallCheck(this, InnovationByDesign);

    return _possibleConstructorReturn(this, (InnovationByDesign.__proto__ || Object.getPrototypeOf(InnovationByDesign)).apply(this, arguments));
  }

  _createClass(InnovationByDesign, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isDesktop = (0, _client_util2.default)('64em');
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _scroll_to_el_util2.default)('.ibd-category--active', 150);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.innovationByDesignPage.error || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }
      if (this.props.innovationByDesignPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'innovation-by-design-page' },
          _react2.default.createElement(
            'article',
            { className: 'innovation-by-design-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(this.props, 'innovationByDesignPage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var innovationByDesign = this.props.innovationByDesign;


      var year = (0, _get2.default)(this.props.match, 'params.year');
      var category = (0, _get2.default)(this.props.match, 'params.category');
      var tags = (0, _get2.default)(this.props, 'tagAllFeed.posts[0].tags');
      var advertorial = (0, _advertorial.isAdvertorial)(tags);
      var pgTitle = 'Innovation By Design Awards ' + year;
      var sectionTitle = 'Innovation By Design ' + year + ' Categories';

      var poster = 'https://images.fastcompany.net/image/upload/w_387,h_218,c_fill,q_auto,f_auto,fl_lossy/v1498077352/fcweb/ibd_a2ubg2.jpg';
      var encodedText = encodeURIComponent('Innovation By Design Awards ' + year + ' #IBDawards' + year);
      var uri = 'https://www.fastcodesign.com/innovation-by-design/' + year;

      // TODO: This solution is temporary. It needs some work to make sure the text is correct for each year.
      var specialText = '';
      if (parseInt(year, 10) === 2017) {
        encodedText = "Fast Company's sixth annual Innovation By Design Awards are now announced. Read on for this year's " + 'best products, services, interfaces, and ideas.';
        specialText = "The %23FCDesignAwards include this year's best products, services, interfaces, and ideas. Be " + 'inspired by @FastCompany:';
      }

      return _react2.default.createElement(
        'section',
        {
          className: 'innovation-by-design-page ' + (advertorial ? 'innovation-by-design-page--advertorial' : '')
        },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'div',
          { className: 'ad-container ad-container--gray ad-container--hide-for-small' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileleaderboard' }))
        ),
        _react2.default.createElement(_franchise_intro2.default, {
          poster: poster,
          title: pgTitle,
          desc: this.props.innovationByDesignYearDetail,
          social: {
            enableSticky: false,
            modifier: 'feature-feed',
            text: '',
            socialText: {
              twitter: specialText,
              linkedin: encodedText,
              email: encodedText
            },
            uri: uri
          }
        }),
        _react2.default.createElement(
          'section',
          { className: 'ibd-list' },
          _react2.default.createElement(_slug2.default, { slugName: sectionTitle, className: 'ibd-list' })
        ),
        _react2.default.createElement(
          'section',
          { className: 'innovation-by-design-page__category-container' },
          innovationByDesign.map(function (cat, idx) {
            return _react2.default.createElement(_ibd_category2.default, {
              combinedAdModel: combinedAdModel,
              category: cat,
              key: (0, _get2.default)(cat, 'category_name'),
              index: String(idx),
              year: year,
              active: category === (0, _get2.default)(cat, 'url')
            });
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        )
      );
    }
  }]);

  return InnovationByDesign;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var ibdData = (0, _get2.default)(state, 'innovationByDesign.data.rows');
  var ibdYearDetail = (0, _get2.default)(state, 'innovationByDesignDetail.data.rows[0].body');

  return {
    config: state.config || {},
    status: state.status.code,
    innovationByDesignPage: (0, _get2.default)(state, 'innovationByDesignPage') || {
      error: true
    },
    innovationByDesign: ibdData || [],
    innovationByDesignYearDetail: ibdYearDetail || ''
  };
}

InnovationByDesign.defaultProps = {
  status: 200
};

InnovationByDesign.propTypes = {
  status: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  match: _propTypes2.default.shape({}).isRequired,
  innovationByDesignPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  innovationByDesign: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  innovationByDesignYearDetail: _propTypes2.default.string.isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(InnovationByDesign));

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(32);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

var _show_more = __webpack_require__(725);

var _show_more2 = _interopRequireDefault(_show_more);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function processAssetServerImage(imgSrc) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://images.fastcompany.net/image/upload/w_387,h_218,c_fill,q_auto,f_auto,fl_lossy,o_30/v1498077352/fcweb/ibd_a2ubg2.jpg';

  var updatedImgSrc = imgSrc;

  // https://fast-company-res.cloudinary.com/image/fetch/w_599,q_auto,f_auto,fl_lossy/https://a.fastcompany.net/multisite_files/fastcompany/people/2017/11/21/p-1-dazzleship-el6sdb.jpg

  if (typeof imgSrc !== 'string' || imgSrc.length === 0) {
    updatedImgSrc = placeholder;
  }

  return 'https://a.fastcompany.net/image/fetch/w_599,q_auto,f_auto,fl_lossy/https:' + updatedImgSrc;
}

var IBDCategory = function (_Component) {
  _inherits(IBDCategory, _Component);

  function IBDCategory() {
    _classCallCheck(this, IBDCategory);

    return _possibleConstructorReturn(this, (IBDCategory.__proto__ || Object.getPrototypeOf(IBDCategory)).apply(this, arguments));
  }

  _createClass(IBDCategory, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.active !== nextProps.active;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          category = _props.category,
          index = _props.index,
          year = _props.year,
          active = _props.active,
          slug = _props.slug,
          slugParam = _props.slugParam;


      var categoryName = (0, _get2.default)(category, 'category_name');
      var url = (0, _get2.default)(category, 'url');
      var judges = (0, _get2.default)(category, 'judges_people');
      var list = (0, _get2.default)(category, 'products.list');
      var winners = (0, _get2.default)(category, 'products.winners');
      var finalists = (0, _get2.default)(category, 'products.finalists');
      var mentions = (0, _get2.default)(category, 'products.mentions', []);
      var productFieldToDisplay = year >= 2017 ? 'description' : 'why';
      var param = slug === 'gift-guide' ? slugParam : year;
      var link = active ? '/' + slug + '/' + param : '/' + slug + '/' + param + '/category/' + url;

      return _react2.default.createElement(
        'section',
        {
          className: 'ibd-category ibd-category--' + index + ' ' + (active ? 'ibd-category--active' : '')
        },
        _react2.default.createElement(
          'div',
          { className: 'ibd-category__row ibd-category__row--' + index },
          _react2.default.createElement(
            _reactRouterDom.Link,
            {
              className: 'ibd-category__header ' + (active ? 'ibd-category__header--active' : ''),
              to: link
            },
            _react2.default.createElement(
              'h2',
              { className: 'ibd-category__title' },
              categoryName
            ),
            _react2.default.createElement('img', {
              className: 'ibd-category__title-icon\n              ' + (active ? ' ibd-category__title-icon--active' : ''),
              src: '//images.fastcompany.net/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg',
              alt: 'arrow icon',
              title: 'arrow icon'
            })
          ),
          active ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__dek' },
            _react2.default.createElement(
              'div',
              { className: 'ibd-category__category-description' },
              (0, _striptags2.default)(category.category_description || '')
            ),
            judges.length ? _react2.default.createElement(
              'div',
              { className: 'ibd-category__judges' },
              _react2.default.createElement(
                'span',
                { className: 'bold' },
                'Judges:'
              ),
              ' ',
              judges.map(function (judge) {
                return judge.name;
              }).join(', ')
            ) : ''
          ) : ''
        ),
        active ? _react2.default.createElement(
          'div',
          {
            className: 'ibd-category__accordion ibd-category__accordion--' + index
          },
          list && list.length ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__accordion-section ibd-category__accordion-section--list' },
            list.map(function (product) {
              return _react2.default.createElement(
                'div',
                { className: 'ibd-category__product-item' },
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { to: '/gift/' + product.url },
                  _react2.default.createElement(
                    'figure',
                    { className: 'ibd-category__product-poster ibd-category__product-poster--item' },
                    _react2.default.createElement('img', {
                      alt: product.name,
                      src: processAssetServerImage((0, _get2.default)(product, 'image'))
                    })
                  ),
                  _react2.default.createElement(
                    'h4',
                    { className: 'ibd-category__product-name ibd-category__product-name--item' },
                    product.name
                  ),
                  _react2.default.createElement(
                    'h4',
                    { className: 'ibd-category__product-description ibd-category__product-description--item' },
                    (0, _striptags2.default)(product.description)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'ibd-category__product-price' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '$',
                    product.price
                  ),
                  _react2.default.createElement(
                    'a',
                    { href: product.affiliate_link, target: '_blank' },
                    'Buy Now'
                  )
                )
              );
            })
          ) : null,
          winners && winners.length ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__accordion-section ibd-category__accordion-section--winners' },
            _react2.default.createElement(
              'h3',
              { className: 'ibd-category__accordion-section-title' },
              _react2.default.createElement(
                'span',
                null,
                'Winners'
              )
            ),
            winners.map(function (winner) {
              return _react2.default.createElement(
                'div',
                { className: 'ibd-category__product-winner' },
                _react2.default.createElement(
                  'figure',
                  { className: 'ibd-category__product-poster ibd-category__product-poster--winner' },
                  _react2.default.createElement('img', {
                    alt: winner.name,
                    src: processAssetServerImage((0, _get2.default)(winner, 'image'))
                  })
                ),
                _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-name ibd-category__product-name--winner' },
                  winner.name
                ),
                winner[productFieldToDisplay] ? _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-description ibd-category__product-description--winner' },
                  (0, _striptags2.default)(winner[productFieldToDisplay])
                ) : '',
                winner.body ? _react2.default.createElement(
                  'div',
                  { className: 'ibd-category__credit' },
                  _react2.default.createElement(_show_more2.default, {
                    initialText: 'See Credits',
                    data: winner.body
                  })
                ) : ''
              );
            })
          ) : null,
          finalists && finalists.length ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__accordion-section ibd-category__accordion-section--finalists' },
            _react2.default.createElement(
              'h3',
              { className: 'ibd-category__accordion-section-title' },
              _react2.default.createElement(
                'span',
                null,
                'Finalists'
              )
            ),
            finalists.map(function (product) {
              return _react2.default.createElement(
                'div',
                { className: 'ibd-category__product-finalists-and-mentions' },
                _react2.default.createElement(
                  'figure',
                  { className: 'ibd-category__product-poster' },
                  _react2.default.createElement('img', {
                    alt: product.name,
                    src: processAssetServerImage((0, _get2.default)(product, 'image'))
                  })
                ),
                _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-name' },
                  product.name
                ),
                product[productFieldToDisplay] ? _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-description' },
                  _react2.default.createElement('div', {
                    dangerouslySetInnerHTML: {
                      __html: (0, _striptags2.default)(product[productFieldToDisplay])
                    }
                  })
                ) : '',
                product.body ? _react2.default.createElement(
                  'div',
                  { className: 'ibd-category__credit' },
                  _react2.default.createElement(_show_more2.default, {
                    initialText: 'See Credits',
                    data: product.body
                  })
                ) : ''
              );
            })
          ) : null,
          mentions && mentions.length ? _react2.default.createElement(
            'div',
            { className: 'ibd-category__accordion-section ibd-category__accordion-section--mentions' },
            _react2.default.createElement(
              'h3',
              { className: 'ibd-category__accordion-section-title' },
              _react2.default.createElement(
                'span',
                null,
                'Honorable Mentions'
              )
            ),
            mentions.map(function (product) {
              return _react2.default.createElement(
                'div',
                { className: 'ibd-category__product-finalists-and-mentions' },
                _react2.default.createElement(
                  'figure',
                  { className: 'ibd-category__product-poster' },
                  _react2.default.createElement('img', {
                    alt: product.name,
                    src: processAssetServerImage((0, _get2.default)(product, 'image'))
                  })
                ),
                _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-name' },
                  product.name
                ),
                product[productFieldToDisplay] ? _react2.default.createElement(
                  'h4',
                  { className: 'ibd-category__product-description' },
                  _react2.default.createElement('div', {
                    dangerouslySetInnerHTML: {
                      __html: (0, _striptags2.default)((0, _striptags2.default)(product[productFieldToDisplay]))
                    }
                  })
                ) : '',
                product.body ? _react2.default.createElement(
                  'div',
                  { className: 'ibd-category__credit' },
                  _react2.default.createElement(_show_more2.default, {
                    initialText: 'See Credits',
                    data: product.body
                  })
                ) : ''
              );
            })
          ) : ''
        ) : ''
      );
    }
  }]);

  return IBDCategory;
}(_react.Component);

exports.default = IBDCategory;


IBDCategory.defaultProps = {
  slug: 'innovation-by-design',
  year: '',
  slugParam: ''
};

IBDCategory.propTypes = {
  category: _propTypes2.default.shape({}).isRequired,
  index: _propTypes2.default.string.isRequired,
  year: _propTypes2.default.string,
  active: _propTypes2.default.bool.isRequired,
  slug: _propTypes2.default.string,
  slugParam: _propTypes2.default.string
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_innovation_by_design_page_actions = __webpack_require__(726);

var _async_innovation_by_design_page_actions2 = _interopRequireDefault(_async_innovation_by_design_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_innovation_by_design_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_innovation_by_design_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _most_creative_people_community_section = __webpack_require__(736);

var _most_creative_people_community_section2 = _interopRequireDefault(_most_creative_people_community_section);

var _social = __webpack_require__(52);

var _social2 = _interopRequireDefault(_social);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line
var MostCreativePeopleCommunitySectionPage = function (_Component) {
  _inherits(MostCreativePeopleCommunitySectionPage, _Component);

  function MostCreativePeopleCommunitySectionPage(props) {
    _classCallCheck(this, MostCreativePeopleCommunitySectionPage);

    var _this = _possibleConstructorReturn(this, (MostCreativePeopleCommunitySectionPage.__proto__ || Object.getPrototypeOf(MostCreativePeopleCommunitySectionPage)).call(this, props));

    _this.alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'y', 'z'];
    return _this;
  }

  _createClass(MostCreativePeopleCommunitySectionPage, [{
    key: 'render',
    value: function render() {
      if (this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.mostCreativePeopleCommunitySectionPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'person-page' },
          _react2.default.createElement(
            'article',
            { className: 'person-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          mostCreativePeopleCommunitySectionData = _props.mostCreativePeopleCommunitySectionData,
          mostCreativePeopleCommunitySectionNextData = _props.mostCreativePeopleCommunitySectionNextData;


      var adData = (0, _get2.default)(this.props, 'mostCreativePeopleCommunitySectionPage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgTitle = 'The Most Creative People in Business Community';
      var pgDesc = 'these inspiring leaders are shaping the future of business in creative ways.';
      var section = (0, _get2.default)(this.props, 'match.params.section');
      var page = Number((0, _get2.default)(this.props, 'match.params.page'));
      var nextPage = page && !(0, _isEmpty2.default)(mostCreativePeopleCommunitySectionNextData) ? String(page + 1) : null;
      var prevPage = page > 1 ? String(page - 1) : null;

      return _react2.default.createElement(
        'section',
        { className: 'person-index-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'section',
          { className: 'page-title person-index-page__page-title' },
          _react2.default.createElement(_slug2.default, { slugName: pgTitle, className: 'category-page' }),
          _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'mcp-community__section-container' },
          _react2.default.createElement(_social2.default, {
            enableSticky: true,
            text: encodeURIComponent('The Most Creative People In Business Community #FCMostCreative'),
            uri: 'https://www.fastcompany.com/most-creative-people-community',
            modifier: 'mcp-community',
            bottomBoundary: '.mcp-community-section--z',
            topValue: 90
          }),
          this.alphabet.map(function (letter) {
            return _react2.default.createElement(_most_creative_people_community_section2.default, {
              combinedAdModel: combinedAdModel,
              index: letter,
              key: letter,
              people: mostCreativePeopleCommunitySectionData,
              prevPage: prevPage,
              nextPage: nextPage,
              activeSection: section
            });
          }),
          _react2.default.createElement(
            'div',
            { className: 'mcp-community-section__ff-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: 'flexiblebillboard_1' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: 'mobileparallax_1' }))
          )
        )
      );
    }
  }]);

  return MostCreativePeopleCommunitySectionPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    mostCreativePeopleCommunitySectionData: (0, _get2.default)(state, 'mostCreativePeopleCommunitySection.data') || {},
    mostCreativePeopleCommunitySectionNextData: (0, _get2.default)(state, 'mostCreativePeopleCommunitySectionNext.data') || {},
    mostCreativePeopleCommunitySectionPage: Object.keys((0, _get2.default)(state, 'mostCreativePeopleCommunityPage') || {}).length ? (0, _get2.default)(state, 'mostCreativePeopleCommunityPage') : (0, _get2.default)(state, 'mostCreativePeopleCommunitySectionPage') || {}
  };
}

MostCreativePeopleCommunitySectionPage.propTypes = {
  status: _propTypes2.default.number.isRequired,
  mostCreativePeopleCommunitySectionData: _propTypes2.default.shape({}).isRequired,
  mostCreativePeopleCommunitySectionNextData: _propTypes2.default.shape({}).isRequired,
  mostCreativePeopleCommunitySectionPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(MostCreativePeopleCommunitySectionPage));

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_most_creative_people_community_page_actions = __webpack_require__(737);

var _async_most_creative_people_community_page_actions2 = _interopRequireDefault(_async_most_creative_people_community_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_most_creative_people_community_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_most_creative_people_community_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(136);

var _lodash2 = _interopRequireDefault(_lodash);

var _exenv = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(32);

var _social = __webpack_require__(52);

var _social2 = _interopRequireDefault(_social);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PersonCompanyComponent = function (_Component) {
  _inherits(PersonCompanyComponent, _Component);

  function PersonCompanyComponent() {
    _classCallCheck(this, PersonCompanyComponent);

    var _this = _possibleConstructorReturn(this, (PersonCompanyComponent.__proto__ || Object.getPrototypeOf(PersonCompanyComponent)).call(this));

    _this.state = { expandedBio: false };
    _this.renderPortrait = _this.renderPortrait.bind(_this);
    _this.renderReadMore = _this.renderReadMore.bind(_this);
    _this.scopedToggleExpandedBio = _this.toggleExpandedBio.bind(_this);
    _this.scopedInitialHeight = _this.getInitialHeight.bind(_this);
    return _this;
  }

  _createClass(PersonCompanyComponent, [{
    key: 'getInitialHeight',
    value: function getInitialHeight() {
      if (_exenv.canUseDOM) {
        var mainSection = document.querySelector('.person-company-component__main');
        if (mainSection.clientHeight < 300 || window.innerWidth < 640) {
          this.setState({ expandedBio: true });
        }
      }
    }
  }, {
    key: 'toggleExpandedBio',
    value: function toggleExpandedBio() {
      this.setState({ expandedBio: true });
    }
  }, {
    key: 'renderPersonOrCompanyEyebrow',
    value: function renderPersonOrCompanyEyebrow(context, mcp, ibd, type) {
      if (!mcp && !ibd) {
        if (type === 'person') {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: '/person' },
              _react2.default.createElement(
                'span',
                { className: 'person-company-component__mcp-credit-year' },
                'Person\xA0'
              )
            ),
            _react2.default.createElement(
              'span',
              { className: 'person-company-component__mcp-credit-year' },
              '| Profile'
            )
          );
        } else if (type === 'company') {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: '/company' },
              _react2.default.createElement(
                'span',
                { className: 'person-company-component__mcp-credit-year' },
                'Company\xA0'
              )
            ),
            _react2.default.createElement(
              'span',
              { className: 'person-company-component__mcp-credit-year' },
              '| Profile'
            )
          );
        }
        return null;
      }

      if (type === 'person' && mcp) {
        if (!(0, _lodash.get)(context, 'year')) {
          return _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/most-creative-people-community' },
            _react2.default.createElement(
              'span',
              { className: 'person-company-component__mcp-credit-year' },
              'Most Creative People'
            )
          );
        }

        return _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/most-creative-people/' + (0, _lodash.get)(context, 'year', '') },
          _react2.default.createElement(
            'span',
            { className: 'person-company-component__mcp-credit-year' },
            'Most Creative People ' + (0, _lodash.get)(context, 'year', '')
          )
        );
      }

      if (type === 'company' && ibd) {
        return _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/most-innovative-companies' },
          _react2.default.createElement(
            'span',
            { className: 'person-company-component__mcp-credit-year' },
            'Most Innovative Companies'
          )
        );
      }

      return null;
    }
  }, {
    key: 'renderPortrait',
    value: function renderPortrait(personOrCompany) {
      if (personOrCompany && this.hasPortrait) {
        var $image = (0, _lodash.get)(personOrCompany, 'images[0]');
        var credit = '';

        if ((0, _lodash.get)($image, 'credit.length')) {
          credit = _react2.default.createElement('span', {
            className: 'person-company-component__poster-credit',
            dangerouslySetInnerHTML: { __html: $image.credit }
          });
        }

        return _react2.default.createElement(
          'div',
          { className: 'person-company-component__poster' },
          _react2.default.createElement('img', {
            className: 'person-company-component__poster-image',
            src: $image.url,
            alt: this.fullName
          }),
          credit
        );
      }

      return null;
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle(personOrCompany) {
      if (personOrCompany) {
        var title = [];
        if (personOrCompany.job_title) {
          title.push(_react2.default.createElement(
            'span',
            { key: 'job_title' },
            personOrCompany.job_title
          ));
        }

        if ((0, _lodash.get)(personOrCompany, 'companies[0].name') && (0, _lodash.get)(personOrCompany, 'companies[0].url')) {
          title.push(_react2.default.createElement(
            'span',
            { key: 'company' },
            ',',
            ' ',
            _react2.default.createElement(
              'a',
              {
                href: '//www.fastcompany.com/company/' + personOrCompany.companies[0].url
              },
              personOrCompany.companies[0].name
            )
          ));
        }

        if ((0, _lodash.get)(personOrCompany, 'location')) {
          title.push(_react2.default.createElement(
            'span',
            { key: 'location' },
            ' | ',
            (0, _lodash.get)(personOrCompany, 'location')
          ));
        }

        return title;
      }

      return null;
    }
  }, {
    key: 'renderReason',
    value: function renderReason(personOrCompany) {
      var why = (0, _lodash.get)(personOrCompany, 'mcp100[0].why');

      if (personOrCompany && why) {
        return _react2.default.createElement(
          'div',
          { className: 'person-company-component__mcp-reason' },
          why
        );
      }

      return null;
    }
  }, {
    key: 'renderAwards',
    value: function renderAwards(awards) {
      if (!awards.length) return null;

      var awardsTransform = _lodash2.default.chain(awards).groupBy('mic_year').map(function (value, key) {
        return {
          year: key,
          awards: value
        };
      }).value().reverse();

      return _react2.default.createElement(
        'div',
        { className: 'person-company-component__information' },
        _react2.default.createElement(
          'span',
          { className: 'person-company-component__information-title' },
          'Lists'
        ),
        awardsTransform.map(function (year) {
          return _react2.default.createElement(
            'div',
            {
              key: '' + year.year,
              className: 'person-company-component__information-item'
            },
            year.year,
            ':',
            ' ',
            year.awards.map(function (award, idx) {
              return _react2.default.createElement(
                'span',
                { key: '' + year.year + award.sector_name },
                award.sector_url === year.year ? _react2.default.createElement(
                  'a',
                  {
                    href: 'https://www.fastcompany.com/most-innovative-companies/' + year.year
                  },
                  idx + 1 !== year.awards.length ? _react2.default.createElement(
                    'span',
                    null,
                    award.sector_name,
                    ', '
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    award.sector_name
                  )
                ) : _react2.default.createElement(
                  'a',
                  {
                    href: 'https://www.fastcompany.com/most-innovative-companies/' + year.year + '/sectors/' + award.sector_url
                  },
                  idx + 1 !== year.awards.length ? _react2.default.createElement(
                    'span',
                    null,
                    award.sector_name,
                    ', '
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    award.sector_name
                  )
                )
              );
            })
          );
        })
      );
    }
  }, {
    key: 'renderData',
    value: function renderData(personOrCompany) {
      var data = (0, _lodash.get)(personOrCompany, 'data') || [];
      var competitors = (0, _lodash.get)(personOrCompany, 'competitors') || [];

      if (!data.length) return null;

      return _react2.default.createElement(
        'div',
        { className: 'person-company-component__information' },
        _react2.default.createElement(
          'span',
          { className: 'person-company-component__information-title' },
          'Data'
        ),
        data.map(function (item) {
          return _react2.default.createElement(
            'div',
            {
              key: item.name,
              className: 'person-company-component__information-item'
            },
            _react2.default.createElement(
              'span',
              { className: 'person-company-component__data-name' },
              item.name,
              ':',
              ' '
            ),
            _react2.default.createElement(
              'span',
              { className: 'person-company-component__data-value' },
              item.value
            )
          );
        }),
        competitors.length ? _react2.default.createElement(
          'div',
          { className: 'person-company-component__information-item' },
          _react2.default.createElement(
            'span',
            { className: 'person-company-component__data-name' },
            'Competition: ',
            competitors.map(function (item, idx) {
              return _react2.default.createElement(
                _reactRouterDom.Link,
                { key: item.url, to: '/company/' + item.url },
                idx + 1 !== competitors.length ? _react2.default.createElement(
                  'span',
                  null,
                  item.name,
                  ', '
                ) : _react2.default.createElement(
                  'span',
                  null,
                  item.name
                )
              );
            })
          )
        ) : ''
      );
    }
  }, {
    key: 'renderSocialMedia',
    value: function renderSocialMedia(personOrCompany) {
      var socialMedia = (0, _lodash.get)(personOrCompany, 'social_media') || [];

      if (!socialMedia.length) return null;

      return _react2.default.createElement(
        'div',
        { className: 'person-company-component__information' },
        _react2.default.createElement(
          'span',
          { className: 'person-company-component__information-title' },
          this.fullName,
          ' On The Web'
        ),
        socialMedia.map(function (item) {
          return _react2.default.createElement(
            'div',
            {
              key: item.name,
              className: 'person-company-component__information-item'
            },
            item.name === 'Website' ? _react2.default.createElement(
              'a',
              { href: item.value },
              item.name
            ) : _react2.default.createElement(
              'a',
              { href: 'https://' + item.name + '.com/' + item.value },
              item.name
            )
          );
        })
      );
    }
  }, {
    key: 'renderReadMore',
    value: function renderReadMore() {
      if (this.state.expandedBio) return null;

      return _react2.default.createElement(
        'div',
        { className: 'person-company-component__button-container' },
        _react2.default.createElement(
          'div',
          {
            onClick: this.scopedToggleExpandedBio,
            className: 'person-company-component__button'
          },
          'Read More'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props) {
        return null;
      }

      var _props = this.props,
          personOrCompany = _props.personOrCompany,
          awards = _props.awards,
          type = _props.type;


      var isPersonOrCompany = (0, _lodash.get)(personOrCompany, 'name') ? 'company' : 'person';

      this.fullName = (0, _lodash.get)(personOrCompany, 'name') ? personOrCompany.name : (0, _lodash.get)(personOrCompany, 'first_name') + ' ' + (0, _lodash.get)(personOrCompany, 'last_name');
      this.hasPortrait = !!(0, _lodash.get)(personOrCompany, 'images[0].url');
      var mcpAwards = (0, _lodash.get)(personOrCompany, 'mcp_awards');
      var mcpYear = (0, _lodash.get)(personOrCompany, 'mcp_awards[0].year');
      var encodedUrl = encodeURIComponent('https://www.fastcompany.com/' + isPersonOrCompany + '/' + (0, _lodash.get)(personOrCompany, 'url'));
      var shareCopy = {
        personOrCompany: this.fullName + ': Latest News, Work, Videos, Photos on Fast Company',
        mcp: 'Check out ' + this.fullName + ', one of @FastCompany\'s Most Creative People #FCMostCreative',
        mcpAwards: 'Check out ' + this.fullName + ', one of @FastCompany\'s Most Creative People ' + mcpYear + ' #FCMostCreative',
        ibd: 'Check out ' + this.fullName + ', one of @FastCompany\'s Most Innovative Businesses #FCMostInnovative',
        default: 'Read more about ' + this.fullName + ' on @FastCompany'
      };
      var isMCP = (0, _lodash.get)(personOrCompany, 'mcp') === 1;
      var isIBD = (0, _lodash.get)(awards, 'length');
      var value = void 0;

      if (isMCP && !(0, _lodash.get)(mcpAwards, 'length')) {
        value = 'mcp';
      } else if (isMCP && (0, _lodash.get)(mcpAwards, 'length')) {
        value = 'mcpAwards';
      } else if (isIBD) {
        value = 'ibd';
      } else {
        value = 'default';
      }

      var encodedText = encodeURIComponent(shareCopy[value]);

      return _react2.default.createElement(
        'section',
        {
          className: 'person-company-component person-company-component--' + this.fullName
        },
        _react2.default.createElement(_social2.default, {
          enableSticky: false,
          text: encodedText,
          uri: encodedUrl,
          modifier: 'person-page',
          topValue: 0
        }),
        this.renderPortrait(personOrCompany),
        _react2.default.createElement(
          'div',
          {
            ref: this.scopedInitialHeight,
            className: 'person-company-component__main' + (this.state.expandedBio ? ' person-company-component__main--expanded' : '') + ' ' + (this.hasPortrait || isIBD ? '' : 'person-company-component__main--no-portrait')
          },
          this.renderPersonOrCompanyEyebrow((0, _lodash.get)(personOrCompany, 'mcp_awards[0]'), (0, _lodash.get)(personOrCompany, 'mcp'), (0, _lodash.get)(awards, 'length'), type),
          _react2.default.createElement(
            'h1',
            { className: 'person-company-component__name' },
            this.fullName
          ),
          _react2.default.createElement(
            'h2',
            { className: 'person-company-component__title' },
            this.renderTitle(personOrCompany)
          ),
          this.renderReason(personOrCompany),
          _react2.default.createElement('div', {
            className: 'person-company-component__bio-text ' + (isIBD ? 'person-company-component__bio-text--ibd' : ''),
            dangerouslySetInnerHTML: { __html: (0, _lodash.get)(personOrCompany, 'bio') }
          }),
          this.renderAwards(awards),
          this.renderData(personOrCompany),
          this.renderSocialMedia(personOrCompany),
          this.renderReadMore()
        )
      );
    }
  }]);

  return PersonCompanyComponent;
}(_react.Component);

exports.default = PersonCompanyComponent;


PersonCompanyComponent.defaultProps = {
  awards: []
};

PersonCompanyComponent.propTypes = {
  personOrCompany: _propTypes2.default.shape({}).isRequired,
  type: _propTypes2.default.string.isRequired,
  awards: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _franchise_accordion_section = __webpack_require__(151);

var _franchise_accordion_section2 = _interopRequireDefault(_franchise_accordion_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var CompanyIndexSectionPage = function (_Component) {
  _inherits(CompanyIndexSectionPage, _Component);

  function CompanyIndexSectionPage(props) {
    _classCallCheck(this, CompanyIndexSectionPage);

    var _this = _possibleConstructorReturn(this, (CompanyIndexSectionPage.__proto__ || Object.getPrototypeOf(CompanyIndexSectionPage)).call(this, props));

    _this.alphabet = ['0-9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    return _this;
  }

  _createClass(CompanyIndexSectionPage, [{
    key: 'render',
    value: function render() {
      if (this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.companyIndexSectionPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'company-page' },
          _react2.default.createElement(
            'article',
            { className: 'company-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          companyIndexSectionData = _props.companyIndexSectionData,
          companyIndexSectionNextData = _props.companyIndexSectionNextData;

      var adData = (0, _get2.default)(this.props, 'companyIndexSectionPage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgTitle = 'company index';
      var pgDesc = 'A list of companies Fast Company has featured including the Most Innovative';
      var section = (0, _get2.default)(this.props, 'match.params.section');
      var page = Number((0, _get2.default)(this.props, 'match.params.page'));
      var nextPage = page && !(0, _isEmpty2.default)(companyIndexSectionNextData) ? String(page + 1) : null;
      var prevPage = page > 1 ? String(page - 1) : null;

      return _react2.default.createElement(
        'section',
        { className: 'company-index-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'section',
          { className: 'page-title company-index-page__page-title' },
          _react2.default.createElement(_slug2.default, { slugName: pgTitle, className: 'category-page' }),
          _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          )
        ),
        this.alphabet.map(function (letter) {
          return _react2.default.createElement(_franchise_accordion_section2.default, {
            combinedAdModel: combinedAdModel,
            index: letter,
            key: letter,
            data: companyIndexSectionData,
            propertyToDisplay: 'name',
            prevPage: prevPage,
            nextPage: nextPage,
            activeSection: section,
            pathForSection: 'company',
            pathForData: 'company'
          });
        })
      );
    }
  }]);

  return CompanyIndexSectionPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    companyIndexSectionData: (0, _get2.default)(state, 'companyIndexSection.data') || {},
    companyIndexSectionNextData: (0, _get2.default)(state, 'companyIndexSectionNext.data') || {},
    companyIndexSectionPage: Object.keys((0, _get2.default)(state, 'companyIndexPage')).length ? (0, _get2.default)(state, 'companyIndexPage') : (0, _get2.default)(state, 'companyIndexSectionPage') || {}
  };
}

CompanyIndexSectionPage.defaultProps = {
  status: 200,
  companyIndexSectionData: {},
  companyIndexSectionNextData: {},
  companyIndexSectionPage: {}
};

CompanyIndexSectionPage.propTypes = {
  status: _propTypes2.default.number,
  companyIndexSectionData: _propTypes2.default.shape({}),
  companyIndexSectionNextData: _propTypes2.default.shape({}),
  companyIndexSectionPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  })
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(CompanyIndexSectionPage));

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_company_index_section_page_actions = __webpack_require__(776);

var _async_company_index_section_page_actions2 = _interopRequireDefault(_async_company_index_section_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_company_index_section_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_company_index_section_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// import { canUseDOM } from 'exenv';


var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(32);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _chunk = __webpack_require__(103);

var _chunk2 = _interopRequireDefault(_chunk);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _reactSlick = __webpack_require__(104);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _social = __webpack_require__(52);

var _social2 = _interopRequireDefault(_social);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _franchise_intro = __webpack_require__(152);

var _franchise_intro2 = _interopRequireDefault(_franchise_intro);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _legacy_image_asset_util = __webpack_require__(785);

var _legacy_image_asset_util2 = _interopRequireDefault(_legacy_image_asset_util);

var _scroll_to_el_util = __webpack_require__(79);

var _scroll_to_el_util2 = _interopRequireDefault(_scroll_to_el_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Company(company) {
  var sector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var config = arguments[2];

  return _react2.default.createElement(
    'div',
    {
      className: 'mic-year-page__slide-company' + (sector ? ' mic-year-page__slide-company--sector' : ''),
      key: 'company-' + company.name
    },
    _react2.default.createElement(
      _fc_link2.default,
      { config: config, to: '/company/' + company.url },
      _react2.default.createElement(
        'div',
        { className: 'mic-year-page__slide-company-content' },
        _react2.default.createElement(
          'span',
          { className: 'mic-year-page__slide-company-rank' },
          Number(company.ranking) < 10 ? '0' : '',
          company.ranking
        ),
        _react2.default.createElement(
          'span',
          { className: 'mic-year-page__slide-company-name' },
          company.name
        ),
        company.why || company.for ? _react2.default.createElement(
          'h3',
          { className: 'mic-year-page__slide-company-reason' },
          company.why || company.for
        ) : null
      )
    )
  );
}

function CompanySection(companies, config) {
  return _react2.default.createElement(
    'section',
    {
      className: 'mic-year-page__slide',
      key: 'mic-section-' + (0, _get2.default)(companies, '[0].name')
    },
    companies.map(function (cpy) {
      return Company(cpy, false, config);
    }),
    _react2.default.createElement(
      'div',
      { className: 'mic-year-page__slide-currently-showing' },
      (0, _get2.default)(companies, '[0].ranking') < 10 ? '0' : '',
      (0, _get2.default)(companies, '[0].ranking') + ' - ' + (0, _get2.default)(companies, '[9].ranking')
    )
  );
}

function SectorSection(sector, micYear, year, sectorName, index, numSectors, ads, config) {
  var sectorUrl = (0, _get2.default)(sector, 'url');
  return _react2.default.createElement(
    'section',
    {
      className: 'franchise-accordion-section franchise-accordion-section--mic-year franchise-accordion-section--' + sectorUrl,
      key: 'section-' + (0, _get2.default)(sector, 'name')
    },
    sectorUrl === sectorName ? _react2.default.createElement(_social2.default, {
      empty: false,
      enableSticky: false,
      modifier: 'mic-year-sector',
      uri: 'https://www.fastcompany.com/most-innovative-companies/' + year + '/sectors/' + sectorUrl,
      text: encodeURIComponent('@FastCompany\'s Most Innovative Companies ' + year + ' in ' + (0, _get2.default)(sector, 'name') + ' #FCMostInnovative')
    }) : '',
    _react2.default.createElement(
      _reactRouterDom.Link,
      {
        className: 'franchise-accordion-section__title-row franchise-accordion-section--mic-year__title-row',
        to: sectorUrl === sectorName ? '/most-innovative-companies/' + year : '/most-innovative-companies/' + year + '/sectors/' + sectorUrl
      },
      _react2.default.createElement(
        'h2',
        { className: 'franchise-accordion-section__title franchise-accordion-section--mic-year__title' },
        sector.name
      ),
      _react2.default.createElement('img', {
        className: 'franchise-accordion-section__title-icon franchise-accordion-section--mic-year__title-icon' + (sectorUrl === sectorName ? ' franchise-accordion-section__title-icon--active' : ''),
        src: '//images.fastcompany.net/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg',
        alt: 'arrow icon',
        title: 'arrow icon'
      })
    ),
    _react2.default.createElement(
      'div',
      {
        className: 'franchise-accordion-section__list franchise-accordion-section--mic-year__list' + (sectorUrl === sectorName ? ' franchise-accordion-section--mic-year__list--active' : '')
      },
      sector.list.map(function (cpy) {
        return Company(cpy, true, config);
      })
    ),
    index === Math.floor(numSectors / 3) || index === Math.floor(numSectors / 3) * 2 ? _react2.default.createElement(
      'div',
      { className: 'franchise-accordion-section__ff-ad-container franchise-accordion-section--mic-year__ff-ad-container' },
      _react2.default.createElement(_ad2.default, _extends({}, ads, { pos: 'btf', name: 'flexiblebillboard_1' })),
      _react2.default.createElement(_ad2.default, _extends({}, ads, { pos: 'btf', name: 'mobileparallax_1' }))
    ) : ''
  );
}

// eslint-disable-next-line react/prefer-stateless-function

var MicYear = function (_Component) {
  _inherits(MicYear, _Component);

  function MicYear(props) {
    _classCallCheck(this, MicYear);

    var _this = _possibleConstructorReturn(this, (MicYear.__proto__ || Object.getPrototypeOf(MicYear)).call(this, props));

    var prevArrow = _react2.default.createElement(
      'button',
      { type: 'button' },
      'PREV'
    );

    var nextArrow = _react2.default.createElement(
      'button',
      { type: 'button' },
      'NEXT'
    );

    _this.state = {
      sector: (0, _get2.default)(_this, 'props.match.params.sector'),
      settings: {
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        className: 'mic-year-page__slider',
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        slide: '.mic-section-slide'
      }
    };
    return _this;
  }

  _createClass(MicYear, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        sector: (0, _get2.default)(nextProps, 'match.params.sector')
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _scroll_to_el_util2.default)('.franchise-accordion-section--' + (0, _get2.default)(this, 'props.match.params.sector'), 150);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.micYearPage.error || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (!this.props.micYearPage.isLoading) {
        var adData = (0, _get2.default)(this.props, 'micYearPage.ads');
        var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

        var year = this.props.year || (0, _get2.default)(this, 'props.match.params.year');

        var encodedText = encodeURIComponent('@FastCompany\'s Most Innovative Companies ' + year + ' #FCMostInnovative');
        var uri = 'https://www.fastcompany.com/most-innovative-companies/' + year;

        var settings = this.state.settings;

        var micSector = (0, _get2.default)(this.props, 'micSector', []);

        return _react2.default.createElement(
          'section',
          { className: 'mic-year-page' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
          _react2.default.createElement(
            'div',
            { className: 'ad-container ad-container--gray ad-container--hide-for-small' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' }))
          ),
          _react2.default.createElement(
            'div',
            { className: 'ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileleaderboard' }))
          ),
          _react2.default.createElement(_franchise_intro2.default, {
            poster: (0, _legacy_image_asset_util2.default)(this.props.micYearDescription.logo_url),
            title: 'Most Innovative Companies ' + year,
            desc: this.props.micYearDescription.intro,
            social: {
              enableSticky: false,
              modifier: 'feature-feed',
              text: encodedText,
              uri: uri
            },
            topValue: 0
          }),
          _react2.default.createElement(_slug2.default, { className: 'mic-year-page', slugName: 'Honorees by Rank' }),
          _react2.default.createElement(
            'div',
            { className: 'mic-year-page__slider-row' },
            _react2.default.createElement(
              _reactSlick2.default,
              settings,
              this.props.micYear.map(function (companies) {
                return CompanySection(companies, _this2.props.config);
              })
            )
          ),
          _react2.default.createElement(_slug2.default, { className: 'mic-year-page', slugName: 'Honorees by Sector' }),
          micSector.map(function (sector, index) {
            return SectorSection(sector, _this2.props.micYear, year, _this2.state.sector, index, (0, _get2.default)(Object.keys(_this2.props.micSector), 'length'), combinedAdModel, _this2.props.config);
          }),
          _react2.default.createElement(
            'div',
            { className: 'ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
          )
        );
      }
      return null;
    }
  }]);

  return MicYear;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var micData = (0, _chunk2.default)((0, _get2.default)(state, 'micYear.data.rows'), 10);
  var micYearDesc = (0, _get2.default)(state, 'micYearDescription.data.rows[0]');
  return {
    config: state.config || {},
    status: state.status.code,
    micYearPage: Object.keys((0, _get2.default)(state, 'micYearPage')).length ? state.micYearPage : (0, _get2.default)(state, 'micSectorPage') || { error: true },
    micYear: micData || { error: true },
    year: (0, _get2.default)(state, 'micYear.year'),
    micSector: (0, _get2.default)(state, 'micSector.data.rows') || { error: true },
    micYearDescription: micYearDesc || { error: true }
  };
}

MicYear.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number,
  micYearPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object.isRequired,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }),
  year: _propTypes2.default.string,
  micYear: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({}))).isRequired,
  micYearDescription: _propTypes2.default.shape({
    logo_url: _propTypes2.default.string,
    intro: _propTypes2.default.string
  }),
  micSector: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired
};

MicYear.defaultProps = {
  status: 200,
  micYearPage: _propTypes2.default.shape({
    isLoading: false,
    error: false,
    errorMessage: 'Error in micYearPage Props'
  }),
  year: '',
  micYearDescription: _propTypes2.default.shape({
    logo_url: '',
    intro: ''
  })
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(MicYear));

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMicDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _mic_year_action_creators = __webpack_require__(789);

var micYearActions = _interopRequireWildcard(_mic_year_action_creators);

var _mic_year_model = __webpack_require__(790);

var _mic_year_model2 = _interopRequireDefault(_mic_year_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMicDetail(params, store) {
  return function firstDispatch(dispatch) {
    return _mic_year_model2.default.fetch(params, store).then(function handleMicDetailData(MicData) {
      dispatch(micYearActions.micYearLoaded(MicData.data, store, params.year));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(micYearActions.micYearLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(micYearActions.micYearLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in micYear actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMicDescription;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _mic_year_description_action_creators = __webpack_require__(791);

var micYearDescriptionActions = _interopRequireWildcard(_mic_year_description_action_creators);

var _mic_year_description_model = __webpack_require__(792);

var _mic_year_description_model2 = _interopRequireDefault(_mic_year_description_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMicDescription(params, store) {
  return function firstDispatch(dispatch) {
    return _mic_year_description_model2.default.fetch(params, store).then(function handleMicDetailData(MicData) {
      dispatch(micYearDescriptionActions.micYearDescriptionLoaded(MicData.data, store));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(micYearDescriptionActions.micYearDescriptionLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(micYearDescriptionActions.micYearDescriptionLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in micYearDescription actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMicDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _mic_sector_action_creators = __webpack_require__(793);

var micSectorActions = _interopRequireWildcard(_mic_sector_action_creators);

var _mic_sector_model = __webpack_require__(794);

var _mic_sector_model2 = _interopRequireDefault(_mic_sector_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMicDetail(params, store) {
  return function firstDispatch(dispatch) {
    return _mic_sector_model2.default.fetch(params, store).then(function handleMicDetailData(MicData) {
      dispatch(micSectorActions.micSectorLoaded(MicData.data, store, params.year, params.sector));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Sector') {
        _logger_service2.default.warn('User tried a most creative people page with invalid sector.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(micSectorActions.micSectorLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(micSectorActions.micSectorLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in micSector actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postpageLoading = postpageLoading;
exports.postpageLoaded = postpageLoaded;
exports.postpageLoadError = postpageLoadError;
exports.infiniteScrollUrlChange = infiniteScrollUrlChange;
// import { canUseDOM } from 'exenv';

function postpageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POSTPAGE_LOADING',
    postpage: resp,
    store: store
  };
}

function postpageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POSTPAGE_LOADED',
    postpage: resp,
    store: store
  };
}

function postpageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POSTPAGE_ERROR',
    postpage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function infiniteScrollUrlChange() {
  return {
    type: 'INFINITE_SCROLLPAGE_LOADED'
  };
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = redirectPostUrl;
function redirectPostUrl() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'REDIRECT_POST_URL',
    status: resp.status,
    redirect: resp.redirect
  };
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JWPlaylistModel = function (_Base) {
  _inherits(JWPlaylistModel, _Base);

  function JWPlaylistModel() {
    _classCallCheck(this, JWPlaylistModel);

    return _possibleConstructorReturn(this, (JWPlaylistModel.__proto__ || Object.getPrototypeOf(JWPlaylistModel)).apply(this, arguments));
  }

  _createClass(JWPlaylistModel, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var page = _ref.page,
          playlistId = _ref.playlistId;

      var pageOffset = page || 1;
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};

      var cacheKeyUrl = '' + protocol + host + '/api/v1/jw-playlist/' + playlistId + '/' + pageOffset;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return JWPlaylistModel;
}(_base_model2.default);

exports.default = JWPlaylistModel;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchJwPlaylistIndexDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _jw_playlist_index_action_creators = __webpack_require__(855);

var jwPlaylistIndexActions = _interopRequireWildcard(_jw_playlist_index_action_creators);

var _jw_playlist_index_model = __webpack_require__(856);

var _jw_playlist_index_model2 = _interopRequireDefault(_jw_playlist_index_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchJwPlaylistIndexDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(jwPlaylistIndexActions.jwPlaylistIndexLoading({}, store));
    return _jw_playlist_index_model2.default.fetch(params, store).then(function handleJwPlaylistIndexDetailData(JwPlaylistIndexData) {
      dispatch(jwPlaylistIndexActions.jwPlaylistIndexLoaded(JwPlaylistIndexData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(jwPlaylistIndexActions.jwPlaylistIndexLoadError(err, store));

      _logger_service2.default.error(err, 'Error in jwPlaylistIndex actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRecaptcha = __webpack_require__(872);

var _reactRecaptcha2 = _interopRequireDefault(_reactRecaptcha);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

var _newsletter_list_section = __webpack_require__(873);

var _newsletter_list_section2 = _interopRequireDefault(_newsletter_list_section);

var _email_input = __webpack_require__(884);

var _email_input2 = _interopRequireDefault(_email_input);

var _sticky_submit = __webpack_require__(885);

var _sticky_submit2 = _interopRequireDefault(_sticky_submit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewsletterSignupForm(props) {
  var handleEmailUpdate = props.handleEmailUpdate,
      emailValue = props.emailValue,
      disabled = props.disabled,
      handleSignupSubmit = props.handleSignupSubmit,
      placeholder = props.placeholder,
      listsDictionary = props.listsDictionary,
      sections = props.sections,
      state = props.state,
      filter = props.filter,
      transition = props.transition,
      handleNewslettersUpdate = props.handleNewslettersUpdate,
      handleNewslettersRadioUpdate = props.handleNewslettersRadioUpdate,
      hed = props.hed,
      dek = props.dek,
      buttonText = props.buttonText,
      setFocus = props.setFocus,
      toggleInputOn = props.toggleInputOn,
      emailFormError = props.emailFormError,
      emailUpdateSuccessMessage = props.emailUpdateSuccessMessage,
      emailUpdateMessageError = props.emailUpdateMessageError,
      subscribedToIds = props.subscribedToIds,
      alreadyUsed = props.alreadyUsed,
      emailEditable = props.emailEditable,
      stickySubmit = props.stickySubmit,
      handleStickySubmit = props.handleStickySubmit,
      handleUnsubscribeAll = props.handleUnsubscribeAll,
      stickyMessage = props.stickyMessage,
      handleVerify = props.handleVerify;


  return _react2.default.createElement(
    'div',
    { className: 'newsletter-form' },
    _react2.default.createElement(
      'h2',
      { className: 'newsletter-form__hed' },
      hed
    ),
    _react2.default.createElement(
      'p',
      { className: 'newsletter-form__dek' },
      dek
    ),
    _react2.default.createElement(
      'form',
      { onSubmit: handleSignupSubmit },
      _react2.default.createElement(_email_input2.default, {
        handleChange: handleEmailUpdate,
        value: emailValue,
        handleSubmit: handleSignupSubmit,
        disabled: disabled,
        placeholder: placeholder,
        buttonText: buttonText,
        setFocus: setFocus,
        toggleInputOn: toggleInputOn,
        emailFormError: emailFormError,
        emailUpdateSuccessMessage: emailUpdateSuccessMessage,
        emailUpdateMessageError: emailUpdateMessageError,
        emailEditable: emailEditable
      }),
      handleVerify ? _react2.default.createElement(_reactRecaptcha2.default, {
        sitekey: _identity2.default.fastcompany.reCaptcha.public,
        render: 'explicit',
        verifyCallback: handleVerify,
        onloadCallback: function onloadCallback() {}
      }) : '',
      _react2.default.createElement(
        'div',
        { className: 'newsletter-form__groupings' },
        sections.map(function (section) {
          return _react2.default.createElement(_newsletter_list_section2.default, {
            key: section.sectionTitle,
            sectionIds: section.ids,
            masterLookup: listsDictionary,
            state: state,
            sectionTitle: section.sectionTitle,
            filter: filter,
            transition: transition,
            subscribedToIds: subscribedToIds,
            alreadyUsed: alreadyUsed,
            handleChange: handleNewslettersUpdate,
            handleNewslettersRadioUpdate: handleNewslettersRadioUpdate
          });
        })
      ),
      stickySubmit ? [_react2.default.createElement(
        'button',
        {
          className: 'newsletter-form__button newsletter-form__button--unsubscribe',
          type: 'button',
          onClick: handleUnsubscribeAll
        },
        'Unsubscribe from all'
      ), _react2.default.createElement(_sticky_submit2.default, {
        message: stickyMessage,
        handleSubmit: handleStickySubmit,
        handleUnsubscribeAll: handleUnsubscribeAll
      })] : null
    )
  );
}

NewsletterSignupForm.defaultProps = {
  filter: true,
  transition: true,
  disabled: false,
  placeholder: 'Your Email',
  buttonText: 'Send',
  setFocus: function setFocus() {},
  toggleInputOn: function toggleInputOn() {},
  handleStickySubmit: function handleStickySubmit() {},
  handleUnsubscribeAll: function handleUnsubscribeAll() {},
  emailFormError: '',
  emailUpdateSuccessMessage: '',
  emailUpdateMessageError: '',
  subscribedToIds: [],
  alreadyUsed: {},
  emailEditable: true,
  stickySubmit: false,
  stickyMessage: '',
  handleNewslettersRadioUpdate: function handleNewslettersRadioUpdate() {},
  handleVerify: false
};

NewsletterSignupForm.propTypes = {
  handleEmailUpdate: _propTypes2.default.func.isRequired,
  emailValue: _propTypes2.default.string.isRequired,
  buttonText: _propTypes2.default.string,
  hed: _propTypes2.default.string.isRequired,
  dek: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool,
  handleSignupSubmit: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  listsDictionary: _propTypes2.default.shape({}).isRequired,
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  state: _propTypes2.default.shape({}).isRequired,
  filter: _propTypes2.default.bool,
  transition: _propTypes2.default.bool,
  handleNewslettersUpdate: _propTypes2.default.func.isRequired,
  setFocus: _propTypes2.default.func,
  toggleInputOn: _propTypes2.default.func,
  emailFormError: _propTypes2.default.string,
  emailUpdateSuccessMessage: _propTypes2.default.string,
  emailUpdateMessageError: _propTypes2.default.string,
  subscribedToIds: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])),
  alreadyUsed: _propTypes2.default.shape({}),
  emailEditable: _propTypes2.default.bool,
  stickySubmit: _propTypes2.default.bool,
  handleStickySubmit: _propTypes2.default.func,
  handleUnsubscribeAll: _propTypes2.default.func,
  stickyMessage: _propTypes2.default.string,
  handleNewslettersRadioUpdate: _propTypes2.default.func,
  handleVerify: _propTypes2.default.func
};

exports.default = NewsletterSignupForm;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
exports.classNamesShape = exports.timeoutsShape = undefined;
;(transitionTimeout);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorAsset = _react2.default.createElement(
  'svg',
  { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 12 12' },
  _react2.default.createElement('path', {
    fill: '#EA212D',
    fillRule: 'nonzero',
    d: 'M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm3 8L8 9 6 7 4 9 3 8l2-2-2-2 1-1 2 2 2-2 1 1-2 2 2 2z'
  })
);

var successAsset = _react2.default.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 36 36',
    width: '12',
    height: '12'
  },
  _react2.default.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    _react2.default.createElement('circle', { id: 'a', cx: '18', cy: '18', r: '18', fill: '#46AC4E' }),
    _react2.default.createElement('path', {
      fill: '#FFF',
      fillRule: 'nonzero',
      d: 'M14.8 28L5 18.3l5-4.7 4.8 4.8L25.4 8l5 4.8'
    })
  )
);

function Message(props) {
  var type = props.type;


  if (!props.message) {
    return false;
  }

  return _react2.default.createElement(
    'div',
    { className: 'message' },
    type === 'success' ? successAsset : '',
    type === 'error' ? errorAsset : '',
    _react2.default.createElement(
      'span',
      { className: 'message__text--' + type + ' message__text' },
      props.message
    )
  );
}

Message.defaultProps = {
  type: 'default',
  message: false
};

Message.propTypes = {
  type: _propTypes2.default.string,
  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
};

exports.default = Message;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePostUpEmailAction = exports.updatePostUpUserAction = exports.fetchNewslettersPreferencesPageModelAction = undefined;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _newsletters_preferences_page_action_creators = __webpack_require__(280);

var newslettersPreferencesPageActions = _interopRequireWildcard(_newsletters_preferences_page_action_creators);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _newsletters_preferences_page = __webpack_require__(892);

var _newsletters_preferences_page2 = _interopRequireDefault(_newsletters_preferences_page);

var _newsletter_module = __webpack_require__(221);

var _newsletter_module2 = _interopRequireDefault(_newsletter_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchNewslettersPreferencesPageModelAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(newslettersPreferencesPageActions.newslettersPreferencesPageLoading({}, store));
    var state = store.getState();
    var userId = (0, _get2.default)(state, 'config.initialQueryParams.u');
    var md5Hash = (0, _get2.default)(state, 'config.initialQueryParams.k');
    var config = (0, _get2.default)(state, 'config', {});

    return _newsletters_preferences_page2.default.fetch({ u: userId, k: md5Hash }, config).then(function handleNewslettersPreferencesPageModelData(newslettersPrefencesPageData) {
      dispatch(newslettersPreferencesPageActions.newslettersPreferencesPageLoaded(newslettersPrefencesPageData.data, store));
      return true;
    }).catch(function handleNewslettersPreferencesPageModelError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(newslettersPreferencesPageActions.newslettersPreferencesPageError(err.data, store));
      return _logger_service2.default.error(err, 'Error in newsletters_preferences_page actions, message: ' + err.message);
    });
  };
}

function updatePostUpUserAction(params, config) {
  return function firstDispatch(dispatch) {
    dispatch(newslettersPreferencesPageActions.newsletterPreferencesUpdateLoading({}));

    return new _newsletter_module2.default().post(params, config).then(function handleNewslettersPreferencesPageModelData(newslettersPrefencesPageData) {
      dispatch(newslettersPreferencesPageActions.newsletterPreferencesUpdateSuccess(newslettersPrefencesPageData.data));
      return true;
    }).catch(function handleNewslettersPreferencesPageModelError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS'));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS'));
      }
      dispatch(newslettersPreferencesPageActions.updateNewsletterPreferencesFailure(err.data));
      return _logger_service2.default.error(err, 'Error in newsletters_preferences_page actions, message: ' + err.message);
    });
  };
}

function updatePostUpEmailAction(params, config) {
  return function firstDispatch(dispatch) {
    dispatch(newslettersPreferencesPageActions.newsletterPreferencesUpdateLoading({}));
    var md5Hash = (0, _get2.default)(config, 'initialQueryParams.k');
    var paramsWithHash = (0, _assign2.default)({}, params, { k: md5Hash });
    return new _newsletter_module2.default().put(paramsWithHash, config).then(function handleNewslettersPreferencesPageModelData(newslettersPrefencesPageData) {
      var errors = (0, _get2.default)(newslettersPrefencesPageData, 'data.errors');
      if (errors) {
        var error = new Error(errors);
        throw error;
      }

      dispatch(newslettersPreferencesPageActions.updateSubscriptionEmailSuccess(newslettersPrefencesPageData.data));
      return true;
    }).catch(function handleNewslettersPreferencesPageModelError(err) {
      var message = err.message;

      dispatch(newslettersPreferencesPageActions.updateSubscriptionEmailError(message));
      return _logger_service2.default.error(err, 'Error in newsletters_preferences_page actions, message: ' + message);
    });
  };
}

exports.fetchNewslettersPreferencesPageModelAction = fetchNewslettersPreferencesPageModelAction;
exports.updatePostUpUserAction = updatePostUpUserAction;
exports.updatePostUpEmailAction = updatePostUpEmailAction;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newslettersPreferencesPageLoading = newslettersPreferencesPageLoading;
exports.newslettersPreferencesPageLoaded = newslettersPreferencesPageLoaded;
exports.newslettersPreferencesPageError = newslettersPreferencesPageError;
exports.newsletterPreferencesUpdateLoading = newsletterPreferencesUpdateLoading;
exports.newsletterPreferencesUpdateSuccess = newsletterPreferencesUpdateSuccess;
exports.updateNewsletterPreferencesFailure = updateNewsletterPreferencesFailure;
exports.newsletterPreferencesChange = newsletterPreferencesChange;
exports.newsletterPreferencesChangeRadio = newsletterPreferencesChangeRadio;
exports.prepareEmailFieldForChange = prepareEmailFieldForChange;
exports.updateSubscriptionEmailSuccess = updateSubscriptionEmailSuccess;
exports.updateSubscriptionEmailError = updateSubscriptionEmailError;
// https://api.github.com/newslettersPreferencesPages/michaelbenin
// import { canUseDOM } from 'exenv';

// page loading actions

function newslettersPreferencesPageLoading() {
  var newslettersPreferencesPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'NEWSLETTERS_PREFERENCES_PAGE_LOADING',
    newslettersPreferencesPage: newslettersPreferencesPage,
    store: store
  };
}

function newslettersPreferencesPageLoaded(newslettersPreferencesPage) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'NEWSLETTERS_PREFERENCES_PAGE_LOADED',
    newslettersPreferencesPage: newslettersPreferencesPage,
    store: store
  };
}

function newslettersPreferencesPageError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'NEWSLETTERS_PREFERENCES_PAGE_ERROR',
    newslettersPreferencesPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

// on submit actions
function newsletterPreferencesUpdateLoading(isLoading) {
  return {
    type: 'IS_UPDATING_NEWSLETTER_PREFERENCES',
    isLoading: isLoading
  };
}

function newsletterPreferencesUpdateSuccess(data) {
  return {
    type: 'UPDATE_NEWSLETTER_PREFERENCES_SUCCESS',
    data: data,
    isLoading: false
  };
}

function updateNewsletterPreferencesFailure(error) {
  return {
    type: 'UPDATE_NEWSLETTER_PREFERENCES_FAILURE',
    data: error,
    msg: 'Error update newsletter post: ' + error
  };
}

// changes to state before submit
function newsletterPreferencesChange(data) {
  return {
    type: 'CHANGE_NEWSLETTER_PREFERENCES',
    data: data
  };
}

function newsletterPreferencesChangeRadio(data) {
  return {
    type: 'CHANGE_NEWSLETTER_PREFERENCES_RADIO',
    data: data
  };
}

function prepareEmailFieldForChange() {
  return {
    type: 'PREPARE_EMAIL_FIELD_FOR_CHANGE'
  };
}

function updateSubscriptionEmailSuccess(data) {
  return {
    type: 'UPDATE_SUBSCRIPTION_EMAIL_SUCCESS',
    data: data
  };
}

function updateSubscriptionEmailError(data) {
  return {
    type: 'UPDATE_SUBSCRIPTION_EMAIL_ERROR',
    data: data
  };
}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _ibd_category = __webpack_require__(261);

var _ibd_category2 = _interopRequireDefault(_ibd_category);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _franchise_intro = __webpack_require__(152);

var _franchise_intro2 = _interopRequireDefault(_franchise_intro);

var _scroll_to_el_util = __webpack_require__(79);

var _scroll_to_el_util2 = _interopRequireDefault(_scroll_to_el_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiftGuide = function (_Component) {
  _inherits(GiftGuide, _Component);

  function GiftGuide() {
    _classCallCheck(this, GiftGuide);

    return _possibleConstructorReturn(this, (GiftGuide.__proto__ || Object.getPrototypeOf(GiftGuide)).apply(this, arguments));
  }

  _createClass(GiftGuide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isDesktop = (0, _client_util2.default)('64em');
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _scroll_to_el_util2.default)('.ibd-category--active', 150);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.giftGuidePage.error || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }
      if (this.props.giftGuidePage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'innovation-by-design-page' },
          _react2.default.createElement(
            'article',
            { className: 'innovation-by-design-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(this.props, 'giftGuidePage.ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var _props = this.props,
          giftGuide = _props.giftGuide,
          giftGuideDetail = _props.giftGuideDetail;

      var year = (0, _get2.default)(this.props.match, 'params.year');
      var category = (0, _get2.default)(this.props.match, 'params.category');
      var sectionTitle = 'Browse By Categories';
      var slugParam = (0, _get2.default)(this.props, 'match.params.slug', '');

      // TODO: this needs to be updated.
      var encodedText = encodeURIComponent("Browse Co.Design's 2017 holiday gift guide, a meticulously curated list of the latest, most innovative, most thoughtful design objects available in 12 categories.");
      var uri = 'https://www.fastcodesign.com/gift-guide/' + slugParam;
      var specialText = "Browse @fastcodesign's 2017 holiday gift guide, a meticulously curated list of the most thoughtful design objects.";

      return _react2.default.createElement(
        'section',
        { className: 'innovation-by-design-page gift-guide-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'div',
          { className: 'ad-container ad-container--gray ad-container--hide-for-small' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileleaderboard' }))
        ),
        _react2.default.createElement(_franchise_intro2.default, {
          poster: (0, _get2.default)(giftGuideDetail, 'logo_url'),
          title: (0, _get2.default)(giftGuideDetail, 'title'),
          desc: (0, _get2.default)(giftGuideDetail, 'intro'),
          social: {
            enableSticky: false,
            modifier: 'feature-feed',
            text: '',
            socialText: {
              twitter: specialText,
              linkedin: encodedText,
              email: encodedText
            },
            uri: uri
          },
          giftGuide: true
        }),
        _react2.default.createElement(
          'section',
          { className: 'ibd-list' },
          _react2.default.createElement(_slug2.default, { slugName: sectionTitle, className: 'ibd-list' })
        ),
        _react2.default.createElement(
          'section',
          { className: 'innovation-by-design-page__category-container' },
          giftGuide.map(function (cat, idx) {
            return _react2.default.createElement(_ibd_category2.default, {
              combinedAdModel: combinedAdModel,
              category: cat,
              key: (0, _get2.default)(cat, 'category_name'),
              index: String(idx),
              year: year,
              active: category === (0, _get2.default)(cat, 'url'),
              slug: 'gift-guide',
              slugParam: slugParam
            });
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        )
      );
    }
  }]);

  return GiftGuide;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var ggData = (0, _get2.default)(state, 'giftGuide.data.rows');
  var ggDetail = (0, _get2.default)(state, 'giftGuideDetail.data.rows[0]');

  return {
    config: state.config || {},
    status: state.status.code,
    giftGuidePage: (0, _get2.default)(state, 'giftGuidePage') || {
      error: true
    },
    giftGuide: ggData || [],
    giftGuideDetail: ggDetail || ''
  };
}

GiftGuide.defaultProps = {
  status: 200
};

GiftGuide.propTypes = {
  status: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  match: _propTypes2.default.shape({}).isRequired,
  giftGuidePage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  giftGuide: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  giftGuideDetail: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(GiftGuide));

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_gift_guide_page_actions = __webpack_require__(897);

var _async_gift_guide_page_actions2 = _interopRequireDefault(_async_gift_guide_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_gift_guide_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_gift_guide_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

;(true);
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CriticalStyles = function (_Component) {
  _inherits(CriticalStyles, _Component);

  function CriticalStyles() {
    _classCallCheck(this, CriticalStyles);

    return _possibleConstructorReturn(this, (CriticalStyles.__proto__ || Object.getPrototypeOf(CriticalStyles)).apply(this, arguments));
  }

  _createClass(CriticalStyles, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.amp === true) {
        return _react2.default.createElement('style', {
          'amp-custom': '',
          dangerouslySetInnerHTML: { __html: '' + this.props.css }
        });
      }

      if (!this.props.shouldRender) {
        return null;
      }

      return _react2.default.createElement('style', {
        className: 'critical-css',
        dangerouslySetInnerHTML: { __html: '' + this.props.css }
      });
    }
  }]);

  return CriticalStyles;
}(_react.Component);

CriticalStyles.propTypes = {
  css: _propTypes2.default.string.isRequired,
  shouldRender: _propTypes2.default.bool.isRequired,
  amp: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state) {
  return {
    shouldRender: state.config.env !== 'development',
    css: state.config.criticalCss || '',
    amp: state.config.amp
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CriticalStyles);

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(130);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(99);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

__webpack_require__(291);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _createBrowserHistory = __webpack_require__(154);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _reactRouterConfig = __webpack_require__(108);

var _scriptjs = __webpack_require__(58);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _root_container = __webpack_require__(334);

var _root_container2 = _interopRequireDefault(_root_container);

__webpack_require__(925);

__webpack_require__(926);

var _store = __webpack_require__(927);

var _store2 = _interopRequireDefault(_store);

var _react_router = __webpack_require__(168);

var _react_router2 = _interopRequireDefault(_react_router);

var _initializer_util = __webpack_require__(1062);

var _initializer_util2 = _interopRequireDefault(_initializer_util);

var _initial_load_action_creator = __webpack_require__(1065);

var _initial_load_action_creator2 = _interopRequireDefault(_initial_load_action_creator);

var _logger_service = __webpack_require__(131);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _caching_service = __webpack_require__(229);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _picture_polyfill_util = __webpack_require__(1066);

var _picture_polyfill_util2 = _interopRequireDefault(_picture_polyfill_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/extensions
// import 'autotrack/autotrack.js';
// https://github.com/reactjs/react-router/blob/master/docs/guides/ServerRendering.md
// https://github.com/reactjs/react-router-redux/blob/master/examples/server/client.js

_bluebird2.default.config({
  warnings: false
});

(0, _initializer_util2.default)().catch(function logError(err) {
  _logger_service2.default.error(err, 'Caught error in initialize.');
});

function bootReact() {
  var browserHistory = (0, _createBrowserHistory2.default)();

  var originalHash = browserHistory.location.hash;

  browserHistory.location.hash = '';

  // get json here
  var bootstrappedConfig = false;
  var env = false;
  var config = document.querySelector('.client-config');

  try {
    bootstrappedConfig = JSON.parse(config.getAttribute('data-state'));
    env = (0, _get2.default)(bootstrappedConfig, 'config.env');
    if (env !== 'development') {
      var criticalCss = document.querySelector('.critical-css');
      bootstrappedConfig.config.criticalCss = criticalCss.innerHTML;
    }
    _caching_service2.default.initialize(bootstrappedConfig.config.cacheEnabled);
    _logger_service2.default.initialize(bootstrappedConfig); // TODO: send, site etc for errors
    browserHistory.location.key = bootstrappedConfig.routing.location.key;
  } catch (error) {
    _logger_service2.default.fatal(error, 'Fatal error parsing bootstrap json.');
  }

  if (!bootstrappedConfig) {
    bootstrappedConfig = {}; // TODO: default bootstrap to handle errors
  }
  var store = (0, _store2.default)(browserHistory, bootstrappedConfig, env);
  var routesToMatch = (0, _react_router2.default)(store);
  (0, _picture_polyfill_util2.default)();

  browserHistory.listen(function (location /* , action */) {
    var url = '' + location.pathname;
    var branch = (0, _reactRouterConfig.matchRoutes)(routesToMatch, url);
    branch.map(function matchMap(_ref) {
      var route = _ref.route,
          match = _ref.match;

      if (route.loadData) {
        if (!route.autoScrollOff) {
          window.scrollTo(0, 0);
        }
        return route.loadData(match);
      }
      return _bluebird2.default.resolve(null);
    });

    if (window.googletag) {
      window.googletag.pubads().updateCorrelator();
    }
  });

  function renderedApp() {
    store.dispatch((0, _initial_load_action_creator2.default)());
    browserHistory.location.hash = originalHash;
    (0, _scriptjs2.default)('https://cdnjs.cloudflare.com/ajax/libs/autotrack/2.2.0/autotrack.js');
    document.documentElement.className += document.documentElement.className === '' ? 'hydrated' : ' hydrated';
  }

  (0, _reactDom.hydrate)(_react2.default.createElement(_root_container2.default, { store: store, history: browserHistory }), window.document, renderedApp);

  if (false) {
    module.hot.accept(['../react_router/react_router', '../views/containers/root_container'], function () {
      // eslint-disable-next-line global-require
      var HotLoadRoot = require('../views/containers/root_container').default;
      (0, _reactDom.render)(_react2.default.createElement(HotLoadRoot, { store: store, history: browserHistory }), window.document);
    });
  }
}

// TODO: add image polyfill util here
if (!window.Map || !window.Set || !window.requestAnimationFrame) {
  (0, _scriptjs2.default)(['https://cdnjs.cloudflare.com/ajax/libs/babel-polyfill/6.26.0/polyfill.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/dom4/1.8.3/dom4.js'], bootReact);
} else {
  bootReact();
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

;(function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
});
;(function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
});
;((function(timeout) {
  if (timeout) {
    timeout.close();
  }
}));

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
;(function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
});

;(function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
});

;((function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
}));

// setimmediate attaches itself to the global object
__webpack_require__(290);
;(setImmediate);
;(clearImmediate);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(68)))

/***/ }),
/* 291 */
/***/ (function(module, exports) {

(function(window, factory) {
	var lazySizes = factory(window, window.document);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(window, function l(window, document) {
	'use strict';
	/*jshint eqnull:true */
	if(!document.getElementsByClassName){return;}

	var lazysizes, lazySizesConfig;

	var docElem = document.documentElement;

	var Date = window.Date;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	var addEventListener = window[_addEventListener];

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('CustomEvent');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initCustomEvent(name, !noBubbles, !noCancelable, detail);

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = 125;
		var rICTimeout = lazySizesConfig.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && lazySizesConfig.ricTimeout ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesConfig.ricTimeout){
					rICTimeout = lazySizesConfig.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || (delay < 9 && requestIdleCallback)){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 300,
		};

		lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesConfig)){
				lazySizesConfig[prop] = lazySizesDefaults[prop];
			}
		}

		window.lazySizesConfig = lazySizesConfig;

		setTimeout(function(){
			if(lazySizesConfig.init){
				init();
			}
		});
	})();

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom;

		var defaultExpand, preloadExpand, hFac;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(e && e.target){
				addRemoveLoadEvents(e.target, resetPreloading);
			}

			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = getCSS(document.body, 'visibility') == 'hidden' || getCSS(elem, 'visibility') != 'hidden';

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal;

			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				if(preloadExpand == null){
					if(!('expand' in lazySizesConfig)){
						lazySizesConfig.expand = docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370;
					}

					defaultExpand = lazySizesConfig.expand;
					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
				}

				if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
					currentExpand = preloadExpand;
					lowRuns = 0;
				} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
					currentExpand = defaultExpand;
				} else {
					currentExpand = shrinkExpand;
				}

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesConfig.loadHidden || getCSS(lazyloadElems[i], 'visibility') != 'hidden') &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			addClass(e.target, lazySizesConfig.loadedClass);
			removeClass(e.target, lazySizesConfig.loadingClass);
			addRemoveLoadEvents(e.target, rafSwitchLoadingClass);
			triggerEvent(e.target, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

			if( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesConfig.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
				src = elem[_getAttribute](lazySizesConfig.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				if(firesLoad){
					addRemoveLoadEvents(elem, resetPreloading, true);
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);

					addClass(elem, lazySizesConfig.loadingClass);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesConfig.lazyClass);

			rAF(function(){
				if( !firesLoad || (elem.complete && elem.naturalWidth > 1)){
					if(firesLoad){
						resetPreloading(event);
					} else {
						isLoading--;
					}
					switchLoadingClass(event);
				}
			}, true);
		});

		var unveilElement = function (elem){
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass) && hasClass(elem, lazySizesConfig.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}
			var afterScroll = debounce(function(){
				lazySizesConfig.loadMode = 3;
				throttledCheckElements();
			});

			isCompleted = true;

			lazySizesConfig.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', function(){
				if(lazySizesConfig.loadMode == 3){
					lazySizesConfig.loadMode = 2;
				}
				afterScroll();
			}, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);
				hFac = lazySizesConfig.hFac;

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	lazysizes = {
		cfg: lazySizesConfig,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(39),n=__webpack_require__(105),p=__webpack_require__(56),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(2),l=__webpack_require__(294),B=__webpack_require__(39),C=__webpack_require__(56),ba=__webpack_require__(295),da=__webpack_require__(296),ea=__webpack_require__(153),fa=__webpack_require__(297),ia=__webpack_require__(300),D=__webpack_require__(105);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(56);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(298);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(299);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The public API for putting history on context.
 */
var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? _react2.default.Children.only(children) : null;
  };

  return Router;
}(_react2.default.Component);

Router.propTypes = {
  history: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node
};
Router.contextTypes = {
  router: _propTypes2.default.object
};
Router.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};
exports.default = Router;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(56);
var invariant = __webpack_require__(110);
var ReactPropTypesSecret = __webpack_require__(304);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _matchPath = __webpack_require__(109);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The public API for rendering the first <Route> that matches.
 */
var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    _react2.default.Children.forEach(children, function (element) {
      if (!_react2.default.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(_react2.default.Component);

Switch.contextTypes = {
  router: _propTypes2.default.shape({
    route: _propTypes2.default.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.object
};
exports.default = Switch;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matchPath = __webpack_require__(109);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isEmptyChildren = function isEmptyChildren(children) {
  return _react2.default.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
  };

  return Route;
}(_react2.default.Component);

Route.propTypes = {
  computedMatch: _propTypes2.default.object, // private, from <Switch>
  path: _propTypes2.default.string,
  exact: _propTypes2.default.bool,
  strict: _propTypes2.default.bool,
  sensitive: _propTypes2.default.bool,
  component: _propTypes2.default.func,
  render: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  location: _propTypes2.default.object
};
Route.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.object.isRequired,
    route: _propTypes2.default.object.isRequired,
    staticContext: _propTypes2.default.object
  })
};
Route.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};
exports.default = Route;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(310);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(311);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(113);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(313),
    ListCache = __webpack_require__(86),
    Map = __webpack_require__(114);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(314),
    hashDelete = __webpack_require__(319),
    hashGet = __webpack_require__(320),
    hashHas = __webpack_require__(321),
    hashSet = __webpack_require__(322);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(85);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(160),
    isMasked = __webpack_require__(316),
    isObject = __webpack_require__(38),
    toSource = __webpack_require__(161);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(317);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(85);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(85);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(85);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    arrayMap = __webpack_require__(116),
    isArray = __webpack_require__(29),
    isSymbol = __webpack_require__(84);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterConfig = __webpack_require__(108);

var _reactRouterRedux = __webpack_require__(61);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _react_router = __webpack_require__(168);

var _react_router2 = _interopRequireDefault(_react_router);

var _head = __webpack_require__(914);

var _head2 = _interopRequireDefault(_head);

var _amp_head = __webpack_require__(922);

var _amp_head2 = _interopRequireDefault(_amp_head);

var _fbia_head = __webpack_require__(924);

var _fbia_head2 = _interopRequireDefault(_fbia_head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Root(_ref) {
  var store = _ref.store,
      history = _ref.history,
      getRoutes = _ref.getRoutes;

  var state = store.getState();
  var amp = (0, _get2.default)(state, 'config.amp');
  var fbia = (0, _get2.default)(state, 'config.fbia');

  if (amp) {
    return _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _reactRouterRedux.ConnectedRouter,
        { history: history },
        _react2.default.createElement(
          'html',
          { amp: '', lang: 'en-US', className: 'fonts-loaded' },
          _react2.default.createElement(_amp_head2.default, null),
          (0, _reactRouterConfig.renderRoutes)(getRoutes(store))
        )
      )
    );
  }

  if (fbia) {
    return _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _reactRouterRedux.ConnectedRouter,
        { history: history },
        _react2.default.createElement(
          'html',
          { lang: 'en-US', prefix: 'op: http://media.facebook.com/op#' },
          _react2.default.createElement(_fbia_head2.default, null),
          (0, _reactRouterConfig.renderRoutes)(getRoutes(store))
        )
      )
    );
  }

  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _reactRouterRedux.ConnectedRouter,
      { history: history },
      _react2.default.createElement(
        'html',
        { lang: 'en-US' },
        _react2.default.createElement(_head2.default, null),
        (0, _reactRouterConfig.renderRoutes)((0, _react_router2.default)(store))
      )
    )
  );
}

Root.defaultProps = {
  getRoutes: undefined
};

Root.propTypes = {
  store: _propTypes2.default.shape({}).isRequired,
  history: _propTypes2.default.shape({}).isRequired,
  getRoutes: _propTypes2.default.func
};

exports.default = Root;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(69);

var _LocationUtils = __webpack_require__(106);

var _createTransitionManager = __webpack_require__(107);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(340);


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(341);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(71)(module)))

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouterConfig = __webpack_require__(108);

var _reactRouter = __webpack_require__(22);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad_util = __webpack_require__(12);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _analytics = __webpack_require__(407);

var _analytics2 = _interopRequireDefault(_analytics);

var _nav = __webpack_require__(432);

var _nav2 = _interopRequireDefault(_nav);

var _nav_data = __webpack_require__(436);

var _nav_data2 = _interopRequireDefault(_nav_data);

var _recirc = __webpack_require__(437);

var _recirc2 = _interopRequireDefault(_recirc);

var _footer = __webpack_require__(445);

var _footer2 = _interopRequireDefault(_footer);

var _config = __webpack_require__(446);

var _config2 = _interopRequireDefault(_config);

var _script = __webpack_require__(208);

var _script2 = _interopRequireDefault(_script);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layout = function (_Component) {
  _inherits(Layout, _Component);

  function Layout() {
    _classCallCheck(this, Layout);

    var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this));

    _this.hasFooter = true;
    return _this;
  }

  _createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.browsiScript();
    }
  }, {
    key: 'livereload',
    value: function livereload(env) {
      if (env === 'development') {
        return _react2.default.createElement('script', { src: '//localhost:35729/livereload.js', async: true });
      }
      return '';
    }
  }, {
    key: 'scriptbundle',
    value: function scriptbundle(env) {
      if (env === 'development') {
        // return <script src="/js/bundle.js" async></script>;
        return _react2.default.createElement('script', { src: '//localhost:3001/static/bundle.js', async: true });
      }
      return _react2.default.createElement('script', { src: this.props.staticUrl + '/js/bundle.js', async: true });
    }
  }, {
    key: 'browsiScript',
    value: function browsiScript() {
      if (!(0, _client_util2.default)() && !document.querySelector('#browsi-tag')) {
        var script = document.createElement('script');
        script.src = 'https://middycdn-a.akamaihd.net/bootstrap/bootstrap.js';
        script.id = 'browsi-tag';
        script.setAttribute('data-pubkey', 'mansueto');
        script.setAttribute('data-sitekey', (0, _get2.default)(this.props, 'config.site', ''));

        document.querySelector('body').appendChild(script);
      }
    }
  }, {
    key: 'adIframe',
    value: function adIframe(site) {
      if ((0, _get2.default)(this.props, 'config.featureFlags.adOpsIframe')) {
        // Used by adops to check if js is enabled
        var adSite = site === 'fastcompany' ? 'fc' : 'fcdesign';
        var iframeSrc = 'https://pubads.g.doubleclick.net/gampad/adx?iu=/4160/mv.' + adSite + '/javascript_disabled&sz=1x1';
        var innerHtml = '<iframe width="1" height="1" frameBorder="0" scrolling="no" src="' + iframeSrc + '" />';

        return _react2.default.createElement('noscript', { dangerouslySetInnerHTML: { __html: innerHtml } });
      }
      return null;
    }
  }, {
    key: 'topNavAd',
    value: function topNavAd(location, site) {
      if (location.pathname !== '/') {
        return null;
      }
      var adData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, null, 'homepage');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      return _react2.default.createElement(
        'div',
        { className: 'homepage-page__ff-ad-container homepage-page__ff-ad-container--navtop' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'welcomemat' }))
      );
    }
  }, {
    key: 'analyticsHeader',
    value: function analyticsHeader() {
      // eslint-disable-next-line class-methods-use-this
      var listOfAnalytics = ['krux', 'comscore', 'nielsen', 'googleAnalytics', 'facebookPixel'];
      return _react2.default.createElement(_analytics2.default, { location: 'header', listOfAnalytics: listOfAnalytics });
    }
  }, {
    key: 'analyticsFooter',
    value: function analyticsFooter(featureFlags) {
      // eslint-disable-next-line class-methods-use-this
      var listOfAnalytics = ['comscore', 'nielsen', 'omniture', 'parsely', 'structuredData', 'moatad'];

      if (featureFlags.liftIgniterEnabled) {
        listOfAnalytics.push('liftIgniter');
      }
      return _react2.default.createElement(_analytics2.default, { location: 'footer', listOfAnalytics: listOfAnalytics });
    }
  }, {
    key: 'postUp',
    value: function postUp() {
      return _react2.default.createElement(_script2.default, {
        type: 'text/javascript',
        innerHtml: "(function () {window.setTimeout(function() {var e = document.createElement('script'); e.type = 'text/javascript'; e.async = true; e.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.lightboxcdn.com/vendor/252af0a6-c9ae-4612-9dbe-5d1552fad623/lightbox_inline.js?mb=' + (new Date().getTime()); var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);}, 500);})();"
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          pageType = _props.pageType,
          recircFeed = _props.recircFeed,
          config = _props.config;

      var featureFlags = (0, _get2.default)(config, 'featureFlags');
      var env = (0, _get2.default)(config, 'env', '');
      var site = (0, _get2.default)(config, 'site', '');

      var activeCategory = '';

      if (this.props.pageType === 'category' || this.props.pageType === 'videoIndexPage') {
        activeCategory = location.pathname;
      }
      var hasTopNavAd = featureFlags.topNavAdEnabled && location.pathname === '/';

      return _react2.default.createElement(
        'body',
        {
          className: 'layout ' + (pageType ? 'layout--' + pageType : '') + ' ' + (hasTopNavAd ? 'layout--has-top-nav-ad' : '') + ' ' + site
        },
        this.analyticsHeader(),
        featureFlags.topNavAdEnabled ? this.topNavAd(location, site) : null,
        _react2.default.createElement(_nav2.default, _extends({
          isHome: location.pathname === '/',
          activeCategory: activeCategory,
          modifier: site,
          config: config
        }, _nav_data2.default[site])),
        _react2.default.createElement(
          'section',
          { className: 'main', role: 'main' },
          (0, _reactRouterConfig.renderRoutes)(this.props.route.routes),
          !(0, _get2.default)(this.props, 'recircFeed.hide') && _react2.default.createElement(_recirc2.default, { config: config, feed: recircFeed })
        ),
        _react2.default.createElement(_footer2.default, null),
        _react2.default.createElement(_config2.default, null),
        this.analyticsFooter(featureFlags),
        this.livereload(env),
        this.scriptbundle(env),
        this.postUp(),
        this.adIframe(site)
      );
    }
  }]);

  return Layout;
}(_react.Component);

function mapStateToProps(state) {
  return {
    config: state.config,
    staticUrl: state.config.staticUrl,
    pageType: state.context.type || '',
    recircFeed: {
      hide: (0, _get2.default)(state, 'recircFeed.hide'),
      fastcompany: (0, _get2.default)(state, 'recircFeed.data.fastcompany') || [],
      fastcodesign: (0, _get2.default)(state, 'recircFeed.data.fastcodesign') || [],
      fastcocreate: (0, _get2.default)(state, 'recircFeed.data.fastcocreate') || [],
      fastcoexist: (0, _get2.default)(state, 'recircFeed.data.fastcoexist') || []
    },
    postFinite: (0, _get2.default)(state, 'postFinite.data.posts') || []
  };
}

Layout.propTypes = {
  route: _propTypes2.default.shape({
    routes: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  staticUrl: _propTypes2.default.string.isRequired,
  pageType: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.shape({}).isRequired,
  recircFeed: _propTypes2.default.shape({
    hide: _propTypes2.default.bool,
    fastcompany: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    fastcocreate: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    fastcodesign: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    fastcoexist: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Layout));

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    createAssigner = __webpack_require__(171),
    keysIn = __webpack_require__(120);

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function(object, source) {
  copyObject(source, keysIn(source), object);
});

module.exports = assignIn;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(346),
    defineProperty = __webpack_require__(170),
    identity = __webpack_require__(94);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isLength = __webpack_require__(119),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(159);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)(module)))

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38),
    isPrototype = __webpack_require__(73),
    nativeKeysIn = __webpack_require__(355);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86),
    Map = __webpack_require__(114),
    MapCache = __webpack_require__(113);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    keys = __webpack_require__(50);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(179);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    keysIn = __webpack_require__(120);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(37);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)(module)))

/***/ }),
/* 365 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    getSymbols = __webpack_require__(124);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(49),
    getSymbolsIn = __webpack_require__(181);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(48),
    root = __webpack_require__(37);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(128),
    cloneDataView = __webpack_require__(374),
    cloneMap = __webpack_require__(375),
    cloneRegExp = __webpack_require__(377),
    cloneSet = __webpack_require__(378),
    cloneSymbol = __webpack_require__(380),
    cloneTypedArray = __webpack_require__(381);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(128);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(376),
    arrayReduce = __webpack_require__(187),
    mapToArray = __webpack_require__(188);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(379),
    arrayReduce = __webpack_require__(187),
    setToArray = __webpack_require__(97);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(128);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(383),
    getPrototype = __webpack_require__(126),
    isPrototype = __webpack_require__(73);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(38);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; /* eslint-disable react/sort-comp */


var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _deepEqual = __webpack_require__(189);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _hoistNonReactStatics = __webpack_require__(387);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _Events = __webpack_require__(190);

var _Events2 = _interopRequireDefault(_Events);

var _filterProps = __webpack_require__(388);

var _filterProps2 = _interopRequireDefault(_filterProps);

var _createManager = __webpack_require__(389);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * An Ad Component using Google Publisher Tags.
 * This component should work standalone w/o context.
 * https://developers.google.com/doubleclick-gpt/
 *
 * @module Bling
 * @class Bling
 * @fires Bling#Events.READY
 * @fires Bling#Events.SLOT_RENDER_ENDED
 * @fires Bling#Events.IMPRESSION_VIEWABLE
 * @fires Bling#Events.SLOT_VISIBILITY_CHANGED
 */
var Bling = (_temp2 = _class = function (_Component) {
    _inherits(Bling, _Component);

    function Bling() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Bling);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bling.__proto__ || Object.getPrototypeOf(Bling)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            scriptLoaded: false,
            inViewport: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * An array of prop names which can reflect to the ad by calling `refresh`.
     *
     * @property refreshableProps
     * @static
     */

    /**
     * An array of prop names which requires to create a new ad slot and render as a new ad.
     *
     * @property reRenderProps
     * @static
     */

    /**
     * An instance of ad manager.
     *
     * @property _adManager
     * @private
     * @static
     */

    /**
     *
     * @property
     * @private
     * @static
     */


    _createClass(Bling, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            Bling._adManager.addInstance(this);
            Bling._adManager.load(Bling._config.seedFileUrl).then(this.onScriptLoaded.bind(this)).catch(this.onScriptError.bind(this));
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var propsEqual = Bling._config.propsEqual;
            var sizeMapping = this.props.sizeMapping;

            if ((nextProps.sizeMapping || sizeMapping) && !propsEqual(nextProps.sizeMapping, sizeMapping)) {
                Bling._adManager.removeMQListener(this, nextProps);
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            // if adUnitPath changes, need to create a new slot, re-render
            // otherwise, just refresh
            var scriptLoaded = nextState.scriptLoaded,
                inViewport = nextState.inViewport;

            var notInViewport = this.notInViewport(nextProps, nextState);
            var inViewportChanged = this.state.inViewport !== inViewport;
            var isScriptLoaded = this.state.scriptLoaded !== scriptLoaded;

            // Exit early for visibility change, before executing deep equality check.
            if (notInViewport) {
                return false;
            } else if (inViewportChanged) {
                return true;
            }

            var _Bling$_config = Bling._config,
                filterProps = _Bling$_config.filterProps,
                propsEqual = _Bling$_config.propsEqual;

            var refreshableProps = filterProps(Bling.refreshableProps, this.props, nextProps);
            var reRenderProps = filterProps(Bling.reRenderProps, this.props, nextProps);
            var shouldRender = !propsEqual(reRenderProps.props, reRenderProps.nextProps);
            var shouldRefresh = !shouldRender && !propsEqual(refreshableProps.props, refreshableProps.nextProps);
            // console.log(`shouldRefresh: ${shouldRefresh}, shouldRender: ${shouldRender}, isScriptLoaded: ${isScriptLoaded}, syncCorrelator: ${Bling._adManager._syncCorrelator}`);

            if (shouldRefresh) {
                this.configureSlot(this._adSlot, nextProps);
            }

            if (Bling._adManager._syncCorrelator) {
                if (shouldRefresh) {
                    Bling._adManager.refresh();
                } else if (shouldRender || isScriptLoaded) {
                    return true;
                }
            } else {
                if (shouldRefresh) {
                    this.refresh();
                    return false;
                }
                if (shouldRender || isScriptLoaded) {
                    return true;
                }
            }

            return false;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            if (this.notInViewport(this.props, this.state)) {
                return;
            }
            if (this._divId) {
                // initial render will enable pubads service before any ad renders
                // so taken care of by the manager
                if (Bling._adManager._initialRender) {
                    Bling._adManager.render();
                } else {
                    this.renderAd();
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            Bling._adManager.removeInstance(this);
            if (this._adSlot) {
                Bling._adManager.googletag.destroySlots([this._adSlot]);
                this._adSlot = null;
            }
        }
    }, {
        key: "onScriptLoaded",
        value: function onScriptLoaded() {
            var onScriptLoaded = this.props.onScriptLoaded;


            if (this.getRenderWhenViewable()) {
                this.foldCheck();
            }
            this.setState({ scriptLoaded: true }, onScriptLoaded); // eslint-disable-line react/no-did-mount-set-state
        }
    }, {
        key: "onScriptError",
        value: function onScriptError(err) {
            console.warn("Ad: Failed to load gpt for " + Bling._config.seedFileUrl, err);
        }
    }, {
        key: "getRenderWhenViewable",
        value: function getRenderWhenViewable() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.renderWhenViewable !== undefined ? props.renderWhenViewable : Bling._config.renderWhenViewable;
        }
    }, {
        key: "foldCheck",
        value: function foldCheck() {
            if (this.state.inViewport) {
                return;
            }

            var slotSize = this.getSlotSize();
            if (Array.isArray(slotSize) && Array.isArray(slotSize[0])) {
                slotSize = slotSize[0];
            }
            if (slotSize === "fluid") {
                slotSize = [0, 0];
            }
            var viewableThresholdValues = this.getUserViewableThresholdValues();
            var inViewport = Bling._adManager.isInViewport(_reactDom2.default.findDOMNode(this), slotSize, this.viewableThreshold, viewableThresholdValues);
            if (inViewport) {
                this.setState({ inViewport: true });
            }
        }
    }, {
        key: "defineSizeMapping",
        value: function defineSizeMapping(adSlot, sizeMapping) {
            if (sizeMapping) {
                Bling._adManager.addMQListener(this, this.props);
                var sizeMappingArray = sizeMapping.reduce(function (mapping, size) {
                    return mapping.addSize(size.viewport, size.slot);
                }, Bling._adManager.googletag.sizeMapping()).build();
                adSlot.defineSizeMapping(sizeMappingArray);
            }
        }
    }, {
        key: "setAttributes",
        value: function setAttributes(adSlot, attributes) {
            // no clear method, attempting to clear existing attributes before setting new ones.
            var attributeKeys = adSlot.getAttributeKeys();
            attributeKeys.forEach(function (key) {
                adSlot.set(key, null);
            });
            if (attributes) {
                Object.keys(attributes).forEach(function (key) {
                    adSlot.set(key, attributes[key]);
                });
            }
        }
    }, {
        key: "setTargeting",
        value: function setTargeting(adSlot, targeting) {
            adSlot.clearTargeting();
            if (targeting) {
                Object.keys(targeting).forEach(function (key) {
                    adSlot.setTargeting(key, targeting[key]);
                });
            }
        }
    }, {
        key: "addCompanionAdService",
        value: function addCompanionAdService(serviceConfig, adSlot) {
            var companionAdsService = Bling._adManager.googletag.companionAds();
            adSlot.addService(companionAdsService);
            if ((typeof serviceConfig === "undefined" ? "undefined" : _typeof(serviceConfig)) === "object") {
                if (serviceConfig.hasOwnProperty("enableSyncLoading")) {
                    companionAdsService.enableSyncLoading();
                }
                if (serviceConfig.hasOwnProperty("refreshUnfilledSlots")) {
                    companionAdsService.setRefreshUnfilledSlots(serviceConfig.refreshUnfilledSlots);
                }
            }
        }
    }, {
        key: "getUserViewableThresholdValues",
        value: function getUserViewableThresholdValues() {
            return this.props.viewableThresholdValues;
        }
    }, {
        key: "getSlotSize",
        value: function getSlotSize() {
            var _props = this.props,
                origSlotSize = _props.slotSize,
                origSizeMapping = _props.sizeMapping;

            var slotSize = void 0;
            if (origSlotSize) {
                slotSize = origSlotSize;
            } else if (origSizeMapping) {
                var sizeMapping = origSizeMapping;
                slotSize = sizeMapping[0] && sizeMapping[0].slot;
            }

            return slotSize;
        }
    }, {
        key: "renderAd",
        value: function renderAd() {
            this.defineSlot();
            this.display();
        }
    }, {
        key: "notInViewport",
        value: function notInViewport() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
            var inViewport = state.inViewport;

            return this.getRenderWhenViewable(props) && !inViewport;
        }
    }, {
        key: "defineSlot",
        value: function defineSlot() {
            var _props2 = this.props,
                adUnitPath = _props2.adUnitPath,
                outOfPage = _props2.outOfPage;

            var divId = this._divId;
            var slotSize = this.getSlotSize();

            if (!this._adSlot) {
                if (outOfPage) {
                    this._adSlot = Bling._adManager.googletag.defineOutOfPageSlot(adUnitPath, divId);
                } else {
                    this._adSlot = Bling._adManager.googletag.defineSlot(adUnitPath, slotSize || [], divId);
                }
            }

            this.configureSlot(this._adSlot);
        }
    }, {
        key: "configureSlot",
        value: function configureSlot(adSlot) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
            var sizeMapping = props.sizeMapping,
                attributes = props.attributes,
                targeting = props.targeting,
                companionAdService = props.companionAdService,
                categoryExclusion = props.categoryExclusion,
                collapseEmptyDiv = props.collapseEmptyDiv,
                safeFrameConfig = props.safeFrameConfig,
                content = props.content,
                clickUrl = props.clickUrl,
                forceSafeFrame = props.forceSafeFrame;


            this.defineSizeMapping(adSlot, sizeMapping);

            if (collapseEmptyDiv !== undefined) {
                if (Array.isArray(collapseEmptyDiv)) {
                    var _adSlot$setCollapseEm;

                    (_adSlot$setCollapseEm = adSlot.setCollapseEmptyDiv).call.apply(_adSlot$setCollapseEm, [adSlot].concat(_toConsumableArray(collapseEmptyDiv)));
                } else {
                    adSlot.setCollapseEmptyDiv(collapseEmptyDiv);
                }
            }

            // Overrides click url
            if (clickUrl) {
                adSlot.setClickUrl(clickUrl);
            }

            // Sets category exclusion
            if (categoryExclusion) {
                var exclusion = categoryExclusion;
                if (typeof exclusion === "string") {
                    exclusion = [exclusion];
                }
                adSlot.clearCategoryExclusions();
                exclusion.forEach(function (item) {
                    adSlot.setCategoryExclusion(item);
                });
            }

            // Sets AdSense attributes
            this.setAttributes(adSlot, attributes);

            // Sets custom targeting parameters
            this.setTargeting(adSlot, targeting);

            if (safeFrameConfig) {
                adSlot.setSafeFrameConfig(safeFrameConfig);
            }

            if (forceSafeFrame) {
                adSlot.setForceSafeFrame(forceSafeFrame);
            }

            // Enables companion ad service
            if (companionAdService) {
                this.addCompanionAdService(companionAdService, adSlot);
            }

            // GPT checks if the same service is already added.
            if (content) {
                adSlot.addService(Bling._adManager.googletag.content());
            } else {
                adSlot.addService(Bling._adManager.googletag.pubads());
            }
        }
    }, {
        key: "display",
        value: function display() {
            var content = this.props.content;

            var divId = this._divId;
            var adSlot = this._adSlot;

            if (content) {
                Bling._adManager.googletag.content().setContent(adSlot, content);
            } else {
                if (!Bling._adManager._disableInitialLoad && !Bling._adManager._syncCorrelator) {
                    Bling._adManager.updateCorrelator();
                }
                Bling._adManager.googletag.display(divId);
                if (Bling._adManager._disableInitialLoad && !Bling._adManager._initialRender) {
                    this.refresh();
                }
            }
        }
    }, {
        key: "clear",
        value: function clear() {
            var adSlot = this._adSlot;
            if (adSlot && adSlot.hasOwnProperty("getServices")) {
                // googletag.ContentService doesn't clear content
                var services = adSlot.getServices();
                if (this._divId && services.some(function (s) {
                    return !!s.setContent;
                })) {
                    document.getElementById(this._divId).innerHTML = "";
                    return;
                }
                Bling._adManager.clear([adSlot]);
            }
        }
    }, {
        key: "refresh",
        value: function refresh(options) {
            var adSlot = this._adSlot;
            if (adSlot) {
                this.clear();
                Bling._adManager.refresh([adSlot], options);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var scriptLoaded = this.state.scriptLoaded;
            var _props3 = this.props,
                id = _props3.id,
                outOfPage = _props3.outOfPage,
                style = _props3.style;

            var shouldNotRender = this.notInViewport(this.props, this.state);

            if (!scriptLoaded || shouldNotRender) {
                var slotSize = this.getSlotSize();

                if (!outOfPage) {
                    (0, _invariant2.default)(slotSize, "Either 'slotSize' or 'sizeMapping' prop needs to be set.");
                }

                if (Array.isArray(slotSize) && Array.isArray(slotSize[0])) {
                    slotSize = slotSize[0];
                }
                // https://developers.google.com/doubleclick-gpt/reference?hl=en#googletag.NamedSize
                if (slotSize === "fluid") {
                    slotSize = ["auto", "auto"];
                }
                var emptyStyle = slotSize && {
                    width: slotSize[0],
                    height: slotSize[1]
                };
                // render node element instead of script element so that `inViewport` check works.
                return _react2.default.createElement("div", { style: emptyStyle });
            }

            // clear the current ad if exists
            this.clear();
            if (this._adSlot) {
                Bling._adManager.googletag.destroySlots([this._adSlot]);
                this._adSlot = null;
            }
            this._divId = id || Bling._adManager.generateDivId();

            return _react2.default.createElement("div", { id: this._divId, style: style });
        }
    }, {
        key: "adSlot",
        get: function get() {
            return this._adSlot;
        }
    }, {
        key: "viewableThreshold",
        get: function get() {
            return this.props.viewableThreshold >= 0 ? this.props.viewableThreshold : Bling._config.viewableThreshold;
        }
    }], [{
        key: "on",
        value: function on(eventType, cb) {
            Bling._on("on", eventType, cb);
        }
    }, {
        key: "once",
        value: function once(eventType, cb) {
            Bling._on("once", eventType, cb);
        }
    }, {
        key: "removeListener",
        value: function removeListener() {
            var _Bling$_adManager;

            (_Bling$_adManager = Bling._adManager).removeListener.apply(_Bling$_adManager, arguments);
        }
    }, {
        key: "removeAllListeners",
        value: function removeAllListeners() {
            var _Bling$_adManager2;

            (_Bling$_adManager2 = Bling._adManager).removeAllListeners.apply(_Bling$_adManager2, arguments);
        }
    }, {
        key: "_on",
        value: function _on(fn, eventType, cb) {
            if (typeof cb !== "function") {
                return;
            }
            if (eventType === _Events2.default.READY && Bling._adManager.isReady) {
                cb.call(Bling._adManager, Bling._adManager.googletag);
            } else {
                Bling._adManager[fn](eventType, cb);
            }
        }
    }, {
        key: "configure",
        value: function configure() {
            var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            Bling._config = _extends({}, Bling._config, config);
        }
        /**
         * Returns the GPT version.
         *
         * @method getGPTVersion
         * @returns {Number|boolean} a version or false if GPT is not yet ready.
         * @static
         */

    }, {
        key: "getGPTVersion",
        value: function getGPTVersion() {
            return Bling._adManager.getGPTVersion();
        }
        /**
         * Returns the Pubads Service version.
         *
         * @method getPubadsVersion
         * @returns {Number|boolean} a version or false if Pubads Service is not yet ready.
         * @static
         */

    }, {
        key: "getPubadsVersion",
        value: function getPubadsVersion() {
            return Bling._adManager.getPubadsVersion();
        }
        /**
         * Sets a flag to indicate whether the correlator value should always be same across the ads in the page or not.
         *
         * @method syncCorrelator
         * @param {boolean} value
         * @static
         */

    }, {
        key: "syncCorrelator",
        value: function syncCorrelator(value) {
            Bling._adManager.syncCorrelator(value);
        }
        /**
         * Trigger re-rendering of all the ads.
         *
         * @method render
         * @static
         */

    }, {
        key: "render",
        value: function render() {
            Bling._adManager.renderAll();
        }
        /**
         * Refreshes all the ads in the page with a new correlator value.
         *
         * @param {Array} slots An array of ad slots.
         * @param {Object} options You can pass `changeCorrelator` flag.
         * @static
         */

    }, {
        key: "refresh",
        value: function refresh(slots, options) {
            Bling._adManager.refresh(slots, options);
        }
        /**
         * Clears the ads for the specified ad slots, if no slots are provided, all the ads will be cleared.
         *
         * @method clear
         * @param {Array} slots An optional array of slots to clear.
         * @static
         */

    }, {
        key: "clear",
        value: function clear(slots) {
            Bling._adManager.clear(slots);
        }
        /**
         * Updates the correlator value for the next ad request.
         *
         * @method updateCorrelator
         * @static
         */

    }, {
        key: "updateCorrelator",
        value: function updateCorrelator() {
            Bling._adManager.updateCorrelator();
        }
    }, {
        key: "testManager",
        set: function set(testManager) {
            (0, _invariant2.default)(testManager, "Pass in createManagerTest to mock GPT");
            Bling._adManager = testManager;
        }
    }]);

    return Bling;
}(_react.Component), _class.propTypes = {
    /**
     * An optional string to be used as container div id.
     *
     * @property id
     */
    id: _propTypes2.default.string,
    /**
     * An optional string indicating ad unit path which will be used
     * to create an ad slot.
     *
     * @property adUnitPath
     */
    adUnitPath: _propTypes2.default.string.isRequired,
    /**
     * An optional object which includes ad targeting key-value pairs.
     *
     * @property targeting
     */
    targeting: _propTypes2.default.object,
    /**
     * An optional prop to specify the ad slot size which accepts [googletag.GeneralSize](https://developers.google.com/doubleclick-gpt/reference#googletag.GeneralSize) as a type.
     * This will be preceded by the sizeMapping if specified.
     *
     * @property slotSize
     */
    slotSize: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    /**
     * An optional array of object which contains an array of viewport size and slot size.
     * This needs to be set if the ad needs to serve different ad sizes per different viewport sizes (responsive ad).
     * Setting the `slot` to any dimension that's not configured in DFP results in rendering an empty ad.
     * The ad slot size which is provided for the viewport size of [0, 0] will be used as default ad size if none of viewport size matches.
     *
     * https://support.google.com/dfp_premium/answer/3423562?hl=en
     *
     * e.g.
     *
     * sizeMapping={[
     *   {viewport: [0, 0], slot: [320, 50]},
     *   {viewport: [768, 0], slot: [728, 90]}
     * ]}
     *
     * @property sizeMapping
     */
    sizeMapping: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        viewport: _propTypes2.default.array,
        slot: _propTypes2.default.array
    })),
    /**
     * An optional flag to indicate whether an ad slot should be out-of-page slot.
     *
     * @property outOfPage
     */
    outOfPage: _propTypes2.default.bool,
    /**
     * An optional flag to indicate whether companion ad service should be enabled for the ad.
     * If an object is passed, it takes as a configuration expecting `enableSyncLoading` or `refreshUnfilledSlots`.
     *
     * @property companionAdService
     */
    companionAdService: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
    /**
     * An optional HTML content for the slot. If specified, the ad will render with the HTML content using content service.
     *
     * @property content
     */
    content: _propTypes2.default.string,
    /**
     * An optional click through URL. If specified, any landing page URL associated with the creative that is served is overridden.
     *
     * @property clickUrl
     */
    clickUrl: _propTypes2.default.string,
    /**
     * An optional string or an array of string which specifies a page-level ad category exclusion for the given label name.
     *
     * @property categoryExclusion
     */
    categoryExclusion: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    /**
     * An optional map of key-value pairs for an AdSense attribute on a particular ad slot.
     * see the list of supported key value: https://developers.google.com/doubleclick-gpt/adsense_attributes#adsense_parameters.googletag.Slot
     *
     * @property attributes
     */
    attributes: _propTypes2.default.object,
    /**
     * An optional flag to indicate whether an empty ad should be collapsed or not.
     *
     * @property collapseEmptyDiv
     */
    collapseEmptyDiv: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
    /**
     * An optional flag to indicate whether ads in this slot should be forced to be rendered using a SafeFrame container.
     *
     * @property forceSafeFrame
     */
    forceSafeFrame: _propTypes2.default.bool,
    /**
     * An optional object to set the slot-level preferences for SafeFrame configuration.
     *
     * @property safeFrameConfig
     */
    safeFrameConfig: _propTypes2.default.object,
    /**
     * An optional event handler function for `googletag.events.SlotRenderEndedEvent`.
     *
     * @property onSlotRenderEnded
     */
    onSlotRenderEnded: _propTypes2.default.func,
    /**
     * An optional event handler function for `googletag.events.ImpressionViewableEvent`.
     *
     * @property onImpressionViewable
     */
    onImpressionViewable: _propTypes2.default.func,
    /**
     * An optional event handler function for `googletag.events.slotVisibilityChangedEvent`.
     *
     * @property onSlotVisibilityChanged
     */
    onSlotVisibilityChanged: _propTypes2.default.func,
    /**
     * An optional flag to indicate whether an ad should only render when it's fully in the viewport area.
     *
     * @property renderWhenViewable
     */
    renderWhenViewable: _propTypes2.default.bool,
    /**
     * An optional number to indicate how much percentage of an ad area needs to be in a viewable area before rendering.
     * Acceptable range is between 0 and 1.
     *
     * @property viewableThreshold
     */
    viewableThreshold: _propTypes2.default.number,
    /**
     * An optional call back function to notify when the script is loaded.
     *
     * @property onScriptLoaded
     */
    onScriptLoaded: _propTypes2.default.func,
    /**
     * An optional call back function to notify when the media queries on the document change.
     *
     * @property onMediaQueryChange
     */
    onMediaQueryChange: _propTypes2.default.func,
    /**
     * An optional object to be applied as `style` props to the container div.
     *
     * @property style
     */
    style: _propTypes2.default.object
}, _class.refreshableProps = ["targeting", "sizeMapping", "clickUrl", "categoryExclusion", "attributes", "collapseEmptyDiv", "companionAdService", "forceSafeFrame", "safeFrameConfig"], _class.reRenderProps = ["adUnitPath", "slotSize", "outOfPage", "content"], _class._adManager = (0, _createManager.createManager)(), _class._config = {
    /**
     * An optional string for GPT seed file url to override.
     */
    seedFileUrl: "//www.googletagservices.com/tag/js/gpt.js",
    /**
     * An optional flag to indicate whether an ad should only render when it's fully in the viewport area. Default is `true`.
     */
    renderWhenViewable: true,
    /**
     * An optional number to indicate how much percentage of an ad area needs to be in a viewable area before rendering. Default value is 0.5.
     * Acceptable range is between 0 and 1.
     */
    viewableThreshold: 0.5,
    /**
     * An optional function to create an object with filtered current props and next props for a given keys to perform equality check.
     */
    filterProps: _filterProps2.default,
    /**
     * An optional function for the filtered props and the next props to perform equality check.
     */
    propsEqual: _deepEqual2.default
}, _temp2);

// proxy pubads API through Bling

exports.default = (0, _hoistNonReactStatics2.default)(Bling, _createManager.pubadsAPI.reduce(function (api, method) {
    api[method] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return Bling._adManager.pubadsProxy({ method: method, args: args });
    };
    return api;
}, {}));

/***/ }),
/* 385 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 386 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 388 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filterProps;
function filterProps(propKeys, props, nextProps) {
    return propKeys.reduce(function (filtered, key) {
        filtered.props[key] = props[key];
        filtered.nextProps[key] = nextProps[key];
        return filtered;
    }, {
        props: {},
        nextProps: {}
    });
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
;((exports.pubadsAPI = undefined));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createManager = createManager;

var _eventemitter = __webpack_require__(191);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _throttleDebounce = __webpack_require__(390);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _exenv = __webpack_require__(4);

var _Events = __webpack_require__(190);

var _Events2 = _interopRequireDefault(_Events);

var _isInViewport2 = __webpack_require__(392);

var _isInViewport3 = _interopRequireDefault(_isInViewport2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// based on https://developers.google.com/doubleclick-gpt/reference?hl=en
var pubadsAPI = exports.pubadsAPI = ["enableAsyncRendering", "enableSingleRequest", "enableSyncRendering", "disableInitialLoad", "collapseEmptyDivs", "enableVideoAds", "set", "get", "getAttributeKeys", "setTargeting", "clearTargeting", "setCategoryExclusion", "clearCategoryExclusions", "setCentering", "setCookieOptions", "setLocation", "setPublisherProvidedId", "setTagForChildDirectedTreatment", "clearTagForChildDirectedTreatment", "setVideoContent", "setForceSafeFrame"];

var APIToCallBeforeServiceEnabled = (["enableAsyncRendering", "enableSingleRequest", "enableSyncRendering", "disableInitialLoad", "collapseEmptyDivs", "setCentering"]);

var AdManager = (function (_EventEmitter) {
    _inherits(AdManager, _EventEmitter);

    function AdManager() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, AdManager);

        var _this = _possibleConstructorReturn(this, (AdManager.__proto__ || Object.getPrototypeOf(AdManager)).call(this, config));

        _this._adCnt = 0;
        _this._initialRender = true;
        _this._syncCorrelator = false;
        _this._testMode = false;
        _this._foldCheck = (0, _throttleDebounce.throttle)(50, function (event) {
            var instances = _this.getMountedInstances();
            instances.forEach(function (instance) {
                if (instance.getRenderWhenViewable()) {
                    instance.foldCheck(event);
                }
            });

            if (_this.testMode) {
                _this._getTimer();
            }
        });

        _this._handleMediaQueryChange = function (event) {
            if (_this._syncCorrelator) {
                _this.refresh();
                return;
            }
            // IE returns `event.media` value differently, need to use regex to evaluate.
            // eslint-disable-next-line wrap-regex
            var res = /min-width:\s?(\d+)px/.exec(event.media);
            var viewportWidth = res && res[1];

            if (viewportWidth && _this._mqls[viewportWidth]) {
                _this._mqls[viewportWidth].listeners.forEach(function (instance) {
                    instance.refresh();
                    if (instance.props.onMediaQueryChange) {
                        instance.props.onMediaQueryChange(event);
                    }
                });
            }
        };

        _this.render = (0, _throttleDebounce.debounce)(4, function () {
            if (!_this._initialRender) {
                return;
            }

            var checkPubadsReady = function checkPubadsReady(cb) {
                if (_this.pubadsReady) {
                    cb();
                } else {
                    setTimeout(checkPubadsReady, 50, cb);
                }
            };

            var instances = _this.getMountedInstances();
            var hasPubAdsService = false;
            var dummyAdSlot = void 0;

            // Define all the slots
            instances.forEach(function (instance) {
                if (!instance.notInViewport()) {
                    instance.defineSlot();
                    var adSlot = instance.adSlot;

                    if (adSlot && adSlot.hasOwnProperty("getServices")) {
                        var services = adSlot.getServices();
                        if (!hasPubAdsService) {
                            hasPubAdsService = services.filter(function (service) {
                                return !!service.enableAsyncRendering;
                            }).length > 0;
                        }
                    }
                }
            });
            // if none of the ad slots uses pubads service, create dummy slot to use pubads service.
            if (!hasPubAdsService) {
                dummyAdSlot = _this.googletag.defineSlot("/", []);
                dummyAdSlot.addService(_this.googletag.pubads());
            }

            // Call pubads API which needs to be called before service is enabled.
            _this._processPubadsQueue();

            // Enable service
            _this.googletag.enableServices();

            // After the service is enabled, check periodically until `pubadsReady` flag returns true before proceeding the rest.
            checkPubadsReady(function () {
                // destroy dummy ad slot if exists.
                if (dummyAdSlot) {
                    _this.googletag.destroySlots([dummyAdSlot]);
                }
                // Call the rest of the pubads API that's in the queue.
                _this._processPubadsQueue();
                // listen for GPT events
                _this._listen();
                // client should be able to set any page-level setting within the event handler.
                _this._isReady = true;
                _this.emit(_Events2.default.READY, _this.googletag);

                // Call display
                instances.forEach(function (instance) {
                    if (!instance.notInViewport()) {
                        instance.display();
                    }
                });

                _this.emit(_Events2.default.RENDER, _this.googletag);

                _this._initialRender = false;
            });
        });
        _this.renderAll = (0, _throttleDebounce.debounce)(4, function () {
            if (!_this.apiReady) {
                return false;
            }

            // first instance updates correlator value and re-render each ad
            var instances = _this.getMountedInstances();
            instances.forEach(function (instance, i) {
                if (i === 0) {
                    _this.updateCorrelator();
                }
                instance.forceUpdate();
            });

            return true;
        });


        if (config.test) {
            _this.testMode = config;
        }
        return _this;
    }

    _createClass(AdManager, [{
        key: "_processPubadsQueue",
        value: function _processPubadsQueue() {
            var _this2 = this;

            if (this._pubadsProxyQueue) {
                Object.keys(this._pubadsProxyQueue).forEach(function (method) {
                    if (_this2.googletag && !_this2.googletag.pubadsReady && APIToCallBeforeServiceEnabled.indexOf(method) > -1 || _this2.pubadsReady) {
                        _this2._pubadsProxyQueue[method].forEach(function (params) {
                            return _this2.pubadsProxy(params);
                        });
                        delete _this2._pubadsProxyQueue[method];
                    }
                });
                if (!Object.keys(this._pubadsProxyQueue).length) {
                    this._pubadsProxyQueue = null;
                }
            }
        }
    }, {
        key: "_callPubads",
        value: function _callPubads(_ref) {
            var method = _ref.method,
                args = _ref.args,
                resolve = _ref.resolve,
                reject = _ref.reject;

            if (typeof this.googletag.pubads()[method] !== "function") {
                reject(new Error("googletag.pubads does not support " + method + ", please update pubadsAPI"));
            } else {
                try {
                    var _googletag$pubads;

                    var result = (_googletag$pubads = this.googletag.pubads())[method].apply(_googletag$pubads, _toConsumableArray(args));
                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            }
        }
    }, {
        key: "_toggleListener",
        value: function _toggleListener(add) {
            var _this3 = this;

            ["scroll", "resize"].forEach(function (eventName) {
                window[add ? "addEventListener" : "removeEventListener"](eventName, _this3._foldCheck);
            });
        }
    }, {
        key: "_getTimer",
        value: function _getTimer() {
            return Date.now();
        }
    }, {
        key: "_listen",
        value: function _listen() {
            var _this4 = this;

            if (!this._listening) {
                [_Events2.default.SLOT_RENDER_ENDED, _Events2.default.IMPRESSION_VIEWABLE, _Events2.default.SLOT_VISIBILITY_CHANGED].forEach(function (eventType) {
                    ["pubads", "content", "companionAds"].forEach(function (service) {
                        // there is no API to remove listeners.
                        _this4.googletag[service]().addEventListener(eventType, _this4._onEvent.bind(_this4, eventType));
                    });
                });
                this._listening = true;
            }
        }
    }, {
        key: "_onEvent",
        value: function _onEvent(eventType, event) {
            // fire to the global listeners
            if (this.listeners(eventType, true)) {
                this.emit(eventType, event);
            }
            // call event handler props
            var instances = this.getMountedInstances();
            var slot = event.slot;

            var funcName = "on" + eventType.charAt(0).toUpperCase() + eventType.substr(1);
            var instance = instances.filter(function (inst) {
                return slot === inst.adSlot;
            })[0];
            if (instance && instance.props[funcName]) {
                instance.props[funcName](event);
            }
        }
    }, {
        key: "syncCorrelator",
        value: function syncCorrelator() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this._syncCorrelator = value;
        }
    }, {
        key: "generateDivId",
        value: function generateDivId() {
            return "bling-" + ++this._adCnt;
        }
    }, {
        key: "getMountedInstances",
        value: function getMountedInstances() {
            if (!this.mountedInstances) {
                this.mountedInstances = [];
            }
            return this.mountedInstances;
        }
    }, {
        key: "addInstance",
        value: function addInstance(instance) {
            var instances = this.getMountedInstances();
            var index = instances.indexOf(instance);
            if (index === -1) {
                // The first instance starts listening for the event.
                if (instances.length === 0) {
                    this._toggleListener(true);
                }
                this.addMQListener(instance, instance.props);
                instances.push(instance);
            }
        }
    }, {
        key: "removeInstance",
        value: function removeInstance(instance) {
            var instances = this.getMountedInstances();
            var index = instances.indexOf(instance);
            if (index >= 0) {
                instances.splice(index, 1);
                // The last instance removes listening for the event.
                if (instances.length === 0) {
                    this._toggleListener(false);
                }
                this.removeMQListener(instance, instance.props);
            }
        }
    }, {
        key: "addMQListener",
        value: function addMQListener(instance, _ref2) {
            var _this5 = this;

            var sizeMapping = _ref2.sizeMapping;

            if (!sizeMapping || !Array.isArray(sizeMapping)) {
                return;
            }

            sizeMapping.forEach(function (size) {
                var viewportWidth = size.viewport && size.viewport[0];
                if (viewportWidth !== undefined) {
                    if (!_this5._mqls) {
                        _this5._mqls = {};
                    }
                    if (!_this5._mqls[viewportWidth]) {
                        var mql = window.matchMedia("(min-width: " + viewportWidth + "px)");
                        mql.addListener(_this5._handleMediaQueryChange);
                        _this5._mqls[viewportWidth] = {
                            mql: mql,
                            listeners: []
                        };
                    }
                    if (_this5._mqls[viewportWidth].listeners.indexOf(instance) === -1) {
                        _this5._mqls[viewportWidth].listeners.push(instance);
                    }
                }
            });
        }
    }, {
        key: "removeMQListener",
        value: function removeMQListener(instance) {
            var _this6 = this;

            if (!this._mqls) {
                return;
            }

            Object.keys(this._mqls).forEach(function (key) {
                var index = _this6._mqls[key].listeners.indexOf(instance);
                if (index > -1) {
                    _this6._mqls[key].listeners.splice(index, 1);
                }
                if (_this6._mqls[key].listeners.length === 0) {
                    _this6._mqls[key].mql.removeListener(_this6._handleMediaQueryChange);
                    delete _this6._mqls[key];
                }
            });
        }
    }, {
        key: "isInViewport",
        value: function isInViewport() {
            return _isInViewport3.default.apply(undefined, arguments);
        }

        /**
         * Refreshes all the ads in the page with a new correlator value.
         *
         * @param {Array} slots An array of ad slots.
         * @param {Object} options You can pass `changeCorrelator` flag.
         * @static
         */

    }, {
        key: "refresh",
        value: function refresh(slots, options) {
            if (!this.pubadsReady) {
                return false;
            }

            // gpt already debounces refresh
            this.googletag.pubads().refresh(slots, options);

            return true;
        }
    }, {
        key: "clear",
        value: function clear(slots) {
            if (!this.pubadsReady) {
                return false;
            }

            this.googletag.pubads().clear(slots);

            return true;
        }

        /**
         * Re-render(not refresh) all the ads in the page and the first ad will update the correlator value.
         * Updating correlator value ensures competitive exclusion.
         *
         * @method renderAll
         * @static
         */

    }, {
        key: "getGPTVersion",
        value: function getGPTVersion() {
            if (!this.apiReady) {
                return false;
            }
            return this.googletag.getVersion();
        }
    }, {
        key: "getPubadsVersion",
        value: function getPubadsVersion() {
            if (!this.pubadsReady) {
                return false;
            }
            return this.googletag.pubads().getVersion();
        }
    }, {
        key: "updateCorrelator",
        value: function updateCorrelator() {
            if (!this.pubadsReady) {
                return false;
            }
            this.googletag.pubads().updateCorrelator();

            return true;
        }
    }, {
        key: "load",
        value: function load(url) {
            var _this7 = this;

            return this._loadPromise || (this._loadPromise = new Promise(function (resolve, reject) {
                // test mode can't be enabled in production mode
                if (_this7.testMode) {
                    resolve(_this7.googletag);
                    return;
                }
                if (!_exenv.canUseDOM) {
                    reject(new Error("DOM not available"));
                    return;
                }
                if (!url) {
                    reject(new Error("url is missing"));
                    return;
                }
                var onLoad = function onLoad() {
                    if (window.googletag) {
                        _this7._googletag = window.googletag;
                        // make sure API is ready for use.
                        _this7.googletag.cmd.push(function () {
                            _this7._isLoaded = true;
                            resolve(_this7.googletag);
                        });
                    } else {
                        reject(new Error("window.googletag is not available"));
                    }
                };
                if (window.googletag && window.googletag.apiReady) {
                    onLoad();
                } else {
                    var script = document.createElement("script");
                    script.async = true;
                    script.onload = onLoad;
                    script.onerror = function () {
                        reject(new Error("failed to load script"));
                    };
                    script.src = url;
                    document.head.appendChild(script);
                }
            }));
        }
    }, {
        key: "pubadsProxy",
        value: function pubadsProxy(_ref3) {
            var _this8 = this;

            var method = _ref3.method,
                _ref3$args = _ref3.args,
                args = _ref3$args === undefined ? [] : _ref3$args,
                resolve = _ref3.resolve,
                reject = _ref3.reject;

            if (!resolve) {
                // there are couple pubads API which doesn't provide getter methods for later use,
                // so remember them here.
                if (APIToCallBeforeServiceEnabled.indexOf(method) > -1) {
                    this["_" + method] = args && args.length && args[0] || true;
                }
                return new Promise(function (resolve2, reject2) {
                    var params = {
                        method: method,
                        args: args,
                        resolve: resolve2,
                        reject: reject2
                    };
                    if (!_this8.pubadsReady) {
                        if (!_this8._pubadsProxyQueue) {
                            _this8._pubadsProxyQueue = {};
                        }
                        if (!_this8._pubadsProxyQueue[method]) {
                            _this8._pubadsProxyQueue[method] = [];
                        }
                        _this8._pubadsProxyQueue[method].push(params);
                    } else {
                        _this8._callPubads(params);
                    }
                });
            }

            this._callPubads({ method: method, args: args, resolve: resolve, reject: reject });

            return Promise.resolve();
        }
    }, {
        key: "googletag",
        get: function get() {
            return this._googletag;
        }
    }, {
        key: "isLoaded",
        get: function get() {
            return !!this._isLoaded;
        }
    }, {
        key: "isReady",
        get: function get() {
            return !!this._isReady;
        }
    }, {
        key: "apiReady",
        get: function get() {
            return this.googletag && this.googletag.apiReady;
        }
    }, {
        key: "pubadsReady",
        get: function get() {
            return this.googletag && this.googletag.pubadsReady;
        }
    }, {
        key: "testMode",
        get: function get() {
            return this._testMode;
        },
        set: function set(config) {
            if (true) {
                return;
            }
            var test = config.test,
                GPTMock = config.GPTMock;

            this._isLoaded = true;
            this._testMode = !!test;

            if (test) {
                (0, _invariant2.default)(test && GPTMock, "Must provide GPTMock to enable testMode. config{GPTMock}");
                this._googletag = new GPTMock(config);
            }
        }
    }]);

    return AdManager;
}(_eventemitter2.default));

function createManager(config) {
    return new AdManager(config);
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var throttle = __webpack_require__(192);
var debounce = __webpack_require__(391);

module.exports = {
	throttle: throttle,
	debounce: debounce
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-undefined */

var throttle = __webpack_require__(192);

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  atBegin       Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */
module.exports = function ( delay, atBegin, callback ) {
	return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
};


/***/ }),
/* 392 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = isInViewport;
function isInViewport(el) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0],
        _ref2 = _slicedToArray(_ref, 2),
        width = _ref2[0],
        height = _ref2[1];

    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var viewableThresholdValues = arguments[3];

    if (!el || el.nodeType !== 1) {
        return false;
    }
    var clientRect = el.getBoundingClientRect();
    if (!viewableThresholdValues) {
        viewableThresholdValues = {
            userViewport: 'desktop',
            mobileValue: 500,
            desktopValue: 500
        };
    }
    var _viewableThresholdVal = viewableThresholdValues,
        userViewport = _viewableThresholdVal.userViewport,
        mobileValue = _viewableThresholdVal.mobileValue,
        desktopValue = _viewableThresholdVal.desktopValue;

    var preLoadOffset = userViewport && userViewport === 'mobile' ? mobileValue : desktopValue;
    var rect = {
        top: clientRect.top - preLoadOffset,
        left: clientRect.left,
        bottom: clientRect.bottom,
        right: clientRect.right
    };
    var viewport = {
        top: 0,
        left: 0,
        bottom: window.innerHeight,
        right: window.innerWidth
    };
    var inViewport = rect.bottom >= viewport.top + height * offset && rect.right >= viewport.left + width * offset && rect.top <= viewport.bottom - height * offset && rect.left <= viewport.right - width * offset;
    return inViewport;
}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(193),
    baseRest = __webpack_require__(172),
    baseUniq = __webpack_require__(130),
    isArrayLikeObject = __webpack_require__(404);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    isArguments = __webpack_require__(95),
    isArray = __webpack_require__(29);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(398);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(195),
    baseIsNaN = __webpack_require__(399),
    strictIndexOf = __webpack_require__(400);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(185),
    noop = __webpack_require__(403),
    setToArray = __webpack_require__(97);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(41),
    isObjectLike = __webpack_require__(44);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  //
  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
  // the lastIndex property so we can continue executing this loop until we've
  // parsed all results.
  //
  for (;
    part = parser.exec(query);
    result[decode(part[1])] = decode(part[2])
  );

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [];

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _last = __webpack_require__(198);

var _last2 = _interopRequireDefault(_last);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _comscore = __webpack_require__(408);

var _comscore2 = _interopRequireDefault(_comscore);

var _facebookpixel = __webpack_require__(409);

var _facebookpixel2 = _interopRequireDefault(_facebookpixel);

var _ga = __webpack_require__(410);

var _ga2 = _interopRequireDefault(_ga);

var _krux = __webpack_require__(416);

var _krux2 = _interopRequireDefault(_krux);

var _moatad = __webpack_require__(417);

var _moatad2 = _interopRequireDefault(_moatad);

var _nielsen = __webpack_require__(418);

var _nielsen2 = _interopRequireDefault(_nielsen);

var _omniture = __webpack_require__(419);

var _omniture2 = _interopRequireDefault(_omniture);

var _parsely = __webpack_require__(426);

var _parsely2 = _interopRequireDefault(_parsely);

var _pingdom = __webpack_require__(427);

var _pingdom2 = _interopRequireDefault(_pingdom);

var _structured_data = __webpack_require__(428);

var _structured_data2 = _interopRequireDefault(_structured_data);

var _trackjs = __webpack_require__(430);

var _trackjs2 = _interopRequireDefault(_trackjs);

var _lift_igniter = __webpack_require__(431);

var _lift_igniter2 = _interopRequireDefault(_lift_igniter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Trackers


/**
 * An analytics component that's broken up to 2 sections, header and footer
 * Pass in the name of the tags you want to display in props
 * and the system will determine what to render
 */
var Analytics = function (_Component) {
  _inherits(Analytics, _Component);

  function Analytics(props) {
    _classCallCheck(this, Analytics);

    var _this = _possibleConstructorReturn(this, (Analytics.__proto__ || Object.getPrototypeOf(Analytics)).call(this, props));

    _this.comscore = _comscore2.default;
    _this.facebookPixel = _facebookpixel2.default;
    _this.googleAnalytics = _ga2.default;
    _this.krux = _krux2.default;
    _this.moatad = _moatad2.default;
    _this.nielsen = _nielsen2.default;
    _this.omniture = _omniture2.default;
    _this.parsely = _parsely2.default;
    _this.pingdom = _pingdom2.default;
    _this.structuredData = _structured_data2.default;
    _this.trackjs = _trackjs2.default;
    _this.liftIgniter = _lift_igniter2.default;
    return _this;
  }

  _createClass(Analytics, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'renderAnalyticsDangerously',
    value: function renderAnalyticsDangerously(context, location, listOfAnalytics, firstLoad, url) {
      var _this2 = this;

      // Create a string of all analytics code
      var combinedAnalytics = '<!-- ANALYTICS ' + location.toUpperCase() + ' START -->';
      listOfAnalytics.forEach(function (analyticTag) {
        if (_this2[analyticTag]) {
          combinedAnalytics += _this2[analyticTag](context, location, firstLoad, url);
        }
      });
      combinedAnalytics += '<!-- ANALYTICS ' + location.toUpperCase() + ' END -->';
      return { __html: combinedAnalytics };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          listOfAnalytics = _props.listOfAnalytics;

      var firstLoad = this.props.initialPageLoad;
      var context = null;

      if (firstLoad) {
        try {
          var currentState = JSON.parse((0, _get2.default)(this.props, 'state'));
          var top = (0, _get2.default)(currentState, 'featuredFeed.data.top') || [];
          var featured = (0, _get2.default)(currentState, 'featuredFeed.data.featured') || [];
          var homeList = top.concat(featured);

          var categoryTop = (0, _get2.default)(currentState, 'categoryFeaturedFeed.top') || [];
          var categoryFeatured = (0, _get2.default)(currentState, 'categoryFeaturedFeed.featured') || [];
          var categoryHomeList = categoryTop.concat(categoryFeatured);

          var tagTop = (0, _get2.default)(currentState, 'tagFeaturedFeed.top') || [];
          var tagFeatured = (0, _get2.default)(currentState, 'tagFeaturedFeed.featured') || [];
          var tagHomeList = tagTop.concat(tagFeatured);

          context = (0, _get2.default)(currentState, 'context');

          context.config = (0, _get2.default)(currentState, 'config');
          context.postData = (0, _get2.default)(currentState, 'post.data.post', null) || (0, _get2.default)(currentState, 'previewPost.data.post', null);
          context.tagPageData = (0, _get2.default)(currentState, 'tagFeaturedFeed.tag', null);
          context.categoryPageData = (0, _get2.default)(currentState, 'categoryFeaturedFeed.category', null);
          context.authorPageData = (0, _get2.default)(currentState, 'author.data', null);
          context.authorAllFeed = (0, _get2.default)(currentState, 'authorAllFeed.data.posts', []);
          context.searchPageData = (0, _get2.default)(currentState, 'search.data', null);
          context.staticPageData = (0, _get2.default)(currentState, 'customPage.data.page[0]', null);
          context.statusCode = (0, _get2.default)(currentState, 'status.code');
          context.homeList = homeList || null;
          context.categoryHomeList = categoryHomeList || null;
          context.tagHomeList = tagHomeList || null;
          context.mostCreativePeoplePageData = (0, _get2.default)(currentState, 'mostCreativePeople', null);
          context.personPageData = (0, _get2.default)(currentState, 'person', null);
          context.ibdPageData = (0, _get2.default)(currentState, 'innovationByDesign', null);
          context.giftGuideData = (0, _get2.default)(currentState, 'giftGuide', null);
          context.companyPageData = (0, _get2.default)(currentState, 'companyData', null);
          context.micYearPageData = (0, _get2.default)(currentState, 'micYear', null);
          context.micSectorPageData = (0, _get2.default)(currentState, 'micSector', null);
          context.videoPageData = (0, _get2.default)(currentState, 'jwVideo', null);
          // context.videoIndexPageData = get(currentState, 'jwVideoIndex', null);
          context.jwPlaylistIndex = (0, _get2.default)(currentState, 'jwPlaylistIndex', null);
          context.magazineArchivePageData = (0, _get2.default)(currentState, 'magazineArchivePage', null);
          context.productPageData = (0, _get2.default)(currentState, 'product', null);
        } catch (e) {
          _logger_service2.default.error(e, 'Unable to parse context for the page');
        }
        /* eslint-disable */

        return _react2.default.createElement('div', {
          dangerouslySetInnerHTML: this.renderAnalyticsDangerously(context, location, listOfAnalytics, firstLoad, this.props.url)
        });
        /* eslint-enable */
      }
      return null;
    }
  }]);

  return Analytics;
}(_react.Component);

Analytics.propTypes = {
  initialPageLoad: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.string.isRequired,
  listOfAnalytics: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

function mapStateToProps(state) {
  var initialPageLoad = state.config.initialPageLoad;

  var currentState = initialPageLoad ? JSON.stringify(state) : '';
  return {
    url: (0, _last2.default)((0, _get2.default)(state, 'config.navHistory', [])),
    state: currentState,
    initialPageLoad: initialPageLoad
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Analytics);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = comscore;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function comscore(context, location) {
  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  var comscoreConfig = (0, _get2.default)(siteConfig, 'comscore');
  var c1 = comscoreConfig.c1,
      publisherId = comscoreConfig.publisherId;


  if (location === 'header') {
    return '\n      <script>\n        var _comscore = _comscore || [];\n        _comscore.push({ c1: "' + c1 + '", c2: "' + publisherId + '" });\n        (function() {\n        var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;\n        s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";\n        el.parentNode.insertBefore(s, el);\n        })();\n      </script>\n    ';
  }

  return '<noscript><img src="http://b.scorecardresearch.com/p?c1=' + c1 + '&c2=' + publisherId + '&cv=2.0&cj=1" /></noscript>';
}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = facebookpixel;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function facebookpixel(context) {
  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  var facebookConfig = (0, _get2.default)(siteConfig, 'facebookPixel');
  var id = facebookConfig.id;


  return '\n    <script>\n      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n              n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;\n          n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;\n          t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,\n              document,\'script\',\'//connect.facebook.net/en_US/fbevents.js\');\n      fbq(\'init\', \'' + id + '\');\n      fbq(\'track\', "PageView");\n    </script>\n  <noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=' + id + '&ev=PageView&noscript=1" /></noscript>\n  ';
}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ga;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(99);

var _forEach2 = _interopRequireDefault(_forEach);

var _toNumber = __webpack_require__(100);

var _toNumber2 = _interopRequireDefault(_toNumber);

var _ad_util = __webpack_require__(12);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _feature_flags = __webpack_require__(75);

var _feature_flags2 = _interopRequireDefault(_feature_flags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ga(context) {
  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    _logger_service2.default.error('GA IS NOT LOADING ON THIS PAGE TYPE ' + (0, _get2.default)(context, 'type') + ' BECAUSE SITECONFIG IS UNDEFINED');
    return '';
  }

  var gaConfig = siteConfig.googleAnalytics;
  var webPropertyId = gaConfig.webPropertyId,
      rollupPropertyId = gaConfig.rollupPropertyId;

  var siteSlug = (0, _get2.default)(siteConfig, 'slug');

  if (_feature_flags2.default.gaCustomVarEnabled) {
    var postData = context.postData,
        tagPageData = context.tagPageData,
        categoryPageData = context.categoryPageData,
        type = context.type;


    var _category = '';
    var _tag = '';

    var legacyDomain = siteSlug;
    var customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'homepage' }];

    var typeLookup = {
      post: function post() {
        _category = (0, _get2.default)(postData, 'categories[0].slug');
        var tags = (0, _get2.default)(postData, 'tags');
        var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);

        var bylineAttribution = null;

        (0, _forEach2.default)(tags, function (tagObj) {
          if (tagObj.name.indexOf('byline_') !== -1 || tagObj.slug.indexOf('byline-') !== -1) {
            bylineAttribution = tagObj.name.replace('byline_', '');
          }
        });

        // For mapping of language, anaytics need to be consistent, language wise
        var typeMap = {
          standard: 'article',
          gallery: 'slideshow',
          video: 'video'
        };
        var pageType = typeMap[(0, _get2.default)(postData, 'format')] || 'article';

        if (_category === 'ideas') {
          legacyDomain = 'Fastcoexist.com';
        } else if (_category === 'entertainment') {
          legacyDomain = 'FastcoCreate.com';
        }

        var minutesRead = (0, _get2.default)(postData, 'readTime');
        if (minutesRead !== 'long') {
          minutesRead = (0, _toNumber2.default)(minutesRead.replace(' minute', ''));
        }

        customDimensions = [{ 'Legacy Domain': legacyDomain }, { Category: _category }, { 'Publication Date': (0, _get2.default)(postData, 'omnitureDate') }, { 'Content Type': pageType }, { 'Minutes Length': minutesRead }, { 'Scroll Page Number': 0 }];

        if (bylineAttribution) {
          customDimensions.push({ Contributor: bylineAttribution });
          customDimensions.push({ Editor: 'Fast Company' });
        } else {
          customDimensions.push({ Contributor: 'Fast Company' });
          customDimensions.push({ Editor: (0, _get2.default)(postData, 'author.name') });
        }

        var eyeBrowTag = (0, _get2.default)(eyeBrowText, 'name');
        if (eyeBrowTag !== '') {
          customDimensions.push({ Tag: eyeBrowTag });
        } else {
          customDimensions.push({ Tag: 'Fast Company' });
        }
      },
      category: function category() {
        _category = (0, _get2.default)(categoryPageData, 'slug');
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { Category: _category }, { 'Content Type': type }];
      },
      tag: function tag() {
        _tag = (0, _get2.default)(tagPageData, 'name');
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { Tag: _tag }, { 'Content Type': 'section page' }];
      },
      author: function author() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': type }];
      },
      search: function search() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': type }];
      },
      page: function page() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': type }];
      },
      personPage: function personPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'person' }];
      },
      personIndexSectionPage: function personIndexSectionPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'person index' }];
      },
      productPage: function productPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'product' }];
      },
      mostCreativePeoplePage: function mostCreativePeoplePage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'most creative people' }];
      },
      mostCreativePeopleCommunityPage: function mostCreativePeopleCommunityPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'most creative people community' }];
      },
      ibdPage: function ibdPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'innovation by design' }];
      },
      companyPage: function companyPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'company' }];
      },
      micYearPage: function micYearPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'most innovative companies year' }];
      },
      companyIndexSectionPage: function companyIndexSectionPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'company sector index' }];
      },
      micSectorPage: function micSectorPage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'most innovative companies sector' }];
      },
      magazineArchivePage: function magazineArchivePage() {
        customDimensions = [{ 'Legacy Domain': legacyDomain }, { 'Content Type': 'magazine archives' }];
      }
    };

    if (typeLookup[type]) {
      typeLookup[type]();
    }

    var customDimensionsString = JSON.stringify(customDimensions);
    var gaDimensionTracker = customDimensions.map(function (dimension) {
      if (!dimension) {
        return '';
      }
      var key = Object.keys(dimension)[0];
      return '\n        ga(\'set\', \'' + key + '\', \'' + dimension[key] + '\');\n      ';
    }).join('');

    return '\n    <script>\n      (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n      })(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');\n\n      ga(\'create\', \'' + webPropertyId + '\', \'auto\');\n      ga(\'create\', \'' + rollupPropertyId + '\', \'auto\', {\'name\': \'rollup\'});\n      ' + gaDimensionTracker + '\n      ga(\'send\', \'pageview\');\n      ga(\'rollup.send\', \'pageview\');\n      ga(\'require\', \'eventTracker\');\n      ga(\'require\', \'cleanUrlTracker\');\n      ga(\'require\', \'impressionTracker\');\n      ga(\'require\', \'mediaQueryTracker\');\n      ga(\'require\', \'outboundFormTracker\');\n      ga(\'require\', \'outboundLinkTracker\');\n      ga(\'require\', \'pageVisibilityTracker\');\n      ga(\'require\', \'socialWidgetTracker\');\n      ga(\'require\', \'urlChangeTracker\');\n      console.log(JSON.stringify(' + customDimensionsString + '));\n    </script>';
  }

  return '\n  <script>\n    (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n    })(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');\n\n    ga(\'create\', \'' + webPropertyId + '\', \'auto\');\n    ga(\'create\', \'' + rollupPropertyId + '\', \'auto\', {\'name\': \'rollup\'});\n    ga(\'send\', \'pageview\');\n    ga(\'rollup.send\', \'pageview\');\n    ga(\'require\', \'eventTracker\');\n    ga(\'require\', \'cleanUrlTracker\');\n    ga(\'require\', \'impressionTracker\');\n    ga(\'require\', \'mediaQueryTracker\');\n    ga(\'require\', \'outboundFormTracker\');\n    ga(\'require\', \'outboundLinkTracker\');\n    ga(\'require\', \'pageVisibilityTracker\');\n    ga(\'require\', \'socialWidgetTracker\');\n    ga(\'require\', \'urlChangeTracker\');\n  </script>';
}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(412),
    keys = __webpack_require__(50);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(413);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(41);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(94);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = krux;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

var _string_util = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function krux(context) {
  var postData = context.postData,
      type = context.type;

  var siteConfig = _identity2.default[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  var kruxConfig = (0, _get2.default)(siteConfig, 'krux');
  var keywords = (0, _get2.default)(siteConfig, 'keywords') || [];
  var siteName = (0, _get2.default)(siteConfig, 'siteName') || '';
  var KruxID = (0, _get2.default)(kruxConfig, 'id');
  var topicList = [];
  var category = '';
  var authorName = '';
  var articleId = null;
  var contentType = type;

  if (type === 'post') {
    var typeMap = {
      post: 'article',
      gallery: 'slideshow',
      video: 'video'
    };

    topicList = (0, _get2.default)(postData, 'tags');
    category = (0, _get2.default)(postData, 'categories[0].slug');
    authorName = (0, _get2.default)(postData, 'author.name');
    articleId = (0, _get2.default)(postData, 'id');
    contentType = typeMap[(0, _get2.default)(postData, 'format')] || 'article';
  }

  // On topic pages category is being passed in as the third param
  var tags = '';

  if (topicList) {
    topicList.forEach(function (tag, index) {
      if (index !== topicList.length - 1) {
        tags += '"' + tag.name + '",';
      } else {
        tags += '"' + tag.name + '"';
      }
    });
  }

  var KruxPreScript = '<script class="kxct" data-id="' + KruxID + '" data-timing="async" data-version="1.9" type="text/javascript"> window.Krux||((Krux=function(){Krux.q.push(arguments)}).q=[]); (function(){ var k=document.createElement("script");k.type="text/javascript";k.async=true; var m,src=(m=location.href.match(/\\bkxsrc=([^&]+)/))&&decodeURIComponent(m[1]); k.src = /^https?:\\/\\/([a-z0-9_\\-\\.]+\\.)?krxd\\.net(:\\d{1,5})?\\//i.test(src) ? src : src === "disable" ? "" : (location.protocol==="https:"?"https:":"http:")+"//cdn.krxd.net/controltag?confid=' + KruxID + '" ; var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(k,s); }()); </script>';

  return '\n  ' + KruxPreScript + '\n  <script>\n      FC_Krux_FPA = {\n          author: null,\n          channels: null,\n          subChannels: null,\n          contentType: null,\n          keywords: null,\n          socialTags: null,\n          siteName: null,\n          referrerUrl: null,\n          url: location.origin + location.pathname,\n          querystring: null\n      };\n      FC_Krux_FPA[\'Read Length\'] = null;\n      FC_Krux_FPA[\'Article ID\'] = ' + articleId + ';\n      FC_Krux_FPA[\'Subchannel\'] = ' + (category ? (0, _string_util.addQuotes)(category.toString()) : null) + ';\n      FC_Krux_FPA[\'Channel\'] = ' + (category ? (0, _string_util.addQuotes)(category.toString()) : null) + ';\n\n      if(location.search !== \'\') {\n          FC_Krux_FPA.querystring = location.search;\n      }\n\n      if(document.referrer) {\n          FC_Krux_FPA.referrerUrl = document.referrer;\n      }\n\n      FC_Krux_FPA.channels = "' + keywords + '".split(\',\');\n      FC_Krux_FPA.siteName = ' + (siteName ? (0, _string_util.addQuotes)(siteName.toString()) : null) + ';\n\n      FC_Krux_FPA.author = ' + (authorName ? (0, _string_util.addQuotes)(authorName.toString()) : null) + ';\n      FC_Krux_FPA.subChannels = ' + (category ? (0, _string_util.addQuotes)(category.toString()) : null) + ';\n      FC_Krux_FPA.keywords = [' + tags + '];\n      FC_Krux_FPA.socialTags = [' + tags + '];\n      FC_Krux_FPA.contentType = ' + (contentType ? (0, _string_util.addQuotes)(contentType.toString()) : null) + ';\n\n      window.FC_Krux_FPA = FC_Krux_FPA;\n  </script>\n  <script> window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]); (function(){ function retrieve(n){ var m, k=\'kxmansueto_\'+n; if(window.localStorage){ return window.localStorage[k] || ""; }else if(navigator.cookieEnabled){ m = document.cookie.match(k+\'=([^;]*)\'); return (m && unescape(m[1])) || ""; }else{ return \'\'; } } Krux.user = retrieve(\'user\');})();\n  </script>';
}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = moatad;
function moatad() {
  return "<script> (function(){function t(){for(var a=[8],e=1;1>=e;e++)a.push(8+e),a.push(8-e);a=a[Math.floor(Math.random()*a.length)];return{b:a,a:0==Math.floor(Math.random()*a)}}function k(a){var e=a=a.replace(\":\",\"\");try{for(var b=0;100>b&&(a=decodeURIComponent(a),e!=a)&&!a.match(/^http(s)?\\:/);b++)e=a}catch(c){}return a.replace(/(^\\s+|\\s+$)/g,\"\")}try{if(!location||!location.hostname||!location.pathname)return!1;var c=document.location.hostname.replace(/^www\\./,\"\"),u=function(){for(var a,b=document.getElementsByTagName(\"meta\"), c,d=0,f=b.length;d<f;d++)if(c=b[d],\"og:title\"===c.getAttribute(\"property\")){a=c.getAttribute(\"content\");break}a||(a=document.title||\"Untitled\");return a}(),b={},b=function(a,b,c){a.l1=b;a.l2=c;a.l3=\"__page__\";a.l4=\"-\";return a}(b,c,u),l=(new Date).getTime(),m=Math.floor(Math.random()*Math.pow(10,12)),d,f;f=t();f.a?d=f.b:d=0;b.zmoatab_cm=d;b.t=l;b.de=m;b.zMoatAB_SNPT=!0;var g;d?g=d:g=1;var n;n=f?f.a?!0:!1:!0;var c=[],p=[k(b.l1),k(b.l2),k(b.l3),k(b.l4)].join(\":\"),v=\"https://aqoqxo4wxfum-a.akamaihd.net/z.gif?e=17&d=\"+ encodeURIComponent(p)+\"&de=\"+m+\"&t=\"+l+\"&i=MANSUETOCONTENT1&cm=\"+g+\"&mp=1&ac=1&pl=1&bq=10&vc=2&cs=0\",w=\"https://px.moatads.com/pixel.gif?e=17&d=\"+encodeURIComponent(p)+\"&de=\"+m+\"&t=\"+l+\"&i=MANSUETOCONTENT1&cm=\"+g+\"&mp=0&ac=1&pl=1&bq=10&ad_type=img&vc=2&cs=0\",x=\"https://px.moatads.com/pixel.gif?e=17&d=\"+encodeURIComponent(p)+\"&de=\"+m+\"&t=\"+l+\"&i=MANSUETOCONTENT1&cm=\"+g+\"&ku=1&ac=1&pl=1&bq=10&ad_type=img&vc=2&cs=0\";n&&((new Image).src=v,(new Image).src=w);for(var q in b)c.push(q+\"=\"+encodeURIComponent(b[q])); var c=c.join(\"&\"),c=c+\"&vc=2\",h=document.createElement(\"script\");h.type=\"text/javascript\";h.async=!0;n&&(h.onerror=function(){(new Image).src=x});var r=document.getElementsByTagName(\"script\")[0];r.parentNode.insertBefore(h,r);h.src=\"https://z.moatads.com/mansuetocontent806566985637/moatcontent.js#\"+c}catch(a){try{var y=\"//pixel.moatads.com/pixel.gif?e=24&d=data%3Adata%3Adata%3Adata&i=MOATCONTENTABSNIPPET1&vc=2&ac=1&k=\"+encodeURIComponent(a)+\"&j=\"+encodeURIComponent(document.referrer)+\"&cs=\"+(new Date).getTime(); (new Image).src=y}catch(e){}}})();\n  </script>";
}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = nielsen;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nielsen(context, location) {
  var siteConfig = _identity2.default[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  var nielsenConfig = (0, _get2.default)(siteConfig, 'nielsen');
  var clientId = nielsenConfig.clientId;


  if (location === 'header') {
    return '\n      <script type="text/javascript">\n        (function () {\n          var d = new Image(1, 1);\n          d.onerror = d.onload = function () {\n          d.onerror = d.onload = null;\n          };\n          d.src = ["//secure-us.imrworldwide.com/cgi-bin/m?ci=' + clientId + '&cg=0&cc=1&si=", escape(window.location.href), "&rp=", escape(document.referrer), "&ts=compact&rnd=", (new Date()).getTime()].join(\'\');\n        })();\n\n        function Nielsen_Event() {\n          var d = new Image(1, 1);\n          d.onerror = d.onload = function () { d.onerror = d.onload = null; };\n          d.src = ["//secure-us.imrworldwide.com/cgi-bin/m?ci=' + clientId + '&cg=0&cc=1&si=", escape(window.location.href),\n          "&rp=", escape(document.referrer),\n          "&ts=compact&c0=usergen,1&rnd=",(new Date()).getTime()].join(\'\');\n        };\n      </script>\n    ';
  }

  return '<noscript><div><img src="//secure-us.imrworldwide.com/cgi-bin/m?ci=' + clientId + '&amp;cg=0&amp;cc=1&amp;ts=noscript" width="1" height="1" alt="" /></div></noscript>';
}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = omniture;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _capitalize = __webpack_require__(200);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function omniture(context) {
  var siteConfig = _identity2.default[context.site];
  var disableOmniture = (0, _get2.default)(context, 'config.navHistory[0]') ? (0, _get2.default)(context, 'config.navHistory[0]').indexOf('?omniture=false') !== -1 : false;

  if (siteConfig === undefined || disableOmniture) {
    return '';
  }
  var omnitureConfig = (0, _get2.default)(siteConfig, 'omniture');
  var siteSlug = (0, _get2.default)(siteConfig, 'slug');

  var postData = context.postData,
      tagPageData = context.tagPageData,
      categoryPageData = context.categoryPageData,
      authorPageData = context.authorPageData,
      searchPageData = context.searchPageData,
      staticPageData = context.staticPageData,
      mostCreativePeoplePageData = context.mostCreativePeoplePageData,
      personPageData = context.personPageData,
      statusCode = context.statusCode,
      ibdPageData = context.ibdPageData,
      companyPageData = context.companyPageData,
      micYearPageData = context.micYearPageData,
      micSectorPageData = context.micSectorPageData,
      videoPageData = context.videoPageData,
      productPageData = context.productPageData,
      type = context.type;

  var _category = '';
  var _tag = '';

  // Omniture data structure, defaults to homepage value
  // it will be further extended depend on page type
  var omnitureMapping = {
    server: siteSlug,
    channel: 'homepage',
    pageName: siteSlug + ':homepage:front',
    events: 'event9',
    prop1: '',
    prop2: '',
    prop3: '',
    prop4: (0, _get2.default)(siteConfig, 'url'),
    prop5: '',
    prop6: '',
    prop7: '',
    prop8: '',
    prop9: '',
    prop10: '',
    prop11: '',
    prop13: 1,
    prop21: 'anonymous',
    prop22: 'anonymous:' + siteSlug + ':homepage:front',
    prop23: 'anonymous',
    prop28: '',
    prop31: '',
    prop32: '',
    prop33: '',
    prop34: '',
    eVar49: 1
  };

  var typeLookup = {
    post: function post() {
      _category = (0, _get2.default)(postData, 'categories[0].slug');
      var postID = (0, _get2.default)(postData, 'id');
      var postSlug = (0, _get2.default)(postData, 'slug');
      var tags = (0, _get2.default)(postData, 'tags');
      var eyeBrowText = (0, _ad_util.figureOutPriorityTag)(tags);

      // For mapping of language, anaytics need to be consistent, language wise
      var typeMap = {
        standard: 'article',
        gallery: 'slideshow',
        video: 'video'
      };

      var pageType = typeMap[(0, _get2.default)(postData, 'format')] || 'article';
      return (0, _extend2.default)({}, omnitureMapping, {
        pageName: siteSlug + ':' + postID + ':' + postSlug,
        channel: '',
        prop1: _category,
        prop2: _category,
        prop3: (0, _get2.default)(postData, 'title'),
        prop4: (0, _get2.default)(postData, 'link'),
        prop5: (0, _get2.default)(eyeBrowText, 'slug'),
        prop6: (0, _get2.default)(eyeBrowText, 'slug'),
        prop8: (0, _get2.default)(postData, 'author.name'),
        prop9: (0, _get2.default)(postData, 'omnitureDate'),
        prop10: postID,
        prop11: (0, _get2.default)(postData, 'author.name'),
        prop22: 'anonymous:' + siteSlug + ':' + postID + ':' + postSlug,
        prop28: pageType,
        prop33: (0, _capitalize2.default)(_category),
        prop34: (0, _get2.default)(postData, 'readTime')
      });
    },
    category: function category() {
      _category = (0, _get2.default)(categoryPageData, 'slug', 'news');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: _category,
        pageName: siteSlug + ':' + _category + ':front',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/' + _category,
        prop22: 'anonymous:' + siteSlug + ':' + _category + ':front'
      });
    },
    tag: function tag() {
      _tag = (0, _get2.default)(tagPageData, 'slug', 'tag');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: _tag,
        pageName: siteSlug + ':taxonomy:' + _tag,
        prop3: (0, _get2.default)(tagPageData, 'name'),
        prop4: (0, _get2.default)(siteConfig, 'url') + '/section/' + _tag,
        prop5: _tag,
        prop6: _tag,
        prop8: 'Fast Company Contributor',
        prop11: 'Fast Company Contributor',
        prop22: 'anonymous:' + siteSlug + ':taxonomy:' + _tag,
        prop28: 'collection'
      });
    },
    author: function author() {
      var authorSlug = (0, _get2.default)(authorPageData, 'slug', 'fastcompany-staff');
      var authorName = (0, _get2.default)(authorPageData, 'name', 'Fastcompany Staff');

      return (0, _extend2.default)({}, omnitureMapping, {
        channel: '',
        pageName: siteSlug + ':user:' + authorSlug,
        prop3: authorName,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/user/' + authorSlug,
        prop8: authorName,
        prop11: authorName,
        prop22: 'anonymous:' + siteSlug + ':user:' + authorSlug,
        prop28: 'user'
      });
    },
    search: function search() {
      var searchQuery = (0, _get2.default)(searchPageData, 'query.queryString', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: '',
        pageName: siteSlug + ':search:' + searchQuery,
        prop3: searchQuery,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/search/' + searchQuery,
        prop5: searchQuery,
        prop6: searchQuery,
        prop22: 'anonymous:' + siteSlug + ':search:' + searchQuery,
        prop28: 'search'
      });
    },
    page: function page() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: '',
        pageName: siteSlug + ':page:' + (0, _get2.default)(staticPageData, 'slug'),
        prop4: (0, _get2.default)(siteConfig, 'url') + '/' + (0, _get2.default)(staticPageData, 'slug'),
        prop22: 'anonymous:' + siteSlug + ':page:' + (0, _get2.default)(staticPageData, 'slug'),
        prop28: 'page'
      });
    },
    sitemapIndexPage: function sitemapIndexPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'sitemap',
        pageName: siteSlug + ':sitemapIndexPage',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/sitemap',
        prop22: 'anonymous:' + siteSlug + ':page:sitemapIndexPage',
        prop28: 'sitemap'
      });
    },
    sitemapPostPage: function sitemapPostPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'sitemap',
        pageName: siteSlug + ':sitemapPostPage',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/sitemap/posts',
        prop22: 'anonymous:' + siteSlug + ':page:sitemapPostPage',
        prop28: 'sitemap'
      });
    },
    personPage: function personPage() {
      var personSlug = (0, _get2.default)(personPageData, 'data.rows[0].url', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'person',
        pageName: siteSlug + ':person:' + personSlug,
        prop3: personSlug,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/person/' + personSlug,
        prop22: 'anonymous:' + siteSlug + ':person:' + personSlug,
        prop28: 'article'
      });
    },
    personIndexSectionPage: function personIndexSectionPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'person',
        pageName: siteSlug + ':person-index',
        prop3: 'Person Index',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/person',
        prop22: 'anonymous:' + siteSlug + ':person-index',
        prop28: 'person'
      });
    },
    mostCreativePeoplePage: function mostCreativePeoplePage() {
      var year = (0, _get2.default)(mostCreativePeoplePageData, 'year', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'MCP',
        pageName: year ? siteSlug + ':mcp:' + year : siteSlug + ':mcp:front', // front of year
        prop3: 'MCP LIST',
        prop4: year ? (0, _get2.default)(siteConfig, 'url') + '/most-creative-people/' + year : (0, _get2.default)(siteConfig, 'url') + '/most-creative-people',
        prop22: 'anonymous:' + siteSlug + ':page:mcp',
        prop28: 'mcp'
      });
    },
    mostCreativePeopleCommunityPage: function mostCreativePeopleCommunityPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'MCP',
        pageName: siteSlug + ':most-creative-people-community',
        prop3: 'Most Creative People Community Page',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/most-creative-people-community',
        prop22: 'anonymous:' + siteSlug + ':mcp:community',
        prop28: 'mcp'
      });
    },
    ibdPage: function ibdPage() {
      var year = (0, _get2.default)(ibdPageData, 'year', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'IBD',
        pageName: year ? siteSlug + ':ibd:' + year : siteSlug + ':ibd:front', // front of year
        prop3: 'Innovation By Design Awards ' + year,
        prop4: year ? (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design/' + year : (0, _get2.default)(siteConfig, 'url') + '/innovation-by-design',
        prop22: 'anonymous:' + siteSlug + ':page:ibd',
        prop28: 'ibd'
      });
    },
    productIndexSectionPage: function productIndexSectionPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'product',
        pageName: 'product:homepage:front', // front of year
        prop3: 'Product Index Page',
        prop4: 'https://www.fastcodesign.com/stuff',
        prop22: 'anonymous:product:homepage:front',
        prop28: 'product'
      });
    },
    productIndexPage: function productIndexPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'product',
        pageName: 'product:homepage:front', // front of year
        prop3: 'Product Index Page',
        prop4: 'https://www.fastcodesign.com/stuff',
        prop22: 'anonymous:product:homepage:front',
        prop28: 'product'
      });
    },
    productPage: function productPage() {
      var productName = (0, _get2.default)(productPageData, 'data.rows[0].name');
      var productSlug = (0, _get2.default)(productPageData, 'data.rows[0].url');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'product',
        pageName: 'product:' + productSlug, // front of year
        prop3: 'Product: ' + productName,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/product/' + productSlug,
        prop22: 'anonymous:product:' + productSlug,
        prop28: 'product'
      });
    },
    companyPage: function companyPage() {
      var companyURL = (0, _get2.default)(companyPageData, 'data.rows[0].url', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'company',
        pageName: 'company:profile:' + companyURL, // front of year
        prop3: 'Company Profile Page',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/company/' + companyURL,
        prop22: 'anonymous:company:profile:' + companyURL,
        prop28: 'company'
      });
    },
    companyIndexSectionPage: function companyIndexSectionPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'company',
        pageName: 'company:index',
        prop3: 'Company Index Page',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/company',
        prop22: 'anonymous:company:index',
        prop28: 'company'
      });
    },
    micYearPage: function micYearPage() {
      var year = (0, _get2.default)(micYearPageData, 'year', '');
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'mic',
        pageName: year ? siteSlug + ':mic:' + year : siteSlug + ':mic:front', // front of year
        prop3: 'Most Innovative Companies ' + year,
        prop4: year ? (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year : (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies',
        prop22: 'anonymous:' + siteSlug + ':mic',
        prop28: 'mic'
      });
    },
    micSectorPage: function micSectorPage() {
      var year = (0, _get2.default)(micSectorPageData, 'year', '');
      var sector = (0, _get2.default)(micSectorPageData, 'sector', '');

      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'mic',
        pageName: siteSlug + ':mic:' + year + ':' + sector,
        prop3: 'Most Innovative Companies ' + year + ' ' + sector,
        prop4: (0, _get2.default)(siteConfig, 'url') + '/most-innovative-companies/' + year + '/' + sector,
        prop22: 'anonymous:' + siteSlug + ':mic:' + year + ':' + sector,
        prop28: 'mic'
      });
    },
    videoPage: function videoPage() {
      var currentVideoData = (0, _get2.default)(videoPageData, 'data.playlist[0]', null);
      if (!currentVideoData) {
        return {};
      }

      var videoTag = (0, _get2.default)(currentVideoData, 'category');
      var postID = (0, _get2.default)(currentVideoData, 'id');

      // Extend original omniture variable
      return (0, _extend2.default)({}, omnitureMapping, {
        pageName: siteSlug + ':' + postID + ':' + (0, _get2.default)(currentVideoData, 'slug'),
        channel: 'video',
        prop1: 'video',
        prop2: 'video',
        prop3: (0, _get2.default)(currentVideoData, 'title'),
        prop4: (0, _get2.default)(currentVideoData, 'link'),
        prop5: videoTag,
        prop6: videoTag,
        prop8: 'FastCo Studios',
        prop9: (0, _get2.default)(currentVideoData, 'omnitureDate'),
        prop10: postID,
        prop11: 'FastCo Studios',
        prop22: 'anonymous:' + siteSlug + ':' + postID + ':' + (0, _get2.default)(currentVideoData, 'slug'),
        prop28: 'video',
        prop33: (0, _capitalize2.default)('video')
      });
    },
    videoIndexPage: function videoIndexPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'video',
        pageName: siteSlug + ':video:front',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/videos',
        prop22: 'anonymous:' + siteSlug + ':video:front'
      });
    },
    magazineArchivePage: function magazineArchivePage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'magazine',
        pageName: 'magazine:magazine-archives:front', // front of year
        prop3: 'Magazine Archives Page',
        prop4: (0, _get2.default)(siteConfig, 'url') + '/magazine/archives',
        prop22: 'anonymous:magazine:archives:front',
        prop28: 'magazine'
      });
    },
    newslettersPreferencesPage: function newslettersPreferencesPage() {
      return (0, _extend2.default)({}, omnitureMapping, {
        channel: 'newsletters',
        pageName: 'newsletters:newsletters-preferences:front', // front of year
        prop3: 'Fast Company Newsletters Preferences Page',
        prop4: 'https://www.fastcompany.com/newsletters-preferences',
        prop22: 'anonymous:newsletters:newsletters-preferences:front',
        prop28: 'newsletters'
      });
    }
  };

  if (statusCode && statusCode === 404) {
    omnitureMapping = (0, _extend2.default)({}, omnitureMapping, {
      channel: 'Error Page',
      pageType: 'errorPage',
      pageName: '',
      events: '',
      prop1: '',
      prop2: '',
      prop3: '',
      prop4: (0, _get2.default)(siteConfig, 'url'),
      prop5: '',
      prop6: '',
      prop7: '',
      prop8: '',
      prop9: '',
      prop10: '',
      prop11: '',
      prop13: 1,
      prop21: '',
      prop22: '',
      prop23: '',
      prop31: true,
      prop32: 404,
      prop33: '',
      prop34: ''
    });
  }

  if (typeLookup[type]) {
    omnitureMapping = typeLookup[type]();
  }

  return '\n    <script type="text/javascript">\n    (function (global, oDOC, handler) {\n    var head = oDOC.head || oDOC.getElementsByTagName("head");\n    function LABjsLoaded() {\n        window.fastco_s = window.fastco_s || {};\n        window.fastco_s.server="' + (0, _get2.default)(omnitureConfig, 'server') + '";\n        window.fastco_s.channel="' + (0, _get2.default)(omnitureMapping, 'channel') + '";\n        window.fastco_s.pageName="' + (0, _get2.default)(omnitureMapping, 'pageName') + '";\n        window.fastco_s.events="' + (0, _get2.default)(omnitureMapping, 'events') + '";\n        window.fastco_s.prop1="' + (0, _get2.default)(omnitureMapping, 'prop1') + '";\n        window.fastco_s.prop2="' + (0, _get2.default)(omnitureMapping, 'prop2') + '";\n        window.fastco_s.prop3="' + (0, _get2.default)(omnitureMapping, 'prop3') + '";\n        window.fastco_s.prop4="' + (0, _get2.default)(omnitureMapping, 'prop4') + '";\n        window.fastco_s.prop5="' + (0, _get2.default)(omnitureMapping, 'prop5') + '";\n        window.fastco_s.prop6="' + (0, _get2.default)(omnitureMapping, 'prop6') + '";\n        window.fastco_s.prop7="' + (0, _get2.default)(omnitureMapping, 'prop7') + '";\n        window.fastco_s.prop8="' + (0, _get2.default)(omnitureMapping, 'prop8') + '";\n        window.fastco_s.prop9="' + (0, _get2.default)(omnitureMapping, 'prop9') + '";\n        window.fastco_s.prop10="' + (0, _get2.default)(omnitureMapping, 'prop10') + '";\n        window.fastco_s.prop11="' + (0, _get2.default)(omnitureMapping, 'prop11') + '";\n        window.fastco_s.prop13="' + (0, _get2.default)(omnitureMapping, 'prop13') + '";\n        window.fastco_s.prop21="' + (0, _get2.default)(omnitureMapping, 'prop21') + '";\n        window.fastco_s.prop22="' + (0, _get2.default)(omnitureMapping, 'prop22') + '";\n        window.fastco_s.prop23="' + (0, _get2.default)(omnitureMapping, 'prop23') + '";\n        window.fastco_s.prop28="' + (0, _get2.default)(omnitureMapping, 'prop28') + '";\n        window.fastco_s.prop31="' + (0, _get2.default)(omnitureMapping, 'prop31') + '";\n        window.fastco_s.prop32="' + (0, _get2.default)(omnitureMapping, 'prop32') + '";\n        window.fastco_s.prop33="' + (0, _get2.default)(omnitureMapping, 'prop33') + '";\n        window.fastco_s.prop34="' + (0, _get2.default)(omnitureMapping, 'prop34') + '";\n        window.fastco_s.eVar49="' + (0, _get2.default)(omnitureMapping, 'eVar49') + '";\n        window.s_code = fastco_s.t();\n        if (s_code)document.write(s_code)\n      }\n      // loading code borrowed directly from LABjs itself\n    setTimeout(function () {\n        if ("item" in head) { // check if ref is still a live node list\n            if (!head[0]) { // append_to node not yet ready\n                setTimeout(arguments.callee, 25);\n                return;\n            }\n            head = head[0]; // reassign from live node list ref to pure node ref -- avoids nasty IE bug where changes to DOM invalidate live node lists\n        }\n        var scriptElem = oDOC.createElement("script"),\n            scriptdone = false;\n        scriptElem.onload = scriptElem.onreadystatechange = function () {\n            if ((scriptElem.readyState && scriptElem.readyState !== "complete" && scriptElem.readyState !== "loaded") || scriptdone) {\n                return false;\n            }\n            scriptElem.onload = scriptElem.onreadystatechange = null;\n            scriptdone = true;\n            LABjsLoaded();\n        };\n        scriptElem.src = "' + (0, _get2.default)(omnitureConfig, 'scode') + '";\n        head.insertBefore(scriptElem, head.firstChild);\n    }, 0);\n\n    // required: shim for FF <= 3.5 not having document.readyState\n    if (oDOC.readyState == null && oDOC.addEventListener) {\n        oDOC.readyState = "loading";\n        oDOC.addEventListener("DOMContentLoaded", handler = function () {\n            oDOC.removeEventListener("DOMContentLoaded", handler, false);\n            oDOC.readyState = "complete";\n        }, false);\n    }\n})(window, document);\n    </script>\n    <script type="text/javascript"><!--\n    if(navigator.appVersion.indexOf(\'MSIE\')>=0)document.write(unescape(\'%3C\')+\'\\!-\'+\'-\')\n    //--></script><noscript><img src="' + omnitureConfig.trackingPixel + '"\n    height="1" width="1" alt="" style="border:0;" /></noscript><!--/DO NOT REMOVE/-->\n  ';
}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(421);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(422),
    hasUnicode = __webpack_require__(201),
    stringToArray = __webpack_require__(423),
    toString = __webpack_require__(115);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(132);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(424),
    hasUnicode = __webpack_require__(201),
    unicodeToArray = __webpack_require__(425);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parsely;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parsely(context) {
  var siteConfig = _identity2.default[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  var parselyConfig = (0, _get2.default)(siteConfig, 'parsely');
  var domain = parselyConfig.domain;


  return '\n    <div id="parsely-root" style="display: none">\n      <span id="parsely-cfg" data-parsely-site="' + domain + '"></span>\n    </div>\n    <script>\n      (function(s, p, d) {\n      var h=d.location.protocol, i=p+"-"+s,\n      e=d.getElementById(i), r=d.getElementById(p+"-root"),\n      u=h==="https:"?"d1z2jf7jlzjs58.cloudfront.net"\n      :"static."+p+".com";\n      if (e) return;\n      e = d.createElement(s); e.id = i; e.async = true;\n      e.src = h+"//"+u+"/p.js"; r.appendChild(e);\n      })("script", "parsely", document);\n    </script>\n  ';
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pingdom;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pingdom(context) {
  var siteConfig = _identity2.default[context.site];
  if (siteConfig === undefined) {
    return '';
  }
  var pingdomConfig = (0, _get2.default)(siteConfig, 'pingdom');
  var id = pingdomConfig.id;


  return '\n    <script>\n      var _prum = [[\'id\', \'' + id + '\'],\n      [\'mark\', \'firstbyte\', (new Date()).getTime()]];\n      (function() {\n      var s = document.getElementsByTagName(\'script\')[0]\n      , p = document.createElement(\'script\');\n      p.async = \'async\';\n      p.src = \'//rum-static.pingdom.net/prum.min.js\';\n      s.parentNode.insertBefore(p, s);\n      })();\n    </script>\n  ';
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parsely;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

var _url_util = __webpack_require__(197);

var _content_util = __webpack_require__(202);

var _content_util2 = _interopRequireDefault(_content_util);

var _cloudinary_asset_util = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Validate your structured data page here (paste in entire view-source: https://search.google.com/structured-data/testing-tool/u/0/
*/
function parsely(context, location, firstLoad, url) {
  var postData = context.postData,
      homeList = context.homeList,
      categoryHomeList = context.categoryHomeList,
      tagHomeList = context.tagHomeList,
      authorAllFeed = context.authorAllFeed,
      mostCreativePeoplePageData = context.mostCreativePeoplePageData,
      ibdPageData = context.ibdPageData,
      giftGuideData = context.giftGuideData,
      videoPageData = context.videoPageData,
      jwPlaylistIndex = context.jwPlaylistIndex;
  var type = context.type;

  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  var articleType = (0, _get2.default)(postData, 'categories[0].name') === 'News' ? 'NewsArticle' : 'Article';

  var topicList = [];
  var articleTitle = '';
  var authorName = '';
  var articleSection = '';
  var thumbnail = '';
  var articleDate = '';
  var thumbnailCaption = void 0;
  var thumbnailWidth = void 0;
  var thumbnailHeight = void 0;
  var dateModified = void 0;
  var DESKTOP_SIZE = true;

  var livePostStructuredData = {};

  if (postData) {
    topicList = (0, _get2.default)(postData, 'tags');
    articleTitle = (0, _get2.default)(postData, 'title');
    authorName = (0, _get2.default)(postData, 'author.name');
    articleSection = (0, _get2.default)(postData, 'categories[0].slug'); // TODO, needs primary tag if exist
    thumbnail = (0, _cloudinary_asset_util.buildAssetUrlWithPresets)((0, _cloudinary_asset_util.changeAssetDomain)((0, _get2.default)(postData, 'featured_image.source')), _cloudinary_asset_util.imageSizesLookup.meta, DESKTOP_SIZE);

    if (/.gif$/.test(thumbnail)) {
      thumbnail = thumbnail.replace('f_auto', 'f_jpg');
    }

    articleDate = (0, _get2.default)(postData, 'structuredData.published');
    dateModified = (0, _get2.default)(postData, 'structuredData.modified');
    thumbnailCaption = (0, _striptags2.default)((0, _get2.default)(postData, 'featured_image.caption') || '');
    thumbnailWidth = (0, _get2.default)(postData, 'featured_image.width') || 700;
    thumbnailHeight = (0, _get2.default)(postData, 'featured_image.height') || 700;
  }

  var siteMaps = {
    fastcompany: {
      humanReadable: 'Fast Company',
      logo: {
        url: 'https://assets.fastcompany.com/image/upload/v1510092328/fc-logo.png',
        width: '346',
        height: '60'
      }
    },
    fastcodesign: {
      humanReadable: 'Co.Design',
      logo: {
        url: 'https://images.fastcompany.net/image/upload/v1485296802/fcweb/codesign-seo.png',
        width: '200',
        height: '200'
      }
    }
  };

  var siteData = (0, _get2.default)(siteMaps, context.site);
  var siteName = (0, _get2.default)(siteData, 'humanReadable');
  var logo = (0, _get2.default)(siteData, 'logo.url');
  var logoWidth = (0, _get2.default)(siteData, 'logo.width');
  var logoHeight = (0, _get2.default)(siteData, 'logo.height');

  var tags = '';

  if (topicList) {
    topicList.forEach(function (tag, index) {
      if (index !== topicList.length - 1) {
        tags += '"' + tag.name + '",';
      } else {
        tags += '"' + tag.name + '"';
      }
    });
  }

  // Set specific structured data for live posts
  if (postData) {
    var livePosts = (0, _get2.default)(postData, 'live.posts', []);
    var livePostsLength = livePosts.length;

    if (livePostsLength) {
      type = 'livePost';
      livePostStructuredData = {
        coverageStartTime: (0, _get2.default)(livePosts[livePostsLength - 1], 'published'),
        coverageEndTime: (0, _get2.default)(livePosts, '[0].published'),
        liveBlogUpdate: livePosts.map(function (post) {
          return {
            '@type': 'BlogPosting',
            headline: articleTitle,
            author: {
              '@type': 'Person',
              name: (0, _get2.default)(post, 'author.name')
            },
            publisher: {
              '@type': 'Organization',
              name: siteName,
              logo: {
                '@type': 'ImageObject',
                url: logo,
                width: logoWidth,
                height: logoHeight
              }
            },
            url: url + '#update-' + (0, _get2.default)(post, 'id'),
            datePublished: (0, _get2.default)(post, 'published'),
            articleBody: (0, _striptags2.default)((0, _content_util2.default)((0, _get2.default)(post, 'content', [])))
          };
        })
      };
    }
  }

  var baseData = {
    '@context': 'https://schema.org'
  };

  var dupeLookUp = {};

  var typeLookup = {
    post: {
      '@type': articleType,
      headline: articleTitle,
      url: url,
      mainEntityOfPage: {
        '@id': url,
        '@type': 'WebPage'
      },
      thumbnailUrl: thumbnail,
      dateCreated: articleDate,
      datePublished: articleDate,
      dateModified: dateModified,
      articleSection: articleSection,
      creator: authorName,
      author: {
        '@type': 'Person',
        name: authorName
      },
      keywords: [tags],
      image: {
        '@type': 'ImageObject',
        caption: thumbnailCaption,
        url: thumbnail,
        width: thumbnailWidth,
        height: thumbnailHeight
      },
      publisher: {
        '@type': 'Organization',
        name: siteName,
        logo: {
          '@type': 'ImageObject',
          url: logo,
          width: logoWidth,
          height: logoHeight
        }
      }
    },
    livePost: {
      '@type': 'LiveBlogPosting',
      url: url,
      headline: articleTitle,
      datePublished: articleDate,
      coverageStartTime: (0, _get2.default)(livePostStructuredData, 'coverageStartTime'),
      coverageEndTime: (0, _get2.default)(livePostStructuredData, 'coverageEndTime'),
      dateModified: dateModified,
      publisher: {
        '@type': 'Organization',
        name: siteName,
        logo: {
          '@type': 'ImageObject',
          url: logo,
          width: logoWidth,
          height: logoHeight
        }
      },
      liveBlogUpdate: (0, _get2.default)(livePostStructuredData, 'liveBlogUpdate')
    },
    homepage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: homeList.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.url || 'https://www.' + (0, _url_util.resolveHost)((0, _get2.default)(item, 'link')) + '/' + (0, _get2.default)(item, 'id') + '/' + (0, _get2.default)(item, 'slug')
        };
      })
    },
    category: {
      '@type': 'ItemList',
      url: url,
      itemListElement: categoryHomeList.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.url || 'https://www.' + (0, _url_util.resolveHost)((0, _get2.default)(item, 'link')) + '/' + (0, _get2.default)(item, 'id') + '/' + (0, _get2.default)(item, 'slug')
        };
      })
    },
    tag: {
      '@type': 'ItemList',
      url: url,
      itemListElement: tagHomeList.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.url || 'https://www.' + (0, _url_util.resolveHost)((0, _get2.default)(item, 'link')) + '/' + (0, _get2.default)(item, 'id') + '/' + (0, _get2.default)(item, 'slug')
        };
      })
    },
    author: {
      '@type': 'ItemList',
      url: url,
      itemListElement: authorAllFeed.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.url || 'https://www.' + (0, _url_util.resolveHost)((0, _get2.default)(item, 'link')) + '/' + (0, _get2.default)(item, 'id') + '/' + (0, _get2.default)(item, 'slug')
        };
      })
    },
    personPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: []
    },
    mostCreativePeoplePage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: ((0, _get2.default)(mostCreativePeoplePageData, 'data.rows') || []).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: url + 'person/' + item.url
        };
      })
    },
    ibdPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: ((0, _get2.default)(ibdPageData, 'data.rows') || []).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: 'https://www.fastcodesign.com/innovation-by-design/2017/category/' + item.url
        };
      })
    },
    giftGuidePage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: ((0, _get2.default)(giftGuideData, 'data.rows') || []).map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: 'https://www.fastcodesign.com/gift-guide/holiday-2017/category/' + item.url
        };
      })
    },
    companyPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: []
    },
    videoIndexPage: {
      '@type': 'ItemList',
      url: url,
      itemListElement: (0, _get2.default)(jwPlaylistIndex, 'data.playlists', []).reduce(function (accum, currVal) {
        (0, _get2.default)(currVal, 'playlist', []).forEach(function (item) {
          if (!dupeLookUp.hasOwnProperty((0, _get2.default)(item, 'mediaid'))) {
            accum.push({
              '@type': 'ListItem',
              position: accum.length + 1,
              url: (0, _get2.default)(item, 'link')
            });
            dupeLookUp[(0, _get2.default)(item, 'mediaid')] = true;
          }
        });
        return accum;
      }, [])
    },
    videoPage: {
      '@type': 'VideoObject',
      url: url,
      name: (0, _get2.default)(videoPageData, 'data.playlist[0].title', ''),
      description: (0, _get2.default)(videoPageData, 'data.playlist[0].description', ''),
      thumbnailUrl: (0, _cloudinary_asset_util.buildAssetUrlWithPresets)((0, _cloudinary_asset_util.changeAssetDomain)((0, _get2.default)(videoPageData, 'data.playlist[0].featured_image.source', '')), _cloudinary_asset_util.imageSizesLookup.meta, DESKTOP_SIZE),
      uploadDate: (0, _get2.default)(videoPageData, 'data.playlist[0].structuredData.published', ''),
      transcript: (0, _get2.default)(videoPageData, 'data.videoSeoText', ''),
      duration: 'PT' + (0, _get2.default)(videoPageData, 'data.playlist[0].duration', '') + 'S',
      contentUrl: (0, _get2.default)(videoPageData, 'data.playlist[0].sources[4].file', '')
    }
  };

  var JSONMeta = JSON.stringify((0, _assign2.default)(baseData, typeLookup[type]));
  var lookUp = typeLookup[type];
  if (!lookUp) {
    _logger_service2.default.error('Structured Data Type Lookup: ' + type + ' not found.');
  }

  return lookUp ? '<script type="application/ld+json">' + JSONMeta + '</script>' : '';
}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trackjs;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackjs(currentState) {
  if ((0, _get2.default)(currentState, 'config.env') === 'development') {
    return '';
  }

  return '<!-- BEGIN TRACKJS -->\n<script type="text/javascript">window._trackJs = { token: \'273b729e2fa84da381a6ddafecd71c58\' };</script>\n<script async type="text/javascript" src="https://cdn.trackjs.com/releases/current/tracker.js"></script>\n<!-- END TRACKJS -->';
}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = comscore;

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function comscore(context) {
  var siteConfig = _identity2.default[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  var key = '';

  return '<script type="text/javascript">\n  if (typeof $igniter_var === \'undefined\') {\n  // Ensures that our client code is updated.\n  (function(w,d,s,p,v,e,r) {w[\'$igniter_var\']=v;w[v]=w[v]||function(){(w[v].q=w[v].q||[]).push(\n  arguments)};w[v].l=1*new Date();e=d.createElement(s),r=d.getElementsByTagName(s)[0];e.async=1;\n  e.src=p+\'?ts=\'+(+new Date()/3600000|0);\n  r.parentNode.insertBefore(e,r)})(window,document, \'script\', \'//cdn.petametrics.com/' + key + '.js\', \'$p\');\n\n  $p("init", ' + key + ');\n  $p("send", "pageview");\n  }\n  </script>';
}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(32);

var _nav_main_menu = __webpack_require__(434);

var _nav_main_menu2 = _interopRequireDefault(_nav_main_menu);

var _nav_main_menu_data = __webpack_require__(435);

var _nav_main_menu_data2 = _interopRequireDefault(_nav_main_menu_data);

var _search = __webpack_require__(203);

var _search2 = _interopRequireDefault(_search);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

var _ga = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Nav = function (_Component) {
  _inherits(Nav, _Component);

  function Nav() {
    _classCallCheck(this, Nav);

    var _this = _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).call(this));

    _this.state = {
      scale: false,
      menu: false,
      search: false
    };

    _this.setNavScale = _this.setNavScale.bind(_this);
    _this.getCategoryData = _this.getCategoryData.bind(_this);
    _this.toggleMenu = _this.toggleMenu.bind(_this);
    _this.closeMenuIfOpen = _this.closeMenuIfOpen.bind(_this);
    _this.toggleSearchModal = _this.toggleSearchModal.bind(_this);
    _this.renderCategoryLink = _this.renderCategoryLink.bind(_this);
    _this.renderPageTitle = _this.renderPageTitle.bind(_this);
    return _this;
  }

  _createClass(Nav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ((0, _client_util2.default)()) {
        window.addEventListener('scroll', this.setNavScale);
      }
    }
  }, {
    key: 'setNavScale',
    value: function setNavScale() {
      var _window = window,
          scrollY = _window.scrollY;
      var scale = this.state.scale;

      var featureFlags = (0, _get2.default)(this.props, 'config.featureFlags');

      if (this.props.isHome && featureFlags.topNavAdEnabled) {
        this.setState({ scale: false });
      } else {
        if (scale && scrollY <= 20) {
          this.setState({ scale: false });
        }

        if (!scale && scrollY > 20) {
          this.setState({ scale: true });
        }
      }
    }
  }, {
    key: 'getCategoryData',
    value: function getCategoryData(topic) {
      var className = 'nav__link';
      var active = topic.url === (0, _get2.default)(this.props, 'activeCategory');

      if (active) {
        className = ' nav__active';
      }

      return { className: className, active: active };
    }
  }, {
    key: 'setHeaderClass',
    value: function setHeaderClass(modifier, menu, isHome) {
      var featureFlags = (0, _get2.default)(this.props, 'config.featureFlags');
      var className = 'page-header';

      if (modifier) {
        className += ' page-header--' + modifier;
      }
      if (menu) {
        className += ' page-header--menu';
      }

      // For when we have homepage ad, manually add this for now for now
      if (isHome && featureFlags.topNavAdEnabled) {
        className += ' page-header--with-top-ad';
      }
      return className;
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu(event) {
      var menu = this.state.menu;

      var html = document.querySelector('html');
      var addRemove = menu ? 'remove' : 'add';
      this.setState({ menu: !menu, search: false });

      html.classList[addRemove]('no-scroll');

      if (event) {
        event.preventDefault();
      }
    }
  }, {
    key: 'closeMenuIfOpen',
    value: function closeMenuIfOpen() {
      if (this.state.menu) {
        this.toggleMenu();
      }
    }
  }, {
    key: 'toggleSearchModal',
    value: function toggleSearchModal() {
      var triggerFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (triggerFocus && window.location.pathname.includes('/search')) {
        document.querySelector('.search-form__input--in-page').focus();
        return;
      }

      this.setState({ search: !this.state.search });
    }
  }, {
    key: 'renderCategoryLink',
    value: function renderCategoryLink(topic) {
      var url = topic.url,
          title = topic.title,
          external = topic.external;

      var data = this.getCategoryData(topic);
      var attrs = {
        className: data.className,
        title: title
      };

      if (data.active) {
        return _react2.default.createElement(
          'span',
          attrs,
          title
        );
      }

      if (external) {
        attrs.href = '//' + url;
        return _react2.default.createElement(
          'a',
          _extends({}, attrs, {
            onClick: function onClick() {
              (0, _ga.trackGAEvent)({
                eventCategory: 'Interaction',
                eventAction: 'Top Nav Category',
                eventLabel: title
              });
            }
          }),
          title
        );
      }

      attrs.to = url;
      return _react2.default.createElement(
        _reactRouterDom.Link,
        _extends({}, attrs, {
          onClick: function onClick() {
            (0, _ga.trackGAEvent)({
              eventCategory: 'Interaction',
              eventAction: 'Top Nav Category',
              eventLabel: title
            });
          }
        }),
        title
      );
    }
  }, {
    key: 'renderPageTitle',
    value: function renderPageTitle() {
      var _props = this.props,
          isHome = _props.isHome,
          modifier = _props.modifier,
          title = _props.title;
      var scale = this.state.scale;

      var className = 'page-header__title';

      if (scale) {
        className += ' page-header__title--scaled';
      }

      if (modifier) {
        className += ' page-header__title--' + modifier;
      }

      if (isHome) {
        return _react2.default.createElement(
          'h2',
          { className: className },
          title
        );
      }

      return _react2.default.createElement(
        _reactRouterDom.Link,
        { to: '/', className: className },
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          modifier = _props2.modifier,
          newsletterLink = _props2.newsletterLink,
          isHome = _props2.isHome,
          topics = _props2.topics,
          config = _props2.config;
      var subscribeLink = this.props.subscribeLink;
      var _state = this.state,
          menu = _state.menu,
          search = _state.search,
          scale = _state.scale;

      var site = (0, _get2.default)(config, 'site', '');
      var social = (0, _get2.default)(_nav_main_menu_data2.default, 'social.' + site, []);

      // When we want to A/B test this link
      subscribeLink = (0, _get2.default)(config, 'magSubscribeLinkAB', 'https://magazine.fastcompany.com/loc/FST/summersale');

      return _react2.default.createElement(
        'header',
        {
          className: this.setHeaderClass(modifier, menu, isHome),
          onClick: this.closeMenuIfOpen
        },
        _react2.default.createElement(
          'div',
          { className: 'nav__main-items' },
          this.renderPageTitle(),
          _react2.default.createElement(
            'ul',
            {
              className: 'nav__extras nav__extras--left ' + (scale ? 'nav__extras--scaled' : '')
            },
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              _react2.default.createElement(
                'a',
                { className: 'nav__menu', onClick: this.toggleMenu },
                'Menu'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              _react2.default.createElement(
                'a',
                { className: 'nav__newsletter', href: newsletterLink },
                'Newsletter'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              _react2.default.createElement(
                'a',
                { href: subscribeLink, className: 'nav__subscribe' },
                'Subscribe'
              )
            )
          ),
          _react2.default.createElement(
            'ul',
            {
              className: 'nav__extras nav__extras--right ' + (scale ? 'nav__extras--scaled' : '')
            },
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              social.map(function (network) {
                return _react2.default.createElement(
                  'a',
                  {
                    key: network.url,
                    href: network.url,
                    className: 'nav__social-button nav__social-button--' + network.property,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    onClick: function onClick() {
                      (0, _ga.trackGAEvent)({
                        eventCategory: 'Social',
                        eventAction: 'Top Nav Follow Us',
                        eventLabel: network.property
                      });
                    }
                  },
                  _react2.default.createElement('i', {
                    className: 'nav__icon nav__icon--' + network.property + ' icon-' + network.property
                  })
                );
              })
            ),
            _react2.default.createElement(
              'li',
              { className: 'nav__extras-item' },
              _react2.default.createElement(
                'button',
                {
                  className: 'nav__search-trigger',
                  onClick: this.toggleSearchModal
                },
                _react2.default.createElement('i', { className: 'icon-search-glass' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'nav',
          { className: 'nav nav--' + modifier },
          _react2.default.createElement(
            'ul',
            { className: 'nav__list' },
            topics.map(function (topic) {
              return _react2.default.createElement(
                'li',
                { key: topic.title, className: 'nav__item' },
                _this2.renderCategoryLink(topic)
              );
            })
          )
        ),
        _react2.default.createElement(_search2.default, {
          skin: 'light',
          modifier: 'overlay',
          active: search,
          modal: true,
          closeModal: this.toggleSearchModal
        }),
        _react2.default.createElement(_nav_main_menu2.default, _extends({
          closeMenu: this.toggleMenu,
          mainMenuVisible: menu,
          scaled: this.state.scale
        }, _nav_main_menu_data2.default, {
          config: config
        }))
      );
    }
  }]);

  return Nav;
}(_react.Component);

exports.default = Nav;


Nav.propTypes = {
  isHome: _propTypes2.default.bool.isRequired,
  modifier: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  subscribeLink: _propTypes2.default.string.isRequired,
  newsletterLink: _propTypes2.default.string.isRequired,
  topics: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    active: _propTypes2.default.bool, // eslint-disable-next-line react/no-unused-prop-types
    title: _propTypes2.default.string.isRequired, // eslint-disable-next-line react/no-unused-prop-types
    url: _propTypes2.default.string.isRequired // eslint-disable-next-line react/no-unused-prop-types
  })).isRequired,
  config: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(106);

var _PathUtils = __webpack_require__(69);

var _createTransitionManager = __webpack_require__(107);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _ga = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 * @param props
 * @returns {Component}
 * @constructor
 */

var MainMenu = function (_Component) {
  _inherits(MainMenu, _Component);

  function MainMenu() {
    _classCallCheck(this, MainMenu);

    var _this = _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).call(this));

    _this.setMenuClasses = _this.setMenuClasses.bind(_this);
    _this.openSection = _this.openSection.bind(_this);
    _this.clickSiteCollectionItem = _this.clickSiteCollectionItem.bind(_this);

    _this.state = { active: null };
    return _this;
  }

  _createClass(MainMenu, [{
    key: 'setMenuClasses',
    value: function setMenuClasses(visible) {
      var classNames = ['main-menu'];

      if (visible) {
        classNames.push('main-menu--opened');
      }

      return classNames.join(' ');
    }
  }, {
    key: 'openSection',
    value: function openSection(section) {
      if (section === this.state.active) {
        this.setState({ active: null });
      } else {
        this.setState({ active: section });
      }
    }
  }, {
    key: 'openSectionMenuHeight',
    value: function openSectionMenuHeight(data) {
      var totalheight = void 0;

      if (data.title !== 'collections') {
        this.navItemHeight = document.querySelector('.main-menu__collection').offsetHeight;

        totalheight = this.navItemHeight * data.collectionItems;
      } else {
        var list = document.querySelector('.main-menu__collections-content--collections').childNodes;
        var collectionsHeight = 0;
        for (var i = 0; i < list.length; i += 1) {
          collectionsHeight += list[i].offsetHeight;
        }
        totalheight = collectionsHeight;
      }

      return totalheight;
    }
  }, {
    key: 'clickSiteCollectionItem',
    value: function clickSiteCollectionItem(title) {
      (0, _ga.trackGAEvent)({
        eventCategory: 'Interaction',
        eventAction: 'Burger Nav Category',
        eventLabel: title
      });
      this.props.closeMenu();
    }
  }, {
    key: 'renderSectionContent',
    value: function renderSectionContent(data) {
      var _this2 = this;

      if (!data) {
        return null;
      }

      var listLink = data.content.map(function (info) {
        var url = info.url,
            title = info.title,
            _info$deck = info.deck,
            deck = _info$deck === undefined ? '' : _info$deck,
            _info$external = info.external,
            external = _info$external === undefined ? false : _info$external;

        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

        return _react2.default.createElement(
          'li',
          {
            key: title,
            className: 'main-menu__collection',
            onClick: function onClick() {
              return _this2.clickSiteCollectionItem(title);
            }
          },
          _react2.default.createElement(
            _fc_link2.default,
            {
              to: url,
              title: title,
              config: data.config,
              externalLink: external
            },
            _react2.default.createElement(
              'h3',
              { className: 'main-menu__collection-title' },
              title
            ),
            deck.length > 0 ? _react2.default.createElement(
              'p',
              { className: 'main-menu__collection-deck' },
              deck
            ) : ''
          )
        );
      });

      return listLink;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          social = _props.social,
          currentIssueCover = _props.currentIssueCover,
          magazineLink = _props.magazineLink,
          mainMenuVisible = _props.mainMenuVisible,
          collections = _props.collections,
          scaled = _props.scaled,
          config = _props.config;
      var subscribeLink = this.props.subscribeLink;

      var socialLinks = social[(0, _get2.default)(config, 'site', '')] || [];

      // When we want to A/B test this link
      subscribeLink = (0, _get2.default)(config, 'magSubscribeLinkAB', 'https://magazine.fastcompany.com/loc/FST/summersale');

      return _react2.default.createElement(
        'div',
        {
          className: this.setMenuClasses(mainMenuVisible, scaled),
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        },
        _react2.default.createElement(
          'div',
          {
            className: 'main-menu__brand ' + (scaled ? 'main-menu__brand--scaled' : '')
          },
          _react2.default.createElement('button', { className: 'icon-close', onClick: this.props.closeMenu })
        ),
        collections.map(function (collection, index) {
          var title = collection.title,
              sections = collection.sections;

          var content = sections;
          var collectionsList = title === 'collections';
          var collectionItems = content.length;

          return _react2.default.createElement(
            'div',
            {
              key: collection.className,
              className: 'main-menu__dropdown-content'
            },
            _react2.default.createElement(
              'a',
              {
                className: collection.className + ' ' + (_this3.state.active === collection.title ? collection.className + '--active' : ''),
                onClick: _this3.openSection.bind(null, collection.title)
              },
              _react2.default.createElement(
                'span',
                { className: 'main-menu__collections-title' },
                collection.title
              ),
              _react2.default.createElement('span', {
                className: 'main-menu__collections-caret ' + (_this3.state.active === collection.title ? 'main-menu__collections-caret--active' : '')
              })
            ),
            _react2.default.createElement(
              'ul',
              {
                className: 'main-menu__collections-content ' + (collectionsList ? 'main-menu__collections-content--collections' : '') + ' ' + (_this3.state.active === collection.title ? 'main-menu__collections-content--active' : '') + ' ',
                style: {
                  height: _this3.state.active === collection.title ? _this3.openSectionMenuHeight({ collectionItems: collectionItems, title: title }) : 0
                }
              },
              _this3.renderSectionContent({ content: content, index: index, config: config })
            )
          );
        }),
        _react2.default.createElement(
          'a',
          {
            href: 'https://www.fastcompany.com/newsletters',
            className: 'main-menu__newsletters',
            onClick: function onClick() {
              (0, _ga.trackGAEvent)({
                eventCategory: 'Burger',
                eventAction: 'Nav Item',
                eventLabel: 'Newsletters'
              });
            }
          },
          'Newsletters'
        ),
        _react2.default.createElement(
          'a',
          {
            href: 'http://events.fastcompany.com/fcny/',
            className: 'main-menu__innovation-festival',
            target: '_blank',
            rel: 'noopener noreferrer',
            onClick: function onClick() {
              (0, _ga.trackGAEvent)({
                eventCategory: 'Burger',
                eventAction: 'Nav Item',
                eventLabel: 'Innovation Festival'
              });
            }
          },
          'Innovation Festival'
        ),
        _react2.default.createElement(
          'a',
          { href: magazineLink, className: 'main-menu__current-issue' },
          'Current Issue'
        ),
        _react2.default.createElement(
          'div',
          { className: 'main-menu__subscription' },
          _react2.default.createElement(
            'a',
            {
              href: magazineLink,
              className: 'main-menu__mag-cover',
              style: { backgroundImage: 'url(' + currentIssueCover + ')' }
            },
            'Current Issue'
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-menu__subscription-button-row' },
            _react2.default.createElement(
              'a',
              {
                href: subscribeLink,
                className: 'main-menu__subscribe-link',
                title: 'subscribe'
              },
              'SUBSCRIBE'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'main-menu__social-menu' },
          _react2.default.createElement(
            'div',
            { className: 'main-menu__social-text' },
            _react2.default.createElement(
              'span',
              { className: 'main-menu__social-text-hed' },
              'Follow us:'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-menu__social-list' },
            socialLinks.map(function (network) {
              return _react2.default.createElement(
                'a',
                {
                  key: network.url,
                  href: network.url,
                  className: 'main-menu__social-button main-menu__social-button--' + network.property,
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  onClick: function onClick() {
                    (0, _ga.trackGAEvent)({
                      eventCategory: 'Social',
                      eventAction: 'Nav Follow Us',
                      eventLabel: network.property
                    });
                  }
                },
                _react2.default.createElement('i', {
                  className: 'main-menu__icon main-menu__icon--' + network.property + ' icon-' + network.property
                })
              );
            })
          )
        )
      );
    }
  }]);

  return MainMenu;
}(_react.Component);

exports.default = MainMenu;


MainMenu.defaultProps = {
  mainMenuVisible: false,
  scaled: false
};

MainMenu.propTypes = {
  social: _propTypes2.default.shape({}).isRequired,
  collections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string,
    deck: _propTypes2.default.string
  })).isRequired,
  currentIssueCover: _propTypes2.default.string.isRequired,
  magazineLink: _propTypes2.default.string.isRequired,
  subscribeLink: _propTypes2.default.string.isRequired,
  mainMenuVisible: _propTypes2.default.bool,
  closeMenu: _propTypes2.default.func.isRequired,
  scaled: _propTypes2.default.bool,
  config: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var data = {
  currentIssueCover: '//www.fastcompany.com/magazine/latest-cover.jpg',
  magazineLink: 'https://www.fastcompany.com/magazine/',
  subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
  cosites: [{
    siteTitle: 'FastCoDesign',
    siteLogo: '//a.fastcompany.net/image/upload/v1488299643/fc/CO.DESIGN_BURGER_LOCKUP.svg',
    siteURL: '//www.fastcodesign.com'
  }, {
    siteTitle: 'FastCoStudios',
    siteLogo: '//a.fastcompany.net/image/upload/v1488300562/fc/video_burger.svg',
    siteURL: '//www.fastcompany.com/videos'
  }],
  social: {
    fastcompany: [{
      property: 'facebook',
      url: 'https://www.facebook.com/FastCompany/'
    }, {
      property: 'twitter',
      url: 'https://twitter.com/fastcompany'
    }, {
      property: 'instagram',
      url: 'https://www.instagram.com/fastcompany/'
    }, {
      property: 'pocket',
      url: 'https://getpocket.com/explore/fastcompany.com'
    }, {
      property: 'linkedin',
      url: 'https://www.linkedin.com/company/fast-company'
    }],
    fastcodesign: [{
      property: 'facebook',
      url: 'https://www.facebook.com/FastCoDesign/'
    }, {
      property: 'twitter',
      url: 'https://twitter.com/FastCoDesign'
    }, {
      property: 'instagram',
      url: 'https://www.instagram.com/fastcodesign/'
    }, {
      property: 'pocket',
      url: 'https://getpocket.com/explore/fastcodesign'
    }, {
      property: 'linkedin',
      url: 'https://www.linkedin.com/showcase/3700248/'
    }]
  },
  collections: [{
    title: 'fast company',
    className: 'main-menu__fastcompany-collection',
    sections: [{
      title: 'homepage',
      url: 'https://www.fastcompany.com'
    }, {
      title: 'technology',
      url: 'https://www.fastcompany.com/technology'
    }, {
      title: 'leadership',
      url: 'https://www.fastcompany.com/leadership'
    }, {
      title: 'entertainment',
      url: 'https://www.fastcompany.com/entertainment'
    }, {
      title: 'ideas',
      url: 'https://www.fastcompany.com/ideas'
    }, {
      title: 'video',
      url: 'https://www.fastcompany.com/videos',
      external: true
    }, {
      title: 'news',
      url: 'https://www.fastcompany.com/news'
    }]
  }, {
    title: 'co.Design',
    className: 'main-menu__codesign-collection',
    sections: [{
      title: 'homepage',
      url: 'https://www.fastcodesign.com'
    }, {
      title: 'cities',
      url: 'https://www.fastcodesign.com/cities'
    }, {
      title: 'graphics',
      url: 'https://www.fastcodesign.com/graphics'
    }, {
      title: 'innovation by design',
      url: 'https://www.fastcodesign.com/innovation-by-design'
    }, {
      title: 'interactive',
      url: 'https://www.fastcodesign.com/interactive'
    }, {
      title: 'products',
      url: 'https://www.fastcodesign.com/products'
    }, {
      title: 'spaces',
      url: 'https://www.fastcodesign.com/spaces'
    }]
  }, {
    title: 'collections',
    className: 'main-menu__collections',
    sections: [{
      title: 'World Changing Ideas',
      url: 'https://www.fastcompany.com/section/world-changing-ideas',
      deck: 'New workplaces, new food sources, new medicine--even an entirely new economic system.'
    }, {
      title: 'Platform Wars',
      url: 'https://www.fastcompany.com/section/platform-wars',
      deck: 'The major tech ecosystems that battle for our attention and dollars.'
    }, {
      title: 'Tech Forecast',
      url: 'https://www.fastcompany.com/section/tech-forecast',
      deck: 'What’s next for hardware, software, and services.'
    }, {
      title: 'Robot Revolution',
      url: 'https://www.fastcompany.com/section/robot-revolution',
      deck: 'The brave new world of automation, from AI to drones.'
    }, {
      title: 'Fast Cities',
      url: 'https://www.fastcompany.com/section/fast-cities',
      deck: 'How our urban centers are building toward the future.'
    }, {
      title: 'Most Creative People',
      url: 'https://www.fastcompany.com/most-creative-people',
      deck: 'See members of our Most Creative People in Business community: leaders who are shaping the future of business in creative ways.'
    }, {
      title: 'FastCo.Works Studio',
      url: 'https://www.fastcompany.com/user/fastco-works',
      deck: "An award-winning team of journalists, designers, and videographers who tell brand stories through Fast Company's distinctive lens."
    }]
  }]
};

exports.default = data;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var data = {
  fastcompany: {
    logo: '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [{
      url: '/technology',
      title: 'Technology'
    }, {
      url: '/leadership',
      title: 'Leadership'
    }, {
      url: '/entertainment',
      title: 'Entertainment'
    }, {
      url: '/ideas',
      title: 'Ideas'
    }, {
      url: '/videos',
      title: 'Video'
    }, {
      url: '/news',
      title: 'News'
    }]
  },
  fastcodesign: {
    logo: '//g.fastcompany.net/asset_files/-/2015/12/22/CODESIGN.svg',
    title: 'Co.Design',
    subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [{
      url: '/ui-ux-interactive',
      title: 'UI & UX'
    }, {
      url: '/products',
      title: 'Products'
    }, {
      url: '/cities-spaces',
      title: 'Cities & Spaces'
    }, {
      url: '/graphics',
      title: 'Graphics'
    }, {
      url: '/innovation-by-design',
      title: 'Innovation By Design'
    }]
  }
};

exports.default = data;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import get from 'lodash/get';


// eslint-disable-next-line react/prefer-stateless-function
var Recirc = function (_Component) {
  _inherits(Recirc, _Component);

  function Recirc() {
    _classCallCheck(this, Recirc);

    return _possibleConstructorReturn(this, (Recirc.__proto__ || Object.getPrototypeOf(Recirc)).apply(this, arguments));
  }

  _createClass(Recirc, [{
    key: 'render',

    // TODO: @mbenin @jferrie Revisit this logic
    /*
    shouldComponentUpdate(nextProps) {
      return (
        get(this.props, 'recircFeed.hide') !== get(nextProps, 'recircFeed.hide')
      );
    } */

    value: function render() {
      var _props = this.props,
          config = _props.config,
          feed = _props.feed;

      // TODO: This should be moved into the API.

      var properties = [{
        key: 'fastcoexist',
        title: 'Ideas',
        data: feed.fastcoexist,
        link: 'https://www.fastcompany.com/ideas'
      }, {
        key: 'fastcocreate',
        title: 'Entertainment',
        data: feed.fastcocreate,
        link: 'https://www.fastcompany.com/entertainment'
      }, {
        key: 'fastcodesign',
        title: 'Co.Design',
        data: feed.fastcodesign,
        link: 'https://www.fastcodesign.com'
      }, {
        key: 'fastcompany',
        title: 'Fast Company',
        data: feed.fastcompany,
        link: 'https://www.fastcompany.com/'
      }];

      return _react2.default.createElement(
        'div',
        { className: 'recirc' },
        properties.map(function (property) {
          return _react2.default.createElement(
            'div',
            { key: property.key, className: 'recirc__column' },
            _react2.default.createElement(
              'h3',
              { className: 'recirc__title recirc__title--' + property.key },
              _react2.default.createElement(
                _fc_link2.default,
                { config: config, to: property.link },
                property.title
              )
            ),
            property.data.map(function (story) {
              return _react2.default.createElement(_card2.default, {
                type: 'recirc',
                config: config,
                metadata: story,
                key: story.id
              });
            })
          );
        })
      );
    }
  }]);

  return Recirc;
}(_react.Component);

exports.default = Recirc;


Recirc.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  feed: _propTypes2.default.shape({}).isRequired
};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DefaultCard;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _poster = __webpack_require__(62);

var _poster2 = _interopRequireDefault(_poster);

var _eyebrow = __webpack_require__(63);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

var _advertorial = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DefaultCard(props) {
  var config = props.config,
      metadata = props.metadata,
      fullPageAdvertorial = props.fullPageAdvertorial,
      cardEvent = props.cardEvent,
      totalCards = props.totalCards;

  var advertorial = (0, _advertorial.isAdvertorial)(metadata.tags) && !fullPageAdvertorial;
  var textOnlyCard = metadata.allowTextOnly && !(0, _get2.default)(metadata, 'featured_image.source');
  var setCardClasses = function setCardClasses() {
    var classNames = ['card', 'card--default'];

    if (textOnlyCard) {
      classNames.push('card--text');

      if (totalCards) {
        classNames.push('card--size-' + totalCards);
      }
    }

    if (metadata.events) {
      classNames.push('card--event');
    }

    if (advertorial) {
      classNames.push('card--advertorial');
    }

    return classNames.join(' ');
  };
  var setPosterClasses = function setPosterClasses() {
    var posterClasses = ['card__poster', 'card__poster--default'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };
  var setTextWrapperClass = function setTextWrapperClass() {
    var event = (0, _get2.default)(metadata, 'events');
    var textWrapperClasses = ['card__text-wrapper'];

    if (!event) {
      textWrapperClasses.push('card__text-wrapper--default');
    }

    if (textOnlyCard) {
      textWrapperClasses.push('card__text-wrapper--text-only');
    } else if (!advertorial && !event) {
      textWrapperClasses.push('card__text-wrapper--border-bottom');
    }

    return textWrapperClasses.join(' ');
  };

  return _react2.default.createElement(
    'article',
    { className: setCardClasses(), onClick: function onClick(event) {
        return cardEvent(event);
      } },
    _react2.default.createElement(
      _fc_link2.default,
      {
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external') || (0, _get2.default)(metadata, 'source') === 'external'
      },
      _react2.default.createElement(_poster2.default, {
        metadata: metadata,
        className: setPosterClasses(),
        generateClasses: false
      }),
      _react2.default.createElement(
        'div',
        { className: setTextWrapperClass() },
        _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
        _react2.default.createElement(
          'h2',
          {
            className: 'card__title card__title--default ' + (textOnlyCard ? 'card__title--only' : '')
          },
          (0, _get2.default)(metadata, 'title')
        ),
        (0, _get2.default)(metadata, 'events') ? _react2.default.createElement(
          'button',
          { className: 'card__button' },
          (0, _get2.default)(metadata, 'buttonText')
        ) : ''
      )
    )
  );
}

DefaultCard.defaultProps = {
  cardEvent: function cardEvent() {},
  fullPageAdvertorial: false,
  totalCards: 0
};

DefaultCard.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  fullPageAdvertorial: _propTypes2.default.bool,
  cardEvent: _propTypes2.default.func,
  totalCards: _propTypes2.default.number
};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Featured;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _poster = __webpack_require__(62);

var _poster2 = _interopRequireDefault(_poster);

var _eyebrow = __webpack_require__(63);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Featured(props) {
  var config = props.config,
      metadata = props.metadata,
      cardEvent = props.cardEvent;

  var noImage = !(0, _get2.default)(metadata, 'featured_image.source');
  var textOnlyCard = metadata.allowTextOnly && noImage;
  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--featured'];

    if (textOnlyCard) {
      cardClasses.push('card--text');
    }

    return cardClasses.join(' ');
  };
  var setPosterClasses = function setPosterClasses() {
    var posterClasses = ['card__poster', 'card__poster--featured'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };

  return _react2.default.createElement(
    'article',
    { className: setCardClasses(), onClick: function onClick(event) {
        return cardEvent(event);
      } },
    _react2.default.createElement(
      _fc_link2.default,
      {
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external') || (0, _get2.default)(metadata, 'source') === 'external'
      },
      _react2.default.createElement(_poster2.default, {
        metadata: metadata,
        className: setPosterClasses(),
        generateClasses: false
      }),
      _react2.default.createElement(
        'div',
        {
          className: 'card__text-wrapper card__text-wrapper--featured ' + (textOnlyCard ? 'card__text-wrapper--text-only' : '')
        },
        _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
        _react2.default.createElement(
          'h2',
          {
            className: 'card__title card__title--featured ' + (textOnlyCard ? 'card__title--only' : '')
          },
          (0, _get2.default)(metadata, 'title')
        )
      )
    )
  );
}

Featured.defaultProps = {
  cardEvent: function cardEvent() {}
};

Featured.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AllFeed;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _poster = __webpack_require__(62);

var _poster2 = _interopRequireDefault(_poster);

var _eyebrow = __webpack_require__(63);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

var _advertorial = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AllFeed(props) {
  var config = props.config,
      top = props.top,
      metadata = props.metadata,
      cardEvent = props.cardEvent,
      fullPageAdvertorial = props.fullPageAdvertorial;

  var advertorial = (0, _advertorial.isAdvertorial)(metadata.tags) && !fullPageAdvertorial;
  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--all-feed'];

    if (advertorial) {
      cardClasses.push('card--advertorial');
    }

    if (top) {
      cardClasses.push('card--top');
    }

    return cardClasses.join(' ');
  };
  var setPosterClasses = function setPosterClasses() {
    var posterClasses = ['card__poster', 'card__poster--all-feed'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };
  var hasImage = (0, _get2.default)(metadata, 'featured_image.source') && metadata.layout !== 'short';

  return _react2.default.createElement(
    'article',
    {
      className: setCardClasses('card'),
      onClick: function onClick(event) {
        return cardEvent(event);
      }
    },
    _react2.default.createElement(
      _fc_link2.default,
      {
        currentSite: (0, _get2.default)(metadata, 'currentSite'),
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external')
      },
      _react2.default.createElement(
        'div',
        { className: 'card__text-wrapper card__text-wrapper--all-feed' },
        _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
        _react2.default.createElement(
          'h2',
          { className: 'card__title card__title--all-feed' },
          (0, _get2.default)(metadata, 'title')
        ),
        hasImage ? _react2.default.createElement(
          'h3',
          { className: 'card__deck card__deck--all-feed' },
          (0, _get2.default)(metadata, 'excerpt')
        ) : null
      ),
      _react2.default.createElement(_poster2.default, {
        metadata: metadata,
        className: setPosterClasses(),
        generateClasses: false
      })
    )
  );
}

AllFeed.defaultProps = {
  top: false,
  cardEvent: function cardEvent() {},
  fullPageAdvertorial: false
};

AllFeed.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  top: _propTypes2.default.bool,
  metadata: _propTypes2.default.shape({}).isRequired,
  fullPageAdvertorial: _propTypes2.default.bool,
  cardEvent: _propTypes2.default.func
};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoCard;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _image = __webpack_require__(76);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VideoCard(props) {
  var config = props.config,
      metadata = props.metadata,
      cardEvent = props.cardEvent,
      hasLink = props.hasLink;

  var videoState = (0, _get2.default)(metadata, 'isVideoActive') ? 'card--video-active' : 'card--video-play';
  var content = [_react2.default.createElement(_image2.default, {
    key: (0, _get2.default)(metadata, 'featured_image.source'),
    alt: (0, _get2.default)(metadata, 'title'),
    src: (0, _get2.default)(metadata, 'featured_image.source'),
    assetSizes: (0, _get2.default)(metadata, 'assetSizes')
  }), _react2.default.createElement(
    'figcaption',
    { key: (0, _get2.default)(metadata, 'title') },
    _react2.default.createElement(
      'h2',
      { className: 'card__title card__title--video' },
      (0, _get2.default)(metadata, 'title')
    )
  )];

  return _react2.default.createElement(
    'figure',
    {
      className: 'card card--video ' + videoState,
      onClick: function onClick(event) {
        return cardEvent(event, (0, _get2.default)(metadata, 'index'));
      }
    },
    hasLink ? _react2.default.createElement(
      _fc_link2.default,
      {
        config: config,
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        externalLink: (0, _get2.default)(metadata, 'external')
      },
      content
    ) : content
  );
}

VideoCard.defaultProps = {
  cardEvent: function cardEvent() {},
  hasLink: true
};

VideoCard.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func,
  hasLink: _propTypes2.default.bool
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RecircCard;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _advertorial = __webpack_require__(28);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _eyebrow = __webpack_require__(63);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RecircCard(props) {
  var config = props.config,
      metadata = props.metadata,
      cardEvent = props.cardEvent;

  var advertorial = (0, _advertorial.isAdvertorial)(metadata.tags);
  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--recirc'];

    if (advertorial) {
      cardClasses.push('card--advertorial');
    }

    return cardClasses.join(' ');
  };

  return _react2.default.createElement(
    'article',
    { className: setCardClasses(), onClick: function onClick(event) {
        return cardEvent(event);
      } },
    _react2.default.createElement(
      _fc_link2.default,
      {
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external')
      },
      _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
      _react2.default.createElement(
        'h2',
        { className: 'card__title card__title--recirc' },
        (0, _get2.default)(metadata, 'title')
      )
    )
  );
}

RecircCard.defaultProps = {
  cardEvent: function cardEvent() {}
};

RecircCard.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SmallCard;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _eyebrow = __webpack_require__(63);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

var _poster = __webpack_require__(62);

var _poster2 = _interopRequireDefault(_poster);

var _advertorial = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmallCard(props) {
  var metadata = props.metadata,
      config = props.config,
      cardEvent = props.cardEvent,
      disabledImage = props.disabledImage,
      fullPageAdvertorial = props.fullPageAdvertorial;

  var advertorial = (0, _advertorial.isAdvertorial)(metadata.tags) && !fullPageAdvertorial;
  var image = (0, _get2.default)(metadata, 'featured_image.source');
  var hasImage = image && !disabledImage;
  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--small'];

    if (advertorial) {
      cardClasses.push('card--advertorial');
    }

    return cardClasses.join(' ');
  };

  var setPosterClasses = function setPosterClasses() {
    var posterClasses = ['card__poster', 'card__poster--small'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };

  return _react2.default.createElement(
    'article',
    { className: setCardClasses(), onClick: cardEvent },
    _react2.default.createElement(
      _fc_link2.default,
      {
        currentSite: (0, _get2.default)(metadata, 'currentSite'),
        to: (0, _get2.default)(metadata, 'link'),
        title: (0, _get2.default)(metadata, 'title'),
        config: config,
        externalLink: (0, _get2.default)(metadata, 'external')
      },
      _react2.default.createElement(
        'div',
        { className: 'card__text-wrapper card__text-wrapper--small' },
        _react2.default.createElement(_eyebrow2.default, { metadata: metadata }),
        _react2.default.createElement(
          'h2',
          { className: 'card__title card__title--small' },
          (0, _get2.default)(metadata, 'title')
        )
      ),
      hasImage ? _react2.default.createElement(_poster2.default, {
        metadata: metadata,
        className: setPosterClasses(),
        generateClasses: false
      }) : null
    )
  );
}

SmallCard.defaultProps = {
  cardEvent: function cardEvent() {},
  fullPageAdvertorial: false,
  disabledImage: false
};

SmallCard.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func,
  fullPageAdvertorial: _propTypes2.default.bool,
  disabledImage: _propTypes2.default.bool
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Magazine;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _image = __webpack_require__(76);

var _image2 = _interopRequireDefault(_image);

var _cloudinary_asset_util = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Magazine(props) {
  var config = props.config,
      metadata = props.metadata,
      cardEvent = props.cardEvent,
      hasTitle = props.hasTitle,
      fullWidth = props.fullWidth,
      fullIssue = props.fullIssue;

  var setCardClasses = function setCardClasses() {
    var cardClasses = ['card', 'card--magazine'];

    if (fullWidth) {
      cardClasses.push('card--full-width');
    }

    return cardClasses.join(' ');
  };

  if (!metadata.title || !metadata.image) {
    return null;
  }

  return _react2.default.createElement(
    'figure',
    { className: setCardClasses(), onClick: function onClick(event) {
        return cardEvent(event);
      } },
    _react2.default.createElement(
      _fc_link2.default,
      {
        config: config,
        to: 'https://www.fastcompany.com/magazine/' + metadata.slug,
        title: (0, _get2.default)(metadata, 'title'),
        externalLink: false
      },
      _react2.default.createElement(_image2.default, {
        src: metadata.image,
        alt: metadata.title,
        assetSizes: _cloudinary_asset_util.imageSizesLookup.magazine
      }),
      hasTitle ? _react2.default.createElement(
        'figcaption',
        null,
        _react2.default.createElement(
          'h2',
          { className: 'card__title card__title--magazine' },
          metadata.title
        )
      ) : null
    ),
    _react2.default.createElement(
      'div',
      { className: 'card__issue-text' },
      _react2.default.createElement(
        'time',
        { className: 'card__issue-date' },
        metadata.date
      ),
      _react2.default.createElement(
        'ul',
        { className: 'card__links' },
        fullIssue ? _react2.default.createElement(
          'li',
          { className: 'card__links-item' },
          _react2.default.createElement(
            _fc_link2.default,
            {
              config: config,
              to: 'https://www.fastcompany.com/magazine/' + metadata.slug,
              title: (0, _get2.default)(metadata, 'title'),
              externalLink: false
            },
            'Full Issue'
          )
        ) : null,
        metadata.pdf_url ? _react2.default.createElement(
          'li',
          { className: 'card__links-item' },
          _react2.default.createElement(
            'a',
            { href: metadata.pdf_url, target: '_blank' },
            'View PDF'
          )
        ) : null
      )
    )
  );
}

Magazine.defaultProps = {
  cardEvent: function cardEvent() {},
  fullWidth: false,
  hasTitle: true,
  fullIssue: true
};

Magazine.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  metadata: _propTypes2.default.shape({}).isRequired,
  cardEvent: _propTypes2.default.func,
  fullWidth: _propTypes2.default.bool,
  hasTitle: _propTypes2.default.bool,
  fullIssue: _propTypes2.default.bool
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var currentYear = new Date().getFullYear();

      return _react2.default.createElement(
        'footer',
        { className: 'footer' },
        _react2.default.createElement(
          'nav',
          { className: 'footer__nav-wrapper' },
          _react2.default.createElement(
            'ul',
            { className: 'footer__link-container' },
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://spotlight.fastcompany.com/' },
                'Advertise'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.fastcompany.com/privacy-policy' },
                'Privacy\xA0Policy'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.fastcompany.com/terms-and-conditions' },
                'Terms'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.fastcompany.com/contact-us' },
                'Contact'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.fastcompany.com/about-us' },
                'About Us'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/sitemap' },
                'Site Map'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              'Fast Company & Inc \xA9 ',
              currentYear,
              ' Mansueto Ventures, LLC'
            ),
            _react2.default.createElement(
              'li',
              { className: 'footer__link' },
              _react2.default.createElement(
                'a',
                { href: 'https://www.aboutads.info/', rel: 'nofollow' },
                _react2.default.createElement('img', {
                  className: 'footer__daa-logo',
                  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAAAAAC4QtCeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAJ0Uk5TAAB2k804AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAEgAAABIAEbJaz4AAACASURBVAjXYyir3PaDAQby09KL9/2FcjIWf1mbVX0Mwklfw8DwbF5awzkwZzXDjco/j/vTuq+COe93APXcLE5bCeKczvzOwPCoPG0xiHMq6/f9SWkdF4HK1jKcyepJazgFNnrBpwtpVUchRuempR17+htqaU/55l9w5xzf+RHOBgC94zlXyQTR6wAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxMy0wMy0wOFQxOToxMDo0NC0wNTowMNnS5vEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMDMtMDhUMTk6MTA6NDQtMDU6MDCoj15NAAAAAElFTkSuQmCC',
                  alt: 'Digital Advertising Alliance (DAA) Self-Regulatory Program',
                  target: '_new'
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Footer;
}(_react.Component);

exports.default = Footer;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _omit = __webpack_require__(205);

var _omit2 = _interopRequireDefault(_omit);

var _clone = __webpack_require__(207);

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Config = function (_Component) {
  _inherits(Config, _Component);

  function Config() {
    _classCallCheck(this, Config);

    return _possibleConstructorReturn(this, (Config.__proto__ || Object.getPrototypeOf(Config)).apply(this, arguments));
  }

  _createClass(Config, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'createConfig',
    value: function createConfig() {
      return this.props.state;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.initialPageLoad) {
        return null;
      }

      return _react2.default.createElement('script', {
        className: 'client-config',
        type: 'application/json',
        charset: 'UTF-8',
        'data-state': this.createConfig()
      });
    }
  }]);

  return Config;
}(_react.Component);

Config.propTypes = {
  state: _propTypes2.default.string.isRequired,
  initialPageLoad: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state) {
  var clonedState = (0, _clone2.default)(state);
  var initialPageLoad = state.config.initialPageLoad;

  clonedState.config = (0, _omit2.default)(clonedState.config, ['criticalCss']);
  var currentState = initialPageLoad ? JSON.stringify(clonedState) : '';
  return {
    state: currentState,
    initialPageLoad: initialPageLoad
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Config);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(111),
    baseSlice = __webpack_require__(132);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(449);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    getPrototype = __webpack_require__(126),
    isObjectLike = __webpack_require__(44);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(451),
    overRest = __webpack_require__(173),
    setToString = __webpack_require__(174);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(193);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/',
    component: _index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _homepage_state_manager2.default)(store)
  };
};

var _index_page = __webpack_require__(134);

var _index_page2 = _interopRequireDefault(_index_page);

var _homepage_state_manager = __webpack_require__(142);

var _homepage_state_manager2 = _interopRequireDefault(_homepage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _promo_banner = __webpack_require__(454);

var _promo_banner2 = _interopRequireDefault(_promo_banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scroll = function (_Component) {
  _inherits(Scroll, _Component);

  function Scroll(props) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

    var metadata = _this.props.metadata;


    _this.currentSite = (0, _get2.default)(metadata, 'stories[0].currentSite');
    return _this;
  }

  _createClass(Scroll, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'buildSlugName',
    value: function buildSlugName(tag) {
      var tagName = (0, _get2.default)(tag, '[0].name');
      if (tagName) {
        return tagName;
      }

      return this.currentSite === 'fastcompany' ? 'News' : 'Latest';
    }
  }, {
    key: 'buildSlugLink',
    value: function buildSlugLink(tag) {
      var tagData = (0, _get2.default)(tag, '[0]');
      if (tagData) {
        var tagSlug = (0, _get2.default)(tagData, 'slug');
        var tagName = (0, _get2.default)(tagData, 'name');
        if (tagData.taxonomy === 'category') {
          return '/' + tagSlug;
        }

        if (tagData.taxonomy === 'post_tag') {
          return '/section/' + tagSlug;
        }
        return tagName;
      }

      return this.currentSite === 'fastcompany' ? '//www.fastcompany.com/news' : null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          className = _props.className,
          metadata = _props.metadata,
          promoBanner = _props.promoBanner;


      if (!metadata) {
        return null;
      }

      var slugName = this.buildSlugName(metadata.tag);
      var slugLink = this.buildSlugLink(metadata.tag);
      var hasPromoBanner = !(0, _isEmpty2.default)(promoBanner);

      return _react2.default.createElement(
        'div',
        {
          className: 'column-component control ' + (className || 'card-wrapper--3')
        },
        hasPromoBanner ? _react2.default.createElement(_promo_banner2.default, promoBanner) : '',
        slugName ? _react2.default.createElement(_slug2.default, { linkTo: slugLink, slugName: slugName, className: 'column' }) : '',
        _react2.default.createElement(
          'div',
          {
            className: hasPromoBanner ? 'scroll-me scroll-me--promoting' : 'scroll-me'
          },
          metadata.stories.map(function (item) {
            return _react2.default.createElement(_card2.default, { config: config, type: 'small', metadata: item, key: item.id });
          })
        )
      );
    }
  }]);

  return Scroll;
}(_react.Component);

exports.default = Scroll;


Scroll.defaultProps = {
  className: '',
  promoBanner: {}
};

Scroll.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  className: _propTypes2.default.string,
  metadata: _propTypes2.default.shape({}).isRequired,
  promoBanner: _propTypes2.default.shape({})
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromoBanner;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PromoBanner(props) {
  return _react2.default.createElement(
    'div',
    { className: 'scrolling-module__promo' },
    _react2.default.createElement(
      'a',
      { href: props.click_through_url, title: '' },
      _react2.default.createElement('img', { src: props.image_url, alt: '', width: 387, height: 100 })
    )
  );
}

PromoBanner.propTypes = {
  click_through_url: _propTypes2.default.string.isRequired,
  image_url: _propTypes2.default.string.isRequired
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscribeUiEvent = __webpack_require__(456);

var _classnames = __webpack_require__(65);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsShallowCompare = __webpack_require__(465);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.
var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform';

// global variable for all instances
var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr
var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = (function (_Component) {
    _inherits(Sticky, _Component);

    function Sticky(props, context) {
        _classCallCheck(this, Sticky);

        _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleScrollStart = this.handleScrollStart.bind(this);
        this.delta = 0;
        this.stickyTop = 0;
        this.stickyBottom = 0;
        this.frozen = false;
        this.skipNextScrollEvent = false;
        this.scrollTop = -1;

        this.bottomBoundaryTarget;
        this.topTarget;
        this.subscribers;

        this.state = {
            top: 0, // A top offset from viewport top where Sticky sticks to when scrolling up
            bottom: 0, // A bottom offset from viewport top where Sticky sticks to when scrolling down
            width: 0, // Sticky width
            height: 0, // Sticky height
            x: 0, // The original x of Sticky
            y: 0, // The original y of Sticky
            topBoundary: 0, // The top boundary on document
            bottomBoundary: Infinity, // The bottom boundary on document
            status: STATUS_ORIGINAL, // The Sticky status
            pos: 0, // Real y-axis offset for rendering position-fixed and position-relative
            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error
        };
    }

    _createClass(Sticky, [{
        key: 'getTargetHeight',
        value: function getTargetHeight(target) {
            return target && target.offsetHeight || 0;
        }
    }, {
        key: 'getTopPosition',
        value: function getTopPosition(top) {
            // TODO, topTarget is for current layout, may remove
            // a top argument can be provided to override reading from the props
            top = top || this.props.top || this.props.topTarget || 0;
            if (typeof top === 'string') {
                if (!this.topTarget) {
                    this.topTarget = doc.querySelector(top);
                }
                top = this.getTargetHeight(this.topTarget);
            }
            return top;
        }
    }, {
        key: 'getTargetBottom',
        value: function getTargetBottom(target) {
            if (!target) {
                return -1;
            }
            var rect = target.getBoundingClientRect();
            return this.scrollTop + rect.bottom;
        }
    }, {
        key: 'getBottomBoundary',
        value: function getBottomBoundary(bottomBoundary) {
            // a bottomBoundary can be provided to avoid reading from the props
            var boundary = bottomBoundary || this.props.bottomBoundary;

            // TODO, bottomBoundary was an object, depricate it later.
            if (typeof boundary === 'object') {
                boundary = boundary.value || boundary.target || 0;
            }

            if (typeof boundary === 'string') {
                if (!this.bottomBoundaryTarget) {
                    this.bottomBoundaryTarget = doc.querySelector(boundary);
                }
                boundary = this.getTargetBottom(this.bottomBoundaryTarget);
            }
            return boundary && boundary > 0 ? boundary : Infinity;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.setState({
                status: STATUS_ORIGINAL,
                pos: 0
            });
        }
    }, {
        key: 'release',
        value: function release(pos) {
            this.setState({
                status: STATUS_RELEASED,
                pos: pos - this.state.y
            });
        }
    }, {
        key: 'fix',
        value: function fix(pos) {
            this.setState({
                status: STATUS_FIXED,
                pos: pos
            });
        }

        /**
         * Update the initial position, width, and height. It should update whenever children change.
         * @param {Object} options optional top and bottomBoundary new values
         */
    }, {
        key: 'updateInitialDimension',
        value: function updateInitialDimension(options) {
            options = options || {};

            var _refs = this.refs;
            var outer = _refs.outer;
            var inner = _refs.inner;

            var outerRect = outer.getBoundingClientRect();
            var innerRect = inner.getBoundingClientRect();

            var width = outerRect.width || outerRect.right - outerRect.left;
            var height = innerRect.height || innerRect.bottom - innerRect.top;;
            var outerY = outerRect.top + this.scrollTop;

            this.setState({
                top: this.getTopPosition(options.top),
                bottom: Math.min(this.state.top + height, winHeight),
                width: width,
                height: height,
                x: outerRect.left,
                y: outerY,
                bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
                topBoundary: outerY
            });
        }
    }, {
        key: 'handleResize',
        value: function handleResize(e, ae) {
            if (this.props.shouldFreeze()) {
                return;
            }

            winHeight = ae.resize.height;
            this.updateInitialDimension();
            this.update();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart(e, ae) {
            this.frozen = this.props.shouldFreeze();

            if (this.frozen) {
                return;
            }

            if (this.scrollTop === ae.scroll.top) {
                // Scroll position hasn't changed,
                // do nothing
                this.skipNextScrollEvent = true;
            } else {
                this.scrollTop = ae.scroll.top;
                this.updateInitialDimension();
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e, ae) {
            // Scroll doesn't need to be handled
            if (this.skipNextScrollEvent) {
                this.skipNextScrollEvent = false;
                return;
            }

            scrollDelta = ae.scroll.delta;
            this.scrollTop = ae.scroll.top;
            this.update();
        }

        /**
         * Update Sticky position.
         */
    }, {
        key: 'update',
        value: function update() {
            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

            if (disabled) {
                if (this.state.status !== STATUS_ORIGINAL) {
                    this.reset();
                }
                return;
            }

            var delta = scrollDelta;
            // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
            // on document from viewport.
            var top = this.scrollTop + this.state.top;
            var bottom = this.scrollTop + this.state.bottom;

            // There are 2 principles to make sure Sticky won't get wrong so much:
            // 1. Reset Sticky to the original postion when "top" <= topBoundary
            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary
            if (top <= this.state.topBoundary) {
                // #1
                this.reset();
            } else if (bottom >= this.state.bottomBoundary) {
                // #2
                this.stickyBottom = this.state.bottomBoundary;
                this.stickyTop = this.stickyBottom - this.state.height;
                this.release(this.stickyTop);
            } else {
                if (this.state.height > winHeight - this.state.top) {
                    // In this case, Sticky is higher then viewport minus top offset
                    switch (this.state.status) {
                        case STATUS_ORIGINAL:
                            this.release(this.state.y);
                            this.stickyTop = this.state.y;
                            this.stickyBottom = this.stickyTop + this.state.height;
                        // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
                        // from ORIGINAL when calling window.scrollTo().
                        // break;
                        case STATUS_RELEASED:
                            // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
                            // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
                            // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
                            this.stickyBottom = this.stickyTop + this.state.height;
                            if (delta > 0 && bottom > this.stickyBottom) {
                                this.fix(this.state.bottom - this.state.height);
                            } else if (delta < 0 && top < this.stickyTop) {
                                this.fix(this.state.top);
                            }
                            break;
                        case STATUS_FIXED:
                            var toRelease = true;
                            var pos = this.state.pos;
                            var height = this.state.height;
                            // In regular cases, when Sticky is in FIXED status,
                            // 1. it's top will stick to the screen top,
                            // 2. it's bottom will stick to the screen bottom,
                            // 3. if not the cases above, then it's height gets changed
                            if (delta > 0 && pos === this.state.top) {
                                // case 1, and scrolling down
                                this.stickyTop = top - delta;
                                this.stickyBottom = this.stickyTop + height;
                            } else if (delta < 0 && pos === this.state.bottom - height) {
                                // case 2, and scrolling up
                                this.stickyBottom = bottom - delta;
                                this.stickyTop = this.stickyBottom - height;
                            } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                                // case 3
                                // This case only happens when Sticky's bottom sticks to the screen bottom and
                                // its height gets changed. Sticky should be in RELEASE status and update its
                                // sticky bottom by calculating how much height it changed.
                                var deltaHeight = pos + height - this.state.bottom;
                                this.stickyBottom = bottom - delta + deltaHeight;
                                this.stickyTop = this.stickyBottom - height;
                            } else {
                                toRelease = false;
                            }

                            if (toRelease) {
                                this.release(this.stickyTop);
                            }
                            break;
                    }
                } else {
                    // In this case, Sticky is shorter then viewport minus top offset
                    // and will always fix to the top offset of viewport
                    this.fix(this.state.top);
                }
            }
            this.delta = delta;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.updateInitialDimension(nextProps);
            this.update();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this = this;

            if (prevState.status !== this.state.status && this.props.onStateChange) {
                this.props.onStateChange({ status: this.state.status });
            }
            // if the props for enabling are toggled, then trigger the update or reset depending on the current props
            if (prevProps.enabled !== this.props.enabled) {
                if (this.props.enabled) {
                    this.setState({ activated: true }, function () {
                        _this.updateInitialDimension();
                        _this.update();
                    });
                } else {
                    this.setState({ activated: false }, function () {
                        _this.reset();
                    });
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var subscribers = this.subscribers || [];
            for (var i = subscribers.length - 1; i >= 0; i--) {
                this.subscribers[i].unsubscribe();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Only initialize the globals if this is the first
            // time this component type has been mounted
            if (!win) {
                win = window;
                doc = document;
                docEl = doc.documentElement;
                docBody = doc.body;
                winHeight = win.innerHeight || docEl.clientHeight;
                M = window.Modernizr;
                // No Sticky on lower-end browser when no Modernizr
                if (M) {
                    canEnableTransforms = M.csstransforms3d;
                    TRANSFORM_PROP = M.prefixed('transform');
                }
            }

            // when mount, the scrollTop is not necessary on the top
            this.scrollTop = docBody.scrollTop + docEl.scrollTop;

            if (this.props.enabled) {
                this.setState({ activated: true });
                this.updateInitialDimension();
                this.update();
            }
            // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality
            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), { useRAF: true }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), { useRAF: true, enableScrollInfo: true }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), { enableResizeInfo: true })];
        }
    }, {
        key: 'translate',
        value: function translate(style, pos) {
            var enableTransforms = canEnableTransforms && this.props.enableTransforms;
            if (enableTransforms && this.state.activated) {
                style[TRANSFORM_PROP] = 'translate3d(0,' + pos + 'px,0)';
            } else {
                style.top = pos + 'px';
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !this.props.shouldFreeze() && (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            // TODO, "overflow: auto" prevents collapse, need a good way to get children height
            var innerStyle = {
                position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
                top: this.state.status === STATUS_FIXED ? '0px' : '',
                zIndex: this.props.innerZ
            };
            var outerStyle = {};

            // always use translate3d to enhance the performance
            this.translate(innerStyle, this.state.pos);
            if (this.state.status !== STATUS_ORIGINAL) {
                innerStyle.width = this.state.width + 'px';
                outerStyle.height = this.state.height + 'px';
            }

            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));

            return _react2['default'].createElement(
                'div',
                { ref: 'outer', className: outerClasses, style: outerStyle },
                _react2['default'].createElement(
                    'div',
                    { ref: 'inner', className: 'sticky-inner-wrapper', style: innerStyle },
                    this.props.children
                )
            );
        }
    }]);

    return Sticky;
})(_react.Component);

Sticky.displayName = 'Sticky';

Sticky.defaultProps = {
    shouldFreeze: function shouldFreeze() {
        return false;
    },
    enabled: true,
    top: 0,
    bottomBoundary: 0,
    enableTransforms: true,
    activeClass: 'active',
    releasedClass: 'released',
    onStateChange: null
};

/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */
Sticky.propTypes = {
    enabled: _propTypes2['default'].bool,
    top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
    _propTypes2['default'].string, _propTypes2['default'].number]),
    enableTransforms: _propTypes2['default'].bool,
    activeClass: _propTypes2['default'].string,
    releasedClass: _propTypes2['default'].string,
    onStateChange: _propTypes2['default'].func,
    shouldFreeze: _propTypes2['default'].func,
    innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
};

Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;

module.exports = Sticky;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


function warn() {
    if (false) {
        console.warn('Warning: the function is client-side only, does not work on server side');
    }
}

if (typeof window !== 'undefined') {
    module.exports = {
        listen: __webpack_require__(209),
        subscribe: __webpack_require__(457),
        unsubscribe: __webpack_require__(464)
    };
} else {
    module.exports = {
        listen: warn,
        subscribe: warn,
        unsubscribe: warn
    };
}


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var globalVars = __webpack_require__(102);
var leIE8 = __webpack_require__(210); // less then or equal to IE8
var mainEventConnectors = __webpack_require__(458);

// constants
var DEFAULT_THROTTLE_RATE = __webpack_require__(212).DEFAULT_THROTTLE_RATE;

/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb, options) {
    options = options || {};

    var useRAF = options.useRAF || false;
    var throttleRate = parseInt(options.throttleRate, 10);

    if (isNaN(throttleRate)) {
        throttleRate = DEFAULT_THROTTLE_RATE;
    }

    if (useRAF) {
        throttleRate = 'raf';
    }

    // turn off throttle if the browser is IE8 or less, because window.event will be reset
    // when using any delayed function, i.g., setTimeout, or rAF.
    if (leIE8) {
        throttleRate = 0;
    }

    // once those variables enabled, then never disabled.
    globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
    globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
    globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

    return mainEventConnectors[type](throttleRate, cb, options);
}

module.exports = subscribe;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */


var _clone = __webpack_require__(207);
var _throttle = __webpack_require__(64);
var AugmentedEvent = __webpack_require__(460);
var globalVars = __webpack_require__(102);
var connections = globalVars.connections;
var EE = globalVars.EE;
var leIE8 = __webpack_require__(210);
var listen = __webpack_require__(209);
var listeners = globalVars.listeners;
var rAFThrottle = __webpack_require__(461);
var removers = globalVars.removers;
var subscriptions = globalVars.subscriptions;

// constants
var EVENT_END_DELAY = __webpack_require__(212).EVENT_END_DELAY;

// global variables
var doc;
var win;
var body;
var hashId = 0;

if (typeof window !== 'undefined') {
    win = window;
    doc = win.document || document;
    body = doc.body;
}

function getHash(domNode) {
    return domNode.id || 'target-id-' + hashId++;
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
    EE.on(throttledEvent, cb, ctx);
    throttledMainEvent = throttledMainEvent || throttledEvent;
    connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
    return {
        _type: throttledEvent,
        _cb: cb,
        _ctx: ctx,
        unsubscribe: function unsubscribe() {
            if (!this._type) {
                return;
            }

            EE.removeListener(throttledEvent, cb, ctx);
            connections[throttledMainEvent]--;
            if (connections[throttledMainEvent] === 0) {
                listeners[throttledMainEvent].remove();
                listeners[throttledMainEvent] = undefined;
            }

            this._type = undefined;
            this._cb = undefined;
            this._ctx = undefined;

            // remove the remover from removers array
            for (var i = removers.length - 1; i >= 0; i--) {
                var remover = removers[i];
                if (remover === this) {
                    removers.splice(i, 1);
                    break;
                }
            }
        }
    };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 */
function connectContinuousEvent(target, mainEvent, event) {
    return function throttleEvent(throttleRate, cb, options) {
        var context = options.context;
        var domTarget = options.target;
        var domId = domTarget && getHash(domTarget);
        var targetPart = domId ? ':' + domId : '';

        var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
        var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
        var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
        var throttledEvent = event + ':' + throttleRate + targetPart;

        var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
        removers.push(remover);

        if (listeners[throttledMainEvent]) {
            return remover;
        }

        var ae = {
            start: new AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
            main: new AugmentedEvent({ mainType: mainEvent }), // main
            end: new AugmentedEvent({ mainType: mainEvent, subType: 'end' }) };

        // No throttle for throttleRate = 0
        // end
        if (throttleRate === 'raf') {
            throttleRate = 16; // Set as a number for setTimeout later.
            handler = rAFThrottle(handler);
        } else if (throttleRate > 0) {
            handler = _throttle(handler, throttleRate);
        }

        var timer;
        function endCallback(e) {
            ae.end.update(e);
            EE.emit(throttledEndEvent, e, ae.end);
            timer = null;
        }
        function handler(e) {
            if (!timer) {
                ae.start.update(e);
                EE.emit(throttledStartEvent, e, ae.start);
            }
            clearTimeout(timer);

            ae.main.update(e);
            EE.emit(throttledMainEvent, e, ae.main);
            if (!leIE8) {
                timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
            } else {
                // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
                e = _clone(e);
                timer = setTimeout(function eventEndDelay() {
                    endCallback(e);
                }, throttleRate + EVENT_END_DELAY);
            }
        }

        listeners[throttledMainEvent] = listen(domTarget || target, mainEvent, handler);
        return remover;
    };
}

function connectDiscreteEvent(target, event) {
    return function throttleEvent(throttleRate, cb, options) {
        var context = options.context;
        var domTarget = options.target;
        var domId = domTarget && getHash(domTarget);

        // no throttling for discrete event
        var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

        var remover = connectThrottle(throttledEvent, cb, context);
        removers.push(remover);

        if (listeners[throttledEvent]) {
            return remover;
        }

        var ae = new AugmentedEvent({ mainType: event });

        function handler(e) {
            ae.update(e);
            EE.emit(throttledEvent, e, ae);
        }

        listeners[throttledEvent] = listen(domTarget || target, event, handler);
        return remover;
    };
}

module.exports = {
    scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
    scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
    scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
    resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
    resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
    resize: connectContinuousEvent(win, 'resize', 'resize'),
    visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
    touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
    touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
    touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
    touchstart: connectDiscreteEvent(body, 'touchstart'),
    touchend: connectDiscreteEvent(body, 'touchend')
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(37);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var globalVars = __webpack_require__(102);
var resize = {
    width: 0,
    height: 0
};
var scroll = {
    delta: 0,
    top: 0
};
var touch = {
    axisIntention: '',
    startX: 0,
    startY: 0,
    deltaX: 0,
    deltaY: 0
};

var INTENTION_THRESHOLD = 5;

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */
function ArgmentedEvent(option) {
    option = option || {};
    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = scroll;
    this.resize = resize;
    this.touch = touch;
}

ArgmentedEvent.prototype = {
    getXY: function getXY(touch) {
        var t = { x: 0, y: 0 };
        var docBody = document.body;
        var docEl = document.documentElement;

        if (touch.pageX || touch.pageY) {
            t.x = touch.pageX;
            t.y = touch.pageY;
        } else {
            t.x = touch.clientX + docBody.scrollLeft + docEl.scrollLeft;
            t.y = touch.clientY + docBody.scrollTop + docEl.scrollTop;
        }

        return t;
    },

    update: function update(e) {
        var mainType = this.mainType;
        var subType = this.subType;
        var docEl = document.documentElement;

        if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
            var top = docEl.scrollTop + document.body.scrollTop;
            // Prevent delta from being 0
            if (top !== this.scroll.top) {
                this.scroll.delta = top - this.scroll.top;
                this.scroll.top = top;
            }
        }
        if (globalVars.enableResizeInfo && mainType === 'resize') {
            this.resize.width = window.innerWidth || docEl.clientWidth;
            this.resize.height = window.innerHeight || docEl.clientHeight;
        }
        if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
            var pos;
            var absX;
            var absY;
            if (mainType === 'touchstart' || subType === 'start') {
                pos = this.getXY(e.touches[0]);
                this.touch.axisIntention = '';
                this.touch.startX = pos.x;
                this.touch.startY = pos.y;
                this.touch.deltaX = 0;
                this.touch.deltaY = 0;
            } else if (mainType === 'touchmove') {
                pos = this.getXY(e.touches[0]);
                this.touch.deltaX = pos.x - this.touch.startX;
                this.touch.deltaY = pos.y - this.touch.startY;
                if (this.touch.axisIntention === '') {
                    absX = Math.abs(this.touch.deltaX);
                    absY = Math.abs(this.touch.deltaY);
                    if (absX > INTENTION_THRESHOLD && absX >= absY) {
                        this.touch.axisIntention = 'x';
                    } else if (absY > INTENTION_THRESHOLD && absY > absX) {
                        this.touch.axisIntention = 'y';
                    }
                }
            }
        }
    }
};

module.exports = ArgmentedEvent;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var rAF = __webpack_require__(462);
var getTime = Date.now || /* istanbul ignore next */function () {
    return new Date().getTime();
};
function rAFThrottle(func, throttle) {
    var context;
    var args;
    var last = 0;
    var requestId = 0;

    throttle = throttle || 15;

    var later = function later() {
        var now = getTime();
        var remaining = throttle - (now - last);

        if (remaining <= 0) {
            last = now;
            requestId = 0;
            func.apply(context, args);
        } else {
            requestId = rAF(later);
        }
    };

    return function throttledFunc() {
        context = this;
        args = arguments;

        if (!requestId) {
            requestId = rAF(later);
        }
    };
}

module.exports = rAFThrottle;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(463)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var removers = __webpack_require__(102).removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */
function unsubscribe(type, cb, options) {
    var remover;
    for (var i = removers.length - 1; i >= 0; i--) {
        remover = removers[i];
        if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
            remover.unsubscribe();
            removers.splice(i, 1);
        }
    }
}

module.exports = unsubscribe;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowCompare
 */



var shallowEqual = __webpack_require__(153);

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(136);

function getSocialModel(encodedPostUrl, text) {
  var emailText = void 0;
  var twitterText = void 0;
  var linkedinText = void 0;

  if ((0, _lodash.isObject)(text)) {
    twitterText = text.twitter;
    linkedinText = text.linkedin;
    emailText = text.email;
  } else {
    emailText = text;
    twitterText = text;
    linkedinText = text;
  }

  return [{
    property: 'facebook',
    url: 'https://www.facebook.com/sharer.php?u=' + encodedPostUrl + '&app_id=178479832213933&display=popup',
    popup: true,
    socialShare: {
      platform: 'Facebook',
      action: 'share'
    }
  }, {
    property: 'twitter',
    url: 'https://twitter.com/share?url=' + encodedPostUrl + '&text=' + twitterText,
    popup: true,
    socialShare: {
      platform: 'Twitter',
      action: 'tweet'
    }
  }, {
    property: 'linkedin',
    url: 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodedPostUrl + '&media=' + linkedinText,
    popup: true,
    socialShare: {
      platform: 'Linkedin',
      action: 'share'
    }
  }, {
    property: 'email',
    url: 'mailto:?body=' + encodedPostUrl + '&subject=' + emailText,
    icon: 'share-email',
    popup: false,
    socialShare: {
      platform: 'Email',
      action: 'email'
    }
  }];
}

exports.default = getSocialModel;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);
var bind = __webpack_require__(214);
var Axios = __webpack_require__(469);
var defaults = __webpack_require__(138);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(218);
axios.CancelToken = __webpack_require__(483);
axios.isCancel = __webpack_require__(217);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(484);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(138);
var utils = __webpack_require__(34);
var InterceptorManager = __webpack_require__(478);
var dispatchRequest = __webpack_require__(479);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(216);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);
var transformData = __webpack_require__(480);
var isCancel = __webpack_require__(217);
var defaults = __webpack_require__(138);
var isAbsoluteURL = __webpack_require__(481);
var combineURLs = __webpack_require__(482);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(34);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(218);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sendGASubscriptionEvents;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ga = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sendGASubscriptionEvents(arr, newsletters) {
  if (Array.isArray(arr) || Object.keys(newsletters || {}).length !== 0) {
    arr.forEach(function iterateThroughListIds(listId) {
      var nlGroup = (0, _get2.default)(Object.keys(newsletters).filter(function findCurrentNlGroup(nl) {
        return (0, _get2.default)(newsletters, '[' + nl + '].listId') === listId;
      }), [0]);
      (0, _ga.trackGAEvent)({
        eventCategory: 'Newsletter Signup',
        eventAction: 'subscribe',
        eventLabel: (0, _get2.default)(newsletters, '[' + nlGroup + '].listName')
      });
    });
  }
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(100);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlParse = __webpack_require__(45);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSiteFromURI(uri) {
  var parsed = (0, _urlParse2.default)(uri);
  var siteLookup = {
    'www.fastcompany.com': 'Fast Company',
    'www.fastcodesign.com': 'Co.Design'
  };

  return siteLookup[parsed.host] || '';
}

exports.default = getSiteFromURI;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(489);

var _objectAssign = __webpack_require__(39);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _json2mq = __webpack_require__(497);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(224);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _canUseDom = __webpack_require__(499);

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = _canUseDom2.default && __webpack_require__(500);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
    return _this;
  }

  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
    this.innerSlider = ref;
  };

  Slider.prototype.media = function media(query, handler) {
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        var bQuery;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
        }
        _canUseDom2.default && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      _canUseDom2.default && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.slickPrev = function slickPrev() {
    this.innerSlider.slickPrev();
  };

  Slider.prototype.slickNext = function slickNext() {
    this.innerSlider.slickNext();
  };

  Slider.prototype.slickGoTo = function slickGoTo(slide) {
    this.innerSlider.slickGoTo(slide);
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
    } else {
      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
    }

    var children = this.props.children;
    if (!Array.isArray(children)) {
      children = [children];
    }

    // Children may contain false or null, so we should filter them
    children = children.filter(function (child) {
      return !!child;
    });

    if (settings === 'unslick') {
      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
      return _react2.default.createElement(
        'div',
        { className: this.props.className + ' unslicked' },
        children
      );
    } else {
      return _react2.default.createElement(
        _innerSlider.InnerSlider,
        _extends({ ref: this.innerSliderRefHandler }, settings),
        children
      );
    }
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
exports.InnerSlider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _eventHandlers = __webpack_require__(490);

var _eventHandlers2 = _interopRequireDefault(_eventHandlers);

var _helpers = __webpack_require__(139);

var _helpers2 = _interopRequireDefault(_helpers);

var _initialState = __webpack_require__(491);

var _initialState2 = _interopRequireDefault(_initialState);

var _defaultProps = __webpack_require__(224);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _createReactClass = __webpack_require__(492);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames = __webpack_require__(65);

var _classnames2 = _interopRequireDefault(_classnames);

var _objectAssign = __webpack_require__(39);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _track = __webpack_require__(494);

var _dots = __webpack_require__(495);

var _arrows = __webpack_require__(496);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
  displayName: 'InnerSlider',

  mixins: [_helpers2.default, _eventHandlers2.default],
  list: null,
  track: null,
  listRefHandler: function listRefHandler(ref) {
    this.list = ref;
  },
  trackRefHandler: function trackRefHandler(ref) {
    this.track = ref;
  },
  getInitialState: function getInitialState() {
    return _extends({}, _initialState2.default, {
      currentSlide: this.props.initialSlide
    });
  },
  getDefaultProps: function getDefaultProps() {
    return _defaultProps2.default;
  },
  componentWillMount: function componentWillMount() {
    if (this.props.init) {
      this.props.init();
    }
    this.setState({
      mounted: true
    });
    var lazyLoadedList = [];
    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
        lazyLoadedList.push(i);
      }
    }

    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
      this.setState({
        lazyLoadedList: lazyLoadedList
      });
    }
  },
  componentDidMount: function componentDidMount() {
    // Hack for autoplay -- Inspect Later
    this.initialize(this.props);
    this.adaptHeight();

    // To support server-side rendering
    if (!window) {
      return;
    }
    if (window.addEventListener) {
      window.addEventListener('resize', this.onWindowResized);
    } else {
      window.attachEvent('onresize', this.onWindowResized);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.animationEndCallback) {
      clearTimeout(this.animationEndCallback);
    }
    if (window.addEventListener) {
      window.removeEventListener('resize', this.onWindowResized);
    } else {
      window.detachEvent('onresize', this.onWindowResized);
    }
    if (this.state.autoPlayTimer) {
      clearInterval(this.state.autoPlayTimer);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.slickGoTo != nextProps.slickGoTo) {
      if (false) {
        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
      }
      this.changeSlide({
        message: 'index',
        index: nextProps.slickGoTo,
        currentSlide: this.state.currentSlide
      });
    } else if (this.state.currentSlide >= nextProps.children.length) {
      this.update(nextProps);
      this.changeSlide({
        message: 'index',
        index: nextProps.children.length - nextProps.slidesToShow,
        currentSlide: this.state.currentSlide
      });
    } else {
      this.update(nextProps);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.adaptHeight();
  },
  onWindowResized: function onWindowResized() {
    this.update(this.props);
    // animating state should be cleared while resizing, otherwise autoplay stops working
    this.setState({
      animating: false
    });
    clearTimeout(this.animationEndCallback);
    delete this.animationEndCallback;
  },
  slickPrev: function slickPrev() {
    this.changeSlide({ message: 'previous' });
  },
  slickNext: function slickNext() {
    this.changeSlide({ message: 'next' });
  },
  slickGoTo: function slickGoTo(slide) {
    slide = Number(slide);
    !isNaN(slide) && this.changeSlide({
      message: 'index',
      index: slide,
      currentSlide: this.state.currentSlide
    });
  },
  render: function render() {
    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
      'slick-vertical': this.props.vertical
    });

    var trackProps = {
      fade: this.props.fade,
      cssEase: this.props.cssEase,
      speed: this.props.speed,
      infinite: this.props.infinite,
      centerMode: this.props.centerMode,
      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
      currentSlide: this.state.currentSlide,
      lazyLoad: this.props.lazyLoad,
      lazyLoadedList: this.state.lazyLoadedList,
      rtl: this.props.rtl,
      slideWidth: this.state.slideWidth,
      slidesToShow: this.props.slidesToShow,
      slidesToScroll: this.props.slidesToScroll,
      slideCount: this.state.slideCount,
      trackStyle: this.state.trackStyle,
      variableWidth: this.props.variableWidth
    };

    var dots;

    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
      var dotProps = {
        dotsClass: this.props.dotsClass,
        slideCount: this.state.slideCount,
        slidesToShow: this.props.slidesToShow,
        currentSlide: this.state.currentSlide,
        slidesToScroll: this.props.slidesToScroll,
        clickHandler: this.changeSlide,
        children: this.props.children,
        customPaging: this.props.customPaging
      };

      dots = _react2.default.createElement(_dots.Dots, dotProps);
    }

    var prevArrow, nextArrow;

    var arrowProps = {
      infinite: this.props.infinite,
      centerMode: this.props.centerMode,
      currentSlide: this.state.currentSlide,
      slideCount: this.state.slideCount,
      slidesToShow: this.props.slidesToShow,
      prevArrow: this.props.prevArrow,
      nextArrow: this.props.nextArrow,
      clickHandler: this.changeSlide
    };

    if (this.props.arrows) {
      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
    }

    var verticalHeightStyle = null;

    if (this.props.vertical) {
      verticalHeightStyle = {
        height: this.state.listHeight
      };
    }

    var centerPaddingStyle = null;

    if (this.props.vertical === false) {
      if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: '0px ' + this.props.centerPadding
        };
      }
    } else {
      if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: this.props.centerPadding + ' 0px'
        };
      }
    }

    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);

    return _react2.default.createElement(
      'div',
      {
        className: className,
        onMouseEnter: this.onInnerSliderEnter,
        onMouseLeave: this.onInnerSliderLeave,
        onMouseOver: this.onInnerSliderOver
      },
      prevArrow,
      _react2.default.createElement(
        'div',
        {
          ref: this.listRefHandler,
          className: 'slick-list',
          style: listStyle,
          onMouseDown: this.swipeStart,
          onMouseMove: this.state.dragging ? this.swipeMove : null,
          onMouseUp: this.swipeEnd,
          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
          onTouchStart: this.swipeStart,
          onTouchMove: this.state.dragging ? this.swipeMove : null,
          onTouchEnd: this.swipeEnd,
          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
          onKeyDown: this.props.accessibility ? this.keyHandler : null },
        _react2.default.createElement(
          _track.Track,
          _extends({ ref: this.trackRefHandler }, trackProps),
          this.props.children
        )
      ),
      nextArrow,
      dots
    );
  }
});

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _trackHelper = __webpack_require__(223);

var _helpers = __webpack_require__(139);

var _helpers2 = _interopRequireDefault(_helpers);

var _objectAssign = __webpack_require__(39);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventHandlers = {
  // Event handler for previous and next
  changeSlide: function changeSlide(options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var _props = this.props,
        slidesToScroll = _props.slidesToScroll,
        slidesToShow = _props.slidesToShow;
    var _state = this.state,
        slideCount = _state.slideCount,
        currentSlide = _state.currentSlide;

    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

    if (options.message === 'previous') {
      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
      targetSlide = currentSlide - slideOffset;
      if (this.props.lazyLoad) {
        previousInt = currentSlide - slideOffset;
        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
      }
    } else if (options.message === 'next') {
      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
      targetSlide = currentSlide + slideOffset;
      if (this.props.lazyLoad) {
        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
      }
    } else if (options.message === 'dots' || options.message === 'children') {
      // Click on dots
      targetSlide = options.index * options.slidesToScroll;
      if (targetSlide === options.currentSlide) {
        return;
      }
    } else if (options.message === 'index') {
      targetSlide = Number(options.index);
      if (targetSlide === options.currentSlide) {
        return;
      }
    }

    this.slideHandler(targetSlide);
  },

  // Accessiblity handler for previous and next
  keyHandler: function keyHandler(e) {
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (e.keyCode === 37 && this.props.accessibility === true) {
        this.changeSlide({
          message: this.props.rtl === true ? 'next' : 'previous'
        });
      } else if (e.keyCode === 39 && this.props.accessibility === true) {
        this.changeSlide({
          message: this.props.rtl === true ? 'previous' : 'next'
        });
      }
    }
  },
  // Focus on selecting a slide (click handler on track)
  selectHandler: function selectHandler(options) {
    this.changeSlide(options);
  },
  swipeStart: function swipeStart(e) {
    var touches, posX, posY;

    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
      return;
    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
      return;
    }
    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
    this.setState({
      dragging: true,
      touchObject: {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      }
    });
  },
  swipeMove: function swipeMove(e) {
    if (!this.state.dragging) {
      e.preventDefault();
      return;
    }
    if (this.state.scrolling) {
      return;
    }
    if (this.state.animating) {
      e.preventDefault();
      return;
    }
    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
      e.preventDefault();
    }
    var swipeLeft;
    var curLeft, positionOffset;
    var touchObject = this.state.touchObject;

    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: this.state.currentSlide,
      trackRef: this.track
    }, this.props, this.state));
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
      this.setState({
        scrolling: true
      });
      return;
    }

    if (this.props.verticalSwiping) {
      touchObject.swipeLength = verticalSwipeLength;
    }

    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);

    if (this.props.verticalSwiping) {
      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    }

    var currentSlide = this.state.currentSlide;
    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
    var swipeDirection = this.swipeDirection(this.state.touchObject);
    var touchSwipeLength = touchObject.swipeLength;

    if (this.props.infinite === false) {
      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;

        if (this.state.edgeDragged === false && this.props.edgeEvent) {
          this.props.edgeEvent(swipeDirection);
          this.setState({ edgeDragged: true });
        }
      }
    }

    if (this.state.swiped === false && this.props.swipeEvent) {
      this.props.swipeEvent(swipeDirection);
      this.setState({ swiped: true });
    }

    if (!this.props.vertical) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
    }

    if (this.props.verticalSwiping) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    }

    this.setState({
      touchObject: touchObject,
      swipeLeft: swipeLeft,
      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
    });

    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
      return;
    }
    if (touchObject.swipeLength > 4) {
      this.setState({
        swiping: true
      });
      e.preventDefault();
    }
  },
  getNavigableIndexes: function getNavigableIndexes() {
    var max = void 0;
    var breakPoint = 0;
    var counter = 0;
    var indexes = [];

    if (!this.props.infinite) {
      max = this.state.slideCount;
    } else {
      breakPoint = this.props.slidesToShow * -1;
      counter = this.props.slidesToShow * -1;
      max = this.state.slideCount * 2;
    }

    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + this.props.slidesToScroll;

      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
    }

    return indexes;
  },
  checkNavigable: function checkNavigable(index) {
    var navigables = this.getNavigableIndexes();
    var prevNavigable = 0;

    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }

        prevNavigable = navigables[n];
      }
    }

    return index;
  },
  getSlideCount: function getSlideCount() {
    var _this = this;

    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;

    if (this.props.swipeToSlide) {
      var swipedSlide = void 0;

      var slickList = _reactDom2.default.findDOMNode(this.list);

      var slides = slickList.querySelectorAll('.slick-slide');

      Array.from(slides).every(function (slide) {
        if (!_this.props.vertical) {
          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
            swipedSlide = slide;
            return false;
          }
        } else {
          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
            swipedSlide = slide;
            return false;
          }
        }

        return true;
      });

      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;

      return slidesTraversed;
    } else {
      return this.props.slidesToScroll;
    }
  },

  swipeEnd: function swipeEnd(e) {
    if (!this.state.dragging) {
      if (this.props.swipe) {
        e.preventDefault();
      }
      return;
    }
    var touchObject = this.state.touchObject;
    var minSwipe = this.state.listWidth / this.props.touchThreshold;
    var swipeDirection = this.swipeDirection(touchObject);

    if (this.props.verticalSwiping) {
      minSwipe = this.state.listHeight / this.props.touchThreshold;
    }

    var wasScrolling = this.state.scrolling;
    // reset the state of touch related state variables.
    this.setState({
      dragging: false,
      edgeDragged: false,
      scrolling: false,
      swiping: false,
      swiped: false,
      swipeLeft: null,
      touchObject: {}
    });
    if (wasScrolling) {
      return;
    }

    // Fix for #13
    if (!touchObject.swipeLength) {
      return;
    }
    if (touchObject.swipeLength > minSwipe) {
      e.preventDefault();

      var slideCount = void 0,
          newSlide = void 0;

      switch (swipeDirection) {

        case 'left':
        case 'down':
          newSlide = this.state.currentSlide + this.getSlideCount();
          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
          this.state.currentDirection = 0;
          break;

        case 'right':
        case 'up':
          newSlide = this.state.currentSlide - this.getSlideCount();
          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
          this.state.currentDirection = 1;
          break;

        default:
          slideCount = this.state.currentSlide;

      }

      this.slideHandler(slideCount);
    } else {
      // Adjust the track back to it's original position.
      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, this.props, this.state));

      this.setState({
        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
      });
    }
  },
  onInnerSliderEnter: function onInnerSliderEnter(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderOver: function onInnerSliderOver(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderLeave: function onInnerSliderLeave(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.autoPlay();
    }
  }
};

exports.default = EventHandlers;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var initialState = {
    animating: false,
    dragging: false,
    autoPlayTimer: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    listWidth: null,
    listHeight: null,
    scrolling: false,
    // loadIndex: 0,
    slideCount: null,
    slideWidth: null,
    slideHeight: null,
    swiping: false,
    // sliding: false,
    // slideOffset: 0,
    swipeLeft: null,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },

    lazyLoadedList: [],

    // added for react
    initialized: false,
    edgeDragged: false,
    swiped: false, // used by swipeEvent. differentites between touch and swipe.
    trackStyle: {},
    trackWidth: 0

    // Removed
    // transformsEnabled: false,
    // $nextArrow: null,
    // $prevArrow: null,
    // $dots: null,
    // $list: null,
    // $slideTrack: null,
    // $slides: null,
};

module.exports = initialState;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(2);
var factory = __webpack_require__(493);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(39);

var emptyObject = __webpack_require__(105);
var _invariant = __webpack_require__(110);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
exports.Track = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(39);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _classnames = __webpack_require__(65);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  return (0, _classnames2.default)({
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned
  });
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = 'relative';
    style.left = -spec.index * spec.slideWidth;
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  // key could be a zero
  return child.key === null || child.key === undefined ? fallbackKey : child.key;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var count = _react2.default.Children.count(spec.children);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: 'children',
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
      child = elem;
    } else {
      child = _react2.default.createElement('div', null);
    }
    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
    var slideClass = child.props.className || '';

    var onClick = function onClick(e) {
      child.props && child.props.onClick && child.props.onClick(e);
      if (spec.focusOnSelect) {
        spec.focusOnSelect(childOnClickOptions);
      }
    };

    slides.push(_react2.default.cloneElement(child, {
      key: 'original' + getKey(child, index),
      'data-index': index,
      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
      tabIndex: '-1',
      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
      onClick: onClick
    }));

    // variableWidth doesn't wrap properly.
    if (spec.infinite && spec.fade === false) {
      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;

      if (index >= count - infiniteCount) {
        key = -(count - index);
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: 'precloned' + getKey(child, key),
          'data-index': key,
          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }

      if (index < infiniteCount) {
        key = count + index;
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: 'postcloned' + getKey(child, key),
          'data-index': key,
          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$Component) {
  _inherits(Track, _React$Component);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides.call(this, this.props);
    return _react2.default.createElement(
      'div',
      { className: 'slick-track', style: this.props.trackStyle },
      slides
    );
  };

  return Track;
}(_react2.default.Component);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
exports.Dots = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(65);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;
  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  return dots;
};

var Dots = exports.Dots = function (_React$Component) {
  _inherits(Dots, _React$Component);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {

      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: 'dots',
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);

      return _react2.default.createElement(
        'li',
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.createElement(
      'ul',
      { className: this.props.dotsClass, style: { display: 'block' } },
      dots
    );
  };

  return Dots;
}(_react2.default.Component);

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(65);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(139);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$Component) {
  _inherits(PrevArrow, _React$Component);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses['slick-disabled'] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: '0',
      'data-role': 'none',
      className: (0, _classnames2.default)(prevClasses),
      style: { display: 'block' },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        'button',
        _extends({ key: '0', type: 'button' }, prevArrowProps),
        ' Previous'
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.Component);

var NextArrow = exports.NextArrow = function (_React$Component2) {
  _inherits(NextArrow, _React$Component2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
    var nextHandler = this.clickHandler.bind(this, { message: 'next' });

    if (!_helpers2.default.canGoNext(this.props)) {
      nextClasses['slick-disabled'] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: '1',
      'data-role': 'none',
      className: (0, _classnames2.default)(nextClasses),
      style: { display: 'block' },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        'button',
        _extends({ key: '1', type: 'button' }, nextArrowProps),
        ' Next'
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.Component);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(498);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 499 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(501);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(502);
var Util = __webpack_require__(225);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(503);
var each = __webpack_require__(225).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 503 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = __webpack_require__(64);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(_ref) {
    var _this = this;

    var player = _ref.player,
        percentInView = _ref.percentInView;

    _classCallCheck(this, _class);

    this.player = player;
    this.wrapper = this.player.getContainer();
    this.throttledScrollListener = (0, _throttle2.default)(function () {
      _this.playerInView(percentInView);
    }, 300);
  }

  _createClass(_class, [{
    key: 'playerPosition',
    value: function playerPosition(playerEl) {
      if (playerEl && playerEl.getBoundingClientRect) {
        var bodyRect = document.body.getBoundingClientRect();
        var playerRect = playerEl.getBoundingClientRect();
        return playerRect.top - bodyRect.top - this.scrollPosition().top;
      }
      return null;
    }
  }, {
    key: 'scrollPosition',
    value: function scrollPosition() {
      var doc = document.documentElement;
      return {
        left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
        top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
      };
    }
  }, {
    key: 'playerInView',
    value: function playerInView(percentInView) {
      var pixelsInView = this.player.getHeight() * percentInView / 100;
      var difference = this.playerPosition(this.wrapper) + pixelsInView;
      var adjust = window.innerHeight > pixelsInView ? window.innerHeight : 100;
      var inView = difference > pixelsInView && difference < adjust;

      return this.player.play(inView);
    }
  }, {
    key: 'on',
    value: function on() {
      window.addEventListener('scroll', this.throttledScrollListener);
    }
  }, {
    key: 'off',
    value: function off() {
      window.removeEventListener('scroll', this.throttledScrollListener);
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchAllFeedIS;

var _all_feed_action_creators = __webpack_require__(227);

var allFeedActions = _interopRequireWildcard(_all_feed_action_creators);

var _all_feed_module = __webpack_require__(228);

var _all_feed_module2 = _interopRequireDefault(_all_feed_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchAllFeedIS(dispatch) {
  return function fetchModelData(params, config) {
    dispatch(allFeedActions.allFeedISLoading());
    return _all_feed_module2.default.fetchAllFeedIS(params, config).then(function handleAuthorAllFeedData(AllFeedData) {
      dispatch(allFeedActions.allFeedISLoaded(AllFeedData.data, config));
    }).catch(function handleAuthorAllFeedError(err) {
      dispatch(allFeedActions.allFeedISError(err, config));
      _logger_service2.default.error(err, 'Error in all  all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(53);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Request = function () {
  function Request() {
    _classCallCheck(this, Request);
  }

  _createClass(Request, null, [{
    key: 'getAsync',
    value: function getAsync(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return (0, _axios2.default)(url, options);
    }
  }]);

  return Request;
}();

exports.default = Request;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recircFeedLoading = recircFeedLoading;
exports.recircFeedLoaded = recircFeedLoaded;
exports.recircFeedLoadError = recircFeedLoadError;
exports.hideRecircFeed = hideRecircFeed;
// import { canUseDOM } from 'exenv';

function recircFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'RECIRC_FEED_LOADING',
    recircFeed: resp,
    store: store
  };
}

function recircFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'RECIRC_FEED_LOADED',
    recircFeed: resp,
    store: store
  };
}

function recircFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'RECIRC_FEED_ERROR',
    recircFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

function hideRecircFeed() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HIDE_RECIRC_FEED',
    recircFeed: resp,
    store: store
  };
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllFeed = function (_Base) {
  _inherits(AllFeed, _Base);

  function AllFeed() {
    _classCallCheck(this, AllFeed);

    return _possibleConstructorReturn(this, (AllFeed.__proto__ || Object.getPrototypeOf(AllFeed)).apply(this, arguments));
  }

  _createClass(AllFeed, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/recirc-feed?total=3';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return AllFeed;
}(_base_model2.default);

exports.default = AllFeed;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(93),
    castPath = __webpack_require__(70),
    isIndex = __webpack_require__(72),
    isObject = __webpack_require__(38),
    toKey = __webpack_require__(60);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _homepage_action_creators = __webpack_require__(511);

var homepageActions = _interopRequireWildcard(_homepage_action_creators);

var _async_scrolling_module_actions = __webpack_require__(512);

var _async_scrolling_module_actions2 = _interopRequireDefault(_async_scrolling_module_actions);

var _async_promo_banner_actions = __webpack_require__(515);

var _async_promo_banner_actions2 = _interopRequireDefault(_async_promo_banner_actions);

var _async_all_feed_actions = __webpack_require__(230);

var _async_all_feed_actions2 = _interopRequireDefault(_async_all_feed_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_featured_feed_actions = __webpack_require__(518);

var _async_featured_feed_actions2 = _interopRequireDefault(_async_featured_feed_actions);

var _async_homepage_tag_actions = __webpack_require__(521);

var _async_homepage_tag_actions2 = _interopRequireDefault(_async_homepage_tag_actions);

var _async_homepage_video_actions = __webpack_require__(524);

var _async_homepage_video_actions2 = _interopRequireDefault(_async_homepage_video_actions);

var _async_magazine_latest_issue_posts_actions = __webpack_require__(231);

var _async_magazine_latest_issue_posts_actions2 = _interopRequireDefault(_async_magazine_latest_issue_posts_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_featured_sponsored_card_actions = __webpack_require__(143);

var _async_featured_sponsored_card_actions2 = _interopRequireDefault(_async_featured_sponsored_card_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageActions.homepageLoading());
    if (params.page) {
      return _bluebird2.default.all([(0, _async_all_feed_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
        dispatch(homepageActions.homepageLoaded({}, store));
        return true;
      }).catch(function handleUserError(err) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
        dispatch(homepageActions.homepageLoadError(err, store));
        return _logger_service2.default.error(err, 'Error in homepage actions, message: ' + err.message);
      });
    }
    return _bluebird2.default.all([(0, _async_featured_feed_actions2.default)(params, store)(dispatch), (0, _async_featured_sponsored_card_actions2.default)(params, store)(dispatch), (0, _async_promo_banner_actions2.default)(params, store)(dispatch), (0, _async_scrolling_module_actions2.default)(params, store)(dispatch), (0, _async_homepage_video_actions2.default)(params, store)(dispatch), (0, _async_homepage_tag_actions2.default)(params, store)(dispatch), (0, _async_all_feed_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch), (0, _async_magazine_latest_issue_posts_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(homepageActions.homepageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      dispatch(homepageActions.homepageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in homepage actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homepageLoading = homepageLoading;
exports.homepageLoaded = homepageLoaded;
exports.homepageLoadError = homepageLoadError;
// import { canUseDOM } from 'exenv';

function homepageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HOMEPAGE_LOADING',
    homepage: resp,
    store: store
  };
}

function homepageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'HOMEPAGE_LOADED',
    homepage: resp,
    store: store
  };
}

function homepageLoadError(error, store) {
  return {
    type: 'HOMEPAGE_ERROR',
    homepage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _scrolling_module_action_creators = __webpack_require__(513);

var scrollingModuleActions = _interopRequireWildcard(_scrolling_module_action_creators);

var _scrolling_module = __webpack_require__(514);

var _scrolling_module2 = _interopRequireDefault(_scrolling_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(scrollingModuleActions.scrollingModuleLoading({}, store));
    return _scrolling_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(scrollingModuleActions.scrollingModuleLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(scrollingModuleActions.scrollingModuleLoadError(err, store));
      _logger_service2.default.error(err, 'Error in scrollingModule actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollingModuleLoading = scrollingModuleLoading;
exports.scrollingModuleLoaded = scrollingModuleLoaded;
exports.scrollingModuleLoadError = scrollingModuleLoadError;
// import { canUseDOM } from 'exenv';

function scrollingModuleLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SCROLLING_MODULE_LOADING',
    scrollingModule: resp,
    store: store
  };
}

function scrollingModuleLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SCROLLING_MODULE_LOADED',
    scrollingModule: {
      posts: resp.posts,
      tag: resp.tag
    },
    store: store
  };
}

function scrollingModuleLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SCROLLING_MODULE_ERROR',
    scrollingModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LatestPosts = function (_Base) {
  _inherits(LatestPosts, _Base);

  function LatestPosts() {
    _classCallCheck(this, LatestPosts);

    return _possibleConstructorReturn(this, (LatestPosts.__proto__ || Object.getPrototypeOf(LatestPosts)).apply(this, arguments));
  }

  _createClass(LatestPosts, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var site = (0, _get2.default)(state, 'config.site');

      var cacheKeyUrl = '' + protocol + host + '/api/v2/scrolling-module-posts/' + site + '?total=20';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return LatestPosts;
}(_base_model2.default);

exports.default = LatestPosts;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _promo_banner_action_creators = __webpack_require__(516);

var promoBannerActions = _interopRequireWildcard(_promo_banner_action_creators);

var _promo_banner = __webpack_require__(517);

var _promo_banner2 = _interopRequireDefault(_promo_banner);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(promoBannerActions.promoBannerLoading({}, store));
    return _promo_banner2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(promoBannerActions.promoBannerLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(promoBannerActions.promoBannerLoadError(err, store));
      _logger_service2.default.error(err, 'Error in promoBanner actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promoBannerLoading = promoBannerLoading;
exports.promoBannerLoaded = promoBannerLoaded;
exports.promoBannerLoadError = promoBannerLoadError;
// import { canUseDOM } from 'exenv';

function promoBannerLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PROMO_BANNER_LOADING',
    promoBanner: resp,
    store: store
  };
}

function promoBannerLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PROMO_BANNER_LOADED',
    promoBanner: resp.promoBanner,
    store: store
  };
}

function promoBannerLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PROMO_BANNER_ERROR',
    promoBanner: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromoBanner = function (_Base) {
  _inherits(PromoBanner, _Base);

  function PromoBanner() {
    _classCallCheck(this, PromoBanner);

    return _possibleConstructorReturn(this, (PromoBanner.__proto__ || Object.getPrototypeOf(PromoBanner)).apply(this, arguments));
  }

  _createClass(PromoBanner, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var site = (0, _get2.default)(state, 'config.site');

      var cacheKeyUrl = '' + protocol + host + '/api/v1/promo-banner/' + site;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return PromoBanner;
}(_base_model2.default);

exports.default = PromoBanner;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchFeaturedModule;

var _featured_feed_action_creators = __webpack_require__(519);

var featuredFeedActions = _interopRequireWildcard(_featured_feed_action_creators);

var _featured_module = __webpack_require__(520);

var _featured_module2 = _interopRequireDefault(_featured_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchFeaturedModule(params, store) {
  return function firstDispatchFeatured(dispatch) {
    dispatch(featuredFeedActions.featuredFeedLoading());
    return _featured_module2.default.fetch(params, store).then(function handleFeaturedModuleData(resp) {
      dispatch(featuredFeedActions.featuredFeedLoaded(resp.data, store));
    }).catch(function handleFeaturedError(err) {
      dispatch(featuredFeedActions.featuredFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in featured feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featuredFeedLoading = featuredFeedLoading;
exports.featuredFeedLoaded = featuredFeedLoaded;
exports.featuredFeedLoadError = featuredFeedLoadError;
// import { canUseDOM } from 'exenv';

function featuredFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'FEATURED_FEED_LOADING',
    featuredFeed: resp,
    store: store
  };
}

function featuredFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'FEATURED_FEED_LOADED',
    featuredFeed: resp,
    store: store
  };
}

function featuredFeedLoadError(error, store) {
  return {
    type: 'FEATURED_FEED_ERROR',
    featuredFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TopTags = function (_Base) {
  _inherits(TopTags, _Base);

  function TopTags() {
    _classCallCheck(this, TopTags);

    return _possibleConstructorReturn(this, (TopTags.__proto__ || Object.getPrototypeOf(TopTags)).apply(this, arguments));
  }

  _createClass(TopTags, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/featured-feed/' + site;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          if (!_exenv.canUseDOM) {
            _logger_service2.default.info('Setting cache key for featured feed: ' + cacheKey + ' from model.');
          }
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return TopTags;
}(_base_model2.default);

exports.default = TopTags;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _homepage_tag_action_creators = __webpack_require__(522);

var homepageTagActions = _interopRequireWildcard(_homepage_tag_action_creators);

var _homepage_tag_module = __webpack_require__(523);

var _homepage_tag_module2 = _interopRequireDefault(_homepage_tag_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageTagActions.homepageTagLoading({}, store));
    return _homepage_tag_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(homepageTagActions.homepageTagLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(homepageTagActions.homepageTagLoadError(err, store));
      _logger_service2.default.error(err, 'Error in homepage tag actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homepageTagLoading = homepageTagLoading;
exports.homepageTagLoaded = homepageTagLoaded;
exports.homepageTagLoadError = homepageTagLoadError;
// import { canUseDOM } from 'exenv';

function homepageTagLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HOMEPAGE_TAG_LOADING',
    homepageTag: resp,
    store: store
  };
}

function homepageTagLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'HOMEPAGE_TAG_LOADED',
    homepageTag: {
      posts: resp
    },
    store: store
  };
}

function homepageTagLoadError(error, store) {
  return {
    type: 'HOMEPAGE_TAG_ERROR',
    homepageTag: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomepageTagModel = function (_Base) {
  _inherits(HomepageTagModel, _Base);

  function HomepageTagModel() {
    _classCallCheck(this, HomepageTagModel);

    return _possibleConstructorReturn(this, (HomepageTagModel.__proto__ || Object.getPrototypeOf(HomepageTagModel)).apply(this, arguments));
  }

  _createClass(HomepageTagModel, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/tag-homepage-feed/' + site + '?total=4&with_body=0';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return HomepageTagModel;
}(_base_model2.default);

exports.default = HomepageTagModel;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _homepage_video_action_creators = __webpack_require__(525);

var homepageVideoActions = _interopRequireWildcard(_homepage_video_action_creators);

var _homepage_video_module = __webpack_require__(526);

var _homepage_video_module2 = _interopRequireDefault(_homepage_video_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageVideoActions.homepageVideoLoading({}, store));
    return _homepage_video_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(homepageVideoActions.homepageVideoLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(homepageVideoActions.homepageVideoLoadError(err, store));
      _logger_service2.default.error(err, 'Error in homepage video actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homepageVideoLoading = homepageVideoLoading;
exports.homepageVideoLoaded = homepageVideoLoaded;
exports.homepageVideoLoadError = homepageVideoLoadError;
// import { canUseDOM } from 'exenv';

function homepageVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HOMEPAGE_VIDEO_LOADING',
    homepageVideo: resp,
    store: store
  };
}

function homepageVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'HOMEPAGE_VIDEO_LOADED',
    homepageVideo: resp,
    store: store
  };
}

function homepageVideoLoadError(error, store) {
  return {
    type: 'HOMEPAGE_VIDEO_ERROR',
    homepageVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var homepageJwIdMap = {
  fastcompany: 'DCmFDcAw',
  fastcodesign: 'Siaxnx3q'
};

var HomePageVideo = function (_Base) {
  _inherits(HomePageVideo, _Base);

  function HomePageVideo() {
    _classCallCheck(this, HomePageVideo);

    return _possibleConstructorReturn(this, (HomePageVideo.__proto__ || Object.getPrototypeOf(HomePageVideo)).apply(this, arguments));
  }

  _createClass(HomePageVideo, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var id = (0, _get2.default)(homepageJwIdMap, site) || homepageJwIdMap.fastcompany;
      var host = 'content.jwplatform.com';
      var options = {};

      var cacheKeyUrl = 'https://' + host + '/feeds/' + id + '.json';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return HomePageVideo;
}(_base_model2.default);

exports.default = HomePageVideo;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.magazineLatestIssuePostsLoading = magazineLatestIssuePostsLoading;
exports.magazineLatestIssuePostsLoaded = magazineLatestIssuePostsLoaded;
exports.magazineLatestIssuePostsError = magazineLatestIssuePostsError;
function magazineLatestIssuePostsLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_LATEST_ISSUE_POSTS_LOADING',
    magazineLatestIssuePosts: resp,
    store: store
  };
}

function magazineLatestIssuePostsLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_LATEST_ISSUE_POSTS_LOADED',
    magazineLatestIssuePosts: resp,
    store: store
  };
}

function magazineLatestIssuePostsError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_LATEST_ISSUE_POSTS_ERROR',
    magazineLatestIssuePosts: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MagazineLatestIssuePostsModel = function (_Base) {
  _inherits(MagazineLatestIssuePostsModel, _Base);

  function MagazineLatestIssuePostsModel() {
    _classCallCheck(this, MagazineLatestIssuePostsModel);

    return _possibleConstructorReturn(this, (MagazineLatestIssuePostsModel.__proto__ || Object.getPrototypeOf(MagazineLatestIssuePostsModel)).apply(this, arguments));
  }

  _createClass(MagazineLatestIssuePostsModel, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      // const site = get(state, 'config.site');
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/magazine/get-magazine-latest-issue-posts';

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return MagazineLatestIssuePostsModel;
}(_base_model2.default);

exports.default = MagazineLatestIssuePostsModel;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featuredSponsoredCardLoading = featuredSponsoredCardLoading;
exports.featuredSponsoredCardLoaded = featuredSponsoredCardLoaded;
exports.featuredSponsoredCardLoadError = featuredSponsoredCardLoadError;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function featuredSponsoredCardLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'FEATURED_SPONSORED_CARD_LOADING',
    featuredSponsoredCard: (0, _get2.default)(resp, 'featuredSponsoredCard'),
    store: store
  };
} // import { canUseDOM } from 'exenv';
function featuredSponsoredCardLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'FEATURED_SPONSORED_CARD_LOADED',
    featuredSponsoredCard: (0, _get2.default)(resp, 'featuredSponsoredCard'),
    store: store
  };
}

function featuredSponsoredCardLoadError(error, store) {
  return {
    type: 'FEATURED_SPONSORED_CARD_ERROR',
    featuredSponsoredCard: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeaturedSponsoredCard = function (_Base) {
  _inherits(FeaturedSponsoredCard, _Base);

  function FeaturedSponsoredCard() {
    _classCallCheck(this, FeaturedSponsoredCard);

    return _possibleConstructorReturn(this, (FeaturedSponsoredCard.__proto__ || Object.getPrototypeOf(FeaturedSponsoredCard)).apply(this, arguments));
  }

  _createClass(FeaturedSponsoredCard, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var site = (0, _get2.default)(state, 'config.site');
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/featured-sponsored-card/' + site;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;
      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return FeaturedSponsoredCard;
}(_base_model2.default);

exports.default = FeaturedSponsoredCard;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/all/:page',
    component: _index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _homepage_state_manager2.default)(store)
  };
};

var _index_page = __webpack_require__(134);

var _index_page2 = _interopRequireDefault(_index_page);

var _homepage_state_manager = __webpack_require__(142);

var _homepage_state_manager2 = _interopRequireDefault(_homepage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/all',
    component: _index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _homepage_state_manager2.default)(store, IS_ALL_INDEX)
  };
};

var _index_page = __webpack_require__(134);

var _index_page2 = _interopRequireDefault(_index_page);

var _homepage_state_manager = __webpack_require__(142);

var _homepage_state_manager2 = _interopRequireDefault(_homepage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_ALL_INDEX = true;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/user/:slug',
    component: _author_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _author_page_state_manager2.default)(store)
  };
};

var _author_page = __webpack_require__(232);

var _author_page2 = _interopRequireDefault(_author_page);

var _author_page_state_manager = __webpack_require__(234);

var _author_page_state_manager2 = _interopRequireDefault(_author_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchAuthorAllFeedIS;

var _author_all_feed_action_creators = __webpack_require__(144);

var authorAllFeedActions = _interopRequireWildcard(_author_all_feed_action_creators);

var _author_all_feed = __webpack_require__(233);

var _author_all_feed2 = _interopRequireDefault(_author_all_feed);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchAuthorAllFeedIS(dispatch) {
  return function fetchModelData(params, config) {
    dispatch(authorAllFeedActions.authorAllFeedISLoading());
    return _author_all_feed2.default.fetchAllFeedIS(params, config).then(function handleAuthorAllFeedData(authorAllFeedData) {
      dispatch(authorAllFeedActions.authorAllFeedISLoaded(authorAllFeedData.data, config));
    }).catch(function handleAuthorAllFeedError(err) {
      dispatch(authorAllFeedActions.authorAllFeedISError(err, config));
      _logger_service2.default.error(err, 'Error in all author all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchAuthorPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _author_page_action_creators = __webpack_require__(536);

var authorPageActions = _interopRequireWildcard(_author_page_action_creators);

var _async_author_all_feed_actions = __webpack_require__(537);

var _async_author_all_feed_actions2 = _interopRequireDefault(_async_author_all_feed_actions);

var _async_author_actions = __webpack_require__(538);

var _async_author_actions2 = _interopRequireDefault(_async_author_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchAuthorPage(params, store) {
  return function firstAuthorPageDispatch(dispatch) {
    dispatch(authorPageActions.authorPageLoading());
    return _bluebird2.default.all([(0, _async_author_actions2.default)(params, store)(dispatch), (0, _async_author_all_feed_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handleAuthorPageData() {
      dispatch(authorPageActions.authorPageLoaded({}, store));
      return true;
    }).catch(function handleAuthorPageError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(authorPageActions.authorPageLoadError(err, store));
      _logger_service2.default.error(err, 'Error in author page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authorPageLoading = authorPageLoading;
exports.authorPageLoaded = authorPageLoaded;
exports.authorPageLoadError = authorPageLoadError;
// import { canUseDOM } from 'exenv';

function authorPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'AUTHOR_PAGE_LOADING',
    authorPage: resp,
    store: store
  };
}

function authorPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'AUTHOR_PAGE_LOADED',
    authorPage: resp,
    store: store
  };
}

function authorPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'AUTHOR_PAGE_ERROR',
    authorPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchAuthorAllFeed;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _author_all_feed_action_creators = __webpack_require__(144);

var authorAllFeedActions = _interopRequireWildcard(_author_all_feed_action_creators);

var _author_all_feed = __webpack_require__(233);

var _author_all_feed2 = _interopRequireDefault(_author_all_feed);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchAuthorAllFeed(params, store) {
  return function authorAllFeed(dispatch) {
    dispatch(authorAllFeedActions.authorAllFeedLoading());
    return _author_all_feed2.default.fetch(params, store).then(function handleAuthorAllFeedData(authorAllFeedData) {
      if (params.page && !(0, _get2.default)(authorAllFeedData, 'data.posts.length')) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }
      dispatch(authorAllFeedActions.authorAllFeedLoaded(authorAllFeedData.data, store));
    }).catch(function handleAuthorAllFeedError(err) {
      dispatch(authorAllFeedActions.authorAllFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in all author all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchAuthorAction;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _author_action_creators = __webpack_require__(539);

var authorActions = _interopRequireWildcard(_author_action_creators);

var _author = __webpack_require__(540);

var _author2 = _interopRequireDefault(_author);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchAuthorAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(authorActions.authorLoading());
    return _author2.default.fetch(params, store).then(function handleAuthorData(AuthorData) {
      dispatch(authorActions.authorLoaded(AuthorData.data, store));
    }).catch(function handleAuthorError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(status, 'ERROR_STATUS', store));
      }
      dispatch(authorActions.authorLoadError(err, store));
      _logger_service2.default.error(err, 'Error in all author actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authorLoading = authorLoading;
exports.authorLoaded = authorLoaded;
exports.authorLoadError = authorLoadError;
// import { canUseDOM } from 'exenv';

function authorLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'AUTHOR_LOADING',
    author: resp,
    store: store
  };
}

function authorLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'AUTHOR_LOADED',
    author: resp.user,
    store: store
  };
}

function authorLoadError(error, store) {
  return {
    type: 'AUTHOR_ERROR',
    author: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Author = function (_Base) {
  _inherits(Author, _Base);

  function Author() {
    _classCallCheck(this, Author);

    return _possibleConstructorReturn(this, (Author.__proto__ || Object.getPrototypeOf(Author)).apply(this, arguments));
  }

  _createClass(Author, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var slug = _ref.slug;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/user-slug/' + site + '/' + this.cleanParam(slug);
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Author;
}(_base_model2.default);

exports.default = Author;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/user/:slug/:page',
    component: _author_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _author_page_state_manager2.default)(store)
  };
};

var _author_page = __webpack_require__(232);

var _author_page2 = _interopRequireDefault(_author_page);

var _author_page_state_manager = __webpack_require__(234);

var _author_page_state_manager2 = _interopRequireDefault(_author_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/:category',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store)
  };
};

var _category_page = __webpack_require__(145);

var _category_page2 = _interopRequireDefault(_category_page);

var _category_page_state_manager = __webpack_require__(67);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategoryPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _category_page_action_creators = __webpack_require__(544);

var categoryPageActions = _interopRequireWildcard(_category_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_category_video_actions = __webpack_require__(545);

var _async_category_video_actions2 = _interopRequireDefault(_async_category_video_actions);

var _async_category_all_feed_actions = __webpack_require__(548);

var _async_category_all_feed_actions2 = _interopRequireDefault(_async_category_all_feed_actions);

var _async_category_scrolling_module_actions = __webpack_require__(550);

var _async_category_scrolling_module_actions2 = _interopRequireDefault(_async_category_scrolling_module_actions);

var _async_category_promo_banner_actions = __webpack_require__(553);

var _async_category_promo_banner_actions2 = _interopRequireDefault(_async_category_promo_banner_actions);

var _async_category_featured_feed_actions = __webpack_require__(556);

var _async_category_featured_feed_actions2 = _interopRequireDefault(_async_category_featured_feed_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_featured_sponsored_card_actions = __webpack_require__(143);

var _async_featured_sponsored_card_actions2 = _interopRequireDefault(_async_featured_sponsored_card_actions);

var _async_magazine_latest_issue_posts_actions = __webpack_require__(231);

var _async_magazine_latest_issue_posts_actions2 = _interopRequireDefault(_async_magazine_latest_issue_posts_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function fetchCategoryPage(params, store, isTag) {
  return function firstDispatchCategoryPage(dispatch) {
    dispatch(categoryPageActions.categoryPageLoading());
    var actions = [];

    switch (params.category) {
      case 'news':
        actions = [(0, _async_category_video_actions2.default)(params, store, isTag)(dispatch), (0, _async_category_all_feed_actions2.default)(params, store, isTag)(dispatch)];
        (0, _set2.default)(params, 'category', 'news');
        break;
      case 'magazine':
        actions = [(0, _async_magazine_latest_issue_posts_actions2.default)(params, store, isTag)(dispatch)];
        (0, _set2.default)(params, 'category', 'magazine');
        break;
      default:
        actions = [(0, _async_category_video_actions2.default)(params, store, isTag)(dispatch), (0, _async_category_all_feed_actions2.default)(params, store, isTag)(dispatch), (0, _async_featured_sponsored_card_actions2.default)(params, store, isTag)(dispatch), (0, _async_category_promo_banner_actions2.default)(params, store, isTag)(dispatch), (0, _async_category_scrolling_module_actions2.default)(params, store, isTag)(dispatch)];
        break;
    }

    return _bluebird2.default.all([(0, _async_category_featured_feed_actions2.default)(params, store, isTag)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store, isTag)(dispatch)].concat(_toConsumableArray(actions))).then(function handleCategoryPageData() {
      dispatch(categoryPageActions.categoryPageLoaded({}, store));
      return true;
    }).catch(function handleCategoryPageError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(categoryPageActions.categoryPageLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryPageLoading = categoryPageLoading;
exports.categoryPageLoaded = categoryPageLoaded;
exports.categoryPageLoadError = categoryPageLoadError;
// import { canUseDOM } from 'exenv';

function categoryPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PAGE_LOADING',
    categoryPage: resp,
    store: store
  };
}

function categoryPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PAGE_LOADED',
    categoryPage: resp,
    store: store
  };
}

function categoryPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PAGE_ERROR',
    categoryPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _category_video_action_creators = __webpack_require__(546);

var categoryVideoActions = _interopRequireWildcard(_category_video_action_creators);

var _category_video_module = __webpack_require__(547);

var _category_video_module2 = _interopRequireDefault(_category_video_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(categoryVideoActions.categoryVideoLoading());
    return _category_video_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(categoryVideoActions.categoryVideoLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(categoryVideoActions.categoryVideoLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category video actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryVideoLoading = categoryVideoLoading;
exports.categoryVideoLoaded = categoryVideoLoaded;
exports.categoryVideoLoadError = categoryVideoLoadError;
// import { canUseDOM } from 'exenv';

function categoryVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_VIDEO_LOADING',
    categoryVideo: resp,
    store: store
  };
}

function categoryVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_VIDEO_LOADED',
    categoryVideo: resp,
    store: store
  };
}

function categoryVideoLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_VIDEO_ERROR',
    categoryVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var categoryJwIdMap = {
  technology: 'PSsJtDkM',
  leadership: 'QIKO4Bg0',
  magazine: 'Y9DjLnt6',
  MCP: '7qluGmg9',
  MIC: 'dGGdpkNJ',
  news: 'W56TTMkA',
  ads: 'AYdibOhm',
  movies: '9pyPGMMb',
  games: 'pcPUSNzp',
  tv: 'BFft6WE8',
  music: '31g3mGyX',
  graphics: 'E94CFqkP',
  IBD: 'ugHwoYDj',
  interactive: 'QhzkgUg4',
  product: 'SguMMpt0',
  spaces: 'G9BPHwFi',
  cities: 'GofVu1Ze',
  ideas: 'OATCOesq',
  sustainability: 'osKp5aZy',
  science: 'WFvqDhWI',
  transportation: '7Knj3gow',
  entertainment: 'Rdek7nNz',
  default: 'R6of2m4z'
};

var CategoryPageVideo = function (_Base) {
  _inherits(CategoryPageVideo, _Base);

  function CategoryPageVideo() {
    _classCallCheck(this, CategoryPageVideo);

    return _possibleConstructorReturn(this, (CategoryPageVideo.__proto__ || Object.getPrototypeOf(CategoryPageVideo)).apply(this, arguments));
  }

  _createClass(CategoryPageVideo, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var category = params.category;

      var id = (0, _get2.default)(categoryJwIdMap, category) || categoryJwIdMap.default;
      var host = 'content.jwplatform.com';
      var options = {};
      var cacheKeyUrl = 'https://' + host + '/feeds/' + id + '.json';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryPageVideo;
}(_base_model2.default);

exports.default = CategoryPageVideo;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategoryAllFeed;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _category_all_feed_action_creators = __webpack_require__(235);

var categoryAllFeedActions = _interopRequireWildcard(_category_all_feed_action_creators);

var _category_all_feed = __webpack_require__(549);

var _category_all_feed2 = _interopRequireDefault(_category_all_feed);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCategoryAllFeed(params, store, isTag) {
  return function firstDispatchCategoryAllFeed(dispatch) {
    dispatch(categoryAllFeedActions.categoryAllFeedLoading());
    return _category_all_feed2.default.fetch(params, store, isTag).then(function handleCategoryAllFeedData(CategoryData) {
      if ((params.page || isTag) && !(0, _get2.default)(CategoryData, 'data.posts.length')) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }
      dispatch(categoryAllFeedActions.categoryAllFeedLoaded(CategoryData.data, store));
    }).catch(function handleCategoryAllFeedError(err) {
      dispatch(categoryAllFeedActions.categoryAllFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryAllFeed = function (_Base) {
  _inherits(CategoryAllFeed, _Base);

  function CategoryAllFeed() {
    _classCallCheck(this, CategoryAllFeed);

    return _possibleConstructorReturn(this, (CategoryAllFeed.__proto__ || Object.getPrototypeOf(CategoryAllFeed)).apply(this, arguments));
  }

  _createClass(CategoryAllFeed, null, [{
    key: 'fetch',
    value: function fetch(_ref, store, isTag) {
      var category = _ref.category,
          page = _ref.page,
          tag = _ref.tag;

      var pageParams = page ? '&page=' + page : '';
      var tagStr = isTag ? '&tag=' + tag : '';
      var total = 20;
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var isNews = category === 'news';
      var url = 'v2/posts-category-slug/' + site + '/' + category + '?total=' + total + pageParams + (isNews ? '&with_body=true' : '') + tagStr;
      var cacheKeyUrl = '' + protocol + host + '/api/' + url;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryAllFeed;
}(_base_model2.default);

exports.default = CategoryAllFeed;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategory;

var _category_scrolling_module_action_creators = __webpack_require__(551);

var categoryScrollingModuleActions = _interopRequireWildcard(_category_scrolling_module_action_creators);

var _category_scrolling_module = __webpack_require__(552);

var _category_scrolling_module2 = _interopRequireDefault(_category_scrolling_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchCategory(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(categoryScrollingModuleActions.categoryScrollingModuleLoading({}, store));
    return _category_scrolling_module2.default.fetch(params, store, isTag).then(function handleCategoryDetailData(CategoryData) {
      dispatch(categoryScrollingModuleActions.categoryScrollingModuleLoaded(CategoryData.data, store));
    }).catch(function handleUserError(err) {
      dispatch(categoryScrollingModuleActions.categoryScrollingModuleLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category scrollingModule actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryScrollingModuleLoading = categoryScrollingModuleLoading;
exports.categoryScrollingModuleLoaded = categoryScrollingModuleLoaded;
exports.categoryScrollingModuleLoadError = categoryScrollingModuleLoadError;
// import { canUseDOM } from 'exenv';

function categoryScrollingModuleLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_SCROLLING_MODULE_LOADING',
    categoryScrollingModule: resp,
    store: store
  };
}

function categoryScrollingModuleLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_SCROLLING_MODULE_LOADED',
    categoryScrollingModule: {
      posts: resp.posts,
      tag: resp.tag
    },
    store: store
  };
}

function categoryScrollingModuleLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_SCROLLING_MODULE_ERROR',
    categoryScrollingModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryScrollingModule = function (_Base) {
  _inherits(CategoryScrollingModule, _Base);

  function CategoryScrollingModule() {
    _classCallCheck(this, CategoryScrollingModule);

    return _possibleConstructorReturn(this, (CategoryScrollingModule.__proto__ || Object.getPrototypeOf(CategoryScrollingModule)).apply(this, arguments));
  }

  _createClass(CategoryScrollingModule, null, [{
    key: 'fetch',
    value: function fetch(_ref, store, isTag) {
      var category = _ref.category,
          tag = _ref.tag;

      var state = store.getState();
      var tagStr = isTag ? '&tag=' + tag : '';
      var site = (0, _get2.default)(state, 'config.site');
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/category-scrolling-module-posts/' + site + '/' + category + '?total=20' + tagStr;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;
      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryScrollingModule;
}(_base_model2.default);

exports.default = CategoryScrollingModule;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _category_promo_banner_action_creators = __webpack_require__(554);

var categoryPromoBannerActions = _interopRequireWildcard(_category_promo_banner_action_creators);

var _category_promo_banner = __webpack_require__(555);

var _category_promo_banner2 = _interopRequireDefault(_category_promo_banner);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store, isTag) {
  return function firstDispatch(dispatch) {
    dispatch(categoryPromoBannerActions.categoryPromoBannerLoading({}, store));
    return _category_promo_banner2.default.fetch(params, store, isTag).then(function handlePostDetailData(resp) {
      dispatch(categoryPromoBannerActions.categoryPromoBannerLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(categoryPromoBannerActions.categoryPromoBannerLoadError(err, store));
      _logger_service2.default.error(err, 'Error in categoryPromoBanner actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryPromoBannerLoading = categoryPromoBannerLoading;
exports.categoryPromoBannerLoaded = categoryPromoBannerLoaded;
exports.categoryPromoBannerLoadError = categoryPromoBannerLoadError;
// import { canUseDOM } from 'exenv';

function categoryPromoBannerLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PROMO_BANNER_LOADING',
    categoryPromoBanner: resp,
    store: store
  };
}

function categoryPromoBannerLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PROMO_BANNER_LOADED',
    categoryPromoBanner: resp.categoryPromoBanner,
    store: store
  };
}

function categoryPromoBannerLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_PROMO_BANNER_ERROR',
    categoryPromoBanner: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryPromoBanner = function (_Base) {
  _inherits(CategoryPromoBanner, _Base);

  function CategoryPromoBanner() {
    _classCallCheck(this, CategoryPromoBanner);

    return _possibleConstructorReturn(this, (CategoryPromoBanner.__proto__ || Object.getPrototypeOf(CategoryPromoBanner)).apply(this, arguments));
  }

  _createClass(CategoryPromoBanner, null, [{
    key: 'fetch',
    value: function fetch(_ref, store, isTag) {
      var category = _ref.category,
          tag = _ref.tag;

      var state = store.getState();
      var tagStr = isTag ? '?tag=' + tag : '';
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/category-promo-banner/' + site + '/' + category + tagStr;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryPromoBanner;
}(_base_model2.default);

exports.default = CategoryPromoBanner;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategoryFeaturedFeed;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _category_featured_feed_action_creators = __webpack_require__(557);

var categoryTagFeaturedActions = _interopRequireWildcard(_category_featured_feed_action_creators);

var _category_featured_feed = __webpack_require__(558);

var _category_featured_feed2 = _interopRequireDefault(_category_featured_feed);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCategoryFeaturedFeed(params, store, isTag) {
  return function dispatchCategoryFeaturedFeed(dispatch) {
    dispatch(categoryTagFeaturedActions.categoryFeaturedFeedLoading());
    return _category_featured_feed2.default.fetch(params, store, isTag).then(function categoryFeaturedFeedData(resp) {
      dispatch(categoryTagFeaturedActions.categoryFeaturedFeedLoaded(resp.data, store));
    }).catch(function categoryFeaturedFeedError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(categoryTagFeaturedActions.categoryFeaturedFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category featured feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryFeaturedFeedLoading = categoryFeaturedFeedLoading;
exports.categoryFeaturedFeedLoaded = categoryFeaturedFeedLoaded;
exports.categoryFeaturedFeedLoadError = categoryFeaturedFeedLoadError;
// import { canUseDOM } from 'exenv';

function categoryFeaturedFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_FEATURED_FEED_LOADING',
    categoryFeaturedFeed: resp,
    store: store
  };
}

function categoryFeaturedFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CATEGORY_FEATURED_FEED_LOADED',
    categoryFeaturedFeed: {
      featured: resp.featured,
      top: resp.top,
      category: resp.category,
      source: resp.source
    },
    store: store
  };
}

function categoryFeaturedFeedLoadError(error, store) {
  return {
    type: 'CATEGORY_FEATURED_FEED_ERROR',
    categoryFeaturedFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryFeatured = function (_Base) {
  _inherits(CategoryFeatured, _Base);

  function CategoryFeatured() {
    _classCallCheck(this, CategoryFeatured);

    return _possibleConstructorReturn(this, (CategoryFeatured.__proto__ || Object.getPrototypeOf(CategoryFeatured)).apply(this, arguments));
  }

  _createClass(CategoryFeatured, null, [{
    key: 'fetch',
    value: function fetch(_ref, store, isTag) {
      var category = _ref.category,
          tag = _ref.tag;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var tagStr = isTag ? '?tag=' + tag : '';
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/category-featured-feed/' + site + '/' + category + tagStr;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;
      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryFeatured;
}(_base_model2.default);

exports.default = CategoryFeatured;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/category/:category/:page',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store)
  };
};

var _category_page = __webpack_require__(145);

var _category_page2 = _interopRequireDefault(_category_page);

var _category_page_state_manager = __webpack_require__(67);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/news',
    component: _news_page2.default,
    strict: true,
    exact: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'news')
  };
};

var _news_page = __webpack_require__(236);

var _news_page2 = _interopRequireDefault(_news_page);

var _category_page_state_manager = __webpack_require__(67);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(65);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCreateFragment = __webpack_require__(562);

var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);

var _PageView = __webpack_require__(564);

var _PageView2 = _interopRequireDefault(_PageView);

var _BreakView = __webpack_require__(565);

var _BreakView2 = _interopRequireDefault(_BreakView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationBoxView = function (_Component) {
  _inherits(PaginationBoxView, _Component);

  function PaginationBoxView(props) {
    _classCallCheck(this, PaginationBoxView);

    var _this = _possibleConstructorReturn(this, (PaginationBoxView.__proto__ || Object.getPrototypeOf(PaginationBoxView)).call(this, props));

    _this.handlePreviousPage = function (evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (_this.state.selected > 0) {
        _this.handlePageSelected(_this.state.selected - 1, evt);
      }
    };

    _this.handleNextPage = function (evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (_this.state.selected < _this.props.pageCount - 1) {
        _this.handlePageSelected(_this.state.selected + 1, evt);
      }
    };

    _this.handlePageSelected = function (selected, evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      if (_this.state.selected === selected) return;

      _this.setState({ selected: selected });

      // Call the callback with the new selected item:
      _this.callCallback(selected);
    };

    _this.callCallback = function (selectedItem) {
      if (typeof _this.props.onPageChange !== "undefined" && typeof _this.props.onPageChange === "function") {
        _this.props.onPageChange({ selected: selectedItem });
      }
    };

    _this.pagination = function () {
      var items = {};

      if (_this.props.pageCount <= _this.props.pageRangeDisplayed) {

        for (var index = 0; index < _this.props.pageCount; index++) {
          items['key' + index] = _this.getPageElement(index);
        }
      } else {

        var leftSide = _this.props.pageRangeDisplayed / 2;
        var rightSide = _this.props.pageRangeDisplayed - leftSide;

        if (_this.state.selected > _this.props.pageCount - _this.props.pageRangeDisplayed / 2) {
          rightSide = _this.props.pageCount - _this.state.selected;
          leftSide = _this.props.pageRangeDisplayed - rightSide;
        } else if (_this.state.selected < _this.props.pageRangeDisplayed / 2) {
          leftSide = _this.state.selected;
          rightSide = _this.props.pageRangeDisplayed - leftSide;
        }

        var _index = void 0;
        var page = void 0;
        var breakView = void 0;
        var createPageView = function createPageView(index) {
          return _this.getPageElement(index);
        };

        for (_index = 0; _index < _this.props.pageCount; _index++) {

          page = _index + 1;

          if (page <= _this.props.marginPagesDisplayed) {
            items['key' + _index] = createPageView(_index);
            continue;
          }

          if (page > _this.props.pageCount - _this.props.marginPagesDisplayed) {
            items['key' + _index] = createPageView(_index);
            continue;
          }

          if (_index >= _this.state.selected - leftSide && _index <= _this.state.selected + rightSide) {
            items['key' + _index] = createPageView(_index);
            continue;
          }

          var keys = Object.keys(items);
          var breakLabelKey = keys[keys.length - 1];
          var breakLabelValue = items[breakLabelKey];

          if (_this.props.breakLabel && breakLabelValue !== breakView) {
            breakView = _react2.default.createElement(_BreakView2.default, {
              breakLabel: _this.props.breakLabel,
              breakClassName: _this.props.breakClassName
            });

            items['key' + _index] = breakView;
          }
        }
      }

      return items;
    };

    _this.state = {
      selected: props.initialPage ? props.initialPage : props.forcePage ? props.forcePage : 0
    };
    return _this;
  }

  _createClass(PaginationBoxView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Call the callback with the initialPage item:
      if (typeof this.props.initialPage !== 'undefined' && !this.props.disableInitialCallback) {
        this.callCallback(this.props.initialPage);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.forcePage !== 'undefined' && this.props.forcePage !== nextProps.forcePage) {
        this.setState({ selected: nextProps.forcePage });
      }
    }
  }, {
    key: 'hrefBuilder',
    value: function hrefBuilder(pageIndex) {
      if (this.props.hrefBuilder && pageIndex !== this.state.selected && pageIndex >= 0 && pageIndex < this.props.pageCount) {
        return this.props.hrefBuilder(pageIndex + 1);
      }
    }
  }, {
    key: 'getPageElement',
    value: function getPageElement(index) {
      return _react2.default.createElement(_PageView2.default, {
        onClick: this.handlePageSelected.bind(null, index),
        selected: this.state.selected === index,
        pageClassName: this.props.pageClassName,
        pageLinkClassName: this.props.pageLinkClassName,
        activeClassName: this.props.activeClassName,
        extraAriaContext: this.props.extraAriaContext,
        href: this.hrefBuilder(index),
        page: index + 1 });
    }
  }, {
    key: 'render',
    value: function render() {
      var disabled = this.props.disabledClassName;

      var previousClasses = (0, _classnames2.default)(this.props.previousClassName, _defineProperty({}, disabled, this.state.selected === 0));

      var nextClasses = (0, _classnames2.default)(this.props.nextClassName, _defineProperty({}, disabled, this.state.selected === this.props.pageCount - 1));

      return _react2.default.createElement(
        'ul',
        { className: this.props.containerClassName },
        _react2.default.createElement(
          'li',
          { className: previousClasses },
          _react2.default.createElement(
            'a',
            { onClick: this.handlePreviousPage,
              className: this.props.previousLinkClassName,
              href: this.hrefBuilder(this.state.selected - 1),
              tabIndex: '0',
              onKeyPress: this.handlePreviousPage },
            this.props.previousLabel
          )
        ),
        (0, _reactAddonsCreateFragment2.default)(this.pagination()),
        _react2.default.createElement(
          'li',
          { className: nextClasses },
          _react2.default.createElement(
            'a',
            { onClick: this.handleNextPage,
              className: this.props.nextLinkClassName,
              href: this.hrefBuilder(this.state.selected + 1),
              tabIndex: '0',
              onKeyPress: this.handleNextPage },
            this.props.nextLabel
          )
        )
      );
    }
  }]);

  return PaginationBoxView;
}(_react.Component);

PaginationBoxView.propTypes = {
  pageCount: _propTypes2.default.number.isRequired,
  pageRangeDisplayed: _propTypes2.default.number.isRequired,
  marginPagesDisplayed: _propTypes2.default.number.isRequired,
  previousLabel: _propTypes2.default.node,
  nextLabel: _propTypes2.default.node,
  breakLabel: _propTypes2.default.node,
  hrefBuilder: _propTypes2.default.func,
  onPageChange: _propTypes2.default.func,
  initialPage: _propTypes2.default.number,
  forcePage: _propTypes2.default.number,
  disableInitialCallback: _propTypes2.default.bool,
  containerClassName: _propTypes2.default.string,
  pageClassName: _propTypes2.default.string,
  pageLinkClassName: _propTypes2.default.string,
  activeClassName: _propTypes2.default.string,
  previousClassName: _propTypes2.default.string,
  nextClassName: _propTypes2.default.string,
  previousLinkClassName: _propTypes2.default.string,
  nextLinkClassName: _propTypes2.default.string,
  disabledClassName: _propTypes2.default.string,
  breakClassName: _propTypes2.default.string
};
PaginationBoxView.defaultProps = {
  pageCount: 10,
  pageRangeDisplayed: 2,
  marginPagesDisplayed: 3,
  activeClassName: "selected",
  previousClassName: "previous",
  nextClassName: "next",
  previousLabel: "Previous",
  nextLabel: "Next",
  breakLabel: "...",
  disabledClassName: "disabled",
  disableInitialCallback: false
};
exports.default = PaginationBoxView;
;
//# sourceMappingURL=PaginationBoxView.js.map

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var React = __webpack_require__(2);

var REACT_ELEMENT_TYPE =
  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
  0xeac7;

var emptyFunction = __webpack_require__(56);
var invariant = __webpack_require__(110);
var warning = __webpack_require__(563);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

var didWarnAboutMaps = false;

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

function getIteratorFn(maybeIterable) {
  var iteratorFn =
    maybeIterable &&
    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
      maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function(match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

function traverseAllChildrenImpl(
  children,
  nameSoFar,
  callback,
  traverseContext
) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (
    children === null ||
    type === 'string' ||
    type === 'number' ||
    // The following is inlined from ReactElement. This means we can optimize
    // some checks. React Fiber also inlines this logic for similar purposes.
    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
  ) {
    callback(
      traverseContext,
      children,
      // If it's the only child, treat the name as if it was wrapped in an array
      // so that it's consistent if the number of children grows.
      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
    );
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(
        child,
        nextName,
        callback,
        traverseContext
      );
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      if (false) {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          warning(
            didWarnAboutMaps,
            'Using Maps as children is unsupported and will likely yield ' +
              'unexpected results. Convert it to a sequence/iterable of keyed ' +
              'ReactElements instead.'
          );
          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step;
      var ii = 0;
      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(
          child,
          nextName,
          callback,
          traverseContext
        );
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum =
          ' If you meant to render a collection of children, use an array ' +
          'instead or wrap the object using createFragment(object) from the ' +
          'React add-ons.';
      }
      var childrenString = '' + children;
      invariant(
        false,
        'Objects are not valid as a React child (found: %s).%s',
        childrenString === '[object Object]'
          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
          : childrenString,
        addendum
      );
    }
  }

  return subtreeCount;
}

function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

function cloneAndReplaceKey(oldElement, newKey) {
  return React.cloneElement(
    oldElement,
    {key: newKey},
    oldElement.props !== undefined ? oldElement.props.children : undefined
  );
}

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

var oneArgumentPooler = function(copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  invariant(
    instance instanceof Klass,
    'Trying to release an instance into a pool of a different type.'
  );
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function() {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(
      mappedChild,
      result,
      childKey,
      emptyFunction.thatReturnsArgument
    );
  } else if (mappedChild != null) {
    if (React.isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(
        mappedChild,
        // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        keyPrefix +
          (mappedChild.key && (!child || child.key !== mappedChild.key)
            ? escapeUserProvidedKey(mappedChild.key) + '/'
            : '') +
          childKey
      );
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(
    array,
    escapedPrefix,
    func,
    context
  );
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

var numericPropertyRegex = /^\d+$/;

var warnedAboutNumeric = false;

function createReactFragment(object) {
  if (typeof object !== 'object' || !object || Array.isArray(object)) {
    warning(
      false,
      'React.addons.createFragment only accepts a single object. Got: %s',
      object
    );
    return object;
  }
  if (React.isValidElement(object)) {
    warning(
      false,
      'React.addons.createFragment does not accept a ReactElement ' +
        'without a wrapper object.'
    );
    return object;
  }

  invariant(
    object.nodeType !== 1,
    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
      'elements are not valid children of React components.'
  );

  var result = [];

  for (var key in object) {
    if (false) {
      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
        warning(
          false,
          'React.addons.createFragment(...): Child objects should have ' +
            'non-numeric keys so ordering is preserved.'
        );
        warnedAboutNumeric = true;
      }
    }
    mapIntoWithKeyPrefixInternal(
      object[key],
      result,
      key,
      emptyFunction.thatReturnsArgument
    );
  }

  return result;
}

module.exports = createReactFragment;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(56);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageView = function PageView(props) {
  var cssClassName = props.pageClassName;
  var linkClassName = props.pageLinkClassName;
  var onClick = props.onClick;
  var href = props.href;
  var ariaLabel = 'Page ' + props.page + (props.extraAriaContext ? ' ' + props.extraAriaContext : '');
  var ariaCurrent = null;

  if (props.selected) {
    ariaCurrent = 'page';
    ariaLabel = 'Page ' + props.page + ' is your current page';
    if (typeof cssClassName !== 'undefined') {
      cssClassName = cssClassName + ' ' + props.activeClassName;
    } else {
      cssClassName = props.activeClassName;
    }
  }

  return _react2.default.createElement(
    'li',
    { className: cssClassName },
    _react2.default.createElement(
      'a',
      { onClick: onClick,
        className: linkClassName,
        href: href,
        tabIndex: '0',
        'aria-label': ariaLabel,
        'aria-current': ariaCurrent,
        onKeyPress: onClick },
      props.page
    )
  );
};

exports.default = PageView;
//# sourceMappingURL=PageView.js.map

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreakView = function BreakView(props) {
  var label = props.breakLabel;
  var className = props.breakClassName || 'break';

  return _react2.default.createElement(
    'li',
    { className: className },
    label
  );
};

exports.default = BreakView;
//# sourceMappingURL=BreakView.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(567),
    getMatchData = __webpack_require__(572),
    matchesStrictComparable = __webpack_require__(242);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(123),
    baseIsEqual = __webpack_require__(239);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(123),
    equalArrays = __webpack_require__(240),
    equalByTag = __webpack_require__(570),
    equalObjects = __webpack_require__(571),
    getTag = __webpack_require__(127),
    isArray = __webpack_require__(29),
    isBuffer = __webpack_require__(96),
    isTypedArray = __webpack_require__(121);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    Uint8Array = __webpack_require__(186),
    eq = __webpack_require__(88),
    equalArrays = __webpack_require__(240),
    mapToArray = __webpack_require__(188),
    setToArray = __webpack_require__(97);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(182);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(241),
    keys = __webpack_require__(50);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(239),
    get = __webpack_require__(0),
    hasIn = __webpack_require__(574),
    isKey = __webpack_require__(112),
    isStrictComparable = __webpack_require__(241),
    matchesStrictComparable = __webpack_require__(242),
    toKey = __webpack_require__(60);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(575),
    hasPath = __webpack_require__(576);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(70),
    isArguments = __webpack_require__(95),
    isArray = __webpack_require__(29),
    isIndex = __webpack_require__(72),
    isLength = __webpack_require__(119),
    toKey = __webpack_require__(60);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(578),
    basePropertyDeep = __webpack_require__(579),
    isKey = __webpack_require__(112),
    toKey = __webpack_require__(60);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(111);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(99);

var _forEach2 = _interopRequireDefault(_forEach);

var _header = __webpack_require__(581);

var _header2 = _interopRequireDefault(_header);

var _by_line = __webpack_require__(603);

var _by_line2 = _interopRequireDefault(_by_line);

var _article = __webpack_require__(604);

var _article2 = _interopRequireDefault(_article);

var _footer = __webpack_require__(605);

var _footer2 = _interopRequireDefault(_footer);

var _social = __webpack_require__(52);

var _social2 = _interopRequireDefault(_social);

var _live = __webpack_require__(610);

var _live2 = _interopRequireDefault(_live);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = function (_Component) {
  _inherits(Body, _Component);

  function Body() {
    _classCallCheck(this, Body);

    return _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).apply(this, arguments));
  }

  _createClass(Body, [{
    key: 'getByLineAttribution',
    value: function getByLineAttribution(tags) {
      var bylineAttribution = '';

      (0, _forEach2.default)(tags, function (tag) {
        if (tag.name.indexOf('byline_') !== -1 || tag.slug.indexOf('byline-') !== -1) {
          bylineAttribution = tag.name.replace('byline_', '');
        }
      });

      return bylineAttribution;
    }
  }, {
    key: 'renderKiaAdWords',
    value: function renderKiaAdWords() {
      var post = this.props.post;
      var tags = post.tags;

      var isKia = tags.filter(function (tag) {
        return tag.slug === 'kia_niro';
      }).length;

      // TODO: refactor to use scriptjs and fire js
      if (isKia) {
        return _react2.default.createElement('div', {
          dangerouslySetInnerHTML: {
            __html: '<script type="text/javascript">/* <![CDATA[ */ var google_conversion_id = 972240864; var google_custom_params = window.google_tag_params; var google_remarketing_only = true; /* ]]> */</script><script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></script><noscript><div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/972240864/?guid=ON&amp;script=0"/></div></noscript>'
          }
        });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          post = _props.post,
          advertorial = _props.advertorial,
          isFirstPost = _props.isFirstPost,
          combinedAdModel = _props.combinedAdModel,
          videoAdData = _props.videoAdData,
          config = _props.config,
          pageNum = _props.pageNum,
          isLongPost = _props.isLongPost,
          isVideoPost = _props.isVideoPost,
          hasNewsletter = _props.hasNewsletter,
          related = _props.related,
          live = _props.live;
      var tags = post.tags,
          article = post.content;

      var emptyContent = !article.length;
      var bylineAttribution = this.getByLineAttribution(tags);
      var postFiniteLive = !isFirstPost && (0, _get2.default)(post, 'tags', []).filter(function (tag) {
        return tag.name.indexOf('live:') > -1;
      }).length === 1;
      var hasLivePosts = (0, _get2.default)(post, 'live.posts.length', 0);

      return _react2.default.createElement(
        'div',
        { className: 'post__body', 'data-id': post.id, 'data-slug': post.slug },
        _react2.default.createElement(_header2.default, {
          tags: tags,
          advertorial: advertorial,
          post: post,
          combinedAdModel: combinedAdModel,
          isFirstPost: isFirstPost,
          isLongPost: isLongPost,
          isVideoPost: isVideoPost,
          related: related,
          videoAdData: videoAdData,
          live: live || postFiniteLive,
          config: config
        }),
        isVideoPost ? _react2.default.createElement(_social2.default, {
          enableSticky: this.props.isDesktop && isLongPost,
          empty: emptyContent,
          text: encodeURIComponent((0, _get2.default)(post, 'title') || ''),
          uri: post.link,
          modifier: 'post-video',
          bottomBoundary: '#social--' + post.id,
          encapsulateId: 'social--' + post.id
        }) : _react2.default.createElement(
          'div',
          { className: 'post__container post__container--' + post.layout },
          _react2.default.createElement(_social2.default, {
            enableSticky: this.props.isDesktop && isLongPost,
            empty: emptyContent,
            text: encodeURIComponent((0, _get2.default)(post, 'title') || ''),
            uri: post.link,
            modifier: 'post',
            bottomBoundary: '#social--' + post.id,
            encapsulateId: 'social--' + post.id
          }),
          _react2.default.createElement(
            'div',
            { className: 'post__content' },
            isLongPost ? _react2.default.createElement(_by_line2.default, { post: post, bylineAttribution: bylineAttribution }) : null,
            _react2.default.createElement(_article2.default, {
              post: post,
              combinedAdModel: combinedAdModel,
              pageNum: pageNum,
              isShortPost: !isLongPost
            }),
            postFiniteLive ? _react2.default.createElement(
              'a',
              {
                className: 'post__live-link',
                href: '/' + post.id + '/' + post.slug
              },
              'Follow Our Live Coverage'
            ) : null,
            !live && !hasLivePosts ? _react2.default.createElement(_footer2.default, {
              post: post,
              bylineAttribution: bylineAttribution,
              isLongPost: isLongPost,
              hasNewsletter: hasNewsletter,
              config: config
            }) : null,
            isFirstPost && live || hasLivePosts ? _react2.default.createElement(_live2.default, { parentPost: post, live: post.live, config: config }) : null,
            this.renderKiaAdWords()
          )
        )
      );
    }
  }]);

  return Body;
}(_react.Component);

exports.default = Body;


Body.defaultProps = {
  isDesktop: false,
  hasNewsletter: false,
  related: []
};

Body.propTypes = {
  post: _propTypes2.default.shape({}).isRequired,
  advertorial: _propTypes2.default.bool.isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  videoAdData: _propTypes2.default.shape({}).isRequired,
  isDesktop: _propTypes2.default.bool,
  pageNum: _propTypes2.default.number.isRequired,
  isLongPost: _propTypes2.default.bool.isRequired,
  hasNewsletter: _propTypes2.default.bool,
  isVideoPost: _propTypes2.default.bool.isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  live: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _media = __webpack_require__(582);

var _media2 = _interopRequireDefault(_media);

var _title = __webpack_require__(602);

var _title2 = _interopRequireDefault(_title);

var _advertorial = __webpack_require__(28);

var _advertorial2 = _interopRequireDefault(_advertorial);

var _related_slider = __webpack_require__(248);

var _related_slider2 = _interopRequireDefault(_related_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          advertorial = _props.advertorial,
          tags = _props.tags,
          post = _props.post,
          combinedAdModel = _props.combinedAdModel,
          isLongPost = _props.isLongPost,
          isVideoPost = _props.isVideoPost,
          videoAdData = _props.videoAdData,
          isFirstPost = _props.isFirstPost,
          related = _props.related,
          live = _props.live;


      return _react2.default.createElement(
        'header',
        { className: 'post__header' },
        advertorial ? _react2.default.createElement(_advertorial2.default, { tags: tags, adModel: combinedAdModel }) : '',
        _react2.default.createElement(
          'div',
          { className: 'post__header-text' },
          _react2.default.createElement(_title2.default, {
            config: config,
            isVideoPost: isVideoPost,
            isFirstPost: isFirstPost,
            location: 'beforevideo',
            post: post,
            tags: tags,
            live: live
          }),
          isLongPost && !isVideoPost ? _react2.default.createElement('h2', {
            className: 'post__deck',
            dangerouslySetInnerHTML: { __html: post.excerpt }
          }) : ''
        ),
        _react2.default.createElement(_media2.default, {
          post: post,
          videoAdData: videoAdData,
          isVideoPost: isVideoPost,
          isFirstPost: isFirstPost
        }),
        isVideoPost ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_title2.default, {
            config: config,
            isVideoPost: isVideoPost,
            isFirstPost: isFirstPost,
            location: 'aftervideo',
            post: post,
            tags: tags,
            live: live
          }),
          _react2.default.createElement('div', {
            className: 'post__article',
            dangerouslySetInnerHTML: { __html: post.excerpt }
          }),
          _react2.default.createElement(_related_slider2.default, {
            title: 'Featured Videos',
            related: related,
            config: config,
            slideClassNames: ['video-slide--horizontal']
          })
        ) : ''
      );
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;

Header.defaultProps = {
  related: []
};

Header.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  advertorial: _propTypes2.default.bool.isRequired,
  post: _propTypes2.default.shape({}).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired,
  isLongPost: _propTypes2.default.bool.isRequired,
  videoAdData: _propTypes2.default.shape({}).isRequired,
  isVideoPost: _propTypes2.default.bool.isRequired,
  related: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  live: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Media;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _reactJwPlayer = __webpack_require__(243);

var _reactJwPlayer2 = _interopRequireDefault(_reactJwPlayer);

var _fc_slider = __webpack_require__(244);

var _fc_slider2 = _interopRequireDefault(_fc_slider);

var _poster = __webpack_require__(62);

var _poster2 = _interopRequireDefault(_poster);

var _cloudinary_asset_util = __webpack_require__(30);

var _video_module_ads = __webpack_require__(140);

var _video_module_ads2 = _interopRequireDefault(_video_module_ads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generatePreRoll(video) {
  return new _video_module_ads2.default(video.title, 'article').adTag;
}

function Media(props) {
  var post = props.post,
      isVideoPost = props.isVideoPost,
      isFirstPost = props.isFirstPost;
  var featured_image = post.featured_image,
      posterSlideshow = post.posterSlideshow,
      posterVideo = post.posterVideo,
      posterIframe = post.posterIframe,
      title = post.title;


  if (!(0, _isEmpty2.default)(posterSlideshow)) {
    return _react2.default.createElement(_fc_slider2.default, { slideShowData: posterSlideshow, title: title });
  }

  if (!(0, _isEmpty2.default)(posterVideo)) {
    var feed = (0, _get2.default)(posterVideo, 'feedId', '');
    var isAutoPlay = Boolean(isFirstPost);
    var playInView = Boolean(!isFirstPost);
    var isMuted = Boolean(!isFirstPost);
    return _react2.default.createElement(
      'div',
      { className: 'poster-video-wrapper poster-video-wrapper--video-permalink' },
      _react2.default.createElement(_reactJwPlayer2.default, {
        playerId: (0, _get2.default)(post, 'playerScriptId'),
        playerScript: 'https://content.jwplatform.com/libraries/' + (0, _get2.default)(post, 'playerScriptId') + '.js',
        playlist: 'https://fc-api.fastcompany.com/api/v1/jw-feed/' + feed,
        generatePrerollUrl: generatePreRoll,
        isAutoPlay: isAutoPlay,
        playInView: playInView,
        isMuted: isMuted,
        playInViewPercentage: 10,
        aspectRatio: '16:9',
        className: 'jwplayer--video-post'
      })
    );
  }

  if (!(0, _isEmpty2.default)(posterIframe)) {
    var source = (0, _get2.default)(posterIframe, 'url');
    /* eslint-disable jsx-a11y/iframe-has-title */
    return _react2.default.createElement(
      'div',
      { className: 'poster-video-wrapper' },
      _react2.default.createElement('iframe', { className: 'poster-video-wrapper__video', src: source })
    );
  }
  if (isVideoPost) {
    var _isAutoPlay = Boolean(!isFirstPost);
    var _playInView = Boolean(isFirstPost);
    return _react2.default.createElement(
      'div',
      { className: 'poster-video-wrapper poster-video-wrapper--video-permalink' },
      _react2.default.createElement(_reactJwPlayer2.default, {
        playerId: (0, _get2.default)(post, 'mediaid'),
        playerScript: 'https://content.jwplatform.com/libraries/QV73eWiB.js',
        playlist: 'https://fc-api.fastcompany.com/api/v1/jw-feed/' + (0, _get2.default)(post, 'mediaid'),
        generatePrerollUrl: generatePreRoll,
        isAutoPlay: _isAutoPlay,
        playInView: _playInView,
        playInViewPercentage: 10,
        aspectRatio: '16:9',
        className: 'jwplayer--video-post'
      })
    );
  }
  var posterSrc = (0, _get2.default)(featured_image, 'source', '');
  var posterCaption = (0, _get2.default)(featured_image, 'caption', '');
  var metadata = {
    title: title,
    featured_image: { source: posterSrc },
    assetSizes: (0, _get2.default)(_cloudinary_asset_util.imageSizesLookup, 'poster'),
    noLazy: true
  };

  if (!posterSrc) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    {
      className: 'post__poster-wrapper post__poster-wrapper--' + post.layout
    },
    _react2.default.createElement(_poster2.default, {
      metadata: metadata,
      className: 'post-featured',
      isVideo: post.hasPosterVideo
    }),
    posterCaption ? _react2.default.createElement('div', {
      className: 'post__featured-caption',
      dangerouslySetInnerHTML: { __html: posterCaption }
    }) : _react2.default.createElement('div', { className: 'post__featured-caption--no-caption' })
  );
}

Media.propTypes = {
  post: _propTypes2.default.shape({}).isRequired,
  isVideoPost: _propTypes2.default.bool.isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _onAdPlay = __webpack_require__(584);

var _onAdPlay2 = _interopRequireDefault(_onAdPlay);

var _onBeforePlay = __webpack_require__(585);

var _onBeforePlay2 = _interopRequireDefault(_onBeforePlay);

var _onFullScreen = __webpack_require__(586);

var _onFullScreen2 = _interopRequireDefault(_onFullScreen);

var _onMute = __webpack_require__(587);

var _onMute2 = _interopRequireDefault(_onMute);

var _onPlay = __webpack_require__(588);

var _onPlay2 = _interopRequireDefault(_onPlay);

var _onTime = __webpack_require__(589);

var _onTime2 = _interopRequireDefault(_onTime);

var _onVideoLoad = __webpack_require__(590);

var _onVideoLoad2 = _interopRequireDefault(_onVideoLoad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createEventHandlers(component) {
  return {
    onAdPlay: _onAdPlay2.default.bind(component),
    onBeforePlay: _onBeforePlay2.default.bind(component),
    onFullScreen: _onFullScreen2.default.bind(component),
    onMute: _onMute2.default.bind(component),
    onPlay: _onPlay2.default.bind(component),
    onTime: _onTime2.default.bind(component),
    onVideoLoad: _onVideoLoad2.default.bind(component)
  };
}

exports.default = createEventHandlers;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function onAdPlay(event) {
  if (!this.state.adHasPlayed) {
    this.props.onAdPlay(event);
    this.setState({
      adHasPlayed: true
    });
  } else {
    this.props.onAdResume(event);
  }
}

exports.default = onAdPlay;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function onBeforePlay(event, player) {
  var currentVideo = player.getPlaylistItem();

  if (typeof this.props.generatePrerollUrl === 'function') {
    if (player.getState() === 'paused') {
      return false;
    }
    player.playAd(this.props.generatePrerollUrl(currentVideo));
  }
}

exports.default = onBeforePlay;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function onFullScreen(event) {
  if (event.fullscreen) {
    this.props.onEnterFullScreen(event);
  } else {
    this.props.onExitFullScreen(event);
  }
}

exports.default = onFullScreen;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function onMute(event) {
  if (event.mute) {
    this.props.onMute(event);
  } else {
    this.props.onUnmute(event);
  }
}

exports.default = onMute;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function onPlay(event) {
  if (event.playReason === 'autostart') {
    this.setState({
      hasPlayed: true
    });
    this.props.onAutoStart(event);
  } else if (this.state.hasPlayed && event.oldstate === 'paused') {
    this.props.onResume(event);
  } else {
    this.props.onPlay(event);
    this.setState({
      hasPlayed: true
    });
  }
}

exports.default = onPlay;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function onTime(event) {
  var hasFired = this.state.hasFired;
  var position = event.position,
      duration = event.duration;

  var hasChanged = false;

  if (!hasFired.threeSeconds && position > 3) {
    this.props.onThreeSeconds();
    hasFired.threeSeconds = true;
    hasChanged = true;
  }

  if (!hasFired.tenSeconds && position > 10) {
    this.props.onTenSeconds();
    hasFired.tenSeconds = true;
    hasChanged = true;
  }

  if (!hasFired.thirtySeconds && position > 30) {
    this.props.onThirtySeconds();
    hasFired.thirtySeconds = true;
    hasChanged = true;
  }

  if (!hasFired.twentyFivePercent && position / duration * 100 > 25) {
    this.props.onTwentyFivePercent();
    hasFired.twentyFivePercent = true;
    hasChanged = true;
  }

  if (!hasFired.fiftyPercent && position / duration * 100 > 50) {
    this.props.onFiftyPercent();
    hasFired.fiftyPercent = true;
    hasChanged = true;
  }

  if (!hasFired.seventyFivePercent && position / duration * 100 > 75) {
    this.props.onSeventyFivePercent();
    hasFired.seventyFivePercent = true;
    hasChanged = true;
  }

  if (!hasFired.ninetyFivePercent && position / duration * 100 > 95) {
    this.props.onNinetyFivePercent();
    hasFired.ninetyFivePercent = true;
    hasChanged = true;
  }

  if (hasChanged) {
    this.setState({
      hasFired: hasFired
    });
  }
}

exports.default = onTime;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function onVideoLoad(event) {
  this.setState({
    hasFired: {}
  });
  this.props.onVideoLoad(event);
}

exports.default = onVideoLoad;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getCurriedOnLoad(existingScript, callback) {
  var previousOnload = existingScript.onload || function () {};
  var curriedOnLoad = function curriedOnLoad() {
    previousOnload();
    callback();
  };

  return curriedOnLoad;
}

exports.default = getCurriedOnLoad;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function getPlayerOpts(opts) {
  var aspectRatio = opts.aspectRatio,
      _opts$customProps = opts.customProps,
      customProps = _opts$customProps === undefined ? {} : _opts$customProps,
      file = opts.file,
      generatePrerollUrl = opts.generatePrerollUrl,
      image = opts.image,
      isAutoPlay = opts.isAutoPlay,
      isMuted = opts.isMuted,
      licenseKey = opts.licenseKey,
      playlist = opts.playlist;


  var hasAdvertising = !!generatePrerollUrl;

  var playerOpts = {
    mute: !!isMuted
  };

  if (licenseKey) {
    playerOpts.key = licenseKey;
  }

  if (playlist) {
    playerOpts.playlist = playlist;
  } else if (file) {
    playerOpts.file = file;
  }

  if (aspectRatio && aspectRatio !== 'inherit') {
    playerOpts.aspectratio = aspectRatio;
  }

  if (hasAdvertising) {
    playerOpts.advertising = {
      client: 'googima',
      admessage: 'Ad — xxs left',
      autoplayadsmuted: true
    };
  }

  if (typeof isAutoPlay !== 'undefined') {
    playerOpts.autostart = !!isAutoPlay;
  }

  if (image) {
    playerOpts.image = image;
  }

  return _extends(playerOpts, customProps);
}

exports.default = getPlayerOpts;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function initialize(_ref) {
  var component = _ref.component,
      player = _ref.player,
      playerOpts = _ref.playerOpts;

  function _onBeforePlay(event) {
    component.eventHandlers.onBeforePlay(event, player);
  }

  player.setup(playerOpts);

  player.on('beforePlay', _onBeforePlay);
  player.on('ready', component.props.onReady);
  player.on('setupError', component.eventHandlers.onError);
  player.on('error', component.eventHandlers.onError);
  player.on('adPlay', component.eventHandlers.onAdPlay);
  player.on('adPause', component.props.onAdPause);
  player.on('fullscreen', component.eventHandlers.onFullScreen);
  player.on('pause', component.props.onPause);
  player.on('play', component.eventHandlers.onPlay);
  player.on('mute', component.eventHandlers.onMute);
  player.on('playlistItem', component.eventHandlers.onVideoLoad);
  player.on('time', component.eventHandlers.onTime);
  player.on('beforeComplete', component.props.onOneHundredPercent);
}

exports.default = initialize;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function installPlayerScript(_ref) {
  var context = _ref.context,
      onLoadCallback = _ref.onLoadCallback,
      scriptSrc = _ref.scriptSrc,
      uniqueScriptId = _ref.uniqueScriptId;

  var jwPlayerScript = context.createElement('script');
  jwPlayerScript.id = uniqueScriptId;
  jwPlayerScript.src = scriptSrc;
  jwPlayerScript.onload = onLoadCallback;

  context.head.appendChild(jwPlayerScript);
}

exports.default = installPlayerScript;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(596);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(player, _ref) {
    var _this = this;

    var percentage = _ref.percentage;

    _classCallCheck(this, _class);

    this.percentage = percentage || 10;
    this.player = player;
    this.wrapper = this.player.getContainer();
    this.throttledScrollListener = (0, _lodash2.default)(function () {
      _this.playerInView();
    }, 300);
    this.possiblyMuted = this.possiblyMuted.bind(this);
    this.wrapper.addEventListener('click', this.possiblyMuted);
  }

  _createClass(_class, [{
    key: 'possiblyMuted',
    value: function possiblyMuted(e) {
      this.possiblyMutedVal = true;
    }
  }, {
    key: 'playerPosition',
    value: function playerPosition(playerEl) {
      if (playerEl && playerEl.getBoundingClientRect) {
        var bodyRect = document.body.getBoundingClientRect();
        var playerRect = playerEl.getBoundingClientRect();
        return playerRect.top - bodyRect.top - this.scrollPosition().top;
      }
      return null;
    }
  }, {
    key: 'scrollPosition',
    value: function scrollPosition() {
      var doc = document.documentElement;
      return {
        left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
        top: (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
      };
    }
  }, {
    key: 'playerInView',
    value: function playerInView() {
      var percentagePlayerHeight = this.player.getHeight() / this.percentage;
      // need to call getContainer again to get correct size and position of client rect
      // otherwise this will always return 0, and will be treated as in view
      var difference = this.playerPosition(this.player.getContainer()) + percentagePlayerHeight;
      var adjust = window.innerHeight > percentagePlayerHeight * 5 ? window.innerHeight : 100;
      var inView = difference > percentagePlayerHeight * -6 && difference < adjust;
      var state = this.player.getState();

      if (state === 'buffering' && inView) {
        return false;
      }

      if (state === 'buffering' && !inView) {
        this.player.pause();
      }

      if (state === 'idle' && inView) {
        if (!this.possiblyMutedVal) {
          this.player.play();
        }
      }

      if (state === 'idle' && !inView) {
        return false;
      }

      if (state === 'playing' && !inView && !this.possiblyMutedVal) {
        this.player.pause(true);
      }

      if (state === 'playing' && inView) {
        return false;
      }

      if (state === 'paused' && inView) {
        if (!this.possiblyMutedVal) {
          this.player.pause(false);
        }
      }

      if (state === 'paused' && !inView) {
        return false;
      }

      return false;
    }
  }, {
    key: 'on',
    value: function on() {
      window.addEventListener('scroll', this.throttledScrollListener);
    }
  }, {
    key: 'off',
    value: function off() {
      window.removeEventListener('scroll', this.throttledScrollListener);
      this.wrapper.removeEventListener('click', this.possiblyMuted);
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var noOp = function noOp() {};

var defaultProps = {
  aspectRatio: 'inherit',
  file: '',
  isAutoPlay: false,
  isMuted: false,
  onAdPlay: noOp,
  onAdResume: noOp,
  onEnterFullScreen: noOp,
  onExitFullScreen: noOp,
  onMute: noOp,
  onUnmute: noOp,
  onAutoStart: noOp,
  onResume: noOp,
  onPlay: noOp,
  onClose: noOp,
  onReady: noOp,
  onError: noOp,
  onAdPause: noOp,
  onPause: noOp,
  onVideoLoad: noOp,
  onOneHundredPercent: noOp,
  onThreeSeconds: noOp,
  onTenSeconds: noOp,
  onThirtySeconds: noOp,
  onTwentyFivePercent: noOp,
  onFiftyPercent: noOp,
  onSeventyFivePercent: noOp,
  onNinetyFivePercent: noOp,
  playlist: ''
};

exports.default = defaultProps;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  aspectRatio: _propTypes2.default.oneOf(['inherit', '1:1', '16:9']),
  className: _propTypes2.default.string,
  customProps: _propTypes2.default.object,
  file: _propTypes2.default.string,
  generatePrerollUrl: _propTypes2.default.func,
  image: _propTypes2.default.string,
  isAutoPlay: _propTypes2.default.bool,
  isMuted: _propTypes2.default.bool,
  licenseKey: _propTypes2.default.string,
  onAdPause: _propTypes2.default.func,
  onAdPlay: _propTypes2.default.func,
  onAdResume: _propTypes2.default.func,
  onAutoStart: _propTypes2.default.func,
  onEnterFullScreen: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onExitFullScreen: _propTypes2.default.func,
  onFiftyPercent: _propTypes2.default.func,
  onMute: _propTypes2.default.func,
  onNinetyFivePercent: _propTypes2.default.func,
  onOneHundredPercent: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onReady: _propTypes2.default.func,
  onResume: _propTypes2.default.func,
  onSeventyFivePercent: _propTypes2.default.func,
  onTenSeconds: _propTypes2.default.func,
  onThirtySeconds: _propTypes2.default.func,
  onThreeSeconds: _propTypes2.default.func,
  onTwentyFivePercent: _propTypes2.default.func,
  onUnmute: _propTypes2.default.func,
  onVideoLoad: _propTypes2.default.func,
  playerId: _propTypes2.default.string.isRequired,
  playerScript: _propTypes2.default.string.isRequired,
  playlist: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array])
};

exports.default = propTypes;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trigger;
/**
 * Use this to trigger custom events in our client side app.
 * We use it to refresh the ad after a few clicks.
 *
 * @param {string} eventName - name for custom event
 * @param {object} [data={}}] data - custom data for the event
 * @param {node} [dispatcher=window] dispatcher - what dispatches the event
 * @return {boolean} returns true if triggered
 *
 * @example
 * trigger('FC_AD_REFRESH')
 * // true
 *
 * @external {Events} https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
 */
function trigger(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var dispatcher = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

  if (typeof eventName !== 'string') {
    return false;
  }

  var event = new CustomEvent(eventName, data);

  dispatcher.dispatchEvent(event);

  return true;
}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(116),
    baseIteratee = __webpack_require__(78),
    baseMap = __webpack_require__(601),
    isArray = __webpack_require__(29);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(199),
    isArrayLike = __webpack_require__(41);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Title;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _eyebrow = __webpack_require__(63);

var _eyebrow2 = _interopRequireDefault(_eyebrow);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Title(props) {
  var isVideoPost = props.isVideoPost,
      location = props.location,
      post = props.post,
      tags = props.tags,
      live = props.live,
      config = props.config,
      isFirstPost = props.isFirstPost;
  var title = post.title,
      id = post.id;

  var key = 'title-' + id;
  var renderPostTitle = function renderPostTitle() {
    var link = _react2.default.createElement(
      _fc_link2.default,
      {
        key: key,
        config: config,
        externalLink: !isFirstPost,
        to: post.link,
        title: title
      },
      title
    );

    if (isFirstPost) {
      return _react2.default.createElement(
        'h1',
        { key: key, className: 'post__title' },
        link
      );
    }

    return _react2.default.createElement(
      'h2',
      { key: key, className: 'post__title' },
      link
    );
  };

  if (isVideoPost && location === 'beforevideo' || !isVideoPost && location === 'aftervideo') {
    return null;
  }

  return [_react2.default.createElement(_eyebrow2.default, { key: 'eyebrow-' + id, post: post, tags: tags, live: live }), renderPostTitle()];
}

Title.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  isVideoPost: _propTypes2.default.bool.isRequired,
  isFirstPost: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.string.isRequired,
  post: _propTypes2.default.shape({}).isRequired,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  live: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ByLine = function (_Component) {
  _inherits(ByLine, _Component);

  function ByLine() {
    _classCallCheck(this, ByLine);

    return _possibleConstructorReturn(this, (ByLine.__proto__ || Object.getPrototypeOf(ByLine)).apply(this, arguments));
  }

  _createClass(ByLine, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'renderAuthorLink',
    value: function renderAuthorLink() {
      var _props = this.props,
          bylineAttribution = _props.bylineAttribution,
          post = _props.post;
      var author = post.author;


      if (bylineAttribution) {
        return _react2.default.createElement(
          'span',
          { className: 'post__by-link-no-underline' },
          'By ',
          bylineAttribution
        );
      }

      return _react2.default.createElement(
        _reactRouterDom.Link,
        { className: 'post__by-link', to: '/user/' + author.slug },
        'By ',
        author.name
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var readTime = this.props.post.readTime;

      return _react2.default.createElement(
        'div',
        { className: 'post__byline' },
        _react2.default.createElement(
          'cite',
          { className: 'post__by' },
          this.renderAuthorLink()
        ),
        _react2.default.createElement(
          'span',
          { className: 'post__readTime' },
          readTime,
          ' Read'
        )
      );
    }
  }]);

  return ByLine;
}(_react.Component);

exports.default = ByLine;


ByLine.propTypes = {
  post: _propTypes2.default.shape({
    tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
    author: _propTypes2.default.shape({}).isRequired,
    readTime: _propTypes2.default.string.isRequired
  }).isRequired,
  bylineAttribution: _propTypes2.default.string.isRequired
};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _cloneDeep = __webpack_require__(74);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _fc_slider = __webpack_require__(244);

var _fc_slider2 = _interopRequireDefault(_fc_slider);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Article = function (_Component) {
  _inherits(Article, _Component);

  function Article() {
    _classCallCheck(this, Article);

    var _this = _possibleConstructorReturn(this, (Article.__proto__ || Object.getPrototypeOf(Article)).call(this));

    _this.mobileAdIndex = 0;
    return _this;
  }

  _createClass(Article, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'setPostChunk',
    value: function setPostChunk(chunk, index) {
      var markup = chunk.join('');

      if (markup === 'INLINE_CAROUSEL') {
        return _react2.default.createElement(_fc_slider2.default, {
          slideShowData: this.inlineCarousels.shift(),
          location: 'post__inline'
        });
      }

      var _props = this.props,
          post = _props.post,
          isShortPost = _props.isShortPost;

      var totalChunkIndexes = post.content && post.content.length - 1;

      if (totalChunkIndexes === index && isShortPost) {
        var _post$author = post.author,
            slug = _post$author.slug,
            initials = _post$author.initials;

        var authorMarkup = '<a class="post__initials" href="/user/' + slug + '">' + initials + '</a>';
        var lastClosePpos = markup.lastIndexOf('</p>');
        var lastIframe = markup.substr(markup.length - 13) === '</iframe></p>';

        if (lastClosePpos + 4 === markup.length && !lastIframe) {
          markup = markup.substring(0, lastClosePpos) + authorMarkup + ' </p>';
        } else {
          markup += '<p>' + authorMarkup + '</p>';
        }
      }

      return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: markup } });
    }
  }, {
    key: 'setMobileAdName',
    value: function setMobileAdName(index) {
      var adName = void 0;
      var adMap = { 0: 'mobileparallax_1', 3: 'mobileparallax_2' };

      if (Object.prototype.hasOwnProperty.call(adMap, index)) {
        adName = adMap[index];
      } else {
        adName = 'mobilerectangle_' + (this.mobileAdIndex += 1);
      }

      return adName;
    }
  }, {
    key: 'notAroundCarousel',
    value: function notAroundCarousel(chunks, currentChunk, index) {
      var next = chunks[index + 1] || [];
      var nextZeroIndex = next[0];
      var carousel = 'INLINE_CAROUSEL';

      if (nextZeroIndex === carousel || currentChunk === carousel) {
        return false;
      }

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          post = _props2.post,
          pageNum = _props2.pageNum,
          combinedAdModel = _props2.combinedAdModel,
          isShortPost = _props2.isShortPost;


      var chunks = post.content;

      this.inlineCarousels = (0, _cloneDeep2.default)((0, _get2.default)(post, 'inlineCarousels')) || [];

      if (post.isVideoPermalink) {
        return _react2.default.createElement(
          'article',
          { className: 'post__article' },
          _react2.default.createElement(
            'p',
            null,
            post.excerpt
          )
        );
      }

      return _react2.default.createElement(
        'article',
        { className: 'post__article' },
        chunks.map(function (chunk, index) {
          return [_this2.setPostChunk(chunk, index), !isShortPost && index < chunks.length - 1 && _this2.notAroundCarousel(chunks, chunk[0], index) ? _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            pos: 'btf',
            pageNum: pageNum,
            name: _this2.setMobileAdName(index)
          })) : ''];
        })
      );
    }
  }]);

  return Article;
}(_react.Component);

exports.default = Article;


Article.propTypes = {
  post: _propTypes2.default.shape({}).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  pageNum: _propTypes2.default.number.isRequired,
  isShortPost: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _tag_category_util = __webpack_require__(606);

var _magazine_attribution = __webpack_require__(607);

var _magazine_attribution2 = _interopRequireDefault(_magazine_attribution);

var _author = __webpack_require__(608);

var _author2 = _interopRequireDefault(_author);

var _newsletterSignup = __webpack_require__(219);

var _newsletterSignup2 = _interopRequireDefault(_newsletterSignup);

var _personalized_recommendations = __webpack_require__(609);

var _personalized_recommendations2 = _interopRequireDefault(_personalized_recommendations);

var _feature_flags = __webpack_require__(75);

var _feature_flags2 = _interopRequireDefault(_feature_flags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'determineNewsletter',
    value: function determineNewsletter(categories, tags, currentSite) {
      if (!Array.isArray(categories)) return null;

      var categoryNewsletters = {
        leadership: '',
        technology: '',
        ideas: '',
        entertainment: '',
        news: ''
      };

      var cat = (0, _get2.default)(categories, '[0].slug', '');
      var primaryNewsletter = currentSite;

      if (categoryNewsletters.hasOwnProperty(cat)) {
        primaryNewsletter = cat;
      }

      if ((0, _tag_category_util.containsTag)(tags, 'work-smart')) {
        primaryNewsletter = 'work-smart';
      }

      if ((0, _tag_category_util.containsTag)(tags, 'ethonomics')) {
        primaryNewsletter = 'ethonomics';
      }

      if ((0, _tag_category_util.containsTag)(tags, 'well-to-do')) {
        primaryNewsletter = 'well-to-do';
      }

      return {
        primary: primaryNewsletter,
        newsletters: [{ list: primaryNewsletter, default: true }, { list: 'events', default: true }]
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          post = _props.post,
          isLongPost = _props.isLongPost,
          hasNewsletter = _props.hasNewsletter,
          bylineAttribution = _props.bylineAttribution,
          config = _props.config;
      var tags = post.tags,
          categories = post.categories,
          author = post.author,
          link = post.link;

      var isMagazine = (0, _tag_category_util.determineIfMagazine)(categories);
      var hasAuthor = isLongPost && !bylineAttribution;
      var hasPersonalizedRecommendations = _feature_flags2.default.postPersonalizedRecommendationsEnabled && !(0, _tag_category_util.containsTag)(tags, 'advertorial');

      if (!isMagazine && !hasAuthor && !hasNewsletter) {
        return null;
      }

      return _react2.default.createElement(
        'footer',
        { className: 'post__footer' },
        isMagazine ? _react2.default.createElement(_magazine_attribution2.default, {
          issueMonth: (0, _tag_category_util.determineMagazineIssueMonth)(tags),
          issueNumber: (0, _tag_category_util.determineMagazineIssueNumber)(tags),
          config: config
        }) : '',
        hasAuthor ? _react2.default.createElement(_author2.default, _extends({ modifier: 'post' }, author)) : '',
        hasPersonalizedRecommendations ? _react2.default.createElement(_personalized_recommendations2.default, {
          config: config,
          link: link,
          isAdvertorial: (0, _tag_category_util.containsTag)(tags, 'advertorial')
        }) : '',
        hasNewsletter ? _react2.default.createElement(_newsletterSignup2.default, _extends({
          modifier: 'post'
        }, this.determineNewsletter(categories, tags, (0, _get2.default)(config, 'site', '')))) : ''
      );
    }
  }]);

  return Footer;
}(_react.Component);

exports.default = Footer;


Footer.propTypes = {
  post: _propTypes2.default.shape({
    tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
    categories: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
    author: _propTypes2.default.shape({}).isRequired
  }).isRequired,
  config: _propTypes2.default.shape({}).isRequired,
  bylineAttribution: _propTypes2.default.string.isRequired,
  isLongPost: _propTypes2.default.bool.isRequired,
  hasNewsletter: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containsTag = containsTag;
exports.determineIfMagazine = determineIfMagazine;
exports.determineMagazineIssueNumber = determineMagazineIssueNumber;
exports.determineMagazineIssueMonth = determineMagazineIssueMonth;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _string_util = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function containsTag(arr, tag) {
  return arr.some(function (item) {
    var slug = (0, _get2.default)(item, 'slug', '');
    return slug === tag;
  });
}

function determineIfMagazine(categories) {
  return categories.some(function (category) {
    return category.slug === 'magazine';
  });
}

function hasProperty(obj, str) {
  return obj.hasOwnProperty(str);
}

function determineMagazineIssueNumber(tags) {
  if (!Array.isArray(tags)) {
    return null;
  }

  var regexp = /^issue[-_]\d{0,3}$/;

  var issue = (0, _get2.default)(tags.filter(function filterForIssueNum(tag) {
    var slug = (0, _get2.default)(tag, 'slug');
    return slug ? slug.match(regexp) : false;
  }), '[0].slug');

  return issue || '';
}

function determineMagazineIssueMonth(tags) {
  if (!Array.isArray(tags)) {
    return null;
  }

  var months = {
    january: '',
    february: '',
    march: '',
    april: '',
    may: '',
    june: '',
    july: '',
    august: '',
    september: '',
    october: '',
    november: '',
    december: ''
  };

  var regexp = /^((\w{3,9})[-_](\d{4})([-_](\w{3,9})[-_](\d{4}))*|((\w{3,9})[-_](\w{3,9})[-_](\d{4})))$/;

  var issue = '';

  for (var i = 0; i < tags.length; i += 1) {
    var currTag = tags[i];
    var currTagSlug = (0, _get2.default)(currTag, 'slug') || '';
    if (regexp.test(currTagSlug)) {
      var matchArr = currTagSlug.match(regexp);
      var testMonth = matchArr[2];
      var year = matchArr[3];
      var isDoubleIssueDiffYear = matchArr[5] && matchArr[6] && hasProperty(months, matchArr[5]);

      var dblIssYr = matchArr[10];
      var dblM1 = matchArr[8];
      var dblM2 = matchArr[9];
      var isDoubleIssueSameYear = dblM1 && dblM2 && dblIssYr;

      if (months.hasOwnProperty(testMonth)) {
        issue += (0, _string_util.capitalize)(testMonth) + ' ' + year;
      }

      if (isDoubleIssueDiffYear) {
        issue += '/' + (0, _string_util.capitalize)(matchArr[5]) + ' ' + matchArr[6];
      }

      if (isDoubleIssueSameYear && hasProperty(months, dblM1) && hasProperty(months, dblM2)) {
        issue += (0, _string_util.capitalize)(dblM1) + '/' + (0, _string_util.capitalize)(dblM2) + ' ' + dblIssYr;
      }
    }
  }

  return issue && typeof issue === 'string' ? issue : '';
}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MagazineAttribution;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MagazineAttribution(props) {
  var config = props.config,
      issueMonth = props.issueMonth,
      issueNumber = props.issueNumber;

  if (!issueMonth || !issueNumber || !(0, _get2.default)(config, 'site', '') || !(0, _get2.default)(config, 'env', '')) {
    return null;
  }

  var linkToIssue = 'https://www.fastcompany.com/magazine/' + issueNumber;

  return _react2.default.createElement(
    'aside',
    { className: 'magazine-attribution' },
    'A version of this article appeared in the',
    ' ',
    _react2.default.createElement(
      _fc_link2.default,
      { to: linkToIssue, config: config, title: issueMonth + ' issue' },
      issueMonth
    ),
    ' ',
    'issue of Fast Company magazine.'
  );
}

MagazineAttribution.defaultProps = {
  issueMonth: '',
  issueNumber: ''
};

MagazineAttribution.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  issueMonth: _propTypes2.default.string,
  issueNumber: _propTypes2.default.string
};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Author;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(32);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function truncateDesc(props) {
  var str = props.description || '';
  var string = (0, _striptags2.default)(str, ['a', 'b', 'em', 'i', 'u', 'strike', 'strong']);
  /* eslint-disable */
  var result = string.match(/(\S.+?[.!?])(?=\s+|$)/ig);
  /* eslint-enable */
  if (result) {
    var finalResult = result.slice(0, 2).join(' ');

    return finalResult;
  }
  return '';
}

function Author(props) {
  if (!props.description) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'author author--' + props.modifier },
    _react2.default.createElement(
      'h4',
      { className: 'author__title' },
      'About the author'
    ),
    _react2.default.createElement('p', { className: 'author__description', dangerouslySetInnerHTML: { __html: truncateDesc(props) } }),
    _react2.default.createElement(
      'p',
      { className: 'author__description' },
      ' ',
      _react2.default.createElement(
        _reactRouterDom.Link,
        { className: 'author__bio-page', to: '/user/' + props.slug },
        'More'
      )
    )
  );
}

Author.propTypes = {
  modifier: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string.isRequired
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(4);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _axios = __webpack_require__(53);

var _axios2 = _interopRequireDefault(_axios);

var _uniqBy = __webpack_require__(249);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

var _parsely = __webpack_require__(137);

var _ga = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PersonalizedRecommendations = function (_Component) {
  _inherits(PersonalizedRecommendations, _Component);

  function PersonalizedRecommendations() {
    _classCallCheck(this, PersonalizedRecommendations);

    var _this = _possibleConstructorReturn(this, (PersonalizedRecommendations.__proto__ || Object.getPrototypeOf(PersonalizedRecommendations)).call(this));

    _this.fetchRecommendations = _this.fetchRecommendations.bind(_this);
    _this.state = {
      personalizedRecommendations: []
    };
    return _this;
  }

  _createClass(PersonalizedRecommendations, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (_exenv.canUseDOM) {
        this.fetchRecommendations();
        // track a widget viewed event to better gauge ctr %
        (0, _ga.trackGAEvent)({
          eventCategory: 'related',
          eventAction: 'viewed',
          eventLabel: 'article-page'
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      // If we don't do this, this widget will render every time inf scroll happens
      return this.state.personalizedRecommendations.length === 0;
    }
  }, {
    key: 'fetchRecommendations',
    value: function fetchRecommendations() {
      var _this2 = this;

      var uuid = (0, _get2.default)(window, 'PARSELY.config.uuid');
      var _props = this.props,
          config = _props.config,
          link = _props.link;

      var site = (0, _get2.default)(config, 'site');

      // https://www.parse.ly/help/api/recommendations/#personalized
      _axios2.default.get('https://api.parsely.com/v2/related?apikey=' + site + '.com&url=' + link + '&uuid=' + uuid).then(function (res) {
        if (res) {
          _this2.setState({
            personalizedRecommendations: _this2.sanitizeRecommendations((0, _get2.default)(res, 'data.data'))
          });
        }
      });
    }
  }, {
    key: 'sanitizeRecommendations',
    value: function sanitizeRecommendations(recommendations) {
      // 1. Remove titles with Fast Company or Fastcodesign
      // 2. Remove any advertorial posts from non-advertorial posts
      // 3. Dedup any title
      var MAX_STORIES = 3;
      var isAdvertorial = this.props.isAdvertorial;

      var sanitizedRecommendations = (0, _uniqBy2.default)(recommendations, function (link) {
        var title = (0, _get2.default)(link, 'title', '');
        return title.toLowerCase();
      }).filter(function (link) {
        if (isAdvertorial) {
          return link.title !== 'Fast Company' && link.title !== 'Fastcodesign';
        }

        return link.title !== 'Fast Company' && link.title !== 'Fastcodesign' && link.section !== 'advertorial';
      });

      if (sanitizedRecommendations.length > MAX_STORIES) {
        return sanitizedRecommendations.slice(0, MAX_STORIES);
      }

      return sanitizedRecommendations;
    }
  }, {
    key: 'render',
    value: function render() {
      var personalizedRecommendations = this.state.personalizedRecommendations;
      var config = this.props.config;


      if (!personalizedRecommendations.length) {
        return '';
      }

      return _react2.default.createElement(
        'section',
        { className: 'post-personalized-recommendations' },
        _react2.default.createElement(
          'h3',
          { className: 'post-personalized-recommendations__header' },
          'You Might Also Like:'
        ),
        _react2.default.createElement(
          'ul',
          { className: 'post-personalized-recommendations__list' },
          this.sanitizeRecommendations(personalizedRecommendations).map(function (link, index) {
            return _react2.default.createElement(
              'li',
              {
                className: 'post-personalized-recommendations__item',
                key: index,
                onClick: function onClick() {
                  var position = index;
                  position += 1;
                  (0, _ga.trackGAEvent)({
                    eventCategory: 'related',
                    eventAction: 'clicked',
                    eventLabel: 'algorithm=parsely,location=article-bottom,position=' + position
                  });
                  (0, _parsely.trainParselyProfile)(link.url);
                }
              },
              _react2.default.createElement(
                _fc_link2.default,
                { config: config, title: link.title, to: link.url },
                link.title
              )
            );
          })
        )
      );
    }
  }]);

  return PersonalizedRecommendations;
}(_react.Component);

PersonalizedRecommendations.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  link: _propTypes2.default.string.isRequired,
  isAdvertorial: _propTypes2.default.bool.isRequired
};

exports.default = PersonalizedRecommendations;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _uniqBy = __webpack_require__(249);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _axios = __webpack_require__(53);

var _axios2 = _interopRequireDefault(_axios);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _update = __webpack_require__(611);

var _update2 = _interopRequireDefault(_update);

var _scroll_to_el_util = __webpack_require__(79);

var _scroll_to_el_util2 = _interopRequireDefault(_scroll_to_el_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Live = function (_Component) {
  _inherits(Live, _Component);

  function Live(props) {
    _classCallCheck(this, Live);

    var _this = _possibleConstructorReturn(this, (Live.__proto__ || Object.getPrototypeOf(Live)).call(this, props));

    var REFRESH_IN_SECONDS = 30;
    _this.fetchDelay = REFRESH_IN_SECONDS * 1000;
    _this.api = '' + props.config.protocol + props.config.apiEndpoint;
    _this.state = {
      posts: props.live.posts
    };
    _this.scrolledToUpdate = false;
    _this.lastSeenParam = '';

    _this.updatesPerPage = 100;
    _this.fetchLiveUpdates = _this.fetchLiveUpdates.bind(_this);
    _this.fetchPaginatedUpdates = _this.fetchPaginatedUpdates.bind(_this);
    return _this;
  }

  _createClass(Live, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var live = this.props.live;

      if (live.enabled) {
        this.fetchLiveUpdates(true);
      } else {
        this.fetchPaginatedUpdates(1, live.posts.length);
      }
      this.scrollToUpdateElement();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.posts.length !== nextState.posts.length;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.scrolledToUpdate) {
        this.scrollToUpdateElement();
      }

      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }

      if (window.twttr) {
        window.twttr.widgets.load();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.refresher);
    }
  }, {
    key: 'setLastSeen',
    value: function setLastSeen() {
      var d = new Date();
      var year = d.getFullYear();
      var month = ('0' + (d.getMonth() + 1)).slice(-2);
      var date = ('0' + d.getDate()).slice(-2);
      var hours = ('0' + d.getHours()).slice(-2);
      var minutes = ('0' + d.getMinutes()).slice(-2);
      var seconds = d.getSeconds() <= 30 ? '00' : 30;
      var formattedDate = year + '-' + month + '-' + date + 'T' + hours + ':' + minutes + ':' + seconds + 'Z';
      this.lastSeenParam = '?lastSeen=' + formattedDate;
    }
  }, {
    key: 'fetchLiveUpdates',
    value: function fetchLiveUpdates() {
      var _this2 = this;

      var initialFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _axios2.default.get(this.api + '/api/v1/live-posts/' + this.props.live.tag).then(function (res) {
        _this2.setLastSeen();

        var livePosts = (0, _get2.default)(res, 'data.livePosts', []);
        var page = (0, _get2.default)(res, 'data.page');
        var total = (0, _get2.default)(res, 'data.total');

        if (livePosts.length) {
          livePosts.push.apply(livePosts, _toConsumableArray(_this2.state.posts));

          _this2.setState({
            posts: (0, _uniqBy2.default)(livePosts, 'id')
          });
        }

        if (initialFetch) {
          _this2.fetchPaginatedUpdates(page, total);
        }

        _this2.refresher = setTimeout(function () {
          _this2.fetchLiveUpdates();
        }, _this2.fetchDelay);
      });
    }
  }, {
    key: 'fetchPaginatedUpdates',
    value: function fetchPaginatedUpdates(page, total) {
      var _this3 = this;

      if (this.updatesPerPage * page <= total) {
        _axios2.default.get(this.api + '/api/v1/live-posts/' + this.props.live.tag + '?page=' + (page + 1)).then(function (res) {
          var nextPagePosts = (0, _get2.default)(res, 'data.livePosts', []);
          var nextPage = (0, _get2.default)(res, 'data.page');
          var totalPosts = (0, _get2.default)(res, 'data.total');
          var livePosts = [].concat(_toConsumableArray(_this3.state.posts), _toConsumableArray(nextPagePosts));

          _this3.setState({
            posts: (0, _uniqBy2.default)(livePosts, 'id')
          });

          if (nextPage && _this3.updatesPerPage * nextPage < totalPosts) {
            _this3.fetchPaginatedUpdates(nextPage, totalPosts);
          }
        });
      }
    }
  }, {
    key: 'scrollToUpdateElement',
    value: function scrollToUpdateElement() {
      var update = window.location.hash;


      if (update && document.querySelector(update)) {
        (0, _scroll_to_el_util2.default)(update, 100);
        this.scrolledToUpdate = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var posts = this.state.posts;
      var _props = this.props,
          parentPost = _props.parentPost,
          config = _props.config;


      if (!posts.length) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'live', id: 'updates' },
        _react2.default.createElement(_slug2.default, { slugName: 'Updates', className: 'live__header' }),
        posts.map(function (post) {
          return _react2.default.createElement(_update2.default, {
            key: post.id,
            update: post,
            parentPost: parentPost,
            site: config.site
          });
        })
      );
    }
  }]);

  return Live;
}(_react.Component);

exports.default = Live;


Live.propTypes = {
  config: _propTypes2.default.shape({
    protocol: _propTypes2.default.string,
    apiEndpoint: _propTypes2.default.string
  }).isRequired,
  parentPost: _propTypes2.default.shape({}).isRequired,
  live: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    tag: _propTypes2.default.string,
    enabled: _propTypes2.default.bool
  }).isRequired
};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _share_util = __webpack_require__(213);

var _content_util = __webpack_require__(202);

var _content_util2 = _interopRequireDefault(_content_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Update = function (_Component) {
  _inherits(Update, _Component);

  function Update(props) {
    _classCallCheck(this, Update);

    var _this = _possibleConstructorReturn(this, (Update.__proto__ || Object.getPrototypeOf(Update)).call(this, props));

    _this.shareUpdate = _this.shareUpdate.bind(_this);
    return _this;
  }

  _createClass(Update, [{
    key: 'shareUpdate',
    value: function shareUpdate(event) {
      var _props = this.props,
          parentPost = _props.parentPost,
          site = _props.site,
          update = _props.update;

      var status = encodeURIComponent(parentPost.title);
      var updateUrl = 'https%3A//www.' + site + '.com/' + parentPost.id + '/' + parentPost.slug + '%23update-' + update.id;
      var hashtags = parentPost.hashtags.join(',');
      var url = 'https://twitter.com/share?url=' + updateUrl + '&text=' + status + '&hashtags=' + hashtags;

      (0, _share_util.popupCenter)(event, url, 560, 725);
      (0, _share_util.trackSocial)('Twitter', 'Tweet');
    }
  }, {
    key: 'render',
    value: function render() {
      var update = this.props.update;

      this.content = (0, _content_util2.default)(update.content);

      return _react2.default.createElement(
        'div',
        { key: update.id, id: 'update-' + update.id, className: 'live__update' },
        _react2.default.createElement(
          'div',
          { className: 'live__eyebrow' },
          _react2.default.createElement(
            'span',
            null,
            update.author.name
          ),
          _react2.default.createElement(
            'span',
            null,
            update.dateFormatted
          ),
          _react2.default.createElement(
            'span',
            null,
            update.timePublished
          ),
          _react2.default.createElement(
            'span',
            { className: 'live__share', onClick: this.shareUpdate },
            'Share This Update'
          )
        ),
        _react2.default.createElement('div', {
          className: 'live__content post__article',
          dangerouslySetInnerHTML: {
            __html: this.content
          }
        })
      );
    }
  }]);

  return Update;
}(_react.Component);

exports.default = Update;


Update.propTypes = {
  update: _propTypes2.default.shape({}).isRequired,
  parentPost: _propTypes2.default.shape({}).isRequired,
  site: _propTypes2.default.string.isRequired
};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Recommender;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(136);

var _books = __webpack_require__(613);

var _books2 = _interopRequireDefault(_books);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _ga = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Recommender(props) {
  if (!props.initialPageLoad && _books2.default.length) {
    var randomBooks = (0, _lodash.sampleSize)(_books2.default, 4);

    return _react2.default.createElement(
      'div',
      { className: 'recommender' },
      _react2.default.createElement(_slug2.default, { slugName: 'The Recommender', className: 'column' }),
      randomBooks.map(function (book) {
        return _react2.default.createElement(
          'div',
          { className: 'book', key: book.affiliate_link },
          _react2.default.createElement(
            'a',
            {
              href: book.affiliate_link,
              target: '_blank',
              className: 'book__link',
              onClick: function onClick() {
                (0, _ga.trackGAEvent)({
                  eventCategory: 'Recommender',
                  eventAction: 'Book',
                  eventLabel: book.title
                });
              }
            },
            _react2.default.createElement(
              'figure',
              { className: 'book__cover' },
              _react2.default.createElement('img', {
                src: book.cover,
                alt: book.title,
                className: 'book__image'
              })
            ),
            _react2.default.createElement(
              'cite',
              { className: 'book__title' },
              book.title
            ),
            _react2.default.createElement(
              'span',
              { className: 'book__price' },
              '$',
              book.price
            )
          )
        );
      }),
      _react2.default.createElement(
        'p',
        { className: 'recommender__disclaimer' },
        'Thanks for supporting Fast Company with these affiliate links'
      )
    );
  }

  return null;
}

Recommender.propTypes = {
  initialPageLoad: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var books = [{
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511811766/fcweb/fc-book-barkingupthewrongtree_sk5uga.jpg',
  title: 'Barking Up The Wrong Tree',
  price: '18.30',
  affiliate_link: 'http://amzn.to/2ztvyoA'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511811943/fcweb/fc-book-fifthTrimester_kfsumj.jpg',
  title: 'The Fifth Trimester',
  price: '17.64',
  affiliate_link: 'http://amzn.to/2zsN2Bo'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812041/fcweb/fc-book-technicallyWrong_emqybr.jpg',
  title: 'Technically Wrong',
  price: '16.18',
  affiliate_link: 'http://amzn.to/2ztLcjH'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812117/fcweb/fc-book-perennialSeller_vbfloh.jpg',
  title: 'Perennial Seller',
  price: '14.67',
  affiliate_link: 'http://amzn.to/2AcDbTk'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812219/fcweb/fc-book-crackInCreation_kyn5nw.jpg',
  title: 'A Crack in Creation',
  price: '18.61',
  affiliate_link: 'http://amzn.to/2zuqSyU'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812368/fcweb/fc-book-greatTransformation_m2rbhw.jpg',
  title: 'The Great Transformation',
  price: '22.85',
  affiliate_link: 'http://amzn.to/2BrORQD'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812472/fcweb/fc-book-deepLearning_m8admo.jpg',
  title: 'Deep Learning',
  price: '47.00',
  affiliate_link: 'http://amzn.to/2k7zRDn'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812561/fcweb/fc-books-boysintheBoat_jgqdvx.jpg',
  title: 'The Boys in the Boat',
  price: '12.27',
  affiliate_link: 'http://amzn.to/2i7oLNX'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812647/fcweb/fc-book-greatConvergence_cbci1g.jpg',
  title: 'The Great Convergence',
  price: '22.84',
  affiliate_link: 'http://amzn.to/2BtoeuH'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812771/fcweb/fc-book-mindset_htkqvr.jpg',
  title: 'Mindset',
  price: '13.60',
  affiliate_link: 'http://amzn.to/2zscLtJ'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511812898/fcweb/fc-book-nonViolentCommunication_fqvqed.jpg',
  title: 'Nonviolent Communication',
  price: '13.50',
  affiliate_link: 'http://amzn.to/2ztH4Ag'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813012/fcweb/fc-books-americanGrowth_swbtwj.jpg',
  title: 'The Rise and Fall of American Growth',
  price: '18.67',
  affiliate_link: 'http://amzn.to/2BtIAns'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813368/fcweb/fc-book-weaponsofMathDestruction_ziestc.jpg',
  title: 'Weapons of Math Destruction',
  price: '17.68',
  affiliate_link: 'http://amzn.to/2Bpln5M'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813416/fcweb/fc-book-urbanCrisis_ff1h7i.jpg',
  title: 'The New Urban Crisis',
  price: '19.04',
  affiliate_link: 'http://amzn.to/2iaCKCs'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813498/fcweb/fc-book-whiplash_ienuxv.jpg',
  title: 'Whiplash',
  price: '17.41',
  affiliate_link: 'http://amzn.to/2zrZt0d'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813630/fcweb/fc-book-playAnything_qgpjgn.jpg',
  title: 'Play Anything',
  price: '15.68',
  affiliate_link: 'http://amzn.to/2BrLHfC'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813735/fcweb/fc-book-dataGoliath_fi8pcv.jpg',
  title: 'Data and Goliath',
  price: '12.80',
  affiliate_link: 'http://amzn.to/2ztMKdv'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813817/fcweb/fc-books-powerofMoments_noieau.jpg',
  title: 'The Power of Moments',
  price: '17.38',
  affiliate_link: 'http://amzn.to/2zt43eS'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813916/fcweb/fc-book-tribeofMentors_bfaqkb.jpg',
  title: 'Tribe of Mentors',
  price: '17.85',
  affiliate_link: 'http://amzn.to/2BsKcho'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511813976/fcweb/fc-book-startupWay_cmmoxs.jpg',
  title: 'The Startup Way',
  price: '17.98',
  affiliate_link: 'http://amzn.to/2zsmWyC'
}, {
  cover: 'https://images.fastcompany.net/image/upload/h_100,f_auto,q_auto,fl_lossy/v1511814039/fcweb/fc-book-secondMachineAge_npugcp.jpg',
  title: 'The Second Machine Age',
  price: '14.83',
  affiliate_link: 'http://amzn.to/2zt5rOC'
}];

exports.default = books;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = __webpack_require__(64);

var _throttle2 = _interopRequireDefault(_throttle);

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(player) {
    var _this = this;

    _classCallCheck(this, _class);

    this.data = {};
    this.player = player;
    this.scrollEvent = (0, _throttle2.default)(function () {
      _this.autoplay(_this.player);
    }, 300);
  }

  _createClass(_class, [{
    key: 'isInViewport',
    value: function isInViewport(element) {
      if (element && element.getBoundingClientRect) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || html.clientHeight) && rect.right <= (window.innerWidth || html.clientWidth);
      }
      return false;
    }
  }, {
    key: 'autoplay',
    value: function autoplay(iframe) {
      this.data.command = 'pause';
      if (this.isInViewport(iframe)) {
        this.data.command = 'play';
      }
      iframe.contentWindow.postMessage(this.data, '*');
    }
  }, {
    key: 'on',
    value: function on() {
      if (_exenv2.default) {
        window.addEventListener('scroll', this.scrollEvent);
      }
    }
  }, {
    key: 'off',
    value: function off() {
      if (_exenv2.default) {
        window.removeEventListener('scroll', this.scrollEvent);
      }
    }
  }]);

  return _class;
}();

exports.default = _class;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(616)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(617);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","RUNTIME_ENV":"browser"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(618);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 618 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadFBTracker;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
function loadFBTracker(currentState) {
  var site = (0, _get2.default)(currentState, 'context.site');
  var facebookConfig = (0, _get2.default)(_identity2.default[site], 'facebookPixel');
  var id = facebookConfig.id;

  // https://www.facebook.com/ads/manager/pixel/facebook_pixel/?act=1375631352670761&pid=p1

  if (window.fbq) {
    return false;
  }

  var _fbq2 = window.fbq;
  _fbq2 = function fbq() {
    var _fbq;

    _fbq2.callMethod ? (_fbq = _fbq2).callMethod.apply(_fbq, arguments) : _fbq2.queue.push(arguments);
  };

  if (!window._fbq) {
    window._fbq = _fbq2;
  }

  _fbq2.push = _fbq2;
  _fbq2.loaded = !0;
  _fbq2.version = '2.0';
  _fbq2.queue = [];

  _fbq2('init', '' + id);
  _fbq2('track', 'PageView');
}
/* eslint-disable */

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadComscoreTracker;

var _exenv = __webpack_require__(4);

function loadComscoreTracker() {
  if (_exenv.canUseDOM) {
    window.Nielsen_Event();
  }
}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadKruxTracker;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _identity = __webpack_require__(26);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadKruxTracker(currentState) {
  var siteName = (0, _get2.default)(currentState, 'context.site', 'fastcompany');
  var context = (0, _get2.default)(currentState, 'context', {});
  var siteConfig = _identity2.default[siteName];
  var keywords = (0, _get2.default)(siteConfig, 'keywords', []);

  var postData = context.postData,
      type = context.type;


  if (window.Krux) {
    var FCKruxFPA = {
      author: null,
      channels: null,
      subChannels: null,
      contentType: null,
      keywords: null,
      socialTags: null,
      siteName: null,
      referrerUrl: null,
      url: window.location.origin + window.location.pathname,
      querystring: null
    };

    var category = null;
    var authorName = siteName || '';
    var contentType = type;
    var tags = [];
    var articleId = '';

    var typeMap = {
      post: 'article',
      gallery: 'slideshow',
      video: 'video'
    };

    // DO POST CHECK
    if (type === 'post') {
      category = (0, _get2.default)(postData, 'categories[0].slug', '');
      articleId = (0, _get2.default)(postData, 'id', null);
      authorName = (0, _get2.default)(postData, 'author.name', '');
      contentType = typeMap[(0, _get2.default)(postData, 'format', 'article')];
    }

    // FCKruxFPA['Read Length'] = null;  // todo @zhi
    FCKruxFPA['Article ID'] = articleId;
    FCKruxFPA.Subchannel = category;
    FCKruxFPA.Channel = category;

    if (window.location.search !== '') {
      FCKruxFPA.querystring = window.location.search;
    }

    if (document.referrer) {
      FCKruxFPA.referrerUrl = document.referrer;
    }

    FCKruxFPA.channels = keywords;
    FCKruxFPA.siteName = siteName;

    FCKruxFPA.author = authorName;
    FCKruxFPA.subChannels = category;
    FCKruxFPA.keywords = tags;
    FCKruxFPA.socialTags = tags;
    FCKruxFPA.contentType = contentType;

    window.FC_Krux_FPA = FCKruxFPA;

    if (window.Krux) {
      // eslint-disable-next-line new-cap
      window.Krux('ns:mansueto', 'page:load', function () {
        return true;
      });
    }
  }
}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadLiftIgniterTracker;

var _exenv = __webpack_require__(4);

function loadLiftIgniterTracker() {
  if (_exenv.canUseDOM) {
    if (window.$p) {
      window.$p('send', 'pageview');
    }
  }
}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/news/:page',
    component: _news_page2.default,
    strict: true,
    exact: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'news')
  };
};

var _news_page = __webpack_require__(236);

var _news_page2 = _interopRequireDefault(_news_page);

var _category_page_state_manager = __webpack_require__(67);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/magazine',
    component: _magazine_page2.default,
    strict: true,
    exact: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'magazine')
  };
};

var _magazine_page = __webpack_require__(625);

var _magazine_page2 = _interopRequireDefault(_magazine_page);

var _category_page_state_manager = __webpack_require__(67);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(22);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _magazine_archive = __webpack_require__(141);

var _magazine_archive2 = _interopRequireDefault(_magazine_archive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Magazine = function (_Component) {
  _inherits(Magazine, _Component);

  function Magazine() {
    _classCallCheck(this, Magazine);

    return _possibleConstructorReturn(this, (Magazine.__proto__ || Object.getPrototypeOf(Magazine)).apply(this, arguments));
  }

  _createClass(Magazine, [{
    key: 'render',
    value: function render() {
      if (this.props.categoryPage.error || this.props.categoryFeaturedFeed.error || this.props.status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.categoryPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'category-page' },
          _react2.default.createElement(
            'article',
            { className: 'category-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          config = _props.config,
          categoryPage = _props.categoryPage,
          categoryFeaturedFeed = _props.categoryFeaturedFeed,
          magazineLatestIssuePosts = _props.magazineLatestIssuePosts;

      var adData = (0, _get2.default)(categoryPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgName = (0, _get2.default)(categoryFeaturedFeed, 'category.name');
      var pgDesc = (0, _get2.default)(categoryFeaturedFeed, 'category.description');

      return _react2.default.createElement(
        'section',
        { className: 'category-page category-page--magazine' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, { slugName: pgName, className: 'category-page' }),
          pgDesc ? _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          ) : ''
        ),
        _react2.default.createElement(
          'div',
          { className: 'row row--magazine' },
          _react2.default.createElement(
            'div',
            { className: 'row__aside' },
            _react2.default.createElement(_card2.default, {
              type: 'magazine',
              metadata: (0, _get2.default)(magazineLatestIssuePosts, 'data.issue', {}),
              fullWidth: true,
              magPage: true,
              config: config
            }),
            _react2.default.createElement(
              'div',
              { className: 'small-cards' },
              (0, _get2.default)(magazineLatestIssuePosts, 'data.features', []).slice(0, 3).map(function (story) {
                return _react2.default.createElement(_card2.default, {
                  key: story.id,
                  type: 'small',
                  metadata: story,
                  disabledImage: true,
                  config: config
                });
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row__main' },
            _react2.default.createElement(_card2.default, {
              type: 'featured',
              metadata: (0, _get2.default)(magazineLatestIssuePosts, 'data.coverStory', {}),
              config: config
            }),
            _react2.default.createElement(
              'div',
              { className: 'card--subscribe' },
              _react2.default.createElement(
                'a',
                { href: 'https://store.fastcompany.com/subscription-order/magazinepage' },
                _react2.default.createElement('img', {
                  className: 'subscribe--rectangle',
                  src: 'https://images.fastcompany.net/image/upload/v1510241760/fcweb/sub-ad-magazine-v2_q7u6jl_bkkzhk.png',
                  alt: 'The future of business starts here. Subscribe now.'
                }),
                _react2.default.createElement('img', {
                  className: 'subscribe--square',
                  src: 'https://images.fastcompany.net/image/upload/v1510241760/fcweb/sub-ad-issue-v2_arfee5_nlh22x.png',
                  alt: 'The future of business starts here. Subscribe now.'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'category-page__ff-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        ),
        _react2.default.createElement(_magazine_archive2.default, {
          config: config,
          title: 'Fast Company Magazine Archives',
          description: 'Browse our previous magazine issues',
          magazines: (0, _get2.default)(magazineLatestIssuePosts, 'data.magazineArchive', []),
          limit: 12
        }),
        _react2.default.createElement(
          'div',
          { className: 'category-page__ff-ad-containe' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
        )
      );
    }
  }]);

  return Magazine;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: (0, _get2.default)(state, 'categoryFeaturedFeed.source') || '',
      featured: (0, _get2.default)(state, 'categoryFeaturedFeed.featured') || [],
      top: (0, _get2.default)(state, 'categoryFeaturedFeed.top') || [],
      category: (0, _get2.default)(state, 'categoryFeaturedFeed.category') || {},
      error: (0, _get2.default)(state, 'categoryFeaturedFeed.error') || false
    },
    categoryPage: (0, _get2.default)(state, 'categoryPage') || {},
    categoryScrollingModule: (0, _get2.default)(state, 'categoryScrollingModule.data') || {},
    magazineLatestIssuePosts: (0, _get2.default)(state, 'magazineLatestIssuePosts') || {}
  };
}

Magazine.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number.isRequired,
  categoryPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  categoryFeaturedFeed: _propTypes2.default.shape({
    source: _propTypes2.default.string,
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    category: _propTypes2.default.object,
    error: _propTypes2.default.bool
  }).isRequired,
  magazineLatestIssuePosts: _propTypes2.default.shape({}).isRequired
  // categoryScrollingModule: PropTypes.shape({}).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Magazine));

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () /* store */{
  return {
    path: '/community-spot-im',
    component: _community_page2.default,
    exact: true,
    strict: true
  };
};

var _community_page = __webpack_require__(627);

var _community_page2 = _interopRequireDefault(_community_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(22);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 import { canUseDOM } from 'exenv';
 if(canUseDOM) {
 debugger;
 }
 */

// eslint-disable-next-line react/prefer-stateless-function
var Community = function (_Component) {
  _inherits(Community, _Component);

  function Community() {
    _classCallCheck(this, Community);

    return _possibleConstructorReturn(this, (Community.__proto__ || Object.getPrototypeOf(Community)).apply(this, arguments));
  }

  _createClass(Community, [{
    key: 'render',
    value: function render() {
      /* eslint-disable jsx-a11y/iframe-has-title */
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, { slugName: 'Fastco. Community', className: 'section-page' })
        ),
        _react2.default.createElement('iframe', {
          className: 'community-frame-test',
          width: '100%',
          height: '1500',
          scrolling: 'no',
          src: 'https://stagingv2.spot.im/embed/modules/topics/demo/index.html#/topic/sp_IjnMf2Jd/top_OmK1Ndpvn3A4'
        })
      );
    }
  }]);

  return Community;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {}
  };
}

Community.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  config: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Community));

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/sitemap',
    component: _html_sitemap_index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _html_sitemap_index_page_state_manager2.default)(store)
  };
};

var _html_sitemap_index_page = __webpack_require__(252);

var _html_sitemap_index_page2 = _interopRequireDefault(_html_sitemap_index_page);

var _html_sitemap_index_page_state_manager = __webpack_require__(253);

var _html_sitemap_index_page_state_manager2 = _interopRequireDefault(_html_sitemap_index_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = htmlSitemapIndexDetail;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _html_sitemap_index_page_action_creators = __webpack_require__(630);

var htmlSitemapIndexPageActions = _interopRequireWildcard(_html_sitemap_index_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_html_sitemap_index_actions = __webpack_require__(631);

var _async_html_sitemap_index_actions2 = _interopRequireDefault(_async_html_sitemap_index_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function htmlSitemapIndexDetail(params, store) {
  return function firstDispatchHtmlSitemapIndex(dispatch) {
    dispatch(htmlSitemapIndexPageActions.htmlSitemapIndexPageLoading());
    return _bluebird2.default.all([(0, _async_html_sitemap_index_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function htmlSitemapIndexDetailData() {
      dispatch(htmlSitemapIndexPageActions.htmlSitemapIndexPageLoaded({}, store));
      return true;
    }).catch(function handlehtmlSitemapIndexError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(htmlSitemapIndexPageActions.htmlSitemapIndexPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in html sitemap index page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlSitemapIndexPageLoading = htmlSitemapIndexPageLoading;
exports.htmlSitemapIndexPageLoaded = htmlSitemapIndexPageLoaded;
exports.htmlSitemapIndexPageLoadError = htmlSitemapIndexPageLoadError;
// import { canUseDOM } from 'exenv';

function htmlSitemapIndexPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_INDEX_PAGE_LOADING',
    htmlSitemapIndexPage: resp,
    store: store
  };
}

function htmlSitemapIndexPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_INDEX_PAGE_LOADED',
    htmlSitemapIndexPage: resp,
    store: store
  };
}

function htmlSitemapIndexPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_INDEX_PAGE_ERROR',
    htmlSitemapIndexPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchSearchAction;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _html_sitemap_index_action_creators = __webpack_require__(632);

var htmlSitemapIndex = _interopRequireWildcard(_html_sitemap_index_action_creators);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _html_sitemap_index = __webpack_require__(633);

var _html_sitemap_index2 = _interopRequireDefault(_html_sitemap_index);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSearchAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(htmlSitemapIndex.htmlSitemapIndexLoading({}, store));
    return _html_sitemap_index2.default.fetch(params, store).then(function handleSearchModelData(htmlSitemapIndexData) {
      dispatch(htmlSitemapIndex.htmlSitemapIndexLoaded(htmlSitemapIndexData.data, store));
    }).catch(function handleSearchError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(htmlSitemapIndex.htmlSitemapIndexError(err.data, store));
      _logger_service2.default.error(err, 'Error in htmlSitemapIndex actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlSitemapIndexLoading = htmlSitemapIndexLoading;
exports.htmlSitemapIndexLoaded = htmlSitemapIndexLoaded;
exports.htmlSitemapIndexError = htmlSitemapIndexError;
// import { canUseDOM } from 'exenv';

function htmlSitemapIndexLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_INDEX_LOADING',
    htmlSitemapIndex: resp,
    store: store
  };
}

function htmlSitemapIndexLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_INDEX_LOADED',
    htmlSitemapIndex: resp,
    store: store
  };
}

function htmlSitemapIndexError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_INDEX_ERROR',
    htmlSitemapIndex: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HtmlSitemap = function (_Base) {
  _inherits(HtmlSitemap, _Base);

  function HtmlSitemap() {
    _classCallCheck(this, HtmlSitemap);

    return _possibleConstructorReturn(this, (HtmlSitemap.__proto__ || Object.getPrototypeOf(HtmlSitemap)).apply(this, arguments));
  }

  _createClass(HtmlSitemap, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var site = (0, _get2.default)(state, 'config.site');
      var year = this.cleanParam((0, _get2.default)(params, 'params.year'));
      if (site === 'fastcodesign') {
        if (!year) {
          var dt = new Date();
          var nyear = dt.getFullYear();
          var startYear = 2011;
          var urls = [{ link: 'https://www.' + site + '.com/sitemap/year/' + startYear }];
          while (startYear < nyear) {
            urls.push({
              link: 'https://www.' + site + '.com/sitemap/year/' + (startYear + 1)
            });
            startYear += 1;
          }
          return _bluebird2.default.resolve({
            data: {
              urls: urls
            }
          });
        }
      }

      if (!year) {
        var _dt = new Date();
        var _nyear = _dt.getFullYear();
        var _startYear = 1995;
        var _urls = [{ link: 'https://www.' + site + '.com/sitemap/year/' + _startYear }];
        while (_startYear < _nyear) {
          _urls.push({
            link: 'https://www.' + site + '.com/sitemap/year/' + (_startYear + 1)
          });
          _startYear += 1;
        }
        return _bluebird2.default.resolve({
          data: {
            urls: _urls
          }
        });
      }

      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/html-sitemap-year/' + site + '/' + year;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return HtmlSitemap;
}(_base_model2.default);

exports.default = HtmlSitemap;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/sitemap/year/:year',
    component: _html_sitemap_index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _html_sitemap_index_page_state_manager2.default)(store)
  };
};

var _html_sitemap_index_page = __webpack_require__(252);

var _html_sitemap_index_page2 = _interopRequireDefault(_html_sitemap_index_page);

var _html_sitemap_index_page_state_manager = __webpack_require__(253);

var _html_sitemap_index_page_state_manager2 = _interopRequireDefault(_html_sitemap_index_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/sitemap/posts',
    component: _html_sitemap_post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _html_sitemap_post_page_state_manager2.default)(store)
  };
};

var _html_sitemap_post_page = __webpack_require__(636);

var _html_sitemap_post_page2 = _interopRequireDefault(_html_sitemap_post_page);

var _html_sitemap_post_page_state_manager = __webpack_require__(637);

var _html_sitemap_post_page_state_manager2 = _interopRequireDefault(_html_sitemap_post_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouterDom = __webpack_require__(32);

var _urlParse = __webpack_require__(45);

var _urlParse2 = _interopRequireDefault(_urlParse);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var SitemapPost = function (_Component) {
  _inherits(SitemapPost, _Component);

  function SitemapPost() {
    _classCallCheck(this, SitemapPost);

    return _possibleConstructorReturn(this, (SitemapPost.__proto__ || Object.getPrototypeOf(SitemapPost)).apply(this, arguments));
  }

  _createClass(SitemapPost, [{
    key: 'render',
    value: function render() {
      if (this.props.htmlSitemapPostPage && this.props.htmlSitemapPostPage.error) {
        return _react2.default.createElement(
          'section',
          { className: 'wp-page' },
          _react2.default.createElement(
            'article',
            { className: 'wp-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.htmlSitemapPostPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var startDate = (0, _get2.default)(this.props, 'htmlSitemapPost.startDate');
      var endDate = (0, _get2.default)(this.props, 'htmlSitemapPost.endDate') || (0, _get2.default)(this.props, 'htmlSitemapPost.amp;endDate');
      var siteMapYear = endDate && endDate.length ? endDate.slice(0, 4) : '';
      var siteMapYearPath = '/sitemap/year/' + siteMapYear;

      if (!startDate || !endDate) {
        return _react2.default.createElement(
          'section',
          { className: 'wp-page' },
          _react2.default.createElement(
            'article',
            { className: 'wp-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      return _react2.default.createElement(
        'section',
        { className: 'html-sitemap-index-page' },
        _react2.default.createElement(
          'div',
          { className: 'html-sitemap-index-page__main' },
          _react2.default.createElement(
            'h2',
            { className: 'html-sitemap-index-page__heading' },
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: '/sitemap' },
              'Site Map'
            ),
            ' >',
            ' ',
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: siteMapYearPath },
              siteMapYear
            ),
            ' >',
            ' ',
            (0, _get2.default)(this.props, 'htmlSitemapPost.title')
          ),
          this.props.htmlSitemapPost.posts.map(function sitemapLink(post) {
            return _react2.default.createElement(
              _reactRouterDom.Link,
              {
                to: post.url.replace((0, _urlParse2.default)(post.url).origin, ''),
                className: 'url--week',
                key: post.url
              },
              post.title
            );
          })
        )
      );
    }
  }]);

  return SitemapPost;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    htmlSitemapPostPage: state.htmlSitemapPostPage || {},
    htmlSitemapPost: (0, _get2.default)(state, 'htmlSitemapPost.data') || { error: true }
  };
}

SitemapPost.propTypes = {
  htmlSitemapPostPage: _propTypes2.default.shape({
    // eslint-disable-next-line
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  htmlSitemapPost: _propTypes2.default.shape({
    // eslint-disable-next-line
    error: _propTypes2.default.bool,
    title: _propTypes2.default.string,
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    startDate: _propTypes2.default.string,
    endDate: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SitemapPost);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchHtmlSitemapPostData;

var _exenv = __webpack_require__(4);

var _async_html_sitemap_post_page_actions = __webpack_require__(638);

var _async_html_sitemap_post_page_actions2 = _interopRequireDefault(_async_html_sitemap_post_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchHtmlSitemapPostData(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_html_sitemap_post_page_actions2.default)(nextState, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_html_sitemap_post_page_actions2.default)(nextState, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleServerSideRenderError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = htmlSitemapPostDetail;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _html_sitemap_post_page_action_creators = __webpack_require__(639);

var htmlSitemapPostPageActions = _interopRequireWildcard(_html_sitemap_post_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_html_sitemap_post_actions = __webpack_require__(640);

var _async_html_sitemap_post_actions2 = _interopRequireDefault(_async_html_sitemap_post_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function htmlSitemapPostDetail(params, store) {
  return function firstDispatchHtmlSitemapPost(dispatch) {
    dispatch(htmlSitemapPostPageActions.htmlSitemapPostPageLoading());
    return _bluebird2.default.all([(0, _async_html_sitemap_post_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function htmlSitemapPostDetailData() {
      dispatch(htmlSitemapPostPageActions.htmlSitemapPostPageLoaded({}, store));
      return true;
    }).catch(function handlehtmlSitemapPostError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(htmlSitemapPostPageActions.htmlSitemapPostPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in html sitemap post page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlSitemapPostPageLoading = htmlSitemapPostPageLoading;
exports.htmlSitemapPostPageLoaded = htmlSitemapPostPageLoaded;
exports.htmlSitemapPostPageLoadError = htmlSitemapPostPageLoadError;
// import { canUseDOM } from 'exenv';

function htmlSitemapPostPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_POST_PAGE_LOADING',
    htmlSitemapPostPage: resp,
    store: store
  };
}

function htmlSitemapPostPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_POST_PAGE_LOADED',
    htmlSitemapPostPage: resp,
    store: store
  };
}

function htmlSitemapPostPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_POST_PAGE_ERROR',
    htmlSitemapPostPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchSearchAction;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _qs = __webpack_require__(641);

var _exenv = __webpack_require__(4);

var _html_sitemap_post_action_creators = __webpack_require__(644);

var htmlSitemapPostActions = _interopRequireWildcard(_html_sitemap_post_action_creators);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _html_sitemap_post = __webpack_require__(645);

var _html_sitemap_post2 = _interopRequireDefault(_html_sitemap_post);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSearchAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(htmlSitemapPostActions.htmlSitemapPostLoading({}, store));

    var state = store.getState();

    var startDate = (0, _get2.default)(state, 'config.initialQueryParams.startDate');
    var endDate = (0, _get2.default)(state, 'config.initialQueryParams.endDate');

    if (_exenv.canUseDOM) {
      var queryParams = (0, _qs.parse)(window.location.search.replace('?', ''));
      startDate = (0, _get2.default)(queryParams, 'startDate');
      endDate = (0, _get2.default)(queryParams, 'endDate');
    }

    return _html_sitemap_post2.default.fetch({ startDate: startDate, endDate: endDate }, store).then(function handleSiteMapPostModelData(htmlSitemapPostData) {
      var htmlSitemapPostDataCloneData = htmlSitemapPostData.data;
      if (htmlSitemapPostDataCloneData) {
        htmlSitemapPostDataCloneData.startDate = startDate;
        htmlSitemapPostDataCloneData.endDate = endDate;
      }
      dispatch(htmlSitemapPostActions.htmlSitemapPostLoaded(htmlSitemapPostDataCloneData, store));
    }).catch(function handleSiteMapPostError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(htmlSitemapPostActions.htmlSitemapPostError(err.data, store));
      _logger_service2.default.error(err, 'Error in htmlSitemapPost actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(642);
var parse = __webpack_require__(643);
var formats = __webpack_require__(255);

module.exports = {
    "formats": ((formats),null),
    parse: parse,
    "stringify": ((stringify),null)
};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(254);
var formats = __webpack_require__(255);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(254);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlSitemapPostLoading = htmlSitemapPostLoading;
exports.htmlSitemapPostLoaded = htmlSitemapPostLoaded;
exports.htmlSitemapPostError = htmlSitemapPostError;
// import { canUseDOM } from 'exenv';

function htmlSitemapPostLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_POST_LOADING',
    htmlSitemapPost: resp,
    store: store
  };
}

function htmlSitemapPostLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_POST_LOADED',
    htmlSitemapPost: resp,
    store: store
  };
}

function htmlSitemapPostError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'HTML_SITEMAP_POST_ERROR',
    htmlSitemapPost: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function (_Base) {
  _inherits(Search, _Base);

  function Search() {
    _classCallCheck(this, Search);

    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
  }

  _createClass(Search, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var site = (0, _get2.default)(state, 'config.site');
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/html-sitemap/' + site + '/posts?startDate=' + startDate + '&endDate=' + endDate;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Search;
}(_base_model2.default);

exports.default = Search;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/about-us',
    component: _wp_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _wp_page_state_manager2.default)(store)
  };
};

var _wp_page = __webpack_require__(54);

var _wp_page2 = _interopRequireDefault(_wp_page);

var _wp_page_state_manager = __webpack_require__(55);

var _wp_page_state_manager2 = _interopRequireDefault(_wp_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _wp_page_action_creators = __webpack_require__(648);

var wpPageActions = _interopRequireWildcard(_wp_page_action_creators);

var _async_custom_page_actions = __webpack_require__(649);

var _async_custom_page_actions2 = _interopRequireDefault(_async_custom_page_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(wpPageActions.wpPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_custom_page_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(wpPageActions.wpPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(wpPageActions.wpPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in wp page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wpPageLoading = wpPageLoading;
exports.wpPageLoaded = wpPageLoaded;
exports.wpPageLoadError = wpPageLoadError;
// import { canUseDOM } from 'exenv';

function wpPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'WP_PAGE_LOADING',
    wpPage: resp,
    store: store
  };
}

function wpPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'WP_PAGE_LOADED',
    wpPage: resp,
    store: store
  };
}

function wpPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'WP_PAGE_ERROR',
    wpPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCustomPageAction;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _custom_page_action_creators = __webpack_require__(650);

var customPageActions = _interopRequireWildcard(_custom_page_action_creators);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _custom_page = __webpack_require__(651);

var _custom_page2 = _interopRequireDefault(_custom_page);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCustomPageAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(customPageActions.customPageLoading({}, store));
    var slug = (0, _get2.default)(params, 'params.slug') || params.path.split('/')[1];
    return _custom_page2.default.fetch({ slug: slug }, store).then(function handleCustomPageModelData(customPageData) {
      dispatch(customPageActions.customPageLoaded(customPageData.data, store));
      return true;
    }).catch(function handleCustomPageError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(customPageActions.customPageError(err.data, store));
      return _logger_service2.default.error(err, 'Error in custom page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customPageLoading = customPageLoading;
exports.customPageLoaded = customPageLoaded;
exports.customPageError = customPageError;
// https://api.github.com/customPages/michaelbenin
// import { canUseDOM } from 'exenv';

function customPageLoading() {
  var customPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CUSTOM_PAGE_LOADING',
    customPage: customPage,
    store: store
  };
}

function customPageLoaded(customPage) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CUSTOM_PAGE_LOADED',
    customPage: customPage,
    store: store
  };
}

function customPageError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'CUSTOM_PAGE_ERROR',
    customPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WPpage = function (_Base) {
  _inherits(WPpage, _Base);

  function WPpage() {
    _classCallCheck(this, WPpage);

    return _possibleConstructorReturn(this, (WPpage.__proto__ || Object.getPrototypeOf(WPpage)).apply(this, arguments));
  }

  _createClass(WPpage, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var slug = _ref.slug;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/page-slug/' + site + '/' + slug;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return WPpage;
}(_base_model2.default);

exports.default = WPpage;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/innovation-by-design-awards/:slug',
    component: _wp_page2.default,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: (0, _wp_page_state_manager2.default)(store)
  };
};

var _wp_page = __webpack_require__(54);

var _wp_page2 = _interopRequireDefault(_wp_page);

var _wp_page_state_manager = __webpack_require__(55);

var _wp_page_state_manager2 = _interopRequireDefault(_wp_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/apply/:slug',
    component: _wp_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _wp_page_state_manager2.default)(store)
  };
};

var _wp_page = __webpack_require__(54);

var _wp_page2 = _interopRequireDefault(_wp_page);

var _wp_page_state_manager = __webpack_require__(55);

var _wp_page_state_manager2 = _interopRequireDefault(_wp_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/contact-us',
    component: _wp_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _wp_page_state_manager2.default)(store)
  };
};

var _wp_page = __webpack_require__(54);

var _wp_page2 = _interopRequireDefault(_wp_page);

var _wp_page_state_manager = __webpack_require__(55);

var _wp_page_state_manager2 = _interopRequireDefault(_wp_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/privacy-policy',
    component: _wp_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _wp_page_state_manager2.default)(store)
  };
};

var _wp_page = __webpack_require__(54);

var _wp_page2 = _interopRequireDefault(_wp_page);

var _wp_page_state_manager = __webpack_require__(55);

var _wp_page_state_manager2 = _interopRequireDefault(_wp_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/staff-masthead',
    component: _wp_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _wp_page_state_manager2.default)(store)
  };
};

var _wp_page = __webpack_require__(54);

var _wp_page2 = _interopRequireDefault(_wp_page);

var _wp_page_state_manager = __webpack_require__(55);

var _wp_page_state_manager2 = _interopRequireDefault(_wp_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/terms-and-conditions',
    component: _wp_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _wp_page_state_manager2.default)(store)
  };
};

var _wp_page = __webpack_require__(54);

var _wp_page2 = _interopRequireDefault(_wp_page);

var _wp_page_state_manager = __webpack_require__(55);

var _wp_page_state_manager2 = _interopRequireDefault(_wp_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/search',
    component: _search_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _search_page_state_manager2.default)(store)
  };
};

var _search_page = __webpack_require__(148);

var _search_page2 = _interopRequireDefault(_search_page);

var _search_page_state_manager = __webpack_require__(149);

var _search_page_state_manager2 = _interopRequireDefault(_search_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _search_page_action_creators = __webpack_require__(660);

var searchPageActions = _interopRequireWildcard(_search_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_all_feed_actions = __webpack_require__(230);

var _async_all_feed_actions2 = _interopRequireDefault(_async_all_feed_actions);

var _async_search_actions = __webpack_require__(661);

var _async_search_actions2 = _interopRequireDefault(_async_search_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(searchPageActions.searchPageLoading());
    return _bluebird2.default.all([(0, _async_search_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch), (0, _async_all_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(searchPageActions.searchPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(searchPageActions.searchPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in search page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPageLoading = searchPageLoading;
exports.searchPageLoaded = searchPageLoaded;
exports.searchPageLoadError = searchPageLoadError;
// import { canUseDOM } from 'exenv';

function searchPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SEARCH_PAGE_LOADING',
    searchPage: resp,
    store: store
  };
}

function searchPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SEARCH_PAGE_LOADED',
    searchPage: resp,
    store: store
  };
}

function searchPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SEARCH_PAGE_ERROR',
    searchPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchSearchAction;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _search_action_creators = __webpack_require__(662);

var searchActions = _interopRequireWildcard(_search_action_creators);

var _search = __webpack_require__(663);

var _search2 = _interopRequireDefault(_search);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchSearchAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(searchActions.searchLoading({}, store));

    var state = store.getState();
    var initialQueryParams = false;

    if ((0, _get2.default)(state, 'config.initialPageLoad')) {
      initialQueryParams = (0, _get2.default)(state, 'config.initialQueryParams.q');
    }

    var page = (0, _get2.default)(params, 'location.query.page') || (0, _get2.default)(params, 'params.page') || 1;
    var q = initialQueryParams || (0, _get2.default)(params, 'params.q') || false;

    return _search2.default.fetch({ q: q, page: page }, store).then(function handleSearchModelData(searchData) {
      dispatch(searchActions.searchLoaded(searchData.data, store));
    }).catch(function handleSearchError(err) {
      dispatch(searchActions.searchError(err.data, q, store));
      _logger_service2.default.error(err, 'Error in search actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchLoading = searchLoading;
exports.searchLoaded = searchLoaded;
exports.searchError = searchError;
// https://api.github.com/searchs/michaelbenin
// import { canUseDOM } from 'exenv';

function searchLoading() {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SEARCH_LOADING',
    search: search,
    store: store
  };
}

function searchLoaded(search) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'SEARCH_LOADED',
    search: search,
    store: store
  };
}

function searchError(error, query) {
  var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return {
    type: 'SEARCH_ERROR',
    search: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message',
      query: query
    },
    store: store
  };
}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function (_Base) {
  _inherits(Search, _Base);

  function Search() {
    _classCallCheck(this, Search);

    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
  }

  _createClass(Search, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var q = _ref.q,
          _ref$page = _ref.page,
          page = _ref$page === undefined ? 1 : _ref$page;

      if (!q) {
        return _bluebird2.default.resolve({});
      }

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/search/?q=' + q + '&page=' + page + '&limit=10';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Search;
}(_base_model2.default);

exports.default = Search;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/search/:q',
    component: _search_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _search_page_state_manager2.default)(store)
  };
};

var _search_page = __webpack_require__(148);

var _search_page2 = _interopRequireDefault(_search_page);

var _search_page_state_manager = __webpack_require__(149);

var _search_page_state_manager2 = _interopRequireDefault(_search_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/search/:q/:page',
    component: _search_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _search_page_state_manager2.default)(store)
  };
};

var _search_page = __webpack_require__(148);

var _search_page2 = _interopRequireDefault(_search_page);

var _search_page_state_manager = __webpack_require__(149);

var _search_page_state_manager2 = _interopRequireDefault(_search_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/section/:tag',
    component: _tag_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _tag_page_state_manager2.default)(store)
  };
};

var _tag_page = __webpack_require__(150);

var _tag_page2 = _interopRequireDefault(_tag_page);

var _tag_page_state_manager = __webpack_require__(80);

var _tag_page_state_manager2 = _interopRequireDefault(_tag_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _tag_page_action_creators = __webpack_require__(668);

var tagPageActions = _interopRequireWildcard(_tag_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_tag_video_actions = __webpack_require__(669);

var _async_tag_video_actions2 = _interopRequireDefault(_async_tag_video_actions);

var _async_tag_all_feed_actions = __webpack_require__(81);

var _async_tag_all_feed_actions2 = _interopRequireDefault(_async_tag_all_feed_actions);

var _async_tag_scrolling_module_actions = __webpack_require__(673);

var _async_tag_scrolling_module_actions2 = _interopRequireDefault(_async_tag_scrolling_module_actions);

var _async_tag_promo_banner_actions = __webpack_require__(676);

var _async_tag_promo_banner_actions2 = _interopRequireDefault(_async_tag_promo_banner_actions);

var _async_tag_featured_feed_actions = __webpack_require__(679);

var _async_tag_featured_feed_actions2 = _interopRequireDefault(_async_tag_featured_feed_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_featured_sponsored_card_actions = __webpack_require__(143);

var _async_featured_sponsored_card_actions2 = _interopRequireDefault(_async_featured_sponsored_card_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_magazine_issue_posts_actions = __webpack_require__(682);

var _async_magazine_issue_posts_actions2 = _interopRequireDefault(_async_magazine_issue_posts_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagPageActions.tagPageLoading({}, store));
    var actions = [(0, _async_tag_featured_feed_actions2.default)(params, store)(dispatch), (0, _async_featured_sponsored_card_actions2.default)(params, store)(dispatch), (0, _async_tag_promo_banner_actions2.default)(params, store)(dispatch), (0, _async_tag_scrolling_module_actions2.default)(params, store)(dispatch), (0, _async_tag_video_actions2.default)(params, store)(dispatch), (0, _async_tag_all_feed_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)];

    if (params.magazine) {
      actions.push((0, _async_magazine_issue_posts_actions2.default)(params, store)(dispatch));
    }

    return _bluebird2.default.all(actions).then(function handlePostDetailData() {
      dispatch(tagPageActions.tagPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(tagPageActions.tagPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagPageLoading = tagPageLoading;
exports.tagPageLoaded = tagPageLoaded;
exports.tagPageLoadError = tagPageLoadError;
// import { canUseDOM } from 'exenv';

function tagPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_PAGE_LOADING',
    tagPage: resp,
    store: store
  };
}

function tagPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_PAGE_LOADED',
    tagPage: resp,
    store: store
  };
}

function tagPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_PAGE_ERROR',
    tagPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _tag_video_action_creators = __webpack_require__(670);

var tagVideoActions = _interopRequireWildcard(_tag_video_action_creators);

var _tag_video_module = __webpack_require__(671);

var _tag_video_module2 = _interopRequireDefault(_tag_video_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagVideoActions.tagVideoLoading({}, store));
    return _tag_video_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(tagVideoActions.tagVideoLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(tagVideoActions.tagVideoLoadError(err, store));
      _logger_service2.default.error(err, 'Error in tag video actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagVideoLoading = tagVideoLoading;
exports.tagVideoLoaded = tagVideoLoaded;
exports.tagVideoLoadError = tagVideoLoadError;
// import { canUseDOM } from 'exenv';

function tagVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_VIDEO_LOADING',
    tagVideo: resp,
    store: store
  };
}

function tagVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_VIDEO_LOADED',
    tagVideo: resp,
    store: store
  };
}

function tagVideoLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_VIDEO_ERROR',
    tagVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tagJwIdMap = {
  default: 'R6of2m4z',
  'living-smarter': 'Tdu1z6L9'
};

var CategoryPageVideo = function (_Base) {
  _inherits(CategoryPageVideo, _Base);

  function CategoryPageVideo() {
    _classCallCheck(this, CategoryPageVideo);

    return _possibleConstructorReturn(this, (CategoryPageVideo.__proto__ || Object.getPrototypeOf(CategoryPageVideo)).apply(this, arguments));
  }

  _createClass(CategoryPageVideo, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var tag = _ref.tag;

      var state = store.getState();
      var id = tagJwIdMap[this.cleanParam(tag)] || tagJwIdMap.default;
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'content.jwplatform.com';
      var options = {};

      var cacheKeyUrl = 'https://' + host + '/feeds/' + id + '.json';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryPageVideo;
}(_base_model2.default);

exports.default = CategoryPageVideo;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryAllFeed = function (_Base) {
  _inherits(CategoryAllFeed, _Base);

  function CategoryAllFeed() {
    _classCallCheck(this, CategoryAllFeed);

    return _possibleConstructorReturn(this, (CategoryAllFeed.__proto__ || Object.getPrototypeOf(CategoryAllFeed)).apply(this, arguments));
  }

  _createClass(CategoryAllFeed, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var tag = _ref.tag,
          person = _ref.person,
          magazine = _ref.magazine,
          company = _ref.company,
          page = _ref.page,
          product = _ref.product;

      var pageParams = page ? '&page=' + page : '';
      var total = 20;
      var tagOrPerson = this.cleanParam(tag || person || company || product);
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var method = magazine ? 'all-posts-tag-slugs' : 'posts-tag-slugs/' + site;

      var cacheKeyUrl = '' + protocol + host + '/api/v2/' + method + '/' + tagOrPerson + '?total=' + total + pageParams + '&with_body=0';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CategoryAllFeed;
}(_base_model2.default);

exports.default = CategoryAllFeed;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchTag;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _tag_scrolling_module_action_creators = __webpack_require__(674);

var tagScrollingModuleActions = _interopRequireWildcard(_tag_scrolling_module_action_creators);

var _tag_scrolling_module = __webpack_require__(675);

var _tag_scrolling_module2 = _interopRequireDefault(_tag_scrolling_module);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchTag(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagScrollingModuleActions.tagScrollingModuleLoading({}, store));
    return _tag_scrolling_module2.default.fetch(params, store).then(function handleTagDetailData(TagData) {
      dispatch(tagScrollingModuleActions.tagScrollingModuleLoaded(TagData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(tagScrollingModuleActions.tagScrollingModuleLoadError(err, store));
      _logger_service2.default.error(err, 'Error in tag scrolling module actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagScrollingModuleLoading = tagScrollingModuleLoading;
exports.tagScrollingModuleLoaded = tagScrollingModuleLoaded;
exports.tagScrollingModuleLoadError = tagScrollingModuleLoadError;
// import { canUseDOM } from 'exenv';

function tagScrollingModuleLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_SCROLLING_MODULE_LOADING',
    tagScrollingModule: resp,
    store: store
  };
}

function tagScrollingModuleLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_SCROLLING_MODULE_LOADED',
    tagScrollingModule: {
      posts: resp.posts,
      tag: resp.tag
    },
    store: store
  };
}

function tagScrollingModuleLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_SCROLLING_MODULE_ERROR',
    tagScrollingModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagScrollingModule = function (_Base) {
  _inherits(TagScrollingModule, _Base);

  function TagScrollingModule() {
    _classCallCheck(this, TagScrollingModule);

    return _possibleConstructorReturn(this, (TagScrollingModule.__proto__ || Object.getPrototypeOf(TagScrollingModule)).apply(this, arguments));
  }

  _createClass(TagScrollingModule, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var tag = _ref.tag;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/tag-scrolling-module-posts/' + site + '/' + this.cleanParam(tag) + '?total=20';

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return TagScrollingModule;
}(_base_model2.default);

exports.default = TagScrollingModule;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _tag_promo_banner_action_creators = __webpack_require__(677);

var tagPromoBannerActions = _interopRequireWildcard(_tag_promo_banner_action_creators);

var _tag_promo_banner = __webpack_require__(678);

var _tag_promo_banner2 = _interopRequireDefault(_tag_promo_banner);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagPromoBannerActions.tagPromoBannerLoading({}, store));
    return _tag_promo_banner2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(tagPromoBannerActions.tagPromoBannerLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(tagPromoBannerActions.tagPromoBannerLoadError(err, store));
      _logger_service2.default.error(err, 'Error in tagPromoBanner actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagPromoBannerLoading = tagPromoBannerLoading;
exports.tagPromoBannerLoaded = tagPromoBannerLoaded;
exports.tagPromoBannerLoadError = tagPromoBannerLoadError;
// import { canUseDOM } from 'exenv';

function tagPromoBannerLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_PROMO_BANNER_LOADING',
    tagPromoBanner: resp,
    store: store
  };
}

function tagPromoBannerLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_PROMO_BANNER_LOADED',
    tagPromoBanner: resp.tagPromoBanner,
    store: store
  };
}

function tagPromoBannerLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_PROMO_BANNER_ERROR',
    tagPromoBanner: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagPromoBanner = function (_Base) {
  _inherits(TagPromoBanner, _Base);

  function TagPromoBanner() {
    _classCallCheck(this, TagPromoBanner);

    return _possibleConstructorReturn(this, (TagPromoBanner.__proto__ || Object.getPrototypeOf(TagPromoBanner)).apply(this, arguments));
  }

  _createClass(TagPromoBanner, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var tag = _ref.tag;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/tag-promo-banner/' + site + '/' + this.cleanParam(tag);

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return TagPromoBanner;
}(_base_model2.default);

exports.default = TagPromoBanner;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _tag_featured_feed_action_creators = __webpack_require__(680);

var tagTagFeaturedActions = _interopRequireWildcard(_tag_featured_feed_action_creators);

var _tag_featured_feed = __webpack_require__(681);

var _tag_featured_feed2 = _interopRequireDefault(_tag_featured_feed);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(tagTagFeaturedActions.tagFeaturedFeedLoading({}, store));
    return _tag_featured_feed2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(tagTagFeaturedActions.tagFeaturedFeedLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (params.tag !== 'living-smarter') {
        if (status === 404) {
          dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
        }
      }
      dispatch(tagTagFeaturedActions.tagFeaturedFeedLoadError(err, store));
      _logger_service2.default.error(err, 'Error in tag featured feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagFeaturedFeedLoading = tagFeaturedFeedLoading;
exports.tagFeaturedFeedLoaded = tagFeaturedFeedLoaded;
exports.tagFeaturedFeedLoadError = tagFeaturedFeedLoadError;
// import { canUseDOM } from 'exenv';

function tagFeaturedFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_FEATURED_FEED_LOADING',
    tagFeaturedFeed: resp,
    store: store
  };
}

function tagFeaturedFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_FEATURED_FEED_LOADED',
    tagFeaturedFeed: {
      featured: resp.featured,
      top: resp.top,
      tag: resp.tag,
      source: resp.source
    },
    store: store
  };
}

function tagFeaturedFeedLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'TAG_FEATURED_FEED_ERROR',
    tagFeaturedFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagFeatured = function (_Base) {
  _inherits(TagFeatured, _Base);

  function TagFeatured() {
    _classCallCheck(this, TagFeatured);

    return _possibleConstructorReturn(this, (TagFeatured.__proto__ || Object.getPrototypeOf(TagFeatured)).apply(this, arguments));
  }

  _createClass(TagFeatured, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var tag = _ref.tag;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/tag-featured-feed/' + site + '/' + this.cleanParam(tag);

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return TagFeatured;
}(_base_model2.default);

exports.default = TagFeatured;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMagazineIssuePosts;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _magazine_issue_posts_action_creators = __webpack_require__(683);

var magazineIssuePostsActions = _interopRequireWildcard(_magazine_issue_posts_action_creators);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _magazine_issue_posts_model = __webpack_require__(684);

var _magazine_issue_posts_model2 = _interopRequireDefault(_magazine_issue_posts_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMagazineIssuePosts(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(magazineIssuePostsActions.magazineIssuePostsLoading({}, store));
    return _magazine_issue_posts_model2.default.fetch(params, store).then(function handleMagazineIssuePostsData(magazineIssuePostsData) {
      dispatch(magazineIssuePostsActions.magazineIssuePostsLoaded(magazineIssuePostsData.data, store));
    }).catch(function handleMagazineIssuePostsError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(magazineIssuePostsActions.magazineIssuePostsError(err.data, store));
      _logger_service2.default.error(err, 'Error in fetchMagazineIssuePosts actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.magazineIssuePostsLoading = magazineIssuePostsLoading;
exports.magazineIssuePostsLoaded = magazineIssuePostsLoaded;
exports.magazineIssuePostsError = magazineIssuePostsError;
// import { canUseDOM } from 'exenv';

function magazineIssuePostsLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_ISSUE_POSTS_LOADING',
    magazineIssuePosts: resp,
    store: store
  };
}

function magazineIssuePostsLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_ISSUE_POSTS_LOADED',
    magazineIssuePosts: resp,
    store: store
  };
}

function magazineIssuePostsError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MAGAZINE_ISSUE_POSTS_ERROR',
    magazineIssuePosts: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MagazineIssuePostsModel = function (_Base) {
  _inherits(MagazineIssuePostsModel, _Base);

  function MagazineIssuePostsModel() {
    _classCallCheck(this, MagazineIssuePostsModel);

    return _possibleConstructorReturn(this, (MagazineIssuePostsModel.__proto__ || Object.getPrototypeOf(MagazineIssuePostsModel)).apply(this, arguments));
  }

  _createClass(MagazineIssuePostsModel, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      // const site = get(state, 'config.site');
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var issueNumber = (0, _get2.default)(params, 'tag', '').replace('issue-', '');
      var cacheKeyUrl = '' + protocol + host + '/api/v1/magazine/get-magazine-posts-by-issue/' + issueNumber;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return MagazineIssuePostsModel;
}(_base_model2.default);

exports.default = MagazineIssuePostsModel;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/section/:tag/:page',
    component: _tag_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _tag_page_state_manager2.default)(store)
  };
};

var _tag_page = __webpack_require__(150);

var _tag_page2 = _interopRequireDefault(_tag_page);

var _tag_page_state_manager = __webpack_require__(80);

var _tag_page_state_manager2 = _interopRequireDefault(_tag_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/section/living-smarter',
    component: _sponsored_kia_tag_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _tag_page_state_manager2.default)(store, 'living-smarter')
  };
};

var _sponsored_kia_tag_page = __webpack_require__(687);

var _sponsored_kia_tag_page2 = _interopRequireDefault(_sponsored_kia_tag_page);

var _tag_page_state_manager = __webpack_require__(80);

var _tag_page_state_manager2 = _interopRequireDefault(_tag_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _video_module = __webpack_require__(66);

var _video_module2 = _interopRequireDefault(_video_module);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _advertorial = __webpack_require__(28);

var _advertorial2 = _interopRequireDefault(_advertorial);

var _tag_all_feed_action_creators = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Tag = function (_Component) {
  _inherits(Tag, _Component);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
  }

  _createClass(Tag, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          tagPage = _props.tagPage,
          tagVideo = _props.tagVideo,
          tagFeaturedFeed = _props.tagFeaturedFeed,
          tagAllFeed = _props.tagAllFeed;
      /*
      if (tagPage.error || tagFeaturedFeed.error) {
        return (
          <section className="tag-page">
            <article className="tag-page__main--error-pg">
              <NotFound />
            </article>
          </section>
        );
      }
      */

      if (tagPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(tagPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgName = 'Crossover To A Smarter Life Presented By Kia Niro';
      var pgDesc = (0, _get2.default)(tagFeaturedFeed, 'tag.description');
      var tags = (0, _get2.default)(tagAllFeed, 'posts[0].tags');
      var advertorial = (0, _advertorial.isAdvertorial)(tags);
      var currentSite = (0, _get2.default)(config, 'site');

      return _react2.default.createElement(
        'section',
        {
          className: 'tag-page tag-page--kia ' + (advertorial ? 'tag-page--advertorial' : '')
        },
        _react2.default.createElement(
          'a',
          { href: 'https://www.kia.com/niro' },
          _react2.default.createElement('img', {
            className: 'kia-banner',
            alt: 'Kia',
            src: 'https://images.fastcompany.net/image/upload/w_1280,q_auto,f_auto,fl_lossy/v1491257339/fcweb/kia_full_screen_banner_v5.jpg'
          })
        ),
        advertorial ? _react2.default.createElement(_advertorial2.default, {
          modifier: 'tag-page',
          tags: tags,
          adModel: combinedAdModel
        }) : '',
        advertorial ? _react2.default.createElement(
          'section',
          { className: 'all-feed' },
          _react2.default.createElement(_slug2.default, { slugName: pgName, className: 'tag-page' }),
          _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          ),
          _react2.default.createElement(_all_feed2.default, {
            adModel: combinedAdModel,
            modifier: 'advertorial',
            stories: (0, _get2.default)(tagAllFeed, 'posts'),
            allRendered: (0, _get2.default)(tagAllFeed, 'allRendered'),
            updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
            currentSite: currentSite
          })
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_video_module2.default, {
            config: config,
            slugName: 'CROSSOVER TO A SMARTER LIFE PRESENTED BY KIA NIRO',
            data: tagVideo,
            playerid: 'xb9OmFp1',
            stories: tagVideo.playlist,
            currentSite: currentSite
          }),
          (0, _get2.default)(tagFeaturedFeed, 'top.length') ? _react2.default.createElement(
            'div',
            { className: 'tag-page__ff-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
          ) : '',
          (0, _get2.default)(tagAllFeed, 'posts').length !== 0 && _react2.default.createElement(_all_feed2.default, {
            adModel: combinedAdModel,
            stories: (0, _get2.default)(tagAllFeed, 'posts'),
            allRendered: (0, _get2.default)(tagAllFeed, 'allRendered'),
            updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
            currentSite: currentSite
          })
        ),
        (0, _get2.default)(tagVideo, 'playlist.length') ? _react2.default.createElement(
          'div',
          { className: 'tag-page__video-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_3' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
        ) : '',
        _react2.default.createElement('div', {
          dangerouslySetInnerHTML: {
            __html: '<script type="text/javascript">/* <![CDATA[ */ var google_conversion_id = 972240864; var google_custom_params = window.google_tag_params; var google_remarketing_only = true; /* ]]> */</script><script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></script><noscript><div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/972240864/?guid=ON&amp;script=0"/></div></noscript>'
          }
        })
      );
    }
  }]);

  return Tag;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    tagFeaturedFeed: {
      featured: (0, _get2.default)(state, 'tagFeaturedFeed.featured') || [],
      top: (0, _get2.default)(state, 'tagFeaturedFeed.top') || [],
      tag: (0, _get2.default)(state, 'tagFeaturedFeed.tag') || {},
      source: (0, _get2.default)(state, 'tagFeaturedFeed.source') || '',
      error: (0, _get2.default)(state, 'tagFeaturedFeed.error') || false
    },
    tagVideo: (0, _get2.default)(state, 'tagVideo.data') || {
      playlist: [],
      title: '',
      feedid: ''
    },
    tagPage: (0, _get2.default)(state, 'tagPage') || { error: true },
    tagScrollingModule: (0, _get2.default)(state, 'tagScrollingModule.data.posts') || [],
    tagAllFeed: {
      totalPosts: (0, _get2.default)(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: (0, _get2.default)(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: (0, _get2.default)(state, 'tagAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'tagAllFeed.data.posts', [])
    }
  };
}

Tag.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  tagPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  tagFeaturedFeed: _propTypes2.default.shape({
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    tag: _propTypes2.default.object,
    source: _propTypes2.default.string,
    error: _propTypes2.default.bool
  }).isRequired,
  tagVideo: _propTypes2.default.shape({
    playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    feedid: _propTypes2.default.string,
    title: _propTypes2.default.string
  }).isRequired,
  tagAllFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool,
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number
  }).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Tag);

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/section/urban-x',
    component: _sponsored_tag_page_custom2.default,
    exact: true,
    strict: true,
    loadData: (0, _tag_page_state_manager2.default)(store, 'urban-x')
  };
};

var _sponsored_tag_page_custom = __webpack_require__(689);

var _sponsored_tag_page_custom2 = _interopRequireDefault(_sponsored_tag_page_custom);

var _tag_page_state_manager = __webpack_require__(80);

var _tag_page_state_manager2 = _interopRequireDefault(_tag_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _advertorial = __webpack_require__(28);

var _advertorial2 = _interopRequireDefault(_advertorial);

var _tag_all_feed_action_creators = __webpack_require__(46);

var _format_post_object = __webpack_require__(135);

var _format_post_object2 = _interopRequireDefault(_format_post_object);

var _cloudinary_asset_util = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Tag = function (_Component) {
  _inherits(Tag, _Component);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
  }

  _createClass(Tag, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          tagPage = _props.tagPage,
          tagFeaturedFeed = _props.tagFeaturedFeed,
          tagAllFeed = _props.tagAllFeed;


      if (tagPage.error || tagFeaturedFeed.error) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (tagPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(tagPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var pgName = (0, _get2.default)(tagFeaturedFeed, 'tag.name');
      var pgDesc = (0, _get2.default)(tagFeaturedFeed, 'tag.description');
      var tags = (0, _get2.default)(tagAllFeed, 'posts[0].tags');
      var advertorial = (0, _advertorial.isAdvertorial)(tags);
      var imgSize = _cloudinary_asset_util.imageSizesLookup[1];
      var stories = (0, _get2.default)(tagAllFeed, 'posts') || [];

      return _react2.default.createElement(
        'section',
        {
          className: 'tag-page tag-page--custom ' + (advertorial ? 'tag-page--advertorial' : '')
        },
        advertorial ? _react2.default.createElement(_advertorial2.default, {
          modifier: 'tag-page',
          tags: tags,
          adModel: combinedAdModel
        }) : '',
        advertorial ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_slug2.default, { slugName: pgName, className: 'tag-page', advertorial: true }),
          _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          ),
          _react2.default.createElement(_card2.default, {
            config: config,
            type: 'featured',
            metadata: (0, _format_post_object2.default)({
              props: this.props,
              post: (0, _get2.default)(stories, '[0]'),
              imgSize: imgSize
            }),
            fullPageAdvertorial: advertorial
          }),
          (0, _get2.default)(tagFeaturedFeed, 'top.length') ? _react2.default.createElement(
            'div',
            { className: 'tag-page__video-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
          ) : '',
          _react2.default.createElement(_all_feed2.default, {
            adModel: combinedAdModel,
            modifier: 'advertorial',
            stories: (stories || []).slice(1),
            allRendered: (0, _get2.default)(tagAllFeed, 'allRendered'),
            updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
            config: config
          }),
          _react2.default.createElement(
            'div',
            { className: 'tag-page__ff-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' }))
          )
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_all_feed2.default, {
            adModel: combinedAdModel,
            stories: (0, _get2.default)(tagAllFeed, 'posts'),
            allRendered: (0, _get2.default)(tagAllFeed, 'allRendered'),
            updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
            config: config
          }),
          _react2.default.createElement(
            'div',
            { className: 'tag-page__ff-ad-container' },
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
            _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_2' }))
          )
        )
      );
    }
  }]);

  return Tag;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    currentSite: state.config.site,
    tagFeaturedFeed: {
      featured: (0, _get2.default)(state, 'tagFeaturedFeed.featured') || [],
      top: (0, _get2.default)(state, 'tagFeaturedFeed.top') || [],
      tag: (0, _get2.default)(state, 'tagFeaturedFeed.tag') || {},
      source: (0, _get2.default)(state, 'tagFeaturedFeed.source') || '',
      error: (0, _get2.default)(state, 'tagFeaturedFeed.error') || false
    },
    tagPage: (0, _get2.default)(state, 'tagPage') || { error: true },
    tagScrollingModule: (0, _get2.default)(state, 'tagScrollingModule.data.posts') || [],
    tagAllFeed: {
      totalPosts: (0, _get2.default)(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: (0, _get2.default)(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: (0, _get2.default)(state, 'tagAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'tagAllFeed.data.posts', [])
      // scrollingModule: get(state, 'scrollingModule.data.posts') || []
    } };
}

Tag.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  tagPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  tagFeaturedFeed: _propTypes2.default.shape({
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    tag: _propTypes2.default.object,
    source: _propTypes2.default.string,
    error: _propTypes2.default.bool
  }).isRequired,
  tagAllFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool,
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number
  }).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Tag);

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return [{
    path: '/magazine/:tag(\\issue-\\d+)',
    component: _magazine_tag_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _tag_page_state_manager2.default)(store, 'magazine')
  }, {
    path: '/magazine/:tag(\\issue-\\d+-\\d+)',
    component: _magazine_tag_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _tag_page_state_manager2.default)(store, 'magazine')
  }, {
    path: '/magazine/:tag',
    component: _tag_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _tag_page_state_manager2.default)(store)
  }];
};

var _magazine_tag_page = __webpack_require__(691);

var _magazine_tag_page2 = _interopRequireDefault(_magazine_tag_page);

var _tag_page = __webpack_require__(150);

var _tag_page2 = _interopRequireDefault(_tag_page);

var _tag_page_state_manager = __webpack_require__(80);

var _tag_page_state_manager2 = _interopRequireDefault(_tag_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get2 = __webpack_require__(0);

var _get3 = _interopRequireDefault(_get2);

var _isEmpty = __webpack_require__(27);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _chunk = __webpack_require__(103);

var _chunk2 = _interopRequireDefault(_chunk);

var _cloneDeep = __webpack_require__(74);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _reactRouter = __webpack_require__(22);

var _format_post_object = __webpack_require__(135);

var _format_post_object2 = _interopRequireDefault(_format_post_object);

var _cloudinary_asset_util = __webpack_require__(30);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _magazine_archive = __webpack_require__(141);

var _magazine_archive2 = _interopRequireDefault(_magazine_archive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var MagazineTag = function (_Component) {
  _inherits(MagazineTag, _Component);

  function MagazineTag() {
    _classCallCheck(this, MagazineTag);

    return _possibleConstructorReturn(this, (MagazineTag.__proto__ || Object.getPrototypeOf(MagazineTag)).apply(this, arguments));
  }

  _createClass(MagazineTag, [{
    key: 'renderTagRows',
    value: function renderTagRows(posts, key) {
      var _this2 = this;

      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var elements = [];
      var tagPosts = (0, _cloneDeep2.default)(posts);
      var totalPosts = tagPosts && tagPosts.length ? tagPosts.length : 0;

      if (totalPosts > 1) {
        if (title) {
          elements.push(_react2.default.createElement(_slug2.default, {
            slugName: title,
            className: 'tag-page-section',
            key: key + '-slug'
          }));
        }

        var firstRow = tagPosts.splice(0, 2);
        var chunks = (0, _chunk2.default)(tagPosts, 3);
        var totalChuncks = chunks.length;
        var lastChunk = chunks[totalChuncks - 1];

        if (lastChunk && lastChunk.length === 1) {
          chunks[totalChuncks - 1].push(lastChunk[0]);
          chunks.pop();
        }

        var seperatedPosts = [firstRow].concat(_toConsumableArray(chunks));

        seperatedPosts.map(function (rowPosts, index) {
          return elements.push(_react2.default.createElement(
            'div',
            { className: 'row', key: key + '-row-' + (index + 1) },
            rowPosts.map(function (post) {
              return _react2.default.createElement(_card2.default, {
                config: _this2.props.config,
                key: post.id,
                metadata: (0, _format_post_object2.default)({
                  post: post,
                  imgSize: _cloudinary_asset_util.imageSizesLookup[rowPosts.length],
                  allowTextOnly: true
                }),
                totalCards: rowPosts.length
              });
            })
          ));
        });
      }

      return elements;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.tagPage.error || this.props.magazineIssuePosts.error) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.tagPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          tagPage = _props.tagPage,
          magazineIssuePosts = _props.magazineIssuePosts,
          config = _props.config,
          match = _props.match;

      var adData = (0, _get3.default)(tagPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get3.default)(adData, 'config.baseConfig') }, { definitions: (0, _get3.default)(adData, 'config.definitions') }, { model: (0, _get3.default)(adData, 'model') });

      var _get = (0, _get3.default)(magazineIssuePosts, 'data', {}),
          coverStory = _get.coverStory,
          next = _get.next,
          departments = _get.departments,
          issue = _get.issue,
          magazineArchive = _get.magazineArchive;

      var features = (0, _get3.default)(magazineIssuePosts, 'data.features', []);
      var hasFeatures = features.length > 1;
      var hasTopRow = (0, _get3.default)(issue, 'title') && (0, _get3.default)(issue, 'image') && !(0, _isEmpty2.default)(coverStory);
      var issueNumber = match.params.tag.replace('issue-', '');

      return _react2.default.createElement(
        'section',
        { className: 'tag-page tag-page--magazine' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(
            'h1',
            { className: 'page-description' },
            (0, _get3.default)(issue, 'description', '')
          ),
          _react2.default.createElement(_slug2.default, {
            slugName: (0, _get3.default)(issue, 'title', 'Fast Company Issue ' + issueNumber),
            className: 'tag-page'
          })
        ),
        hasTopRow ? _react2.default.createElement(
          'div',
          { className: 'row row--magazine row__top' },
          _react2.default.createElement(
            'div',
            { className: 'row__aside' },
            _react2.default.createElement(_card2.default, {
              config: config,
              type: 'magazine',
              metadata: issue,
              fullWidth: true,
              hasTitle: false,
              fullIssue: false
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row__main' },
            _react2.default.createElement(_card2.default, {
              config: config,
              type: 'featured',
              metadata: (0, _format_post_object2.default)({
                post: coverStory,
                imgSize: _cloudinary_asset_util.imageSizesLookup[1],
                allowTextOnly: true
              })
            })
          )
        ) : null,
        hasFeatures || !hasTopRow && hasFeatures ? [hasTopRow ? _react2.default.createElement(_slug2.default, {
          slugName: 'Features',
          className: 'tag-page-section',
          key: 'features-slug'
        }) : null, _react2.default.createElement(
          'div',
          { className: 'row', key: 'features-3-row' },
          features.slice(0, 2).map(function (post) {
            return _react2.default.createElement(_card2.default, {
              config: config,
              key: post.id,
              metadata: (0, _format_post_object2.default)({
                post: post,
                imgSize: _cloudinary_asset_util.imageSizesLookup[3],
                allowTextOnly: true
              }),
              index: 3
            });
          }),
          _react2.default.createElement(
            'div',
            { className: 'card card--default card--subscribe' },
            _react2.default.createElement(
              'a',
              { href: 'https://store.fastcompany.com/subscription-order/issuepage' },
              _react2.default.createElement('img', {
                className: 'subscribe--square',
                src: 'https://images.fastcompany.net/image/upload/v1510241760/fcweb/sub-ad-issue-v2_arfee5_nlh22x.png',
                alt: 'The future of business starts here. Subscribe now.'
              })
            )
          )
        ), this.renderTagRows(features.slice(2), 'features')] : null,
        this.renderTagRows(next, 'next', 'Next'),
        _react2.default.createElement(
          'div',
          { className: 'tag-page__ff-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        ),
        this.renderTagRows(departments, 'departments', 'Departments'),
        _react2.default.createElement(_magazine_archive2.default, { config: config, magazines: magazineArchive })
      );
    }
  }]);

  return MagazineTag;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    featuredSponsoredCard: (0, _get3.default)(state, 'featuredSponsoredCard.data') || {},
    tagFeaturedFeed: {
      featured: (0, _get3.default)(state, 'tagFeaturedFeed.featured') || [],
      top: (0, _get3.default)(state, 'tagFeaturedFeed.top') || [],
      tag: (0, _get3.default)(state, 'tagFeaturedFeed.tag') || {},
      source: (0, _get3.default)(state, 'tagFeaturedFeed.source') || '',
      error: (0, _get3.default)(state, 'tagFeaturedFeed.error') || false
    },
    tagVideo: (0, _get3.default)(state, 'tagVideo.data') || {
      playlist: [],
      title: '',
      feedid: ''
    },
    tagPage: (0, _get3.default)(state, 'tagPage') || { error: true },
    tagScrollingModule: (0, _get3.default)(state, 'tagScrollingModule.data') || {},
    tagPromoBanner: (0, _get3.default)(state, 'tagPromoBanner.data') || {},
    tagAllFeed: {
      totalPosts: (0, _get3.default)(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: (0, _get3.default)(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: (0, _get3.default)(state, 'tagAllFeed.data.allRendered', false),
      posts: (0, _get3.default)(state, 'tagAllFeed.data.posts', [])
    },
    magazineArchive: (0, _get3.default)(state, 'magazineArchive') || {},
    magazineIssuePosts: (0, _get3.default)(state, 'magazineIssuePosts') || { error: true }
  };
}

MagazineTag.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  match: _propTypes2.default.shape({}).isRequired,
  tagPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  tagFeaturedFeed: _propTypes2.default.shape({
    featured: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    top: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    tag: _propTypes2.default.object,
    source: _propTypes2.default.string,
    error: _propTypes2.default.bool
  }).isRequired,
  tagAllFeed: _propTypes2.default.shape({
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
    allRendered: _propTypes2.default.bool,
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number
  }).isRequired,
  magazineArchive: _propTypes2.default.shape({}).isRequired,
  magazineIssuePosts: _propTypes2.default.shape({
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(MagazineTag));

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/product/:product',
    component: _product_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _product_page_state_manager2.default)(store)
  };
};

var _product_page = __webpack_require__(693);

var _product_page2 = _interopRequireDefault(_product_page);

var _product_page_state_manager = __webpack_require__(694);

var _product_page_state_manager2 = _interopRequireDefault(_product_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _product_post = __webpack_require__(256);

var _product_post2 = _interopRequireDefault(_product_post);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _tag_all_feed_action_creators = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Product = function (_Component) {
  _inherits(Product, _Component);

  function Product() {
    _classCallCheck(this, Product);

    return _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).apply(this, arguments));
  }

  _createClass(Product, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          status = _props.status,
          config = _props.config,
          productPage = _props.productPage,
          product = _props.product,
          tagAllFeed = _props.tagAllFeed;


      if (status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (productPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'product-page' },
          _react2.default.createElement(
            'article',
            { className: 'product-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(productPage, 'ads');

      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      // const product = this.props.product;
      var productName = '' + (0, _get2.default)(product, 'name');

      return _react2.default.createElement(
        'section',
        { className: 'product-page' },
        _react2.default.createElement(
          'div',
          { className: 'post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'flexiblepushdown',
            region: 'articletop'
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'mobileleaderboard',
            region: 'articletop'
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true }))
        ),
        _react2.default.createElement(_product_post2.default, {
          config: config,
          product: product,
          combinedAdModel: combinedAdModel
        }),
        (0, _get2.default)(tagAllFeed, 'posts[0]') ? _react2.default.createElement(_all_feed2.default, {
          adModel: combinedAdModel,
          stories: (0, _get2.default)(tagAllFeed, 'posts'),
          allRendered: true,
          updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
          config: config,
          titleOverride: 'Stories about ' + productName
        }) : '',
        _react2.default.createElement(
          'div',
          { className: 'product-page__ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        )
      );
    }
  }]);

  return Product;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    product: (0, _get2.default)(state, 'product.data.rows[0]') || { error: true },
    productPage: (0, _get2.default)(state, 'productPage') || { error: true },
    tagAllFeed: {
      totalPosts: (0, _get2.default)(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: (0, _get2.default)(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: (0, _get2.default)(state, 'tagAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'tagAllFeed.data.posts', [])
    }
  };
}

Product.propTypes = {
  config: _propTypes2.default.shape({}),
  status: _propTypes2.default.number,
  product: _propTypes2.default.shape({}).isRequired,
  productPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object.isRequired,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }),
  tagAllFeed: _propTypes2.default.shape({
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number,
    allRendered: _propTypes2.default.bool,
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  })
};

Product.defaultProps = {
  config: {},
  status: 200,
  productPage: {
    isLoading: false,
    error: false,
    errorMessage: ''
  },
  tagAllFeed: {
    posts: [{}],
    allRendered: false
  }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Product);

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_product_page_actions = __webpack_require__(695);

var _async_product_page_actions2 = _interopRequireDefault(_async_product_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_product_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_product_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchProductPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _product_page_action_creators = __webpack_require__(696);

var productPageActions = _interopRequireWildcard(_product_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_tag_all_feed_actions = __webpack_require__(81);

var _async_tag_all_feed_actions2 = _interopRequireDefault(_async_tag_all_feed_actions);

var _async_product_actions = __webpack_require__(697);

var _async_product_actions2 = _interopRequireDefault(_async_product_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchProductPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(productPageActions.productPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_product_actions2.default)(params, store)(dispatch), (0, _async_tag_all_feed_actions2.default)(params, store, true)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(productPageActions.productPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(productPageActions.productPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productPageLoading = productPageLoading;
exports.productPageLoaded = productPageLoaded;
exports.productPageLoadError = productPageLoadError;
// import { canUseDOM } from 'exenv';

function productPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_PAGE_LOADING',
    productPage: resp,
    store: store
  };
}

function productPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_PAGE_LOADED',
    productPage: resp,
    store: store
  };
}

function productPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_PAGE_ERROR',
    productPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchProductDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _product_action_creators = __webpack_require__(698);

var productActions = _interopRequireWildcard(_product_action_creators);

var _product_model = __webpack_require__(699);

var _product_model2 = _interopRequireDefault(_product_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchProductDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') !== 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(productActions.productLoading({}, store));
    return _product_model2.default.fetch(params, store).then(function handleProductDetailData(ProductData) {
      dispatch(productActions.productLoaded(ProductData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(productActions.productLoadError(err, store));

      _logger_service2.default.error(err, 'Error in product actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productLoading = productLoading;
exports.productLoaded = productLoaded;
exports.productLoadError = productLoadError;
// import { canUseDOM } from 'exenv';

function productLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_LOADING',
    product: resp,
    store: store
  };
}

function productLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_LOADED',
    product: resp,
    store: store
  };
}

function productLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_ERROR',
    product: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Person = function (_Base) {
  _inherits(Person, _Base);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var product = _ref.product;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/product/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/product/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=' + this.cleanParam(product);
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Person;
}(_base_model2.default);

exports.default = Person;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/stuff/:section/:page',
    component: _product_index_section_page2.default,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: (0, _product_index_section_page_state_manager2.default)(store)
  };
};

var _product_index_section_page = __webpack_require__(257);

var _product_index_section_page2 = _interopRequireDefault(_product_index_section_page);

var _product_index_section_page_state_manager = __webpack_require__(701);

var _product_index_section_page_state_manager2 = _interopRequireDefault(_product_index_section_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_product_index_section_page_actions = __webpack_require__(702);

var _async_product_index_section_page_actions2 = _interopRequireDefault(_async_product_index_section_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_product_index_section_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_product_index_section_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchProductPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _product_index_section_page_action_creators = __webpack_require__(703);

var productIndexSectionPageActions = _interopRequireWildcard(_product_index_section_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_product_index_section_actions = __webpack_require__(704);

var _async_product_index_section_actions2 = _interopRequireDefault(_async_product_index_section_actions);

var _async_product_index_section_next_actions = __webpack_require__(707);

var _async_product_index_section_next_actions2 = _interopRequireDefault(_async_product_index_section_next_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchProductPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(productIndexSectionPageActions.productIndexSectionPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_product_index_section_actions2.default)(params, store)(dispatch), (0, _async_product_index_section_next_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(productIndexSectionPageActions.productIndexSectionPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(productIndexSectionPageActions.productIndexSectionPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productIndexSectionPageLoading = productIndexSectionPageLoading;
exports.productIndexSectionPageLoaded = productIndexSectionPageLoaded;
exports.productIndexSectionPageLoadError = productIndexSectionPageLoadError;
// import { canUseDOM } from 'exenv';

function productIndexSectionPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_PAGE_LOADING',
    productIndexSectionPage: resp,
    store: store
  };
}

function productIndexSectionPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_PAGE_LOADED',
    productIndexSectionPage: resp,
    store: store
  };
}

function productIndexSectionPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_PAGE_ERROR',
    productIndexSectionPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchProductDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _product_index_section_action_creators = __webpack_require__(705);

var productIndexSectionActions = _interopRequireWildcard(_product_index_section_action_creators);

var _product_index_section_model = __webpack_require__(706);

var _product_index_section_model2 = _interopRequireDefault(_product_index_section_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchProductDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcompany') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(productIndexSectionActions.productIndexSectionLoading({}, store));
    return _product_index_section_model2.default.fetch(params, store).then(function handleProductDetailData(ProductData) {
      dispatch(productIndexSectionActions.productIndexSectionLoaded(ProductData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(productIndexSectionActions.productIndexSectionLoadError(err, store));

      _logger_service2.default.error(err, 'Error in product actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productIndexSectionLoading = productIndexSectionLoading;
exports.productIndexSectionLoaded = productIndexSectionLoaded;
exports.productIndexSectionLoadError = productIndexSectionLoadError;
// import { canUseDOM } from 'exenv';

function productIndexSectionLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_LOADING',
    productIndexSection: resp,
    store: store
  };
}

function productIndexSectionLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_LOADED',
    productIndexSection: resp,
    store: store
  };
}

function productIndexSectionLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_ERROR',
    productIndexSection: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Product = function (_Base) {
  _inherits(Product, _Base);

  function Product() {
    _classCallCheck(this, Product);

    return _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).apply(this, arguments));
  }

  _createClass(Product, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var section = _ref.section,
          page = _ref.page;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      var pattern = section;
      // https://api.fastcompany.com/v1/packages/person/search/pattern?page=1&rows_per_page=60&pattern=a
      // console.log('>>> ', page, section)
      // Don't worry about this token. Can be public. Talked to Harry.
      if (pattern === '0-9') {
        pattern = '%5B0-9%5D';
      }

      var cacheKeyUrl = 'https://' + host + '/v1/packages/product/search/pattern?page=' + page + '&rows_per_page=40&pattern=' + pattern + '&allow_index=1';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Product;
}(_base_model2.default);

exports.default = Product;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchProductDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _product_index_section_next_action_creators = __webpack_require__(708);

var productIndexSectionNextActions = _interopRequireWildcard(_product_index_section_next_action_creators);

var _product_index_section_next_model = __webpack_require__(709);

var _product_index_section_next_model2 = _interopRequireDefault(_product_index_section_next_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchProductDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcompany') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(productIndexSectionNextActions.productIndexSectionNextLoading({}, store));
    return _product_index_section_next_model2.default.fetch(params, store).then(function handleProductDetailData(ProductData) {
      dispatch(productIndexSectionNextActions.productIndexSectionNextLoaded(ProductData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(productIndexSectionNextActions.productIndexSectionNextLoadError(err, store));

      _logger_service2.default.error(err, 'Error in product actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productIndexSectionNextLoading = productIndexSectionNextLoading;
exports.productIndexSectionNextLoaded = productIndexSectionNextLoaded;
exports.productIndexSectionNextLoadError = productIndexSectionNextLoadError;
// import { canUseDOM } from 'exenv';

function productIndexSectionNextLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_NEXT_LOADING',
    productIndexSectionNext: resp,
    store: store
  };
}

function productIndexSectionNextLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_NEXT_LOADED',
    productIndexSectionNext: resp,
    store: store
  };
}

function productIndexSectionNextLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_SECTION_NEXT_ERROR',
    productIndexSectionNext: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Product = function (_Base) {
  _inherits(Product, _Base);

  function Product() {
    _classCallCheck(this, Product);

    return _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).apply(this, arguments));
  }

  _createClass(Product, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var section = _ref.section,
          page = _ref.page;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      var pattern = section;

      if (pattern === '0-9') {
        pattern = '%5B0-9%5D';
      }
      // https://api.fastcompany.com/v1/packages/product/search/pattern?page=1&rows_per_page=60&pattern=a

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/product/search/pattern?page=' + (Number(page) + 1) + '&rows_per_page=40&pattern=' + pattern + '&allow_index=1';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Product;
}(_base_model2.default);

exports.default = Product;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/stuff',
    component: _product_index_section_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _product_index_page_state_manager2.default)(store)
  };
};

var _product_index_section_page = __webpack_require__(257);

var _product_index_section_page2 = _interopRequireDefault(_product_index_section_page);

var _product_index_page_state_manager = __webpack_require__(711);

var _product_index_page_state_manager2 = _interopRequireDefault(_product_index_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_product_index_page_actions = __webpack_require__(712);

var _async_product_index_page_actions2 = _interopRequireDefault(_async_product_index_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_product_index_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_product_index_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchProductPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _product_index_page_action_creators = __webpack_require__(713);

var productIndexPageActions = _interopRequireWildcard(_product_index_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchProductPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    if ((0, _get2.default)(state, 'config.site') !== 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(productIndexPageActions.productIndexPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(productIndexPageActions.productIndexPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(productIndexPageActions.productIndexPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productIndexPageLoading = productIndexPageLoading;
exports.productIndexPageLoaded = productIndexPageLoaded;
exports.productIndexPageLoadError = productIndexPageLoadError;
// import { canUseDOM } from 'exenv';

function productIndexPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_PAGE_LOADING',
    productIndexPage: resp,
    store: store
  };
}

function productIndexPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_PAGE_LOADED',
    productIndexPage: resp,
    store: store
  };
}

function productIndexPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PRODUCT_INDEX_PAGE_ERROR',
    productIndexPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/person',
    component: _person_index_section_page2.default,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: (0, _person_index_section_page_state_manager2.default)(store)
  };
};

var _person_index_section_page = __webpack_require__(258);

var _person_index_section_page2 = _interopRequireDefault(_person_index_section_page);

var _person_index_section_page_state_manager = __webpack_require__(259);

var _person_index_section_page_state_manager2 = _interopRequireDefault(_person_index_section_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _person_index_section_page_action_creators = __webpack_require__(716);

var personIndexSectionPageActions = _interopRequireWildcard(_person_index_section_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_person_index_section_actions = __webpack_require__(717);

var _async_person_index_section_actions2 = _interopRequireDefault(_async_person_index_section_actions);

var _async_person_index_section_next_actions = __webpack_require__(720);

var _async_person_index_section_next_actions2 = _interopRequireDefault(_async_person_index_section_next_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(personIndexSectionPageActions.personIndexSectionPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_person_index_section_actions2.default)(params, store)(dispatch), (0, _async_person_index_section_next_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(personIndexSectionPageActions.personIndexSectionPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(personIndexSectionPageActions.personIndexSectionPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personIndexSectionPageLoading = personIndexSectionPageLoading;
exports.personIndexSectionPageLoaded = personIndexSectionPageLoaded;
exports.personIndexSectionPageLoadError = personIndexSectionPageLoadError;
// import { canUseDOM } from 'exenv';

function personIndexSectionPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_PAGE_LOADING',
    personIndexSectionPage: resp,
    store: store
  };
}

function personIndexSectionPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_PAGE_LOADED',
    personIndexSectionPage: resp,
    store: store
  };
}

function personIndexSectionPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_PAGE_ERROR',
    personIndexSectionPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _person_index_section_action_creators = __webpack_require__(718);

var personIndexSectionActions = _interopRequireWildcard(_person_index_section_action_creators);

var _person_index_section_model = __webpack_require__(719);

var _person_index_section_model2 = _interopRequireDefault(_person_index_section_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(personIndexSectionActions.personIndexSectionLoading({}, store));
    return _person_index_section_model2.default.fetch(params, store).then(function handlePersonDetailData(PersonData) {
      dispatch(personIndexSectionActions.personIndexSectionLoaded(PersonData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(personIndexSectionActions.personIndexSectionLoadError(err, store));

      _logger_service2.default.error(err, 'Error in person actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personIndexSectionLoading = personIndexSectionLoading;
exports.personIndexSectionLoaded = personIndexSectionLoaded;
exports.personIndexSectionLoadError = personIndexSectionLoadError;
// import { canUseDOM } from 'exenv';

function personIndexSectionLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_LOADING',
    personIndexSection: resp,
    store: store
  };
}

function personIndexSectionLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_LOADED',
    personIndexSection: resp,
    store: store
  };
}

function personIndexSectionLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_ERROR',
    personIndexSection: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Person = function (_Base) {
  _inherits(Person, _Base);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var section = _ref.section,
          page = _ref.page;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/pattern?page=1&rows_per_page=60&pattern=a
      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/person/search/pattern?page=' + page + '&rows_per_page=40&pattern=' + section + '&allow_index=1';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Person;
}(_base_model2.default);

exports.default = Person;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _person_index_section_next_action_creators = __webpack_require__(721);

var personIndexSectionNextActions = _interopRequireWildcard(_person_index_section_next_action_creators);

var _person_index_section_next_model = __webpack_require__(722);

var _person_index_section_next_model2 = _interopRequireDefault(_person_index_section_next_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(personIndexSectionNextActions.personIndexSectionNextLoading({}, store));
    return _person_index_section_next_model2.default.fetch(params, store).then(function handlePersonDetailData(PersonData) {
      dispatch(personIndexSectionNextActions.personIndexSectionNextLoaded(PersonData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(personIndexSectionNextActions.personIndexSectionNextLoadError(err, store));

      _logger_service2.default.error(err, 'Error in person actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personIndexSectionNextLoading = personIndexSectionNextLoading;
exports.personIndexSectionNextLoaded = personIndexSectionNextLoaded;
exports.personIndexSectionNextLoadError = personIndexSectionNextLoadError;
// import { canUseDOM } from 'exenv';

function personIndexSectionNextLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_NEXT_LOADING',
    personIndexSectionNext: resp,
    store: store
  };
}

function personIndexSectionNextLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_NEXT_LOADED',
    personIndexSectionNext: resp,
    store: store
  };
}

function personIndexSectionNextLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_INDEX_SECTION_NEXT_ERROR',
    personIndexSectionNext: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Person = function (_Base) {
  _inherits(Person, _Base);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var section = _ref.section,
          page = _ref.page;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/pattern?page=1&rows_per_page=60&pattern=a

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/person/search/pattern?page=' + (Number(page) + 1) + '&rows_per_page=40&pattern=' + section + '&allow_index=1';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Person;
}(_base_model2.default);

exports.default = Person;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/person/:section/:page',
    component: _person_index_section_page2.default,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: (0, _person_index_section_page_state_manager2.default)(store)
  };
};

var _person_index_section_page = __webpack_require__(258);

var _person_index_section_page2 = _interopRequireDefault(_person_index_section_page);

var _person_index_section_page_state_manager = __webpack_require__(259);

var _person_index_section_page_state_manager2 = _interopRequireDefault(_person_index_section_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/innovation-by-design/:year',
    component: _innovation_by_design_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _innovation_by_design_page_state_manager2.default)(store),
    autoScrollOff: true
  };
};

var _innovation_by_design_page = __webpack_require__(260);

var _innovation_by_design_page2 = _interopRequireDefault(_innovation_by_design_page);

var _innovation_by_design_page_state_manager = __webpack_require__(262);

var _innovation_by_design_page_state_manager2 = _interopRequireDefault(_innovation_by_design_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowMore = function (_Component) {
  _inherits(ShowMore, _Component);

  function ShowMore() {
    _classCallCheck(this, ShowMore);

    var _this = _possibleConstructorReturn(this, (ShowMore.__proto__ || Object.getPrototypeOf(ShowMore)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.state = {
      showMore: false
    };
    return _this;
  }

  _createClass(ShowMore, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        showMore: !this.state.showMore
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        onClick: this.handleClick,
        className: 'show-more ' + (this.state.showMore ? 'show-more--expanded' : ''),
        dangerouslySetInnerHTML: {
          __html: this.state.showMore ? this.props.data : '<p class="show-more__text">' + this.props.initialText + '</p>'
        }
      });
    }
  }]);

  return ShowMore;
}(_react.Component);

ShowMore.defaultProps = {
  initialText: 'Show More'
};

ShowMore.propTypes = {
  initialText: _propTypes2.default.string,
  data: _propTypes2.default.string.isRequired
};

exports.default = ShowMore;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _innovation_by_design_page_action_creators = __webpack_require__(727);

var innovationByDesignPageActions = _interopRequireWildcard(_innovation_by_design_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_innovation_by_design_actions = __webpack_require__(728);

var _async_innovation_by_design_actions2 = _interopRequireDefault(_async_innovation_by_design_actions);

var _async_innovation_by_design_details_actions = __webpack_require__(731);

var _async_innovation_by_design_details_actions2 = _interopRequireDefault(_async_innovation_by_design_details_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    if ((0, _get2.default)(state, 'config.site') !== 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }
    if (!params.category) {
      dispatch(innovationByDesignPageActions.innovationByDesignPageLoading({}, store));
    }
    return _bluebird2.default.all([(0, _async_innovation_by_design_details_actions2.default)(params, store)(dispatch), (0, _async_innovation_by_design_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(innovationByDesignPageActions.innovationByDesignPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      dispatch(innovationByDesignPageActions.innovationByDesignPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.innovationByDesignPageLoading = innovationByDesignPageLoading;
exports.innovationByDesignPageLoaded = innovationByDesignPageLoaded;
exports.innovationByDesignPageLoadError = innovationByDesignPageLoadError;
// import { canUseDOM } from 'exenv';

function innovationByDesignPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'INNOVATION_BY_DESIGN_PAGE_LOADING',
    innovationByDesignPage: resp,
    store: store
  };
}

function innovationByDesignPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'INNOVATION_BY_DESIGN_PAGE_LOADED',
    innovationByDesignPage: resp,
    store: store
  };
}

function innovationByDesignPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'INNOVATION_BY_DESIGN_PAGE_ERROR',
    innovationByDesignPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchInnovationByDesignDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _innovation_by_design_action_creators = __webpack_require__(729);

var innovationByDesign = _interopRequireWildcard(_innovation_by_design_action_creators);

var _innovation_by_design_model = __webpack_require__(730);

var _innovation_by_design_model2 = _interopRequireDefault(_innovation_by_design_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchInnovationByDesignDetail(params, store) {
  return function firstDispatch(dispatch) {
    return _innovation_by_design_model2.default.fetch(params, store).then(function handleInnovationByDesignDetailData(InnovationByDesignData) {
      if (params.category) {
        var hasIBDCategory = InnovationByDesignData.data.rows.filter(function (category) {
          return category.url === params.category;
        }).length;

        if (!hasIBDCategory) {
          dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        }
      }

      dispatch(innovationByDesign.innovationByDesignLoaded(InnovationByDesignData.data, store, params.year));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(innovationByDesign.innovationByDesignLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(innovationByDesign.innovationByDesignLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in innovationByDesign actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.innovationByDesignLoading = innovationByDesignLoading;
exports.innovationByDesignLoaded = innovationByDesignLoaded;
exports.innovationByDesignLoadError = innovationByDesignLoadError;
// import { canUseDOM } from 'exenv';

function innovationByDesignLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'INNOVATION_BY_DESIGN_LOADING',
    innovationByDesign: resp,
    store: store
  };
}

function innovationByDesignLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];

  return {
    type: 'INNOVATION_BY_DESIGN_LOADED',
    innovationByDesign: resp,
    store: store,
    year: year
  };
}

function innovationByDesignLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'INNOVATION_BY_DESIGN_ERROR',
    innovationByDesign: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnovationByDesign = function (_Base) {
  _inherits(InnovationByDesign, _Base);

  function InnovationByDesign() {
    _classCallCheck(this, InnovationByDesign);

    return _possibleConstructorReturn(this, (InnovationByDesign.__proto__ || Object.getPrototypeOf(InnovationByDesign)).apply(this, arguments));
  }

  _createClass(InnovationByDesign, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var year = _ref.year;

      var cleanedYear = this.cleanParam(year);

      // change to 2018 when api is active
      if (cleanedYear < 2018 && cleanedYear > 2008) {
        var state = store.getState();
        var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
        var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
        var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
        var host = 'api.fastcompany.com';
        var options = {};
        // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

        // Don't worry about this token. Can be public. Talked to Harry.
        var cacheKeyUrl = 'https://' + host + '/v1/packages/ibd/' + cleanedYear + '/categories/top/50?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
        var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

        if (!cacheEnabled) {
          return _request_util2.default.getAsync(cacheKeyUrl, options);
        }

        return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
          // TODO: refactor so we only need to do this on server
          if (cacheRes) {
            return _bluebird2.default.resolve(JSON.parse(cacheRes));
          }

          if (!_exenv.canUseDOM) {
            _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
          }

          return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
            _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
            return resp;
          });
        });
      }
      return _bluebird2.default.reject(new Error('Invalid Year'));
    }
  }]);

  return InnovationByDesign;
}(_base_model2.default);

exports.default = InnovationByDesign;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchInnovationByDesignDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _innovation_by_design_details_action_creators = __webpack_require__(732);

var innovationByDesign = _interopRequireWildcard(_innovation_by_design_details_action_creators);

var _innovation_by_design_detail_model = __webpack_require__(733);

var _innovation_by_design_detail_model2 = _interopRequireDefault(_innovation_by_design_detail_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchInnovationByDesignDetail(params, store) {
  return function firstDispatch(dispatch) {
    return _innovation_by_design_detail_model2.default.fetch(params, store).then(function handleInnovationByDesignDetailData(InnovationByDesignData) {
      // console.log('ibddetaildata: ', InnovationByDesignData.data.rows);
      dispatch(innovationByDesign.innovationByDesignDetailLoaded(InnovationByDesignData.data, store, params.year));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(innovationByDesign.innovationByDesignDetailLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(innovationByDesign.innovationByDesignDetailLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in innovationByDesignDetail actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.innovationByDesignDetailLoading = innovationByDesignDetailLoading;
exports.innovationByDesignDetailLoaded = innovationByDesignDetailLoaded;
exports.innovationByDesignDetailLoadError = innovationByDesignDetailLoadError;
// import { canUseDOM } from 'exenv';

function innovationByDesignDetailLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'INNOVATION_BY_DESIGN_DETAIL_LOADING',
    innovationByDesignDetail: resp,
    store: store
  };
}

function innovationByDesignDetailLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];

  return {
    type: 'INNOVATION_BY_DESIGN_DETAIL_LOADED',
    innovationByDesignDetail: resp,
    store: store,
    year: year
  };
}

function innovationByDesignDetailLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'INNOVATION_BY_DESIGN_DETAIL_ERROR',
    innovationByDesignDetail: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnovationByDesign = function (_Base) {
  _inherits(InnovationByDesign, _Base);

  function InnovationByDesign() {
    _classCallCheck(this, InnovationByDesign);

    return _possibleConstructorReturn(this, (InnovationByDesign.__proto__ || Object.getPrototypeOf(InnovationByDesign)).apply(this, arguments));
  }

  _createClass(InnovationByDesign, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var year = _ref.year;

      var cleanedYear = this.cleanParam(year);

      // change to 2018 when api is active
      if (cleanedYear < 2018 && cleanedYear > 2008) {
        var state = store.getState();
        var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
        var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
        var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
        var host = 'api.fastcompany.com';
        var options = {};
        // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

        // Don't worry about this token. Can be public. Talked to Harry.
        var cacheKeyUrl = 'https://' + host + '/v1/packages/ibd/' + cleanedYear + '/details?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
        var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

        if (!cacheEnabled) {
          return _request_util2.default.getAsync(cacheKeyUrl, options);
        }

        return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
          // TODO: refactor so we only need to do this on server
          if (cacheRes) {
            return _bluebird2.default.resolve(JSON.parse(cacheRes));
          }

          if (!_exenv.canUseDOM) {
            _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
          }

          return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
            _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
            return resp;
          });
        });
      }
      return _bluebird2.default.reject(new Error('Invalid Year'));
    }
  }]);

  return InnovationByDesign;
}(_base_model2.default);

exports.default = InnovationByDesign;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/innovation-by-design/:year/category/:category',
    component: _innovation_by_design_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _innovation_by_design_page_state_manager2.default)(store),
    autoScrollOff: true
  };
};

var _innovation_by_design_page = __webpack_require__(260);

var _innovation_by_design_page2 = _interopRequireDefault(_innovation_by_design_page);

var _innovation_by_design_page_state_manager = __webpack_require__(262);

var _innovation_by_design_page_state_manager2 = _interopRequireDefault(_innovation_by_design_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/most-creative-people-community',
    component: _most_creative_people_community_section_page2.default,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: (0, _most_creative_people_community_page_state_manager2.default)(store)
  };
};

var _most_creative_people_community_section_page = __webpack_require__(263);

var _most_creative_people_community_section_page2 = _interopRequireDefault(_most_creative_people_community_section_page);

var _most_creative_people_community_page_state_manager = __webpack_require__(264);

var _most_creative_people_community_page_state_manager2 = _interopRequireDefault(_most_creative_people_community_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(32);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line
var MostCreativePeopleCommunitySection = function (_Component) {
  _inherits(MostCreativePeopleCommunitySection, _Component);

  function MostCreativePeopleCommunitySection(props) {
    _classCallCheck(this, MostCreativePeopleCommunitySection);

    var _this = _possibleConstructorReturn(this, (MostCreativePeopleCommunitySection.__proto__ || Object.getPrototypeOf(MostCreativePeopleCommunitySection)).call(this, props));

    _this.screenLarge = true;
    return _this;
  }

  _createClass(MostCreativePeopleCommunitySection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateDisplay((0, _get2.default)(this.props, 'activeSection'));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateDisplay((0, _get2.default)(this.props, 'activeSection'));
    }
  }, {
    key: 'animatedScroll',
    value: function animatedScroll(element, to, duration) {
      var _this2 = this;

      if (duration <= 0) return;
      var difference = to - element.scrollTop;
      var perTick = difference / duration * 10;

      setTimeout(function () {
        // eslint-disable-next-line no-param-reassign
        element.scrollTop += perTick;
        if (element.scrollTop === to) return;
        _this2.animatedScroll(element, to, duration - 10);
      }, 10);
    }
  }, {
    key: 'updateDisplay',
    value: function updateDisplay(activeSection) {
      if (activeSection && _exenv.canUseDOM) {
        this.screenLarge = window.innerWidth > 640;
        var el = document.querySelector('.mcp-community-section--' + activeSection + ':not(.scrolled)');
        if (el) {
          this.animatedScroll(document.body, el.offsetTop + (this.screenLarge ? 130 : 190), 100);
          el.classList.add('scrolled');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          combinedAdModel = _props.combinedAdModel,
          index = _props.index,
          people = _props.people,
          nextPage = _props.nextPage,
          prevPage = _props.prevPage,
          activeSection = _props.activeSection;


      var nextStyle = {
        minHeight: 473
      };

      var peopleList = (0, _get2.default)(people, 'rows') ? people.rows : null;
      var peopleListSections = [];

      if (peopleList && peopleList.length) {
        var i = 0;
        var chunk = 10;
        for (i; i < peopleList.length; i += chunk) {
          peopleListSections.push(peopleList.slice(i, i + chunk));
        }
      }

      return _react2.default.createElement(
        'section',
        {
          className: 'mcp-community-section mcp-community-section--' + index,
          style: activeSection === index && this.screenLarge ? nextStyle : {}
        },
        _react2.default.createElement(
          _reactRouterDom.Link,
          {
            to: activeSection === index ? '/most-creative-people-community' : '/most-creative-people-community/' + index + '/1',
            className: 'mcp-community-section__title-row mcp-community-section__title-row--' + index
          },
          _react2.default.createElement(
            'h2',
            { className: 'mcp-community-section__title' },
            index
          ),
          _react2.default.createElement('img', {
            className: 'mcp-community-section__title-icon\n              ' + (activeSection === index ? ' mcp-community-section__title-icon--active' : ''),
            src: '//images.fastcompany.net/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg',
            alt: 'arrow icon',
            title: 'arrow icon'
          })
        ),
        peopleListSections.length && activeSection === index ? _react2.default.createElement(
          'div',
          { className: 'mcp-community-section__list-container' },
          prevPage && this.screenLarge ? _react2.default.createElement(
            'div',
            { className: 'mcp-community-section__prev-paddle' },
            _react2.default.createElement(
              _reactRouterDom.Link,
              {
                to: '/most-creative-people-community/' + index + '/' + prevPage
              },
              _react2.default.createElement('div', { className: 'mcp-community-section__prev-icon' })
            )
          ) : '',
          _react2.default.createElement(
            'div',
            { className: 'mcp-community-section__list' },
            peopleListSections.map(function (section) {
              return _react2.default.createElement(
                'div',
                {
                  key: '' + section[0].full_name,
                  className: 'mcp-community-section__list-column'
                },
                section.map(function (person) {
                  return _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/person/' + person.url, key: person.full_name },
                    person.full_name
                  );
                })
              );
            }),
            !this.screenLarge && (prevPage || nextPage) ? _react2.default.createElement(
              'ul',
              { className: 'pagination mcp-community-section__pagination' },
              _react2.default.createElement(
                'li',
                {
                  className: 'pagination__page pagination__page--prev' + (!prevPage ? ' mcp-community-section__pagination-page--inactive' : '')
                },
                prevPage ? _react2.default.createElement(
                  _reactRouterDom.Link,
                  {
                    to: '/most-creative-people-community/' + index + '/' + prevPage
                  },
                  'Prev'
                ) : _react2.default.createElement(
                  'span',
                  { className: 'pagination__link' },
                  'Prev'
                )
              ),
              _react2.default.createElement(
                'li',
                {
                  className: 'pagination__page pagination__page--next' + (!nextPage ? ' mcp-community-section__pagination-page--inactive' : '')
                },
                nextPage ? _react2.default.createElement(
                  _reactRouterDom.Link,
                  {
                    to: '/most-creative-people-community/' + index + '/' + nextPage
                  },
                  'Next'
                ) : _react2.default.createElement(
                  'span',
                  { className: 'pagination__link' },
                  'Next'
                )
              )
            ) : ''
          ),
          nextPage && this.screenLarge ? _react2.default.createElement(
            'div',
            { className: 'mcp-community-section__next-paddle' },
            _react2.default.createElement(
              _reactRouterDom.Link,
              {
                to: '/most-creative-people-community/' + index + '/' + nextPage
              },
              _react2.default.createElement('div', { className: 'mcp-community-section__next-icon' })
            )
          ) : ''
        ) : '',
        index === 'j' ? _react2.default.createElement(
          'div',
          { className: 'mcp-community-section__ff-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: 'mobileparallax_1' }))
        ) : ''
      );
    }
  }]);

  return MostCreativePeopleCommunitySection;
}(_react.Component);

exports.default = MostCreativePeopleCommunitySection;


MostCreativePeopleCommunitySection.propTypes = {
  /* eslint-disable */
  people: _propTypes2.default.shape({}),
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  index: _propTypes2.default.string,
  nextPage: _propTypes2.default.string,
  prevPage: _propTypes2.default.string,
  activeSection: _propTypes2.default.string
  /* eslint-enable */
};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _most_creative_people_community_page_action_creators = __webpack_require__(738);

var mostCreativePeopleCommunityPageActions = _interopRequireWildcard(_most_creative_people_community_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_most_creative_people_community_section_actions = __webpack_require__(739);

var _async_most_creative_people_community_section_actions2 = _interopRequireDefault(_async_most_creative_people_community_section_actions);

var _async_most_creative_people_community_section_next_actions = __webpack_require__(742);

var _async_most_creative_people_community_section_next_actions2 = _interopRequireDefault(_async_most_creative_people_community_section_next_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(mostCreativePeopleCommunityPageActions.mostCreativePeopleCommunityPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_recirc_feed_actions2.default)(params, store)(dispatch), (0, _async_most_creative_people_community_section_actions2.default)(params, store)(dispatch), (0, _async_most_creative_people_community_section_next_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(mostCreativePeopleCommunityPageActions.mostCreativePeopleCommunityPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(mostCreativePeopleCommunityPageActions.mostCreativePeopleCommunityPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mostCreativePeopleCommunityPageLoading = mostCreativePeopleCommunityPageLoading;
exports.mostCreativePeopleCommunityPageLoaded = mostCreativePeopleCommunityPageLoaded;
exports.mostCreativePeopleCommunityPageLoadError = mostCreativePeopleCommunityPageLoadError;
// import { canUseDOM } from 'exenv';

function mostCreativePeopleCommunityPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADING',
    mostCreativePeopleCommunityPage: resp,
    store: store
  };
}

function mostCreativePeopleCommunityPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED',
    mostCreativePeopleCommunityPage: resp,
    store: store
  };
}

function mostCreativePeopleCommunityPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR',
    mostCreativePeopleCommunityPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _most_creative_people_community_section_action_creators = __webpack_require__(740);

var mostCreativePeopleCommunitySectionActions = _interopRequireWildcard(_most_creative_people_community_section_action_creators);

var _most_creative_people_community_section_model = __webpack_require__(741);

var _most_creative_people_community_section_model2 = _interopRequireDefault(_most_creative_people_community_section_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(mostCreativePeopleCommunitySectionActions.mostCreativePeopleCommunitySectionLoading({}, store));
    return _most_creative_people_community_section_model2.default.fetch(params, store).then(function handlePersonDetailData(PersonData) {
      dispatch(mostCreativePeopleCommunitySectionActions.mostCreativePeopleCommunitySectionLoaded(PersonData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(mostCreativePeopleCommunitySectionActions.mostCreativePeopleCommunitySectionLoadError(err, store));

      _logger_service2.default.error(err, 'Error in person actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mostCreativePeopleCommunitySectionLoading = mostCreativePeopleCommunitySectionLoading;
exports.mostCreativePeopleCommunitySectionLoaded = mostCreativePeopleCommunitySectionLoaded;
exports.mostCreativePeopleCommunitySectionLoadError = mostCreativePeopleCommunitySectionLoadError;
// import { canUseDOM } from 'exenv';

function mostCreativePeopleCommunitySectionLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADING',
    mostCreativePeopleCommunitySection: resp,
    store: store
  };
}

function mostCreativePeopleCommunitySectionLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADED',
    mostCreativePeopleCommunitySection: resp,
    store: store
  };
}

function mostCreativePeopleCommunitySectionLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_ERROR',
    mostCreativePeopleCommunitySection: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Person = function (_Base) {
  _inherits(Person, _Base);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var section = _ref.section,
          page = _ref.page;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/pattern?page=1&rows_per_page=60&pattern=a

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/person/search/pattern?page=' + page + '&rows_per_page=40&pattern=' + section + '&allow_index=1&mcp1000=1';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Person;
}(_base_model2.default);

exports.default = Person;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _most_creative_people_community_section_next_action_creators = __webpack_require__(743);

var mostCreativePeopleCommunitySectionNextActions = _interopRequireWildcard(_most_creative_people_community_section_next_action_creators);

var _most_creative_people_community_section_next_model = __webpack_require__(744);

var _most_creative_people_community_section_next_model2 = _interopRequireDefault(_most_creative_people_community_section_next_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(mostCreativePeopleCommunitySectionNextActions.mostCreativePeopleCommunitySectionNextLoading({}, store));
    return _most_creative_people_community_section_next_model2.default.fetch(params, store).then(function handlePersonDetailData(PersonData) {
      dispatch(mostCreativePeopleCommunitySectionNextActions.mostCreativePeopleCommunitySectionNextLoaded(PersonData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(mostCreativePeopleCommunitySectionNextActions.mostCreativePeopleCommunitySectionNextLoadError(err, store));

      _logger_service2.default.error(err, 'Error in person actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mostCreativePeopleCommunitySectionNextLoading = mostCreativePeopleCommunitySectionNextLoading;
exports.mostCreativePeopleCommunitySectionNextLoaded = mostCreativePeopleCommunitySectionNextLoaded;
exports.mostCreativePeopleCommunitySectionNextLoadError = mostCreativePeopleCommunitySectionNextLoadError;
// import { canUseDOM } from 'exenv';

function mostCreativePeopleCommunitySectionNextLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADING',
    mostCreativePeopleCommunitySectionNext: resp,
    store: store
  };
}

function mostCreativePeopleCommunitySectionNextLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADED',
    mostCreativePeopleCommunitySectionNext: resp,
    store: store
  };
}

function mostCreativePeopleCommunitySectionNextLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_ERROR',
    mostCreativePeopleCommunitySectionNext: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Person = function (_Base) {
  _inherits(Person, _Base);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var section = _ref.section,
          page = _ref.page;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/pattern?page=1&rows_per_page=60&pattern=a

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/person/search/pattern?page=' + (Number(page) + 1) + '&rows_per_page=40&pattern=' + section + '&allow_index=1&mcp1000=1';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Person;
}(_base_model2.default);

exports.default = Person;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/most-creative-people-community/:section/:page',
    component: _most_creative_people_community_section_page2.default,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: (0, _most_creative_people_community_page_state_manager2.default)(store)
  };
};

var _most_creative_people_community_section_page = __webpack_require__(263);

var _most_creative_people_community_section_page2 = _interopRequireDefault(_most_creative_people_community_section_page);

var _most_creative_people_community_page_state_manager = __webpack_require__(264);

var _most_creative_people_community_page_state_manager2 = _interopRequireDefault(_most_creative_people_community_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/most-creative-people/:year',
    component: _most_creative_people_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _most_creative_people_page_state_manager2.default)(store)
  };
};

var _most_creative_people_page = __webpack_require__(747);

var _most_creative_people_page2 = _interopRequireDefault(_most_creative_people_page);

var _most_creative_people_page_state_manager = __webpack_require__(749);

var _most_creative_people_page_state_manager2 = _interopRequireDefault(_most_creative_people_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _chunk = __webpack_require__(103);

var _chunk2 = _interopRequireDefault(_chunk);

var _reactRouter = __webpack_require__(22);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _mcp_section = __webpack_require__(748);

var _mcp_section2 = _interopRequireDefault(_mcp_section);

var _feature_feed = __webpack_require__(101);

var _feature_feed2 = _interopRequireDefault(_feature_feed);

var _client_util = __webpack_require__(40);

var _client_util2 = _interopRequireDefault(_client_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { canUseDOM } from 'exenv';


function mapPostsToFeaturedStoriesObj(featuredFeed) {
  var stories = (0, _get2.default)(featuredFeed, 'data.posts') || [];

  return {
    top: stories.slice(1),
    featured: stories.slice(0, 1)
  };
}

var MostCreativePeople = function (_Component) {
  _inherits(MostCreativePeople, _Component);

  function MostCreativePeople() {
    _classCallCheck(this, MostCreativePeople);

    return _possibleConstructorReturn(this, (MostCreativePeople.__proto__ || Object.getPrototypeOf(MostCreativePeople)).apply(this, arguments));
  }

  _createClass(MostCreativePeople, [{
    key: 'componentDidMount',

    // eslint-disable-next-line react/prefer-stateless-function
    value: function componentDidMount() {
      this.isDesktop = (0, _client_util2.default)('64em');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          mostCreativePeoplePage = _props.mostCreativePeoplePage,
          mostCreativePeople = _props.mostCreativePeople,
          mostCreativePeopleFeaturedFeed = _props.mostCreativePeopleFeaturedFeed,
          mostCreativePeopleScrollingModule = _props.mostCreativePeopleScrollingModule,
          status = _props.status;


      if (mostCreativePeoplePage.error || status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (mostCreativePeoplePage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'most-creative-people-page' },
          _react2.default.createElement(
            'article',
            { className: 'most-creative-people-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(mostCreativePeoplePage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      var year = (0, _get2.default)(this.props, 'match.params.year');
      var pgTitle = 'The Most Creative People In Business ' + year;
      var pgDesc = 'These inspiring leaders are shaping the future of business in creative ways. Scroll to see the Top 100.';
      var sectionTitle = 'Meet The 100 Most Creative People in Business ' + year;
      var mcpSections = mostCreativePeople.map(function (people, index) {
        return {
          id: 'section-' + (index + 1),
          people: people
        };
      });

      var encodedText = encodeURIComponent('The Most Creative People In Business ' + year + ' #FCMostCreative');
      var uri = encodeURIComponent('https://www.fastcompany.com/most-creative-people/' + year);
      return _react2.default.createElement(
        'section',
        { className: 'most-creative-people-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, { slugName: pgTitle, className: 'category-page' }),
          _react2.default.createElement(
            'h3',
            { className: 'page-description' },
            pgDesc
          )
        ),
        _react2.default.createElement(_feature_feed2.default, {
          featuredFeed: mapPostsToFeaturedStoriesObj(mostCreativePeopleFeaturedFeed),
          scrollingModule: mostCreativePeopleScrollingModule,
          currentSite: 'fastcompany',
          page: 'most-creative-people',
          combinedAdModel: combinedAdModel,
          config: config,
          social: {
            enableSticky: false,
            modifier: 'feature-feed',
            text: encodedText,
            uri: uri
          }
        }),
        _react2.default.createElement(
          'section',
          { className: 'mcp-list' },
          _react2.default.createElement(_slug2.default, { slugName: sectionTitle, className: 'mcp-list' }),
          mcpSections.map(function (col, idx) {
            return (idx % 2 === 0 || idx === 0) && _react2.default.createElement(_mcp_section2.default, {
              config: config,
              key: col.id,
              data: col.people.concat(mcpSections[idx + 1].people || []),
              combinedAdModel: combinedAdModel,
              index: String(idx)
            });
          })
        )
      );
    }
  }]);

  return MostCreativePeople;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var mcpData = (0, _chunk2.default)((0, _get2.default)(state, 'mostCreativePeople.data.rows'), 10);
  return {
    config: state.config || {},
    status: state.status.code,
    mostCreativePeoplePage: (0, _get2.default)(state, 'mostCreativePeoplePage') || {
      error: true
    },
    mostCreativePeople: mcpData || [],
    mostCreativePeopleFeaturedFeed: (0, _get2.default)(state, 'mostCreativePeopleFeaturedFeed') || {},
    mostCreativePeopleScrollingModule: (0, _get2.default)(state, 'mostCreativePeopleScrollingModule.data') || {}
  };
}

MostCreativePeople.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number.isRequired,
  mostCreativePeoplePage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  mostCreativePeople: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({}))).isRequired,
  mostCreativePeopleFeaturedFeed: _propTypes2.default.shape({}).isRequired,
  mostCreativePeopleScrollingModule: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(MostCreativePeople));

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStickynode = __webpack_require__(77);

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function processAssetServerImage(imgSrc) {
  if (typeof imgSrc !== 'string') {
    return '';
  }

  return imgSrc.replace('multisite_files/fastcompany', 'multisite_files/fastcompany/imagecache/w/80/h/80/scale');
}

var MCPSection = function (_Component) {
  _inherits(MCPSection, _Component);

  function MCPSection() {
    _classCallCheck(this, MCPSection);

    return _possibleConstructorReturn(this, (MCPSection.__proto__ || Object.getPrototypeOf(MCPSection)).apply(this, arguments));
  }

  _createClass(MCPSection, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          combinedAdModel = _props.combinedAdModel,
          index = _props.index,
          data = _props.data;


      return _react2.default.createElement(
        'section',
        { className: 'mcp-section mcp-section--' + index },
        _react2.default.createElement(
          'div',
          { className: 'mcp-section__row mcp-section__row--' + index },
          data ? data.map(function (person) {
            var hasThumbnail = !!(0, _get2.default)(person, 'thumb_url');
            return _react2.default.createElement(
              _fc_link2.default,
              {
                config: config,
                to: 'https://www.fastcompany.com/person/' + (0, _get2.default)(person, 'url'),
                title: (0, _get2.default)(person, 'first_name') + ' ' + (0, _get2.default)(person, 'last_name'),
                key: (0, _get2.default)(person, 'id')
              },
              hasThumbnail ? _react2.default.createElement(
                'div',
                { className: 'mcp-section__poster' },
                _react2.default.createElement('img', {
                  className: 'mcp-section__poster-image',
                  src: processAssetServerImage((0, _get2.default)(person, 'thumb_url')),
                  alt: (0, _get2.default)(person, 'first_name') + ' ' + (0, _get2.default)(person, 'last_name')
                })
              ) : '',
              _react2.default.createElement(
                'div',
                {
                  className: 'mcp-section__text ' + (hasThumbnail ? '' : 'mcp-section__text--no-thumb')
                },
                _react2.default.createElement(
                  'h2',
                  { className: 'mcp-section__name' },
                  '' + ((0, _get2.default)(person, 'ranking') < 10 ? '0' + (0, _get2.default)(person, 'ranking') : (0, _get2.default)(person, 'ranking')),
                  '  ' + (0, _get2.default)(person, 'first_name') + ' ' + (0, _get2.default)(person, 'last_name')
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'mcp-section__reason' },
                  (0, _get2.default)(person, 'why')
                )
              )
            );
          }) : ''
        ),
        _react2.default.createElement(
          'div',
          { className: 'all-feed__sidebar' },
          _react2.default.createElement(
            'div',
            { className: 'all-feed__promotion' },
            _react2.default.createElement(
              _reactStickynode2.default,
              { top: 100, bottomBoundary: '.mcp-section__row--' + index },
              _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblehalfpage' }))
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'mcp-section__all-ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_5' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileparallax_2' }))
        )
      );
    }
  }]);

  return MCPSection;
}(_react.Component);

exports.default = MCPSection;


MCPSection.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  combinedAdModel: _propTypes2.default.shape({}).isRequired,
  index: _propTypes2.default.string.isRequired
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_most_creative_people_page_actions = __webpack_require__(750);

var _async_most_creative_people_page_actions2 = _interopRequireDefault(_async_most_creative_people_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_most_creative_people_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_most_creative_people_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _most_creative_people_page_action_creators = __webpack_require__(751);

var mostCreativePeoplePageActions = _interopRequireWildcard(_most_creative_people_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_most_creative_people_actions = __webpack_require__(752);

var _async_most_creative_people_actions2 = _interopRequireDefault(_async_most_creative_people_actions);

var _async_most_creative_people_featured_feed_actions = __webpack_require__(755);

var _async_most_creative_people_featured_feed_actions2 = _interopRequireDefault(_async_most_creative_people_featured_feed_actions);

var _async_most_creative_people_scrolling_module_actions = __webpack_require__(758);

var _async_most_creative_people_scrolling_module_actions2 = _interopRequireDefault(_async_most_creative_people_scrolling_module_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }
    dispatch(mostCreativePeoplePageActions.mostCreativePeoplePageLoading({}, store));
    return _bluebird2.default.all([(0, _async_most_creative_people_actions2.default)(params, store)(dispatch), (0, _async_most_creative_people_featured_feed_actions2.default)(params, store)(dispatch), (0, _async_most_creative_people_scrolling_module_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(mostCreativePeoplePageActions.mostCreativePeoplePageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      dispatch(mostCreativePeoplePageActions.mostCreativePeoplePageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mostCreativePeoplePageLoading = mostCreativePeoplePageLoading;
exports.mostCreativePeoplePageLoaded = mostCreativePeoplePageLoaded;
exports.mostCreativePeoplePageLoadError = mostCreativePeoplePageLoadError;
// import { canUseDOM } from 'exenv';

function mostCreativePeoplePageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_PAGE_LOADING',
    mostCreativePeoplePage: resp,
    store: store
  };
}

function mostCreativePeoplePageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_PAGE_LOADED',
    mostCreativePeoplePage: resp,
    store: store
  };
}

function mostCreativePeoplePageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_PAGE_ERROR',
    mostCreativePeoplePage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMostCreativePeopleDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _most_creative_people_action_creators = __webpack_require__(753);

var mostCreativePeople = _interopRequireWildcard(_most_creative_people_action_creators);

var _most_creative_people_model = __webpack_require__(754);

var _most_creative_people_model2 = _interopRequireDefault(_most_creative_people_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMostCreativePeopleDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(mostCreativePeople.mostCreativePeopleLoading({}, store));
    return _most_creative_people_model2.default.fetch(params, store).then(function handleMostCreativePeopleDetailData(MostCreativePeopleData) {
      dispatch(mostCreativePeople.mostCreativePeopleLoaded(MostCreativePeopleData.data, store, params.year));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(mostCreativePeople.mostCreativePeopleLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(mostCreativePeople.mostCreativePeopleLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in mostCreativePeople actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mostCreativePeopleLoading = mostCreativePeopleLoading;
exports.mostCreativePeopleLoaded = mostCreativePeopleLoaded;
exports.mostCreativePeopleLoadError = mostCreativePeopleLoadError;
// import { canUseDOM } from 'exenv';

function mostCreativePeopleLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_LOADING',
    mostCreativePeople: resp,
    store: store
  };
}

function mostCreativePeopleLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];

  return {
    type: 'MOST_CREATIVE_PEOPLE_LOADED',
    mostCreativePeople: resp,
    store: store,
    year: year
  };
}

function mostCreativePeopleLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_ERROR',
    mostCreativePeople: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MostCreativePeople = function (_Base) {
  _inherits(MostCreativePeople, _Base);

  function MostCreativePeople() {
    _classCallCheck(this, MostCreativePeople);

    return _possibleConstructorReturn(this, (MostCreativePeople.__proto__ || Object.getPrototypeOf(MostCreativePeople)).apply(this, arguments));
  }

  _createClass(MostCreativePeople, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var year = _ref.year;

      var cleanedYear = this.cleanParam(year);

      // change to 2018 when api is active
      if (cleanedYear < 2018 && cleanedYear > 2008) {
        var state = store.getState();
        var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
        var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
        var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
        var host = 'api.fastcompany.com';
        var options = {};
        // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

        // Don't worry about this token. Can be public. Talked to Harry.
        var cacheKeyUrl = 'https://' + host + '/v1/packages/mcp/' + cleanedYear + '/persons/top/100?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
        var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

        if (!cacheEnabled) {
          return _request_util2.default.getAsync(cacheKeyUrl, options);
        }

        return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
          // TODO: refactor so we only need to do this on server
          if (cacheRes) {
            return _bluebird2.default.resolve(JSON.parse(cacheRes));
          }

          if (!_exenv.canUseDOM) {
            _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
          }

          return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
            _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
            return resp;
          });
        });
      }
      return _bluebird2.default.reject(new Error('Invalid Year'));
    }
  }]);

  return MostCreativePeople;
}(_base_model2.default);

exports.default = MostCreativePeople;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMostCreativePeopleFeaturedFeedFeaturedModule;

var _most_creative_people_featured_feed_action_creators = __webpack_require__(756);

var mostCreativePeopleFeaturedFeedActions = _interopRequireWildcard(_most_creative_people_featured_feed_action_creators);

var _most_creative_people_featured_feed = __webpack_require__(757);

var _most_creative_people_featured_feed2 = _interopRequireDefault(_most_creative_people_featured_feed);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchMostCreativePeopleFeaturedFeedFeaturedModule(params, store) {
  return function firstDispatchMostCreativePeopleFeaturedFeed(dispatch) {
    dispatch(mostCreativePeopleFeaturedFeedActions.mostCreativePeopleFeaturedFeedLoading());
    return _most_creative_people_featured_feed2.default.fetch(params, store).then(function handleFeaturedModuleData(resp) {
      /* eslint-disable */
      dispatch(mostCreativePeopleFeaturedFeedActions.mostCreativePeopleFeaturedFeedLoaded(resp.data, store));
      /* eslint-enable */
    }).catch(function handleFeaturedError(err) {
      /* eslint-disable */
      dispatch(mostCreativePeopleFeaturedFeedActions.mostCreativePeopleFeaturedFeedLoadError(err, store));
      /* eslint-enable */
      _logger_service2.default.error(err, 'Error in featured feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mostCreativePeopleFeaturedFeedLoading = mostCreativePeopleFeaturedFeedLoading;
exports.mostCreativePeopleFeaturedFeedLoaded = mostCreativePeopleFeaturedFeedLoaded;
exports.mostCreativePeopleFeaturedFeedLoadError = mostCreativePeopleFeaturedFeedLoadError;
// import { canUseDOM } from 'exenv';

function mostCreativePeopleFeaturedFeedLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADING',
    mostCreativePeopleFeaturedFeed: resp,
    store: store
  };
}

function mostCreativePeopleFeaturedFeedLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments[1];

  return {
    type: 'MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADED',
    mostCreativePeopleFeaturedFeed: resp,
    store: store
  };
}

function mostCreativePeopleFeaturedFeedLoadError(error, store) {
  return {
    type: 'MOST_CREATIVE_PEOPLE_FEATURED_FEED_ERROR',
    mostCreativePeopleFeaturedFeed: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mcpFeaturedFeed = function (_Base) {
  _inherits(mcpFeaturedFeed, _Base);

  function mcpFeaturedFeed() {
    _classCallCheck(this, mcpFeaturedFeed);

    return _possibleConstructorReturn(this, (mcpFeaturedFeed.__proto__ || Object.getPrototypeOf(mcpFeaturedFeed)).apply(this, arguments));
  }

  _createClass(mcpFeaturedFeed, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var year = _ref.year;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      // const site = get(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/category-tag-slug-posts/fastcompany/most-creative-people/' + this.cleanParam(year) + '?total=1';

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;
      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return mcpFeaturedFeed;
}(_base_model2.default);

exports.default = mcpFeaturedFeed;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCategory;

var _most_creative_people_scrolling_module_action_creators = __webpack_require__(759);

var mostCreativePeopleScrollingModuleActions = _interopRequireWildcard(_most_creative_people_scrolling_module_action_creators);

var _most_creative_people_scrolling_module = __webpack_require__(760);

var _most_creative_people_scrolling_module2 = _interopRequireDefault(_most_creative_people_scrolling_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchCategory(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(mostCreativePeopleScrollingModuleActions.mostCreativePeopleScrollingModuleLoading({}, store));
    return _most_creative_people_scrolling_module2.default.fetch(params, store).then(function handleCategoryDetailData(CategoryData) {
      dispatch(mostCreativePeopleScrollingModuleActions.mostCreativePeopleScrollingModuleLoaded(CategoryData.data, store));
    }).catch(function handleUserError(err) {
      dispatch(mostCreativePeopleScrollingModuleActions.mostCreativePeopleScrollingModuleLoadError(err, store));
      _logger_service2.default.error(err, 'Error in category scrollingModule actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mostCreativePeopleScrollingModuleLoading = mostCreativePeopleScrollingModuleLoading;
exports.mostCreativePeopleScrollingModuleLoaded = mostCreativePeopleScrollingModuleLoaded;
exports.mostCreativePeopleScrollingModuleLoadError = mostCreativePeopleScrollingModuleLoadError;
// import { canUseDOM } from 'exenv';

function mostCreativePeopleScrollingModuleLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADING',
    mostCreativePeopleScrollingModule: resp,
    store: store
  };
}

function mostCreativePeopleScrollingModuleLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADED',
    mostCreativePeopleScrollingModule: resp,
    store: store
  };
}

function mostCreativePeopleScrollingModuleLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_ERROR',
    mostCreativePeopleScrollingModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MostCreativePeopleScrollingModule = function (_Base) {
  _inherits(MostCreativePeopleScrollingModule, _Base);

  function MostCreativePeopleScrollingModule() {
    _classCallCheck(this, MostCreativePeopleScrollingModule);

    return _possibleConstructorReturn(this, (MostCreativePeopleScrollingModule.__proto__ || Object.getPrototypeOf(MostCreativePeopleScrollingModule)).apply(this, arguments));
  }

  _createClass(MostCreativePeopleScrollingModule, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var site = (0, _get2.default)(state, 'config.site');
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      if (site === 'fastcompany') {
        site = 'fastconews';
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/category-scrolling-module-posts/fastcompany/most-creative-people?total=20';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;
      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
      }
      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return MostCreativePeopleScrollingModule;
}(_base_model2.default);

exports.default = MostCreativePeopleScrollingModule;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/company/:company',
    component: _company_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _company_page_state_manager2.default)(store)
  };
};

var _company_page = __webpack_require__(762);

var _company_page2 = _interopRequireDefault(_company_page);

var _company_page_state_manager = __webpack_require__(763);

var _company_page_state_manager2 = _interopRequireDefault(_company_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouter = __webpack_require__(22);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _person_company_component = __webpack_require__(265);

var _person_company_component2 = _interopRequireDefault(_person_company_component);

var _tag_all_feed_action_creators = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Company = function (_Component) {
  _inherits(Company, _Component);

  function Company() {
    _classCallCheck(this, Company);

    return _possibleConstructorReturn(this, (Company.__proto__ || Object.getPrototypeOf(Company)).apply(this, arguments));
  }

  _createClass(Company, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          status = _props.status,
          config = _props.config,
          companyPage = _props.companyPage,
          company = _props.company,
          companyData = _props.companyData,
          companyAwards = _props.companyAwards,
          tagAllFeed = _props.tagAllFeed;


      if (status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (companyPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'company-page' },
          _react2.default.createElement(
            'article',
            { className: 'company-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(companyPage, 'ads');

      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });
      var fullName = (0, _get2.default)(company, 'name');

      return _react2.default.createElement(
        'section',
        { className: 'company-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileleaderboard', region: 'articletop' })),
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(_person_company_component2.default, {
          personOrCompany: companyData,
          type: 'company',
          awards: companyAwards
        }),
        _react2.default.createElement(
          'div',
          { className: 'company-page__ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        ),
        (0, _get2.default)(tagAllFeed, 'posts[0]') ? _react2.default.createElement(_all_feed2.default, {
          adModel: combinedAdModel,
          stories: (0, _get2.default)(tagAllFeed, 'posts'),
          allRendered: true,
          updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
          config: config,
          titleOverride: 'Stories about ' + fullName
        }) : '',
        (0, _get2.default)(this.props, 'tagAllFeed.posts[0]') ? _react2.default.createElement(
          'div',
          { className: 'company-page__ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        ) : ''
      );
    }
  }]);

  return Company;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    company: (0, _get2.default)(state, 'company.data.rows[0]', {}),
    companyData: (0, _get2.default)(state, 'companyData.data.rows[0]', {}),
    companyAwards: (0, _get2.default)(state, 'companyAwards.data.rows', {}),
    companyPage: (0, _get2.default)(state, 'companyPage', {}),
    tagAllFeed: {
      totalPosts: (0, _get2.default)(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: (0, _get2.default)(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: (0, _get2.default)(state, 'tagAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'tagAllFeed.data.posts', [])
    }
  };
}

Company.propTypes = {
  status: _propTypes2.default.number,
  config: _propTypes2.default.shape({}).isRequired,
  company: _propTypes2.default.shape({}).isRequired,
  companyAwards: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  companyData: _propTypes2.default.shape({}).isRequired,
  companyPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object.isRequired,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }),
  tagAllFeed: _propTypes2.default.shape({
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number,
    allRendered: _propTypes2.default.bool,
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  })
};

Company.defaultProps = {
  status: 200,
  companyPage: _propTypes2.default.shape({
    isLoading: false,
    error: false,
    errorMessage: 'Error in companyPage props'
  }),
  tagAllFeed: _propTypes2.default.shape({
    posts: [{}],
    allRendered: false
  })
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Company));

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_company_page_actions = __webpack_require__(764);

var _async_company_page_actions2 = _interopRequireDefault(_async_company_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_company_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_company_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCompanyPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _company_page_action_creators = __webpack_require__(765);

var companyPageActions = _interopRequireWildcard(_company_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_tag_all_feed_actions = __webpack_require__(81);

var _async_tag_all_feed_actions2 = _interopRequireDefault(_async_tag_all_feed_actions);

var _async_company_actions = __webpack_require__(766);

var _async_company_actions2 = _interopRequireDefault(_async_company_actions);

var _async_company_awards_actions = __webpack_require__(769);

var _async_company_awards_actions2 = _interopRequireDefault(_async_company_awards_actions);

var _async_company_data_actions = __webpack_require__(772);

var _async_company_data_actions2 = _interopRequireDefault(_async_company_data_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCompanyPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(companyPageActions.companyPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_company_actions2.default)(params, store)(dispatch), (0, _async_company_data_actions2.default)(params, store)(dispatch), (0, _async_company_awards_actions2.default)(params, store)(dispatch), (0, _async_tag_all_feed_actions2.default)(params, store, true)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(companyPageActions.companyPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(companyPageActions.companyPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyPageLoading = companyPageLoading;
exports.companyPageLoaded = companyPageLoaded;
exports.companyPageLoadError = companyPageLoadError;
// import { canUseDOM } from 'exenv';

function companyPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_PAGE_LOADING',
    companyPage: resp,
    store: store
  };
}

function companyPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_PAGE_LOADED',
    companyPage: resp,
    store: store
  };
}

function companyPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_PAGE_ERROR',
    companyPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCompanyDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _company_action_creators = __webpack_require__(767);

var companyActions = _interopRequireWildcard(_company_action_creators);

var _company_model = __webpack_require__(768);

var _company_model2 = _interopRequireDefault(_company_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCompanyDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(companyActions.companyLoading({}, store));
    return _company_model2.default.fetch(params, store).then(function handleCompanyDetailData(CompanyData) {
      dispatch(companyActions.companyLoaded(CompanyData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(companyActions.companyLoadError(err, store));

      _logger_service2.default.error(err, 'Error in company actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyLoading = companyLoading;
exports.companyLoaded = companyLoaded;
exports.companyLoadError = companyLoadError;
// import { canUseDOM } from 'exenv';

function companyLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_LOADING',
    company: resp,
    store: store
  };
}

function companyLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_LOADED',
    company: resp,
    store: store
  };
}

function companyLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_ERROR',
    company: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Company = function (_Base) {
  _inherits(Company, _Base);

  function Company() {
    _classCallCheck(this, Company);

    return _possibleConstructorReturn(this, (Company.__proto__ || Object.getPrototypeOf(Company)).apply(this, arguments));
  }

  _createClass(Company, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var company = _ref.company;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/companies/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=' + this.cleanParam(company);
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Company;
}(_base_model2.default);

exports.default = Company;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCompanyDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _company_awards_action_creators = __webpack_require__(770);

var companyAwardsActions = _interopRequireWildcard(_company_awards_action_creators);

var _company_awards_model = __webpack_require__(771);

var _company_awards_model2 = _interopRequireDefault(_company_awards_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCompanyDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(companyAwardsActions.companyAwardsLoading({}, store));
    return _company_awards_model2.default.fetch(params, store).then(function handleCompanyDetailData(CompanyData) {
      dispatch(companyAwardsActions.companyAwardsLoaded(CompanyData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(companyAwardsActions.companyAwardsLoadError(err, store));

      _logger_service2.default.error(err, 'Error in companyAwards actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyAwardsLoading = companyAwardsLoading;
exports.companyAwardsLoaded = companyAwardsLoaded;
exports.companyAwardsLoadError = companyAwardsLoadError;
// import { canUseDOM } from 'exenv';

function companyAwardsLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_AWARDS_LOADING',
    companyAwards: resp,
    store: store
  };
}

function companyAwardsLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_AWARDS_LOADED',
    companyAwards: resp,
    store: store
  };
}

function companyAwardsLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_AWARDS_ERROR',
    companyAwards: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompanyAwards = function (_Base) {
  _inherits(CompanyAwards, _Base);

  function CompanyAwards() {
    _classCallCheck(this, CompanyAwards);

    return _possibleConstructorReturn(this, (CompanyAwards.__proto__ || Object.getPrototypeOf(CompanyAwards)).apply(this, arguments));
  }

  _createClass(CompanyAwards, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var company = _ref.company;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs
      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/companies/search/awards/mic/url?url=' + this.cleanParam(company) + '&token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CompanyAwards;
}(_base_model2.default);

exports.default = CompanyAwards;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCompanyDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _company_data_action_creators = __webpack_require__(773);

var companyDataActions = _interopRequireWildcard(_company_data_action_creators);

var _company_data_model = __webpack_require__(774);

var _company_data_model2 = _interopRequireDefault(_company_data_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCompanyDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(companyDataActions.companyDataLoading({}, store));
    return _company_data_model2.default.fetch(params, store).then(function handleCompanyDetailData(CompanyData) {
      dispatch(companyDataActions.companyDataLoaded(CompanyData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(companyDataActions.companyDataLoadError(err, store));

      _logger_service2.default.error(err, 'Error in companyData actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyDataLoading = companyDataLoading;
exports.companyDataLoaded = companyDataLoaded;
exports.companyDataLoadError = companyDataLoadError;
// import { canUseDOM } from 'exenv';

function companyDataLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_DATA_LOADING',
    companyData: resp,
    store: store
  };
}

function companyDataLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_DATA_LOADED',
    companyData: resp,
    store: store
  };
}

function companyDataLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_DATA_ERROR',
    companyData: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompanyData = function (_Base) {
  _inherits(CompanyData, _Base);

  function CompanyData() {
    _classCallCheck(this, CompanyData);

    return _possibleConstructorReturn(this, (CompanyData.__proto__ || Object.getPrototypeOf(CompanyData)).apply(this, arguments));
  }

  _createClass(CompanyData, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var company = _ref.company;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/mic/0/companies/' + this.cleanParam(company) + '?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CompanyData;
}(_base_model2.default);

exports.default = CompanyData;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/company',
    component: _company_index_section_page2.default,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: (0, _company_index_section_page_state_manager2.default)(store)
  };
};

var _company_index_section_page = __webpack_require__(266);

var _company_index_section_page2 = _interopRequireDefault(_company_index_section_page);

var _company_index_section_page_state_manager = __webpack_require__(267);

var _company_index_section_page_state_manager2 = _interopRequireDefault(_company_index_section_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCompanyPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _company_index_section_page_action_creators = __webpack_require__(777);

var companyIndexSectionPageActions = _interopRequireWildcard(_company_index_section_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_company_index_section_actions = __webpack_require__(778);

var _async_company_index_section_actions2 = _interopRequireDefault(_async_company_index_section_actions);

var _async_company_index_section_next_actions = __webpack_require__(781);

var _async_company_index_section_next_actions2 = _interopRequireDefault(_async_company_index_section_next_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCompanyPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(companyIndexSectionPageActions.companyIndexSectionPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_company_index_section_actions2.default)(params, store)(dispatch), (0, _async_company_index_section_next_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(companyIndexSectionPageActions.companyIndexSectionPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(companyIndexSectionPageActions.companyIndexSectionPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyIndexSectionPageLoading = companyIndexSectionPageLoading;
exports.companyIndexSectionPageLoaded = companyIndexSectionPageLoaded;
exports.companyIndexSectionPageLoadError = companyIndexSectionPageLoadError;
// import { canUseDOM } from 'exenv';

function companyIndexSectionPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_PAGE_LOADING',
    companyIndexSectionPage: resp,
    store: store
  };
}

function companyIndexSectionPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_PAGE_LOADED',
    companyIndexSectionPage: resp,
    store: store
  };
}

function companyIndexSectionPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_PAGE_ERROR',
    companyIndexSectionPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCompanyDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _company_index_section_action_creators = __webpack_require__(779);

var companyIndexSectionActions = _interopRequireWildcard(_company_index_section_action_creators);

var _company_index_section_model = __webpack_require__(780);

var _company_index_section_model2 = _interopRequireDefault(_company_index_section_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCompanyDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(companyIndexSectionActions.companyIndexSectionLoading({}, store));
    return _company_index_section_model2.default.fetch(params, store).then(function handleCompanyDetailData(CompanyData) {
      dispatch(companyIndexSectionActions.companyIndexSectionLoaded(CompanyData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(companyIndexSectionActions.companyIndexSectionLoadError(err, store));

      _logger_service2.default.error(err, 'Error in company actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyIndexSectionLoading = companyIndexSectionLoading;
exports.companyIndexSectionLoaded = companyIndexSectionLoaded;
exports.companyIndexSectionLoadError = companyIndexSectionLoadError;
// import { canUseDOM } from 'exenv';

function companyIndexSectionLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_LOADING',
    companyIndexSection: resp,
    store: store
  };
}

function companyIndexSectionLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_LOADED',
    companyIndexSection: resp,
    store: store
  };
}

function companyIndexSectionLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_ERROR',
    companyIndexSection: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompanyIndex = function (_Base) {
  _inherits(CompanyIndex, _Base);

  function CompanyIndex() {
    _classCallCheck(this, CompanyIndex);

    return _possibleConstructorReturn(this, (CompanyIndex.__proto__ || Object.getPrototypeOf(CompanyIndex)).apply(this, arguments));
  }

  _createClass(CompanyIndex, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var section = _ref.section,
          page = _ref.page;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};

      var pattern = section;
      if (pattern === '0-9') {
        pattern = '%5B0-9%5D';
      }
      // https://api.fastcompany.com/v1/packages/person/search/pattern?page=1&rows_per_page=60&pattern=a

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/companies/search/pattern?page=' + page + '&rows_per_page=40&pattern=' + pattern + '&allow_index=1';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CompanyIndex;
}(_base_model2.default);

exports.default = CompanyIndex;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchCompanyDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _company_index_section_next_action_creators = __webpack_require__(782);

var companyIndexSectionNextActions = _interopRequireWildcard(_company_index_section_next_action_creators);

var _company_index_section_next_model = __webpack_require__(783);

var _company_index_section_next_model2 = _interopRequireDefault(_company_index_section_next_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchCompanyDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(companyIndexSectionNextActions.companyIndexSectionNextLoading({}, store));
    return _company_index_section_next_model2.default.fetch(params, store).then(function handleCompanyDetailData(CompanyData) {
      dispatch(companyIndexSectionNextActions.companyIndexSectionNextLoaded(CompanyData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(companyIndexSectionNextActions.companyIndexSectionNextLoadError(err, store));

      _logger_service2.default.error(err, 'Error in company actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyIndexSectionNextLoading = companyIndexSectionNextLoading;
exports.companyIndexSectionNextLoaded = companyIndexSectionNextLoaded;
exports.companyIndexSectionNextLoadError = companyIndexSectionNextLoadError;
// import { canUseDOM } from 'exenv';

function companyIndexSectionNextLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_NEXT_LOADING',
    companyIndexSectionNext: resp,
    store: store
  };
}

function companyIndexSectionNextLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_NEXT_LOADED',
    companyIndexSectionNext: resp,
    store: store
  };
}

function companyIndexSectionNextLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'COMPANY_INDEX_SECTION_NEXT_ERROR',
    companyIndexSectionNext: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompanyIndexNext = function (_Base) {
  _inherits(CompanyIndexNext, _Base);

  function CompanyIndexNext() {
    _classCallCheck(this, CompanyIndexNext);

    return _possibleConstructorReturn(this, (CompanyIndexNext.__proto__ || Object.getPrototypeOf(CompanyIndexNext)).apply(this, arguments));
  }

  _createClass(CompanyIndexNext, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var section = _ref.section,
          page = _ref.page;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      var pattern = section;
      if (pattern === '0-9') {
        pattern = '%5B0-9%5D';
      }
      // https://api.fastcompany.com/v1/packages/company/search/pattern?page=1&rows_per_page=60&pattern=a

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/companies/search/pattern?page=' + (Number(page) + 1) + '&rows_per_page=40&pattern=' + pattern + '&allow_index=1';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return CompanyIndexNext;
}(_base_model2.default);

exports.default = CompanyIndexNext;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/most-innovative-companies/:year',
    component: _mic_year_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _mic_year_page_state_manager2.default)(store),
    autoScrollOff: true
  };
};

var _mic_year_page = __webpack_require__(268);

var _mic_year_page2 = _interopRequireDefault(_mic_year_page);

var _mic_year_page_state_manager = __webpack_require__(786);

var _mic_year_page_state_manager2 = _interopRequireDefault(_mic_year_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = processAssetServerImage;
/**
 * Our legacy image stack has different urls than our cloudinary images,
 * these are found within our franchise pages (mic, ibd, and mcp)
 *
 * @param {string} imgSrc - legacy url for multisite files
 * @param {number} [width=387] width - width value
 * @param {number} [height=218] height - height value
 * @return {string} formatted image url
 *
 * @example
 * processAssetServer('multisite_files/fastcompany/REPLACE_ME/mic/mic-2016-logo.png')
 * // https://assets.fastcompany.com/multisite_files/fastcompany/imagecache/w/387/h/218/crop/mic/mic-2016-logo.png
 */
function processAssetServerImage(imgSrc) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 387;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 218;

  if (typeof imgSrc !== 'string') {
    return '';
  }

  return 'https://images.fastcompany.net/' + imgSrc.replace('REPLACE_ME', 'imagecache/w/' + width + '/h/' + height + '/crop');
}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_mic_year_page_actions = __webpack_require__(787);

var _async_mic_year_page_actions2 = _interopRequireDefault(_async_mic_year_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_mic_year_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_mic_year_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMicPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _mic_year_page_action_creators = __webpack_require__(788);

var micYearPageActions = _interopRequireWildcard(_mic_year_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_mic_year_actions = __webpack_require__(269);

var _async_mic_year_actions2 = _interopRequireDefault(_async_mic_year_actions);

var _async_mic_year_description_actions = __webpack_require__(270);

var _async_mic_year_description_actions2 = _interopRequireDefault(_async_mic_year_description_actions);

var _async_mic_sector_actions = __webpack_require__(271);

var _async_mic_sector_actions2 = _interopRequireDefault(_async_mic_sector_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMicPage(params, store) {
  return function firstDispatch(dispatch) {
    return _bluebird2.default.all([(0, _async_mic_year_actions2.default)(params, store)(dispatch), (0, _async_mic_sector_actions2.default)(params, store)(dispatch), (0, _async_mic_year_description_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(micYearPageActions.micYearPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(micYearPageActions.micYearPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.micYearPageLoading = micYearPageLoading;
exports.micYearPageLoaded = micYearPageLoaded;
exports.micYearPageLoadError = micYearPageLoadError;
// import { canUseDOM } from 'exenv';

function micYearPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_YEAR_PAGE_LOADING',
    micYearPage: resp,
    store: store
  };
}

function micYearPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_YEAR_PAGE_LOADED',
    micYearPage: resp,
    store: store
  };
}

function micYearPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_YEAR_PAGE_ERROR',
    micYearPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.micYearLoading = micYearLoading;
exports.micYearLoaded = micYearLoaded;
exports.micYearLoadError = micYearLoadError;
// import { canUseDOM } from 'exenv';

function micYearLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_YEAR_LOADING',
    micYear: resp,
    store: store
  };
}

function micYearLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];

  return {
    type: 'MIC_YEAR_LOADED',
    micYear: resp,
    store: store,
    year: year
  };
}

function micYearLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_YEAR_ERROR',
    micYear: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Mic = function (_Base) {
  _inherits(Mic, _Base);

  function Mic() {
    _classCallCheck(this, Mic);

    return _possibleConstructorReturn(this, (Mic.__proto__ || Object.getPrototypeOf(Mic)).apply(this, arguments));
  }

  _createClass(Mic, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var year = _ref.year;

      var cleanedYear = this.cleanParam(year);

      // change to 2018 when api is active
      if (cleanedYear < 2018 && cleanedYear > 2007) {
        var state = store.getState();
        var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
        var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
        var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
        var host = 'api.fastcompany.com';
        var options = {};
        // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

        // Don't worry about this token. Can be public. Talked to Harry.
        var cacheKeyUrl = 'https://' + host + '/v1/packages/mic/' + cleanedYear + '/companies/top/50?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
        var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

        if (!cacheEnabled) {
          return _request_util2.default.getAsync(cacheKeyUrl, options);
        }

        return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
          // TODO: refactor so we only need to do this on server
          if (cacheRes) {
            return _bluebird2.default.resolve(JSON.parse(cacheRes));
          }

          if (!_exenv.canUseDOM) {
            _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
          }

          return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
            _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
            return resp;
          });
        });
      }
      return _bluebird2.default.reject(new Error('Invalid Year'));
    }
  }]);

  return Mic;
}(_base_model2.default);

exports.default = Mic;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.micYearDescriptionLoading = micYearDescriptionLoading;
exports.micYearDescriptionLoaded = micYearDescriptionLoaded;
exports.micYearDescriptionLoadError = micYearDescriptionLoadError;
// import { canUseDOM } from 'exenv';

function micYearDescriptionLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_YEAR_DESCRIPTION_LOADING',
    micYearDescription: resp,
    store: store
  };
}

function micYearDescriptionLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_YEAR_DESCRIPTION_LOADED',
    micYearDescription: resp,
    store: store
  };
}

function micYearDescriptionLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_YEAR_DESCRIPTION_ERROR',
    micYearDescription: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Mic = function (_Base) {
  _inherits(Mic, _Base);

  function Mic() {
    _classCallCheck(this, Mic);

    return _possibleConstructorReturn(this, (Mic.__proto__ || Object.getPrototypeOf(Mic)).apply(this, arguments));
  }

  _createClass(Mic, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var year = _ref.year;

      var cleanedYear = this.cleanParam(year);

      // change to 2018 when api is active
      if (cleanedYear < 2018 && cleanedYear > 2007) {
        var state = store.getState();
        var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
        var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
        var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
        var host = 'api.fastcompany.com';
        var options = {};
        // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

        // Don't worry about this token. Can be public. Talked to Harry.
        var cacheKeyUrl = 'https://' + host + '/v1/packages/mic/' + year + '/details?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';

        var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

        if (!cacheEnabled) {
          return _request_util2.default.getAsync(cacheKeyUrl, options);
        }

        return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
          // TODO: refactor so we only need to do this on server
          if (cacheRes) {
            return _bluebird2.default.resolve(JSON.parse(cacheRes));
          }

          if (!_exenv.canUseDOM) {
            _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
          }

          return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
            _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
            return resp;
          });
        });
      }
      return _bluebird2.default.reject(new Error('Invalid Year'));
    }
  }]);

  return Mic;
}(_base_model2.default);

exports.default = Mic;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.micSectorLoading = micSectorLoading;
exports.micSectorLoaded = micSectorLoaded;
exports.micSectorLoadError = micSectorLoadError;

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function micSectorLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_SECTOR_LOADING',
    micSector: resp,
    store: store
  };
} // import { canUseDOM } from 'exenv';
function micSectorLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];
  var sector = arguments[3];

  (0, _extend2.default)(resp, { year: year });
  return {
    type: 'MIC_SECTOR_LOADED',
    micSector: resp,
    store: store,
    year: year,
    sector: sector
  };
}

function micSectorLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_SECTOR_ERROR',
    micSector: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MicSector = function (_Base) {
  _inherits(MicSector, _Base);

  function MicSector() {
    _classCallCheck(this, MicSector);

    return _possibleConstructorReturn(this, (MicSector.__proto__ || Object.getPrototypeOf(MicSector)).apply(this, arguments));
  }

  _createClass(MicSector, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var year = _ref.year;

      var cleanedYear = this.cleanParam(year);

      // change to 2018 when api is active
      if (cleanedYear < 2018 && cleanedYear > 2007) {
        var state = store.getState();
        var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
        var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
        var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
        var host = 'api.fastcompany.com';
        var options = {};
        // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

        // Don't worry about this token. Can be public. Talked to Harry.
        var cacheKeyUrl = 'https://' + host + '/v1/packages/mic/' + cleanedYear + '/sectors/companies?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
        var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

        if (!cacheEnabled) {
          return _request_util2.default.getAsync(cacheKeyUrl, options);
        }

        return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
          // TODO: refactor so we only need to do this on server
          if (cacheRes) {
            return _bluebird2.default.resolve(JSON.parse(cacheRes));
          }

          if (!_exenv.canUseDOM) {
            _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
          }

          return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
            _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
            return resp;
          });
        });
      }
      return _bluebird2.default.reject(new Error('Invalid Year'));
    }
  }]);

  return MicSector;
}(_base_model2.default);

exports.default = MicSector;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/most-innovative-companies/:year/sectors/:sector',
    component: _mic_year_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _mic_sector_page_state_manager2.default)(store),
    autoScrollOff: true
  };
};

var _mic_year_page = __webpack_require__(268);

var _mic_year_page2 = _interopRequireDefault(_mic_year_page);

var _mic_sector_page_state_manager = __webpack_require__(796);

var _mic_sector_page_state_manager2 = _interopRequireDefault(_mic_sector_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_mic_sector_page_actions = __webpack_require__(797);

var _async_mic_sector_page_actions2 = _interopRequireDefault(_async_mic_sector_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_mic_sector_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_mic_sector_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMicPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _mic_sector_page_action_creators = __webpack_require__(798);

var micYearPageActions = _interopRequireWildcard(_mic_sector_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_mic_year_actions = __webpack_require__(269);

var _async_mic_year_actions2 = _interopRequireDefault(_async_mic_year_actions);

var _async_mic_year_description_actions = __webpack_require__(270);

var _async_mic_year_description_actions2 = _interopRequireDefault(_async_mic_year_description_actions);

var _async_mic_sector_actions = __webpack_require__(271);

var _async_mic_sector_actions2 = _interopRequireDefault(_async_mic_sector_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchMicPage(params, store) {
  return function firstDispatch(dispatch) {
    return _bluebird2.default.all([(0, _async_mic_year_actions2.default)(params, store)(dispatch), (0, _async_mic_sector_actions2.default)(params, store)(dispatch), (0, _async_mic_year_description_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(micYearPageActions.micSectorPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(micYearPageActions.micSectorPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.micSectorPageLoading = micSectorPageLoading;
exports.micSectorPageLoaded = micSectorPageLoaded;
exports.micSectorPageLoadError = micSectorPageLoadError;
// import { canUseDOM } from 'exenv';

function micSectorPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_SECTOR_PAGE_LOADING',
    micSectorPage: resp,
    store: store
  };
}

function micSectorPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_SECTOR_PAGE_LOADED',
    micSectorPage: resp,
    store: store
  };
}

function micSectorPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'MIC_SECTOR_PAGE_ERROR',
    micSectorPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/person/:person',
    component: _person_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _person_page_state_manager2.default)(store)
  };
};

var _person_page = __webpack_require__(800);

var _person_page2 = _interopRequireDefault(_person_page);

var _person_page_state_manager = __webpack_require__(801);

var _person_page_state_manager2 = _interopRequireDefault(_person_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _person_company_component = __webpack_require__(265);

var _person_company_component2 = _interopRequireDefault(_person_company_component);

var _tag_all_feed_action_creators = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Person = function (_Component) {
  _inherits(Person, _Component);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          status = _props.status,
          config = _props.config,
          personPage = _props.personPage,
          person = _props.person,
          tagAllFeed = _props.tagAllFeed;


      if (status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (personPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'person-page' },
          _react2.default.createElement(
            'article',
            { className: 'person-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(personPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });
      var fullName = (0, _get2.default)(person, 'first_name') + ' ' + (0, _get2.default)(person, 'last_name');

      return _react2.default.createElement(
        'section',
        { className: 'person-page' },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobileleaderboard', region: 'articletop' })),
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true })),
        _react2.default.createElement(_person_company_component2.default, { personOrCompany: person, type: 'person' }),
        _react2.default.createElement(
          'div',
          { className: 'person-page__ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        ),
        (0, _get2.default)(tagAllFeed, 'posts[0]') ? _react2.default.createElement(_all_feed2.default, {
          adModel: combinedAdModel,
          stories: (0, _get2.default)(tagAllFeed, 'posts'),
          allRendered: true,
          updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
          config: config,
          titleOverride: 'Stories about ' + fullName
        }) : '',
        (0, _get2.default)(this.props, 'tagAllFeed.posts[0]') ? _react2.default.createElement(
          'div',
          { className: 'person-page__ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        ) : ''
      );
    }
  }]);

  return Person;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    person: (0, _get2.default)(state, 'person.data.rows[0]') || { error: true },
    personPage: (0, _get2.default)(state, 'personPage') || { error: true },
    tagAllFeed: {
      totalPosts: (0, _get2.default)(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: (0, _get2.default)(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: (0, _get2.default)(state, 'tagAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'tagAllFeed.data.posts', [])
    }
  };
}

Person.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number.isRequired,
  person: _propTypes2.default.shape({}).isRequired,
  personPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired,
  tagAllFeed: _propTypes2.default.shape({
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number,
    allRendered: _propTypes2.default.bool,
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Person);

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_person_page_actions = __webpack_require__(802);

var _async_person_page_actions2 = _interopRequireDefault(_async_person_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_person_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_person_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _person_page_action_creators = __webpack_require__(803);

var personPageActions = _interopRequireWildcard(_person_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_tag_all_feed_actions = __webpack_require__(81);

var _async_tag_all_feed_actions2 = _interopRequireDefault(_async_tag_all_feed_actions);

var _async_person_actions = __webpack_require__(804);

var _async_person_actions2 = _interopRequireDefault(_async_person_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(personPageActions.personPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_person_actions2.default)(params, store)(dispatch), (0, _async_tag_all_feed_actions2.default)(params, store, true)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(personPageActions.personPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(personPageActions.personPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personPageLoading = personPageLoading;
exports.personPageLoaded = personPageLoaded;
exports.personPageLoadError = personPageLoadError;
// import { canUseDOM } from 'exenv';

function personPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_PAGE_LOADING',
    personPage: resp,
    store: store
  };
}

function personPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_PAGE_LOADED',
    personPage: resp,
    store: store
  };
}

function personPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_PAGE_ERROR',
    personPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _person_action_creators = __webpack_require__(805);

var personActions = _interopRequireWildcard(_person_action_creators);

var _person_model = __webpack_require__(806);

var _person_model2 = _interopRequireDefault(_person_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(personActions.personLoading({}, store));
    return _person_model2.default.fetch(params, store).then(function handlePersonDetailData(PersonData) {
      dispatch(personActions.personLoaded(PersonData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(personActions.personLoadError(err, store));

      _logger_service2.default.error(err, 'Error in person actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personLoading = personLoading;
exports.personLoaded = personLoaded;
exports.personLoadError = personLoadError;
// import { canUseDOM } from 'exenv';

function personLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_LOADING',
    person: resp,
    store: store
  };
}

function personLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_LOADED',
    person: resp,
    store: store
  };
}

function personLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PERSON_ERROR',
    person: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Person = function (_Base) {
  _inherits(Person, _Base);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var person = _ref.person;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=' + this.cleanParam(person);
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Person;
}(_base_model2.default);

exports.default = Person;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/company/:section/:page',
    component: _company_index_section_page2.default,
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: (0, _company_index_section_page_state_manager2.default)(store)
  };
};

var _company_index_section_page = __webpack_require__(266);

var _company_index_section_page2 = _interopRequireDefault(_company_index_section_page);

var _company_index_section_page_state_manager = __webpack_require__(267);

var _company_index_section_page_state_manager2 = _interopRequireDefault(_company_index_section_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/:id/:slug',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(82);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(83);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _post_finite_action_creators = __webpack_require__(811);

var postFiniteActions = _interopRequireWildcard(_post_finite_action_creators);

var _post_finite_module = __webpack_require__(812);

var _post_finite_module2 = _interopRequireDefault(_post_finite_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(dispatch, id, config) {
  dispatch(postFiniteActions.postFiniteLoading());
  return _post_finite_module2.default.fetch(id, config).then(function handlePostDetailData(resp) {
    dispatch(postFiniteActions.postFiniteLoaded(resp.data));
  }).catch(function handleUserError(err) {
    dispatch(postFiniteActions.postFiniteLoadError(err));
    _logger_service2.default.error(err, 'Error in post finite actions, message: ' + err.message);
  });
}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postFiniteLoading = postFiniteLoading;
exports.postFiniteLoaded = postFiniteLoaded;
exports.postFiniteLoadError = postFiniteLoadError;
// import { canUseDOM } from 'exenv';

function postFiniteLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'POST_FINITE_LOADING',
    postFinite: resp
  };
}

function postFiniteLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'POST_FINITE_LOADED',
    postFinite: {
      posts: resp.posts
    }
  };
}

function postFiniteLoadError(error) {
  return {
    type: 'POST_FINITE_ERROR',
    postFinite: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    }
  };
}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _remove = __webpack_require__(813);

var _remove2 = _interopRequireDefault(_remove);

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _toNumber = __webpack_require__(100);

var _toNumber2 = _interopRequireDefault(_toNumber);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostFiniteScrollModel = function (_Base) {
  _inherits(PostFiniteScrollModel, _Base);

  function PostFiniteScrollModel() {
    _classCallCheck(this, PostFiniteScrollModel);

    return _possibleConstructorReturn(this, (PostFiniteScrollModel.__proto__ || Object.getPrototypeOf(PostFiniteScrollModel)).apply(this, arguments));
  }

  _createClass(PostFiniteScrollModel, null, [{
    key: 'fetch',
    value: function fetch(id, config) {
      var cacheEnabled = (0, _get2.default)(config, 'cacheEnabled');
      var cacheExpire = (0, _get2.default)(config, 'cacheExpire');
      var cacheNamespace = (0, _get2.default)(config, 'cacheNamespace');
      var site = (0, _get2.default)(config, 'site');
      var host = (0, _get2.default)(config, 'apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(config, 'protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(config, 'authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)({ config: config }));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/' + site + '/post-finite';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      function removeId(resp) {
        var posts = (0, _get2.default)(resp, 'data.posts');
        (0, _remove2.default)(posts, { id: (0, _toNumber2.default)(id) });
        (0, _set2.default)(resp, 'data.posts', posts);
        return resp;
      }

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(removeId);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(removeId).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return PostFiniteScrollModel;
}(_base_model2.default);

exports.default = PostFiniteScrollModel;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(78),
    basePullAt = __webpack_require__(814);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(206),
    isIndex = __webpack_require__(72);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _postpage_action_creators = __webpack_require__(272);

var postpageActions = _interopRequireWildcard(_postpage_action_creators);

var _async_post_actions = __webpack_require__(816);

var _async_post_actions2 = _interopRequireDefault(_async_post_actions);

var _async_post_video_actions = __webpack_require__(819);

var _async_post_video_actions2 = _interopRequireDefault(_async_post_video_actions);

var _async_post_more_stories_actions = __webpack_require__(822);

var _async_post_more_stories_actions2 = _interopRequireDefault(_async_post_more_stories_actions);

var _async_afterbody_recirc_module_type_actions = __webpack_require__(825);

var _async_afterbody_recirc_module_type_actions2 = _interopRequireDefault(_async_afterbody_recirc_module_type_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postpageActions.postpageLoading({}, store));

    var asyncPostActionsList = [(0, _async_afterbody_recirc_module_type_actions2.default)(params, store)(dispatch), (0, _async_post_actions2.default)(params, store)(dispatch), (0, _async_post_video_actions2.default)(params, store)(dispatch), (0, _async_post_more_stories_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)];

    return _bluebird2.default.all(asyncPostActionsList).then(function handlePostDetailData() {
      dispatch(postpageActions.postpageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(postpageActions.postpageLoadError(err, store));
      _logger_service2.default.error(err, 'Error in post page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _exenv = __webpack_require__(4);

var _urlParse = __webpack_require__(45);

var _urlParse2 = _interopRequireDefault(_urlParse);

var _post_action_creators = __webpack_require__(817);

var postActions = _interopRequireWildcard(_post_action_creators);

var _post = __webpack_require__(818);

var _post2 = _interopRequireDefault(_post);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _redirect_action_creators = __webpack_require__(273);

var _redirect_action_creators2 = _interopRequireDefault(_redirect_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    dispatch(postActions.postLoading({}, store));
    return _post2.default.fetch(params, store).then(function handlePostDetailData(PostData) {
      var isPreview = (0, _get2.default)(state, 'config.isPreview');
      var isAmp = (0, _get2.default)(state, 'config.amp');
      var postLink = (0, _get2.default)(PostData, 'data.post.link');
      var currentUrl = (0, _get2.default)(state, 'config.navHistory[0]');
      if (!_exenv.canUseDOM && postLink && !isPreview) {
        if (currentUrl !== postLink) {
          var parsedCurrent = new _urlParse2.default(currentUrl).pathname;
          var parsedPostLink = new _urlParse2.default(postLink).pathname;
          if (parsedCurrent !== parsedPostLink) {
            if (isAmp) {
              postLink = postLink.replace('www', 'amp');
            }
            dispatch((0, _redirect_action_creators2.default)({
              status: 301,
              redirect: postLink
            }));
          }
        }
      }

      dispatch(postActions.postLoaded(PostData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 400 || status === 403) {
        dispatch((0, _not_found_status_action_creator2.default)(403, 'UNPUBLISHED_STATUS', store));
      }
      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }
      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(postActions.postLoadError(err, store));
      _logger_service2.default.error(err, 'Error in post actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postLoading = postLoading;
exports.postLoaded = postLoaded;
exports.postLoadError = postLoadError;
// import { canUseDOM } from 'exenv';

function postLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_LOADING',
    post: resp,
    store: store
  };
}

function postLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_LOADED',
    post: resp,
    store: store
  };
}

function postLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_ERROR',
    post: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Post = function (_Base) {
  _inherits(Post, _Base);

  function Post() {
    _classCallCheck(this, Post);

    return _possibleConstructorReturn(this, (Post.__proto__ || Object.getPrototypeOf(Post)).apply(this, arguments));
  }

  _createClass(Post, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var id = _ref.id;

      var state = store.getState();
      var isPreview = (0, _get2.default)(state, 'config.isPreview');
      var amp = (0, _get2.default)(state, 'config.amp') ? '?amp=true' : '';
      var cacheEnabled = isPreview ? false : (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      var postRelatedSlug = isPreview ? 'preview-post-related' : 'post-related';
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = isPreview ? '' + protocol + host + '/api/v2/' + postRelatedSlug + '/' + site + '/' + id + amp : '' + protocol + host + '/api/v3/' + postRelatedSlug + '/' + site + '/' + id + amp;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Post;
}(_base_model2.default);

exports.default = Post;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _post_video_action_creators = __webpack_require__(820);

var postVideoActions = _interopRequireWildcard(_post_video_action_creators);

var _post_video_module = __webpack_require__(821);

var _post_video_module2 = _interopRequireDefault(_post_video_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postVideoActions.postVideoLoading({}, store));
    return _post_video_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(postVideoActions.postVideoLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(postVideoActions.postVideoLoadError(err, store));
      _logger_service2.default.error(err, 'Error in post video actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postVideoLoading = postVideoLoading;
exports.postVideoLoaded = postVideoLoaded;
exports.postVideoLoadError = postVideoLoadError;
// import { canUseDOM } from 'exenv';

function postVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_VIDEO_LOADING',
    postVideo: resp,
    store: store
  };
}

function postVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_VIDEO_LOADED',
    postVideo: resp,
    store: store
  };
}

function postVideoLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_VIDEO_ERROR',
    postVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var homepageJwIdMap = {
  fastcompany: 'R6of2m4z',
  fastcodesign: 'mQZdMNHq'
};

var HomePageVideo = function (_Base) {
  _inherits(HomePageVideo, _Base);

  function HomePageVideo() {
    _classCallCheck(this, HomePageVideo);

    return _possibleConstructorReturn(this, (HomePageVideo.__proto__ || Object.getPrototypeOf(HomePageVideo)).apply(this, arguments));
  }

  _createClass(HomePageVideo, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var site = (0, _get2.default)(state, 'config.site');
      var id = (0, _get2.default)(homepageJwIdMap, site) || homepageJwIdMap.fastcompany;
      var host = 'content.jwplatform.com';
      var options = {};

      var cacheKeyUrl = 'https://' + host + '/feeds/' + id + '.json';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return HomePageVideo;
}(_base_model2.default);

exports.default = HomePageVideo;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPostDetail;

var _post_more_stories_action_creators = __webpack_require__(823);

var postMoreStoriesActions = _interopRequireWildcard(_post_more_stories_action_creators);

var _post_more_stories_module = __webpack_require__(824);

var _post_more_stories_module2 = _interopRequireDefault(_post_more_stories_module);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postMoreStoriesActions.postMoreStoriesLoading({}, store));
    return _post_more_stories_module2.default.fetch(params, store).then(function handlePostDetailData(resp) {
      dispatch(postMoreStoriesActions.postMoreStoriesLoaded(resp.data, store));
    }).catch(function handleUserError(err) {
      dispatch(postMoreStoriesActions.postMoreStoriesLoadError(err, store));
      _logger_service2.default.error(err, 'Error in post see more actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postMoreStoriesLoading = postMoreStoriesLoading;
exports.postMoreStoriesLoaded = postMoreStoriesLoaded;
exports.postMoreStoriesLoadError = postMoreStoriesLoadError;
// import { canUseDOM } from 'exenv';

function postMoreStoriesLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_MORE_STORIES_LOADING',
    postMoreStories: resp,
    store: store
  };
}

function postMoreStoriesLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_MORE_STORIES_LOADED',
    postMoreStories: resp,
    store: store
  };
}

function postMoreStoriesLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_MORE_STORIES_ERROR',
    postMoreStories: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostSeeMoreModel = function (_Base) {
  _inherits(PostSeeMoreModel, _Base);

  function PostSeeMoreModel() {
    _classCallCheck(this, PostSeeMoreModel);

    return _possibleConstructorReturn(this, (PostSeeMoreModel.__proto__ || Object.getPrototypeOf(PostSeeMoreModel)).apply(this, arguments));
  }

  _createClass(PostSeeMoreModel, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/tag-homepage-feed/' + site + '?total=4';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return PostSeeMoreModel;
}(_base_model2.default);

exports.default = PostSeeMoreModel;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = afterbodyRecircModuleTypeAction;

var _post_afterbody_recirc_module_type_action_creators = __webpack_require__(826);

var afterbodyRecircModuleTypeActions = _interopRequireWildcard(_post_afterbody_recirc_module_type_action_creators);

var _afterbody_recirc_module_type = __webpack_require__(827);

var _afterbody_recirc_module_type2 = _interopRequireDefault(_afterbody_recirc_module_type);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function afterbodyRecircModuleTypeAction(params, store) {
  return function afterbodyRecircModuleTypeDispatch(dispatch) {
    dispatch(afterbodyRecircModuleTypeActions.afterbodyRecircModuleTypeLoading(store));
    return _afterbody_recirc_module_type2.default.fetch(params, store).then(function handleAfterbodyRecircModuleTypeData(resp) {
      dispatch(afterbodyRecircModuleTypeActions.afterbodyRecircModuleTypeLoaded(resp.data, store));
    }).catch(function handleAfterbodyRecircModuleTypeError(err) {
      dispatch(afterbodyRecircModuleTypeActions.afterbodyRecircModuleTypeLoadError(err, store));
      _logger_service2.default.error(err, 'Error in all feed actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.afterbodyRecircModuleTypeLoading = afterbodyRecircModuleTypeLoading;
exports.afterbodyRecircModuleTypeLoaded = afterbodyRecircModuleTypeLoaded;
exports.afterbodyRecircModuleTypeLoadError = afterbodyRecircModuleTypeLoadError;
// import { canUseDOM } from 'exenv';

function afterbodyRecircModuleTypeLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADING',
    postAfterbodyRecircModule: resp,
    store: store
  };
}

function afterbodyRecircModuleTypeLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADED',
    postAfterbodyRecircModule: resp,
    store: store
  };
}

function afterbodyRecircModuleTypeLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_ERROR',
    postAfterbodyRecircModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AfterbodyRecircModuleType = function (_Base) {
  _inherits(AfterbodyRecircModuleType, _Base);

  function AfterbodyRecircModuleType() {
    _classCallCheck(this, AfterbodyRecircModuleType);

    return _possibleConstructorReturn(this, (AfterbodyRecircModuleType.__proto__ || Object.getPrototypeOf(AfterbodyRecircModuleType)).apply(this, arguments));
  }

  _createClass(AfterbodyRecircModuleType, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var site = (0, _get2.default)(state, 'config.site');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v2/afterbody-recirc-module-type/' + site;
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return AfterbodyRecircModuleType;
}(_base_model2.default);

exports.default = AfterbodyRecircModuleType;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/:id/:section/:slug',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(82);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(83);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/:id/:section/:slug/:pageNumber',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(82);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(83);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/pvw/:id/:slug',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(82);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(83);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/pvw/:id/:section/:slug',
    component: _post_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _postpage_state_manager2.default)(store)
  };
};

var _post_page = __webpack_require__(82);

var _post_page2 = _interopRequireDefault(_post_page);

var _postpage_state_manager = __webpack_require__(83);

var _postpage_state_manager2 = _interopRequireDefault(_postpage_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    component: _not_found_page2.default,
    loadData: (0, _not_found_page_state_manager2.default)(store)
  };
};

var _not_found_page = __webpack_require__(833);

var _not_found_page2 = _interopRequireDefault(_not_found_page);

var _not_found_page_state_manager = __webpack_require__(834);

var _not_found_page_state_manager2 = _interopRequireDefault(_not_found_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return _react2.default.createElement(
    'div',
    { className: 'not-found-page' },
    _react2.default.createElement(_not_found_component2.default, null)
  );
};

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = notFoundPageData;

var _exenv = __webpack_require__(4);

var _async_not_found_page_actions = __webpack_require__(835);

var _async_not_found_page_actions2 = _interopRequireDefault(_async_not_found_page_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function notFoundPageData(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_not_found_page_actions2.default)(nextState, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }

    // run sync
    dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS'));
    return (0, _async_not_found_page_actions2.default)(nextState, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleServerSideRenderError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchNotFoundPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _not_found_page_action_creators = __webpack_require__(836);

var notFoundPageActionCreator = _interopRequireWildcard(_not_found_page_action_creators);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchNotFoundPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(notFoundPageActionCreator.notFoundPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(notFoundPageActionCreator.notFoundPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch(notFoundPageActionCreator(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch(notFoundPageActionCreator(500, 'ERROR_STATUS', store));
      }
      dispatch(notFoundPageActionCreator.notFoundPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in wp page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notFoundPageLoading = notFoundPageLoading;
exports.notFoundPageLoaded = notFoundPageLoaded;
exports.notFoundPageLoadError = notFoundPageLoadError;
function notFoundPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'NOT_FOUND_LOADING',
    notFoundPage: resp
  };
}

function notFoundPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'NOT_FOUND_LOADED',
    notFoundPage: resp
  };
}

function notFoundPageLoadError(error) {
  return {
    type: 'NOT_FOUND_ERROR',
    notFoundPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    }
  };
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/video/:slug/:id',
    component: _video_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _video_page_state_manager2.default)(store)
  };
};

var _video_page = __webpack_require__(838);

var _video_page2 = _interopRequireDefault(_video_page);

var _video_page_state_manager = __webpack_require__(839);

var _video_page_state_manager2 = _interopRequireDefault(_video_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _container = __webpack_require__(146);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var VideoPage = function (_Component) {
  _inherits(VideoPage, _Component);

  function VideoPage() {
    _classCallCheck(this, VideoPage);

    return _possibleConstructorReturn(this, (VideoPage.__proto__ || Object.getPrototypeOf(VideoPage)).apply(this, arguments));
  }

  _createClass(VideoPage, [{
    key: 'render',
    value: function render() {
      if (this.props.status === 404 || this.props.status === 500) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.videoPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'video-page' },
          _react2.default.createElement(
            'article',
            { className: 'video-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var _props = this.props,
          videoPage = _props.videoPage,
          jwVideo = _props.jwVideo,
          jwRelatedVideo = _props.jwRelatedVideo,
          jwNewestVideo = _props.jwNewestVideo,
          config = _props.config;

      var adData = (0, _get2.default)(this.props.videoPage, 'ads');
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });
      var containerProps = {
        config: this.props.config,
        posts: [(0, _get2.default)(jwVideo, 'data.playlist[0]')],
        related: (0, _get2.default)(jwRelatedVideo, 'data.playlist', []),
        combinedAdModel: combinedAdModel,
        isDesktop: false, // disable sticky sidebars and social
        pageNum: 1,
        mediaid: (0, _get2.default)(jwVideo, 'data.playlist[0].mediaid'),
        videoAdData: (0, _get2.default)(videoPage, 'ads.model', {})
      };

      return _react2.default.createElement(
        'section',
        { className: 'post-page' },
        _react2.default.createElement(_container2.default, containerProps),
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
          noLazyLoad: true,
          pos: 'atf',
          name: 'flexiblebillboard_1'
        })),
        _react2.default.createElement(_all_feed2.default, {
          adModel: combinedAdModel,
          titleOverride: 'Latest Videos',
          stories: (0, _get2.default)(jwNewestVideo, 'data.playlist', []),
          allRendered: true,
          config: config
        }),
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_2' }))
      );
    }
  }]);

  return VideoPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    videoPage: (0, _get2.default)(state, 'videoPage', { error: true }),
    jwVideo: (0, _get2.default)(state, 'jwVideo'),
    jwRelatedVideo: (0, _get2.default)(state, 'jwRelatedVideo'),
    jwNewestVideo: (0, _get2.default)(state, 'jwNewestVideo')
  };
}

VideoPage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number.isRequired,
  videoPage: _propTypes2.default.shape({
    isLoading: _propTypes2.default.bool
  }).isRequired,
  jwVideo: _propTypes2.default.shape({}).isRequired,
  jwRelatedVideo: _propTypes2.default.shape({}).isRequired,
  jwNewestVideo: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(VideoPage);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_video_page_actions = __webpack_require__(840);

var _async_video_page_actions2 = _interopRequireDefault(_async_video_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_video_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_video_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchVideoPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _video_page_action_creators = __webpack_require__(841);

var videoPageActions = _interopRequireWildcard(_video_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_jw_video_actions = __webpack_require__(842);

var _async_jw_video_actions2 = _interopRequireDefault(_async_jw_video_actions);

var _async_jw_related_video_actions = __webpack_require__(845);

var _async_jw_related_video_actions2 = _interopRequireDefault(_async_jw_related_video_actions);

var _async_jw_newest_video_actions = __webpack_require__(848);

var _async_jw_newest_video_actions2 = _interopRequireDefault(_async_jw_newest_video_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchVideoPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(videoPageActions.videoPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_jw_video_actions2.default)(params, store)(dispatch), (0, _async_jw_related_video_actions2.default)(params, store)(dispatch), (0, _async_jw_newest_video_actions2.default)(params, store)(dispatch),
    // tagAllFeedActions(params, store, true)(dispatch),
    (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(videoPageActions.videoPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(videoPageActions.videoPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

// import tagAllFeedActions from './async_tag_all_feed_actions';

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoPageLoading = videoPageLoading;
exports.videoPageLoaded = videoPageLoaded;
exports.videoPageLoadError = videoPageLoadError;
// import { canUseDOM } from 'exenv';

function videoPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'VIDEO_PAGE_LOADING',
    videoPage: resp,
    store: store
  };
}

function videoPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'VIDEO_PAGE_LOADED',
    videoPage: resp,
    store: store
  };
}

function videoPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'VIDEO_PAGE_ERROR',
    videoPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchJwVideoDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _exenv = __webpack_require__(4);

var _urlParse = __webpack_require__(45);

var _urlParse2 = _interopRequireDefault(_urlParse);

var _jw_video_action_creators = __webpack_require__(843);

var jwVideoActions = _interopRequireWildcard(_jw_video_action_creators);

var _jw_video_model = __webpack_require__(844);

var _jw_video_model2 = _interopRequireDefault(_jw_video_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _redirect_action_creators = __webpack_require__(273);

var _redirect_action_creators2 = _interopRequireDefault(_redirect_action_creators);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchJwVideoDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    dispatch(jwVideoActions.jwVideoLoading({}, store));
    return _jw_video_model2.default.fetch(params, store).then(function handleJwVideoDetailData(JwVideoData) {
      var currentUrl = (0, _get2.default)(state, 'config.navHistory[0]');
      var postLink = (0, _get2.default)(JwVideoData, 'data.playlist[0].link');
      if (!_exenv.canUseDOM && postLink) {
        if (currentUrl !== postLink) {
          var parsedCurrent = new _urlParse2.default(currentUrl).pathname;
          var parsedPostLink = new _urlParse2.default(postLink).pathname;
          if (parsedCurrent !== parsedPostLink) {
            dispatch((0, _redirect_action_creators2.default)({
              status: 301,
              redirect: postLink
            }));
          }
        }
      }
      dispatch(jwVideoActions.jwVideoLoaded(JwVideoData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(jwVideoActions.jwVideoLoadError(err, store));

      _logger_service2.default.error(err, 'Error in jwVideo actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jwVideoLoading = jwVideoLoading;
exports.jwVideoLoaded = jwVideoLoaded;
exports.jwVideoLoadError = jwVideoLoadError;
// import { canUseDOM } from 'exenv';

function jwVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_VIDEO_LOADING',
    jwVideo: resp,
    store: store
  };
}

function jwVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_VIDEO_LOADED',
    jwVideo: resp,
    store: store
  };
}

function jwVideoLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_VIDEO_ERROR',
    jwVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JWVideo = function (_Base) {
  _inherits(JWVideo, _Base);

  function JWVideo() {
    _classCallCheck(this, JWVideo);

    return _possibleConstructorReturn(this, (JWVideo.__proto__ || Object.getPrototypeOf(JWVideo)).apply(this, arguments));
  }

  _createClass(JWVideo, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var id = _ref.id;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v1/jw-video/' + id;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return JWVideo;
}(_base_model2.default);

exports.default = JWVideo;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchJwRelatedVideoDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _jw_related_video_action_creators = __webpack_require__(846);

var jwRelatedVideoActions = _interopRequireWildcard(_jw_related_video_action_creators);

var _jw_related_video_model = __webpack_require__(847);

var _jw_related_video_model2 = _interopRequireDefault(_jw_related_video_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchJwRelatedVideoDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(jwRelatedVideoActions.jwRelatedVideoLoading({}, store));
    return _jw_related_video_model2.default.fetch(params, store).then(function handleJwRelatedVideoDetailData(JwRelatedVideoData) {
      dispatch(jwRelatedVideoActions.jwRelatedVideoLoaded(JwRelatedVideoData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(jwRelatedVideoActions.jwRelatedVideoLoadError(err, store));

      _logger_service2.default.error(err, 'Error in jwRelatedVideo actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jwRelatedVideoLoading = jwRelatedVideoLoading;
exports.jwRelatedVideoLoaded = jwRelatedVideoLoaded;
exports.jwRelatedVideoLoadError = jwRelatedVideoLoadError;
// import { canUseDOM } from 'exenv';

function jwRelatedVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_RELATED_VIDEO_LOADING',
    jwRelatedVideo: resp,
    store: store
  };
}

function jwRelatedVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_RELATED_VIDEO_LOADED',
    jwRelatedVideo: resp,
    store: store
  };
}

function jwRelatedVideoLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_RELATED_VIDEO_ERROR',
    jwRelatedVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JWRelatedVideos = function (_Base) {
  _inherits(JWRelatedVideos, _Base);

  function JWRelatedVideos() {
    _classCallCheck(this, JWRelatedVideos);

    return _possibleConstructorReturn(this, (JWRelatedVideos.__proto__ || Object.getPrototypeOf(JWRelatedVideos)).apply(this, arguments));
  }

  _createClass(JWRelatedVideos, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var id = _ref.id;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};
      // api has auth in beta
      if ((0, _get2.default)(state, 'config.authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(state));
      }

      var cacheKeyUrl = '' + protocol + host + '/api/v3/jw-related-videos/' + id;

      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return JWRelatedVideos;
}(_base_model2.default);

exports.default = JWRelatedVideos;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchJwNewestVideoDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _jw_newest_video_action_creators = __webpack_require__(849);

var jwNewestVideoActions = _interopRequireWildcard(_jw_newest_video_action_creators);

var _jw_playlist_model = __webpack_require__(274);

var _jw_playlist_model2 = _interopRequireDefault(_jw_playlist_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchJwNewestVideoDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(jwNewestVideoActions.jwNewestVideoLoading({}, store));

    // we override the id here for the newest playlist
    (0, _set2.default)(params, 'playlistId', 'Y4a4AwUd');

    return _jw_playlist_model2.default.fetch(params, store).then(function handleJwNewestVideoDetailData(JwNewestVideoData) {
      dispatch(jwNewestVideoActions.jwNewestVideoLoaded(JwNewestVideoData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(jwNewestVideoActions.jwNewestVideoLoadError(err, store));

      _logger_service2.default.error(err, 'Error in jwNewestVideo actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jwNewestVideoLoading = jwNewestVideoLoading;
exports.jwNewestVideoLoaded = jwNewestVideoLoaded;
exports.jwNewestVideoLoadError = jwNewestVideoLoadError;
// import { canUseDOM } from 'exenv';

function jwNewestVideoLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_NEWEST_VIDEO_LOADING',
    jwNewestVideo: resp,
    store: store
  };
}

function jwNewestVideoLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_NEWEST_VIDEO_LOADED',
    jwNewestVideo: resp,
    store: store
  };
}

function jwNewestVideoLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_NEWEST_VIDEO_ERROR',
    jwNewestVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/videos/playlists',
    component: _playlist_index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _playlist_index_page_state_manager2.default)(store)
  };
};

var _playlist_index_page = __webpack_require__(851);

var _playlist_index_page2 = _interopRequireDefault(_playlist_index_page);

var _playlist_index_page_state_manager = __webpack_require__(852);

var _playlist_index_page_state_manager2 = _interopRequireDefault(_playlist_index_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouter = __webpack_require__(22);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */

// This lib is under 1kb gzipped - maybe we move to api later on


// eslint-disable-next-line
var PlaylistIndexPage = function (_Component) {
  _inherits(PlaylistIndexPage, _Component);

  function PlaylistIndexPage() {
    _classCallCheck(this, PlaylistIndexPage);

    var _this = _possibleConstructorReturn(this, (PlaylistIndexPage.__proto__ || Object.getPrototypeOf(PlaylistIndexPage)).call(this));

    _this.renderPlaylist = _this.renderPlaylist.bind(_this);
    return _this;
  }

  _createClass(PlaylistIndexPage, [{
    key: 'renderPlaylist',
    value: function renderPlaylist(playlist) {
      var config = this.props.config;


      return _react2.default.createElement(
        _fc_link2.default,
        {
          config: config,
          title: '' + playlist.title,
          to: '/videos/playlist/' + playlist.slug + '/' + playlist.feedid,
          key: playlist.feedid
        },
        _react2.default.createElement(_slug2.default, {
          slugName: '' + playlist.title,
          className: 'category-page'
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.status === 404 || this.props.status === 500) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.playlistIndexPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'playlist-page' },
          _react2.default.createElement(
            'article',
            { className: 'playlist-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      return _react2.default.createElement(
        'section',
        { className: 'tag-page' },
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, {
            slugName: 'Fast Company Playlists',
            className: 'category-page'
          }),
          (0, _get2.default)(this.props, 'jwPlaylistIndex.data.playlists', []).map(this.renderPlaylist)
        )
      );
    }
  }]);

  return PlaylistIndexPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    playlistIndexPage: state.playlistIndexPage,
    jwPlaylistIndex: state.jwPlaylistIndex
  };
}

PlaylistIndexPage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number,
  playlistIndexPage: _propTypes2.default.shape({}),
  jwPlaylistIndex: _propTypes2.default.shape({})
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(PlaylistIndexPage));

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_playlist_index_page_actions = __webpack_require__(853);

var _async_playlist_index_page_actions2 = _interopRequireDefault(_async_playlist_index_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_playlist_index_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_playlist_index_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPlaylistPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _playlist_index_page_action_creators = __webpack_require__(854);

var playlistIndexPageActions = _interopRequireWildcard(_playlist_index_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_jw_playlist_index_actions = __webpack_require__(275);

var _async_jw_playlist_index_actions2 = _interopRequireDefault(_async_jw_playlist_index_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPlaylistPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(playlistIndexPageActions.playlistIndexPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_jw_playlist_index_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(playlistIndexPageActions.playlistIndexPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(playlistIndexPageActions.playlistIndexPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playlistIndexPageLoading = playlistIndexPageLoading;
exports.playlistIndexPageLoaded = playlistIndexPageLoaded;
exports.playlistIndexPageLoadError = playlistIndexPageLoadError;
// import { canUseDOM } from 'exenv';

function playlistIndexPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PLAYLIST_INDEX_PAGE_LOADING',
    playlistIndexPage: resp,
    store: store
  };
}

function playlistIndexPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PLAYLIST_INDEX_PAGE_LOADED',
    playlistIndexPage: resp,
    store: store
  };
}

function playlistIndexPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PLAYLIST_INDEX_PAGE_ERROR',
    playlistIndexPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jwPlaylistIndexLoading = jwPlaylistIndexLoading;
exports.jwPlaylistIndexLoaded = jwPlaylistIndexLoaded;
exports.jwPlaylistIndexLoadError = jwPlaylistIndexLoadError;
// import { canUseDOM } from 'exenv';

function jwPlaylistIndexLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_PLAYLIST_INDEX_LOADING',
    jwPlaylistIndex: resp,
    store: store
  };
}

function jwPlaylistIndexLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_PLAYLIST_INDEX_LOADED',
    jwPlaylistIndex: resp,
    store: store
  };
}

function jwPlaylistIndexLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_PLAYLIST_INDEX_ERROR',
    jwPlaylistIndex: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JWPlaylistIndexModel = function (_Base) {
  _inherits(JWPlaylistIndexModel, _Base);

  function JWPlaylistIndexModel() {
    _classCallCheck(this, JWPlaylistIndexModel);

    return _possibleConstructorReturn(this, (JWPlaylistIndexModel.__proto__ || Object.getPrototypeOf(JWPlaylistIndexModel)).apply(this, arguments));
  }

  _createClass(JWPlaylistIndexModel, null, [{
    key: 'fetch',
    value: function fetch(params, store) {
      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = (0, _get2.default)(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
      var protocol = (0, _get2.default)(state, 'config.protocol') || 'https://';
      var options = {};

      var cacheKeyUrl = '' + protocol + host + '/api/v1/jw-playlist-index';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }
        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return JWPlaylistIndexModel;
}(_base_model2.default);

exports.default = JWPlaylistIndexModel;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/videos',
    component: _video_index_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _video_index_page_state_manager2.default)(store)
  };
};

var _video_index_page = __webpack_require__(858);

var _video_index_page2 = _interopRequireDefault(_video_index_page);

var _video_index_page_state_manager = __webpack_require__(859);

var _video_index_page_state_manager2 = _interopRequireDefault(_video_index_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouter = __webpack_require__(22);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _reactJwPlayer = __webpack_require__(243);

var _reactJwPlayer2 = _interopRequireDefault(_reactJwPlayer);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _related_slider = __webpack_require__(248);

var _related_slider2 = _interopRequireDefault(_related_slider);

var _video_module_ads = __webpack_require__(140);

var _video_module_ads2 = _interopRequireDefault(_video_module_ads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


// eslint-disable-next-line
var VideoIndexPage = function (_Component) {
  _inherits(VideoIndexPage, _Component);

  function VideoIndexPage(props) {
    _classCallCheck(this, VideoIndexPage);

    var _this = _possibleConstructorReturn(this, (VideoIndexPage.__proto__ || Object.getPrototypeOf(VideoIndexPage)).call(this));

    _this.renderVideoPlaylist = _this.renderVideoPlaylist.bind(_this);
    return _this;
  }

  _createClass(VideoIndexPage, [{
    key: 'renderVideoPlaylist',
    value: function renderVideoPlaylist(playlist, index) {
      var config = this.props.config;

      var props = this.props;
      var adData = (0, _get2.default)(props, 'videoIndexPage.ads', {});
      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });
      return [_react2.default.createElement(_related_slider2.default, {
        key: playlist.feedid,
        title: playlist.title,
        related: playlist.playlist,
        classNames: ['related-slider--video-index'],
        slideClassNames: ['video-slide--horizontal-tight'],
        config: config,
        responsive: [{
          breakpoint: 640,
          settings: {
            slidesToShow: 2.15,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 100000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }]
      }), index % 3 === 0 ? _react2.default.createElement(
        'div',
        { className: 'video-index-page__ad-container', key: index },
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: 'flexiblebillboard_' + (index / 3 + 1) })),
        _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { pos: 'btf', name: index === 0 ? "mobileparallax_1" : 'mobilerectangle_' + (index / 3 + 1) }))
      ) : ''];
    }
  }, {
    key: 'render',
    value: function render() {

      if (this.props.status === 404 || this.props.status === 500) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.videoIndexPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'video-page' },
          _react2.default.createElement(
            'article',
            { className: 'video-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      return _react2.default.createElement(
        'section',
        { className: 'video-index-page' },
        _react2.default.createElement(
          'section',
          { className: 'video-index-page__video-wrapper' },
          _react2.default.createElement(_reactJwPlayer2.default, {
            playerId: 'video--index-page',
            playerScript: 'https://content.jwplatform.com/libraries/S002m6Rz.js',
            playlist: 'https://fc-api.fastcompany.com/api/v1/jw-feed/0lmMve0i',
            generatePrerollUrl: function generatePreRoll(video) {
              return new _video_module_ads2.default(video.title, 'videohomepage').adTag;
            },
            isAutoPlay: false,
            playInView: false,
            playInViewPercentage: 10,
            className: 'jwplayer--video-post'
          })
        ),
        _react2.default.createElement(
          'section',
          null,
          (0, _get2.default)(this.props, 'jwPlaylistIndex.data.playlists', []).map(this.renderVideoPlaylist)
        )
      );
    }
  }]);

  return VideoIndexPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    videoIndexPage: state.videoIndexPage,
    jwPlaylistIndex: state.jwPlaylistIndex
  };
}

VideoIndexPage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number,
  videoIndexPage: _propTypes2.default.shape({}),
  jwPlaylistIndex: _propTypes2.default.shape({})
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(VideoIndexPage));

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_video_index_page_actions = __webpack_require__(860);

var _async_video_index_page_actions2 = _interopRequireDefault(_async_video_index_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_video_index_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_video_index_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchVideoPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _video_index_page_action_creators = __webpack_require__(861);

var videoIndexPageActions = _interopRequireWildcard(_video_index_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_jw_playlist_index_actions = __webpack_require__(275);

var _async_jw_playlist_index_actions2 = _interopRequireDefault(_async_jw_playlist_index_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_recirc_feed_actions = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchVideoPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    if ((0, _get2.default)(state, 'config.site') === 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(videoIndexPageActions.videoIndexPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_jw_playlist_index_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(videoIndexPageActions.videoIndexPageLoaded({}, store));
      (0, _async_recirc_feed_actions.hideRecircAction)(dispatch)();
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(videoIndexPageActions.videoIndexPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoIndexPageLoading = videoIndexPageLoading;
exports.videoIndexPageLoaded = videoIndexPageLoaded;
exports.videoIndexPageLoadError = videoIndexPageLoadError;
// import { canUseDOM } from 'exenv';

function videoIndexPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'VIDEO_INDEX_PAGE_LOADING',
    videoIndexPage: resp,
    store: store
  };
}

function videoIndexPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'VIDEO_INDEX_PAGE_LOADED',
    videoIndexPage: resp,
    store: store
  };
}

function videoIndexPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'VIDEO_INDEX_PAGE_ERROR',
    videoIndexPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/videos/playlist/:playlistTitle/:playlistId',
    component: _playlist_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _playlist_page_state_manager2.default)(store)
  };
};

var _playlist_page = __webpack_require__(863);

var _playlist_page2 = _interopRequireDefault(_playlist_page);

var _playlist_page_state_manager = __webpack_require__(864);

var _playlist_page_state_manager2 = _interopRequireDefault(_playlist_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactRouter = __webpack_require__(22);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _card = __webpack_require__(33);

var _card2 = _interopRequireDefault(_card);

var _slug = __webpack_require__(21);

var _slug2 = _interopRequireDefault(_slug);

var _fc_link = __webpack_require__(24);

var _fc_link2 = _interopRequireDefault(_fc_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */

// This lib is under 1kb gzipped - maybe we move to api later on


// eslint-disable-next-line
var PlaylistPage = function (_Component) {
  _inherits(PlaylistPage, _Component);

  function PlaylistPage() {
    _classCallCheck(this, PlaylistPage);

    var _this = _possibleConstructorReturn(this, (PlaylistPage.__proto__ || Object.getPrototypeOf(PlaylistPage)).call(this));

    _this.renderVideoCard = _this.renderVideoCard.bind(_this);
    return _this;
  }

  _createClass(PlaylistPage, [{
    key: 'renderVideoCard',
    value: function renderVideoCard(videoData, config) {
      return _react2.default.createElement(_card2.default, {
        config: config,
        key: videoData.mediaid,
        type: 'all-feed',
        metadata: {
          link: '/video/' + videoData.slug + '/' + videoData.mediaid,
          title: videoData.title,
          excerpt: videoData.description,
          layout: 'long',
          featured_image: {
            source: videoData.image
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.status === 404 || this.props.status === 500) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.playlistPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'playlist-page' },
          _react2.default.createElement(
            'article',
            { className: 'playlist-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var config = (0, _get2.default)(this.props, 'config', {});
      var playlistTitle = (0, _get2.default)(this.props, 'match.params.playlistTitle', '');
      var playlistId = (0, _get2.default)(this.props, 'match.params.playlistId', 0);
      var page = (0, _get2.default)(this.props, 'match.params.page', false);
      var lastPage = (0, _get2.default)(this.props, 'jwPlaylist.data.lastPage');
      var nextPage = Number(page) + 1 === 1 ? 2 : Number(page) + 1;
      var previousPage = Number(page) - 1;
      var shouldShowNext = Number(page) < lastPage;
      var shouldShowPrevious = page && Number(page) - 1 !== 0;
      var nextLink = '/videos/playlist/' + playlistTitle + '/' + playlistId + '/' + nextPage;
      var previousLink = Number(page) - 1 === 1 ? '/videos/playlist/' + playlistTitle + '/' + playlistId : '/videos/playlist/' + playlistTitle + '/' + playlistId + '/' + previousPage;
      return _react2.default.createElement(
        'section',
        { className: 'tag-page' },
        _react2.default.createElement(
          'section',
          { className: 'page-title' },
          _react2.default.createElement(_slug2.default, {
            slugName: (0, _get2.default)(this.props, 'jwPlaylist.data.title') + ' ' + (page ? 'Page ' + page : ''),
            className: 'category-page'
          }),
          shouldShowPrevious && _react2.default.createElement(
            _fc_link2.default,
            { config: config, title: 'TODO: title', to: previousLink },
            'PREVIOUS PAGE'
          ),
          shouldShowNext && _react2.default.createElement(
            _fc_link2.default,
            { config: config, title: 'TODO: title', to: nextLink },
            'NEXT PAGE'
          ),
          _react2.default.createElement(
            'p',
            null,
            '' + (0, _get2.default)(this.props, 'jwPlaylist.data.description')
          ),
          (0, _get2.default)(this.props, 'jwPlaylist.data.playlist', []).map(function (videoData) {
            return _this2.renderVideoCard(videoData, config);
          })
        )
      );
    }
  }]);

  return PlaylistPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    playlistPage: state.playlistPage,
    jwPlaylist: state.jwPlaylist
  };
}

PlaylistPage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  status: _propTypes2.default.number,
  playlistPage: _propTypes2.default.shape({}),
  jwPlaylist: _propTypes2.default.shape({})
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(PlaylistPage));

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_playlist_page_actions = __webpack_require__(865);

var _async_playlist_page_actions2 = _interopRequireDefault(_async_playlist_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_playlist_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_playlist_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPlaylistPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _playlist_page_action_creators = __webpack_require__(866);

var playlistPageActions = _interopRequireWildcard(_playlist_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_jw_playlist_actions = __webpack_require__(867);

var _async_jw_playlist_actions2 = _interopRequireDefault(_async_jw_playlist_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPlaylistPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(playlistPageActions.playlistPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_jw_playlist_actions2.default)(params, store)(dispatch),
    // tagAllFeedActions(params, store, true)(dispatch),
    (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(playlistPageActions.playlistPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(playlistPageActions.playlistPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

// import tagAllFeedActions from './async_tag_all_feed_actions';

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playlistPageLoading = playlistPageLoading;
exports.playlistPageLoaded = playlistPageLoaded;
exports.playlistPageLoadError = playlistPageLoadError;
// import { canUseDOM } from 'exenv';

function playlistPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PLAYLIST_PAGE_LOADING',
    playlistPage: resp,
    store: store
  };
}

function playlistPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PLAYLIST_PAGE_LOADED',
    playlistPage: resp,
    store: store
  };
}

function playlistPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'PLAYLIST_PAGE_ERROR',
    playlistPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchJwPlaylistDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _jw_playlist_action_creators = __webpack_require__(868);

var jwPlaylistActions = _interopRequireWildcard(_jw_playlist_action_creators);

var _jw_playlist_model = __webpack_require__(274);

var _jw_playlist_model2 = _interopRequireDefault(_jw_playlist_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchJwPlaylistDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(jwPlaylistActions.jwPlaylistLoading({}, store));
    return _jw_playlist_model2.default.fetch(params, store).then(function handleJwPlaylistDetailData(JwPlaylistData) {
      dispatch(jwPlaylistActions.jwPlaylistLoaded(JwPlaylistData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(jwPlaylistActions.jwPlaylistLoadError(err, store));

      _logger_service2.default.error(err, 'Error in jwPlaylist actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jwPlaylistLoading = jwPlaylistLoading;
exports.jwPlaylistLoaded = jwPlaylistLoaded;
exports.jwPlaylistLoadError = jwPlaylistLoadError;
// import { canUseDOM } from 'exenv';

function jwPlaylistLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_PLAYLIST_LOADING',
    jwPlaylist: resp,
    store: store
  };
}

function jwPlaylistLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_PLAYLIST_LOADED',
    jwPlaylist: resp,
    store: store
  };
}

function jwPlaylistLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'JW_PLAYLIST_ERROR',
    jwPlaylist: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/newsletters',
    component: _newsletters_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _newsletters_page_state_manager2.default)(store)
  };
};

var _newsletters_page = __webpack_require__(870);

var _newsletters_page2 = _interopRequireDefault(_newsletters_page);

var _newsletters_page_state_manager = __webpack_require__(887);

var _newsletters_page_state_manager2 = _interopRequireDefault(_newsletters_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _newsletters_page_form_with_state = __webpack_require__(871);

var _newsletters_page_form_with_state2 = _interopRequireDefault(_newsletters_page_form_with_state);

var _newsletters_page_data = __webpack_require__(886);

var _newsletters_page_data2 = _interopRequireDefault(_newsletters_page_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var scriptjs = false;

var NewsletterPage = function (_Component) {
  _inherits(NewsletterPage, _Component);

  function NewsletterPage() {
    _classCallCheck(this, NewsletterPage);

    return _possibleConstructorReturn(this, (NewsletterPage.__proto__ || Object.getPrototypeOf(NewsletterPage)).apply(this, arguments));
  }

  _createClass(NewsletterPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line global-require
      scriptjs = __webpack_require__(58);
      scriptjs('https://www.google.com/recaptcha/api.js');
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.staticPage.error) {
        return _react2.default.createElement(
          'section',
          { className: 'wp-page' },
          _react2.default.createElement(
            'article',
            { className: 'wp-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.staticPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var config = this.props.config;

      var newslettersConfig = (0, _get2.default)(config, 'newsletters');
      var listsDictionary = (0, _get2.default)(newslettersConfig, 'listsById');
      var allIds = (0, _get2.default)(newslettersConfig, 'allIds');

      return _react2.default.createElement(
        'section',
        { className: 'container' },
        _react2.default.createElement(_newsletters_page_form_with_state2.default, {
          config: config,
          newsletterIds: allIds,
          listsDictionary: listsDictionary,
          sections: _newsletters_page_data2.default,
          hed: 'Never miss a story.',
          dek: 'Get the latest stories and updates sent your inbox.'
        })
      );
    }
  }]);

  return NewsletterPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    staticPage: state.staticPage || {},
    config: state.config
  };
}

NewsletterPage.propTypes = {
  config: _propTypes2.default.shape({
    newsletters: _propTypes2.default.shape({}).isRequired
  }).isRequired,
  staticPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NewsletterPage);

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _newsletter_subscriber = __webpack_require__(220);

var _newsletter_subscriber2 = _interopRequireDefault(_newsletter_subscriber);

var _newsletters_form = __webpack_require__(276);

var _newsletters_form2 = _interopRequireDefault(_newsletters_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewslettersPageForm = function (_NewsletterSubscriber) {
  _inherits(NewslettersPageForm, _NewsletterSubscriber);

  function NewslettersPageForm() {
    _classCallCheck(this, NewslettersPageForm);

    return _possibleConstructorReturn(this, (NewslettersPageForm.__proto__ || Object.getPrototypeOf(NewslettersPageForm)).apply(this, arguments));
  }

  _createClass(NewslettersPageForm, [{
    key: 'render',
    value: function render() {
      var formParams = {
        handleEmailUpdate: this.handleEmailUpdate,
        emailValue: this.state.email,
        handleSignupSubmit: this.handleSubmit,
        disabled: this.state.disabled,
        placeholder: (0, _get2.default)(this.statusMessages, [this.state.status]) || 'YOUR EMAIL ADDRESS',
        listsDictionary: this.props.listsDictionary,
        sections: this.props.sections,
        state: this.state.newsletters,
        filter: false,
        transition: false,
        handleNewslettersUpdate: this.handleUpdate,
        hed: this.props.hed,
        dek: this.props.dek,
        handleVerify: this.handleVerify,
        reCaptchaPublic: this.props.config.reCaptcha
      };
      return _react2.default.createElement(_newsletters_form2.default, formParams);
    }
  }]);

  return NewslettersPageForm;
}(_newsletter_subscriber2.default);

NewslettersPageForm.propTypes = {
  listsDictionary: _propTypes2.default.shape({}).isRequired,
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired
};

exports.default = NewslettersPageForm;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(2)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ReactRecaptcha=t(require("react")):e.ReactRecaptcha=t(e.React)}(this,function(e){return function(e){function t(r){if(a[r])return a[r].exports;var n=a[r]={exports:{},id:r,loaded:!1};return e[r].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var a={};return t.m=e,t.c=a,t.p="",t(0)}([function(e,t,a){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var a=0;a<t.length;a++){var r=t[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,a,r){return a&&e(t.prototype,a),r&&e(t,r),t}}(),l=a(6),c=r(l),p=a(4),u=r(p),d={className:u.default.string,onloadCallbackName:u.default.string,elementID:u.default.string,onloadCallback:u.default.func,verifyCallback:u.default.func,expiredCallback:u.default.func,render:u.default.string,sitekey:u.default.string,theme:u.default.string,type:u.default.string,verifyCallbackName:u.default.string,expiredCallbackName:u.default.string,size:u.default.string,tabindex:u.default.string,hl:u.default.string,badge:u.default.string},f={elementID:"g-recaptcha",onloadCallback:void 0,onloadCallbackName:"onloadCallback",verifyCallback:void 0,verifyCallbackName:"verifyCallback",expiredCallback:void 0,expiredCallbackName:"expiredCallback",render:"onload",theme:"light",type:"image",size:"normal",tabindex:"0",hl:"en",badge:"bottomright"},h=function(){return"undefined"!=typeof window&&"undefined"!=typeof window.grecaptcha},b=void 0,y=function(e){function t(e){n(this,t);var a=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return a._renderGrecaptcha=a._renderGrecaptcha.bind(a),a.reset=a.reset.bind(a),a.state={ready:h(),widget:null},a.state.ready||(b=setInterval(a._updateReadyState.bind(a),1e3)),a}return i(t,e),s(t,[{key:"componentDidMount",value:function(){this.state.ready&&this._renderGrecaptcha()}},{key:"componentDidUpdate",value:function(e,t){var a=this.props,r=a.render,n=a.onloadCallback;"explicit"===r&&n&&this.state.ready&&!t.ready&&this._renderGrecaptcha()}},{key:"componentWillUnmount",value:function(){clearInterval(b)}},{key:"reset",value:function(){var e=this.state,t=e.ready,a=e.widget;t&&null!==a&&grecaptcha.reset(a)}},{key:"_updateReadyState",value:function(){h()&&(this.setState({ready:!0}),clearInterval(b))}},{key:"_renderGrecaptcha",value:function(){this.state.widget=grecaptcha.render(this.props.elementID,{sitekey:this.props.sitekey,callback:this.props.verifyCallback?this.props.verifyCallback:void 0,theme:this.props.theme,type:this.props.type,size:this.props.size,tabindex:this.props.tabindex,hl:this.props.hl,badge:this.props.badge,"expired-callback":this.props.expiredCallback?this.props.expiredCallback:void 0}),this.props.onloadCallback&&this.props.onloadCallback()}},{key:"render",value:function(){return"explicit"===this.props.render&&this.props.onloadCallback?c.default.createElement("div",{id:this.props.elementID,"data-onloadcallbackname":this.props.onloadCallbackName,"data-verifycallbackname":this.props.verifyCallbackName}):c.default.createElement("div",{id:this.props.elementID,className:"g-recaptcha","data-sitekey":this.props.sitekey,"data-theme":this.props.theme,"data-type":this.props.type,"data-size":this.props.size,"data-badge":this.props.badge,"data-tabindex":this.props.tabindex})}}]),t}(l.Component);t.default=y,y.propTypes=d,y.defaultProps=f,e.exports=t.default},function(e,t){"use strict";function a(e){return function(){return e}}var r=function(){};r.thatReturns=a,r.thatReturnsFalse=a(!1),r.thatReturnsTrue=a(!0),r.thatReturnsNull=a(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,a){"use strict";function r(e,t,a,r,o,i,s,l){if(n(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var p=[a,r,o,i,s,l],u=0;c=new Error(t.replace(/%s/g,function(){return p[u++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var n=function(e){};e.exports=r},function(e,t,a){"use strict";var r=a(1),n=a(2),o=a(5);e.exports=function(){function e(e,t,a,r,i,s){s!==o&&n(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return a.checkPropTypes=r,a.PropTypes=a,a}},function(e,t,a){e.exports=a(3)()},function(e,t){"use strict";var a="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=a},function(t,a){t.exports=e}])});

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(874);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransition = __webpack_require__(876);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(43);

var _set2 = _interopRequireDefault(_set);

var _newsletter = __webpack_require__(881);

var _newsletter2 = _interopRequireDefault(_newsletter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function find(listId, subscribedToIds, condition) {
  var isFound = void 0;
  if (Array.isArray(listId)) {
    isFound = listId.reduce(function (acc, curr) {
      return find(curr, subscribedToIds, condition) || find(acc, subscribedToIds, condition);
    });

    return isFound;
  }
  if (condition) {
    isFound = subscribedToIds.indexOf(listId) !== -1;
  } else {
    isFound = subscribedToIds.indexOf(listId) === -1;
  }

  return isFound;
}

function NewsletterListSection(props) {
  var subscribedToIds = props.subscribedToIds,
      sectionIds = props.sectionIds,
      masterLookup = props.masterLookup,
      state = props.state,
      handleChange = props.handleChange,
      handleNewslettersRadioUpdate = props.handleNewslettersRadioUpdate,
      alreadyUsed = props.alreadyUsed,
      sectionTitle = props.sectionTitle,
      filter = props.filter,
      transition = props.transition;


  var newsletters = sectionIds.map(function (listId, idx) {
    if (filter) {
      if (alreadyUsed.hasOwnProperty(listId)) {
        return null;
      }
      var isFound = find(listId, subscribedToIds, sectionTitle === 'Your Current Subscriptions');

      if (!isFound) {
        return null;
      }
    }
    var foundNewsletter = masterLookup[listId];
    (0, _set2.default)(alreadyUsed, listId, ''); // eslint-disable-line  no-param-reassign
    var name = (0, _get2.default)(foundNewsletter, 'listName');
    var desc = (0, _get2.default)(foundNewsletter, 'message');
    var choices = (0, _get2.default)(foundNewsletter, 'choices');
    var isRadio = (0, _get2.default)(foundNewsletter, 'radio', false);
    var lists = Array.isArray(listId) ? listId : [listId];
    var checked = Array.isArray(listId) ? listId.map(function (id) {
      return state[id];
    }) : [state[listId]];

    if (typeof listId === 'string' && listId.split(',').length) {
      lists = listId.split(',');
      checked = listId.split(',').map(function (id) {
        return state[id];
      });
    }
    var newsletter = _react2.default.createElement(_newsletter2.default, {
      name: name,
      desc: desc,
      lists: lists,
      checked: checked,
      choices: choices,
      onChange: handleChange,
      key: '' + listId + idx,
      isRadio: isRadio,
      handleNewslettersRadioUpdate: handleNewslettersRadioUpdate
    });
    return transition ? _react2.default.createElement(
      _CSSTransition2.default,
      { classNames: 'fade', key: '' + listId + idx, timeout: 500 },
      newsletter
    ) : newsletter;
  });
  return _react2.default.createElement(
    'div',
    { key: sectionTitle, className: 'newsletter-list-section' },
    _react2.default.createElement(
      'h3',
      { className: 'newsletter-list-section__label' },
      sectionTitle
    ),
    transition ? _react2.default.createElement(
      _TransitionGroup2.default,
      { className: 'newsletter-list-section__input-group' },
      newsletters
    ) : _react2.default.createElement(
      'div',
      { className: 'newsletter-list-section__input-group' },
      newsletters
    )
  );
}

NewsletterListSection.defaultProps = {
  alreadyUsed: {},
  subscribedToIds: [],
  filter: true,
  transition: true,
  handleNewslettersRadioUpdate: function handleNewslettersRadioUpdate() {}
};

NewsletterListSection.propTypes = {
  subscribedToIds: _propTypes2.default.arrayOf(_propTypes2.default.number),
  sectionIds: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])).isRequired,
  masterLookup: _propTypes2.default.shape({}).isRequired,
  state: _propTypes2.default.shape({}).isRequired,
  alreadyUsed: _propTypes2.default.shape({}),
  sectionTitle: _propTypes2.default.string.isRequired,
  handleChange: _propTypes2.default.func.isRequired,
  transition: _propTypes2.default.bool,
  filter: _propTypes2.default.bool,
  handleNewslettersRadioUpdate: _propTypes2.default.func
};

exports.default = NewsletterListSection;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(875);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


;(true);
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(2);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(877);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(879);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(880);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(277);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters or exits.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  exit?: string,
   *  exitActive?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ```js
 * import CSSTransition from 'react-transition-group/CSSTransition';
 *
 * const Fade = ({ children, ...props }) => (
 *  <CSSTransition
 *    {...props}
 *    timeout={500}
 *    classNames="fade"
 *  >
 *   {children}
 *  </CSSTransition>
 * );
 *
 * class FadeInAndOut extends React.Component {
 *   constructor(...args) {
 *     super(...args);
 *     this.state= { show: false }
 *
 *     setInterval(() => {
 *       this.setState({ show: !this.state.show })
 *     }, 5000)
 *   }
 *   render() {
 *     return (
 *       <Fade in={this.state.show}>
 *         <div>Hello world</div>
 *       </Fade>
 *     )
 *   }
 * }
 * ```
 *
 * And the coorresponding CSS for the `<Fade>` component:
 *
 * ```css
 * .fade-enter {
 *   opacity: 0.01;
 * }
 *
 * .fade-enter.fade-enter-active {
 *   opacity: 1;
 *   transition: opacity 500ms ease-in;
 * }
 *
 * .fade-exit {
 *   opacity: 1;
 * }
 *
 * .fade-exit.fade-exit-active {
 *   opacity: 0.01;
 *   transition: opacity 300ms ease-in;
 * }
 * ```
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      return { className: className, activeClassName: activeClassName };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(878);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(3);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(57);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(277);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkbox = __webpack_require__(882);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _radio_group = __webpack_require__(883);

var _radio_group2 = _interopRequireDefault(_radio_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Newsletter(props) {
  return _react2.default.createElement(
    'div',
    { className: 'newsletter' },
    _react2.default.createElement(
      'h4',
      { className: 'newsletter__name' },
      props.name
    ),
    _react2.default.createElement(
      'p',
      { className: 'newsletter__desc' },
      props.desc
    ),
    props.isRadio ? _react2.default.createElement(_radio_group2.default, {
      listIds: props.lists,
      onChange: props.handleNewslettersRadioUpdate,
      choices: props.choices,
      checked: props.checked
    }) : props.lists.map(function generateListsOptions(listId, index) {
      return _react2.default.createElement(_checkbox2.default, {
        listId: listId,
        onChange: props.onChange,
        checked: props.checked[index],
        choice: props.choices[index],
        key: listId
      });
    })
  );
}

Newsletter.defaultProps = {
  choices: [],
  isRadio: false,
  handleNewslettersRadioUpdate: function handleNewslettersRadioUpdate() {}
};

Newsletter.propTypes = {
  name: _propTypes2.default.string.isRequired,
  desc: _propTypes2.default.string.isRequired,
  lists: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
  choices: _propTypes2.default.arrayOf(_propTypes2.default.string),
  checked: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  handleNewslettersRadioUpdate: _propTypes2.default.func,
  isRadio: _propTypes2.default.bool
};

exports.default = Newsletter;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Checkbox(props) {
  return _react2.default.createElement(
    'label',
    { key: props.listId, htmlFor: props.listId },
    _react2.default.createElement('input', {
      type: 'checkbox',
      name: props.listId,
      id: props.listId,
      checked: props.checked,
      onChange: props.onChange,
      className: 'newsletter__checkbox'
    }),
    _react2.default.createElement(
      'span',
      { className: 'newsletter__option' },
      props.choice
    )
  );
}

Checkbox.propTypes = {
  listId: _propTypes2.default.number.isRequired,
  checked: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  choice: _propTypes2.default.string.isRequired
};

exports.default = Checkbox;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RadioGroup(props) {
  return props.listIds.map(function generateRadioButtons(listId, index) {
    return _react2.default.createElement(
      'label',
      { key: listId, htmlFor: listId },
      _react2.default.createElement('input', {
        type: 'radio',
        name: props.listIds.toString(),
        value: listId,
        id: listId,
        checked: props.checked[index],
        onChange: props.onChange
      }),
      _react2.default.createElement(
        'span',
        { className: 'newsletter__option' },
        props.choices[index]
      )
    );
  });
}

RadioGroup.propTypes = {
  listIds: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
  checked: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  choices: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

exports.default = RadioGroup;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _message = __webpack_require__(278);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SignupWidget(props) {
  return _react2.default.createElement(
    'div',
    { className: 'signup-widget' },
    _react2.default.createElement('input', {
      type: 'email',
      id: 'email',
      className: 'signup-widget__email ' + (props.emailEditable ? 'signup-widget__email--editable' : ''),
      value: props.value,
      placeholder: props.placeholder,
      onChange: props.handleChange,
      disabled: !props.emailEditable || props.disabled,
      ref: props.setFocus
    }),
    _react2.default.createElement(
      'label',
      { className: 'visually-hidden', htmlFor: 'email' },
      'Email'
    ),
    _react2.default.createElement(
      'button',
      {
        className: 'signup-widget__button ' + (props.emailFormError ? 'signup-widget__button--disabled' : '') + ' ' + (props.emailEditable ? 'signup-widget__button--left-space' : 'signup-widget__button--no-border'),
        onClick: props.emailEditable ? props.handleSubmit : props.toggleInputOn,
        disabled: props.emailFormError || props.disabled,
        type: 'button'
      },
      props.buttonText
    ),
    _react2.default.createElement(
      'div',
      { className: 'signup-widget__message-container' },
      _react2.default.createElement(_message2.default, { type: 'error', message: props.emailUpdateMessageError }),
      _react2.default.createElement(_message2.default, { type: 'success', message: props.emailUpdateSuccessMessage }),
      _react2.default.createElement(_message2.default, { type: 'error', message: props.emailFormError })
    )
  );
}

SignupWidget.defaultProps = {
  buttonText: 'Send',
  emailFormError: '',
  setFocus: function setFocus() {},
  emailUpdateMessageError: '',
  emailUpdateSuccessMessage: '',
  emailEditable: true,
  placeholder: 'You Email Address',
  toggleInputOn: function toggleInputOn() {},
  disabled: false
};

SignupWidget.propTypes = {
  emailUpdateMessageError: _propTypes2.default.string,
  emailUpdateSuccessMessage: _propTypes2.default.string,
  emailEditable: _propTypes2.default.bool,
  buttonText: _propTypes2.default.string,
  value: _propTypes2.default.string.isRequired,
  placeholder: _propTypes2.default.string,
  handleChange: _propTypes2.default.func.isRequired,
  handleSubmit: _propTypes2.default.func.isRequired,
  setFocus: _propTypes2.default.func,
  toggleInputOn: _propTypes2.default.func,
  emailFormError: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  disabled: _propTypes2.default.bool
};

exports.default = SignupWidget;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(64);

var _throttle2 = _interopRequireDefault(_throttle);

var _message = __webpack_require__(278);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StickySubmit = function (_Component) {
  _inherits(StickySubmit, _Component);

  function StickySubmit() {
    _classCallCheck(this, StickySubmit);

    var _this = _possibleConstructorReturn(this, (StickySubmit.__proto__ || Object.getPrototypeOf(StickySubmit)).call(this));

    _this.state = {
      fixFooter: false
    };
    return _this;
  }

  _createClass(StickySubmit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleScroll = (0, _throttle2.default)(this.handleScroll.bind(this), 100);
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (window.innerHeight + window.scrollY < document.body.offsetHeight - 200 && this.state.fixFooter) {
        this.setState({ fixFooter: false });
      }

      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
        this.setState({ fixFooter: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'sticky-submit ' + (this.state.fixFooter ? 'sticky-submit--static' : '')
        },
        _react2.default.createElement(
          'div',
          { className: 'sticky-submit__button-container' },
          _react2.default.createElement(
            'button',
            {
              className: 'sticky-submit__button',
              type: 'submit',
              onClick: this.props.handleSubmit
            },
            'Update Preferences'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'sticky-submit__message-container' },
          _react2.default.createElement(_message2.default, { type: 'success', message: this.props.message })
        )
      );
    }
  }]);

  return StickySubmit;
}(_react.Component);

StickySubmit.defaultProps = {
  message: ''
};

StickySubmit.propTypes = {
  message: _propTypes2.default.string,
  handleSubmit: _propTypes2.default.func.isRequired
};

exports.default = StickySubmit;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  sectionTitle: 'Sites',
  ids: [[2, 5], [6, 11]]
}, {
  sectionTitle: 'Daily',
  ids: [4, 15]
}, {
  sectionTitle: 'Weekly',
  ids: [8, 7, 9, 48, 10, 70, 19, 24, 40, 22, 12, 18, 21, 17, 16]
}, {
  sectionTitle: 'Promotions',
  ids: [25, 31]
}];

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = staticData;

var _exenv = __webpack_require__(4);

var _async_newsletters_page_actions = __webpack_require__(888);

var _async_newsletters_page_actions2 = _interopRequireDefault(_async_newsletters_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function staticData(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;
    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_newsletters_page_actions2.default)(nextState, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_newsletters_page_actions2.default)(nextState, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleServerSideRenderError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prepareNewslettersPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _static_page_action_creators = __webpack_require__(889);

var staticPageActions = _interopRequireWildcard(_static_page_action_creators);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_recirc_feed_actions = __webpack_require__(17);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prepareNewslettersPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(staticPageActions.staticPageLoading({}, store));
    return _bluebird2.default.resolve().then(function dispatchNewsletterPageActions() {
      dispatch(staticPageActions.staticPageLoaded({}, store));
      (0, _async_recirc_feed_actions.hideRecircAction)(dispatch)();
      return true;
    }).catch(function handleNewsletterPageError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(staticPageActions.staticPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in wp page actions, message: ' + err.message);
    });
  };
}
// import asyncRecircFeedActions from '../async_recirc_feed_actions';

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticPageLoading = staticPageLoading;
exports.staticPageLoaded = staticPageLoaded;
exports.staticPageLoadError = staticPageLoadError;
// import { canUseDOM } from 'exenv';

function staticPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'STATIC_PAGE_LOADING',
    staticPage: resp,
    store: store
  };
}

function staticPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'STATIC_PAGE_LOADED',
    staticPage: resp,
    store: store
  };
}

function staticPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'STATIC_PAGE_ERROR',
    staticPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/newsletters-preferences',
    component: _newsletters_preferences_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _newsletters_preferences_page_state_manager2.default)(store)
  };
};

var _newsletters_preferences_page = __webpack_require__(891);

var _newsletters_preferences_page2 = _interopRequireDefault(_newsletters_preferences_page);

var _newsletters_preferences_page_state_manager = __webpack_require__(894);

var _newsletters_preferences_page_state_manager2 = _interopRequireDefault(_newsletters_preferences_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _redux = __webpack_require__(92);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _newsletters_form = __webpack_require__(276);

var _newsletters_form2 = _interopRequireDefault(_newsletters_form);

var _async_newsletters_preferences_page_actions = __webpack_require__(279);

var _newsletters_preferences_page_action_creators = __webpack_require__(280);

var _newsletters_preferences_page_data = __webpack_require__(893);

var _newsletters_preferences_page_data2 = _interopRequireDefault(_newsletters_preferences_page_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewslettersPreferencesPage = function (_Component) {
  _inherits(NewslettersPreferencesPage, _Component);

  function NewslettersPreferencesPage() {
    _classCallCheck(this, NewslettersPreferencesPage);

    var _this = _possibleConstructorReturn(this, (NewslettersPreferencesPage.__proto__ || Object.getPrototypeOf(NewslettersPreferencesPage)).call(this));

    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
    _this.handleNewslettersRadioUpdate = _this.handleNewslettersRadioUpdate.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleChangeEmailClick = _this.handleChangeEmailClick.bind(_this);
    _this.handleEmailInputChange = _this.handleEmailInputChange.bind(_this);
    _this.handleChangeEmailSubmit = _this.handleChangeEmailSubmit.bind(_this);
    _this.handleUnsubscribeAll = _this.handleUnsubscribeAll.bind(_this);
    _this.setFocus = _this.setFocus.bind(_this);
    _this.state = {
      emailFormError: ''
    };
    return _this;
  }

  _createClass(NewslettersPreferencesPage, [{
    key: 'setFocus',
    value: function setFocus(ref) {
      this.emailInput = ref;
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(e) {
      var target = e.target;

      var id = Number(target.name);
      this.props.actions.newsletterPreferencesChange({
        id: id
      });
    }
  }, {
    key: 'handleNewslettersRadioUpdate',
    value: function handleNewslettersRadioUpdate(e) {
      var target = e.target;

      var selectedListId = Number(target.value);
      var radioSet = target.name.split(',').map(function (str) {
        return Number(str);
      });
      this.props.actions.newsletterPreferencesChangeRadio({
        selectedListId: selectedListId,
        radioSet: radioSet
      });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var newsletterPrefPageData = (0, _get2.default)(this.props, 'newslettersPreferencesPage');
      var userData = (0, _get2.default)(newsletterPrefPageData, 'data');
      var userId = (0, _get2.default)(userData, 'userId');
      var email = (0, _get2.default)(userData, 'email');
      var subscribe = (0, _get2.default)(newsletterPrefPageData, 'subscribe');
      var unsubscribe = (0, _get2.default)(newsletterPrefPageData, 'unsubscribe');
      var currUrl = (0, _get2.default)(this.props, 'config.navHistory[0]');

      if (subscribe.length === 0 && unsubscribe.length === 0) {
        return null;
      }

      var params = {
        userId: userId,
        email: email,
        lists: subscribe,
        unsubscribe: unsubscribe,
        sourceDescription: currUrl
      };

      this.props.actions.updatePostUpUserAction(params, this.props.config);
      return true;
    }
  }, {
    key: 'handleUnsubscribeAll',
    value: function handleUnsubscribeAll(e) {
      e.preventDefault();
      var newsletterPrefPageData = (0, _get2.default)(this.props, 'newslettersPreferencesPage');
      var userData = (0, _get2.default)(newsletterPrefPageData, 'data');
      var userId = (0, _get2.default)(userData, 'userId');
      var email = (0, _get2.default)(userData, 'email');
      var lists = (0, _get2.default)(userData, 'lists', []);
      var params = {
        userId: userId,
        email: email,
        unsubscribe: lists
      };
      this.props.actions.updatePostUpUserAction(params, this.props.config);
      return true;
    }
  }, {
    key: 'handleChangeEmailClick',
    value: function handleChangeEmailClick() {
      this.props.actions.prepareEmailFieldForChange();
      this.setState({
        email: ''
      }, function setStateCallback() {
        this.emailInput.focus();
      });
    }
  }, {
    key: 'detectCorrectEmail',
    value: function detectCorrectEmail(email) {
      return typeof email === 'string' ? /[^\s@]+@[^\s@]+\.[^\s@]+/.test(email) : null;
    }
  }, {
    key: 'handleEmailInputChange',
    value: function handleEmailInputChange(e) {
      var _this2 = this;

      this.setState({
        email: e.target.value
      }, function () {
        var isValidEmail = _this2.detectCorrectEmail(_this2.state.email);

        _this2.setState({
          emailFormError: isValidEmail ? false : 'Invalid email address'
        });
      });
    }
  }, {
    key: 'handleChangeEmailSubmit',
    value: function handleChangeEmailSubmit(e) {
      e.preventDefault();
      var newsletterPreferencesPage = (0, _get2.default)(this.props, 'newslettersPreferencesPage.data');
      var newEmail = this.state.email;
      if (newEmail !== newsletterPreferencesPage.email) {
        this.props.actions.updatePostUpEmailAction({
          email: newEmail,
          userId: newsletterPreferencesPage.userId
        }, this.props.config);
      } else {
        this.props.actions.prepareEmailFieldForChange();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.newslettersPreferencesPage.error) {
        return _react2.default.createElement(
          'section',
          { className: 'wp-page' },
          _react2.default.createElement(
            'article',
            { className: 'wp-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (this.props.newslettersPreferencesPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'post-page' },
          _react2.default.createElement(
            'article',
            { className: 'post__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }
      var email = (0, _get2.default)(this.props, 'newslettersPreferencesPage.data.email');
      var masterLookup = (0, _get2.default)(this.props, 'newslettersPreferencesPage.masterLookup');
      var subscribedTo = (0, _get2.default)(this.props, 'newslettersPreferencesPage.data.lists', []);

      var currentNewsletterSelectionState = this.props.newslettersPreferencesPage.allNewslettersSelected;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(_newsletters_form2.default, {
          hed: 'Email Preference Center',
          dek: 'Indicate your email preferences below. Once you have made your changes to your information, save your preferences.',
          sections: _newsletters_preferences_page_data2.default,
          listsDictionary: masterLookup,
          filter: true,
          handleEmailUpdate: this.handleEmailInputChange,
          emailValue: typeof this.state.email === 'string' ? this.state.email : email,
          placeholder: email,
          handleNewslettersUpdate: this.handleCheckboxChange,
          handleNewslettersRadioUpdate: this.handleNewslettersRadioUpdate,
          buttonText: 'Change Email',
          state: currentNewsletterSelectionState,
          setFocus: this.setFocus,
          toggleInputOn: this.handleChangeEmailClick,
          emailFormError: this.state.emailFormError,
          emailUpdateSuccessMessage: this.props.newslettersPreferencesPage.emailUpdateSuccessMessage,
          emailUpdateMessageError: this.props.newslettersPreferencesPage.emailUpdateMessageError,
          subscribedToIds: subscribedTo,
          alreadyUsed: {},
          emailEditable: this.props.newslettersPreferencesPage.emailEditable,
          stickySubmit: true,
          handleSignupSubmit: this.handleChangeEmailSubmit,
          handleStickySubmit: this.handleSubmit,
          handleUnsubscribeAll: this.handleUnsubscribeAll,
          stickyMessage: this.props.newslettersPreferencesPage.subscriptionUpdateSuccessMessage
        })
      );
    }
  }]);

  return NewslettersPreferencesPage;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config,
    newslettersPreferencesPage: state.newslettersPreferencesPage || {}
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)({
      newsletterPreferencesChange: _newsletters_preferences_page_action_creators.newsletterPreferencesChange,
      updatePostUpEmailAction: _async_newsletters_preferences_page_actions.updatePostUpEmailAction,
      newsletterPreferencesChangeRadio: _newsletters_preferences_page_action_creators.newsletterPreferencesChangeRadio,
      updatePostUpUserAction: _async_newsletters_preferences_page_actions.updatePostUpUserAction,
      prepareEmailFieldForChange: _newsletters_preferences_page_action_creators.prepareEmailFieldForChange
    }, dispatch)
  };
}

NewslettersPreferencesPage.propTypes = {
  config: _propTypes2.default.shape({}).isRequired,
  actions: _propTypes2.default.shape({
    newsletterPreferencesChange: _propTypes2.default.func,
    updatePostUpUserAction: _propTypes2.default.func,
    prepareEmailFieldForChange: _propTypes2.default.func,
    updatePostUpEmailAction: _propTypes2.default.func,
    newsletterPreferencesChangeRadio: _propTypes2.default.func
  }).isRequired,
  newslettersPreferencesPage: _propTypes2.default.shape({
    isLoading: _propTypes2.default.bool,
    allNewslettersSelected: _propTypes2.default.shape({}),
    data: _propTypes2.default.shape({
      lists: _propTypes2.default.arrayOf(_propTypes2.default.number),
      email: _propTypes2.default.string,
      userId: _propTypes2.default.string
    }),
    subscribe: _propTypes2.default.arrayOf(_propTypes2.default.number),
    unsubscribe: _propTypes2.default.arrayOf(_propTypes2.default.number),
    emailEditable: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string,
    emailUpdateMessageError: _propTypes2.default.string,
    emailUpdateSuccessMessage: _propTypes2.default.string,
    subscriptionUpdateSuccessMessage: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewslettersPreferencesPage);

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(53);

var _axios2 = _interopRequireDefault(_axios);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _auth_util = __webpack_require__(15);

var _auth_util2 = _interopRequireDefault(_auth_util);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewsletterPreferences = function () {
  function NewsletterPreferences() {
    _classCallCheck(this, NewsletterPreferences);
  }

  _createClass(NewsletterPreferences, null, [{
    key: 'fetch',
    value: function fetch(args, config) {
      var host = (0, _get2.default)(config, 'apiEndpoint');
      var protocol = (0, _get2.default)(config, 'protocol');
      var options = (0, _extend2.default)({}, args);
      var url = '' + protocol + host + '/api/v2/newsletter-user';

      // api has auth in beta
      if ((0, _get2.default)(config, 'authEnabled')) {
        (0, _extend2.default)(options, (0, _auth_util2.default)(config, 'get'));
      }

      if (!_exenv.canUseDOM) {
        _logger_service2.default.info('Requesting: ' + url + ' from model.');
      }

      return _axios2.default.post(url, options);
    }
  }]);

  return NewsletterPreferences;
}();

exports.default = NewsletterPreferences;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  sectionTitle: 'Your Current Subscriptions',
  ids: [[2, 5], [6, 11], [4, 10], 15, 40, 9, 21, 7, 22, 12, 19, 24, 8, 48, 70, 16, 18, 17, 99, 25, 100, 41, 102]
}, {
  sectionTitle: 'Newsletters To Add',
  ids: [[2, 5], [6, 11], [4, 10], 15, 40, 9, 21, 7, 22, 12, 19, 24, 8, 48, 70, 16]
}, {
  sectionTitle: 'Alerts',
  ids: [18, 17, 99, 25, 100, 41, 102]
}, {
  sectionTitle: 'Permissions',
  ids: [[103, 46], [31, 105]]
}];

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = newslettersPreferencesData;

var _async_newsletters_preferences_page_actions = __webpack_require__(279);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_recirc_feed_actions = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function newslettersPreferencesData(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;


    return (0, _async_newsletters_preferences_page_actions.fetchNewslettersPreferencesPageModelAction)(nextState, store)(dispatch).then(function cb() {
      (0, _async_recirc_feed_actions.hideRecircAction)(dispatch)();
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleServerSideRenderError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  var state = store.getState();

  if (state.config.site === 'fastcompany') {
    return [{
      path: '/technology/:tag',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'technology', IS_TAG)
    }, {
      path: '/technology/:tag/:page',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'technology', IS_TAG)
    }, {
      path: '/leadership/:tag',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'leadership', IS_TAG)
    }, {
      path: '/leadership/:tag/:page',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'leadership', IS_TAG)
    }, {
      path: '/entertainment/:tag',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'entertainment', IS_TAG)
    }, {
      path: '/entertainment/:tag/:page',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'entertainment', IS_TAG)
    }, {
      path: '/ideas/:tag',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'ideas', IS_TAG)
    }, {
      path: '/ideas/:tag/:page',
      component: _category_page2.default,
      exact: true,
      strict: true,
      loadData: (0, _category_page_state_manager2.default)(store, 'ideas', IS_TAG)
    }];
  }
  return [{
    path: '/cities/:tag',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'cities', IS_TAG)
  }, {
    path: '/cities/:tag/:page',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'cities', IS_TAG)
  }, {
    path: '/graphics/:tag',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'graphics', IS_TAG)
  }, {
    path: '/graphics/:tag/:page',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'graphics', IS_TAG)
  }, {
    path: '/interactive/:tag',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'interactive', IS_TAG)
  }, {
    path: '/interactive/:tag/:page',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'interactive', IS_TAG)
  }, {
    path: '/products/:tag',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'products', IS_TAG)
  }, {
    path: '/products/:tag/:page',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'products', IS_TAG)
  }, {
    path: '/spaces/:tag',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'spaces', IS_TAG)
  }, {
    path: '/spaces/:tag/:page',
    component: _category_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _category_page_state_manager2.default)(store, 'spaces', IS_TAG)
  }];
};

var _category_page = __webpack_require__(145);

var _category_page2 = _interopRequireDefault(_category_page);

var _category_page_state_manager = __webpack_require__(67);

var _category_page_state_manager2 = _interopRequireDefault(_category_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_TAG = true;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/gift-guide/:slug',
    component: _gift_guide_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _gift_guide_page_state_manager2.default)(store),
    autoScrollOff: true
  };
};

var _gift_guide_page = __webpack_require__(281);

var _gift_guide_page2 = _interopRequireDefault(_gift_guide_page);

var _gift_guide_page_state_manager = __webpack_require__(282);

var _gift_guide_page_state_manager2 = _interopRequireDefault(_gift_guide_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchPersonPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _gift_guide_page_action_creators = __webpack_require__(898);

var giftGuidePageActions = _interopRequireWildcard(_gift_guide_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _async_gift_guide_actions = __webpack_require__(899);

var _async_gift_guide_actions2 = _interopRequireDefault(_async_gift_guide_actions);

var _async_gift_guide_details_actions = __webpack_require__(902);

var _async_gift_guide_details_actions2 = _interopRequireDefault(_async_gift_guide_details_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    if ((0, _get2.default)(state, 'config.site') !== 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }
    if (!params.category) {
      dispatch(giftGuidePageActions.giftGuidePageLoading({}, store));
    }
    return _bluebird2.default.all([(0, _async_gift_guide_details_actions2.default)(params, store)(dispatch), (0, _async_gift_guide_actions2.default)(params, store)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(giftGuidePageActions.giftGuidePageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      dispatch(giftGuidePageActions.giftGuidePageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftGuidePageLoading = giftGuidePageLoading;
exports.giftGuidePageLoaded = giftGuidePageLoaded;
exports.giftGuidePageLoadError = giftGuidePageLoadError;
// import { canUseDOM } from 'exenv';

function giftGuidePageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_PAGE_LOADING',
    giftGuidePage: resp,
    store: store
  };
}

function giftGuidePageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_PAGE_LOADED',
    giftGuidePage: resp,
    store: store
  };
}

function giftGuidePageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_PAGE_ERROR',
    giftGuidePage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchGiftGuideDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _gift_guide_action_creators = __webpack_require__(900);

var giftGuide = _interopRequireWildcard(_gift_guide_action_creators);

var _gift_guide_model = __webpack_require__(901);

var _gift_guide_model2 = _interopRequireDefault(_gift_guide_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchGiftGuideDetail(params, store) {
  return function firstDispatch(dispatch) {
    var idMapping = {
      'holiday-2017': 1
    };
    var requestParams = {
      id: idMapping[(0, _get2.default)(params, 'slug', 0)]
    };

    if (params.category) {
      requestParams.category = params.category;
    }

    return _gift_guide_model2.default.fetch(requestParams, store).then(function handleGiftGuideDetailData(GiftGuideData) {
      if (requestParams.category) {
        var hasGiftGuideGuideCategory = GiftGuideData.data.rows.filter(function (category) {
          return category.url === requestParams.category;
        }).length;

        if (!hasGiftGuideGuideCategory) {
          dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        }
      }

      dispatch(giftGuide.giftGuideLoaded(GiftGuideData.data, store, requestParams.id));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(giftGuide.giftGuideLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(giftGuide.giftGuideLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in giftGuide actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftGuideLoading = giftGuideLoading;
exports.giftGuideLoaded = giftGuideLoaded;
exports.giftGuideLoadError = giftGuideLoadError;
// import { canUseDOM } from 'exenv';

function giftGuideLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_LOADING',
    giftGuide: resp,
    store: store
  };
}

function giftGuideLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];

  return {
    type: 'GIFT_GUIDE_LOADED',
    giftGuide: resp,
    store: store,
    year: year
  };
}

function giftGuideLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_ERROR',
    giftGuide: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiftGuide = function (_Base) {
  _inherits(GiftGuide, _Base);

  function GiftGuide() {
    _classCallCheck(this, GiftGuide);

    return _possibleConstructorReturn(this, (GiftGuide.__proto__ || Object.getPrototypeOf(GiftGuide)).apply(this, arguments));
  }

  _createClass(GiftGuide, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var id = _ref.id;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/gifts/' + id + '/categories/top/50?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return GiftGuide;
}(_base_model2.default);

exports.default = GiftGuide;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchGiftGuideDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _gift_guide_details_action_creators = __webpack_require__(903);

var giftGuide = _interopRequireWildcard(_gift_guide_details_action_creators);

var _gift_guide_detail_model = __webpack_require__(904);

var _gift_guide_detail_model2 = _interopRequireDefault(_gift_guide_detail_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchGiftGuideDetail(params, store) {
  return function firstDispatch(dispatch) {
    return _gift_guide_detail_model2.default.fetch(params, store).then(function handleGiftGuideDetailData(GiftGuideData) {
      dispatch(giftGuide.giftGuideDetailLoaded(GiftGuideData.data, store, params.year));
    }).catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        _logger_service2.default.warn('User tried a most creative people page with invalid year.');
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
        return dispatch(giftGuide.giftGuideDetailLoadError(err, store));
      }

      var status = (0, _get2.default)(err, 'response.status');

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(giftGuide.giftGuideDetailLoadError(err, store));

      return _logger_service2.default.error(err, 'Error in giftGuideDetail actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftGuideDetailLoading = giftGuideDetailLoading;
exports.giftGuideDetailLoaded = giftGuideDetailLoaded;
exports.giftGuideDetailLoadError = giftGuideDetailLoadError;
// import { canUseDOM } from 'exenv';

function giftGuideDetailLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_DETAIL_LOADING',
    giftGuideDetail: resp,
    store: store
  };
}

function giftGuideDetailLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var year = arguments[2];

  return {
    type: 'GIFT_GUIDE_DETAIL_LOADED',
    giftGuideDetail: resp,
    store: store,
    year: year
  };
}

function giftGuideDetailLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_GUIDE_DETAIL_ERROR',
    giftGuideDetail: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiftGuide = function (_Base) {
  _inherits(GiftGuide, _Base);

  function GiftGuide() {
    _classCallCheck(this, GiftGuide);

    return _possibleConstructorReturn(this, (GiftGuide.__proto__ || Object.getPrototypeOf(GiftGuide)).apply(this, arguments));
  }

  _createClass(GiftGuide, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var slug = _ref.slug;

      var idMapping = {
        'holiday-2017': 1
      };

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/person/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/gifts/' + idMapping[slug] + '/details?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07';
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return GiftGuide;
}(_base_model2.default);

exports.default = GiftGuide;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/gift-guide/:slug/category/:category',
    component: _gift_guide_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _gift_guide_page_state_manager2.default)(store),
    autoScrollOff: true
  };
};

var _gift_guide_page = __webpack_require__(281);

var _gift_guide_page2 = _interopRequireDefault(_gift_guide_page);

var _gift_guide_page_state_manager = __webpack_require__(282);

var _gift_guide_page_state_manager2 = _interopRequireDefault(_gift_guide_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (store) {
  return {
    path: '/gift/:product',
    component: _gift_page2.default,
    exact: true,
    strict: true,
    loadData: (0, _gift_page_state_manager2.default)(store)
  };
};

var _gift_page = __webpack_require__(907);

var _gift_page2 = _interopRequireDefault(_gift_page);

var _gift_page_state_manager = __webpack_require__(908);

var _gift_page_state_manager2 = _interopRequireDefault(_gift_page_state_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _ad = __webpack_require__(14);

var _ad2 = _interopRequireDefault(_ad);

var _not_found_component = __webpack_require__(16);

var _not_found_component2 = _interopRequireDefault(_not_found_component);

var _loading_spinner = __webpack_require__(18);

var _loading_spinner2 = _interopRequireDefault(_loading_spinner);

var _product_post = __webpack_require__(256);

var _product_post2 = _interopRequireDefault(_product_post);

var _all_feed = __webpack_require__(35);

var _all_feed2 = _interopRequireDefault(_all_feed);

var _tag_all_feed_action_creators = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-next-line react/prefer-stateless-function
var Gift = function (_Component) {
  _inherits(Gift, _Component);

  function Gift() {
    _classCallCheck(this, Gift);

    return _possibleConstructorReturn(this, (Gift.__proto__ || Object.getPrototypeOf(Gift)).apply(this, arguments));
  }

  _createClass(Gift, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          status = _props.status,
          config = _props.config,
          giftPage = _props.giftPage,
          gift = _props.gift,
          tagAllFeed = _props.tagAllFeed;


      if (status === 404) {
        return _react2.default.createElement(
          'section',
          { className: 'tag-page' },
          _react2.default.createElement(
            'article',
            { className: 'tag-page__main--error-pg' },
            _react2.default.createElement(_not_found_component2.default, null)
          )
        );
      }

      if (giftPage.isLoading) {
        return _react2.default.createElement(
          'section',
          { className: 'product-page' },
          _react2.default.createElement(
            'article',
            { className: 'product-page__main' },
            _react2.default.createElement(_loading_spinner2.default, null)
          )
        );
      }

      var adData = (0, _get2.default)(giftPage, 'ads');

      var combinedAdModel = (0, _extend2.default)({}, { baseConfig: (0, _get2.default)(adData, 'config.baseConfig') }, { definitions: (0, _get2.default)(adData, 'config.definitions') }, { model: (0, _get2.default)(adData, 'model') });

      // const product = this.props.product;
      var productName = '' + (0, _get2.default)(gift, 'name');

      return _react2.default.createElement(
        'section',
        { className: 'product-page' },
        _react2.default.createElement(
          'div',
          { className: 'post__article-top-ad-wrapper' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'flexiblepushdown',
            region: 'articletop'
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, {
            name: 'mobileleaderboard',
            region: 'articletop'
          })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'oop', slug: false, oop: true }))
        ),
        _react2.default.createElement(_product_post2.default, {
          config: config,
          product: gift,
          combinedAdModel: combinedAdModel,
          gift: true
        }),
        (0, _get2.default)(tagAllFeed, 'posts[0]') ? _react2.default.createElement(_all_feed2.default, {
          adModel: combinedAdModel,
          stories: (0, _get2.default)(tagAllFeed, 'posts'),
          allRendered: true,
          updateAction: _tag_all_feed_action_creators.tagAllFeedAllStoriesRendered,
          config: config,
          titleOverride: 'Stories about ' + productName
        }) : '',
        _react2.default.createElement(
          'div',
          { className: 'product-page__ad-container' },
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'flexiblebillboard_1' })),
          _react2.default.createElement(_ad2.default, _extends({}, combinedAdModel, { name: 'mobilerectangle_1' }))
        )
      );
    }
  }]);

  return Gift;
}(_react.Component);

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    config: state.config || {},
    status: state.status.code,
    gift: (0, _get2.default)(state, 'gift.data.rows[0]') || { error: true },
    giftPage: (0, _get2.default)(state, 'giftPage') || { error: true },
    tagAllFeed: {
      totalPosts: (0, _get2.default)(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: (0, _get2.default)(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: (0, _get2.default)(state, 'tagAllFeed.data.allRendered', false),
      posts: (0, _get2.default)(state, 'tagAllFeed.data.posts', [])
    }
  };
}

Gift.propTypes = {
  config: _propTypes2.default.shape({}),
  status: _propTypes2.default.number,
  gift: _propTypes2.default.shape({}).isRequired,
  giftPage: _propTypes2.default.shape({
    ads: _propTypes2.default.object.isRequired,
    isLoading: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string
  }),
  tagAllFeed: _propTypes2.default.shape({
    totalPages: _propTypes2.default.number,
    totalPosts: _propTypes2.default.number,
    allRendered: _propTypes2.default.bool,
    posts: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  })
};

Gift.defaultProps = {
  config: {},
  status: 200,
  giftPage: {
    isLoading: false,
    error: false,
    errorMessage: ''
  },
  tagAllFeed: {
    posts: [{}],
    allRendered: false
  }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Gift);

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchDataWithStore;

var _exenv = __webpack_require__(4);

var _async_gift_page_actions = __webpack_require__(909);

var _async_gift_page_actions2 = _interopRequireDefault(_async_gift_page_actions);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataWithStore(store) {
  return function fetchData(nextState, replace, callback) {
    var dispatch = store.dispatch;

    // run async

    if (_exenv.canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      (0, _async_gift_page_actions2.default)(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return (0, _async_gift_page_actions2.default)(nextState.params, store)(dispatch).then(function cb() {
      if (callback) {
        return callback();
      }
      return false;
    }).catch(function handleActionError(error) {
      _logger_service2.default.fatal(error, 'Fatal error in onEnter state manager: ' + error.message);
      if (callback) {
        return callback(error);
      }
      return false;
    });
  };
}

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchProductPage;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _gift_page_action_creators = __webpack_require__(910);

var giftPageActions = _interopRequireWildcard(_gift_page_action_creators);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

var _async_tag_all_feed_actions = __webpack_require__(81);

var _async_tag_all_feed_actions2 = _interopRequireDefault(_async_tag_all_feed_actions);

var _async_gift_actions = __webpack_require__(911);

var _async_gift_actions2 = _interopRequireDefault(_async_gift_actions);

var _async_recirc_feed_actions = __webpack_require__(17);

var _async_recirc_feed_actions2 = _interopRequireDefault(_async_recirc_feed_actions);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchProductPage(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();
    if ((0, _get2.default)(state, 'config.site') !== 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(giftPageActions.giftPageLoading({}, store));
    return _bluebird2.default.all([(0, _async_gift_actions2.default)(params, store)(dispatch), (0, _async_tag_all_feed_actions2.default)(params, store, true)(dispatch), (0, _async_recirc_feed_actions2.default)(params, store)(dispatch)]).then(function handlePostDetailData() {
      dispatch(giftPageActions.giftPageLoaded({}, store));
      return true;
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status') || 500;
      if (status === 404) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      } else {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }
      dispatch(giftPageActions.giftPageLoadError(err, store));
      return _logger_service2.default.error(err, 'Error in tag page actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftPageLoading = giftPageLoading;
exports.giftPageLoaded = giftPageLoaded;
exports.giftPageLoadError = giftPageLoadError;
// import { canUseDOM } from 'exenv';

function giftPageLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_PAGE_LOADING',
    giftPage: resp,
    store: store
  };
}

function giftPageLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_PAGE_LOADED',
    giftPage: resp,
    store: store
  };
}

function giftPageLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_PAGE_ERROR',
    giftPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchGiftDetail;

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _gift_action_creators = __webpack_require__(912);

var giftActions = _interopRequireWildcard(_gift_action_creators);

var _gift_model = __webpack_require__(913);

var _gift_model2 = _interopRequireDefault(_gift_model);

var _not_found_status_action_creator = __webpack_require__(6);

var _not_found_status_action_creator2 = _interopRequireDefault(_not_found_status_action_creator);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchGiftDetail(params, store) {
  return function firstDispatch(dispatch) {
    var state = store.getState();

    if ((0, _get2.default)(state, 'config.site') !== 'fastcodesign') {
      dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(giftActions.giftLoading({}, store));
    return _gift_model2.default.fetch(params, store).then(function handleGiftDetailData(GiftData) {
      dispatch(giftActions.giftLoaded(GiftData.data, store));
    }).catch(function handleUserError(err) {
      var status = (0, _get2.default)(err, 'response.status.code') || 500;

      if (status === 404 || status === 401) {
        dispatch((0, _not_found_status_action_creator2.default)(404, 'NOT_FOUND_STATUS', store));
      }

      if (status === 500) {
        dispatch((0, _not_found_status_action_creator2.default)(500, 'ERROR_STATUS', store));
      }

      dispatch(giftActions.giftLoadError(err, store));

      _logger_service2.default.error(err, 'Error in gift actions, message: ' + err.message);
    });
  };
}

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftLoading = giftLoading;
exports.giftLoaded = giftLoaded;
exports.giftLoadError = giftLoadError;
// import { canUseDOM } from 'exenv';

function giftLoading() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_LOADING',
    gift: resp,
    store: store
  };
}

function giftLoaded() {
  var resp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_LOADED',
    gift: resp,
    store: store
  };
}

function giftLoadError(error) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: 'GIFT_ERROR',
    gift: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store: store
  };
}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _exenv = __webpack_require__(4);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _caching_service = __webpack_require__(8);

var _caching_service2 = _interopRequireDefault(_caching_service);

var _request_util = __webpack_require__(9);

var _request_util2 = _interopRequireDefault(_request_util);

var _base_model = __webpack_require__(10);

var _base_model2 = _interopRequireDefault(_base_model);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Person = function (_Base) {
  _inherits(Person, _Base);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, null, [{
    key: 'fetch',
    value: function fetch(_ref, store) {
      var product = _ref.product;

      var state = store.getState();
      var cacheEnabled = (0, _get2.default)(state, 'config.cacheEnabled');
      var cacheExpire = (0, _get2.default)(state, 'config.cacheExpire');
      var cacheNamespace = (0, _get2.default)(state, 'config.cacheNamespace');
      var host = 'api.fastcompany.com';
      var options = {};
      // https://api.fastcompany.com/v1/packages/product/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=steve-jobs

      // Don't worry about this token. Can be public. Talked to Harry.
      var cacheKeyUrl = 'https://' + host + '/v1/packages/product/search/url?token=33FDDA6B-93D3-40A7-83E9-E2AA671FEC07&url=' + this.cleanParam(product);
      var cacheKey = cacheNamespace + ':' + cacheKeyUrl;

      if (!cacheEnabled) {
        return _request_util2.default.getAsync(cacheKeyUrl, options);
      }

      return _caching_service2.default.getAsync(cacheKey).then(function fromCache(cacheRes) {
        // TODO: refactor so we only need to do this on server
        if (cacheRes) {
          return _bluebird2.default.resolve(JSON.parse(cacheRes));
        }

        if (!_exenv.canUseDOM) {
          _logger_service2.default.info('Requesting: ' + cacheKeyUrl + ' from model.');
        }

        return _request_util2.default.getAsync(cacheKeyUrl, options).then(function fetchSuccess(resp) {
          _caching_service2.default.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
      });
    }
  }]);

  return Person;
}(_base_model2.default);

exports.default = Person;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _reactHelmet = __webpack_require__(915);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _script = __webpack_require__(208);

var _script2 = _interopRequireDefault(_script);

var _style = __webpack_require__(919);

var _style2 = _interopRequireDefault(_style);

var _noscript = __webpack_require__(920);

var _noscript2 = _interopRequireDefault(_noscript);

var _critical_css = __webpack_require__(284);

var _critical_css2 = _interopRequireDefault(_critical_css);

var _dev_css = __webpack_require__(921);

var _dev_css2 = _interopRequireDefault(_dev_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ClientSideHead(initialPageLoad, attr) {
  if (!initialPageLoad) {
    return _react2.default.createElement(_reactHelmet2.default, attr);
  }
  return null;
}

function Head(props) {
  var meta = (0, _get2.default)(props, 'meta.meta') || [];
  var link = (0, _get2.default)(props, 'meta.link') || [];
  var script = (0, _get2.default)(props, 'meta.script') || [];
  var noscript = (0, _get2.default)(props, 'meta.noscript') || [];
  var style = (0, _get2.default)(props, 'meta.style') || [];
  var title = (0, _get2.default)(props, 'meta.title');

  var staticPath = 'https://images.fastcompany.net/multisite_files/fastcompany/static/sites/fonts/201010';

  // meta.push({'httpEquiv': 'Content-Type', 'content': 'text/html; charset=utf-8'});
  // meta.push({ charSet: 'UTF-8' });

  // On initial render Helmet has a bug: https://github.com/nfl/react-helmet/issues/98
  return _react2.default.createElement(
    'head',
    {
      prefix: 'og: http://ogp.me/ns# fb: http://ogp.me/ns/fb# article: http://ogp.me/ns/article#',
      lang: 'en'
    },
    _react2.default.createElement('meta', { charset: 'utf-8' }),
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    meta.map(function createMetaTags(conf) {
      return _react2.default.createElement('meta', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fc-icons/fc-icon11.woff?pa1lh4'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fczizou/FCZizouSans-Regular-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fczizou/FCZizouSans-Medium-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fczizou/FCZizouSans-Bold-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fczizou/FCZizouSans-Black-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fckaiser/FCKaiser-Medium-Web.woff'
    }),
    _react2.default.createElement('link', {
      rel: 'preload',
      as: 'font',
      crossOrigin: 'crossorigin',
      type: 'font/woff',
      href: staticPath + '/fc-app-2017/fckaiser/FCKaiser-Bold-Web.woff'
    }),
    _react2.default.createElement('link', { rel: 'dns-prefetch', href: props.staticUrl }),
    _react2.default.createElement(_critical_css2.default, null),
    _react2.default.createElement(_dev_css2.default, null),
    _react2.default.createElement('script', { src: '//www.googletagservices.com/tag/js/gpt.js', async: true }),
    link.map(function createLinkTags(conf) {
      return _react2.default.createElement('link', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    script.map(function createScriptTags(conf) {
      return _react2.default.createElement(_script2.default, _extends({ key: JSON.stringify(conf) }, conf));
    }),
    noscript.map(function createNoScriptTags(conf) {
      return _react2.default.createElement(_noscript2.default, _extends({ key: JSON.stringify(conf) }, conf));
    }),
    style.map(function createStyleTags(conf) {
      return _react2.default.createElement(_style2.default, _extends({ key: JSON.stringify(conf) }, conf));
    }),
    ClientSideHead(props.initialPageLoad, {
      title: title,
      meta: meta,
      link: link,
      script: script,
      noscript: noscript,
      style: style
    })
  );
}

function mapStateToProps(state) {
  return {
    staticUrl: state.config.staticUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  staticUrl: _propTypes2.default.string.isRequired,
  initialPageLoad: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  meta: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Head);

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(916);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(189);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(918);

var _HelmetConstants = __webpack_require__(283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(4);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(917);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {;(true);
exports.warn = (exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(39);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
;(requestAnimationFrame);
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Style;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Style(_ref) {
  var innerHtml = _ref.innerHtml;

  if (!innerHtml) {
    return null;
  }
  return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: innerHtml } });
}

Style.defaultProps = {
  innerHtml: ''
};

Style.propTypes = {
  innerHtml: _propTypes2.default.string
};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Noscript;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Noscript(_ref) {
  var innerHtml = _ref.innerHtml;

  if (!innerHtml) {
    return null;
  }
  return _react2.default.createElement('noscript', { dangerouslySetInnerHTML: { __html: innerHtml } });
}

Noscript.defaultProps = {
  innerHtml: ''
};

Noscript.propTypes = {
  innerHtml: _propTypes2.default.string
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DevStyles = function (_Component) {
  _inherits(DevStyles, _Component);

  function DevStyles() {
    _classCallCheck(this, DevStyles);

    return _possibleConstructorReturn(this, (DevStyles.__proto__ || Object.getPrototypeOf(DevStyles)).apply(this, arguments));
  }

  _createClass(DevStyles, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.shouldRender) {
        return null;
      }

      return _react2.default.createElement('link', { href: this.props.staticUrl + '/css/main.css', rel: 'stylesheet' });
    }
  }]);

  return DevStyles;
}(_react.Component);

DevStyles.propTypes = {
  staticUrl: _propTypes2.default.string.isRequired,
  shouldRender: _propTypes2.default.bool.isRequired
};

function mapStateToProps(state) {
  return {
    shouldRender: state.config.env === 'development',
    staticUrl: state.config.staticUrl
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DevStyles);

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _critical_css = __webpack_require__(284);

var _critical_css2 = _interopRequireDefault(_critical_css);

var _amp_styles = __webpack_require__(923);

var _amp_styles2 = _interopRequireDefault(_amp_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// function DevReloading(props) {
//   if (props.env === 'development') {
//     return (
//       <script
//         dangerouslySetInnerHTML={{
//           __html: `setTimeout(function(){window.location.reload();}, 60000);`
//         }}
//       />
//     );
//   }
//
//   return null;
// }

function Head(props) {
  var meta = (0, _get2.default)(props, 'meta.meta') || [];
  var link = (0, _get2.default)(props, 'meta.link') || [];
  var script = (0, _get2.default)(props, 'meta.script') || [];
  var title = (0, _get2.default)(props, 'meta.title');

  return _react2.default.createElement(
    'head',
    null,
    _react2.default.createElement('meta', { charset: 'utf-8' }),
    _react2.default.createElement('meta', {
      'http-equiv': 'origin-trial',
      content: 'AjQkyiCgG5iPFdJnbc/BHOxiJXzCd8tS1qO2BPNmUcjPhqTAlpCqguyW04T5U5JUik+rrEV/zE5+dMa+k3KT5gYAAABneyJvcmlnaW4iOiJodHRwczovL2Nkbi5hbXBwcm9qZWN0Lm9yZzo0NDMiLCJmZWF0dXJlIjoiV2ViU2hhcmUiLCJleHBpcnkiOjE0ODg4MTA2NjQsImlzU3ViZG9tYWluIjp0cnVlfQ=='
    }),
    _react2.default.createElement('link', { rel: 'canonical', href: props.canonical }),
    _react2.default.createElement('meta', {
      name: 'viewport',
      content: 'width=device-width,minimum-scale=1,initial-scale=1'
    }),
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement(_amp_styles2.default, null),
    meta.map(function createMetaTags(conf) {
      return _react2.default.createElement('meta', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    link.map(function createLinkTags(conf) {
      return _react2.default.createElement('link', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    _react2.default.createElement(_critical_css2.default, { amp: true }),
    _react2.default.createElement('script', { async: true, src: 'https://cdn.ampproject.org/v0.js' }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-ad',
      src: 'https://cdn.ampproject.org/v0/amp-ad-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-analytics',
      src: 'https://cdn.ampproject.org/v0/amp-analytics-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-iframe',
      src: 'https://cdn.ampproject.org/v0/amp-iframe-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-twitter',
      src: 'https://cdn.ampproject.org/v0/amp-twitter-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-instagram',
      src: 'https://cdn.ampproject.org/v0/amp-instagram-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-facebook',
      src: 'https://cdn.ampproject.org/v0/amp-facebook-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-youtube',
      src: 'https://cdn.ampproject.org/v0/amp-youtube-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-vimeo',
      src: 'https://cdn.ampproject.org/v0/amp-vimeo-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-sticky-ad',
      src: 'https://cdn.ampproject.org/v0/amp-sticky-ad-1.0.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-carousel',
      src: 'https://cdn.ampproject.org/v0/amp-carousel-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-anim',
      src: 'https://cdn.ampproject.org/v0/amp-anim-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-jwplayer',
      src: 'https://cdn.ampproject.org/v0/amp-jwplayer-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-sidebar',
      src: 'https://cdn.ampproject.org/v0/amp-sidebar-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-fit-text',
      src: 'https://cdn.ampproject.org/v0/amp-fit-text-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-social-share',
      src: 'https://cdn.ampproject.org/v0/amp-social-share-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-video',
      src: 'https://cdn.ampproject.org/v0/amp-video-0.1.js'
    }),
    _react2.default.createElement('script', {
      async: true,
      'custom-element': 'amp-audio',
      src: 'https://cdn.ampproject.org/v0/amp-audio-0.1.js'
    })
  );
}

function mapStateToProps(state) {
  return {
    env: state.config.env,
    canonical: state.config.navHistory[0].split('?')[0],
    staticUrl: state.config.staticUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  meta: _propTypes2.default.shape({}).isRequired,
  canonical: _propTypes2.default.string.isRequired
  // env: PropTypes.string.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Head);

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AmpStyleBoilerplate;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AmpStyleBoilerplate() {
  return [_react2.default.createElement("style", {
    "amp-boilerplate": "",
    dangerouslySetInnerHTML: {
      __html: "body{-webkit-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-moz-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-ms-animation:-amp-start 8s steps(1,end) 0s 1 normal both;animation:-amp-start 8s steps(1,end) 0s 1 normal both}@-webkit-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-moz-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-ms-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-o-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}"
    }
  }), _react2.default.createElement("noscript", {
    dangerouslySetInnerHTML: {
      __html: "<style amp-boilerplate=\"\">body{-webkit-animation:none;-moz-animation:none;-ms-animation:none;animation:none}</style>"
    }
  })];
}

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Head(props) {
  var meta = (0, _get2.default)(props, 'meta.meta') || [];
  var link = (0, _get2.default)(props, 'meta.link') || [];
  var title = (0, _get2.default)(props, 'meta.title');

  return _react2.default.createElement(
    'head',
    null,
    _react2.default.createElement('meta', { charset: 'utf-8' }),
    _react2.default.createElement('meta', { property: 'op:markup_version', content: 'v1.0' }),
    _react2.default.createElement('link', { rel: 'canonical', href: this.props.canonical }),
    _react2.default.createElement('meta', {
      name: 'viewport',
      content: 'width=device-width,minimum-scale=1,initial-scale=1'
    }),
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement('meta', { property: 'fb:article_style', content: this.props.articleStyle }),
    meta.map(function createMetaTags(conf) {
      return _react2.default.createElement('meta', _extends({ key: JSON.stringify(conf) }, conf));
    }),
    link.map(function createLinkTags(conf) {
      return _react2.default.createElement('link', _extends({ key: JSON.stringify(conf) }, conf));
    })
  );
}

function mapStateToProps(state) {
  return {
    articleStyle: 'TEST ARTICLE STYLE',
    canonical: state.config.navHistory[0].split('?')[0],
    staticUrl: state.config.staticUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  meta: _propTypes2.default.shape({}).isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Head);

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _exenv = __webpack_require__(4);

__webpack_require__(2).PropTypes = __webpack_require__(3);

// https://gist.github.com/gaearon/9a4d54653ae9c50af6c54b4e0e56b583#javascript-environment-requirements
if (!_exenv.canUseDOM) {
  global.requestAnimationFrame = function raf(callback) {
    setTimeout(callback, 0);
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.Promise = _bluebird2.default;
// eslint-disable-next-line no-underscore-dangle, no-undef
window._LTracker = [];
// eslint-disable-next-line no-underscore-dangle
window._LTracker.push({
  logglyKey: 'd95daaf3-a943-48f4-8687-cd0c6696f50b',
  sendConsoleErrors: false,
  tag: 'fc-app-browser-logger'
});
// window.Promise.longStackTraces();

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(92);

var _reduxThunk = __webpack_require__(928);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRouterRedux = __webpack_require__(61);

var _reducers = __webpack_require__(929);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://raw.githubusercontent.com/reactjs/react-router-redux/master/examples/server/store.js
function configureStore(history) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var env = arguments[2];

  // eslint-disable-next-line import/no-mutable-exports
  var store = {};

  if (env !== 'development') {
    store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)((0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(history)), (0, _redux.applyMiddleware)(_reduxThunk2.default)));
  } else {
    var composeEnhancers =
    // eslint-disable-next-line no-underscore-dangle, max-len
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
    store = (0, _redux.createStore)(_reducers2.default, initialState, composeEnhancers((0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(history)), (0, _redux.applyMiddleware)(_reduxThunk2.default)));
  }

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', function () {
      // eslint-disable-next-line global-require
      var nextReducer = require('../reducers').default;
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}
// https://github.com/gaearon/redux-thunk

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(92);

var _reactRouterRedux = __webpack_require__(61);

var _homepage_reducer = __webpack_require__(930);

var _homepage_reducer2 = _interopRequireDefault(_homepage_reducer);

var _scrolling_module_reducer = __webpack_require__(931);

var _scrolling_module_reducer2 = _interopRequireDefault(_scrolling_module_reducer);

var _promo_banner_reducer = __webpack_require__(932);

var _promo_banner_reducer2 = _interopRequireDefault(_promo_banner_reducer);

var _all_feed_reducer = __webpack_require__(933);

var _all_feed_reducer2 = _interopRequireDefault(_all_feed_reducer);

var _featured_feed_reducer = __webpack_require__(934);

var _featured_feed_reducer2 = _interopRequireDefault(_featured_feed_reducer);

var _homepage_tag_reducer = __webpack_require__(935);

var _homepage_tag_reducer2 = _interopRequireDefault(_homepage_tag_reducer);

var _homepage_video_reducer = __webpack_require__(936);

var _homepage_video_reducer2 = _interopRequireDefault(_homepage_video_reducer);

var _featured_sponsored_card_reducer = __webpack_require__(937);

var _featured_sponsored_card_reducer2 = _interopRequireDefault(_featured_sponsored_card_reducer);

var _postpage_reducer = __webpack_require__(938);

var _postpage_reducer2 = _interopRequireDefault(_postpage_reducer);

var _post_reducer = __webpack_require__(939);

var _post_reducer2 = _interopRequireDefault(_post_reducer);

var _post_video_reducer = __webpack_require__(940);

var _post_video_reducer2 = _interopRequireDefault(_post_video_reducer);

var _post_finite_reducer = __webpack_require__(941);

var _post_finite_reducer2 = _interopRequireDefault(_post_finite_reducer);

var _post_afterbody_recirc_module_type_reducer = __webpack_require__(942);

var _post_afterbody_recirc_module_type_reducer2 = _interopRequireDefault(_post_afterbody_recirc_module_type_reducer);

var _post_more_stories_reducer = __webpack_require__(943);

var _post_more_stories_reducer2 = _interopRequireDefault(_post_more_stories_reducer);

var _video_page_reducer = __webpack_require__(944);

var _video_page_reducer2 = _interopRequireDefault(_video_page_reducer);

var _video_index_page_reducer = __webpack_require__(945);

var _video_index_page_reducer2 = _interopRequireDefault(_video_index_page_reducer);

var _jw_video_reducer = __webpack_require__(946);

var _jw_video_reducer2 = _interopRequireDefault(_jw_video_reducer);

var _jw_related_video_reducer = __webpack_require__(947);

var _jw_related_video_reducer2 = _interopRequireDefault(_jw_related_video_reducer);

var _jw_newest_video_reducer = __webpack_require__(948);

var _jw_newest_video_reducer2 = _interopRequireDefault(_jw_newest_video_reducer);

var _jw_playlist_reducer = __webpack_require__(949);

var _jw_playlist_reducer2 = _interopRequireDefault(_jw_playlist_reducer);

var _jw_playlist_index_reducer = __webpack_require__(950);

var _jw_playlist_index_reducer2 = _interopRequireDefault(_jw_playlist_index_reducer);

var _playlist_index_page_reducer = __webpack_require__(951);

var _playlist_index_page_reducer2 = _interopRequireDefault(_playlist_index_page_reducer);

var _playlist_page_reducer = __webpack_require__(952);

var _playlist_page_reducer2 = _interopRequireDefault(_playlist_page_reducer);

var _category_page_reducer = __webpack_require__(953);

var _category_page_reducer2 = _interopRequireDefault(_category_page_reducer);

var _category_featured_feed_reducer = __webpack_require__(954);

var _category_featured_feed_reducer2 = _interopRequireDefault(_category_featured_feed_reducer);

var _category_video_reducer = __webpack_require__(955);

var _category_video_reducer2 = _interopRequireDefault(_category_video_reducer);

var _category_all_feed_reducer = __webpack_require__(956);

var _category_all_feed_reducer2 = _interopRequireDefault(_category_all_feed_reducer);

var _category_scrolling_module_reducer = __webpack_require__(957);

var _category_scrolling_module_reducer2 = _interopRequireDefault(_category_scrolling_module_reducer);

var _category_promo_banner_reducer = __webpack_require__(958);

var _category_promo_banner_reducer2 = _interopRequireDefault(_category_promo_banner_reducer);

var _tag_page_reducer = __webpack_require__(959);

var _tag_page_reducer2 = _interopRequireDefault(_tag_page_reducer);

var _tag_featured_feed_reducer = __webpack_require__(960);

var _tag_featured_feed_reducer2 = _interopRequireDefault(_tag_featured_feed_reducer);

var _tag_video_reducer = __webpack_require__(961);

var _tag_video_reducer2 = _interopRequireDefault(_tag_video_reducer);

var _tag_all_feed_reducer = __webpack_require__(962);

var _tag_all_feed_reducer2 = _interopRequireDefault(_tag_all_feed_reducer);

var _tag_scrolling_module_reducer = __webpack_require__(963);

var _tag_scrolling_module_reducer2 = _interopRequireDefault(_tag_scrolling_module_reducer);

var _tag_promo_banner_reducer = __webpack_require__(964);

var _tag_promo_banner_reducer2 = _interopRequireDefault(_tag_promo_banner_reducer);

var _magazine_archive_page_reducer = __webpack_require__(965);

var _magazine_archive_page_reducer2 = _interopRequireDefault(_magazine_archive_page_reducer);

var _magazine_archive_reducer = __webpack_require__(966);

var _magazine_archive_reducer2 = _interopRequireDefault(_magazine_archive_reducer);

var _magazine_issue_posts_reducer = __webpack_require__(967);

var _magazine_issue_posts_reducer2 = _interopRequireDefault(_magazine_issue_posts_reducer);

var _magazine_latest_issue_posts_reducer = __webpack_require__(968);

var _magazine_latest_issue_posts_reducer2 = _interopRequireDefault(_magazine_latest_issue_posts_reducer);

var _person_page_reducer = __webpack_require__(969);

var _person_page_reducer2 = _interopRequireDefault(_person_page_reducer);

var _person_reducer = __webpack_require__(970);

var _person_reducer2 = _interopRequireDefault(_person_reducer);

var _person_index_page_reducer = __webpack_require__(971);

var _person_index_page_reducer2 = _interopRequireDefault(_person_index_page_reducer);

var _product_page_reducer = __webpack_require__(972);

var _product_page_reducer2 = _interopRequireDefault(_product_page_reducer);

var _product_reducer = __webpack_require__(973);

var _product_reducer2 = _interopRequireDefault(_product_reducer);

var _product_index_page_reducer = __webpack_require__(974);

var _product_index_page_reducer2 = _interopRequireDefault(_product_index_page_reducer);

var _innovation_by_design_page_reducer = __webpack_require__(975);

var _innovation_by_design_page_reducer2 = _interopRequireDefault(_innovation_by_design_page_reducer);

var _innovation_by_design_reducer = __webpack_require__(976);

var _innovation_by_design_reducer2 = _interopRequireDefault(_innovation_by_design_reducer);

var _innovation_by_design_details_reducer = __webpack_require__(977);

var _innovation_by_design_details_reducer2 = _interopRequireDefault(_innovation_by_design_details_reducer);

var _innovation_by_design_featured_feed_reducer = __webpack_require__(978);

var _innovation_by_design_featured_feed_reducer2 = _interopRequireDefault(_innovation_by_design_featured_feed_reducer);

var _innovation_by_design_scrolling_module_reducer = __webpack_require__(979);

var _innovation_by_design_scrolling_module_reducer2 = _interopRequireDefault(_innovation_by_design_scrolling_module_reducer);

var _gift_guide_page_reducer = __webpack_require__(980);

var _gift_guide_page_reducer2 = _interopRequireDefault(_gift_guide_page_reducer);

var _gift_guide_reducer = __webpack_require__(981);

var _gift_guide_reducer2 = _interopRequireDefault(_gift_guide_reducer);

var _gift_guide_details_reducer = __webpack_require__(982);

var _gift_guide_details_reducer2 = _interopRequireDefault(_gift_guide_details_reducer);

var _gift_page_reducer = __webpack_require__(983);

var _gift_page_reducer2 = _interopRequireDefault(_gift_page_reducer);

var _gift_reducer = __webpack_require__(984);

var _gift_reducer2 = _interopRequireDefault(_gift_reducer);

var _person_index_section_page_reducer = __webpack_require__(985);

var _person_index_section_page_reducer2 = _interopRequireDefault(_person_index_section_page_reducer);

var _person_index_section_reducer = __webpack_require__(986);

var _person_index_section_reducer2 = _interopRequireDefault(_person_index_section_reducer);

var _person_index_section_next_reducer = __webpack_require__(987);

var _person_index_section_next_reducer2 = _interopRequireDefault(_person_index_section_next_reducer);

var _product_index_section_page_reducer = __webpack_require__(988);

var _product_index_section_page_reducer2 = _interopRequireDefault(_product_index_section_page_reducer);

var _product_index_section_reducer = __webpack_require__(989);

var _product_index_section_reducer2 = _interopRequireDefault(_product_index_section_reducer);

var _product_index_section_next_reducer = __webpack_require__(990);

var _product_index_section_next_reducer2 = _interopRequireDefault(_product_index_section_next_reducer);

var _most_creative_people_page_reducer = __webpack_require__(991);

var _most_creative_people_page_reducer2 = _interopRequireDefault(_most_creative_people_page_reducer);

var _most_creative_people_reducer = __webpack_require__(992);

var _most_creative_people_reducer2 = _interopRequireDefault(_most_creative_people_reducer);

var _most_creative_people_featured_feed_reducer = __webpack_require__(993);

var _most_creative_people_featured_feed_reducer2 = _interopRequireDefault(_most_creative_people_featured_feed_reducer);

var _most_creative_people_scrolling_module_reducer = __webpack_require__(994);

var _most_creative_people_scrolling_module_reducer2 = _interopRequireDefault(_most_creative_people_scrolling_module_reducer);

var _most_creative_people_community_page_reducer = __webpack_require__(995);

var _most_creative_people_community_page_reducer2 = _interopRequireDefault(_most_creative_people_community_page_reducer);

var _most_creative_people_community_section_page_reducer = __webpack_require__(996);

var _most_creative_people_community_section_page_reducer2 = _interopRequireDefault(_most_creative_people_community_section_page_reducer);

var _most_creative_people_community_section_reducer = __webpack_require__(997);

var _most_creative_people_community_section_reducer2 = _interopRequireDefault(_most_creative_people_community_section_reducer);

var _most_creative_people_community_section_next_reducer = __webpack_require__(998);

var _most_creative_people_community_section_next_reducer2 = _interopRequireDefault(_most_creative_people_community_section_next_reducer);

var _company_page_reducer = __webpack_require__(999);

var _company_page_reducer2 = _interopRequireDefault(_company_page_reducer);

var _company_reducer = __webpack_require__(1000);

var _company_reducer2 = _interopRequireDefault(_company_reducer);

var _company_data_reducer = __webpack_require__(1001);

var _company_data_reducer2 = _interopRequireDefault(_company_data_reducer);

var _company_awards_reducer = __webpack_require__(1002);

var _company_awards_reducer2 = _interopRequireDefault(_company_awards_reducer);

var _company_index_groups_reducer = __webpack_require__(1003);

var _company_index_groups_reducer2 = _interopRequireDefault(_company_index_groups_reducer);

var _company_index_section_page_reducer = __webpack_require__(1004);

var _company_index_section_page_reducer2 = _interopRequireDefault(_company_index_section_page_reducer);

var _company_index_section_reducer = __webpack_require__(1005);

var _company_index_section_reducer2 = _interopRequireDefault(_company_index_section_reducer);

var _company_index_section_next_reducer = __webpack_require__(1006);

var _company_index_section_next_reducer2 = _interopRequireDefault(_company_index_section_next_reducer);

var _company_index_page_reducer = __webpack_require__(1007);

var _company_index_page_reducer2 = _interopRequireDefault(_company_index_page_reducer);

var _mic_year_page_reducer = __webpack_require__(1008);

var _mic_year_page_reducer2 = _interopRequireDefault(_mic_year_page_reducer);

var _mic_sector_page_reducer = __webpack_require__(1009);

var _mic_sector_page_reducer2 = _interopRequireDefault(_mic_sector_page_reducer);

var _mic_year_reducer = __webpack_require__(1010);

var _mic_year_reducer2 = _interopRequireDefault(_mic_year_reducer);

var _mic_year_description_reducer = __webpack_require__(1011);

var _mic_year_description_reducer2 = _interopRequireDefault(_mic_year_description_reducer);

var _mic_sector_reducer = __webpack_require__(1012);

var _mic_sector_reducer2 = _interopRequireDefault(_mic_sector_reducer);

var _author_page_reducer = __webpack_require__(1013);

var _author_page_reducer2 = _interopRequireDefault(_author_page_reducer);

var _author_reducer = __webpack_require__(1014);

var _author_reducer2 = _interopRequireDefault(_author_reducer);

var _author_all_feed_reducer = __webpack_require__(1015);

var _author_all_feed_reducer2 = _interopRequireDefault(_author_all_feed_reducer);

var _search_reducer = __webpack_require__(1016);

var _search_reducer2 = _interopRequireDefault(_search_reducer);

var _search_page_reducer = __webpack_require__(1017);

var _search_page_reducer2 = _interopRequireDefault(_search_page_reducer);

var _wp_page_reducer = __webpack_require__(1018);

var _wp_page_reducer2 = _interopRequireDefault(_wp_page_reducer);

var _static_page_reducer = __webpack_require__(1019);

var _static_page_reducer2 = _interopRequireDefault(_static_page_reducer);

var _newsletters_preferences_page_reducer = __webpack_require__(1020);

var _newsletters_preferences_page_reducer2 = _interopRequireDefault(_newsletters_preferences_page_reducer);

var _custom_page_reducer = __webpack_require__(1021);

var _custom_page_reducer2 = _interopRequireDefault(_custom_page_reducer);

var _html_sitemap_index_page_reducer = __webpack_require__(1022);

var _html_sitemap_index_page_reducer2 = _interopRequireDefault(_html_sitemap_index_page_reducer);

var _html_sitemap_index_reducer = __webpack_require__(1023);

var _html_sitemap_index_reducer2 = _interopRequireDefault(_html_sitemap_index_reducer);

var _html_sitemap_post_page_reducer = __webpack_require__(1024);

var _html_sitemap_post_page_reducer2 = _interopRequireDefault(_html_sitemap_post_page_reducer);

var _html_sitemap_post_reducer = __webpack_require__(1025);

var _html_sitemap_post_reducer2 = _interopRequireDefault(_html_sitemap_post_reducer);

var _recirc_feed_reducer = __webpack_require__(1026);

var _recirc_feed_reducer2 = _interopRequireDefault(_recirc_feed_reducer);

var _context_reducer = __webpack_require__(1027);

var _context_reducer2 = _interopRequireDefault(_context_reducer);

var _analytics_reducer = __webpack_require__(1028);

var _analytics_reducer2 = _interopRequireDefault(_analytics_reducer);

var _config_reducer = __webpack_require__(1029);

var _config_reducer2 = _interopRequireDefault(_config_reducer);

var _meta_reducer = __webpack_require__(1030);

var _meta_reducer2 = _interopRequireDefault(_meta_reducer);

var _status_reducer = __webpack_require__(1060);

var _status_reducer2 = _interopRequireDefault(_status_reducer);

var _not_found_page_reducer = __webpack_require__(1061);

var _not_found_page_reducer2 = _interopRequireDefault(_not_found_page_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  config: _config_reducer2.default,
  meta: _meta_reducer2.default,
  context: _context_reducer2.default,
  analytics: _analytics_reducer2.default,
  status: _status_reducer2.default,

  homepage: _homepage_reducer2.default,
  scrollingModule: _scrolling_module_reducer2.default,
  promoBanner: _promo_banner_reducer2.default,
  allFeed: _all_feed_reducer2.default,
  recircFeed: _recirc_feed_reducer2.default,
  featuredFeed: _featured_feed_reducer2.default,
  homepageTag: _homepage_tag_reducer2.default,
  homepageVideo: _homepage_video_reducer2.default,
  featuredSponsoredCard: _featured_sponsored_card_reducer2.default,

  postpage: _postpage_reducer2.default,
  post: _post_reducer2.default,
  postVideo: _post_video_reducer2.default,
  postAfterbodyRecircModuleType: _post_afterbody_recirc_module_type_reducer2.default,
  postMoreStories: _post_more_stories_reducer2.default,
  postFinite: _post_finite_reducer2.default,

  categoryPage: _category_page_reducer2.default,
  categoryScrollingModule: _category_scrolling_module_reducer2.default,
  categoryPromoBanner: _category_promo_banner_reducer2.default,
  categoryFeaturedFeed: _category_featured_feed_reducer2.default,
  categoryVideo: _category_video_reducer2.default,
  categoryAllFeed: _category_all_feed_reducer2.default,

  tagPage: _tag_page_reducer2.default,
  tagScrollingModule: _tag_scrolling_module_reducer2.default,
  tagPromoBanner: _tag_promo_banner_reducer2.default,
  tagFeaturedFeed: _tag_featured_feed_reducer2.default,
  tagVideo: _tag_video_reducer2.default,
  tagAllFeed: _tag_all_feed_reducer2.default,

  personPage: _person_page_reducer2.default,
  person: _person_reducer2.default,

  personIndexPage: _person_index_page_reducer2.default,

  personIndexSectionPage: _person_index_section_page_reducer2.default,
  personIndexSection: _person_index_section_reducer2.default,
  personIndexSectionNext: _person_index_section_next_reducer2.default,

  productPage: _product_page_reducer2.default,
  product: _product_reducer2.default,

  productIndexPage: _product_index_page_reducer2.default,
  productIndexSectionPage: _product_index_section_page_reducer2.default,
  productIndexSection: _product_index_section_reducer2.default,
  productIndexSectionNext: _product_index_section_next_reducer2.default,

  innovationByDesignPage: _innovation_by_design_page_reducer2.default,
  innovationByDesign: _innovation_by_design_reducer2.default,
  innovationByDesignDetail: _innovation_by_design_details_reducer2.default,
  innovationByDesignFeaturedFeed: _innovation_by_design_featured_feed_reducer2.default,
  innovationByDesignScrollingModule: _innovation_by_design_scrolling_module_reducer2.default,

  giftGuidePage: _gift_guide_page_reducer2.default,
  giftGuide: _gift_guide_reducer2.default,
  giftGuideDetail: _gift_guide_details_reducer2.default,
  giftPage: _gift_page_reducer2.default,
  gift: _gift_reducer2.default,

  mostCreativePeoplePage: _most_creative_people_page_reducer2.default,
  mostCreativePeople: _most_creative_people_reducer2.default,
  mostCreativePeopleFeaturedFeed: _most_creative_people_featured_feed_reducer2.default,
  mostCreativePeopleScrollingModule: _most_creative_people_scrolling_module_reducer2.default,

  mostCreativePeopleCommunityPage: _most_creative_people_community_page_reducer2.default,
  mostCreativePeopleCommunitySectionPage: _most_creative_people_community_section_page_reducer2.default,
  mostCreativePeopleCommunitySection: _most_creative_people_community_section_reducer2.default,
  mostCreativePeopleCommunitySectionNext: _most_creative_people_community_section_next_reducer2.default,

  companyPage: _company_page_reducer2.default,
  company: _company_reducer2.default,
  companyData: _company_data_reducer2.default,
  companyAwards: _company_awards_reducer2.default,
  companyIndexGroups: _company_index_groups_reducer2.default,

  companyIndexPage: _company_index_page_reducer2.default,
  companyIndexSection: _company_index_section_reducer2.default,
  companyIndexSectionNext: _company_index_section_next_reducer2.default,
  companyIndexSectionPage: _company_index_section_page_reducer2.default,

  micYearPage: _mic_year_page_reducer2.default,
  micSectorPage: _mic_sector_page_reducer2.default,
  micYear: _mic_year_reducer2.default,
  micYearDescription: _mic_year_description_reducer2.default,

  micSector: _mic_sector_reducer2.default,

  magazineArchivePage: _magazine_archive_page_reducer2.default,
  magazineArchive: _magazine_archive_reducer2.default,
  magazineIssuePosts: _magazine_issue_posts_reducer2.default,
  magazineLatestIssuePosts: _magazine_latest_issue_posts_reducer2.default,

  videoIndexPage: _video_index_page_reducer2.default,
  videoPage: _video_page_reducer2.default,
  jwVideo: _jw_video_reducer2.default,
  jwRelatedVideo: _jw_related_video_reducer2.default,
  jwNewestVideo: _jw_newest_video_reducer2.default,

  jwPlaylist: _jw_playlist_reducer2.default,
  jwPlaylistIndex: _jw_playlist_index_reducer2.default,
  playlistPage: _playlist_page_reducer2.default,
  playlistIndexPage: _playlist_index_page_reducer2.default,

  authorPage: _author_page_reducer2.default,
  authorAllFeed: _author_all_feed_reducer2.default,
  author: _author_reducer2.default,

  search: _search_reducer2.default,
  searchPage: _search_page_reducer2.default,

  wpPage: _wp_page_reducer2.default,
  staticPage: _static_page_reducer2.default,
  customPage: _custom_page_reducer2.default,

  newslettersPreferencesPage: _newsletters_preferences_page_reducer2.default,

  htmlSitemapIndexPage: _html_sitemap_index_page_reducer2.default,
  htmlSitemapIndex: _html_sitemap_index_reducer2.default,

  htmlSitemapPostPage: _html_sitemap_post_page_reducer2.default,
  htmlSitemapPost: _html_sitemap_post_reducer2.default,

  notFoundPage: _not_found_page_reducer2.default
});

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HOMEPAGE_LOADING: function HOMEPAGE_LOADING() {
      return {
        isLoading: true,
        homepage: action.homepage
      };
    },
    HOMEPAGE_LOADED: function HOMEPAGE_LOADED() {
      // For future, the topic needs to be passed here,
      // to determine which topic page you're on, the adzone for topic will be
      // 'topicName/topicName', no need to look it up in keymap
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, null, 'homepage');

      return {
        isLoading: false,
        data: (0, _get2.default)(action, 'homepage'),
        ads: adModelData
      };
    },
    HOMEPAGE_ERROR: function HOMEPAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.homepage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    SCROLLING_MODULE_LOADING: function SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        scrollingModule: action.scrollingModule
      };
    },
    SCROLLING_MODULE_LOADED: function SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.scrollingModule
      };
    },
    SCROLLING_MODULE_ERROR: function SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.scrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PROMO_BANNER_LOADING: function PROMO_BANNER_LOADING() {
      return {
        isLoading: true,
        promoBanner: action.promoBanner
      };
    },
    PROMO_BANNER_LOADED: function PROMO_BANNER_LOADED() {
      return {
        isLoading: false,
        data: action.promoBanner
      };
    },
    PROMO_BANNER_ERROR: function PROMO_BANNER_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.promoBanner.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    ALL_FEED_LOADING: function ALL_FEED_LOADING() {
      return {
        isLoading: true,
        allFeed: action.allFeed,
        allRendered: false
      };
    },
    ALL_FEED_LOADED: function ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.allFeed,
        allRendered: false
      };
    },
    ALL_FEED_ERROR: function ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        allRendered: false,
        errorMessage: action.allFeed.errorMessage
      };
    },
    ALL_FEED_ALL_STORIES_RENDERED: function ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: false,
        data: { posts: state.data.posts },
        allRendered: true
      };
    },
    ALL_FEED_IS_LOADING: function ALL_FEED_IS_LOADING() {
      return (0, _extend2.default)({}, state, { isEnabled: true, isLoading: true });
    },
    ALL_FEED_IS_LOADED: function ALL_FEED_IS_LOADED() {
      return {
        isEnabled: true,
        isLoading: false,
        data: (0, _extend2.default)({}, state.data, {
          page: (0, _get2.default)(action, 'allFeed.page'),
          posts: [].concat(_toConsumableArray(state.data.posts), _toConsumableArray((0, _get2.default)(action, 'allFeed.posts', [])))
        }),
        allRendered: false
      };
    },
    ALL_FEED_IS_ERROR: function ALL_FEED_IS_ERROR() {
      return {
        isEnabled: true,
        isLoading: true,
        data: (0, _extend2.default)({}, state, {
          page: (0, _get2.default)(action, 'allFeed.page'),
          posts: [].concat(_toConsumableArray(state.data.posts), _toConsumableArray((0, _get2.default)(action, 'allFeed.posts', [])))
        }),
        allRendered: false
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    FEATURED_FEED_LOADING: function FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        featuredFeed: action.featuredFeed
      };
    },
    FEATURED_FEED_LOADED: function FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.featuredFeed
      };
    },
    FEATURED_FEED_ERROR: function FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.featuredFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    HOMEPAGE_TAG_LOADING: function HOMEPAGE_TAG_LOADING() {
      return {
        isLoading: true,
        homepageTag: action.homepageTag
      };
    },
    HOMEPAGE_TAG_LOADED: function HOMEPAGE_TAG_LOADED() {
      var tagID = (0, _get2.default)(action, 'homepageTag.tag_id');

      return {
        isLoading: false,
        data: action.homepageTag.posts,
        tagID: tagID
      };
    },
    HOMEPAGE_TAG_ERROR: function HOMEPAGE_TAG_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.homepageTag.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    HOMEPAGE_VIDEO_LOADING: function HOMEPAGE_VIDEO_LOADING() {
      return {
        isLoading: true,
        homepageVideo: action.homepageVideo
      };
    },
    HOMEPAGE_VIDEO_LOADED: function HOMEPAGE_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.homepageVideo
      };
    },
    HOMEPAGE_VIDEO_ERROR: function HOMEPAGE_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.homepageVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    FEATURED_SPONSORED_CARD_LOADING: function FEATURED_SPONSORED_CARD_LOADING() {
      return {
        isLoading: true,
        featuredSponsoredCard: action.featuredSponsoredCard
      };
    },
    FEATURED_SPONSORED_CARD_LOADED: function FEATURED_SPONSORED_CARD_LOADED() {
      return {
        isLoading: false,
        data: action.featuredSponsoredCard
      };
    },
    FEATURED_SPONSORED_CARD_ERROR: function FEATURED_SPONSORED_CARD_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.featuredSponsoredCard.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    POSTPAGE_LOADING: function POSTPAGE_LOADING() {
      return {
        isLoading: true,
        postpage: action.postpage
      };
    },
    POSTPAGE_LOADED: function POSTPAGE_LOADED() {
      var currentState = store.getState();
      var postData = (0, _get2.default)(currentState, 'post.data.post');
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, postData, 'postPage');

      return {
        isLoading: false,
        data: (0, _get2.default)(action, 'postpage'),
        ads: adModelData,
        postScrollDepth: 0
      };
    },
    POSTPAGE_ERROR: function POSTPAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postpage.errorMessage
      };
    },
    POSTPAGE_SCROLL_DEPTH: function POSTPAGE_SCROLL_DEPTH() {
      return {
        isLoading: state.isLoading,
        data: state.postpage,
        ads: state.ads,
        postScrollDepth: action.postScrollDepth
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_LOADING: function POST_LOADING() {
      return {
        isLoading: true,
        post: action.post
      };
    },
    POST_LOADED: function POST_LOADED() {
      return {
        isLoading: false,
        data: action.post
      };
    },
    POST_ERROR: function POST_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.post.errorMessage
      };
    },
    REFRESH_AD: function REFRESH_AD() {
      return {
        isLoading: false,
        data: state.data,
        slotsToRefresh: [action.slot]
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_VIDEO_LOADING: function POST_VIDEO_LOADING() {
      return {
        isLoading: true,
        postVideo: action.postVideo
      };
    },
    POST_VIDEO_LOADED: function POST_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.postVideo
      };
    },
    POST_VIDEO_ERROR: function POST_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_FINITE_LOADING: function POST_FINITE_LOADING() {
      return {
        isLoading: true,
        postFinite: action.postFinite
      };
    },
    POST_FINITE_LOADED: function POST_FINITE_LOADED() {
      return {
        isLoading: false,
        data: action.postFinite
      };
    },
    POST_FINITE_ERROR: function POST_FINITE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postFinite.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADING: function POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADING() {
      return {
        isLoading: true,
        postAfterbodyRecircModule: action.postAfterbodyRecircModule
      };
    },
    POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADED: function POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADED() {
      return {
        isLoading: false,
        data: action.postAfterbodyRecircModule
      };
    },
    POST_AFTERBODY_RECIRC_MODULE_TYPE_ERROR: function POST_AFTERBODY_RECIRC_MODULE_TYPE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postAfterbodyRecircModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    POST_MORE_STORIES_LOADING: function POST_MORE_STORIES_LOADING() {
      return {
        isLoading: true,
        postMoreStories: action.postMoreStories
      };
    },
    POST_MORE_STORIES_LOADED: function POST_MORE_STORIES_LOADED() {
      return {
        isLoading: false,
        data: action.postMoreStories
      };
    },
    POST_MORE_STORIES_ERROR: function POST_MORE_STORIES_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postMoreStories.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    VIDEO_PAGE_LOADING: function VIDEO_PAGE_LOADING() {
      return {
        isLoading: true,
        videoPage: action.videoPage
      };
    },
    VIDEO_PAGE_LOADED: function VIDEO_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var videoPageData = (0, _get2.default)(currentState, 'jwVideo');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, videoPageData, 'videoPage');

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.videoPage,
        ads: adModelData
      };
    },
    VIDEO_PAGE_ERROR: function VIDEO_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.videoPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    VIDEO_INDEX_PAGE_LOADING: function VIDEO_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        videoIndexPage: action.videoIndexPage
      };
    },
    VIDEO_INDEX_PAGE_LOADED: function VIDEO_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, {}, 'videoIndexPage');

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.videoIndexPage,
        ads: adModelData
      };
    },
    VIDEO_INDEX_PAGE_ERROR: function VIDEO_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.videoIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_VIDEO_LOADING: function JW_VIDEO_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_VIDEO_LOADED: function JW_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.jwVideo
      };
    },
    JW_VIDEO_ERROR: function JW_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_RELATED_VIDEO_LOADING: function JW_RELATED_VIDEO_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_RELATED_VIDEO_LOADED: function JW_RELATED_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.jwRelatedVideo
      };
    },
    JW_RELATED_VIDEO_ERROR: function JW_RELATED_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwRelatedVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_NEWEST_VIDEO_LOADING: function JW_NEWEST_VIDEO_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_NEWEST_VIDEO_LOADED: function JW_NEWEST_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.jwNewestVideo
      };
    },
    JW_NEWEST_VIDEO_ERROR: function JW_NEWEST_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwNewestVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_PLAYLIST_LOADING: function JW_PLAYLIST_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_PLAYLIST_LOADED: function JW_PLAYLIST_LOADED() {
      return {
        isLoading: false,
        data: action.jwPlaylist
      };
    },
    JW_PLAYLIST_ERROR: function JW_PLAYLIST_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwPlaylist.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    JW_PLAYLIST_INDEX_LOADING: function JW_PLAYLIST_INDEX_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_PLAYLIST_INDEX_LOADED: function JW_PLAYLIST_INDEX_LOADED() {
      return {
        isLoading: false,
        data: action.jwPlaylistIndex
      };
    },
    JW_PLAYLIST_INDEX_ERROR: function JW_PLAYLIST_INDEX_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwPlaylistIndex.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PLAYLIST_INDEX_PAGE_LOADING: function PLAYLIST_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        playlistIndexPage: action.playlistIndexPage
      };
    },
    PLAYLIST_INDEX_PAGE_LOADED: function PLAYLIST_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'playlist-index');

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.playlistIndexPage,
        ads: adModelData
      };
    },
    PLAYLIST_INDEX_PAGE_ERROR: function PLAYLIST_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.playlistIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PLAYLIST_PAGE_LOADING: function PLAYLIST_PAGE_LOADING() {
      return {
        isLoading: true,
        playlistPage: action.playlistPage
      };
    },
    PLAYLIST_PAGE_LOADED: function PLAYLIST_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'playlist', 'categoryPage');

      // Override this for MCP
      // adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    PLAYLIST_PAGE_ERROR: function PLAYLIST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.playlistPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    CATEGORY_PAGE_LOADING: function CATEGORY_PAGE_LOADING() {
      return {
        isLoading: true,
        categoryPage: action.categoryPage
      };
    },
    CATEGORY_PAGE_LOADED: function CATEGORY_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var category = (0, _get2.default)(currentState, 'categoryFeaturedFeed.category.slug');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, category, 'categoryPage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    CATEGORY_PAGE_ERROR: function CATEGORY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_FEATURED_FEED_LOADING: function CATEGORY_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        categoryFeaturedFeed: action.categoryFeaturedFeed
      };
    },
    CATEGORY_FEATURED_FEED_LOADED: function CATEGORY_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        featured: (0, _get2.default)(action, 'categoryFeaturedFeed.featured'),
        top: (0, _get2.default)(action, 'categoryFeaturedFeed.top'),
        category: (0, _get2.default)(action, 'categoryFeaturedFeed.category'),
        source: (0, _get2.default)(action, 'categoryFeaturedFeed.source')
      };
    },
    CATEGORY_FEATURED_FEED_ERROR: function CATEGORY_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryFeaturedFeed.errorMessage,
        featured: [],
        category: {},
        top: []
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_VIDEO_LOADING: function CATEGORY_VIDEO_LOADING() {
      return {
        isLoading: true,
        categoryVideo: action.categoryVideo
      };
    },
    CATEGORY_VIDEO_LOADED: function CATEGORY_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.categoryVideo
      };
    },
    CATEGORY_VIDEO_ERROR: function CATEGORY_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_ALL_FEED_LOADING: function CATEGORY_ALL_FEED_LOADING() {
      return {
        isLoading: true,
        categoryAllFeed: action.categoryAllFeed,
        allRendered: false
      };
    },
    CATEGORY_ALL_FEED_LOADED: function CATEGORY_ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.categoryAllFeed,
        allRendered: false
      };
    },
    CATEGORY_ALL_FEED_ERROR: function CATEGORY_ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryAllFeed.errorMessage
      };
    },
    CATEGORY_ALL_FEED_ALL_STORIES_RENDERED: function CATEGORY_ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: false,
        data: state.data,
        allRendered: true
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_SCROLLING_MODULE_LOADING: function CATEGORY_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        categoryScrollingModule: action.categoryScrollingModule
      };
    },
    CATEGORY_SCROLLING_MODULE_LOADED: function CATEGORY_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.categoryScrollingModule
      };
    },
    CATEGORY_SCROLLING_MODULE_ERROR: function CATEGORY_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CATEGORY_PROMO_BANNER_LOADING: function CATEGORY_PROMO_BANNER_LOADING() {
      return {
        isLoading: true,
        categoryPromoBanner: action.categoryPromoBanner
      };
    },
    CATEGORY_PROMO_BANNER_LOADED: function CATEGORY_PROMO_BANNER_LOADED() {
      return {
        isLoading: false,
        data: action.categoryPromoBanner
      };
    },
    CATEGORY_PROMO_BANNER_ERROR: function CATEGORY_PROMO_BANNER_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryPromoBanner.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    TAG_PAGE_LOADING: function TAG_PAGE_LOADING() {
      return {
        isLoading: true,
        tagPage: action.tagPage
      };
    },
    TAG_PAGE_LOADED: function TAG_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var tag = (0, _get2.default)(currentState, 'tagFeaturedFeed.tag');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, tag, 'tagPage');
      return {
        isLoading: false,
        data: {},
        ads: adModelData
      };
    },
    TAG_PAGE_ERROR: function TAG_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_FEATURED_FEED_LOADING: function TAG_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        tagFeaturedFeed: action.tagFeaturedFeed
      };
    },
    TAG_FEATURED_FEED_LOADED: function TAG_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        featured: (0, _get2.default)(action, 'tagFeaturedFeed.featured'),
        top: (0, _get2.default)(action, 'tagFeaturedFeed.top'),
        tag: (0, _get2.default)(action, 'tagFeaturedFeed.tag'),
        source: (0, _get2.default)(action, 'tagFeaturedFeed.source')
      };
    },
    TAG_FEATURED_FEED_ERROR: function TAG_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagFeaturedFeed.errorMessage,
        featured: [],
        tag: {},
        top: []
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_VIDEO_LOADING: function TAG_VIDEO_LOADING() {
      return {
        isLoading: true,
        tagVideo: action.tagVideo
      };
    },
    TAG_VIDEO_LOADED: function TAG_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.tagVideo
      };
    },
    TAG_VIDEO_ERROR: function TAG_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_ALL_FEED_LOADING: function TAG_ALL_FEED_LOADING() {
      return {
        isLoading: true,
        tagAllFeed: action.tagAllFeed,
        allRendered: false
      };
    },
    TAG_ALL_FEED_LOADED: function TAG_ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.tagAllFeed,
        allRendered: false
      };
    },
    TAG_ALL_FEED_ERROR: function TAG_ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagAllFeed.errorMessage
      };
    },
    TAG_ALL_FEED_ALL_STORIES_RENDERED: function TAG_ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: false,
        data: state.data,
        allRendered: true
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_SCROLLING_MODULE_LOADING: function TAG_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        tagScrollingModule: action.tagScrollingModule
      };
    },
    TAG_SCROLLING_MODULE_LOADED: function TAG_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.tagScrollingModule
      };
    },
    TAG_SCROLLING_MODULE_ERROR: function TAG_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    TAG_PROMO_BANNER_LOADING: function TAG_PROMO_BANNER_LOADING() {
      return {
        isLoading: true,
        tagPromoBanner: action.tagPromoBanner
      };
    },
    TAG_PROMO_BANNER_LOADED: function TAG_PROMO_BANNER_LOADED() {
      return {
        isLoading: false,
        data: action.tagPromoBanner
      };
    },
    TAG_PROMO_BANNER_ERROR: function TAG_PROMO_BANNER_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagPromoBanner.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MAGAZINE_ARCHIVE_PAGE_LOADING: function MAGAZINE_ARCHIVE_PAGE_LOADING() {
      return {
        isLoading: true,
        magazineArchivePage: action.magazineArchivePage
      };
    },
    MAGAZINE_ARCHIVE_PAGE_LOADED: function MAGAZINE_ARCHIVE_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var tag = (0, _get2.default)(currentState, 'tagFeaturedFeed.tag');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, tag, 'magazineArchivePage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    MAGAZINE_ARCHIVE_PAGE_ERROR: function MAGAZINE_ARCHIVE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineArchivePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MAGAZINE_ARCHIVE_LOADING: function MAGAZINE_ARCHIVE_LOADING() {
      return {
        isLoading: true,
        magazineArchive: action.magazineArchive
      };
    },
    MAGAZINE_ARCHIVE_LOADED: function MAGAZINE_ARCHIVE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'magazineArchive');

      return {
        isLoading: false,
        data: action.magazineArchive,
        ads: adModelData
      };
    },
    MAGAZINE_ARCHIVE_ERROR: function MAGAZINE_ARCHIVE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineArchive.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  // const { store } = action;
  var typeMap = {
    MAGAZINE_ISSUE_POSTS_LOADING: function MAGAZINE_ISSUE_POSTS_LOADING() {
      return {
        isLoading: true,
        magazineIssuePosts: action.magazineIssuePosts
      };
    },
    MAGAZINE_ISSUE_POSTS_LOADED: function MAGAZINE_ISSUE_POSTS_LOADED() {
      return {
        isLoading: false,
        data: action.magazineIssuePosts
      };
    },
    MAGAZINE_ISSUE_POSTS_ERROR: function MAGAZINE_ISSUE_POSTS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineIssuePosts.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  // const { store } = action;
  var typeMap = {
    MAGAZINE_LATEST_ISSUE_POSTS_LOADING: function MAGAZINE_LATEST_ISSUE_POSTS_LOADING() {
      return {
        isLoading: true,
        magazineLatestIssuePosts: action.magazineLatestIssuePosts
      };
    },
    MAGAZINE_LATEST_ISSUE_POSTS_LOADED: function MAGAZINE_LATEST_ISSUE_POSTS_LOADED() {
      return {
        isLoading: false,
        data: action.magazineLatestIssuePosts
      };
    },
    MAGAZINE_LATEST_ISSUE_POSTS_ERROR: function MAGAZINE_LATEST_ISSUE_POSTS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineLatestIssuePosts.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PERSON_PAGE_LOADING: function PERSON_PAGE_LOADING() {
      return {
        isLoading: true,
        personPage: action.personPage
      };
    },
    PERSON_PAGE_LOADED: function PERSON_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.personPage,
        ads: adModelData
      };
    },
    PERSON_PAGE_ERROR: function PERSON_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PERSON_LOADING: function PERSON_LOADING() {
      return {
        isLoading: true
      };
    },
    PERSON_LOADED: function PERSON_LOADED() {
      return {
        isLoading: false,
        data: action.person
      };
    },
    PERSON_ERROR: function PERSON_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.person.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PERSON_INDEX_PAGE_LOADING: function PERSON_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        personIndexPage: action.personIndexPage
      };
    },
    PERSON_INDEX_PAGE_LOADED: function PERSON_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.personIndexPage,
        ads: adModelData
      };
    },
    PERSON_INDEX_PAGE_ERROR: function PERSON_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PRODUCT_PAGE_LOADING: function PRODUCT_PAGE_LOADING() {
      return {
        isLoading: true,
        productPage: action.productPage
      };
    },
    PRODUCT_PAGE_LOADED: function PRODUCT_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'product', 'productPage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    PRODUCT_PAGE_ERROR: function PRODUCT_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PRODUCT_LOADING: function PRODUCT_LOADING() {
      return {
        isLoading: true
      };
    },
    PRODUCT_LOADED: function PRODUCT_LOADED() {
      return {
        isLoading: false,
        data: action.product
      };
    },
    PRODUCT_ERROR: function PRODUCT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.product.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PRODUCT_INDEX_PAGE_LOADING: function PRODUCT_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        productIndexPage: action.productIndexPage
      };
    },
    PRODUCT_INDEX_PAGE_LOADED: function PRODUCT_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'product', 'productPage');

      return {
        isLoading: false,
        data: action.productIndexPage,
        ads: adModelData
      };
    },
    PRODUCT_INDEX_PAGE_ERROR: function PRODUCT_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    INNOVATION_BY_DESIGN_PAGE_LOADING: function INNOVATION_BY_DESIGN_PAGE_LOADING() {
      return {
        isLoading: true,
        innovationByDesignPage: action.innovationByDesignPage
      };
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED: function INNOVATION_BY_DESIGN_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'innovation-by-design', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'innovation/innovation-by-design';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    INNOVATION_BY_DESIGN_PAGE_ERROR: function INNOVATION_BY_DESIGN_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    INNOVATION_BY_DESIGN_LOADING: function INNOVATION_BY_DESIGN_LOADING() {
      return {
        isLoading: true
      };
    },
    INNOVATION_BY_DESIGN_LOADED: function INNOVATION_BY_DESIGN_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesign,
        year: action.year
      };
    },
    INNOVATION_BY_DESIGN_ERROR: function INNOVATION_BY_DESIGN_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesign.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    INNOVATION_BY_DESIGN_DETAIL_LOADING: function INNOVATION_BY_DESIGN_DETAIL_LOADING() {
      return {
        isLoading: true
      };
    },
    INNOVATION_BY_DESIGN_DETAIL_LOADED: function INNOVATION_BY_DESIGN_DETAIL_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignDetail,
        year: action.year
      };
    },
    INNOVATION_BY_DESIGN_DETAIL_ERROR: function INNOVATION_BY_DESIGN_DETAIL_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesign.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    INNOVATION_BY_DESIGN_FEATURED_FEED_LOADING: function INNOVATION_BY_DESIGN_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        innovationByDesignFeaturedFeed: action.innovationByDesignFeaturedFeed
      };
    },
    INNOVATION_BY_DESIGN_FEATURED_FEED_LOADED: function INNOVATION_BY_DESIGN_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignFeaturedFeed
      };
    },
    INNOVATION_BY_DESIGN_FEATURED_FEED_ERROR: function INNOVATION_BY_DESIGN_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignFeaturedFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADING: function INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        innovationByDesignScrollingModule: action.innovationByDesignScrollingModule
      };
    },
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADED: function INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignScrollingModule
      };
    },
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_ERROR: function INNOVATION_BY_DESIGN_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    GIFT_GUIDE_PAGE_LOADING: function GIFT_GUIDE_PAGE_LOADING() {
      return {
        isLoading: true,
        giftGuidePage: action.giftGuidePage
      };
    },
    GIFT_GUIDE_PAGE_LOADED: function GIFT_GUIDE_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'gift-guide', 'categoryPage');

      adModelData.model.adzone = 'gift-guide/gift-guide';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    GIFT_GUIDE_PAGE_ERROR: function GIFT_GUIDE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftGuidePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    GIFT_GUIDE_LOADING: function GIFT_GUIDE_LOADING() {
      return {
        isLoading: true
      };
    },
    GIFT_GUIDE_LOADED: function GIFT_GUIDE_LOADED() {
      return {
        isLoading: false,
        data: action.giftGuide,
        year: action.year
      };
    },
    GIFT_GUIDE_ERROR: function GIFT_GUIDE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftGuide.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    GIFT_GUIDE_DETAIL_LOADING: function GIFT_GUIDE_DETAIL_LOADING() {
      return {
        isLoading: true
      };
    },
    GIFT_GUIDE_DETAIL_LOADED: function GIFT_GUIDE_DETAIL_LOADED() {
      return {
        isLoading: false,
        data: action.giftGuideDetail,
        year: action.year
      };
    },
    GIFT_GUIDE_DETAIL_ERROR: function GIFT_GUIDE_DETAIL_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftGuide.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    GIFT_PAGE_LOADING: function GIFT_PAGE_LOADING() {
      return {
        isLoading: true,
        giftPage: action.giftPage
      };
    },
    GIFT_PAGE_LOADED: function GIFT_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'gift', 'giftPage');

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    GIFT_PAGE_ERROR: function GIFT_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    GIFT_LOADING: function GIFT_LOADING() {
      return {
        isLoading: true
      };
    },
    GIFT_LOADED: function GIFT_LOADED() {
      return {
        isLoading: false,
        data: action.gift
      };
    },
    GIFT_ERROR: function GIFT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.gift.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PERSON_INDEX_SECTION_PAGE_LOADING: function PERSON_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        personIndexSectionPage: action.personIndexSectionPage
      };
    },
    PERSON_INDEX_SECTION_PAGE_LOADED: function PERSON_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.personIndexSectionPage,
        ads: adModelData
      };
    },
    PERSON_INDEX_SECTION_PAGE_ERROR: function PERSON_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PERSON_INDEX_SECTION_LOADING: function PERSON_INDEX_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    PERSON_INDEX_SECTION_LOADED: function PERSON_INDEX_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.personIndexSection
      };
    },
    PERSON_INDEX_SECTION_ERROR: function PERSON_INDEX_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexSection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PERSON_INDEX_SECTION_NEXT_LOADING: function PERSON_INDEX_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    PERSON_INDEX_SECTION_NEXT_LOADED: function PERSON_INDEX_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.personIndexSectionNext
      };
    },
    PERSON_INDEX_SECTION_NEXT_ERROR: function PERSON_INDEX_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.personIndexSectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    PRODUCT_INDEX_SECTION_PAGE_LOADING: function PRODUCT_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        productIndexSectionPage: action.productIndexSectionPage
      };
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED: function PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'innovationbydesign', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'innovation/innovationbydesign';
      return {
        isLoading: false,
        data: action.productIndexSectionPage,
        ads: adModelData
      };
    },
    PRODUCT_INDEX_SECTION_PAGE_ERROR: function PRODUCT_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PRODUCT_INDEX_SECTION_LOADING: function PRODUCT_INDEX_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    PRODUCT_INDEX_SECTION_LOADED: function PRODUCT_INDEX_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.productIndexSection
      };
    },
    PRODUCT_INDEX_SECTION_ERROR: function PRODUCT_INDEX_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    PRODUCT_INDEX_SECTION_NEXT_LOADING: function PRODUCT_INDEX_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    PRODUCT_INDEX_SECTION_NEXT_LOADED: function PRODUCT_INDEX_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.productIndexSectionNext
      };
    },
    PRODUCT_INDEX_SECTION_NEXT_ERROR: function PRODUCT_INDEX_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MOST_CREATIVE_PEOPLE_PAGE_LOADING: function MOST_CREATIVE_PEOPLE_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeoplePage: action.mostCreativePeoplePage
      };
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    MOST_CREATIVE_PEOPLE_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeoplePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_LOADING: function MOST_CREATIVE_PEOPLE_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_LOADED: function MOST_CREATIVE_PEOPLE_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeople,
        year: action.year
      };
    },
    MOST_CREATIVE_PEOPLE_ERROR: function MOST_CREATIVE_PEOPLE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeople.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADING: function MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleFeaturedFeed: action.mostCreativePeopleFeaturedFeed
      };
    },
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADED: function MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleFeaturedFeed
      };
    },
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_ERROR: function MOST_CREATIVE_PEOPLE_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleFeaturedFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADING: function MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleScrollingModule: action.mostCreativePeopleScrollingModule
      };
    },
    MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADED: function MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleScrollingModule
      };
    },
    MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_ERROR: function MOST_CREATIVE_PEOPLE_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADING: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleCommunityPage: action.mostCreativePeopleCommunityPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunityPage,
        ads: adModelData
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunityPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADING: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleCommunitySectionPage: action.mostCreativePeopleCommunitySectionPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-creative-people', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySectionPage,
        ads: adModelData
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADING: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySection
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADING: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySectionNext
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    COMPANY_PAGE_LOADING: function COMPANY_PAGE_LOADING() {
      return {
        isLoading: true,
        companyPage: action.companyPage
      };
    },
    COMPANY_PAGE_LOADED: function COMPANY_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for Company page
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.companyPage,
        ads: adModelData
      };
    },
    COMPANY_PAGE_ERROR: function COMPANY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_LOADING: function COMPANY_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_LOADED: function COMPANY_LOADED() {
      return {
        isLoading: false,
        data: action.company
      };
    },
    COMPANY_ERROR: function COMPANY_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.company.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_DATA_LOADING: function COMPANY_DATA_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_DATA_LOADED: function COMPANY_DATA_LOADED() {
      return {
        isLoading: false,
        data: action.companyData
      };
    },
    COMPANY_DATA_ERROR: function COMPANY_DATA_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyData.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_AWARDS_LOADING: function COMPANY_AWARDS_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_AWARDS_LOADED: function COMPANY_AWARDS_LOADED() {
      return {
        isLoading: false,
        data: action.companyAwards
      };
    },
    COMPANY_AWARDS_ERROR: function COMPANY_AWARDS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyAwards.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_INDEX_GROUPS_LOADING: function COMPANY_INDEX_GROUPS_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_INDEX_GROUPS_LOADED: function COMPANY_INDEX_GROUPS_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexGroups
      };
    },
    COMPANY_INDEX_GROUPS_ERROR: function COMPANY_INDEX_GROUPS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexGroups.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    COMPANY_INDEX_SECTION_PAGE_LOADING: function COMPANY_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        companyIndexSectionPage: action.companyIndexSectionPage
      };
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED: function COMPANY_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-creative-people';
      return {
        isLoading: false,
        data: action.companyIndexSectionPage,
        ads: adModelData
      };
    },
    COMPANY_INDEX_SECTION_PAGE_ERROR: function COMPANY_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_INDEX_SECTION_LOADING: function COMPANY_INDEX_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_INDEX_SECTION_LOADED: function COMPANY_INDEX_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexSection
      };
    },
    COMPANY_INDEX_SECTION_ERROR: function COMPANY_INDEX_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexSection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    COMPANY_INDEX_SECTION_NEXT_LOADING: function COMPANY_INDEX_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_INDEX_SECTION_NEXT_LOADED: function COMPANY_INDEX_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexSectionNext
      };
    },
    COMPANY_INDEX_SECTION_NEXT_ERROR: function COMPANY_INDEX_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexSectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    COMPANY_INDEX_PAGE_LOADING: function COMPANY_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        companyIndexPage: action.companyIndexPage
      };
    },
    COMPANY_INDEX_PAGE_LOADED: function COMPANY_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.companyIndexPage,
        ads: adModelData
      };
    },
    COMPANY_INDEX_PAGE_ERROR: function COMPANY_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MIC_YEAR_PAGE_LOADING: function MIC_YEAR_PAGE_LOADING() {
      return {
        isLoading: true,
        micYearPage: action.micYearPage
      };
    },
    MIC_YEAR_PAGE_LOADED: function MIC_YEAR_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastmic';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.micYearPage,
        ads: adModelData
      };
    },
    MIC_YEAR_PAGE_ERROR: function MIC_YEAR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYearPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    MIC_SECTOR_PAGE_LOADING: function MIC_SECTOR_PAGE_LOADING() {
      return {
        isLoading: true,
        micYearPage: action.micSectorPage
      };
    },
    MIC_SECTOR_PAGE_LOADED: function MIC_SECTOR_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastmic';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'most-innovative-companies', 'categoryPage');

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.micSectorPage,
        ads: adModelData
      };
    },
    MIC_SECTOR_PAGE_ERROR: function MIC_SECTOR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micSectorPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MIC_YEAR_LOADING: function MIC_YEAR_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_YEAR_LOADED: function MIC_YEAR_LOADED() {
      return {
        isLoading: false,
        data: action.micYear,
        year: action.year
      };
    },
    MIC_YEAR_ERROR: function MIC_YEAR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYear.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MIC_YEAR_DESCRIPTION_LOADING: function MIC_YEAR_DESCRIPTION_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_YEAR_DESCRIPTION_LOADED: function MIC_YEAR_DESCRIPTION_LOADED() {
      return {
        isLoading: false,
        data: action.micYearDescription
      };
    },
    MIC_YEAR_DESCRIPTION_ERROR: function MIC_YEAR_DESCRIPTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYearDescription.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    MIC_SECTOR_LOADING: function MIC_SECTOR_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_SECTOR_LOADED: function MIC_SECTOR_LOADED() {
      return {
        isLoading: false,
        data: action.micSector,
        year: action.year,
        sector: action.sector
      };
    },
    MIC_SECTOR_ERROR: function MIC_SECTOR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micSector.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    AUTHOR_PAGE_LOADING: function AUTHOR_PAGE_LOADING() {
      return {
        isLoading: true,
        authorPage: action.authorPage
      };
    },
    AUTHOR_PAGE_LOADED: function AUTHOR_PAGE_LOADED() {
      var currentState = store.getState();
      var authorData = (0, _get2.default)(currentState, 'author.data');
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, authorData, 'authorPage');

      return {
        isLoading: false,
        data: action.authorPage,
        ads: adModelData
      };
    },
    AUTHOR_PAGE_ERROR: function AUTHOR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.authorPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    AUTHOR_LOADING: function AUTHOR_LOADING() {
      return {
        isLoading: true,
        author: action.author
      };
    },
    AUTHOR_LOADED: function AUTHOR_LOADED() {
      return {
        isLoading: false,
        data: (0, _get2.default)(action, 'author')
      };
    },
    AUTHOR_ERROR: function AUTHOR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: (0, _get2.default)(action, 'author.errorMessage')
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    AUTHOR_ALL_FEED_LOADING: function AUTHOR_ALL_FEED_LOADING() {
      return {
        isLoading: true,
        authorAllFeed: action.authorAllFeed,
        allRendered: false
      };
    },
    AUTHOR_ALL_FEED_LOADED: function AUTHOR_ALL_FEED_LOADED() {
      return {
        isLoading: false,
        data: (0, _get2.default)(action, 'authorAllFeed', {}),
        allRendered: false
      };
    },
    AUTHOR_ALL_FEED_ERROR: function AUTHOR_ALL_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: (0, _get2.default)(action, 'authorAllFeed.errorMessage')
      };
    },
    AUTHOR_ALL_FEED_IS_LOADING: function AUTHOR_ALL_FEED_IS_LOADING() {
      return (0, _extend2.default)({}, state, { isEnabled: true, isLoading: true });
    },
    AUTHOR_ALL_FEED_IS_LOADED: function AUTHOR_ALL_FEED_IS_LOADED() {
      return {
        isEnabled: true,
        isLoading: false,
        data: (0, _extend2.default)({}, state.data, {
          page: (0, _get2.default)(action, 'authorAllFeed.page'),
          posts: [].concat(_toConsumableArray(state.data.posts), _toConsumableArray((0, _get2.default)(action, 'authorAllFeed.posts', [])))
        }),
        allRendered: false
      };
    },
    AUTHOR_ALL_FEED_IS_ERROR: function AUTHOR_ALL_FEED_IS_ERROR() {
      return {
        isEnabled: true,
        isLoading: true,
        data: (0, _extend2.default)({}, state, {
          page: (0, _get2.default)(action, 'authorAllFeed.page'),
          posts: [].concat(_toConsumableArray(state.data.posts), _toConsumableArray((0, _get2.default)(action, 'authorAllFeed.posts', [])))
        }),
        allRendered: false
      };
    },
    AUTHOR_ALL_FEED_ALL_STORIES_RENDERED: function AUTHOR_ALL_FEED_ALL_STORIES_RENDERED() {
      return {
        isLoading: true,
        data: state.data,
        allRendered: true
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    SEARCH_LOADING: function SEARCH_LOADING() {
      return {
        isLoading: true
      };
    },
    SEARCH_LOADED: function SEARCH_LOADED() {
      return {
        isLoading: false,
        data: action.search
      };
    },
    SEARCH_ERROR: function SEARCH_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.search.errorMessage,
        queryString: action.search.query
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    SEARCH_PAGE_LOADING: function SEARCH_PAGE_LOADING() {
      return {
        isLoading: true,
        searchPage: action.searchPage
      };
    },
    SEARCH_PAGE_LOADED: function SEARCH_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var searchQuery = (0, _get2.default)(currentState, 'search.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, searchQuery, 'searchPage');

      return {
        isLoading: false,
        data: action.searchPage,
        ads: adModelData
      };
    },
    SEARCH_PAGE_ERROR: function SEARCH_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.searchPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    WP_PAGE_LOADING: function WP_PAGE_LOADING() {
      return {
        isLoading: true,
        wpPage: action.wpPage
      };
    },
    WP_PAGE_LOADED: function WP_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, 'page', 'wpPage');

      return {
        isLoading: false,
        data: action.wpPage,
        ads: adModelData
      };
    },
    WP_PAGE_ERROR: function WP_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.wpPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    STATIC_PAGE_LOADING: function STATIC_PAGE_LOADING() {
      return {
        isLoading: true,
        staticPage: action.staticPage
      };
    },
    STATIC_PAGE_LOADED: function STATIC_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.staticPage
      };
    },
    STATIC_PAGE_ERROR: function STATIC_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.staticPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    NEWSLETTERS_PREFERENCES_PAGE_LOADING: function NEWSLETTERS_PREFERENCES_PAGE_LOADING() {
      return {
        isLoading: true,
        newslettersPreferencesPage: action.newslettersPreferencesPage
      };
    },
    NEWSLETTERS_PREFERENCES_PAGE_LOADED: function NEWSLETTERS_PREFERENCES_PAGE_LOADED() {
      var baseNewsletterLookup = action.store.getState().config.newsletters.listsById;
      var allNewsletterIds = action.store.getState().config.newsletters.allIds;
      var allNewsletters = allNewsletterIds.map(function (key) {
        var found = baseNewsletterLookup[key];

        return (0, _assign3.default)({}, found, {
          listId: key
        });
      });

      return {
        isLoading: false,
        data: action.newslettersPreferencesPage,
        subscribe: [],
        unsubscribe: [],
        emailEditable: false,
        allNewsletterIds: allNewsletterIds,
        allNewsletters: allNewsletters,
        masterLookup: baseNewsletterLookup,
        allNewslettersSelected: _assign3.default.apply(undefined, _toConsumableArray(allNewsletterIds.map(function (id) {
          return _defineProperty({}, id, action.newslettersPreferencesPage.lists.indexOf(Number(id)) !== -1);
        })))
      };
    },
    NEWSLETTERS_PREFERENCES_PAGE_ERROR: function NEWSLETTERS_PREFERENCES_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.newslettersPreferencesPage.errorMessage
      };
    },
    CHANGE_NEWSLETTER_PREFERENCES_RADIO: function CHANGE_NEWSLETTER_PREFERENCES_RADIO() {
      var newNewsletterId = action.data.selectedListId;
      var radioSet = action.data.radioSet;

      var toUnsubscribe = radioSet.filter(function (id) {
        return id !== newNewsletterId;
      });

      var subscribeLists = determineSubscribeForRadio(newNewsletterId, toUnsubscribe, state.subscribe, state.unsubscribe);

      var newSelectionState = _defineProperty({}, newNewsletterId, true);

      toUnsubscribe.forEach(function (id) {
        newSelectionState[id] = false;
      });

      return (0, _assign3.default)({}, state, {
        allNewslettersSelected: (0, _assign3.default)({}, state.allNewslettersSelected, newSelectionState)
      }, subscribeLists);
    },
    CHANGE_NEWSLETTER_PREFERENCES: function CHANGE_NEWSLETTER_PREFERENCES() {
      var currentlySubscribedTo = state.data.lists;
      var newNewsletterId = action.data.id;
      var currentSelectionState = state.allNewslettersSelected;
      var subscribeLists = determineSubscribe(currentlySubscribedTo, newNewsletterId, currentSelectionState, state.subscribe, state.unsubscribe);
      return (0, _assign3.default)({}, state, {
        allNewslettersSelected: (0, _assign3.default)({}, state.allNewslettersSelected, _defineProperty({}, newNewsletterId, !currentSelectionState[newNewsletterId]))
      }, subscribeLists);
    },
    UPDATE_NEWSLETTER_PREFERENCES_SUCCESS: function UPDATE_NEWSLETTER_PREFERENCES_SUCCESS() {
      return (0, _assign3.default)({}, state, {
        isLoading: false,
        unsubscribe: [],
        subscribe: [],
        subscriptionUpdateSuccessMessage: 'Your subscriptions have been updated!',
        data: (0, _assign3.default)({}, state.data, {
          lists: pruneLists(state.data.lists, state.subscribe, state.unsubscribe)
        })
      });
    },
    PREPARE_EMAIL_FIELD_FOR_CHANGE: function PREPARE_EMAIL_FIELD_FOR_CHANGE() {
      return (0, _assign3.default)({}, state, {
        emailEditable: !state.emailEditable
      });
    },
    UPDATE_SUBSCRIPTION_EMAIL_SUCCESS: function UPDATE_SUBSCRIPTION_EMAIL_SUCCESS() {
      return (0, _assign3.default)({}, state, {
        emailEditable: false,
        data: Object.assign({}, state.data, { email: action.data.email }),
        emailUpdateSuccessMessage: 'Email change sucessful!'
      });
    },
    UPDATE_SUBSCRIPTION_EMAIL_ERROR: function UPDATE_SUBSCRIPTION_EMAIL_ERROR() {
      return (0, _assign3.default)({}, state, {
        emailUpdateMessageError: (0, _get2.default)(action, 'data', '')
      });
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _assign2 = __webpack_require__(31);

var _assign3 = _interopRequireDefault(_assign2);

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';


function determineSubscribe(currentlySubscribedTo, id, nlState, toSubscribe, toUnsubscribe) {
  var currVal = nlState[id]; // true or false
  var isAlreadySubscribed = currentlySubscribedTo.indexOf(id) !== -1;
  var updatedUnsubscribed = toUnsubscribe.slice(0);
  var updatedToSubscribe = toSubscribe.slice(0);

  if (isAlreadySubscribed && currVal) {
    // add id to unsubscribe list
    updatedUnsubscribed.push(id);
  }

  if (isAlreadySubscribed && !currVal) {
    // remove id from unsubscribe list
    updatedUnsubscribed.splice(updatedUnsubscribed.indexOf(id), 1);
  }

  if (!isAlreadySubscribed && currVal) {
    // remove id to subscribe list
    updatedToSubscribe.splice(updatedToSubscribe.indexOf(id), 1);
  }

  if (!isAlreadySubscribed && !currVal) {
    // add id to subscribe list
    updatedToSubscribe.push(id);
  }

  return { subscribe: updatedToSubscribe, unsubscribe: updatedUnsubscribed };
}

function determineSubscribeForRadio(idToSubscribe, idsToUnsubscribe, toSubscribe, toUnsubscribe) {
  var updatedToSubscribe = [].concat(_toConsumableArray(toSubscribe), [idToSubscribe]);
  var updatedUnsubscribed = [].concat(_toConsumableArray(toUnsubscribe), _toConsumableArray(idsToUnsubscribe));

  return { subscribe: updatedToSubscribe, unsubscribe: updatedUnsubscribed };
}

function pruneLists(previousState, subscribe, unsubscribe) {
  unsubscribe.forEach(function (listId) {
    previousState.splice(previousState.indexOf(listId), 1);
  });
  return previousState.concat(subscribe);
}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    CUSTOM_PAGE_LOADING: function CUSTOM_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    CUSTOM_PAGE_LOADED: function CUSTOM_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.customPage
      };
    },
    CUSTOM_PAGE_ERROR: function CUSTOM_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.customPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HTML_SITEMAP_INDEX_PAGE_LOADING: function HTML_SITEMAP_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        htmlSitemapIndexPage: action.htmlSitemapIndexPage
      };
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED: function HTML_SITEMAP_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var htmlSitemapIndexQuery = (0, _get2.default)(currentState, 'htmlSitemapIndex.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, htmlSitemapIndexQuery, 'htmlSitemapIndexPage');

      return {
        isLoading: false,
        data: action.htmlSitemapIndexPage,
        ads: adModelData
      };
    },
    HTML_SITEMAP_INDEX_PAGE_ERROR: function HTML_SITEMAP_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HTML_SITEMAP_INDEX_LOADING: function HTML_SITEMAP_INDEX_LOADING() {
      return {
        isLoading: true,
        htmlSitemapIndex: action.htmlSitemapIndex
      };
    },
    HTML_SITEMAP_INDEX_LOADED: function HTML_SITEMAP_INDEX_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var htmlSitemapIndexQuery = (0, _get2.default)(currentState, 'htmlSitemapIndex.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, htmlSitemapIndexQuery, 'htmlSitemapIndex');

      return {
        isLoading: false,
        data: action.htmlSitemapIndex,
        ads: adModelData
      };
    },
    HTML_SITEMAP_INDEX_ERROR: function HTML_SITEMAP_INDEX_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapIndex.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HTML_SITEMAP_POST_PAGE_LOADING: function HTML_SITEMAP_POST_PAGE_LOADING() {
      return {
        isLoading: true,
        htmlSitemapPostPage: action.htmlSitemapPostPage
      };
    },
    HTML_SITEMAP_POST_PAGE_LOADED: function HTML_SITEMAP_POST_PAGE_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var htmlSitemapPostQuery = (0, _get2.default)(currentState, 'htmlSitemapPost.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, htmlSitemapPostQuery, 'htmlSitemapPostPage');

      return {
        isLoading: false,
        data: action.htmlSitemapPostPage,
        ads: adModelData
      };
    },
    HTML_SITEMAP_POST_PAGE_ERROR: function HTML_SITEMAP_POST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapPostPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store;

  var typeMap = {
    HTML_SITEMAP_POST_LOADING: function HTML_SITEMAP_POST_LOADING() {
      return {
        isLoading: true,
        htmlSitemapPost: action.htmlSitemapPost
      };
    },
    HTML_SITEMAP_POST_LOADED: function HTML_SITEMAP_POST_LOADED() {
      var currentState = store.getState();
      var site = (0, _get2.default)(currentState, 'config.site') || 'fastcompany';
      var htmlSitemapPostQuery = (0, _get2.default)(currentState, 'htmlSitemapPost.data.query.queryString');
      var adModelData = (0, _ad_util.buildPostAdModel)(_ads2.default, site, htmlSitemapPostQuery, 'htmlSitemapPost');

      return {
        isLoading: false,
        data: action.htmlSitemapPost,
        ads: adModelData
      };
    },
    HTML_SITEMAP_POST_ERROR: function HTML_SITEMAP_POST_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapPost.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _ads = __webpack_require__(13);

var _ads2 = _interopRequireDefault(_ads);

var _ad_util = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    RECIRC_FEED_LOADING: function RECIRC_FEED_LOADING() {
      return {
        hide: false,
        isLoading: true,
        recircFeed: action.recircFeed
      };
    },
    RECIRC_FEED_LOADED: function RECIRC_FEED_LOADED() {
      return {
        hide: false,
        isLoading: false,
        data: action.recircFeed
      };
    },
    RECIRC_FEED_ERROR: function RECIRC_FEED_ERROR() {
      return {
        hide: false,
        isLoading: false,
        error: true,
        errorMessage: action.recircFeed.errorMessage
      };
    },
    HIDE_RECIRC_FEED: function HIDE_RECIRC_FEED() {
      return (0, _extend2.default)({}, state, {
        hide: true
      });
    }
  };

  if (/PAGE_LOADED/.test(action.type)) {
    return (0, _extend2.default)({}, state, {
      hide: false
    });
  }

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    HOMEPAGE_LOADED: function HOMEPAGE_LOADED(site) {
      return contextHelper('homepage', site);
    },
    HOMEPAGE_ERROR: function HOMEPAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    POSTPAGE_LOADED: function POSTPAGE_LOADED(site, currentState) {
      var postData = (0, _get2.default)(currentState, 'post.data.post');
      var id = (0, _get2.default)(postData, 'id');
      return contextHelper((0, _get2.default)(postData, 'type'), site, id, id + '/' + (0, _get2.default)(postData, 'slug'));
    },
    PREVIEW_POSTPAGE_LOADED: function PREVIEW_POSTPAGE_LOADED(site, currentState) {
      var postData = (0, _get2.default)(currentState, 'previewPost.data.post');
      var id = (0, _get2.default)(postData, 'id');
      return contextHelper((0, _get2.default)(postData, 'type'), site, id, 'pvw/' + id + '/' + (0, _get2.default)(postData, 'slug'));
    },
    POSTPAGE_ERROR: function POSTPAGE_ERROR(site, currentState) {
      var postData = (0, _get2.default)(currentState, 'post.data.post');
      var id = (0, _get2.default)(postData, 'id');
      return contextHelper('errorPage', site, id, id + '/' + (0, _get2.default)(postData, 'slug'));
    },
    CATEGORY_PAGE_LOADED: function CATEGORY_PAGE_LOADED(site) {
      return contextHelper('category', site);
    },
    CATEGORY_PAGE_ERROR: function CATEGORY_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    TAG_PAGE_LOADED: function TAG_PAGE_LOADED(site) {
      return contextHelper('tag', site);
    },
    TAG_PAGE_ERROR: function TAG_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    AUTHOR_PAGE_LOADED: function AUTHOR_PAGE_LOADED(site) {
      return contextHelper('author', site);
    },
    AUTHOR_PAGE_ERROR: function AUTHOR_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    SEARCH_PAGE_LOADED: function SEARCH_PAGE_LOADED(site) {
      return contextHelper('search', site);
    },
    SEARCH_PAGE_ERROR: function SEARCH_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    WP_PAGE_LOADED: function WP_PAGE_LOADED(site) {
      return contextHelper('page', site);
    },
    WP_PAGE_ERROR: function WP_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    CUSTOM_PAGE_LOADED: function CUSTOM_PAGE_LOADED(site) {
      return contextHelper('page', site);
    },
    CUSTOM_PAGE_ERROR: function CUSTOM_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED: function HTML_SITEMAP_INDEX_PAGE_LOADED(site) {
      return contextHelper('sitemapIndexPage', site);
    },
    HTML_SITEMAP_POST_PAGE_LOADED: function HTML_SITEMAP_POST_PAGE_LOADED(site) {
      return contextHelper('sitemapPostPage', site);
    },
    MAGAZINE_ARCHIVE_PAGE_LOADED: function MAGAZINE_ARCHIVE_PAGE_LOADED(site) {
      return contextHelper('magazineArchivePage', site);
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_PAGE_LOADED(site) {
      return contextHelper('mostCreativePeoplePage', site);
    },
    MOST_CREATIVE_PEOPLE_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED(site) {
      return contextHelper('mostCreativePeopleCommunityPage', site);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED(site) {
      return contextHelper('mostCreativePeopleCommunitySectionPage', site);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PERSON_INDEX_PAGE_LOADED: function PERSON_INDEX_PAGE_LOADED(site) {
      return contextHelper('personIndexPage', site);
    },
    PERSON_INDEX_PAGE_ERROR: function PERSON_INDEX_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PERSON_INDEX_SECTION_PAGE_LOADED: function PERSON_INDEX_SECTION_PAGE_LOADED(site) {
      return contextHelper('personIndexSectionPage', site);
    },
    PERSON_INDEX_SECTION_PAGE_ERROR: function PERSON_INDEX_SECTION_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PERSON_PAGE_LOADED: function PERSON_PAGE_LOADED(site) {
      return contextHelper('personPage', site);
    },
    PERSON_PAGE_ERROR: function PERSON_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PRODUCT_PAGE_LOADED: function PRODUCT_PAGE_LOADED(site) {
      return contextHelper('productPage', site);
    },
    PRODUCT_INDEX_PAGE_LOADED: function PRODUCT_INDEX_PAGE_LOADED(site) {
      return contextHelper('productIndexPage', site);
    },
    PRODUCT_INDEX_PAGE_ERROR: function PRODUCT_INDEX_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED: function PRODUCT_INDEX_SECTION_PAGE_LOADED(site) {
      return contextHelper('productIndexSectionPage', site);
    },
    PRODUCT_INDEX_SECTION_PAGE_ERROR: function PRODUCT_INDEX_SECTION_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    PRODUCT_PAGE_ERROR: function PRODUCT_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    STATIC_PAGE_LOADED: function STATIC_PAGE_LOADED(site) {
      return contextHelper('staticPage', site);
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED: function INNOVATION_BY_DESIGN_PAGE_LOADED(site) {
      return contextHelper('ibdPage', site);
    },
    GIFT_GUIDE_PAGE_LOADED: function GIFT_GUIDE_PAGE_LOADED(site) {
      return contextHelper('giftGuidePage', site);
    },
    COMPANY_PAGE_LOADED: function COMPANY_PAGE_LOADED(site) {
      return contextHelper('companyPage', site);
    },
    VIDEO_INDEX_PAGE_LOADED: function VIDEO_INDEX_PAGE_LOADED(site) {
      return contextHelper('videoIndexPage', site);
    },
    VIDEO_PAGE_LOADED: function VIDEO_PAGE_LOADED(site) {
      return contextHelper('videoPage', site);
    },
    VIDEO_PAGE_ERROR: function VIDEO_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    COMPANY_INDEX_PAGE_LOADED: function COMPANY_INDEX_PAGE_LOADED(site) {
      return contextHelper('companyIndexPage', site);
    },
    COMPANY_INDEX_PAGE_ERROR: function COMPANY_INDEX_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED: function COMPANY_INDEX_SECTION_PAGE_LOADED(site) {
      return contextHelper('companyIndexSectionPage', site);
    },
    COMPANY_INDEX_SECTION_PAGE_ERROR: function COMPANY_INDEX_SECTION_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    MIC_YEAR_PAGE_LOADED: function MIC_YEAR_PAGE_LOADED(site) {
      return contextHelper('micYearPage', site);
    },
    MIC_YEAR_PAGE_ERROR: function MIC_YEAR_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    MIC_SECTOR_PAGE_LOADED: function MIC_SECTOR_PAGE_LOADED(site) {
      return contextHelper('micSectorPage', site);
    },
    MIC_SECTOR_PAGE_ERROR: function MIC_SECTOR_PAGE_ERROR(site) {
      return contextHelper('errorPage', site);
    },
    NEWSLETTERS_PREFERENCES_PAGE_LOADED: function NEWSLETTERS_PREFERENCES_PAGE_LOADED(site) {
      return contextHelper('newslettersPreferencesPage', site);
    }
  };

  var store = action.store,
      type = action.type;


  if (typeMap[type]) {
    var currentState = store.getState();
    var site = (0, _get2.default)(currentState, 'config.site');
    return typeMap[action.type](site, currentState);
  }

  if (/PAGE_LOADED/.test(type)) {
    if (store && store.getState) {
      var _currentState = store.getState();
      var _site = (0, _get2.default)(_currentState, 'config.site');
      _logger_service2.default.error('CONTEXT REDUCER DID NOT HANDLE PAGE LOADED, ANALYTICS ARE BROKEN ON ' + type + '!!');
      return {
        type: 'unknown',
        site: _site
      };
    }
  }

  if (/PAGE_ERROR/.test(type)) {
    if (store && store.getState) {
      var _currentState2 = store.getState();
      var _site2 = (0, _get2.default)(_currentState2, 'config.site');
      _logger_service2.default.error('CONTEXT REDUCER DID NOT HANDLE PAGE ERROR, ANALYTICS ARE BROKEN ON ' + action.type + '!!');
      return contextHelper('errorPage', _site2);
    }
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _logger_service = __webpack_require__(1);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
function contextHelper(type, site, id, path) {
  if (!id && !path) {
    return {
      type: type,
      site: site
    };
  }
  return {
    type: type,
    site: site,
    id: id,
    path: path
  };
}

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store,
      type = action.type;


  var typeMap = {
    POSTPAGE_LOADED: function POSTPAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'post');
      return state;
    },
    POSTPAGE_ERROR: function POSTPAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    HOMEPAGE_LOADED: function HOMEPAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'homepage');
      return state;
    },
    HOMEPAGE_ERROR: function HOMEPAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    CATEGORY_PAGE_LOADED: function CATEGORY_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'category');
      return state;
    },
    CATEGORY_PAGE_ERROR: function CATEGORY_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    TAG_PAGE_LOADED: function TAG_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'tag');
      return state;
    },
    TAG_PAGE_ERROR: function TAG_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    SEARCH_PAGE_LOADED: function SEARCH_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'search');
      return state;
    },
    SEARCH_PAGE_ERROR: function SEARCH_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    AUTHOR_PAGE_LOADED: function AUTHOR_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'author');
      return state;
    },
    AUTHOR_PAGE_ERROR: function AUTHOR_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    WP_PAGE_LOADED: function WP_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'page');
      return state;
    },
    WP_PAGE_ERROR: function WP_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'errorPage');
      return state;
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED: function HTML_SITEMAP_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'htmlSitemapIndex');
      return state;
    },
    HTML_SITEMAP_INDEX_PAGE_ERROR: function HTML_SITEMAP_INDEX_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'htmlSitemapIndex');
      return state;
    },
    HTML_SITEMAP_POST_PAGE_LOADED: function HTML_SITEMAP_POST_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'htmlSitemapPostPage');
      return state;
    },
    HTML_SITEMAP_POST_PAGE_ERROR: function HTML_SITEMAP_POST_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'htmlSitemapPostPage');
      return state;
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'mostCreativePeoplePage');
      return state;
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'mostCreativePeopleCommunityPage');
      return state;
    },
    PRODUCT_INDEX_PAGE_LOADED: function PRODUCT_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productIndexPage');
      return state;
    },
    PRODUCT_INDEX_PAGE_ERROR: function PRODUCT_INDEX_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productIndexPage');

      return state;
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED: function PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productIndexSectionPage');

      return state;
    },
    PRODUCT_INDEX_SECTION_PAGE_ERROR: function PRODUCT_INDEX_SECTION_PAGE_ERROR() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productIndexSectionPage');
      return state;
    },
    PRODUCT_PAGE_LOADED: function PRODUCT_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'productPage');
      return state;
    },
    PERSON_PAGE_LOADED: function PERSON_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'personPage');
      return state;
    },
    STATIC_PAGE_LOADED: function STATIC_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'staticPageData');
      return state;
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED: function INNOVATION_BY_DESIGN_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'ibdPage');
      return state;
    },
    COMPANY_PAGE_LOADED: function COMPANY_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'companyPage');
      return state;
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED: function COMPANY_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'companyIndexSectionPage');
      return state;
    },
    MIC_YEAR_PAGE_LOADED: function MIC_YEAR_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'micYearPage');
      return state;
    },
    MIC_SECTOR_PAGE_LOADED: function MIC_SECTOR_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'micSectorPage');
      return state;
    },
    VIDEO_PAGE_LOADED: function VIDEO_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'videoPage');
      return state;
    },
    VIDEO_INDEX_PAGE_LOADED: function VIDEO_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'videoIndexPage');
      return state;
    },
    MAGAZINE_ARCHIVE_PAGE_LOADED: function MAGAZINE_ARCHIVE_PAGE_LOADED() {
      var currentState = store.getState();
      trackAnalytics(currentState, 'magazineArchivePage');
      return state;
    }
  };

  if (typeMap[type]) {
    return typeMap[type](action);
  }

  return state;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _exenv = __webpack_require__(4);

var _trackThirdPartyJS = __webpack_require__(147);

var _trackThirdPartyJS2 = _interopRequireDefault(_trackThirdPartyJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackAnalytics(currentState, type) {
  if (_exenv.canUseDOM) {
    var currentStateCopy = currentState;
    var initialPageLoad = (0, _get2.default)(currentStateCopy, 'config.initialPageLoad');
    // build context... sux but due to synchronous nature of reducers
    // this will have to be built here

    currentStateCopy.context = {
      site: (0, _get2.default)(currentStateCopy, 'config.site'),
      type: type,
      postData: (0, _get2.default)(currentStateCopy, 'post.data.post'),
      tagPageData: (0, _get2.default)(currentState, 'tagFeaturedFeed.tag'),
      categoryPageData: (0, _get2.default)(currentState, 'categoryFeaturedFeed.category'),
      authorPageData: (0, _get2.default)(currentState, 'author.data'),
      staticPageData: (0, _get2.default)(currentState, 'customPage.data.page[0]'),
      mostCreativePeoplePageData: (0, _get2.default)(currentState, 'mostCreativePeople'),
      personPageData: (0, _get2.default)(currentState, 'person'),
      searchPageData: (0, _get2.default)(currentState, 'search.data'),
      ibdPageData: (0, _get2.default)(currentState, 'innovationByDesign'),
      companyPageData: (0, _get2.default)(currentState, 'companyData'),
      micPageData: (0, _get2.default)(currentState, 'micYear'),
      micSectorPageData: (0, _get2.default)(currentState, 'micSector'),
      videoPageData: (0, _get2.default)(currentState, 'jwVideo'),
      videoIndexPageData: (0, _get2.default)(currentState, 'videoIndexPage'),
      productPageData: (0, _get2.default)(currentState, 'product')
    };

    if (!initialPageLoad) {
      (0, _trackThirdPartyJS2.default)(currentStateCopy);
    }
  }
}

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (action.type === 'INITIAL_PAGE_LOAD') {
    return (0, _assign2.default)({}, state, {
      initialPageLoad: false
    });
  }

  if (_exenv.canUseDOM && /PAGE_LOADED/.test(action.type)) {
    // console.log('reducer: ' + action.type + ' ' + window.location.href);
    var navHistory = (0, _cloneDeep2.default)(state.navHistory);
    navHistory.push(window.location.href);
    return (0, _assign2.default)({}, state, { navHistory: navHistory });
  }

  return state;
};

var _exenv = __webpack_require__(4);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _cloneDeep = __webpack_require__(74);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var store = action.store,
      type = action.type;


  var typeMap = {
    POSTPAGE_LOADED: function POSTPAGE_LOADED() {
      var currentState = store.getState();
      return (0, _post_seo_util2.default)(currentState);
    },
    PREVIEW_POSTPAGE_LOADED: function PREVIEW_POSTPAGE_LOADED() {
      var currentState = store.getState();
      return (0, _post_seo_util2.default)(currentState);
    },
    HOMEPAGE_LOADED: function HOMEPAGE_LOADED() {
      var currentState = store.getState();
      return (0, _homepage_seo_util2.default)(currentState);
    },
    CATEGORY_PAGE_LOADED: function CATEGORY_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _category_seo_util2.default)(currentState);
    },
    TAG_PAGE_LOADED: function TAG_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _tag_seo_util2.default)(currentState);
    },
    PERSON_PAGE_LOADED: function PERSON_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _person_seo_util2.default)(currentState);
    },
    PRODUCT_PAGE_LOADED: function PRODUCT_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _product_seo_util2.default)(currentState);
    },
    MOST_CREATIVE_PEOPLE_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _most_creative_people_seo_util2.default)(currentState);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _most_creative_people_community_seo_util2.default)(currentState);
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED: function MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _most_creative_people_community_seo_util2.default)(currentState);
    },
    PERSON_INDEX_PAGE_LOADED: function PERSON_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _person_index_seo_util2.default)(currentState);
    },
    PERSON_INDEX_SECTION_PAGE_LOADED: function PERSON_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _person_index_seo_util2.default)(currentState);
    },
    PRODUCT_INDEX_PAGE_LOADED: function PRODUCT_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _product_index_seo_util2.default)(currentState);
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED: function PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _product_index_seo_util2.default)(currentState);
    },
    AUTHOR_PAGE_LOADED: function AUTHOR_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _author_seo_util2.default)(currentState);
    },
    SEARCH_PAGE_LOADED: function SEARCH_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _search_seo_util2.default)(currentState);
    },
    WP_PAGE_LOADED: function WP_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _wp_page_seo_util2.default)(currentState);
    },
    STATIC_PAGE_LOADED: function STATIC_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _static_page_seo_util2.default)(currentState);
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED: function HTML_SITEMAP_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _sitemap_index_page_seo_util2.default)(currentState);
    },
    HTML_SITEMAP_POST_PAGE_LOADED: function HTML_SITEMAP_POST_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _sitemap_post_page_seo_util2.default)(currentState);
    },
    MAGAZINE_ARCHIVE_LOADED: function MAGAZINE_ARCHIVE_LOADED() {
      var currentState = store.getState();
      return (0, _magazine_archive_seo_util2.default)(currentState);
    },
    MIC_YEAR_PAGE_LOADED: function MIC_YEAR_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _mic_year_page_seo_util2.default)(currentState);
    },
    MIC_SECTOR_PAGE_LOADED: function MIC_SECTOR_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _mic_sector_page_seo_util2.default)(currentState);
    },
    COMPANY_PAGE_LOADED: function COMPANY_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _company_page_seo_util2.default)(currentState);
    },
    COMPANY_INDEX_PAGE_LOADED: function COMPANY_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _company_index_seo_util2.default)(currentState);
    },
    COMPANY_INDEX_SECTION_PAGE_LOADED: function COMPANY_INDEX_SECTION_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _company_index_seo_util2.default)(currentState);
    },
    INNOVATION_BY_DESIGN_PAGE_LOADED: function INNOVATION_BY_DESIGN_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _ibd_year_page_seo_util2.default)(currentState);
    },
    GIFT_GUIDE_PAGE_LOADED: function GIFT_GUIDE_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _gift_guide_page_seo_util2.default)(currentState);
    },
    GIFT_PAGE_LOADED: function GIFT_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _gift_seo_util2.default)(currentState);
    },
    VIDEO_PAGE_LOADED: function VIDEO_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _video_seo_util2.default)(currentState);
    },
    VIDEO_INDEX_PAGE_LOADED: function VIDEO_INDEX_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _video_index_seo_util2.default)(currentState);
    },
    NEWSLETTERS_PREFERENCES_PAGE_LOADED: function NEWSLETTERS_PREFERENCES_PAGE_LOADED() {
      var currentState = store.getState();
      return (0, _newsletters_preferences_page_seo_util2.default)(currentState);
    }
  };
  if (typeMap[type]) {
    return typeMap[type](action);
  }

  return state;
};

var _homepage_seo_util = __webpack_require__(1031);

var _homepage_seo_util2 = _interopRequireDefault(_homepage_seo_util);

var _post_seo_util = __webpack_require__(1032);

var _post_seo_util2 = _interopRequireDefault(_post_seo_util);

var _video_seo_util = __webpack_require__(1035);

var _video_seo_util2 = _interopRequireDefault(_video_seo_util);

var _video_index_seo_util = __webpack_require__(1036);

var _video_index_seo_util2 = _interopRequireDefault(_video_index_seo_util);

var _category_seo_util = __webpack_require__(1037);

var _category_seo_util2 = _interopRequireDefault(_category_seo_util);

var _tag_seo_util = __webpack_require__(1038);

var _tag_seo_util2 = _interopRequireDefault(_tag_seo_util);

var _person_seo_util = __webpack_require__(1039);

var _person_seo_util2 = _interopRequireDefault(_person_seo_util);

var _product_seo_util = __webpack_require__(1040);

var _product_seo_util2 = _interopRequireDefault(_product_seo_util);

var _person_index_seo_util = __webpack_require__(1041);

var _person_index_seo_util2 = _interopRequireDefault(_person_index_seo_util);

var _product_index_seo_util = __webpack_require__(1042);

var _product_index_seo_util2 = _interopRequireDefault(_product_index_seo_util);

var _magazine_archive_seo_util = __webpack_require__(1043);

var _magazine_archive_seo_util2 = _interopRequireDefault(_magazine_archive_seo_util);

var _most_creative_people_seo_util = __webpack_require__(1044);

var _most_creative_people_seo_util2 = _interopRequireDefault(_most_creative_people_seo_util);

var _most_creative_people_community_seo_util = __webpack_require__(1045);

var _most_creative_people_community_seo_util2 = _interopRequireDefault(_most_creative_people_community_seo_util);

var _mic_year_page_seo_util = __webpack_require__(1046);

var _mic_year_page_seo_util2 = _interopRequireDefault(_mic_year_page_seo_util);

var _mic_sector_page_seo_util = __webpack_require__(1047);

var _mic_sector_page_seo_util2 = _interopRequireDefault(_mic_sector_page_seo_util);

var _company_page_seo_util = __webpack_require__(1048);

var _company_page_seo_util2 = _interopRequireDefault(_company_page_seo_util);

var _ibd_year_page_seo_util = __webpack_require__(1049);

var _ibd_year_page_seo_util2 = _interopRequireDefault(_ibd_year_page_seo_util);

var _gift_guide_page_seo_util = __webpack_require__(1050);

var _gift_guide_page_seo_util2 = _interopRequireDefault(_gift_guide_page_seo_util);

var _gift_seo_util = __webpack_require__(1051);

var _gift_seo_util2 = _interopRequireDefault(_gift_seo_util);

var _company_index_seo_util = __webpack_require__(1052);

var _company_index_seo_util2 = _interopRequireDefault(_company_index_seo_util);

var _author_seo_util = __webpack_require__(1053);

var _author_seo_util2 = _interopRequireDefault(_author_seo_util);

var _search_seo_util = __webpack_require__(1054);

var _search_seo_util2 = _interopRequireDefault(_search_seo_util);

var _wp_page_seo_util = __webpack_require__(1055);

var _wp_page_seo_util2 = _interopRequireDefault(_wp_page_seo_util);

var _static_page_seo_util = __webpack_require__(1056);

var _static_page_seo_util2 = _interopRequireDefault(_static_page_seo_util);

var _newsletters_preferences_page_seo_util = __webpack_require__(1057);

var _newsletters_preferences_page_seo_util2 = _interopRequireDefault(_newsletters_preferences_page_seo_util);

var _sitemap_index_page_seo_util = __webpack_require__(1058);

var _sitemap_index_page_seo_util2 = _interopRequireDefault(_sitemap_index_page_seo_util);

var _sitemap_post_page_seo_util = __webpack_require__(1059);

var _sitemap_post_page_seo_util2 = _interopRequireDefault(_sitemap_post_page_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');

  var next = false;
  var prev = false;

  var page = (0, _get2.default)(state, 'allFeed.data.page');
  var totalPages = (0, _get2.default)(state, 'allFeed.data.totalPages');
  var rss = '/latest/rss?truncated=true';

  var base = {
    site: site,
    siteConf: siteConf,
    title: siteHumanReadable || 'Fast Company',
    twitterCard: 'summary',
    publisher: false,
    type: 'website',
    config: state.config,
    rss: rss,
    extend: [{
      link: []
    }],
    useSloganTitle: true
  };

  if (page < totalPages && page - 1 !== 0) {
    prev = 'https://www.' + site + '.com/all/' + (page - 1);
  }

  if (page + 1 <= totalPages) {
    next = 'https://www.' + site + '.com/all/' + (page + 1);
  }

  if (next) {
    base.extend[0].link.push({
      rel: 'next',
      href: next
    });
  }

  if (prev) {
    base.extend[0].link.push({
      rel: 'prev',
      href: prev
    });
  }

  return (0, _base_seo_util2.default)(base);
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var post = (0, _get2.default)(state, 'post.data.post') || (0, _get2.default)(state, 'previewPost.data.post') || {};
  var categories = (0, _get2.default)(post, 'categories', []);
  var title = (0, _get2.default)(post, 'title', '');
  var id = (0, _get2.default)(post, 'id');
  var slug = (0, _get2.default)(post, 'slug');
  var author = (0, _get2.default)(post, 'author.name');

  var image = (0, _get2.default)(post, 'shareImage', '');
  if ((0, _get2.default)(post, 'featured_image.source')) {
    // TODO: move this into the api.
    image = (0, _cloudinary_asset_util.changeAssetDomain)(image);
    image = image.replace('.gif', '.jpg');
  }
  var DESKTOP_SIZE = true;
  image = (0, _cloudinary_asset_util.buildAssetUrlWithPresets)(image, _cloudinary_asset_util.imageSizesLookup.meta, DESKTOP_SIZE);

  var articleDate = (0, _get2.default)(post, 'datePublished');
  var dateModified = (0, _get2.default)(post, 'dateModified');
  var allTags = (0, _get2.default)(post, 'tags');
  var category = (0, _get2.default)(categories, '[0].name');
  var getTag = function cleanTag() {
    var name = (0, _get2.default)(allTags, '[0].name');
    if (name === 'homepage' || name === 'top' || name === 'featured') {
      return false;
    }
    return name;
  };

  var oTags = [category, getTag()];
  var dedupedTags = (0, _uniq2.default)((0, _compact2.default)(oTags));
  var standout = (0, _find2.default)(allTags, { name: 'standout' }) || (0, _find2.default)(allTags, { name: 'googlepick' }) || false;
  var tags = dedupedTags.filter(function (item) {
    return !/^byline_/.test(item);
  }).join(', ');
  var description = (0, _get2.default)(post, 'excerpt') || '';
  var url = 'https://www.' + site + '.com/' + id + '/' + slug;

  var titleTruncated = title.length >= 70 ? title.substring(0, 70) : title;

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    titleTruncated: titleTruncated,
    url: url,
    description: description,
    image: image,
    image_width: 1280,
    image_height: 720,
    articleSection: category,
    config: state.config,
    extend: [{
      meta: [{
        property: 'article:published_time',
        content: articleDate
      }, {
        property: 'article:modified_time',
        content: dateModified
      }, {
        property: 'author',
        content: author
      }, {
        name: 'news_keywords',
        content: tags
      }]
    }],
    noPipe: true
  });

  (0, _each2.default)(dedupedTags, function addOGMeta(tag) {
    data.meta.push({
      property: 'article:tag',
      content: tag
    });
  });

  if (standout) {
    data.meta.push({
      property: 'standout',
      content: url
    });
  }

  if ((0, _advertorial.isAdvertorial)(allTags)) {
    data.meta.push({ name: 'ROBOTS', content: 'NOINDEX,FOLLOW' });
  }

  if ((0, _get2.default)(state, 'config.featureFlags.ampIngestionEnabled')) {
    var ampUrl = url.replace('https://www', 'https://amp');
    data.link.push({
      rel: 'amphtml',
      href: ampUrl
    });
  }

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _uniq = __webpack_require__(285);

var _uniq2 = _interopRequireDefault(_uniq);

var _compact = __webpack_require__(286);

var _compact2 = _interopRequireDefault(_compact);

var _each = __webpack_require__(287);

var _each2 = _interopRequireDefault(_each);

var _find = __webpack_require__(1033);

var _find2 = _interopRequireDefault(_find);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

var _advertorial = __webpack_require__(28);

var _cloudinary_asset_util = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1034),
    findIndex = __webpack_require__(238);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(78),
    isArrayLike = __webpack_require__(41),
    keys = __webpack_require__(50);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var video = (0, _get2.default)(state, 'jwVideo.data.playlist[0]', {});
  var title = 'VIDEO | ' + (0, _get2.default)(video, 'title', '');
  var id = (0, _get2.default)(video, 'mediaid');
  var slug = (0, _get2.default)(video, 'slug');
  var image = 'https://images.fastcompany.net/image/fetch/w_1280,f_auto,q_auto,fl_lossy/' + (0, _get2.default)(video, 'image', '');
  var date = (0, _get2.default)(video, 'formattedDate', '');
  var tags = (0, _get2.default)(video, 'tags', []).map(function (tag) {
    return tag.name;
  });
  var dedupedTags = (0, _uniq2.default)((0, _compact2.default)(tags));
  var description = (0, _get2.default)(video, 'description', '');

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.' + site + '.com/video/' + slug + '/' + id,
    description: description,
    image: image,
    image_width: 1280,
    image_height: 720,
    type: 'video',
    config: state.config,
    extend: [{
      meta: [{
        property: 'video:published_time',
        content: date
      }]
    }]
  });

  (0, _each2.default)(dedupedTags, function addOGMeta(tag) {
    data.meta.push({
      property: 'video:tag',
      content: tag
    });
  });

  /*
  if (isAdvertorial(allTags)) {
    data.meta.push({ name: 'ROBOTS', content: 'NOINDEX,FOLLOW' });
  }
  */

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _uniq = __webpack_require__(285);

var _uniq2 = _interopRequireDefault(_uniq);

var _compact = __webpack_require__(286);

var _compact2 = _interopRequireDefault(_compact);

var _each = __webpack_require__(287);

var _each2 = _interopRequireDefault(_each);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var title = 'Video | Fast Company | Business + Innovation';

  var image = 'https://images.fastcompany.net/image/upload/w_1280,q_auto,f_auto,fl_lossy/v1480632834/fast-company-share-graphic.png';
  var description = 'Fast Company inspires a new breed of innovative and creative thought leaders who are actively inventing the future of business.';

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.fastcompany.com/videos',
    description: description,
    image: image,
    image_width: 1280,
    image_height: 720,
    type: 'video',
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var category = (0, _get2.default)(state, 'categoryFeaturedFeed.category', {
    description: 'Breaking news and analysis on business, technology, and leadership from the Fast Company news team.',
    slug: 'news'
  });

  var tagName = (0, _get2.default)(state, 'categoryAllFeed.data.tag.name');
  var tagSlug = (0, _get2.default)(state, 'categoryAllFeed.data.tag.slug');
  var hasTagDescription = (0, _get2.default)(state, 'categoryAllFeed.data.tag.description') !== '';

  var categoryName = (0, _get2.default)(category, 'name');
  var slug = (0, _get2.default)(category, 'slug');
  var description = hasTagDescription ? (0, _get2.default)(state, 'categoryAllFeed.data.tag.description') : (0, _get2.default)(category, 'description');
  var title = categoryName ? '' + categoryName : '';
  var image = '';

  if (slug === 'magazine') {
    title = 'Fast Company Magazine';
  }

  if (tagName) {
    title = categoryName + ' : ' + tagName;
  }

  if (slug === 'news') {
    image = 'https://images.fastcompany.net/image/upload/v1501604705/fcweb/fastco-news-share-graphic_jot2bv.png';
  }

  var url = tagName ? 'https://www.' + site + '.com/' + slug + '/' + tagSlug : 'https://www.' + site + '.com/' + slug;

  var rss = '/' + slug + '/rss';

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    image: image,
    url: url,
    description: description,
    config: state.config,
    articleSection: categoryName,
    rss: rss
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var tag = (0, _get2.default)(state, 'tagFeaturedFeed.tag') || {};
  var tagName = (0, _get2.default)(tag, 'name');
  var slug = (0, _get2.default)(tag, 'slug');
  var tagDescription = (0, _get2.default)(tag, 'description');
  var tags = (0, _get2.default)(state, 'tagAllFeed.data[0].tags');
  var rss = '/section/' + slug + '/rss';
  var defaultDescription = 'Fast Company articles and posts tagged ' + tagName + ' with a unique editorial focus on innovation in technology, leadership, and design.';
  var currentIssue = null;

  if ((0, _get2.default)(state, 'magazineIssuePosts')) {
    currentIssue = (0, _get2.default)(state, 'magazineIssuePosts.data.issue', {});
  }

  var title = tagName ? 'Fast Company posts tagged ' + tagName : '';

  if ((0, _get2.default)(currentIssue, 'description', '')) {
    title = (0, _get2.default)(currentIssue, 'description', '').replace(/ \| /g, ', ');
  }

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.' + site + '.com/section/' + slug,
    description: tagDescription ? (0, _striptags2.default)(tagDescription) : defaultDescription,
    articleSection: tagName,
    rss: rss,
    config: state.config
  });

  if ((0, _advertorial.isAdvertorial)(tags)) {
    data.meta.push({
      name: 'ROBOTS',
      content: 'NOINDEX,FOLLOW'
    });
  }

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

var _advertorial = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var person = (0, _get2.default)(state, 'person.data.rows[0]');
  var name = (0, _get2.default)(person, 'first_name') + ' ' + (0, _get2.default)(person, 'last_name');
  var url = 'https://www.fastcompany.com/person/' + (0, _get2.default)(person, 'url');
  var description = (0, _striptags2.default)((0, _get2.default)(person, 'bio'), '');
  var image = (0, _get2.default)(person, 'images[0].url') || '';
  var mcp = (0, _get2.default)(person, 'mcp');
  var mcpAwards = (0, _get2.default)(person, 'mcp_awards');
  var mcpYear = (0, _get2.default)(person, 'mcp_awards[0].year');

  // https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/300/h/300/crop/people/2017/05/03/ganesh-bell-fa0617head024a_sm-6orww8.jpg

  // https://a.fastcompany.net/multisite_files/fastcompany/people/2017/05/03/james-anderson-fa0617head029a_sm-i9y01m.jpg

  var imageParts = image.split('/fastcompany/');
  var twitterImage = 'https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/300/h/300/crop/' + (0, _get2.default)(imageParts, '[1]');

  var baseSEO = {
    site: site,
    siteConf: siteConf,
    url: url,
    description: description,
    image: image,
    twitterCard: 'summary',
    twitterImage: twitterImage
  };

  if (mcp === 1 && mcpAwards.length) {
    baseSEO.articleSection = 'Most Creative People';
    baseSEO.title = name + ', Most Creative People ' + mcpYear;
    return (0, _base_seo_util2.default)(baseSEO);
  }

  if (mcp === 1) {
    baseSEO.articleSection = 'Most Creative People';
    baseSEO.title = name + ', Most Creative People';
    return (0, _base_seo_util2.default)(baseSEO);
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: name + ': Latest News, Work, Videos, Photos',
    url: url,
    description: description,
    image: image,
    articleSection: 'People',
    twitterCard: 'summary',
    twitterImage: twitterImage,
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var product = (0, _get2.default)(state, 'product.data.rows[0]');
  var name = '' + (0, _get2.default)(product, 'name');
  var url = 'https://www.fastcodesign.com/product/' + (0, _get2.default)(product, 'url');
  var description = name + ' and what makes it innovative for users, developers and partners.  Includes press releases, videos, screenshots and downloads.';
  var image = (0, _get2.default)(product, 'images[0].url') || '';

  var imageParts = image.split('/fastcompany/');
  var twitterImage = 'https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/300/h/300/crop/' + (0, _get2.default)(imageParts, '[1]');

  var title = name + ': Latest News, Work, Videos, Photos';
  var isIBDEntry = (0, _get2.default)(product, 'creator_people.length');
  if (isIBDEntry) {
    title = name + ': Innovation by Design';
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: url,
    description: description,
    image: image,
    articleSection: 'Product',
    twitterCard: 'summary',
    twitterImage: twitterImage,
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Person Index',
    url: 'https://www.fastcompany.com/person',
    description: 'A list of people in the Fast Company database',
    articleSection: 'Person Index',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Product Index',
    url: 'https://www.fastcodesign.com/stuff',
    description: 'A list of products Co.Design has featured including finalists and winners of Innovation by Design Awards',
    articleSection: 'Product Index',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Fast Company Magazine Archives From 1995 to Today',
    url: 'https://www.fastcompany.com/magazine/archives',
    description: 'Fast Company Magazine issues and archives published from 1995 to today. Available in print, on the web, and PDF format.',
    articleSection: 'Magazine Index',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var year = (0, _get2.default)(state, 'mostCreativePeople.year');
  var imgPresets = 'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';
  var posterImgs = {
    2017: imgPresets + '/v1494843167/MCPwith100and2017forSocial.jpg',
    2016: imgPresets + '/v1495030888/MCP100-2016Logo-SHARE.png',
    2015: imgPresets + '/v1495030888/MCP100-2015Logo-SHARE.png',
    2014: imgPresets + '/v1495030888/MCP100-2014Logo-SHARE.png',
    fallback: imgPresets + '/v1495030888/MCP-Logo-default-SHARE.png'
  };

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Most Creative People in Business ' + year,
    url: 'https://www.fastcompany.com/most-creative-people/' + year,
    description: 'Meet ' + year + '\'s most inspiring leaders in the Fast Company community',
    image: posterImgs[year] || posterImgs.fallback,
    articleSection: 'Most Creative People',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var imgPresets = 'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Most Creative People in Business Community',
    url: 'https://www.fastcompany.com/most-creative-people-community',
    description: 'Meet the most inspiring leaders in the Fast Company community',
    image: imgPresets + '/v1495030888/MCP-Logo-default-SHARE.jpg',
    articleSection: 'Most Creative People',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var year = (0, _get2.default)(state, 'micYear.year');
  var imgPresets = 'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'The ' + year + ' World\'s Most Innovative Companies',
    url: 'https://www.fastcompany.com/most-innovative-companies/' + year,
    description: 'The ' + year + ' guide to the businesses that matter the most.',
    image: imgPresets + '/v1495030888/fcweb/MIC-' + year + '-Logo-OG.png',
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var year = (0, _get2.default)(state, 'micYear.year');
  var sector = (0, _get2.default)(state, 'micSector.sector');
  var imgPresets = 'https://images.fastcompany.net/image/upload/w_530,q_auto,f_auto,fl_lossy';
  if (sector) {
    return (0, _base_seo_util2.default)({
      site: site,
      siteConf: siteConf,
      title: 'Most Innovative Companies ' + year + ' in ' + sector,
      url: 'https://www.fastcompany.com/most-innovative-companies/' + year,
      description: 'The ' + year + ' guide to the businesses that matter the most in ' + sector + '.',
      image: imgPresets + '/v1501095175/fcweb/MICbySectorforSocial_tknaam.jpg',
      articleSection: 'Most Innovative Companies'
    });
  }
  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'The ' + year + ' World\'s Most Innovative Companies',
    url: 'https://www.fastcompany.com/most-innovative-companies/' + year,
    description: 'The ' + year + ' guide to the businesses that matter the most.',
    image: imgPresets + '/v1495030888/fcweb/MIC-' + year + '-Logo-OG.png',
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var company = (0, _get2.default)(state, 'company.data.rows[0].name');
  var slug = (0, _get2.default)(state, 'company.data.rows[0].url');

  var isMIC = (0, _get2.default)(state, 'companyAwards.data.rows.length');
  var title = company + ': Latest News, Work, Videos, Photos';

  if (isMIC) {
    title = company + ': Most Innovative Company';
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.fastcompany.com/company/' + slug,
    description: 'Read more about ' + company + ' on Fast Company',
    image: 'https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png',
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var year = (0, _get2.default)(state, 'innovationByDesign.year');
  var img = 'https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/500/h/400/scale/ibd/ibd-' + year + '-logo-share.png';

  // TODO: This solution is temporary. It needs some work to make sure the text is correct for each year.
  var description = 'Check out the ' + year + ' Innovation by Design Awards.';
  if (parseInt(year, 10) === 2017) {
    description = "Fast Company's sixth annual Innovation By Design Awards are now announced. Read on for this year's " + 'best products, services, interfaces, and ideas.';
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'Innovation by Design Awards ' + year,
    url: 'https://www.fastcodesign.com/innovation-by-design/' + year,
    description: description,
    image: img,
    articleSection: 'Innovation By Design Awards',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var ggDetails = (0, _get2.default)(state, 'giftGuideDetail.data.rows[0]');
  var slugMapping = {
    1: 'holiday-2017'
  };
  var slug = slugMapping[(0, _get2.default)(ggDetails, 'year_id')];

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: (0, _get2.default)(ggDetails, 'title', ''),
    url: 'https://www.fastcodesign.com/gift-guide/' + slug,
    description: (0, _get2.default)(ggDetails, 'description', ''),
    image: (0, _get2.default)(ggDetails, 'logo_url', ''),
    articleSection: 'Gift Guide',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var gift = (0, _get2.default)(state, 'gift.data.rows[0]');
  var name = '' + (0, _get2.default)(gift, 'name');
  var url = 'https://www.fastcompany.com/gift/' + (0, _get2.default)(gift, 'url');
  var description = '';
  var image = (0, _get2.default)(gift, 'images[0].url') || '';

  var imageParts = image.split('/fastcompany/');
  var twitterImage = 'https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/300/h/300/crop/' + (0, _get2.default)(imageParts, '[1]');

  var title = name + ': Latest News, Work, Videos, Photos';
  var isIBDEntry = (0, _get2.default)(gift, 'creator_people.length');
  if (isIBDEntry) {
    title = name + ': Innovation by Design';
  }

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: url,
    description: description,
    image: image,
    articleSection: 'Product',
    twitterCard: 'summary',
    twitterImage: twitterImage,
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};

  return (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: 'All Companies',
    url: 'https://www.fastcompany.com/company',
    description: 'A list of companies Fast Company has featured including the Most Innovative',
    image: 'https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png',
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');
  var author = (0, _get2.default)(state, 'author.data') || {};
  var authorName = (0, _get2.default)(author, 'name');
  var authorSlug = (0, _get2.default)(author, 'slug');
  var description = authorName ? 'Articles and posts written and edited by ' + authorName : 'Author stories on ' + siteHumanReadable;
  var title = authorName ? '' + authorName : '' + siteHumanReadable;

  var rss = '/user/' + authorSlug + '/rss';

  var next = false;
  var prev = false;

  var page = (0, _get2.default)(state, 'authorAllFeed.data.page');
  var totalPages = (0, _get2.default)(state, 'authorAllFeed.data.totalPages');

  if (page < totalPages && page - 1 !== 0) {
    prev = 'https://www.' + site + '.com/user/' + authorSlug + '/' + (page - 1);
  }

  if (page + 1 <= totalPages) {
    next = 'https://www.' + site + '.com/user/' + authorSlug + '/' + (page + 1);
  }

  var base = {
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.' + site + '.com/user/' + authorSlug,
    description: description,
    articleSection: authorName,
    rss: rss,
    config: state.config,
    extend: [{
      link: []
    }]
  };

  if (next) {
    base.extend[0].link.push({
      rel: 'next',
      href: next
    });
  }

  if (prev) {
    base.extend[0].link.push({
      rel: 'prev',
      href: prev
    });
  }

  return (0, _base_seo_util2.default)(base);
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');
  var searchQuery = (0, _get2.default)(state, 'search.data.query.queryString') || (0, _get2.default)(state, 'search.queryString') || '';
  var description = searchQuery ? 'Search results for: ' + searchQuery : 'Search results on ' + siteHumanReadable;
  var title = searchQuery ? 'Search results for: ' + searchQuery : 'Search results on ' + siteHumanReadable;

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: 'https://www.' + site + '.com/search/' + searchQuery,
    description: description,
    articleSection: searchQuery,
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var wpPage = (0, _get2.default)(state, 'customPage.data.page[0]');
  var slug = (0, _get2.default)(wpPage, 'slug');
  var pageTitle = (0, _get2.default)(wpPage, 'title.rendered');
  var wpExcerpt = (0, _get2.default)(wpPage, 'excerpt.rendered');
  var description = wpExcerpt ? (0, _striptags2.default)(wpExcerpt).trim() : '';

  var slugLookup = {
    'world-changing-ideas': {
      title: 'World Changing Ideas',
      description: 'Rewarding ideas, projects, and products from the last year that have the potential to alter the lives of people and the direction of the planet for the better.',
      articleSection: 'World Changing Ideas'
    },
    'most-innovative-companies': {
      title: 'Most Innovative Companies',
      description: "Designating the world's most innovative companies to reflect today’s expanding innovation efforts across the business landscape.",
      articleSection: 'Most Innovative Companies'
    },
    about: {
      title: 'Innovation By Design Awards',
      description: 'We honor the designers and businesses solving the problems of today and tomorrow. We have featured a cross-section of blue-chip companies, scruffy startups, and hungry young talents.',
      articleSection: 'Innovation By Design Award About'
    }
  };

  var foundStaticConfig = slugLookup[slug] || {};

  var base = {
    site: site,
    siteConf: siteConf,
    url: 'https://www.' + site + '.com/' + slug,
    title: pageTitle,
    articleSection: pageTitle,
    description: description,
    config: state.config
  };

  var union = (0, _assign2.default)({}, base, foundStaticConfig);

  var data = (0, _base_seo_util2.default)(union);
  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _striptags = __webpack_require__(42);

var _striptags2 = _interopRequireDefault(_striptags);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');

  var url = (0, _get2.default)(state, 'config.navHistory[0]');

  /*
    USE CASE: add your url here if you are creating a static page that does not pull
    data from an external API. To start, there is only /newsletters page.
  */

  var urlLookup = {
    'https://www.fastcompany.com/newsletters': {
      title: 'Fast Company Newsletters',
      description: 'Get the latest stories and updates sent your inbox.',
      url: url,
      articleSection: 'Fast Company Newsletters'
    }
  };

  var foundStaticConfig = urlLookup[url] || {};

  var base = {
    site: site,
    siteConf: siteConf,
    title: siteHumanReadable,
    config: state.config
  };

  var union = (0, _assign2.default)({}, base, foundStaticConfig);

  var data = (0, _base_seo_util2.default)(union);

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');

  var url = (0, _get2.default)(state, 'config.navHistory[0]');

  /*
    USE CASE: add your url here if you are creating a static page that does not pull
    data from an external API. To start, there is only /newsletters page.
  */

  var config = {
    title: 'Fast Company Newsletters Preferences Page',
    description: 'Update your subscriptions to Fast Company Newsletters',
    url: url,
    articleSection: 'Fast Company Newsletters Preferences Page'
  };

  var base = {
    site: site,
    siteConf: siteConf,
    title: siteHumanReadable,
    config: state.config
  };

  var union = (0, _assign2.default)({}, base, config);

  var data = (0, _base_seo_util2.default)(union);

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var siteHumanReadable = (0, _get2.default)(siteConf, '[og:site_name]');
  var description = 'Site map for ' + siteHumanReadable;

  var pageURL = (0, _get2.default)(state, 'config.navHistory[0]').split('/');
  var year = '';

  if (pageURL.length) {
    var yearIdentifier = pageURL[pageURL.length - 1];
    if (yearIdentifier !== 'sitemap') {
      year = ' > ' + yearIdentifier;
    }
  }

  var title = 'Site Map' + year;
  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: (0, _get2.default)(state, 'config.navHistory[0]'),
    description: description,
    articleSection: title,
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var site = (0, _get2.default)(state, 'config.site');
  var siteConf = _site_data_util2.default[site] || {};
  var sitemapPostPageTitle = (0, _get2.default)(state, 'htmlSitemapPost.data.title');
  var description = 'Site map for ' + sitemapPostPageTitle;
  var title = '' + sitemapPostPageTitle;

  var data = (0, _base_seo_util2.default)({
    site: site,
    siteConf: siteConf,
    title: title,
    url: (0, _get2.default)(state, 'config.navHistory[0]'),
    description: description,
    articleSection: title,
    config: state.config
  });

  return data;
};

var _get = __webpack_require__(0);

var _get2 = _interopRequireDefault(_get);

var _site_data_util = __webpack_require__(19);

var _site_data_util2 = _interopRequireDefault(_site_data_util);

var _base_seo_util = __webpack_require__(20);

var _base_seo_util2 = _interopRequireDefault(_base_seo_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    code: 200
  };
  var action = arguments[1];

  if (action.type === 'NOT_FOUND_STATUS') {
    return {
      code: 404
    };
  }

  if (action.type === 'ERROR_STATUS') {
    return {
      code: action.status
    };
  }

  if (action.type === 'UNPUBLISHED_STATUS') {
    return {
      code: 403
    };
  }

  if (action.type === 'REDIRECT_POST_URL') {
    return {
      code: 301,
      redirect: action.redirect
    };
  }

  if (/PAGE_LOADING/.test(action.type) && _exenv.canUseDOM) {
    return (0, _extend2.default)({}, state, {
      code: 200
    });
  }

  return state;
};

var _extend = __webpack_require__(7);

var _extend2 = _interopRequireDefault(_extend);

var _exenv = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var typeMap = {
    NOT_FOUND_PAGE_LOADING: function NOT_FOUND_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    NOT_FOUND_PAGE_LOADED: function NOT_FOUND_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.notFoundPage
      };
    },
    NOT_FOUND_PAGE_ERROR: function NOT_FOUND_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.notFoundPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initialize;

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _font_loader_util = __webpack_require__(1063);

var _font_loader_util2 = _interopRequireDefault(_font_loader_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import log from '../services/logger_service';
function initialize() {
  return _bluebird2.default.all([_font_loader_util2.default.loadFonts()]);
}

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fontfaceobserver = __webpack_require__(1064);

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

var _bluebird = __webpack_require__(5);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _logger_service = __webpack_require__(131);

var _logger_service2 = _interopRequireDefault(_logger_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

if (!window.Promise) {
  window.Promise = _bluebird2.default;
}

var fonts = ['FCIcon2015', 'FCKaiser', 'FCZizouSans', 'MeretPro'];

var FontLoaderUtil = function () {
  function FontLoaderUtil() {
    _classCallCheck(this, FontLoaderUtil);
  }

  _createClass(FontLoaderUtil, null, [{
    key: 'loadFonts',
    value: function loadFonts() {
      var fontPromise = _bluebird2.default.all(fonts.map(function observeFont(fontname) {
        return new _fontfaceobserver2.default(fontname);
      }));
      return fontPromise.then(function fontLoadSuccess() {
        document.documentElement.className += document.documentElement.className === '' ? 'fonts-loaded' : ' fonts-loaded';
      }).catch(function fontLoadFail(err) {
        document.documentElement.className += document.documentElement.className === '' ? 'fonts-loaded fonts-loaded-error' : ' fonts-loaded fonts-loaded-error';
        _logger_service2.default.error(err, 'Error in font loader loading fonts.');
      });
    }
  }]);

  return FontLoaderUtil;
}();

exports.default = FontLoaderUtil;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

/* Font Face Observer v2.0.13 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a()}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a()})};function r(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c)}
function t(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";"}function y(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function z(a,b){function c(){var a=k;y(a)&&a.a.parentNode&&b(a.g)}var k=a;l(a.b,c);l(a.c,c);y(a)};function A(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal"}var B=null,C=null,E=null,F=null;function G(){if(null===C)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);C=!!a&&603>parseInt(a[1],10)}else C=!1;return C}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}E=""!==a.style.font}return E}function L(a,b){return[a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
A.prototype.load=function(a,b){var c=this,k=a||"BESbswy",q=0,D=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=D?b():document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25)},function(){b()})}e()}),N=new Promise(function(a,c){q=setTimeout(c,D)});Promise.race([N,M]).then(function(){clearTimeout(q);a(c)},function(){b(c)})}else m(function(){function u(){var b;if(b=-1!=
f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===B&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),B=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=B&&(f==v&&g==v&&h==v||f==w&&g==w&&h==w||f==x&&g==x&&h==x)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(q),a(c))}function I(){if((new Date).getTime()-H>=D)d.parentNode&&d.parentNode.removeChild(d),b(c);else{var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,
g=n.a.offsetWidth,h=p.a.offsetWidth,u();q=setTimeout(I,50)}}var e=new r(k),n=new r(k),p=new r(k),f=-1,g=-1,h=-1,v=-1,w=-1,x=-1,d=document.createElement("div");d.dir="ltr";t(e,L(c,"sans-serif"));t(n,L(c,"serif"));t(p,L(c,"monospace"));d.appendChild(e.a);d.appendChild(n.a);d.appendChild(p.a);document.body.appendChild(d);v=e.a.offsetWidth;w=n.a.offsetWidth;x=p.a.offsetWidth;I();z(e,function(a){f=a;u()});t(e,L(c,'"'+c.family+'",sans-serif'));z(n,function(a){g=a;u()});t(n,L(c,'"'+c.family+'",serif'));
z(p,function(a){h=a;u()});t(p,L(c,'"'+c.family+'",monospace'))})})}; true?module.exports=A:(window.FontFaceObserver=A,window.FontFaceObserver.prototype.load=A.prototype.load);}());


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    type: 'INITIAL_PAGE_LOAD',
    initialPageLoad: false
  };
};

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = polyfillImages;
function polyfillImages() {
  // create an image node so we can test its properties
  var img = document.createElement('img');
  // feature detect
  var supportSrcset = 'srcset' in img && 'sizes' in img;
  if (!supportSrcset) {
    // feature not available:
    // create a script tag
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.jsdelivr.net/picturefill/3.0.3/picturefill.min.js';
    script.setAttribute('async', '');
    // add it to the document <head>...
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
  }
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js